/*! jQuery v3.5.1 | (c) JS Foundation and other contributors | jquery.org/license */
function _typeof(e) {
    return (_typeof =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (e) {
                  return typeof e;
              }
            : function (e) {
                  return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
              })(e);
}
function _get(e, t, n) {
    return (
        (_get =
            "undefined" != typeof Reflect && Reflect.get
                ? Reflect.get
                : function (e, t, n) {
                      var i = _superPropBase(e, t);
                      if (i) {
                          var o = Object.getOwnPropertyDescriptor(i, t);
                          return o.get ? o.get.call(n) : o.value;
                      }
                  }),
        _get(e, t, n || e)
    );
}
function _superPropBase(e, t) {
    for (; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = _getPrototypeOf(e)); );
    return e;
}
function _inherits(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    (e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } })), t && _setPrototypeOf(e, t);
}
function _setPrototypeOf(e, t) {
    return (
        (_setPrototypeOf =
            Object.setPrototypeOf ||
            function (e, t) {
                return (e.__proto__ = t), e;
            }),
        _setPrototypeOf(e, t)
    );
}
function _createSuper(e) {
    var t = _isNativeReflectConstruct();
    return function () {
        var n,
            i = _getPrototypeOf(e);
        if (t) {
            var o = _getPrototypeOf(this).constructor;
            n = Reflect.construct(i, arguments, o);
        } else n = i.apply(this, arguments);
        return _possibleConstructorReturn(this, n);
    };
}
function _possibleConstructorReturn(e, t) {
    return !t || ("object" !== _typeof(t) && "function" != typeof t) ? _assertThisInitialized(e) : t;
}
function _assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
function _isNativeReflectConstruct() {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
        return !1;
    }
}
function _getPrototypeOf(e) {
    return (
        (_getPrototypeOf = Object.setPrototypeOf
            ? Object.getPrototypeOf
            : function (e) {
                  return e.__proto__ || Object.getPrototypeOf(e);
              }),
        _getPrototypeOf(e)
    );
}
function _classCallCheck(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, t) {
    for (var n = 0; n < t.length; n++) {
        var i = t[n];
        (i.enumerable = i.enumerable || !1), (i.configurable = !0), "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
    }
}
function _createClass(e, t, n) {
    return t && _defineProperties(e.prototype, t), n && _defineProperties(e, n), e;
}
function _typeof(e) {
    return (
        (_typeof =
            "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                ? function (e) {
                      return typeof e;
                  }
                : function (e) {
                      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                  }),
        _typeof(e)
    );
}
!(function (e, t) {
    "use strict";
    "object" == typeof module && "object" == typeof module.exports
        ? (module.exports = e.document
              ? t(e, !0)
              : function (e) {
                    if (!e.document) throw new Error("jQuery requires a window with a document");
                    return t(e);
                })
        : t(e);
})("undefined" != typeof window ? window : this, function (e, t) {
    "use strict";
    var n = [],
        i = Object.getPrototypeOf,
        o = n.slice,
        s = n.flat
            ? function (e) {
                  return n.flat.call(e);
              }
            : function (e) {
                  return n.concat.apply([], e);
              },
        r = n.push,
        a = n.indexOf,
        l = {},
        c = l.toString,
        d = l.hasOwnProperty,
        u = d.toString,
        p = u.call(Object),
        h = {},
        f = function (e) {
            return "function" == typeof e && "number" != typeof e.nodeType;
        },
        m = function (e) {
            return null != e && e === e.window;
        },
        g = e.document,
        v = { type: !0, src: !0, nonce: !0, noModule: !0 };
    function y(e, t, n) {
        var i,
            o,
            s = (n = n || g).createElement("script");
        if (((s.text = e), t)) for (i in v) (o = t[i] || (t.getAttribute && t.getAttribute(i))) && s.setAttribute(i, o);
        n.head.appendChild(s).parentNode.removeChild(s);
    }
    function b(e) {
        return null == e ? e + "" : "object" == typeof e || "function" == typeof e ? l[c.call(e)] || "object" : typeof e;
    }
    var w = "3.5.1",
        x = function (e, t) {
            return new x.fn.init(e, t);
        };
    function T(e) {
        var t = !!e && "length" in e && e.length,
            n = b(e);
        return !f(e) && !m(e) && ("array" === n || 0 === t || ("number" == typeof t && 0 < t && t - 1 in e));
    }
    (x.fn = x.prototype = {
        jquery: w,
        constructor: x,
        length: 0,
        toArray: function () {
            return o.call(this);
        },
        get: function (e) {
            return null == e ? o.call(this) : e < 0 ? this[e + this.length] : this[e];
        },
        pushStack: function (e) {
            var t = x.merge(this.constructor(), e);
            return (t.prevObject = this), t;
        },
        each: function (e) {
            return x.each(this, e);
        },
        map: function (e) {
            return this.pushStack(
                x.map(this, function (t, n) {
                    return e.call(t, n, t);
                })
            );
        },
        slice: function () {
            return this.pushStack(o.apply(this, arguments));
        },
        first: function () {
            return this.eq(0);
        },
        last: function () {
            return this.eq(-1);
        },
        even: function () {
            return this.pushStack(
                x.grep(this, function (e, t) {
                    return (t + 1) % 2;
                })
            );
        },
        odd: function () {
            return this.pushStack(
                x.grep(this, function (e, t) {
                    return t % 2;
                })
            );
        },
        eq: function (e) {
            var t = this.length,
                n = +e + (e < 0 ? t : 0);
            return this.pushStack(0 <= n && n < t ? [this[n]] : []);
        },
        end: function () {
            return this.prevObject || this.constructor();
        },
        push: r,
        sort: n.sort,
        splice: n.splice,
    }),
        (x.extend = x.fn.extend = function () {
            var e,
                t,
                n,
                i,
                o,
                s,
                r = arguments[0] || {},
                a = 1,
                l = arguments.length,
                c = !1;
            for ("boolean" == typeof r && ((c = r), (r = arguments[a] || {}), a++), "object" == typeof r || f(r) || (r = {}), a === l && ((r = this), a--); a < l; a++)
                if (null != (e = arguments[a]))
                    for (t in e)
                        (i = e[t]),
                            "__proto__" !== t &&
                                r !== i &&
                                (c && i && (x.isPlainObject(i) || (o = Array.isArray(i)))
                                    ? ((n = r[t]), (s = o && !Array.isArray(n) ? [] : o || x.isPlainObject(n) ? n : {}), (o = !1), (r[t] = x.extend(c, s, i)))
                                    : void 0 !== i && (r[t] = i));
            return r;
        }),
        x.extend({
            expando: "jQuery" + (w + Math.random()).replace(/\D/g, ""),
            isReady: !0,
            error: function (e) {
                throw new Error(e);
            },
            noop: function () {},
            isPlainObject: function (e) {
                var t, n;
                return !(!e || "[object Object]" !== c.call(e) || ((t = i(e)) && ("function" != typeof (n = d.call(t, "constructor") && t.constructor) || u.call(n) !== p)));
            },
            isEmptyObject: function (e) {
                var t;
                for (t in e) return !1;
                return !0;
            },
            globalEval: function (e, t, n) {
                y(e, { nonce: t && t.nonce }, n);
            },
            each: function (e, t) {
                var n,
                    i = 0;
                if (T(e)) for (n = e.length; i < n && !1 !== t.call(e[i], i, e[i]); i++);
                else for (i in e) if (!1 === t.call(e[i], i, e[i])) break;
                return e;
            },
            makeArray: function (e, t) {
                var n = t || [];
                return null != e && (T(Object(e)) ? x.merge(n, "string" == typeof e ? [e] : e) : r.call(n, e)), n;
            },
            inArray: function (e, t, n) {
                return null == t ? -1 : a.call(t, e, n);
            },
            merge: function (e, t) {
                for (var n = +t.length, i = 0, o = e.length; i < n; i++) e[o++] = t[i];
                return (e.length = o), e;
            },
            grep: function (e, t, n) {
                for (var i = [], o = 0, s = e.length, r = !n; o < s; o++) !t(e[o], o) !== r && i.push(e[o]);
                return i;
            },
            map: function (e, t, n) {
                var i,
                    o,
                    r = 0,
                    a = [];
                if (T(e)) for (i = e.length; r < i; r++) null != (o = t(e[r], r, n)) && a.push(o);
                else for (r in e) null != (o = t(e[r], r, n)) && a.push(o);
                return s(a);
            },
            guid: 1,
            support: h,
        }),
        "function" == typeof Symbol && (x.fn[Symbol.iterator] = n[Symbol.iterator]),
        x.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function (e, t) {
            l["[object " + t + "]"] = t.toLowerCase();
        });
    var C = (function (e) {
        var t,
            n,
            i,
            o,
            s,
            r,
            a,
            l,
            c,
            d,
            u,
            p,
            h,
            f,
            m,
            g,
            v,
            y,
            b,
            w = "sizzle" + 1 * new Date(),
            x = e.document,
            T = 0,
            C = 0,
            S = le(),
            k = le(),
            $ = le(),
            _ = le(),
            E = function (e, t) {
                return e === t && (u = !0), 0;
            },
            A = {}.hasOwnProperty,
            M = [],
            P = M.pop,
            L = M.push,
            D = M.push,
            O = M.slice,
            z = function (e, t) {
                for (var n = 0, i = e.length; n < i; n++) if (e[n] === t) return n;
                return -1;
            },
            I = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
            N = "[\\x20\\t\\r\\n\\f]",
            j = "(?:\\\\[\\da-fA-F]{1,6}" + N + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
            R = "\\[" + N + "*(" + j + ")(?:" + N + "*([*^$|!~]?=)" + N + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + j + "))|)" + N + "*\\]",
            H = ":(" + j + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + R + ")*)|.*)\\)|)",
            q = new RegExp(N + "+", "g"),
            F = new RegExp("^" + N + "+|((?:^|[^\\\\])(?:\\\\.)*)" + N + "+$", "g"),
            W = new RegExp("^" + N + "*," + N + "*"),
            B = new RegExp("^" + N + "*([>+~]|" + N + ")" + N + "*"),
            V = new RegExp(N + "|>"),
            U = new RegExp(H),
            G = new RegExp("^" + j + "$"),
            X = {
                ID: new RegExp("^#(" + j + ")"),
                CLASS: new RegExp("^\\.(" + j + ")"),
                TAG: new RegExp("^(" + j + "|[*])"),
                ATTR: new RegExp("^" + R),
                PSEUDO: new RegExp("^" + H),
                CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + N + "*(even|odd|(([+-]|)(\\d*)n|)" + N + "*(?:([+-]|)" + N + "*(\\d+)|))" + N + "*\\)|)", "i"),
                bool: new RegExp("^(?:" + I + ")$", "i"),
                needsContext: new RegExp("^" + N + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + N + "*((?:-\\d)?\\d*)" + N + "*\\)|)(?=[^-]|$)", "i"),
            },
            Y = /HTML$/i,
            K = /^(?:input|select|textarea|button)$/i,
            Z = /^h\d$/i,
            Q = /^[^{]+\{\s*\[native \w/,
            J = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
            ee = /[+~]/,
            te = new RegExp("\\\\[\\da-fA-F]{1,6}" + N + "?|\\\\([^\\r\\n\\f])", "g"),
            ne = function (e, t) {
                var n = "0x" + e.slice(1) - 65536;
                return t || (n < 0 ? String.fromCharCode(n + 65536) : String.fromCharCode((n >> 10) | 55296, (1023 & n) | 56320));
            },
            ie = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
            oe = function (e, t) {
                return t ? ("\0" === e ? "�" : e.slice(0, -1) + "\\" + e.charCodeAt(e.length - 1).toString(16) + " ") : "\\" + e;
            },
            se = function () {
                p();
            },
            re = we(
                function (e) {
                    return !0 === e.disabled && "fieldset" === e.nodeName.toLowerCase();
                },
                { dir: "parentNode", next: "legend" }
            );
        try {
            D.apply((M = O.call(x.childNodes)), x.childNodes), M[x.childNodes.length].nodeType;
        } catch (t) {
            D = {
                apply: M.length
                    ? function (e, t) {
                          L.apply(e, O.call(t));
                      }
                    : function (e, t) {
                          for (var n = e.length, i = 0; (e[n++] = t[i++]); );
                          e.length = n - 1;
                      },
            };
        }
        function ae(e, t, i, o) {
            var s,
                a,
                c,
                d,
                u,
                f,
                v,
                y = t && t.ownerDocument,
                x = t ? t.nodeType : 9;
            if (((i = i || []), "string" != typeof e || !e || (1 !== x && 9 !== x && 11 !== x))) return i;
            if (!o && (p(t), (t = t || h), m)) {
                if (11 !== x && (u = J.exec(e)))
                    if ((s = u[1])) {
                        if (9 === x) {
                            if (!(c = t.getElementById(s))) return i;
                            if (c.id === s) return i.push(c), i;
                        } else if (y && (c = y.getElementById(s)) && b(t, c) && c.id === s) return i.push(c), i;
                    } else {
                        if (u[2]) return D.apply(i, t.getElementsByTagName(e)), i;
                        if ((s = u[3]) && n.getElementsByClassName && t.getElementsByClassName) return D.apply(i, t.getElementsByClassName(s)), i;
                    }
                if (n.qsa && !_[e + " "] && (!g || !g.test(e)) && (1 !== x || "object" !== t.nodeName.toLowerCase())) {
                    if (((v = e), (y = t), 1 === x && (V.test(e) || B.test(e)))) {
                        for (((y = (ee.test(e) && ve(t.parentNode)) || t) === t && n.scope) || ((d = t.getAttribute("id")) ? (d = d.replace(ie, oe)) : t.setAttribute("id", (d = w))), a = (f = r(e)).length; a--; )
                            f[a] = (d ? "#" + d : ":scope") + " " + be(f[a]);
                        v = f.join(",");
                    }
                    try {
                        return D.apply(i, y.querySelectorAll(v)), i;
                    } catch (t) {
                        _(e, !0);
                    } finally {
                        d === w && t.removeAttribute("id");
                    }
                }
            }
            return l(e.replace(F, "$1"), t, i, o);
        }
        function le() {
            var e = [];
            return function t(n, o) {
                return e.push(n + " ") > i.cacheLength && delete t[e.shift()], (t[n + " "] = o);
            };
        }
        function ce(e) {
            return (e[w] = !0), e;
        }
        function de(e) {
            var t = h.createElement("fieldset");
            try {
                return !!e(t);
            } catch (e) {
                return !1;
            } finally {
                t.parentNode && t.parentNode.removeChild(t), (t = null);
            }
        }
        function ue(e, t) {
            for (var n = e.split("|"), o = n.length; o--; ) i.attrHandle[n[o]] = t;
        }
        function pe(e, t) {
            var n = t && e,
                i = n && 1 === e.nodeType && 1 === t.nodeType && e.sourceIndex - t.sourceIndex;
            if (i) return i;
            if (n) for (; (n = n.nextSibling); ) if (n === t) return -1;
            return e ? 1 : -1;
        }
        function he(e) {
            return function (t) {
                return "input" === t.nodeName.toLowerCase() && t.type === e;
            };
        }
        function fe(e) {
            return function (t) {
                var n = t.nodeName.toLowerCase();
                return ("input" === n || "button" === n) && t.type === e;
            };
        }
        function me(e) {
            return function (t) {
                return "form" in t
                    ? t.parentNode && !1 === t.disabled
                        ? "label" in t
                            ? "label" in t.parentNode
                                ? t.parentNode.disabled === e
                                : t.disabled === e
                            : t.isDisabled === e || (t.isDisabled !== !e && re(t) === e)
                        : t.disabled === e
                    : "label" in t && t.disabled === e;
            };
        }
        function ge(e) {
            return ce(function (t) {
                return (
                    (t = +t),
                    ce(function (n, i) {
                        for (var o, s = e([], n.length, t), r = s.length; r--; ) n[(o = s[r])] && (n[o] = !(i[o] = n[o]));
                    })
                );
            });
        }
        function ve(e) {
            return e && void 0 !== e.getElementsByTagName && e;
        }
        for (t in ((n = ae.support = {}),
        (s = ae.isXML = function (e) {
            var t = e.namespaceURI,
                n = (e.ownerDocument || e).documentElement;
            return !Y.test(t || (n && n.nodeName) || "HTML");
        }),
        (p = ae.setDocument = function (e) {
            var t,
                o,
                r = e ? e.ownerDocument || e : x;
            return (
                r != h &&
                    9 === r.nodeType &&
                    r.documentElement &&
                    ((f = (h = r).documentElement),
                    (m = !s(h)),
                    x != h && (o = h.defaultView) && o.top !== o && (o.addEventListener ? o.addEventListener("unload", se, !1) : o.attachEvent && o.attachEvent("onunload", se)),
                    (n.scope = de(function (e) {
                        return f.appendChild(e).appendChild(h.createElement("div")), void 0 !== e.querySelectorAll && !e.querySelectorAll(":scope fieldset div").length;
                    })),
                    (n.attributes = de(function (e) {
                        return (e.className = "i"), !e.getAttribute("className");
                    })),
                    (n.getElementsByTagName = de(function (e) {
                        return e.appendChild(h.createComment("")), !e.getElementsByTagName("*").length;
                    })),
                    (n.getElementsByClassName = Q.test(h.getElementsByClassName)),
                    (n.getById = de(function (e) {
                        return (f.appendChild(e).id = w), !h.getElementsByName || !h.getElementsByName(w).length;
                    })),
                    n.getById
                        ? ((i.filter.ID = function (e) {
                              var t = e.replace(te, ne);
                              return function (e) {
                                  return e.getAttribute("id") === t;
                              };
                          }),
                          (i.find.ID = function (e, t) {
                              if (void 0 !== t.getElementById && m) {
                                  var n = t.getElementById(e);
                                  return n ? [n] : [];
                              }
                          }))
                        : ((i.filter.ID = function (e) {
                              var t = e.replace(te, ne);
                              return function (e) {
                                  var n = void 0 !== e.getAttributeNode && e.getAttributeNode("id");
                                  return n && n.value === t;
                              };
                          }),
                          (i.find.ID = function (e, t) {
                              if (void 0 !== t.getElementById && m) {
                                  var n,
                                      i,
                                      o,
                                      s = t.getElementById(e);
                                  if (s) {
                                      if ((n = s.getAttributeNode("id")) && n.value === e) return [s];
                                      for (o = t.getElementsByName(e), i = 0; (s = o[i++]); ) if ((n = s.getAttributeNode("id")) && n.value === e) return [s];
                                  }
                                  return [];
                              }
                          })),
                    (i.find.TAG = n.getElementsByTagName
                        ? function (e, t) {
                              return void 0 !== t.getElementsByTagName ? t.getElementsByTagName(e) : n.qsa ? t.querySelectorAll(e) : void 0;
                          }
                        : function (e, t) {
                              var n,
                                  i = [],
                                  o = 0,
                                  s = t.getElementsByTagName(e);
                              if ("*" === e) {
                                  for (; (n = s[o++]); ) 1 === n.nodeType && i.push(n);
                                  return i;
                              }
                              return s;
                          }),
                    (i.find.CLASS =
                        n.getElementsByClassName &&
                        function (e, t) {
                            if (void 0 !== t.getElementsByClassName && m) return t.getElementsByClassName(e);
                        }),
                    (v = []),
                    (g = []),
                    (n.qsa = Q.test(h.querySelectorAll)) &&
                        (de(function (e) {
                            var t;
                            (f.appendChild(e).innerHTML = "<a id='" + w + "'></a><select id='" + w + "-\r\\' msallowcapture=''><option selected=''></option></select>"),
                                e.querySelectorAll("[msallowcapture^='']").length && g.push("[*^$]=" + N + "*(?:''|\"\")"),
                                e.querySelectorAll("[selected]").length || g.push("\\[" + N + "*(?:value|" + I + ")"),
                                e.querySelectorAll("[id~=" + w + "-]").length || g.push("~="),
                                (t = h.createElement("input")).setAttribute("name", ""),
                                e.appendChild(t),
                                e.querySelectorAll("[name='']").length || g.push("\\[" + N + "*name" + N + "*=" + N + "*(?:''|\"\")"),
                                e.querySelectorAll(":checked").length || g.push(":checked"),
                                e.querySelectorAll("a#" + w + "+*").length || g.push(".#.+[+~]"),
                                e.querySelectorAll("\\\f"),
                                g.push("[\\r\\n\\f]");
                        }),
                        de(function (e) {
                            e.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                            var t = h.createElement("input");
                            t.setAttribute("type", "hidden"),
                                e.appendChild(t).setAttribute("name", "D"),
                                e.querySelectorAll("[name=d]").length && g.push("name" + N + "*[*^$|!~]?="),
                                2 !== e.querySelectorAll(":enabled").length && g.push(":enabled", ":disabled"),
                                (f.appendChild(e).disabled = !0),
                                2 !== e.querySelectorAll(":disabled").length && g.push(":enabled", ":disabled"),
                                e.querySelectorAll("*,:x"),
                                g.push(",.*:");
                        })),
                    (n.matchesSelector = Q.test((y = f.matches || f.webkitMatchesSelector || f.mozMatchesSelector || f.oMatchesSelector || f.msMatchesSelector))) &&
                        de(function (e) {
                            (n.disconnectedMatch = y.call(e, "*")), y.call(e, "[s!='']:x"), v.push("!=", H);
                        }),
                    (g = g.length && new RegExp(g.join("|"))),
                    (v = v.length && new RegExp(v.join("|"))),
                    (t = Q.test(f.compareDocumentPosition)),
                    (b =
                        t || Q.test(f.contains)
                            ? function (e, t) {
                                  var n = 9 === e.nodeType ? e.documentElement : e,
                                      i = t && t.parentNode;
                                  return e === i || !(!i || 1 !== i.nodeType || !(n.contains ? n.contains(i) : e.compareDocumentPosition && 16 & e.compareDocumentPosition(i)));
                              }
                            : function (e, t) {
                                  if (t) for (; (t = t.parentNode); ) if (t === e) return !0;
                                  return !1;
                              }),
                    (E = t
                        ? function (e, t) {
                              if (e === t) return (u = !0), 0;
                              var i = !e.compareDocumentPosition - !t.compareDocumentPosition;
                              return (
                                  i ||
                                  (1 & (i = (e.ownerDocument || e) == (t.ownerDocument || t) ? e.compareDocumentPosition(t) : 1) || (!n.sortDetached && t.compareDocumentPosition(e) === i)
                                      ? e == h || (e.ownerDocument == x && b(x, e))
                                          ? -1
                                          : t == h || (t.ownerDocument == x && b(x, t))
                                          ? 1
                                          : d
                                          ? z(d, e) - z(d, t)
                                          : 0
                                      : 4 & i
                                      ? -1
                                      : 1)
                              );
                          }
                        : function (e, t) {
                              if (e === t) return (u = !0), 0;
                              var n,
                                  i = 0,
                                  o = e.parentNode,
                                  s = t.parentNode,
                                  r = [e],
                                  a = [t];
                              if (!o || !s) return e == h ? -1 : t == h ? 1 : o ? -1 : s ? 1 : d ? z(d, e) - z(d, t) : 0;
                              if (o === s) return pe(e, t);
                              for (n = e; (n = n.parentNode); ) r.unshift(n);
                              for (n = t; (n = n.parentNode); ) a.unshift(n);
                              for (; r[i] === a[i]; ) i++;
                              return i ? pe(r[i], a[i]) : r[i] == x ? -1 : a[i] == x ? 1 : 0;
                          })),
                h
            );
        }),
        (ae.matches = function (e, t) {
            return ae(e, null, null, t);
        }),
        (ae.matchesSelector = function (e, t) {
            if ((p(e), n.matchesSelector && m && !_[t + " "] && (!v || !v.test(t)) && (!g || !g.test(t))))
                try {
                    var i = y.call(e, t);
                    if (i || n.disconnectedMatch || (e.document && 11 !== e.document.nodeType)) return i;
                } catch (e) {
                    _(t, !0);
                }
            return 0 < ae(t, h, null, [e]).length;
        }),
        (ae.contains = function (e, t) {
            return (e.ownerDocument || e) != h && p(e), b(e, t);
        }),
        (ae.attr = function (e, t) {
            (e.ownerDocument || e) != h && p(e);
            var o = i.attrHandle[t.toLowerCase()],
                s = o && A.call(i.attrHandle, t.toLowerCase()) ? o(e, t, !m) : void 0;
            return void 0 !== s ? s : n.attributes || !m ? e.getAttribute(t) : (s = e.getAttributeNode(t)) && s.specified ? s.value : null;
        }),
        (ae.escape = function (e) {
            return (e + "").replace(ie, oe);
        }),
        (ae.error = function (e) {
            throw new Error("Syntax error, unrecognized expression: " + e);
        }),
        (ae.uniqueSort = function (e) {
            var t,
                i = [],
                o = 0,
                s = 0;
            if (((u = !n.detectDuplicates), (d = !n.sortStable && e.slice(0)), e.sort(E), u)) {
                for (; (t = e[s++]); ) t === e[s] && (o = i.push(s));
                for (; o--; ) e.splice(i[o], 1);
            }
            return (d = null), e;
        }),
        (o = ae.getText = function (e) {
            var t,
                n = "",
                i = 0,
                s = e.nodeType;
            if (s) {
                if (1 === s || 9 === s || 11 === s) {
                    if ("string" == typeof e.textContent) return e.textContent;
                    for (e = e.firstChild; e; e = e.nextSibling) n += o(e);
                } else if (3 === s || 4 === s) return e.nodeValue;
            } else for (; (t = e[i++]); ) n += o(t);
            return n;
        }),
        ((i = ae.selectors = {
            cacheLength: 50,
            createPseudo: ce,
            match: X,
            attrHandle: {},
            find: {},
            relative: { ">": { dir: "parentNode", first: !0 }, " ": { dir: "parentNode" }, "+": { dir: "previousSibling", first: !0 }, "~": { dir: "previousSibling" } },
            preFilter: {
                ATTR: function (e) {
                    return (e[1] = e[1].replace(te, ne)), (e[3] = (e[3] || e[4] || e[5] || "").replace(te, ne)), "~=" === e[2] && (e[3] = " " + e[3] + " "), e.slice(0, 4);
                },
                CHILD: function (e) {
                    return (
                        (e[1] = e[1].toLowerCase()),
                        "nth" === e[1].slice(0, 3) ? (e[3] || ae.error(e[0]), (e[4] = +(e[4] ? e[5] + (e[6] || 1) : 2 * ("even" === e[3] || "odd" === e[3]))), (e[5] = +(e[7] + e[8] || "odd" === e[3]))) : e[3] && ae.error(e[0]),
                        e
                    );
                },
                PSEUDO: function (e) {
                    var t,
                        n = !e[6] && e[2];
                    return X.CHILD.test(e[0])
                        ? null
                        : (e[3] ? (e[2] = e[4] || e[5] || "") : n && U.test(n) && (t = r(n, !0)) && (t = n.indexOf(")", n.length - t) - n.length) && ((e[0] = e[0].slice(0, t)), (e[2] = n.slice(0, t))), e.slice(0, 3));
                },
            },
            filter: {
                TAG: function (e) {
                    var t = e.replace(te, ne).toLowerCase();
                    return "*" === e
                        ? function () {
                              return !0;
                          }
                        : function (e) {
                              return e.nodeName && e.nodeName.toLowerCase() === t;
                          };
                },
                CLASS: function (e) {
                    var t = S[e + " "];
                    return (
                        t ||
                        ((t = new RegExp("(^|" + N + ")" + e + "(" + N + "|$)")) &&
                            S(e, function (e) {
                                return t.test(("string" == typeof e.className && e.className) || (void 0 !== e.getAttribute && e.getAttribute("class")) || "");
                            }))
                    );
                },
                ATTR: function (e, t, n) {
                    return function (i) {
                        var o = ae.attr(i, e);
                        return null == o
                            ? "!=" === t
                            : !t ||
                                  ((o += ""),
                                  "=" === t
                                      ? o === n
                                      : "!=" === t
                                      ? o !== n
                                      : "^=" === t
                                      ? n && 0 === o.indexOf(n)
                                      : "*=" === t
                                      ? n && -1 < o.indexOf(n)
                                      : "$=" === t
                                      ? n && o.slice(-n.length) === n
                                      : "~=" === t
                                      ? -1 < (" " + o.replace(q, " ") + " ").indexOf(n)
                                      : "|=" === t && (o === n || o.slice(0, n.length + 1) === n + "-"));
                    };
                },
                CHILD: function (e, t, n, i, o) {
                    var s = "nth" !== e.slice(0, 3),
                        r = "last" !== e.slice(-4),
                        a = "of-type" === t;
                    return 1 === i && 0 === o
                        ? function (e) {
                              return !!e.parentNode;
                          }
                        : function (t, n, l) {
                              var c,
                                  d,
                                  u,
                                  p,
                                  h,
                                  f,
                                  m = s !== r ? "nextSibling" : "previousSibling",
                                  g = t.parentNode,
                                  v = a && t.nodeName.toLowerCase(),
                                  y = !l && !a,
                                  b = !1;
                              if (g) {
                                  if (s) {
                                      for (; m; ) {
                                          for (p = t; (p = p[m]); ) if (a ? p.nodeName.toLowerCase() === v : 1 === p.nodeType) return !1;
                                          f = m = "only" === e && !f && "nextSibling";
                                      }
                                      return !0;
                                  }
                                  if (((f = [r ? g.firstChild : g.lastChild]), r && y)) {
                                      for (
                                          b = (h = (c = (d = (u = (p = g)[w] || (p[w] = {}))[p.uniqueID] || (u[p.uniqueID] = {}))[e] || [])[0] === T && c[1]) && c[2], p = h && g.childNodes[h];
                                          (p = (++h && p && p[m]) || (b = h = 0) || f.pop());

                                      )
                                          if (1 === p.nodeType && ++b && p === t) {
                                              d[e] = [T, h, b];
                                              break;
                                          }
                                  } else if ((y && (b = h = (c = (d = (u = (p = t)[w] || (p[w] = {}))[p.uniqueID] || (u[p.uniqueID] = {}))[e] || [])[0] === T && c[1]), !1 === b))
                                      for (
                                          ;
                                          (p = (++h && p && p[m]) || (b = h = 0) || f.pop()) &&
                                          ((a ? p.nodeName.toLowerCase() !== v : 1 !== p.nodeType) || !++b || (y && ((d = (u = p[w] || (p[w] = {}))[p.uniqueID] || (u[p.uniqueID] = {}))[e] = [T, b]), p !== t));

                                      );
                                  return (b -= o) === i || (b % i == 0 && 0 <= b / i);
                              }
                          };
                },
                PSEUDO: function (e, t) {
                    var n,
                        o = i.pseudos[e] || i.setFilters[e.toLowerCase()] || ae.error("unsupported pseudo: " + e);
                    return o[w]
                        ? o(t)
                        : 1 < o.length
                        ? ((n = [e, e, "", t]),
                          i.setFilters.hasOwnProperty(e.toLowerCase())
                              ? ce(function (e, n) {
                                    for (var i, s = o(e, t), r = s.length; r--; ) e[(i = z(e, s[r]))] = !(n[i] = s[r]);
                                })
                              : function (e) {
                                    return o(e, 0, n);
                                })
                        : o;
                },
            },
            pseudos: {
                not: ce(function (e) {
                    var t = [],
                        n = [],
                        i = a(e.replace(F, "$1"));
                    return i[w]
                        ? ce(function (e, t, n, o) {
                              for (var s, r = i(e, null, o, []), a = e.length; a--; ) (s = r[a]) && (e[a] = !(t[a] = s));
                          })
                        : function (e, o, s) {
                              return (t[0] = e), i(t, null, s, n), (t[0] = null), !n.pop();
                          };
                }),
                has: ce(function (e) {
                    return function (t) {
                        return 0 < ae(e, t).length;
                    };
                }),
                contains: ce(function (e) {
                    return (
                        (e = e.replace(te, ne)),
                        function (t) {
                            return -1 < (t.textContent || o(t)).indexOf(e);
                        }
                    );
                }),
                lang: ce(function (e) {
                    return (
                        G.test(e || "") || ae.error("unsupported lang: " + e),
                        (e = e.replace(te, ne).toLowerCase()),
                        function (t) {
                            var n;
                            do {
                                if ((n = m ? t.lang : t.getAttribute("xml:lang") || t.getAttribute("lang"))) return (n = n.toLowerCase()) === e || 0 === n.indexOf(e + "-");
                            } while ((t = t.parentNode) && 1 === t.nodeType);
                            return !1;
                        }
                    );
                }),
                target: function (t) {
                    var n = e.location && e.location.hash;
                    return n && n.slice(1) === t.id;
                },
                root: function (e) {
                    return e === f;
                },
                focus: function (e) {
                    return e === h.activeElement && (!h.hasFocus || h.hasFocus()) && !!(e.type || e.href || ~e.tabIndex);
                },
                enabled: me(!1),
                disabled: me(!0),
                checked: function (e) {
                    var t = e.nodeName.toLowerCase();
                    return ("input" === t && !!e.checked) || ("option" === t && !!e.selected);
                },
                selected: function (e) {
                    return e.parentNode && e.parentNode.selectedIndex, !0 === e.selected;
                },
                empty: function (e) {
                    for (e = e.firstChild; e; e = e.nextSibling) if (e.nodeType < 6) return !1;
                    return !0;
                },
                parent: function (e) {
                    return !i.pseudos.empty(e);
                },
                header: function (e) {
                    return Z.test(e.nodeName);
                },
                input: function (e) {
                    return K.test(e.nodeName);
                },
                button: function (e) {
                    var t = e.nodeName.toLowerCase();
                    return ("input" === t && "button" === e.type) || "button" === t;
                },
                text: function (e) {
                    var t;
                    return "input" === e.nodeName.toLowerCase() && "text" === e.type && (null == (t = e.getAttribute("type")) || "text" === t.toLowerCase());
                },
                first: ge(function () {
                    return [0];
                }),
                last: ge(function (e, t) {
                    return [t - 1];
                }),
                eq: ge(function (e, t, n) {
                    return [n < 0 ? n + t : n];
                }),
                even: ge(function (e, t) {
                    for (var n = 0; n < t; n += 2) e.push(n);
                    return e;
                }),
                odd: ge(function (e, t) {
                    for (var n = 1; n < t; n += 2) e.push(n);
                    return e;
                }),
                lt: ge(function (e, t, n) {
                    for (var i = n < 0 ? n + t : t < n ? t : n; 0 <= --i; ) e.push(i);
                    return e;
                }),
                gt: ge(function (e, t, n) {
                    for (var i = n < 0 ? n + t : n; ++i < t; ) e.push(i);
                    return e;
                }),
            },
        }).pseudos.nth = i.pseudos.eq),
        { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 }))
            i.pseudos[t] = he(t);
        for (t in { submit: !0, reset: !0 }) i.pseudos[t] = fe(t);
        function ye() {}
        function be(e) {
            for (var t = 0, n = e.length, i = ""; t < n; t++) i += e[t].value;
            return i;
        }
        function we(e, t, n) {
            var i = t.dir,
                o = t.next,
                s = o || i,
                r = n && "parentNode" === s,
                a = C++;
            return t.first
                ? function (t, n, o) {
                      for (; (t = t[i]); ) if (1 === t.nodeType || r) return e(t, n, o);
                      return !1;
                  }
                : function (t, n, l) {
                      var c,
                          d,
                          u,
                          p = [T, a];
                      if (l) {
                          for (; (t = t[i]); ) if ((1 === t.nodeType || r) && e(t, n, l)) return !0;
                      } else
                          for (; (t = t[i]); )
                              if (1 === t.nodeType || r)
                                  if (((d = (u = t[w] || (t[w] = {}))[t.uniqueID] || (u[t.uniqueID] = {})), o && o === t.nodeName.toLowerCase())) t = t[i] || t;
                                  else {
                                      if ((c = d[s]) && c[0] === T && c[1] === a) return (p[2] = c[2]);
                                      if (((d[s] = p)[2] = e(t, n, l))) return !0;
                                  }
                      return !1;
                  };
        }
        function xe(e) {
            return 1 < e.length
                ? function (t, n, i) {
                      for (var o = e.length; o--; ) if (!e[o](t, n, i)) return !1;
                      return !0;
                  }
                : e[0];
        }
        function Te(e, t, n, i, o) {
            for (var s, r = [], a = 0, l = e.length, c = null != t; a < l; a++) (s = e[a]) && ((n && !n(s, i, o)) || (r.push(s), c && t.push(a)));
            return r;
        }
        function Ce(e, t, n, i, o, s) {
            return (
                i && !i[w] && (i = Ce(i)),
                o && !o[w] && (o = Ce(o, s)),
                ce(function (s, r, a, l) {
                    var c,
                        d,
                        u,
                        p = [],
                        h = [],
                        f = r.length,
                        m =
                            s ||
                            (function (e, t, n) {
                                for (var i = 0, o = t.length; i < o; i++) ae(e, t[i], n);
                                return n;
                            })(t || "*", a.nodeType ? [a] : a, []),
                        g = !e || (!s && t) ? m : Te(m, p, e, a, l),
                        v = n ? (o || (s ? e : f || i) ? [] : r) : g;
                    if ((n && n(g, v, a, l), i)) for (c = Te(v, h), i(c, [], a, l), d = c.length; d--; ) (u = c[d]) && (v[h[d]] = !(g[h[d]] = u));
                    if (s) {
                        if (o || e) {
                            if (o) {
                                for (c = [], d = v.length; d--; ) (u = v[d]) && c.push((g[d] = u));
                                o(null, (v = []), c, l);
                            }
                            for (d = v.length; d--; ) (u = v[d]) && -1 < (c = o ? z(s, u) : p[d]) && (s[c] = !(r[c] = u));
                        }
                    } else (v = Te(v === r ? v.splice(f, v.length) : v)), o ? o(null, r, v, l) : D.apply(r, v);
                })
            );
        }
        function Se(e) {
            for (
                var t,
                    n,
                    o,
                    s = e.length,
                    r = i.relative[e[0].type],
                    a = r || i.relative[" "],
                    l = r ? 1 : 0,
                    d = we(
                        function (e) {
                            return e === t;
                        },
                        a,
                        !0
                    ),
                    u = we(
                        function (e) {
                            return -1 < z(t, e);
                        },
                        a,
                        !0
                    ),
                    p = [
                        function (e, n, i) {
                            var o = (!r && (i || n !== c)) || ((t = n).nodeType ? d(e, n, i) : u(e, n, i));
                            return (t = null), o;
                        },
                    ];
                l < s;
                l++
            )
                if ((n = i.relative[e[l].type])) p = [we(xe(p), n)];
                else {
                    if ((n = i.filter[e[l].type].apply(null, e[l].matches))[w]) {
                        for (o = ++l; o < s && !i.relative[e[o].type]; o++);
                        return Ce(1 < l && xe(p), 1 < l && be(e.slice(0, l - 1).concat({ value: " " === e[l - 2].type ? "*" : "" })).replace(F, "$1"), n, l < o && Se(e.slice(l, o)), o < s && Se((e = e.slice(o))), o < s && be(e));
                    }
                    p.push(n);
                }
            return xe(p);
        }
        return (
            (ye.prototype = i.filters = i.pseudos),
            (i.setFilters = new ye()),
            (r = ae.tokenize = function (e, t) {
                var n,
                    o,
                    s,
                    r,
                    a,
                    l,
                    c,
                    d = k[e + " "];
                if (d) return t ? 0 : d.slice(0);
                for (a = e, l = [], c = i.preFilter; a; ) {
                    for (r in ((n && !(o = W.exec(a))) || (o && (a = a.slice(o[0].length) || a), l.push((s = []))),
                    (n = !1),
                    (o = B.exec(a)) && ((n = o.shift()), s.push({ value: n, type: o[0].replace(F, " ") }), (a = a.slice(n.length))),
                    i.filter))
                        !(o = X[r].exec(a)) || (c[r] && !(o = c[r](o))) || ((n = o.shift()), s.push({ value: n, type: r, matches: o }), (a = a.slice(n.length)));
                    if (!n) break;
                }
                return t ? a.length : a ? ae.error(e) : k(e, l).slice(0);
            }),
            (a = ae.compile = function (e, t) {
                var n,
                    o,
                    s,
                    a,
                    l,
                    d,
                    u = [],
                    f = [],
                    g = $[e + " "];
                if (!g) {
                    for (t || (t = r(e)), n = t.length; n--; ) (g = Se(t[n]))[w] ? u.push(g) : f.push(g);
                    (g = $(
                        e,
                        ((o = f),
                        (a = 0 < (s = u).length),
                        (l = 0 < o.length),
                        (d = function (e, t, n, r, d) {
                            var u,
                                f,
                                g,
                                v = 0,
                                y = "0",
                                b = e && [],
                                w = [],
                                x = c,
                                C = e || (l && i.find.TAG("*", d)),
                                S = (T += null == x ? 1 : Math.random() || 0.1),
                                k = C.length;
                            for (d && (c = t == h || t || d); y !== k && null != (u = C[y]); y++) {
                                if (l && u) {
                                    for (f = 0, t || u.ownerDocument == h || (p(u), (n = !m)); (g = o[f++]); )
                                        if (g(u, t || h, n)) {
                                            r.push(u);
                                            break;
                                        }
                                    d && (T = S);
                                }
                                a && ((u = !g && u) && v--, e && b.push(u));
                            }
                            if (((v += y), a && y !== v)) {
                                for (f = 0; (g = s[f++]); ) g(b, w, t, n);
                                if (e) {
                                    if (0 < v) for (; y--; ) b[y] || w[y] || (w[y] = P.call(r));
                                    w = Te(w);
                                }
                                D.apply(r, w), d && !e && 0 < w.length && 1 < v + s.length && ae.uniqueSort(r);
                            }
                            return d && ((T = S), (c = x)), b;
                        }),
                        a ? ce(d) : d)
                    )).selector = e;
                }
                return g;
            }),
            (l = ae.select = function (e, t, n, o) {
                var s,
                    l,
                    c,
                    d,
                    u,
                    p = "function" == typeof e && e,
                    h = !o && r((e = p.selector || e));
                if (((n = n || []), 1 === h.length)) {
                    if (2 < (l = h[0] = h[0].slice(0)).length && "ID" === (c = l[0]).type && 9 === t.nodeType && m && i.relative[l[1].type]) {
                        if (!(t = (i.find.ID(c.matches[0].replace(te, ne), t) || [])[0])) return n;
                        p && (t = t.parentNode), (e = e.slice(l.shift().value.length));
                    }
                    for (s = X.needsContext.test(e) ? 0 : l.length; s-- && ((c = l[s]), !i.relative[(d = c.type)]); )
                        if ((u = i.find[d]) && (o = u(c.matches[0].replace(te, ne), (ee.test(l[0].type) && ve(t.parentNode)) || t))) {
                            if ((l.splice(s, 1), !(e = o.length && be(l)))) return D.apply(n, o), n;
                            break;
                        }
                }
                return (p || a(e, h))(o, t, !m, n, !t || (ee.test(e) && ve(t.parentNode)) || t), n;
            }),
            (n.sortStable = w.split("").sort(E).join("") === w),
            (n.detectDuplicates = !!u),
            p(),
            (n.sortDetached = de(function (e) {
                return 1 & e.compareDocumentPosition(h.createElement("fieldset"));
            })),
            de(function (e) {
                return (e.innerHTML = "<a href='#'></a>"), "#" === e.firstChild.getAttribute("href");
            }) ||
                ue("type|href|height|width", function (e, t, n) {
                    if (!n) return e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2);
                }),
            (n.attributes &&
                de(function (e) {
                    return (e.innerHTML = "<input/>"), e.firstChild.setAttribute("value", ""), "" === e.firstChild.getAttribute("value");
                })) ||
                ue("value", function (e, t, n) {
                    if (!n && "input" === e.nodeName.toLowerCase()) return e.defaultValue;
                }),
            de(function (e) {
                return null == e.getAttribute("disabled");
            }) ||
                ue(I, function (e, t, n) {
                    var i;
                    if (!n) return !0 === e[t] ? t.toLowerCase() : (i = e.getAttributeNode(t)) && i.specified ? i.value : null;
                }),
            ae
        );
    })(e);
    (x.find = C), (x.expr = C.selectors), (x.expr[":"] = x.expr.pseudos), (x.uniqueSort = x.unique = C.uniqueSort), (x.text = C.getText), (x.isXMLDoc = C.isXML), (x.contains = C.contains), (x.escapeSelector = C.escape);
    var S = function (e, t, n) {
            for (var i = [], o = void 0 !== n; (e = e[t]) && 9 !== e.nodeType; )
                if (1 === e.nodeType) {
                    if (o && x(e).is(n)) break;
                    i.push(e);
                }
            return i;
        },
        k = function (e, t) {
            for (var n = []; e; e = e.nextSibling) 1 === e.nodeType && e !== t && n.push(e);
            return n;
        },
        $ = x.expr.match.needsContext;
    function _(e, t) {
        return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase();
    }
    var E = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    function A(e, t, n) {
        return f(t)
            ? x.grep(e, function (e, i) {
                  return !!t.call(e, i, e) !== n;
              })
            : t.nodeType
            ? x.grep(e, function (e) {
                  return (e === t) !== n;
              })
            : "string" != typeof t
            ? x.grep(e, function (e) {
                  return -1 < a.call(t, e) !== n;
              })
            : x.filter(t, e, n);
    }
    (x.filter = function (e, t, n) {
        var i = t[0];
        return (
            n && (e = ":not(" + e + ")"),
            1 === t.length && 1 === i.nodeType
                ? x.find.matchesSelector(i, e)
                    ? [i]
                    : []
                : x.find.matches(
                      e,
                      x.grep(t, function (e) {
                          return 1 === e.nodeType;
                      })
                  )
        );
    }),
        x.fn.extend({
            find: function (e) {
                var t,
                    n,
                    i = this.length,
                    o = this;
                if ("string" != typeof e)
                    return this.pushStack(
                        x(e).filter(function () {
                            for (t = 0; t < i; t++) if (x.contains(o[t], this)) return !0;
                        })
                    );
                for (n = this.pushStack([]), t = 0; t < i; t++) x.find(e, o[t], n);
                return 1 < i ? x.uniqueSort(n) : n;
            },
            filter: function (e) {
                return this.pushStack(A(this, e || [], !1));
            },
            not: function (e) {
                return this.pushStack(A(this, e || [], !0));
            },
            is: function (e) {
                return !!A(this, "string" == typeof e && $.test(e) ? x(e) : e || [], !1).length;
            },
        });
    var M,
        P = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
    ((x.fn.init = function (e, t, n) {
        var i, o;
        if (!e) return this;
        if (((n = n || M), "string" == typeof e)) {
            if (!(i = "<" === e[0] && ">" === e[e.length - 1] && 3 <= e.length ? [null, e, null] : P.exec(e)) || (!i[1] && t)) return !t || t.jquery ? (t || n).find(e) : this.constructor(t).find(e);
            if (i[1]) {
                if (((t = t instanceof x ? t[0] : t), x.merge(this, x.parseHTML(i[1], t && t.nodeType ? t.ownerDocument || t : g, !0)), E.test(i[1]) && x.isPlainObject(t))) for (i in t) f(this[i]) ? this[i](t[i]) : this.attr(i, t[i]);
                return this;
            }
            return (o = g.getElementById(i[2])) && ((this[0] = o), (this.length = 1)), this;
        }
        return e.nodeType ? ((this[0] = e), (this.length = 1), this) : f(e) ? (void 0 !== n.ready ? n.ready(e) : e(x)) : x.makeArray(e, this);
    }).prototype = x.fn),
        (M = x(g));
    var L = /^(?:parents|prev(?:Until|All))/,
        D = { children: !0, contents: !0, next: !0, prev: !0 };
    function O(e, t) {
        for (; (e = e[t]) && 1 !== e.nodeType; );
        return e;
    }
    x.fn.extend({
        has: function (e) {
            var t = x(e, this),
                n = t.length;
            return this.filter(function () {
                for (var e = 0; e < n; e++) if (x.contains(this, t[e])) return !0;
            });
        },
        closest: function (e, t) {
            var n,
                i = 0,
                o = this.length,
                s = [],
                r = "string" != typeof e && x(e);
            if (!$.test(e))
                for (; i < o; i++)
                    for (n = this[i]; n && n !== t; n = n.parentNode)
                        if (n.nodeType < 11 && (r ? -1 < r.index(n) : 1 === n.nodeType && x.find.matchesSelector(n, e))) {
                            s.push(n);
                            break;
                        }
            return this.pushStack(1 < s.length ? x.uniqueSort(s) : s);
        },
        index: function (e) {
            return e ? ("string" == typeof e ? a.call(x(e), this[0]) : a.call(this, e.jquery ? e[0] : e)) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
        },
        add: function (e, t) {
            return this.pushStack(x.uniqueSort(x.merge(this.get(), x(e, t))));
        },
        addBack: function (e) {
            return this.add(null == e ? this.prevObject : this.prevObject.filter(e));
        },
    }),
        x.each(
            {
                parent: function (e) {
                    var t = e.parentNode;
                    return t && 11 !== t.nodeType ? t : null;
                },
                parents: function (e) {
                    return S(e, "parentNode");
                },
                parentsUntil: function (e, t, n) {
                    return S(e, "parentNode", n);
                },
                next: function (e) {
                    return O(e, "nextSibling");
                },
                prev: function (e) {
                    return O(e, "previousSibling");
                },
                nextAll: function (e) {
                    return S(e, "nextSibling");
                },
                prevAll: function (e) {
                    return S(e, "previousSibling");
                },
                nextUntil: function (e, t, n) {
                    return S(e, "nextSibling", n);
                },
                prevUntil: function (e, t, n) {
                    return S(e, "previousSibling", n);
                },
                siblings: function (e) {
                    return k((e.parentNode || {}).firstChild, e);
                },
                children: function (e) {
                    return k(e.firstChild);
                },
                contents: function (e) {
                    return null != e.contentDocument && i(e.contentDocument) ? e.contentDocument : (_(e, "template") && (e = e.content || e), x.merge([], e.childNodes));
                },
            },
            function (e, t) {
                x.fn[e] = function (n, i) {
                    var o = x.map(this, t, n);
                    return "Until" !== e.slice(-5) && (i = n), i && "string" == typeof i && (o = x.filter(i, o)), 1 < this.length && (D[e] || x.uniqueSort(o), L.test(e) && o.reverse()), this.pushStack(o);
                };
            }
        );
    var z = /[^\x20\t\r\n\f]+/g;
    function I(e) {
        return e;
    }
    function N(e) {
        throw e;
    }
    function j(e, t, n, i) {
        var o;
        try {
            e && f((o = e.promise)) ? o.call(e).done(t).fail(n) : e && f((o = e.then)) ? o.call(e, t, n) : t.apply(void 0, [e].slice(i));
        } catch (e) {
            n.apply(void 0, [e]);
        }
    }
    (x.Callbacks = function (e) {
        var t, n;
        e =
            "string" == typeof e
                ? ((t = e),
                  (n = {}),
                  x.each(t.match(z) || [], function (e, t) {
                      n[t] = !0;
                  }),
                  n)
                : x.extend({}, e);
        var i,
            o,
            s,
            r,
            a = [],
            l = [],
            c = -1,
            d = function () {
                for (r = r || e.once, s = i = !0; l.length; c = -1) for (o = l.shift(); ++c < a.length; ) !1 === a[c].apply(o[0], o[1]) && e.stopOnFalse && ((c = a.length), (o = !1));
                e.memory || (o = !1), (i = !1), r && (a = o ? [] : "");
            },
            u = {
                add: function () {
                    return (
                        a &&
                            (o && !i && ((c = a.length - 1), l.push(o)),
                            (function t(n) {
                                x.each(n, function (n, i) {
                                    f(i) ? (e.unique && u.has(i)) || a.push(i) : i && i.length && "string" !== b(i) && t(i);
                                });
                            })(arguments),
                            o && !i && d()),
                        this
                    );
                },
                remove: function () {
                    return (
                        x.each(arguments, function (e, t) {
                            for (var n; -1 < (n = x.inArray(t, a, n)); ) a.splice(n, 1), n <= c && c--;
                        }),
                        this
                    );
                },
                has: function (e) {
                    return e ? -1 < x.inArray(e, a) : 0 < a.length;
                },
                empty: function () {
                    return a && (a = []), this;
                },
                disable: function () {
                    return (r = l = []), (a = o = ""), this;
                },
                disabled: function () {
                    return !a;
                },
                lock: function () {
                    return (r = l = []), o || i || (a = o = ""), this;
                },
                locked: function () {
                    return !!r;
                },
                fireWith: function (e, t) {
                    return r || ((t = [e, (t = t || []).slice ? t.slice() : t]), l.push(t), i || d()), this;
                },
                fire: function () {
                    return u.fireWith(this, arguments), this;
                },
                fired: function () {
                    return !!s;
                },
            };
        return u;
    }),
        x.extend({
            Deferred: function (t) {
                var n = [
                        ["notify", "progress", x.Callbacks("memory"), x.Callbacks("memory"), 2],
                        ["resolve", "done", x.Callbacks("once memory"), x.Callbacks("once memory"), 0, "resolved"],
                        ["reject", "fail", x.Callbacks("once memory"), x.Callbacks("once memory"), 1, "rejected"],
                    ],
                    i = "pending",
                    o = {
                        state: function () {
                            return i;
                        },
                        always: function () {
                            return s.done(arguments).fail(arguments), this;
                        },
                        catch: function (e) {
                            return o.then(null, e);
                        },
                        pipe: function () {
                            var e = arguments;
                            return x
                                .Deferred(function (t) {
                                    x.each(n, function (n, i) {
                                        var o = f(e[i[4]]) && e[i[4]];
                                        s[i[1]](function () {
                                            var e = o && o.apply(this, arguments);
                                            e && f(e.promise) ? e.promise().progress(t.notify).done(t.resolve).fail(t.reject) : t[i[0] + "With"](this, o ? [e] : arguments);
                                        });
                                    }),
                                        (e = null);
                                })
                                .promise();
                        },
                        then: function (t, i, o) {
                            var s = 0;
                            function r(t, n, i, o) {
                                return function () {
                                    var a = this,
                                        l = arguments,
                                        c = function () {
                                            var e, c;
                                            if (!(t < s)) {
                                                if ((e = i.apply(a, l)) === n.promise()) throw new TypeError("Thenable self-resolution");
                                                (c = e && ("object" == typeof e || "function" == typeof e) && e.then),
                                                    f(c)
                                                        ? o
                                                            ? c.call(e, r(s, n, I, o), r(s, n, N, o))
                                                            : (s++, c.call(e, r(s, n, I, o), r(s, n, N, o), r(s, n, I, n.notifyWith)))
                                                        : (i !== I && ((a = void 0), (l = [e])), (o || n.resolveWith)(a, l));
                                            }
                                        },
                                        d = o
                                            ? c
                                            : function () {
                                                  try {
                                                      c();
                                                  } catch (e) {
                                                      x.Deferred.exceptionHook && x.Deferred.exceptionHook(e, d.stackTrace), s <= t + 1 && (i !== N && ((a = void 0), (l = [e])), n.rejectWith(a, l));
                                                  }
                                              };
                                    t ? d() : (x.Deferred.getStackHook && (d.stackTrace = x.Deferred.getStackHook()), e.setTimeout(d));
                                };
                            }
                            return x
                                .Deferred(function (e) {
                                    n[0][3].add(r(0, e, f(o) ? o : I, e.notifyWith)), n[1][3].add(r(0, e, f(t) ? t : I)), n[2][3].add(r(0, e, f(i) ? i : N));
                                })
                                .promise();
                        },
                        promise: function (e) {
                            return null != e ? x.extend(e, o) : o;
                        },
                    },
                    s = {};
                return (
                    x.each(n, function (e, t) {
                        var r = t[2],
                            a = t[5];
                        (o[t[1]] = r.add),
                            a &&
                                r.add(
                                    function () {
                                        i = a;
                                    },
                                    n[3 - e][2].disable,
                                    n[3 - e][3].disable,
                                    n[0][2].lock,
                                    n[0][3].lock
                                ),
                            r.add(t[3].fire),
                            (s[t[0]] = function () {
                                return s[t[0] + "With"](this === s ? void 0 : this, arguments), this;
                            }),
                            (s[t[0] + "With"] = r.fireWith);
                    }),
                    o.promise(s),
                    t && t.call(s, s),
                    s
                );
            },
            when: function (e) {
                var t = arguments.length,
                    n = t,
                    i = Array(n),
                    s = o.call(arguments),
                    r = x.Deferred(),
                    a = function (e) {
                        return function (n) {
                            (i[e] = this), (s[e] = 1 < arguments.length ? o.call(arguments) : n), --t || r.resolveWith(i, s);
                        };
                    };
                if (t <= 1 && (j(e, r.done(a(n)).resolve, r.reject, !t), "pending" === r.state() || f(s[n] && s[n].then))) return r.then();
                for (; n--; ) j(s[n], a(n), r.reject);
                return r.promise();
            },
        });
    var R = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    (x.Deferred.exceptionHook = function (t, n) {
        e.console && e.console.warn && t && R.test(t.name) && e.console.warn("jQuery.Deferred exception: " + t.message, t.stack, n);
    }),
        (x.readyException = function (t) {
            e.setTimeout(function () {
                throw t;
            });
        });
    var H = x.Deferred();
    function q() {
        g.removeEventListener("DOMContentLoaded", q), e.removeEventListener("load", q), x.ready();
    }
    (x.fn.ready = function (e) {
        return (
            H.then(e).catch(function (e) {
                x.readyException(e);
            }),
            this
        );
    }),
        x.extend({
            isReady: !1,
            readyWait: 1,
            ready: function (e) {
                (!0 === e ? --x.readyWait : x.isReady) || ((x.isReady = !0) !== e && 0 < --x.readyWait) || H.resolveWith(g, [x]);
            },
        }),
        (x.ready.then = H.then),
        "complete" === g.readyState || ("loading" !== g.readyState && !g.documentElement.doScroll) ? e.setTimeout(x.ready) : (g.addEventListener("DOMContentLoaded", q), e.addEventListener("load", q));
    var F = function (e, t, n, i, o, s, r) {
            var a = 0,
                l = e.length,
                c = null == n;
            if ("object" === b(n)) for (a in ((o = !0), n)) F(e, t, a, n[a], !0, s, r);
            else if (
                void 0 !== i &&
                ((o = !0),
                f(i) || (r = !0),
                c &&
                    (r
                        ? (t.call(e, i), (t = null))
                        : ((c = t),
                          (t = function (e, t, n) {
                              return c.call(x(e), n);
                          }))),
                t)
            )
                for (; a < l; a++) t(e[a], n, r ? i : i.call(e[a], a, t(e[a], n)));
            return o ? e : c ? t.call(e) : l ? t(e[0], n) : s;
        },
        W = /^-ms-/,
        B = /-([a-z])/g;
    function V(e, t) {
        return t.toUpperCase();
    }
    function U(e) {
        return e.replace(W, "ms-").replace(B, V);
    }
    var G = function (e) {
        return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType;
    };
    function X() {
        this.expando = x.expando + X.uid++;
    }
    (X.uid = 1),
        (X.prototype = {
            cache: function (e) {
                var t = e[this.expando];
                return t || ((t = {}), G(e) && (e.nodeType ? (e[this.expando] = t) : Object.defineProperty(e, this.expando, { value: t, configurable: !0 }))), t;
            },
            set: function (e, t, n) {
                var i,
                    o = this.cache(e);
                if ("string" == typeof t) o[U(t)] = n;
                else for (i in t) o[U(i)] = t[i];
                return o;
            },
            get: function (e, t) {
                return void 0 === t ? this.cache(e) : e[this.expando] && e[this.expando][U(t)];
            },
            access: function (e, t, n) {
                return void 0 === t || (t && "string" == typeof t && void 0 === n) ? this.get(e, t) : (this.set(e, t, n), void 0 !== n ? n : t);
            },
            remove: function (e, t) {
                var n,
                    i = e[this.expando];
                if (void 0 !== i) {
                    if (void 0 !== t) {
                        n = (t = Array.isArray(t) ? t.map(U) : (t = U(t)) in i ? [t] : t.match(z) || []).length;
                        for (; n--; ) delete i[t[n]];
                    }
                    (void 0 === t || x.isEmptyObject(i)) && (e.nodeType ? (e[this.expando] = void 0) : delete e[this.expando]);
                }
            },
            hasData: function (e) {
                var t = e[this.expando];
                return void 0 !== t && !x.isEmptyObject(t);
            },
        });
    var Y = new X(),
        K = new X(),
        Z = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
        Q = /[A-Z]/g;
    function J(e, t, n) {
        var i, o;
        if (void 0 === n && 1 === e.nodeType)
            if (((i = "data-" + t.replace(Q, "-$&").toLowerCase()), "string" == typeof (n = e.getAttribute(i)))) {
                try {
                    n = "true" === (o = n) || ("false" !== o && ("null" === o ? null : o === +o + "" ? +o : Z.test(o) ? JSON.parse(o) : o));
                } catch (e) {}
                K.set(e, t, n);
            } else n = void 0;
        return n;
    }
    x.extend({
        hasData: function (e) {
            return K.hasData(e) || Y.hasData(e);
        },
        data: function (e, t, n) {
            return K.access(e, t, n);
        },
        removeData: function (e, t) {
            K.remove(e, t);
        },
        _data: function (e, t, n) {
            return Y.access(e, t, n);
        },
        _removeData: function (e, t) {
            Y.remove(e, t);
        },
    }),
        x.fn.extend({
            data: function (e, t) {
                var n,
                    i,
                    o,
                    s = this[0],
                    r = s && s.attributes;
                if (void 0 === e) {
                    if (this.length && ((o = K.get(s)), 1 === s.nodeType && !Y.get(s, "hasDataAttrs"))) {
                        for (n = r.length; n--; ) r[n] && 0 === (i = r[n].name).indexOf("data-") && ((i = U(i.slice(5))), J(s, i, o[i]));
                        Y.set(s, "hasDataAttrs", !0);
                    }
                    return o;
                }
                return "object" == typeof e
                    ? this.each(function () {
                          K.set(this, e);
                      })
                    : F(
                          this,
                          function (t) {
                              var n;
                              if (s && void 0 === t) return void 0 !== (n = K.get(s, e)) || void 0 !== (n = J(s, e)) ? n : void 0;
                              this.each(function () {
                                  K.set(this, e, t);
                              });
                          },
                          null,
                          t,
                          1 < arguments.length,
                          null,
                          !0
                      );
            },
            removeData: function (e) {
                return this.each(function () {
                    K.remove(this, e);
                });
            },
        }),
        x.extend({
            queue: function (e, t, n) {
                var i;
                if (e) return (t = (t || "fx") + "queue"), (i = Y.get(e, t)), n && (!i || Array.isArray(n) ? (i = Y.access(e, t, x.makeArray(n))) : i.push(n)), i || [];
            },
            dequeue: function (e, t) {
                t = t || "fx";
                var n = x.queue(e, t),
                    i = n.length,
                    o = n.shift(),
                    s = x._queueHooks(e, t);
                "inprogress" === o && ((o = n.shift()), i--),
                    o &&
                        ("fx" === t && n.unshift("inprogress"),
                        delete s.stop,
                        o.call(
                            e,
                            function () {
                                x.dequeue(e, t);
                            },
                            s
                        )),
                    !i && s && s.empty.fire();
            },
            _queueHooks: function (e, t) {
                var n = t + "queueHooks";
                return (
                    Y.get(e, n) ||
                    Y.access(e, n, {
                        empty: x.Callbacks("once memory").add(function () {
                            Y.remove(e, [t + "queue", n]);
                        }),
                    })
                );
            },
        }),
        x.fn.extend({
            queue: function (e, t) {
                var n = 2;
                return (
                    "string" != typeof e && ((t = e), (e = "fx"), n--),
                    arguments.length < n
                        ? x.queue(this[0], e)
                        : void 0 === t
                        ? this
                        : this.each(function () {
                              var n = x.queue(this, e, t);
                              x._queueHooks(this, e), "fx" === e && "inprogress" !== n[0] && x.dequeue(this, e);
                          })
                );
            },
            dequeue: function (e) {
                return this.each(function () {
                    x.dequeue(this, e);
                });
            },
            clearQueue: function (e) {
                return this.queue(e || "fx", []);
            },
            promise: function (e, t) {
                var n,
                    i = 1,
                    o = x.Deferred(),
                    s = this,
                    r = this.length,
                    a = function () {
                        --i || o.resolveWith(s, [s]);
                    };
                for ("string" != typeof e && ((t = e), (e = void 0)), e = e || "fx"; r--; ) (n = Y.get(s[r], e + "queueHooks")) && n.empty && (i++, n.empty.add(a));
                return a(), o.promise(t);
            },
        });
    var ee = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
        te = new RegExp("^(?:([+-])=|)(" + ee + ")([a-z%]*)$", "i"),
        ne = ["Top", "Right", "Bottom", "Left"],
        ie = g.documentElement,
        oe = function (e) {
            return x.contains(e.ownerDocument, e);
        },
        se = { composed: !0 };
    ie.getRootNode &&
        (oe = function (e) {
            return x.contains(e.ownerDocument, e) || e.getRootNode(se) === e.ownerDocument;
        });
    var re = function (e, t) {
        return "none" === (e = t || e).style.display || ("" === e.style.display && oe(e) && "none" === x.css(e, "display"));
    };
    function ae(e, t, n, i) {
        var o,
            s,
            r = 20,
            a = i
                ? function () {
                      return i.cur();
                  }
                : function () {
                      return x.css(e, t, "");
                  },
            l = a(),
            c = (n && n[3]) || (x.cssNumber[t] ? "" : "px"),
            d = e.nodeType && (x.cssNumber[t] || ("px" !== c && +l)) && te.exec(x.css(e, t));
        if (d && d[3] !== c) {
            for (l /= 2, c = c || d[3], d = +l || 1; r--; ) x.style(e, t, d + c), (1 - s) * (1 - (s = a() / l || 0.5)) <= 0 && (r = 0), (d /= s);
            (d *= 2), x.style(e, t, d + c), (n = n || []);
        }
        return n && ((d = +d || +l || 0), (o = n[1] ? d + (n[1] + 1) * n[2] : +n[2]), i && ((i.unit = c), (i.start = d), (i.end = o))), o;
    }
    var le = {};
    function ce(e, t) {
        for (var n, i, o, s, r, a, l, c = [], d = 0, u = e.length; d < u; d++)
            (i = e[d]).style &&
                ((n = i.style.display),
                t
                    ? ("none" === n && ((c[d] = Y.get(i, "display") || null), c[d] || (i.style.display = "")),
                      "" === i.style.display &&
                          re(i) &&
                          (c[d] =
                              ((l = r = s = void 0),
                              (r = (o = i).ownerDocument),
                              (a = o.nodeName),
                              (l = le[a]) || ((s = r.body.appendChild(r.createElement(a))), (l = x.css(s, "display")), s.parentNode.removeChild(s), "none" === l && (l = "block"), (le[a] = l)))))
                    : "none" !== n && ((c[d] = "none"), Y.set(i, "display", n)));
        for (d = 0; d < u; d++) null != c[d] && (e[d].style.display = c[d]);
        return e;
    }
    x.fn.extend({
        show: function () {
            return ce(this, !0);
        },
        hide: function () {
            return ce(this);
        },
        toggle: function (e) {
            return "boolean" == typeof e
                ? e
                    ? this.show()
                    : this.hide()
                : this.each(function () {
                      re(this) ? x(this).show() : x(this).hide();
                  });
        },
    });
    var de,
        ue,
        pe = /^(?:checkbox|radio)$/i,
        he = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i,
        fe = /^$|^module$|\/(?:java|ecma)script/i;
    (de = g.createDocumentFragment().appendChild(g.createElement("div"))),
        (ue = g.createElement("input")).setAttribute("type", "radio"),
        ue.setAttribute("checked", "checked"),
        ue.setAttribute("name", "t"),
        de.appendChild(ue),
        (h.checkClone = de.cloneNode(!0).cloneNode(!0).lastChild.checked),
        (de.innerHTML = "<textarea>x</textarea>"),
        (h.noCloneChecked = !!de.cloneNode(!0).lastChild.defaultValue),
        (de.innerHTML = "<option></option>"),
        (h.option = !!de.lastChild);
    var me = { thead: [1, "<table>", "</table>"], col: [2, "<table><colgroup>", "</colgroup></table>"], tr: [2, "<table><tbody>", "</tbody></table>"], td: [3, "<table><tbody><tr>", "</tr></tbody></table>"], _default: [0, "", ""] };
    function ge(e, t) {
        var n;
        return (n = void 0 !== e.getElementsByTagName ? e.getElementsByTagName(t || "*") : void 0 !== e.querySelectorAll ? e.querySelectorAll(t || "*") : []), void 0 === t || (t && _(e, t)) ? x.merge([e], n) : n;
    }
    function ve(e, t) {
        for (var n = 0, i = e.length; n < i; n++) Y.set(e[n], "globalEval", !t || Y.get(t[n], "globalEval"));
    }
    (me.tbody = me.tfoot = me.colgroup = me.caption = me.thead), (me.th = me.td), h.option || (me.optgroup = me.option = [1, "<select multiple='multiple'>", "</select>"]);
    var ye = /<|&#?\w+;/;
    function be(e, t, n, i, o) {
        for (var s, r, a, l, c, d, u = t.createDocumentFragment(), p = [], h = 0, f = e.length; h < f; h++)
            if ((s = e[h]) || 0 === s)
                if ("object" === b(s)) x.merge(p, s.nodeType ? [s] : s);
                else if (ye.test(s)) {
                    for (r = r || u.appendChild(t.createElement("div")), a = (he.exec(s) || ["", ""])[1].toLowerCase(), l = me[a] || me._default, r.innerHTML = l[1] + x.htmlPrefilter(s) + l[2], d = l[0]; d--; ) r = r.lastChild;
                    x.merge(p, r.childNodes), ((r = u.firstChild).textContent = "");
                } else p.push(t.createTextNode(s));
        for (u.textContent = "", h = 0; (s = p[h++]); )
            if (i && -1 < x.inArray(s, i)) o && o.push(s);
            else if (((c = oe(s)), (r = ge(u.appendChild(s), "script")), c && ve(r), n)) for (d = 0; (s = r[d++]); ) fe.test(s.type || "") && n.push(s);
        return u;
    }
    var we = /^key/,
        xe = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
        Te = /^([^.]*)(?:\.(.+)|)/;
    function Ce() {
        return !0;
    }
    function Se() {
        return !1;
    }
    function ke(e, t) {
        return (
            (e ===
                (function () {
                    try {
                        return g.activeElement;
                    } catch (e) {}
                })()) ==
            ("focus" === t)
        );
    }
    function $e(e, t, n, i, o, s) {
        var r, a;
        if ("object" == typeof t) {
            for (a in ("string" != typeof n && ((i = i || n), (n = void 0)), t)) $e(e, a, n, i, t[a], s);
            return e;
        }
        if ((null == i && null == o ? ((o = n), (i = n = void 0)) : null == o && ("string" == typeof n ? ((o = i), (i = void 0)) : ((o = i), (i = n), (n = void 0))), !1 === o)) o = Se;
        else if (!o) return e;
        return (
            1 === s &&
                ((r = o),
                ((o = function (e) {
                    return x().off(e), r.apply(this, arguments);
                }).guid = r.guid || (r.guid = x.guid++))),
            e.each(function () {
                x.event.add(this, t, o, i, n);
            })
        );
    }
    function _e(e, t, n) {
        n
            ? (Y.set(e, t, !1),
              x.event.add(e, t, {
                  namespace: !1,
                  handler: function (e) {
                      var i,
                          s,
                          r = Y.get(this, t);
                      if (1 & e.isTrigger && this[t]) {
                          if (r.length) (x.event.special[t] || {}).delegateType && e.stopPropagation();
                          else if (((r = o.call(arguments)), Y.set(this, t, r), (i = n(this, t)), this[t](), r !== (s = Y.get(this, t)) || i ? Y.set(this, t, !1) : (s = {}), r !== s))
                              return e.stopImmediatePropagation(), e.preventDefault(), s.value;
                      } else r.length && (Y.set(this, t, { value: x.event.trigger(x.extend(r[0], x.Event.prototype), r.slice(1), this) }), e.stopImmediatePropagation());
                  },
              }))
            : void 0 === Y.get(e, t) && x.event.add(e, t, Ce);
    }
    (x.event = {
        global: {},
        add: function (e, t, n, i, o) {
            var s,
                r,
                a,
                l,
                c,
                d,
                u,
                p,
                h,
                f,
                m,
                g = Y.get(e);
            if (G(e))
                for (
                    n.handler && ((n = (s = n).handler), (o = s.selector)),
                        o && x.find.matchesSelector(ie, o),
                        n.guid || (n.guid = x.guid++),
                        (l = g.events) || (l = g.events = Object.create(null)),
                        (r = g.handle) ||
                            (r = g.handle = function (t) {
                                return void 0 !== x && x.event.triggered !== t.type ? x.event.dispatch.apply(e, arguments) : void 0;
                            }),
                        c = (t = (t || "").match(z) || [""]).length;
                    c--;

                )
                    (h = m = (a = Te.exec(t[c]) || [])[1]),
                        (f = (a[2] || "").split(".").sort()),
                        h &&
                            ((u = x.event.special[h] || {}),
                            (h = (o ? u.delegateType : u.bindType) || h),
                            (u = x.event.special[h] || {}),
                            (d = x.extend({ type: h, origType: m, data: i, handler: n, guid: n.guid, selector: o, needsContext: o && x.expr.match.needsContext.test(o), namespace: f.join(".") }, s)),
                            (p = l[h]) || (((p = l[h] = []).delegateCount = 0), (u.setup && !1 !== u.setup.call(e, i, f, r)) || (e.addEventListener && e.addEventListener(h, r))),
                            u.add && (u.add.call(e, d), d.handler.guid || (d.handler.guid = n.guid)),
                            o ? p.splice(p.delegateCount++, 0, d) : p.push(d),
                            (x.event.global[h] = !0));
        },
        remove: function (e, t, n, i, o) {
            var s,
                r,
                a,
                l,
                c,
                d,
                u,
                p,
                h,
                f,
                m,
                g = Y.hasData(e) && Y.get(e);
            if (g && (l = g.events)) {
                for (c = (t = (t || "").match(z) || [""]).length; c--; )
                    if (((h = m = (a = Te.exec(t[c]) || [])[1]), (f = (a[2] || "").split(".").sort()), h)) {
                        for (u = x.event.special[h] || {}, p = l[(h = (i ? u.delegateType : u.bindType) || h)] || [], a = a[2] && new RegExp("(^|\\.)" + f.join("\\.(?:.*\\.|)") + "(\\.|$)"), r = s = p.length; s--; )
                            (d = p[s]),
                                (!o && m !== d.origType) ||
                                    (n && n.guid !== d.guid) ||
                                    (a && !a.test(d.namespace)) ||
                                    (i && i !== d.selector && ("**" !== i || !d.selector)) ||
                                    (p.splice(s, 1), d.selector && p.delegateCount--, u.remove && u.remove.call(e, d));
                        r && !p.length && ((u.teardown && !1 !== u.teardown.call(e, f, g.handle)) || x.removeEvent(e, h, g.handle), delete l[h]);
                    } else for (h in l) x.event.remove(e, h + t[c], n, i, !0);
                x.isEmptyObject(l) && Y.remove(e, "handle events");
            }
        },
        dispatch: function (e) {
            var t,
                n,
                i,
                o,
                s,
                r,
                a = new Array(arguments.length),
                l = x.event.fix(e),
                c = (Y.get(this, "events") || Object.create(null))[l.type] || [],
                d = x.event.special[l.type] || {};
            for (a[0] = l, t = 1; t < arguments.length; t++) a[t] = arguments[t];
            if (((l.delegateTarget = this), !d.preDispatch || !1 !== d.preDispatch.call(this, l))) {
                for (r = x.event.handlers.call(this, l, c), t = 0; (o = r[t++]) && !l.isPropagationStopped(); )
                    for (l.currentTarget = o.elem, n = 0; (s = o.handlers[n++]) && !l.isImmediatePropagationStopped(); )
                        (l.rnamespace && !1 !== s.namespace && !l.rnamespace.test(s.namespace)) ||
                            ((l.handleObj = s), (l.data = s.data), void 0 !== (i = ((x.event.special[s.origType] || {}).handle || s.handler).apply(o.elem, a)) && !1 === (l.result = i) && (l.preventDefault(), l.stopPropagation()));
                return d.postDispatch && d.postDispatch.call(this, l), l.result;
            }
        },
        handlers: function (e, t) {
            var n,
                i,
                o,
                s,
                r,
                a = [],
                l = t.delegateCount,
                c = e.target;
            if (l && c.nodeType && !("click" === e.type && 1 <= e.button))
                for (; c !== this; c = c.parentNode || this)
                    if (1 === c.nodeType && ("click" !== e.type || !0 !== c.disabled)) {
                        for (s = [], r = {}, n = 0; n < l; n++) void 0 === r[(o = (i = t[n]).selector + " ")] && (r[o] = i.needsContext ? -1 < x(o, this).index(c) : x.find(o, this, null, [c]).length), r[o] && s.push(i);
                        s.length && a.push({ elem: c, handlers: s });
                    }
            return (c = this), l < t.length && a.push({ elem: c, handlers: t.slice(l) }), a;
        },
        addProp: function (e, t) {
            Object.defineProperty(x.Event.prototype, e, {
                enumerable: !0,
                configurable: !0,
                get: f(t)
                    ? function () {
                          if (this.originalEvent) return t(this.originalEvent);
                      }
                    : function () {
                          if (this.originalEvent) return this.originalEvent[e];
                      },
                set: function (t) {
                    Object.defineProperty(this, e, { enumerable: !0, configurable: !0, writable: !0, value: t });
                },
            });
        },
        fix: function (e) {
            return e[x.expando] ? e : new x.Event(e);
        },
        special: {
            load: { noBubble: !0 },
            click: {
                setup: function (e) {
                    var t = this || e;
                    return pe.test(t.type) && t.click && _(t, "input") && _e(t, "click", Ce), !1;
                },
                trigger: function (e) {
                    var t = this || e;
                    return pe.test(t.type) && t.click && _(t, "input") && _e(t, "click"), !0;
                },
                _default: function (e) {
                    var t = e.target;
                    return (pe.test(t.type) && t.click && _(t, "input") && Y.get(t, "click")) || _(t, "a");
                },
            },
            beforeunload: {
                postDispatch: function (e) {
                    void 0 !== e.result && e.originalEvent && (e.originalEvent.returnValue = e.result);
                },
            },
        },
    }),
        (x.removeEvent = function (e, t, n) {
            e.removeEventListener && e.removeEventListener(t, n);
        }),
        (x.Event = function (e, t) {
            if (!(this instanceof x.Event)) return new x.Event(e, t);
            e && e.type
                ? ((this.originalEvent = e),
                  (this.type = e.type),
                  (this.isDefaultPrevented = e.defaultPrevented || (void 0 === e.defaultPrevented && !1 === e.returnValue) ? Ce : Se),
                  (this.target = e.target && 3 === e.target.nodeType ? e.target.parentNode : e.target),
                  (this.currentTarget = e.currentTarget),
                  (this.relatedTarget = e.relatedTarget))
                : (this.type = e),
                t && x.extend(this, t),
                (this.timeStamp = (e && e.timeStamp) || Date.now()),
                (this[x.expando] = !0);
        }),
        (x.Event.prototype = {
            constructor: x.Event,
            isDefaultPrevented: Se,
            isPropagationStopped: Se,
            isImmediatePropagationStopped: Se,
            isSimulated: !1,
            preventDefault: function () {
                var e = this.originalEvent;
                (this.isDefaultPrevented = Ce), e && !this.isSimulated && e.preventDefault();
            },
            stopPropagation: function () {
                var e = this.originalEvent;
                (this.isPropagationStopped = Ce), e && !this.isSimulated && e.stopPropagation();
            },
            stopImmediatePropagation: function () {
                var e = this.originalEvent;
                (this.isImmediatePropagationStopped = Ce), e && !this.isSimulated && e.stopImmediatePropagation(), this.stopPropagation();
            },
        }),
        x.each(
            {
                altKey: !0,
                bubbles: !0,
                cancelable: !0,
                changedTouches: !0,
                ctrlKey: !0,
                detail: !0,
                eventPhase: !0,
                metaKey: !0,
                pageX: !0,
                pageY: !0,
                shiftKey: !0,
                view: !0,
                char: !0,
                code: !0,
                charCode: !0,
                key: !0,
                keyCode: !0,
                button: !0,
                buttons: !0,
                clientX: !0,
                clientY: !0,
                offsetX: !0,
                offsetY: !0,
                pointerId: !0,
                pointerType: !0,
                screenX: !0,
                screenY: !0,
                targetTouches: !0,
                toElement: !0,
                touches: !0,
                which: function (e) {
                    var t = e.button;
                    return null == e.which && we.test(e.type) ? (null != e.charCode ? e.charCode : e.keyCode) : !e.which && void 0 !== t && xe.test(e.type) ? (1 & t ? 1 : 2 & t ? 3 : 4 & t ? 2 : 0) : e.which;
                },
            },
            x.event.addProp
        ),
        x.each({ focus: "focusin", blur: "focusout" }, function (e, t) {
            x.event.special[e] = {
                setup: function () {
                    return _e(this, e, ke), !1;
                },
                trigger: function () {
                    return _e(this, e), !0;
                },
                delegateType: t,
            };
        }),
        x.each({ mouseenter: "mouseover", mouseleave: "mouseout", pointerenter: "pointerover", pointerleave: "pointerout" }, function (e, t) {
            x.event.special[e] = {
                delegateType: t,
                bindType: t,
                handle: function (e) {
                    var n,
                        i = e.relatedTarget,
                        o = e.handleObj;
                    return (i && (i === this || x.contains(this, i))) || ((e.type = o.origType), (n = o.handler.apply(this, arguments)), (e.type = t)), n;
                },
            };
        }),
        x.fn.extend({
            on: function (e, t, n, i) {
                return $e(this, e, t, n, i);
            },
            one: function (e, t, n, i) {
                return $e(this, e, t, n, i, 1);
            },
            off: function (e, t, n) {
                var i, o;
                if (e && e.preventDefault && e.handleObj) return (i = e.handleObj), x(e.delegateTarget).off(i.namespace ? i.origType + "." + i.namespace : i.origType, i.selector, i.handler), this;
                if ("object" == typeof e) {
                    for (o in e) this.off(o, t, e[o]);
                    return this;
                }
                return (
                    (!1 !== t && "function" != typeof t) || ((n = t), (t = void 0)),
                    !1 === n && (n = Se),
                    this.each(function () {
                        x.event.remove(this, e, n, t);
                    })
                );
            },
        });
    var Ee = /<script|<style|<link/i,
        Ae = /checked\s*(?:[^=]|=\s*.checked.)/i,
        Me = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
    function Pe(e, t) {
        return (_(e, "table") && _(11 !== t.nodeType ? t : t.firstChild, "tr") && x(e).children("tbody")[0]) || e;
    }
    function Le(e) {
        return (e.type = (null !== e.getAttribute("type")) + "/" + e.type), e;
    }
    function De(e) {
        return "true/" === (e.type || "").slice(0, 5) ? (e.type = e.type.slice(5)) : e.removeAttribute("type"), e;
    }
    function Oe(e, t) {
        var n, i, o, s, r, a;
        if (1 === t.nodeType) {
            if (Y.hasData(e) && (a = Y.get(e).events)) for (o in (Y.remove(t, "handle events"), a)) for (n = 0, i = a[o].length; n < i; n++) x.event.add(t, o, a[o][n]);
            K.hasData(e) && ((s = K.access(e)), (r = x.extend({}, s)), K.set(t, r));
        }
    }
    function ze(e, t, n, i) {
        t = s(t);
        var o,
            r,
            a,
            l,
            c,
            d,
            u = 0,
            p = e.length,
            m = p - 1,
            g = t[0],
            v = f(g);
        if (v || (1 < p && "string" == typeof g && !h.checkClone && Ae.test(g)))
            return e.each(function (o) {
                var s = e.eq(o);
                v && (t[0] = g.call(this, o, s.html())), ze(s, t, n, i);
            });
        if (p && ((r = (o = be(t, e[0].ownerDocument, !1, e, i)).firstChild), 1 === o.childNodes.length && (o = r), r || i)) {
            for (l = (a = x.map(ge(o, "script"), Le)).length; u < p; u++) (c = o), u !== m && ((c = x.clone(c, !0, !0)), l && x.merge(a, ge(c, "script"))), n.call(e[u], c, u);
            if (l)
                for (d = a[a.length - 1].ownerDocument, x.map(a, De), u = 0; u < l; u++)
                    (c = a[u]),
                        fe.test(c.type || "") &&
                            !Y.access(c, "globalEval") &&
                            x.contains(d, c) &&
                            (c.src && "module" !== (c.type || "").toLowerCase() ? x._evalUrl && !c.noModule && x._evalUrl(c.src, { nonce: c.nonce || c.getAttribute("nonce") }, d) : y(c.textContent.replace(Me, ""), c, d));
        }
        return e;
    }
    function Ie(e, t, n) {
        for (var i, o = t ? x.filter(t, e) : e, s = 0; null != (i = o[s]); s++) n || 1 !== i.nodeType || x.cleanData(ge(i)), i.parentNode && (n && oe(i) && ve(ge(i, "script")), i.parentNode.removeChild(i));
        return e;
    }
    x.extend({
        htmlPrefilter: function (e) {
            return e;
        },
        clone: function (e, t, n) {
            var i,
                o,
                s,
                r,
                a,
                l,
                c,
                d = e.cloneNode(!0),
                u = oe(e);
            if (!(h.noCloneChecked || (1 !== e.nodeType && 11 !== e.nodeType) || x.isXMLDoc(e)))
                for (r = ge(d), i = 0, o = (s = ge(e)).length; i < o; i++)
                    (a = s[i]), "input" === (c = (l = r[i]).nodeName.toLowerCase()) && pe.test(a.type) ? (l.checked = a.checked) : ("input" !== c && "textarea" !== c) || (l.defaultValue = a.defaultValue);
            if (t)
                if (n) for (s = s || ge(e), r = r || ge(d), i = 0, o = s.length; i < o; i++) Oe(s[i], r[i]);
                else Oe(e, d);
            return 0 < (r = ge(d, "script")).length && ve(r, !u && ge(e, "script")), d;
        },
        cleanData: function (e) {
            for (var t, n, i, o = x.event.special, s = 0; void 0 !== (n = e[s]); s++)
                if (G(n)) {
                    if ((t = n[Y.expando])) {
                        if (t.events) for (i in t.events) o[i] ? x.event.remove(n, i) : x.removeEvent(n, i, t.handle);
                        n[Y.expando] = void 0;
                    }
                    n[K.expando] && (n[K.expando] = void 0);
                }
        },
    }),
        x.fn.extend({
            detach: function (e) {
                return Ie(this, e, !0);
            },
            remove: function (e) {
                return Ie(this, e);
            },
            text: function (e) {
                return F(
                    this,
                    function (e) {
                        return void 0 === e
                            ? x.text(this)
                            : this.empty().each(function () {
                                  (1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType) || (this.textContent = e);
                              });
                    },
                    null,
                    e,
                    arguments.length
                );
            },
            append: function () {
                return ze(this, arguments, function (e) {
                    (1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType) || Pe(this, e).appendChild(e);
                });
            },
            prepend: function () {
                return ze(this, arguments, function (e) {
                    if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                        var t = Pe(this, e);
                        t.insertBefore(e, t.firstChild);
                    }
                });
            },
            before: function () {
                return ze(this, arguments, function (e) {
                    this.parentNode && this.parentNode.insertBefore(e, this);
                });
            },
            after: function () {
                return ze(this, arguments, function (e) {
                    this.parentNode && this.parentNode.insertBefore(e, this.nextSibling);
                });
            },
            empty: function () {
                for (var e, t = 0; null != (e = this[t]); t++) 1 === e.nodeType && (x.cleanData(ge(e, !1)), (e.textContent = ""));
                return this;
            },
            clone: function (e, t) {
                return (
                    (e = null != e && e),
                    (t = null == t ? e : t),
                    this.map(function () {
                        return x.clone(this, e, t);
                    })
                );
            },
            html: function (e) {
                return F(
                    this,
                    function (e) {
                        var t = this[0] || {},
                            n = 0,
                            i = this.length;
                        if (void 0 === e && 1 === t.nodeType) return t.innerHTML;
                        if ("string" == typeof e && !Ee.test(e) && !me[(he.exec(e) || ["", ""])[1].toLowerCase()]) {
                            e = x.htmlPrefilter(e);
                            try {
                                for (; n < i; n++) 1 === (t = this[n] || {}).nodeType && (x.cleanData(ge(t, !1)), (t.innerHTML = e));
                                t = 0;
                            } catch (e) {}
                        }
                        t && this.empty().append(e);
                    },
                    null,
                    e,
                    arguments.length
                );
            },
            replaceWith: function () {
                var e = [];
                return ze(
                    this,
                    arguments,
                    function (t) {
                        var n = this.parentNode;
                        x.inArray(this, e) < 0 && (x.cleanData(ge(this)), n && n.replaceChild(t, this));
                    },
                    e
                );
            },
        }),
        x.each({ appendTo: "append", prependTo: "prepend", insertBefore: "before", insertAfter: "after", replaceAll: "replaceWith" }, function (e, t) {
            x.fn[e] = function (e) {
                for (var n, i = [], o = x(e), s = o.length - 1, a = 0; a <= s; a++) (n = a === s ? this : this.clone(!0)), x(o[a])[t](n), r.apply(i, n.get());
                return this.pushStack(i);
            };
        });
    var Ne = new RegExp("^(" + ee + ")(?!px)[a-z%]+$", "i"),
        je = function (t) {
            var n = t.ownerDocument.defaultView;
            return (n && n.opener) || (n = e), n.getComputedStyle(t);
        },
        Re = function (e, t, n) {
            var i,
                o,
                s = {};
            for (o in t) (s[o] = e.style[o]), (e.style[o] = t[o]);
            for (o in ((i = n.call(e)), t)) e.style[o] = s[o];
            return i;
        },
        He = new RegExp(ne.join("|"), "i");
    function qe(e, t, n) {
        var i,
            o,
            s,
            r,
            a = e.style;
        return (
            (n = n || je(e)) &&
                ("" !== (r = n.getPropertyValue(t) || n[t]) || oe(e) || (r = x.style(e, t)),
                !h.pixelBoxStyles() && Ne.test(r) && He.test(t) && ((i = a.width), (o = a.minWidth), (s = a.maxWidth), (a.minWidth = a.maxWidth = a.width = r), (r = n.width), (a.width = i), (a.minWidth = o), (a.maxWidth = s))),
            void 0 !== r ? r + "" : r
        );
    }
    function Fe(e, t) {
        return {
            get: function () {
                if (!e()) return (this.get = t).apply(this, arguments);
                delete this.get;
            },
        };
    }
    !(function () {
        function t() {
            if (d) {
                (c.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0"),
                    (d.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%"),
                    ie.appendChild(c).appendChild(d);
                var t = e.getComputedStyle(d);
                (i = "1%" !== t.top),
                    (l = 12 === n(t.marginLeft)),
                    (d.style.right = "60%"),
                    (r = 36 === n(t.right)),
                    (o = 36 === n(t.width)),
                    (d.style.position = "absolute"),
                    (s = 12 === n(d.offsetWidth / 3)),
                    ie.removeChild(c),
                    (d = null);
            }
        }
        function n(e) {
            return Math.round(parseFloat(e));
        }
        var i,
            o,
            s,
            r,
            a,
            l,
            c = g.createElement("div"),
            d = g.createElement("div");
        d.style &&
            ((d.style.backgroundClip = "content-box"),
            (d.cloneNode(!0).style.backgroundClip = ""),
            (h.clearCloneStyle = "content-box" === d.style.backgroundClip),
            x.extend(h, {
                boxSizingReliable: function () {
                    return t(), o;
                },
                pixelBoxStyles: function () {
                    return t(), r;
                },
                pixelPosition: function () {
                    return t(), i;
                },
                reliableMarginLeft: function () {
                    return t(), l;
                },
                scrollboxSize: function () {
                    return t(), s;
                },
                reliableTrDimensions: function () {
                    var t, n, i, o;
                    return (
                        null == a &&
                            ((t = g.createElement("table")),
                            (n = g.createElement("tr")),
                            (i = g.createElement("div")),
                            (t.style.cssText = "position:absolute;left:-11111px"),
                            (n.style.height = "1px"),
                            (i.style.height = "9px"),
                            ie.appendChild(t).appendChild(n).appendChild(i),
                            (o = e.getComputedStyle(n)),
                            (a = 3 < parseInt(o.height)),
                            ie.removeChild(t)),
                        a
                    );
                },
            }));
    })();
    var We = ["Webkit", "Moz", "ms"],
        Be = g.createElement("div").style,
        Ve = {};
    function Ue(e) {
        return (
            x.cssProps[e] ||
            Ve[e] ||
            (e in Be
                ? e
                : (Ve[e] =
                      (function (e) {
                          for (var t = e[0].toUpperCase() + e.slice(1), n = We.length; n--; ) if ((e = We[n] + t) in Be) return e;
                      })(e) || e))
        );
    }
    var Ge = /^(none|table(?!-c[ea]).+)/,
        Xe = /^--/,
        Ye = { position: "absolute", visibility: "hidden", display: "block" },
        Ke = { letterSpacing: "0", fontWeight: "400" };
    function Ze(e, t, n) {
        var i = te.exec(t);
        return i ? Math.max(0, i[2] - (n || 0)) + (i[3] || "px") : t;
    }
    function Qe(e, t, n, i, o, s) {
        var r = "width" === t ? 1 : 0,
            a = 0,
            l = 0;
        if (n === (i ? "border" : "content")) return 0;
        for (; r < 4; r += 2)
            "margin" === n && (l += x.css(e, n + ne[r], !0, o)),
                i
                    ? ("content" === n && (l -= x.css(e, "padding" + ne[r], !0, o)), "margin" !== n && (l -= x.css(e, "border" + ne[r] + "Width", !0, o)))
                    : ((l += x.css(e, "padding" + ne[r], !0, o)), "padding" !== n ? (l += x.css(e, "border" + ne[r] + "Width", !0, o)) : (a += x.css(e, "border" + ne[r] + "Width", !0, o)));
        return !i && 0 <= s && (l += Math.max(0, Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - s - l - a - 0.5)) || 0), l;
    }
    function Je(e, t, n) {
        var i = je(e),
            o = (!h.boxSizingReliable() || n) && "border-box" === x.css(e, "boxSizing", !1, i),
            s = o,
            r = qe(e, t, i),
            a = "offset" + t[0].toUpperCase() + t.slice(1);
        if (Ne.test(r)) {
            if (!n) return r;
            r = "auto";
        }
        return (
            ((!h.boxSizingReliable() && o) || (!h.reliableTrDimensions() && _(e, "tr")) || "auto" === r || (!parseFloat(r) && "inline" === x.css(e, "display", !1, i))) &&
                e.getClientRects().length &&
                ((o = "border-box" === x.css(e, "boxSizing", !1, i)), (s = a in e) && (r = e[a])),
            (r = parseFloat(r) || 0) + Qe(e, t, n || (o ? "border" : "content"), s, i, r) + "px"
        );
    }
    function et(e, t, n, i, o) {
        return new et.prototype.init(e, t, n, i, o);
    }
    x.extend({
        cssHooks: {
            opacity: {
                get: function (e, t) {
                    if (t) {
                        var n = qe(e, "opacity");
                        return "" === n ? "1" : n;
                    }
                },
            },
        },
        cssNumber: {
            animationIterationCount: !0,
            columnCount: !0,
            fillOpacity: !0,
            flexGrow: !0,
            flexShrink: !0,
            fontWeight: !0,
            gridArea: !0,
            gridColumn: !0,
            gridColumnEnd: !0,
            gridColumnStart: !0,
            gridRow: !0,
            gridRowEnd: !0,
            gridRowStart: !0,
            lineHeight: !0,
            opacity: !0,
            order: !0,
            orphans: !0,
            widows: !0,
            zIndex: !0,
            zoom: !0,
        },
        cssProps: {},
        style: function (e, t, n, i) {
            if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
                var o,
                    s,
                    r,
                    a = U(t),
                    l = Xe.test(t),
                    c = e.style;
                if ((l || (t = Ue(a)), (r = x.cssHooks[t] || x.cssHooks[a]), void 0 === n)) return r && "get" in r && void 0 !== (o = r.get(e, !1, i)) ? o : c[t];
                "string" == (s = typeof n) && (o = te.exec(n)) && o[1] && ((n = ae(e, t, o)), (s = "number")),
                    null != n &&
                        n == n &&
                        ("number" !== s || l || (n += (o && o[3]) || (x.cssNumber[a] ? "" : "px")),
                        h.clearCloneStyle || "" !== n || 0 !== t.indexOf("background") || (c[t] = "inherit"),
                        (r && "set" in r && void 0 === (n = r.set(e, n, i))) || (l ? c.setProperty(t, n) : (c[t] = n)));
            }
        },
        css: function (e, t, n, i) {
            var o,
                s,
                r,
                a = U(t);
            return (
                Xe.test(t) || (t = Ue(a)),
                (r = x.cssHooks[t] || x.cssHooks[a]) && "get" in r && (o = r.get(e, !0, n)),
                void 0 === o && (o = qe(e, t, i)),
                "normal" === o && t in Ke && (o = Ke[t]),
                "" === n || n ? ((s = parseFloat(o)), !0 === n || isFinite(s) ? s || 0 : o) : o
            );
        },
    }),
        x.each(["height", "width"], function (e, t) {
            x.cssHooks[t] = {
                get: function (e, n, i) {
                    if (n)
                        return !Ge.test(x.css(e, "display")) || (e.getClientRects().length && e.getBoundingClientRect().width)
                            ? Je(e, t, i)
                            : Re(e, Ye, function () {
                                  return Je(e, t, i);
                              });
                },
                set: function (e, n, i) {
                    var o,
                        s = je(e),
                        r = !h.scrollboxSize() && "absolute" === s.position,
                        a = (r || i) && "border-box" === x.css(e, "boxSizing", !1, s),
                        l = i ? Qe(e, t, i, a, s) : 0;
                    return (
                        a && r && (l -= Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - parseFloat(s[t]) - Qe(e, t, "border", !1, s) - 0.5)),
                        l && (o = te.exec(n)) && "px" !== (o[3] || "px") && ((e.style[t] = n), (n = x.css(e, t))),
                        Ze(0, n, l)
                    );
                },
            };
        }),
        (x.cssHooks.marginLeft = Fe(h.reliableMarginLeft, function (e, t) {
            if (t)
                return (
                    (parseFloat(qe(e, "marginLeft")) ||
                        e.getBoundingClientRect().left -
                            Re(e, { marginLeft: 0 }, function () {
                                return e.getBoundingClientRect().left;
                            })) + "px"
                );
        })),
        x.each({ margin: "", padding: "", border: "Width" }, function (e, t) {
            (x.cssHooks[e + t] = {
                expand: function (n) {
                    for (var i = 0, o = {}, s = "string" == typeof n ? n.split(" ") : [n]; i < 4; i++) o[e + ne[i] + t] = s[i] || s[i - 2] || s[0];
                    return o;
                },
            }),
                "margin" !== e && (x.cssHooks[e + t].set = Ze);
        }),
        x.fn.extend({
            css: function (e, t) {
                return F(
                    this,
                    function (e, t, n) {
                        var i,
                            o,
                            s = {},
                            r = 0;
                        if (Array.isArray(t)) {
                            for (i = je(e), o = t.length; r < o; r++) s[t[r]] = x.css(e, t[r], !1, i);
                            return s;
                        }
                        return void 0 !== n ? x.style(e, t, n) : x.css(e, t);
                    },
                    e,
                    t,
                    1 < arguments.length
                );
            },
        }),
        (((x.Tween = et).prototype = {
            constructor: et,
            init: function (e, t, n, i, o, s) {
                (this.elem = e), (this.prop = n), (this.easing = o || x.easing._default), (this.options = t), (this.start = this.now = this.cur()), (this.end = i), (this.unit = s || (x.cssNumber[n] ? "" : "px"));
            },
            cur: function () {
                var e = et.propHooks[this.prop];
                return e && e.get ? e.get(this) : et.propHooks._default.get(this);
            },
            run: function (e) {
                var t,
                    n = et.propHooks[this.prop];
                return (
                    this.options.duration ? (this.pos = t = x.easing[this.easing](e, this.options.duration * e, 0, 1, this.options.duration)) : (this.pos = t = e),
                    (this.now = (this.end - this.start) * t + this.start),
                    this.options.step && this.options.step.call(this.elem, this.now, this),
                    n && n.set ? n.set(this) : et.propHooks._default.set(this),
                    this
                );
            },
        }).init.prototype = et.prototype),
        ((et.propHooks = {
            _default: {
                get: function (e) {
                    var t;
                    return 1 !== e.elem.nodeType || (null != e.elem[e.prop] && null == e.elem.style[e.prop]) ? e.elem[e.prop] : (t = x.css(e.elem, e.prop, "")) && "auto" !== t ? t : 0;
                },
                set: function (e) {
                    x.fx.step[e.prop] ? x.fx.step[e.prop](e) : 1 !== e.elem.nodeType || (!x.cssHooks[e.prop] && null == e.elem.style[Ue(e.prop)]) ? (e.elem[e.prop] = e.now) : x.style(e.elem, e.prop, e.now + e.unit);
                },
            },
        }).scrollTop = et.propHooks.scrollLeft = {
            set: function (e) {
                e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now);
            },
        }),
        (x.easing = {
            linear: function (e) {
                return e;
            },
            swing: function (e) {
                return 0.5 - Math.cos(e * Math.PI) / 2;
            },
            _default: "swing",
        }),
        (x.fx = et.prototype.init),
        (x.fx.step = {});
    var tt,
        nt,
        it,
        ot,
        st = /^(?:toggle|show|hide)$/,
        rt = /queueHooks$/;
    function at() {
        nt && (!1 === g.hidden && e.requestAnimationFrame ? e.requestAnimationFrame(at) : e.setTimeout(at, x.fx.interval), x.fx.tick());
    }
    function lt() {
        return (
            e.setTimeout(function () {
                tt = void 0;
            }),
            (tt = Date.now())
        );
    }
    function ct(e, t) {
        var n,
            i = 0,
            o = { height: e };
        for (t = t ? 1 : 0; i < 4; i += 2 - t) o["margin" + (n = ne[i])] = o["padding" + n] = e;
        return t && (o.opacity = o.width = e), o;
    }
    function dt(e, t, n) {
        for (var i, o = (ut.tweeners[t] || []).concat(ut.tweeners["*"]), s = 0, r = o.length; s < r; s++) if ((i = o[s].call(n, t, e))) return i;
    }
    function ut(e, t, n) {
        var i,
            o,
            s = 0,
            r = ut.prefilters.length,
            a = x.Deferred().always(function () {
                delete l.elem;
            }),
            l = function () {
                if (o) return !1;
                for (var t = tt || lt(), n = Math.max(0, c.startTime + c.duration - t), i = 1 - (n / c.duration || 0), s = 0, r = c.tweens.length; s < r; s++) c.tweens[s].run(i);
                return a.notifyWith(e, [c, i, n]), i < 1 && r ? n : (r || a.notifyWith(e, [c, 1, 0]), a.resolveWith(e, [c]), !1);
            },
            c = a.promise({
                elem: e,
                props: x.extend({}, t),
                opts: x.extend(!0, { specialEasing: {}, easing: x.easing._default }, n),
                originalProperties: t,
                originalOptions: n,
                startTime: tt || lt(),
                duration: n.duration,
                tweens: [],
                createTween: function (t, n) {
                    var i = x.Tween(e, c.opts, t, n, c.opts.specialEasing[t] || c.opts.easing);
                    return c.tweens.push(i), i;
                },
                stop: function (t) {
                    var n = 0,
                        i = t ? c.tweens.length : 0;
                    if (o) return this;
                    for (o = !0; n < i; n++) c.tweens[n].run(1);
                    return t ? (a.notifyWith(e, [c, 1, 0]), a.resolveWith(e, [c, t])) : a.rejectWith(e, [c, t]), this;
                },
            }),
            d = c.props;
        for (
            (function (e, t) {
                var n, i, o, s, r;
                for (n in e)
                    if (((o = t[(i = U(n))]), (s = e[n]), Array.isArray(s) && ((o = s[1]), (s = e[n] = s[0])), n !== i && ((e[i] = s), delete e[n]), (r = x.cssHooks[i]) && ("expand" in r)))
                        for (n in ((s = r.expand(s)), delete e[i], s)) (n in e) || ((e[n] = s[n]), (t[n] = o));
                    else t[i] = o;
            })(d, c.opts.specialEasing);
            s < r;
            s++
        )
            if ((i = ut.prefilters[s].call(c, e, d, c.opts))) return f(i.stop) && (x._queueHooks(c.elem, c.opts.queue).stop = i.stop.bind(i)), i;
        return (
            x.map(d, dt, c),
            f(c.opts.start) && c.opts.start.call(e, c),
            c.progress(c.opts.progress).done(c.opts.done, c.opts.complete).fail(c.opts.fail).always(c.opts.always),
            x.fx.timer(x.extend(l, { elem: e, anim: c, queue: c.opts.queue })),
            c
        );
    }
    (x.Animation = x.extend(ut, {
        tweeners: {
            "*": [
                function (e, t) {
                    var n = this.createTween(e, t);
                    return ae(n.elem, e, te.exec(t), n), n;
                },
            ],
        },
        tweener: function (e, t) {
            f(e) ? ((t = e), (e = ["*"])) : (e = e.match(z));
            for (var n, i = 0, o = e.length; i < o; i++) (n = e[i]), (ut.tweeners[n] = ut.tweeners[n] || []), ut.tweeners[n].unshift(t);
        },
        prefilters: [
            function (e, t, n) {
                var i,
                    o,
                    s,
                    r,
                    a,
                    l,
                    c,
                    d,
                    u = "width" in t || "height" in t,
                    p = this,
                    h = {},
                    f = e.style,
                    m = e.nodeType && re(e),
                    g = Y.get(e, "fxshow");
                for (i in (n.queue ||
                    (null == (r = x._queueHooks(e, "fx")).unqueued &&
                        ((r.unqueued = 0),
                        (a = r.empty.fire),
                        (r.empty.fire = function () {
                            r.unqueued || a();
                        })),
                    r.unqueued++,
                    p.always(function () {
                        p.always(function () {
                            r.unqueued--, x.queue(e, "fx").length || r.empty.fire();
                        });
                    })),
                t))
                    if (((o = t[i]), st.test(o))) {
                        if ((delete t[i], (s = s || "toggle" === o), o === (m ? "hide" : "show"))) {
                            if ("show" !== o || !g || void 0 === g[i]) continue;
                            m = !0;
                        }
                        h[i] = (g && g[i]) || x.style(e, i);
                    }
                if ((l = !x.isEmptyObject(t)) || !x.isEmptyObject(h))
                    for (i in (u &&
                        1 === e.nodeType &&
                        ((n.overflow = [f.overflow, f.overflowX, f.overflowY]),
                        null == (c = g && g.display) && (c = Y.get(e, "display")),
                        "none" === (d = x.css(e, "display")) && (c ? (d = c) : (ce([e], !0), (c = e.style.display || c), (d = x.css(e, "display")), ce([e]))),
                        ("inline" === d || ("inline-block" === d && null != c)) &&
                            "none" === x.css(e, "float") &&
                            (l ||
                                (p.done(function () {
                                    f.display = c;
                                }),
                                null == c && ((d = f.display), (c = "none" === d ? "" : d))),
                            (f.display = "inline-block"))),
                    n.overflow &&
                        ((f.overflow = "hidden"),
                        p.always(function () {
                            (f.overflow = n.overflow[0]), (f.overflowX = n.overflow[1]), (f.overflowY = n.overflow[2]);
                        })),
                    (l = !1),
                    h))
                        l ||
                            (g ? "hidden" in g && (m = g.hidden) : (g = Y.access(e, "fxshow", { display: c })),
                            s && (g.hidden = !m),
                            m && ce([e], !0),
                            p.done(function () {
                                for (i in (m || ce([e]), Y.remove(e, "fxshow"), h)) x.style(e, i, h[i]);
                            })),
                            (l = dt(m ? g[i] : 0, i, p)),
                            i in g || ((g[i] = l.start), m && ((l.end = l.start), (l.start = 0)));
            },
        ],
        prefilter: function (e, t) {
            t ? ut.prefilters.unshift(e) : ut.prefilters.push(e);
        },
    })),
        (x.speed = function (e, t, n) {
            var i = e && "object" == typeof e ? x.extend({}, e) : { complete: n || (!n && t) || (f(e) && e), duration: e, easing: (n && t) || (t && !f(t) && t) };
            return (
                x.fx.off ? (i.duration = 0) : "number" != typeof i.duration && (i.duration in x.fx.speeds ? (i.duration = x.fx.speeds[i.duration]) : (i.duration = x.fx.speeds._default)),
                (null != i.queue && !0 !== i.queue) || (i.queue = "fx"),
                (i.old = i.complete),
                (i.complete = function () {
                    f(i.old) && i.old.call(this), i.queue && x.dequeue(this, i.queue);
                }),
                i
            );
        }),
        x.fn.extend({
            fadeTo: function (e, t, n, i) {
                return this.filter(re).css("opacity", 0).show().end().animate({ opacity: t }, e, n, i);
            },
            animate: function (e, t, n, i) {
                var o = x.isEmptyObject(e),
                    s = x.speed(t, n, i),
                    r = function () {
                        var t = ut(this, x.extend({}, e), s);
                        (o || Y.get(this, "finish")) && t.stop(!0);
                    };
                return (r.finish = r), o || !1 === s.queue ? this.each(r) : this.queue(s.queue, r);
            },
            stop: function (e, t, n) {
                var i = function (e) {
                    var t = e.stop;
                    delete e.stop, t(n);
                };
                return (
                    "string" != typeof e && ((n = t), (t = e), (e = void 0)),
                    t && this.queue(e || "fx", []),
                    this.each(function () {
                        var t = !0,
                            o = null != e && e + "queueHooks",
                            s = x.timers,
                            r = Y.get(this);
                        if (o) r[o] && r[o].stop && i(r[o]);
                        else for (o in r) r[o] && r[o].stop && rt.test(o) && i(r[o]);
                        for (o = s.length; o--; ) s[o].elem !== this || (null != e && s[o].queue !== e) || (s[o].anim.stop(n), (t = !1), s.splice(o, 1));
                        (!t && n) || x.dequeue(this, e);
                    })
                );
            },
            finish: function (e) {
                return (
                    !1 !== e && (e = e || "fx"),
                    this.each(function () {
                        var t,
                            n = Y.get(this),
                            i = n[e + "queue"],
                            o = n[e + "queueHooks"],
                            s = x.timers,
                            r = i ? i.length : 0;
                        for (n.finish = !0, x.queue(this, e, []), o && o.stop && o.stop.call(this, !0), t = s.length; t--; ) s[t].elem === this && s[t].queue === e && (s[t].anim.stop(!0), s.splice(t, 1));
                        for (t = 0; t < r; t++) i[t] && i[t].finish && i[t].finish.call(this);
                        delete n.finish;
                    })
                );
            },
        }),
        x.each(["toggle", "show", "hide"], function (e, t) {
            var n = x.fn[t];
            x.fn[t] = function (e, i, o) {
                return null == e || "boolean" == typeof e ? n.apply(this, arguments) : this.animate(ct(t, !0), e, i, o);
            };
        }),
        x.each({ slideDown: ct("show"), slideUp: ct("hide"), slideToggle: ct("toggle"), fadeIn: { opacity: "show" }, fadeOut: { opacity: "hide" }, fadeToggle: { opacity: "toggle" } }, function (e, t) {
            x.fn[e] = function (e, n, i) {
                return this.animate(t, e, n, i);
            };
        }),
        (x.timers = []),
        (x.fx.tick = function () {
            var e,
                t = 0,
                n = x.timers;
            for (tt = Date.now(); t < n.length; t++) (e = n[t])() || n[t] !== e || n.splice(t--, 1);
            n.length || x.fx.stop(), (tt = void 0);
        }),
        (x.fx.timer = function (e) {
            x.timers.push(e), x.fx.start();
        }),
        (x.fx.interval = 13),
        (x.fx.start = function () {
            nt || ((nt = !0), at());
        }),
        (x.fx.stop = function () {
            nt = null;
        }),
        (x.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
        (x.fn.delay = function (t, n) {
            return (
                (t = (x.fx && x.fx.speeds[t]) || t),
                (n = n || "fx"),
                this.queue(n, function (n, i) {
                    var o = e.setTimeout(n, t);
                    i.stop = function () {
                        e.clearTimeout(o);
                    };
                })
            );
        }),
        (it = g.createElement("input")),
        (ot = g.createElement("select").appendChild(g.createElement("option"))),
        (it.type = "checkbox"),
        (h.checkOn = "" !== it.value),
        (h.optSelected = ot.selected),
        ((it = g.createElement("input")).value = "t"),
        (it.type = "radio"),
        (h.radioValue = "t" === it.value);
    var pt,
        ht = x.expr.attrHandle;
    x.fn.extend({
        attr: function (e, t) {
            return F(this, x.attr, e, t, 1 < arguments.length);
        },
        removeAttr: function (e) {
            return this.each(function () {
                x.removeAttr(this, e);
            });
        },
    }),
        x.extend({
            attr: function (e, t, n) {
                var i,
                    o,
                    s = e.nodeType;
                if (3 !== s && 8 !== s && 2 !== s)
                    return void 0 === e.getAttribute
                        ? x.prop(e, t, n)
                        : ((1 === s && x.isXMLDoc(e)) || (o = x.attrHooks[t.toLowerCase()] || (x.expr.match.bool.test(t) ? pt : void 0)),
                          void 0 !== n
                              ? null === n
                                  ? void x.removeAttr(e, t)
                                  : o && "set" in o && void 0 !== (i = o.set(e, n, t))
                                  ? i
                                  : (e.setAttribute(t, n + ""), n)
                              : o && "get" in o && null !== (i = o.get(e, t))
                              ? i
                              : null == (i = x.find.attr(e, t))
                              ? void 0
                              : i);
            },
            attrHooks: {
                type: {
                    set: function (e, t) {
                        if (!h.radioValue && "radio" === t && _(e, "input")) {
                            var n = e.value;
                            return e.setAttribute("type", t), n && (e.value = n), t;
                        }
                    },
                },
            },
            removeAttr: function (e, t) {
                var n,
                    i = 0,
                    o = t && t.match(z);
                if (o && 1 === e.nodeType) for (; (n = o[i++]); ) e.removeAttribute(n);
            },
        }),
        (pt = {
            set: function (e, t, n) {
                return !1 === t ? x.removeAttr(e, n) : e.setAttribute(n, n), n;
            },
        }),
        x.each(x.expr.match.bool.source.match(/\w+/g), function (e, t) {
            var n = ht[t] || x.find.attr;
            ht[t] = function (e, t, i) {
                var o,
                    s,
                    r = t.toLowerCase();
                return i || ((s = ht[r]), (ht[r] = o), (o = null != n(e, t, i) ? r : null), (ht[r] = s)), o;
            };
        });
    var ft = /^(?:input|select|textarea|button)$/i,
        mt = /^(?:a|area)$/i;
    function gt(e) {
        return (e.match(z) || []).join(" ");
    }
    function vt(e) {
        return (e.getAttribute && e.getAttribute("class")) || "";
    }
    function yt(e) {
        return Array.isArray(e) ? e : ("string" == typeof e && e.match(z)) || [];
    }
    x.fn.extend({
        prop: function (e, t) {
            return F(this, x.prop, e, t, 1 < arguments.length);
        },
        removeProp: function (e) {
            return this.each(function () {
                delete this[x.propFix[e] || e];
            });
        },
    }),
        x.extend({
            prop: function (e, t, n) {
                var i,
                    o,
                    s = e.nodeType;
                if (3 !== s && 8 !== s && 2 !== s)
                    return (
                        (1 === s && x.isXMLDoc(e)) || ((t = x.propFix[t] || t), (o = x.propHooks[t])),
                        void 0 !== n ? (o && "set" in o && void 0 !== (i = o.set(e, n, t)) ? i : (e[t] = n)) : o && "get" in o && null !== (i = o.get(e, t)) ? i : e[t]
                    );
            },
            propHooks: {
                tabIndex: {
                    get: function (e) {
                        var t = x.find.attr(e, "tabindex");
                        return t ? parseInt(t, 10) : ft.test(e.nodeName) || (mt.test(e.nodeName) && e.href) ? 0 : -1;
                    },
                },
            },
            propFix: { for: "htmlFor", class: "className" },
        }),
        h.optSelected ||
            (x.propHooks.selected = {
                get: function (e) {
                    var t = e.parentNode;
                    return t && t.parentNode && t.parentNode.selectedIndex, null;
                },
                set: function (e) {
                    var t = e.parentNode;
                    t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex);
                },
            }),
        x.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function () {
            x.propFix[this.toLowerCase()] = this;
        }),
        x.fn.extend({
            addClass: function (e) {
                var t,
                    n,
                    i,
                    o,
                    s,
                    r,
                    a,
                    l = 0;
                if (f(e))
                    return this.each(function (t) {
                        x(this).addClass(e.call(this, t, vt(this)));
                    });
                if ((t = yt(e)).length)
                    for (; (n = this[l++]); )
                        if (((o = vt(n)), (i = 1 === n.nodeType && " " + gt(o) + " "))) {
                            for (r = 0; (s = t[r++]); ) i.indexOf(" " + s + " ") < 0 && (i += s + " ");
                            o !== (a = gt(i)) && n.setAttribute("class", a);
                        }
                return this;
            },
            removeClass: function (e) {
                var t,
                    n,
                    i,
                    o,
                    s,
                    r,
                    a,
                    l = 0;
                if (f(e))
                    return this.each(function (t) {
                        x(this).removeClass(e.call(this, t, vt(this)));
                    });
                if (!arguments.length) return this.attr("class", "");
                if ((t = yt(e)).length)
                    for (; (n = this[l++]); )
                        if (((o = vt(n)), (i = 1 === n.nodeType && " " + gt(o) + " "))) {
                            for (r = 0; (s = t[r++]); ) for (; -1 < i.indexOf(" " + s + " "); ) i = i.replace(" " + s + " ", " ");
                            o !== (a = gt(i)) && n.setAttribute("class", a);
                        }
                return this;
            },
            toggleClass: function (e, t) {
                var n = typeof e,
                    i = "string" === n || Array.isArray(e);
                return "boolean" == typeof t && i
                    ? t
                        ? this.addClass(e)
                        : this.removeClass(e)
                    : f(e)
                    ? this.each(function (n) {
                          x(this).toggleClass(e.call(this, n, vt(this), t), t);
                      })
                    : this.each(function () {
                          var t, o, s, r;
                          if (i) for (o = 0, s = x(this), r = yt(e); (t = r[o++]); ) s.hasClass(t) ? s.removeClass(t) : s.addClass(t);
                          else (void 0 !== e && "boolean" !== n) || ((t = vt(this)) && Y.set(this, "__className__", t), this.setAttribute && this.setAttribute("class", t || !1 === e ? "" : Y.get(this, "__className__") || ""));
                      });
            },
            hasClass: function (e) {
                var t,
                    n,
                    i = 0;
                for (t = " " + e + " "; (n = this[i++]); ) if (1 === n.nodeType && -1 < (" " + gt(vt(n)) + " ").indexOf(t)) return !0;
                return !1;
            },
        });
    var bt = /\r/g;
    x.fn.extend({
        val: function (e) {
            var t,
                n,
                i,
                o = this[0];
            return arguments.length
                ? ((i = f(e)),
                  this.each(function (n) {
                      var o;
                      1 === this.nodeType &&
                          (null == (o = i ? e.call(this, n, x(this).val()) : e)
                              ? (o = "")
                              : "number" == typeof o
                              ? (o += "")
                              : Array.isArray(o) &&
                                (o = x.map(o, function (e) {
                                    return null == e ? "" : e + "";
                                })),
                          ((t = x.valHooks[this.type] || x.valHooks[this.nodeName.toLowerCase()]) && "set" in t && void 0 !== t.set(this, o, "value")) || (this.value = o));
                  }))
                : o
                ? (t = x.valHooks[o.type] || x.valHooks[o.nodeName.toLowerCase()]) && "get" in t && void 0 !== (n = t.get(o, "value"))
                    ? n
                    : "string" == typeof (n = o.value)
                    ? n.replace(bt, "")
                    : null == n
                    ? ""
                    : n
                : void 0;
        },
    }),
        x.extend({
            valHooks: {
                option: {
                    get: function (e) {
                        var t = x.find.attr(e, "value");
                        return null != t ? t : gt(x.text(e));
                    },
                },
                select: {
                    get: function (e) {
                        var t,
                            n,
                            i,
                            o = e.options,
                            s = e.selectedIndex,
                            r = "select-one" === e.type,
                            a = r ? null : [],
                            l = r ? s + 1 : o.length;
                        for (i = s < 0 ? l : r ? s : 0; i < l; i++)
                            if (((n = o[i]).selected || i === s) && !n.disabled && (!n.parentNode.disabled || !_(n.parentNode, "optgroup"))) {
                                if (((t = x(n).val()), r)) return t;
                                a.push(t);
                            }
                        return a;
                    },
                    set: function (e, t) {
                        for (var n, i, o = e.options, s = x.makeArray(t), r = o.length; r--; ) ((i = o[r]).selected = -1 < x.inArray(x.valHooks.option.get(i), s)) && (n = !0);
                        return n || (e.selectedIndex = -1), s;
                    },
                },
            },
        }),
        x.each(["radio", "checkbox"], function () {
            (x.valHooks[this] = {
                set: function (e, t) {
                    if (Array.isArray(t)) return (e.checked = -1 < x.inArray(x(e).val(), t));
                },
            }),
                h.checkOn ||
                    (x.valHooks[this].get = function (e) {
                        return null === e.getAttribute("value") ? "on" : e.value;
                    });
        }),
        (h.focusin = "onfocusin" in e);
    var wt = /^(?:focusinfocus|focusoutblur)$/,
        xt = function (e) {
            e.stopPropagation();
        };
    x.extend(x.event, {
        trigger: function (t, n, i, o) {
            var s,
                r,
                a,
                l,
                c,
                u,
                p,
                h,
                v = [i || g],
                y = d.call(t, "type") ? t.type : t,
                b = d.call(t, "namespace") ? t.namespace.split(".") : [];
            if (
                ((r = h = a = i = i || g),
                3 !== i.nodeType &&
                    8 !== i.nodeType &&
                    !wt.test(y + x.event.triggered) &&
                    (-1 < y.indexOf(".") && ((y = (b = y.split(".")).shift()), b.sort()),
                    (c = y.indexOf(":") < 0 && "on" + y),
                    ((t = t[x.expando] ? t : new x.Event(y, "object" == typeof t && t)).isTrigger = o ? 2 : 3),
                    (t.namespace = b.join(".")),
                    (t.rnamespace = t.namespace ? new RegExp("(^|\\.)" + b.join("\\.(?:.*\\.|)") + "(\\.|$)") : null),
                    (t.result = void 0),
                    t.target || (t.target = i),
                    (n = null == n ? [t] : x.makeArray(n, [t])),
                    (p = x.event.special[y] || {}),
                    o || !p.trigger || !1 !== p.trigger.apply(i, n)))
            ) {
                if (!o && !p.noBubble && !m(i)) {
                    for (l = p.delegateType || y, wt.test(l + y) || (r = r.parentNode); r; r = r.parentNode) v.push(r), (a = r);
                    a === (i.ownerDocument || g) && v.push(a.defaultView || a.parentWindow || e);
                }
                for (s = 0; (r = v[s++]) && !t.isPropagationStopped(); )
                    (h = r),
                        (t.type = 1 < s ? l : p.bindType || y),
                        (u = (Y.get(r, "events") || Object.create(null))[t.type] && Y.get(r, "handle")) && u.apply(r, n),
                        (u = c && r[c]) && u.apply && G(r) && ((t.result = u.apply(r, n)), !1 === t.result && t.preventDefault());
                return (
                    (t.type = y),
                    o ||
                        t.isDefaultPrevented() ||
                        (p._default && !1 !== p._default.apply(v.pop(), n)) ||
                        !G(i) ||
                        (c &&
                            f(i[y]) &&
                            !m(i) &&
                            ((a = i[c]) && (i[c] = null),
                            (x.event.triggered = y),
                            t.isPropagationStopped() && h.addEventListener(y, xt),
                            i[y](),
                            t.isPropagationStopped() && h.removeEventListener(y, xt),
                            (x.event.triggered = void 0),
                            a && (i[c] = a))),
                    t.result
                );
            }
        },
        simulate: function (e, t, n) {
            var i = x.extend(new x.Event(), n, { type: e, isSimulated: !0 });
            x.event.trigger(i, null, t);
        },
    }),
        x.fn.extend({
            trigger: function (e, t) {
                return this.each(function () {
                    x.event.trigger(e, t, this);
                });
            },
            triggerHandler: function (e, t) {
                var n = this[0];
                if (n) return x.event.trigger(e, t, n, !0);
            },
        }),
        h.focusin ||
            x.each({ focus: "focusin", blur: "focusout" }, function (e, t) {
                var n = function (e) {
                    x.event.simulate(t, e.target, x.event.fix(e));
                };
                x.event.special[t] = {
                    setup: function () {
                        var i = this.ownerDocument || this.document || this,
                            o = Y.access(i, t);
                        o || i.addEventListener(e, n, !0), Y.access(i, t, (o || 0) + 1);
                    },
                    teardown: function () {
                        var i = this.ownerDocument || this.document || this,
                            o = Y.access(i, t) - 1;
                        o ? Y.access(i, t, o) : (i.removeEventListener(e, n, !0), Y.remove(i, t));
                    },
                };
            });
    var Tt = e.location,
        Ct = { guid: Date.now() },
        St = /\?/;
    x.parseXML = function (t) {
        var n;
        if (!t || "string" != typeof t) return null;
        try {
            n = new e.DOMParser().parseFromString(t, "text/xml");
        } catch (t) {
            n = void 0;
        }
        return (n && !n.getElementsByTagName("parsererror").length) || x.error("Invalid XML: " + t), n;
    };
    var kt = /\[\]$/,
        $t = /\r?\n/g,
        _t = /^(?:submit|button|image|reset|file)$/i,
        Et = /^(?:input|select|textarea|keygen)/i;
    function At(e, t, n, i) {
        var o;
        if (Array.isArray(t))
            x.each(t, function (t, o) {
                n || kt.test(e) ? i(e, o) : At(e + "[" + ("object" == typeof o && null != o ? t : "") + "]", o, n, i);
            });
        else if (n || "object" !== b(t)) i(e, t);
        else for (o in t) At(e + "[" + o + "]", t[o], n, i);
    }
    (x.param = function (e, t) {
        var n,
            i = [],
            o = function (e, t) {
                var n = f(t) ? t() : t;
                i[i.length] = encodeURIComponent(e) + "=" + encodeURIComponent(null == n ? "" : n);
            };
        if (null == e) return "";
        if (Array.isArray(e) || (e.jquery && !x.isPlainObject(e)))
            x.each(e, function () {
                o(this.name, this.value);
            });
        else for (n in e) At(n, e[n], t, o);
        return i.join("&");
    }),
        x.fn.extend({
            serialize: function () {
                return x.param(this.serializeArray());
            },
            serializeArray: function () {
                return this.map(function () {
                    var e = x.prop(this, "elements");
                    return e ? x.makeArray(e) : this;
                })
                    .filter(function () {
                        var e = this.type;
                        return this.name && !x(this).is(":disabled") && Et.test(this.nodeName) && !_t.test(e) && (this.checked || !pe.test(e));
                    })
                    .map(function (e, t) {
                        var n = x(this).val();
                        return null == n
                            ? null
                            : Array.isArray(n)
                            ? x.map(n, function (e) {
                                  return { name: t.name, value: e.replace($t, "\r\n") };
                              })
                            : { name: t.name, value: n.replace($t, "\r\n") };
                    })
                    .get();
            },
        });
    var Mt = /%20/g,
        Pt = /#.*$/,
        Lt = /([?&])_=[^&]*/,
        Dt = /^(.*?):[ \t]*([^\r\n]*)$/gm,
        Ot = /^(?:GET|HEAD)$/,
        zt = /^\/\//,
        It = {},
        Nt = {},
        jt = "*/".concat("*"),
        Rt = g.createElement("a");
    function Ht(e) {
        return function (t, n) {
            "string" != typeof t && ((n = t), (t = "*"));
            var i,
                o = 0,
                s = t.toLowerCase().match(z) || [];
            if (f(n)) for (; (i = s[o++]); ) "+" === i[0] ? ((i = i.slice(1) || "*"), (e[i] = e[i] || []).unshift(n)) : (e[i] = e[i] || []).push(n);
        };
    }
    function qt(e, t, n, i) {
        var o = {},
            s = e === Nt;
        function r(a) {
            var l;
            return (
                (o[a] = !0),
                x.each(e[a] || [], function (e, a) {
                    var c = a(t, n, i);
                    return "string" != typeof c || s || o[c] ? (s ? !(l = c) : void 0) : (t.dataTypes.unshift(c), r(c), !1);
                }),
                l
            );
        }
        return r(t.dataTypes[0]) || (!o["*"] && r("*"));
    }
    function Ft(e, t) {
        var n,
            i,
            o = x.ajaxSettings.flatOptions || {};
        for (n in t) void 0 !== t[n] && ((o[n] ? e : i || (i = {}))[n] = t[n]);
        return i && x.extend(!0, e, i), e;
    }
    (Rt.href = Tt.href),
        x.extend({
            active: 0,
            lastModified: {},
            etag: {},
            ajaxSettings: {
                url: Tt.href,
                type: "GET",
                isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(Tt.protocol),
                global: !0,
                processData: !0,
                async: !0,
                contentType: "application/x-www-form-urlencoded; charset=UTF-8",
                accepts: { "*": jt, text: "text/plain", html: "text/html", xml: "application/xml, text/xml", json: "application/json, text/javascript" },
                contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ },
                responseFields: { xml: "responseXML", text: "responseText", json: "responseJSON" },
                converters: { "* text": String, "text html": !0, "text json": JSON.parse, "text xml": x.parseXML },
                flatOptions: { url: !0, context: !0 },
            },
            ajaxSetup: function (e, t) {
                return t ? Ft(Ft(e, x.ajaxSettings), t) : Ft(x.ajaxSettings, e);
            },
            ajaxPrefilter: Ht(It),
            ajaxTransport: Ht(Nt),
            ajax: function (t, n) {
                "object" == typeof t && ((n = t), (t = void 0)), (n = n || {});
                var i,
                    o,
                    s,
                    r,
                    a,
                    l,
                    c,
                    d,
                    u,
                    p,
                    h = x.ajaxSetup({}, n),
                    f = h.context || h,
                    m = h.context && (f.nodeType || f.jquery) ? x(f) : x.event,
                    v = x.Deferred(),
                    y = x.Callbacks("once memory"),
                    b = h.statusCode || {},
                    w = {},
                    T = {},
                    C = "canceled",
                    S = {
                        readyState: 0,
                        getResponseHeader: function (e) {
                            var t;
                            if (c) {
                                if (!r) for (r = {}; (t = Dt.exec(s)); ) r[t[1].toLowerCase() + " "] = (r[t[1].toLowerCase() + " "] || []).concat(t[2]);
                                t = r[e.toLowerCase() + " "];
                            }
                            return null == t ? null : t.join(", ");
                        },
                        getAllResponseHeaders: function () {
                            return c ? s : null;
                        },
                        setRequestHeader: function (e, t) {
                            return null == c && ((e = T[e.toLowerCase()] = T[e.toLowerCase()] || e), (w[e] = t)), this;
                        },
                        overrideMimeType: function (e) {
                            return null == c && (h.mimeType = e), this;
                        },
                        statusCode: function (e) {
                            var t;
                            if (e)
                                if (c) S.always(e[S.status]);
                                else for (t in e) b[t] = [b[t], e[t]];
                            return this;
                        },
                        abort: function (e) {
                            var t = e || C;
                            return i && i.abort(t), k(0, t), this;
                        },
                    };
                if (
                    (v.promise(S),
                    (h.url = ((t || h.url || Tt.href) + "").replace(zt, Tt.protocol + "//")),
                    (h.type = n.method || n.type || h.method || h.type),
                    (h.dataTypes = (h.dataType || "*").toLowerCase().match(z) || [""]),
                    null == h.crossDomain)
                ) {
                    l = g.createElement("a");
                    try {
                        (l.href = h.url), (l.href = l.href), (h.crossDomain = Rt.protocol + "//" + Rt.host != l.protocol + "//" + l.host);
                    } catch (t) {
                        h.crossDomain = !0;
                    }
                }
                if ((h.data && h.processData && "string" != typeof h.data && (h.data = x.param(h.data, h.traditional)), qt(It, h, n, S), c)) return S;
                for (u in ((d = x.event && h.global) && 0 == x.active++ && x.event.trigger("ajaxStart"),
                (h.type = h.type.toUpperCase()),
                (h.hasContent = !Ot.test(h.type)),
                (o = h.url.replace(Pt, "")),
                h.hasContent
                    ? h.data && h.processData && 0 === (h.contentType || "").indexOf("application/x-www-form-urlencoded") && (h.data = h.data.replace(Mt, "+"))
                    : ((p = h.url.slice(o.length)),
                      h.data && (h.processData || "string" == typeof h.data) && ((o += (St.test(o) ? "&" : "?") + h.data), delete h.data),
                      !1 === h.cache && ((o = o.replace(Lt, "$1")), (p = (St.test(o) ? "&" : "?") + "_=" + Ct.guid++ + p)),
                      (h.url = o + p)),
                h.ifModified && (x.lastModified[o] && S.setRequestHeader("If-Modified-Since", x.lastModified[o]), x.etag[o] && S.setRequestHeader("If-None-Match", x.etag[o])),
                ((h.data && h.hasContent && !1 !== h.contentType) || n.contentType) && S.setRequestHeader("Content-Type", h.contentType),
                S.setRequestHeader("Accept", h.dataTypes[0] && h.accepts[h.dataTypes[0]] ? h.accepts[h.dataTypes[0]] + ("*" !== h.dataTypes[0] ? ", " + jt + "; q=0.01" : "") : h.accepts["*"]),
                h.headers))
                    S.setRequestHeader(u, h.headers[u]);
                if (h.beforeSend && (!1 === h.beforeSend.call(f, S, h) || c)) return S.abort();
                if (((C = "abort"), y.add(h.complete), S.done(h.success), S.fail(h.error), (i = qt(Nt, h, n, S)))) {
                    if (((S.readyState = 1), d && m.trigger("ajaxSend", [S, h]), c)) return S;
                    h.async &&
                        0 < h.timeout &&
                        (a = e.setTimeout(function () {
                            S.abort("timeout");
                        }, h.timeout));
                    try {
                        (c = !1), i.send(w, k);
                    } catch (t) {
                        if (c) throw t;
                        k(-1, t);
                    }
                } else k(-1, "No Transport");
                function k(t, n, r, l) {
                    var u,
                        p,
                        g,
                        w,
                        T,
                        C = n;
                    c ||
                        ((c = !0),
                        a && e.clearTimeout(a),
                        (i = void 0),
                        (s = l || ""),
                        (S.readyState = 0 < t ? 4 : 0),
                        (u = (200 <= t && t < 300) || 304 === t),
                        r &&
                            (w = (function (e, t, n) {
                                for (var i, o, s, r, a = e.contents, l = e.dataTypes; "*" === l[0]; ) l.shift(), void 0 === i && (i = e.mimeType || t.getResponseHeader("Content-Type"));
                                if (i)
                                    for (o in a)
                                        if (a[o] && a[o].test(i)) {
                                            l.unshift(o);
                                            break;
                                        }
                                if (l[0] in n) s = l[0];
                                else {
                                    for (o in n) {
                                        if (!l[0] || e.converters[o + " " + l[0]]) {
                                            s = o;
                                            break;
                                        }
                                        r || (r = o);
                                    }
                                    s = s || r;
                                }
                                if (s) return s !== l[0] && l.unshift(s), n[s];
                            })(h, S, r)),
                        !u && -1 < x.inArray("script", h.dataTypes) && (h.converters["text script"] = function () {}),
                        (w = (function (e, t, n, i) {
                            var o,
                                s,
                                r,
                                a,
                                l,
                                c = {},
                                d = e.dataTypes.slice();
                            if (d[1]) for (r in e.converters) c[r.toLowerCase()] = e.converters[r];
                            for (s = d.shift(); s; )
                                if ((e.responseFields[s] && (n[e.responseFields[s]] = t), !l && i && e.dataFilter && (t = e.dataFilter(t, e.dataType)), (l = s), (s = d.shift())))
                                    if ("*" === s) s = l;
                                    else if ("*" !== l && l !== s) {
                                        if (!(r = c[l + " " + s] || c["* " + s]))
                                            for (o in c)
                                                if ((a = o.split(" "))[1] === s && (r = c[l + " " + a[0]] || c["* " + a[0]])) {
                                                    !0 === r ? (r = c[o]) : !0 !== c[o] && ((s = a[0]), d.unshift(a[1]));
                                                    break;
                                                }
                                        if (!0 !== r)
                                            if (r && e.throws) t = r(t);
                                            else
                                                try {
                                                    t = r(t);
                                                } catch (e) {
                                                    return { state: "parsererror", error: r ? e : "No conversion from " + l + " to " + s };
                                                }
                                    }
                            return { state: "success", data: t };
                        })(h, w, S, u)),
                        u
                            ? (h.ifModified && ((T = S.getResponseHeader("Last-Modified")) && (x.lastModified[o] = T), (T = S.getResponseHeader("etag")) && (x.etag[o] = T)),
                              204 === t || "HEAD" === h.type ? (C = "nocontent") : 304 === t ? (C = "notmodified") : ((C = w.state), (p = w.data), (u = !(g = w.error))))
                            : ((g = C), (!t && C) || ((C = "error"), t < 0 && (t = 0))),
                        (S.status = t),
                        (S.statusText = (n || C) + ""),
                        u ? v.resolveWith(f, [p, C, S]) : v.rejectWith(f, [S, C, g]),
                        S.statusCode(b),
                        (b = void 0),
                        d && m.trigger(u ? "ajaxSuccess" : "ajaxError", [S, h, u ? p : g]),
                        y.fireWith(f, [S, C]),
                        d && (m.trigger("ajaxComplete", [S, h]), --x.active || x.event.trigger("ajaxStop")));
                }
                return S;
            },
            getJSON: function (e, t, n) {
                return x.get(e, t, n, "json");
            },
            getScript: function (e, t) {
                return x.get(e, void 0, t, "script");
            },
        }),
        x.each(["get", "post"], function (e, t) {
            x[t] = function (e, n, i, o) {
                return f(n) && ((o = o || i), (i = n), (n = void 0)), x.ajax(x.extend({ url: e, type: t, dataType: o, data: n, success: i }, x.isPlainObject(e) && e));
            };
        }),
        x.ajaxPrefilter(function (e) {
            var t;
            for (t in e.headers) "content-type" === t.toLowerCase() && (e.contentType = e.headers[t] || "");
        }),
        (x._evalUrl = function (e, t, n) {
            return x.ajax({
                url: e,
                type: "GET",
                dataType: "script",
                cache: !0,
                async: !1,
                global: !1,
                converters: { "text script": function () {} },
                dataFilter: function (e) {
                    x.globalEval(e, t, n);
                },
            });
        }),
        x.fn.extend({
            wrapAll: function (e) {
                var t;
                return (
                    this[0] &&
                        (f(e) && (e = e.call(this[0])),
                        (t = x(e, this[0].ownerDocument).eq(0).clone(!0)),
                        this[0].parentNode && t.insertBefore(this[0]),
                        t
                            .map(function () {
                                for (var e = this; e.firstElementChild; ) e = e.firstElementChild;
                                return e;
                            })
                            .append(this)),
                    this
                );
            },
            wrapInner: function (e) {
                return f(e)
                    ? this.each(function (t) {
                          x(this).wrapInner(e.call(this, t));
                      })
                    : this.each(function () {
                          var t = x(this),
                              n = t.contents();
                          n.length ? n.wrapAll(e) : t.append(e);
                      });
            },
            wrap: function (e) {
                var t = f(e);
                return this.each(function (n) {
                    x(this).wrapAll(t ? e.call(this, n) : e);
                });
            },
            unwrap: function (e) {
                return (
                    this.parent(e)
                        .not("body")
                        .each(function () {
                            x(this).replaceWith(this.childNodes);
                        }),
                    this
                );
            },
        }),
        (x.expr.pseudos.hidden = function (e) {
            return !x.expr.pseudos.visible(e);
        }),
        (x.expr.pseudos.visible = function (e) {
            return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length);
        }),
        (x.ajaxSettings.xhr = function () {
            try {
                return new e.XMLHttpRequest();
            } catch (e) {}
        });
    var Wt = { 0: 200, 1223: 204 },
        Bt = x.ajaxSettings.xhr();
    (h.cors = !!Bt && "withCredentials" in Bt),
        (h.ajax = Bt = !!Bt),
        x.ajaxTransport(function (t) {
            var n, i;
            if (h.cors || (Bt && !t.crossDomain))
                return {
                    send: function (o, s) {
                        var r,
                            a = t.xhr();
                        if ((a.open(t.type, t.url, t.async, t.username, t.password), t.xhrFields)) for (r in t.xhrFields) a[r] = t.xhrFields[r];
                        for (r in (t.mimeType && a.overrideMimeType && a.overrideMimeType(t.mimeType), t.crossDomain || o["X-Requested-With"] || (o["X-Requested-With"] = "XMLHttpRequest"), o)) a.setRequestHeader(r, o[r]);
                        (n = function (e) {
                            return function () {
                                n &&
                                    ((n = i = a.onload = a.onerror = a.onabort = a.ontimeout = a.onreadystatechange = null),
                                    "abort" === e
                                        ? a.abort()
                                        : "error" === e
                                        ? "number" != typeof a.status
                                            ? s(0, "error")
                                            : s(a.status, a.statusText)
                                        : s(Wt[a.status] || a.status, a.statusText, "text" !== (a.responseType || "text") || "string" != typeof a.responseText ? { binary: a.response } : { text: a.responseText }, a.getAllResponseHeaders()));
                            };
                        }),
                            (a.onload = n()),
                            (i = a.onerror = a.ontimeout = n("error")),
                            void 0 !== a.onabort
                                ? (a.onabort = i)
                                : (a.onreadystatechange = function () {
                                      4 === a.readyState &&
                                          e.setTimeout(function () {
                                              n && i();
                                          });
                                  }),
                            (n = n("abort"));
                        try {
                            a.send((t.hasContent && t.data) || null);
                        } catch (o) {
                            if (n) throw o;
                        }
                    },
                    abort: function () {
                        n && n();
                    },
                };
        }),
        x.ajaxPrefilter(function (e) {
            e.crossDomain && (e.contents.script = !1);
        }),
        x.ajaxSetup({
            accepts: { script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript" },
            contents: { script: /\b(?:java|ecma)script\b/ },
            converters: {
                "text script": function (e) {
                    return x.globalEval(e), e;
                },
            },
        }),
        x.ajaxPrefilter("script", function (e) {
            void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = "GET");
        }),
        x.ajaxTransport("script", function (e) {
            var t, n;
            if (e.crossDomain || e.scriptAttrs)
                return {
                    send: function (i, o) {
                        (t = x("<script>")
                            .attr(e.scriptAttrs || {})
                            .prop({ charset: e.scriptCharset, src: e.url })
                            .on(
                                "load error",
                                (n = function (e) {
                                    t.remove(), (n = null), e && o("error" === e.type ? 404 : 200, e.type);
                                })
                            )),
                            g.head.appendChild(t[0]);
                    },
                    abort: function () {
                        n && n();
                    },
                };
        });
    var Vt,
        Ut = [],
        Gt = /(=)\?(?=&|$)|\?\?/;
    x.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function () {
            var e = Ut.pop() || x.expando + "_" + Ct.guid++;
            return (this[e] = !0), e;
        },
    }),
        x.ajaxPrefilter("json jsonp", function (t, n, i) {
            var o,
                s,
                r,
                a = !1 !== t.jsonp && (Gt.test(t.url) ? "url" : "string" == typeof t.data && 0 === (t.contentType || "").indexOf("application/x-www-form-urlencoded") && Gt.test(t.data) && "data");
            if (a || "jsonp" === t.dataTypes[0])
                return (
                    (o = t.jsonpCallback = f(t.jsonpCallback) ? t.jsonpCallback() : t.jsonpCallback),
                    a ? (t[a] = t[a].replace(Gt, "$1" + o)) : !1 !== t.jsonp && (t.url += (St.test(t.url) ? "&" : "?") + t.jsonp + "=" + o),
                    (t.converters["script json"] = function () {
                        return r || x.error(o + " was not called"), r[0];
                    }),
                    (t.dataTypes[0] = "json"),
                    (s = e[o]),
                    (e[o] = function () {
                        r = arguments;
                    }),
                    i.always(function () {
                        void 0 === s ? x(e).removeProp(o) : (e[o] = s), t[o] && ((t.jsonpCallback = n.jsonpCallback), Ut.push(o)), r && f(s) && s(r[0]), (r = s = void 0);
                    }),
                    "script"
                );
        }),
        (h.createHTMLDocument = (((Vt = g.implementation.createHTMLDocument("").body).innerHTML = "<form></form><form></form>"), 2 === Vt.childNodes.length)),
        (x.parseHTML = function (e, t, n) {
            return "string" != typeof e
                ? []
                : ("boolean" == typeof t && ((n = t), (t = !1)),
                  t || (h.createHTMLDocument ? (((i = (t = g.implementation.createHTMLDocument("")).createElement("base")).href = g.location.href), t.head.appendChild(i)) : (t = g)),
                  (s = !n && []),
                  (o = E.exec(e)) ? [t.createElement(o[1])] : ((o = be([e], t, s)), s && s.length && x(s).remove(), x.merge([], o.childNodes)));
            var i, o, s;
        }),
        (x.fn.load = function (e, t, n) {
            var i,
                o,
                s,
                r = this,
                a = e.indexOf(" ");
            return (
                -1 < a && ((i = gt(e.slice(a))), (e = e.slice(0, a))),
                f(t) ? ((n = t), (t = void 0)) : t && "object" == typeof t && (o = "POST"),
                0 < r.length &&
                    x
                        .ajax({ url: e, type: o || "GET", dataType: "html", data: t })
                        .done(function (e) {
                            (s = arguments), r.html(i ? x("<div>").append(x.parseHTML(e)).find(i) : e);
                        })
                        .always(
                            n &&
                                function (e, t) {
                                    r.each(function () {
                                        n.apply(this, s || [e.responseText, t, e]);
                                    });
                                }
                        ),
                this
            );
        }),
        (x.expr.pseudos.animated = function (e) {
            return x.grep(x.timers, function (t) {
                return e === t.elem;
            }).length;
        }),
        (x.offset = {
            setOffset: function (e, t, n) {
                var i,
                    o,
                    s,
                    r,
                    a,
                    l,
                    c = x.css(e, "position"),
                    d = x(e),
                    u = {};
                "static" === c && (e.style.position = "relative"),
                    (a = d.offset()),
                    (s = x.css(e, "top")),
                    (l = x.css(e, "left")),
                    ("absolute" === c || "fixed" === c) && -1 < (s + l).indexOf("auto") ? ((r = (i = d.position()).top), (o = i.left)) : ((r = parseFloat(s) || 0), (o = parseFloat(l) || 0)),
                    f(t) && (t = t.call(e, n, x.extend({}, a))),
                    null != t.top && (u.top = t.top - a.top + r),
                    null != t.left && (u.left = t.left - a.left + o),
                    "using" in t ? t.using.call(e, u) : ("number" == typeof u.top && (u.top += "px"), "number" == typeof u.left && (u.left += "px"), d.css(u));
            },
        }),
        x.fn.extend({
            offset: function (e) {
                if (arguments.length)
                    return void 0 === e
                        ? this
                        : this.each(function (t) {
                              x.offset.setOffset(this, e, t);
                          });
                var t,
                    n,
                    i = this[0];
                return i ? (i.getClientRects().length ? ((t = i.getBoundingClientRect()), (n = i.ownerDocument.defaultView), { top: t.top + n.pageYOffset, left: t.left + n.pageXOffset }) : { top: 0, left: 0 }) : void 0;
            },
            position: function () {
                if (this[0]) {
                    var e,
                        t,
                        n,
                        i = this[0],
                        o = { top: 0, left: 0 };
                    if ("fixed" === x.css(i, "position")) t = i.getBoundingClientRect();
                    else {
                        for (t = this.offset(), n = i.ownerDocument, e = i.offsetParent || n.documentElement; e && (e === n.body || e === n.documentElement) && "static" === x.css(e, "position"); ) e = e.parentNode;
                        e && e !== i && 1 === e.nodeType && (((o = x(e).offset()).top += x.css(e, "borderTopWidth", !0)), (o.left += x.css(e, "borderLeftWidth", !0)));
                    }
                    return { top: t.top - o.top - x.css(i, "marginTop", !0), left: t.left - o.left - x.css(i, "marginLeft", !0) };
                }
            },
            offsetParent: function () {
                return this.map(function () {
                    for (var e = this.offsetParent; e && "static" === x.css(e, "position"); ) e = e.offsetParent;
                    return e || ie;
                });
            },
        }),
        x.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function (e, t) {
            var n = "pageYOffset" === t;
            x.fn[e] = function (i) {
                return F(
                    this,
                    function (e, i, o) {
                        var s;
                        if ((m(e) ? (s = e) : 9 === e.nodeType && (s = e.defaultView), void 0 === o)) return s ? s[t] : e[i];
                        s ? s.scrollTo(n ? s.pageXOffset : o, n ? o : s.pageYOffset) : (e[i] = o);
                    },
                    e,
                    i,
                    arguments.length
                );
            };
        }),
        x.each(["top", "left"], function (e, t) {
            x.cssHooks[t] = Fe(h.pixelPosition, function (e, n) {
                if (n) return (n = qe(e, t)), Ne.test(n) ? x(e).position()[t] + "px" : n;
            });
        }),
        x.each({ Height: "height", Width: "width" }, function (e, t) {
            x.each({ padding: "inner" + e, content: t, "": "outer" + e }, function (n, i) {
                x.fn[i] = function (o, s) {
                    var r = arguments.length && (n || "boolean" != typeof o),
                        a = n || (!0 === o || !0 === s ? "margin" : "border");
                    return F(
                        this,
                        function (t, n, o) {
                            var s;
                            return m(t)
                                ? 0 === i.indexOf("outer")
                                    ? t["inner" + e]
                                    : t.document.documentElement["client" + e]
                                : 9 === t.nodeType
                                ? ((s = t.documentElement), Math.max(t.body["scroll" + e], s["scroll" + e], t.body["offset" + e], s["offset" + e], s["client" + e]))
                                : void 0 === o
                                ? x.css(t, n, a)
                                : x.style(t, n, o, a);
                        },
                        t,
                        r ? o : void 0,
                        r
                    );
                };
            });
        }),
        x.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function (e, t) {
            x.fn[t] = function (e) {
                return this.on(t, e);
            };
        }),
        x.fn.extend({
            bind: function (e, t, n) {
                return this.on(e, null, t, n);
            },
            unbind: function (e, t) {
                return this.off(e, null, t);
            },
            delegate: function (e, t, n, i) {
                return this.on(t, e, n, i);
            },
            undelegate: function (e, t, n) {
                return 1 === arguments.length ? this.off(e, "**") : this.off(t, e || "**", n);
            },
            hover: function (e, t) {
                return this.mouseenter(e).mouseleave(t || e);
            },
        }),
        x.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function (e, t) {
            x.fn[t] = function (e, n) {
                return 0 < arguments.length ? this.on(t, null, e, n) : this.trigger(t);
            };
        });
    var Xt = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
    (x.proxy = function (e, t) {
        var n, i, s;
        if (("string" == typeof t && ((n = e[t]), (t = e), (e = n)), f(e)))
            return (
                (i = o.call(arguments, 2)),
                ((s = function () {
                    return e.apply(t || this, i.concat(o.call(arguments)));
                }).guid = e.guid = e.guid || x.guid++),
                s
            );
    }),
        (x.holdReady = function (e) {
            e ? x.readyWait++ : x.ready(!0);
        }),
        (x.isArray = Array.isArray),
        (x.parseJSON = JSON.parse),
        (x.nodeName = _),
        (x.isFunction = f),
        (x.isWindow = m),
        (x.camelCase = U),
        (x.type = b),
        (x.now = Date.now),
        (x.isNumeric = function (e) {
            var t = x.type(e);
            return ("number" === t || "string" === t) && !isNaN(e - parseFloat(e));
        }),
        (x.trim = function (e) {
            return null == e ? "" : (e + "").replace(Xt, "");
        }),
        "function" == typeof define &&
            define.amd &&
            define("jquery", [], function () {
                return x;
            });
    var Yt = e.jQuery,
        Kt = e.$;
    return (
        (x.noConflict = function (t) {
            return e.$ === x && (e.$ = Kt), t && e.jQuery === x && (e.jQuery = Yt), x;
        }),
        void 0 === t && (e.jQuery = e.$ = x),
        x
    );
}),
    (function (e, t) {
        "use strict";
        "object" == ("undefined" == typeof module ? "undefined" : _typeof(module)) && "object" == _typeof(module.exports)
            ? (module.exports = e.document
                  ? t(e, !0)
                  : function (e) {
                        if (!e.document) throw new Error("jQuery requires a window with a document");
                        return t(e);
                    })
            : t(e);
    })("undefined" != typeof window ? window : this, function (e, t) {
        "use strict";
        function n(e) {
            return null != e && e === e.window;
        }
        var i = [],
            o = Object.getPrototypeOf,
            s = i.slice,
            r = i.flat
                ? function (e) {
                      return i.flat.call(e);
                  }
                : function (e) {
                      return i.concat.apply([], e);
                  },
            a = i.push,
            l = i.indexOf,
            c = {},
            d = c.toString,
            u = c.hasOwnProperty,
            p = u.toString,
            h = p.call(Object),
            f = {},
            m = function (e) {
                return "function" == typeof e && "number" != typeof e.nodeType;
            },
            g = e.document,
            v = { type: !0, src: !0, nonce: !0, noModule: !0 };
        function y(e, t, n) {
            var i,
                o,
                s = (n = n || g).createElement("script");
            if (((s.text = e), t)) for (i in v) (o = t[i] || (t.getAttribute && t.getAttribute(i))) && s.setAttribute(i, o);
            n.head.appendChild(s).parentNode.removeChild(s);
        }
        function b(e) {
            return null == e ? e + "" : "object" == _typeof(e) || "function" == typeof e ? c[d.call(e)] || "object" : _typeof(e);
        }
        var w = "3.5.1",
            x = function e(t, n) {
                return new e.fn.init(t, n);
            };
        function T(e) {
            var t = !!e && "length" in e && e.length,
                i = b(e);
            return !m(e) && !n(e) && ("array" === i || 0 === t || ("number" == typeof t && 0 < t && t - 1 in e));
        }
        (x.fn = x.prototype = {
            jquery: w,
            constructor: x,
            length: 0,
            toArray: function () {
                return s.call(this);
            },
            get: function (e) {
                return null == e ? s.call(this) : e < 0 ? this[e + this.length] : this[e];
            },
            pushStack: function (e) {
                return ((e = x.merge(this.constructor(), e)).prevObject = this), e;
            },
            each: function (e) {
                return x.each(this, e);
            },
            map: function (e) {
                return this.pushStack(
                    x.map(this, function (t, n) {
                        return e.call(t, n, t);
                    })
                );
            },
            slice: function () {
                return this.pushStack(s.apply(this, arguments));
            },
            first: function () {
                return this.eq(0);
            },
            last: function () {
                return this.eq(-1);
            },
            even: function () {
                return this.pushStack(
                    x.grep(this, function (e, t) {
                        return (t + 1) % 2;
                    })
                );
            },
            odd: function () {
                return this.pushStack(
                    x.grep(this, function (e, t) {
                        return t % 2;
                    })
                );
            },
            eq: function (e) {
                var t = this.length;
                return (e = +e + (e < 0 ? t : 0)), this.pushStack(0 <= e && e < t ? [this[e]] : []);
            },
            end: function () {
                return this.prevObject || this.constructor();
            },
            push: a,
            sort: i.sort,
            splice: i.splice,
        }),
            (x.extend = x.fn.extend = function () {
                var e,
                    t,
                    n,
                    i,
                    o,
                    s = arguments[0] || {},
                    r = 1,
                    a = arguments.length,
                    l = !1;
                for ("boolean" == typeof s && ((l = s), (s = arguments[r] || {}), r++), "object" == _typeof(s) || m(s) || (s = {}), r === a && ((s = this), r--); r < a; r++)
                    if (null != (e = arguments[r]))
                        for (t in e)
                            (n = e[t]),
                                "__proto__" !== t &&
                                    s !== n &&
                                    (l && n && (x.isPlainObject(n) || (i = Array.isArray(n)))
                                        ? ((o = s[t]), (o = i && !Array.isArray(o) ? [] : i || x.isPlainObject(o) ? o : {}), (i = !1), (s[t] = x.extend(l, o, n)))
                                        : void 0 !== n && (s[t] = n));
                return s;
            }),
            x.extend({
                expando: "jQuery" + (w + Math.random()).replace(/\D/g, ""),
                isReady: !0,
                error: function (e) {
                    throw new Error(e);
                },
                noop: function () {},
                isPlainObject: function (e) {
                    return !(!e || "[object Object]" !== d.call(e) || ((e = o(e)) && ("function" != typeof (e = u.call(e, "constructor") && e.constructor) || p.call(e) !== h)));
                },
                isEmptyObject: function (e) {
                    for (var t in e) return !1;
                    return !0;
                },
                globalEval: function (e, t, n) {
                    y(e, { nonce: t && t.nonce }, n);
                },
                each: function (e, t) {
                    var n,
                        i = 0;
                    if (T(e)) for (n = e.length; i < n && !1 !== t.call(e[i], i, e[i]); i++);
                    else for (i in e) if (!1 === t.call(e[i], i, e[i])) break;
                    return e;
                },
                makeArray: function (e, t) {
                    return (t = t || []), null != e && (T(Object(e)) ? x.merge(t, "string" == typeof e ? [e] : e) : a.call(t, e)), t;
                },
                inArray: function (e, t, n) {
                    return null == t ? -1 : l.call(t, e, n);
                },
                merge: function (e, t) {
                    for (var n = +t.length, i = 0, o = e.length; i < n; i++) e[o++] = t[i];
                    return (e.length = o), e;
                },
                grep: function (e, t, n) {
                    for (var i = [], o = 0, s = e.length, r = !n; o < s; o++) !t(e[o], o) != r && i.push(e[o]);
                    return i;
                },
                map: function (e, t, n) {
                    var i,
                        o,
                        s = 0,
                        a = [];
                    if (T(e)) for (i = e.length; s < i; s++) null != (o = t(e[s], s, n)) && a.push(o);
                    else for (s in e) null != (o = t(e[s], s, n)) && a.push(o);
                    return r(a);
                },
                guid: 1,
                support: f,
            }),
            "function" == typeof Symbol && (x.fn[Symbol.iterator] = i[Symbol.iterator]),
            x.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function (e, t) {
                c["[object " + t + "]"] = t.toLowerCase();
            });
        var C = (function (e) {
            function t(e, t) {
                return (e = "0x" + e.slice(1) - 65536), t || (e < 0 ? String.fromCharCode(65536 + e) : String.fromCharCode((e >> 10) | 55296, (1023 & e) | 56320));
            }
            function n() {
                f();
            }
            var i,
                o,
                s,
                r,
                a,
                l,
                c,
                d,
                u,
                p,
                h,
                f,
                m,
                g,
                v,
                y,
                b,
                w,
                x,
                T = "sizzle" + +new Date(),
                C = e.document,
                S = 0,
                k = 0,
                $ = le(),
                _ = le(),
                E = le(),
                A = le(),
                M = function (e, t) {
                    return e === t && (h = !0), 0;
                },
                P = {}.hasOwnProperty,
                L = [],
                D = L.pop,
                O = L.push,
                z = L.push,
                I = L.slice,
                N = function (e, t) {
                    for (var n = 0, i = e.length; n < i; n++) if (e[n] === t) return n;
                    return -1;
                },
                j = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
                R = "[\\x20\\t\\r\\n\\f]",
                H = "(?:\\\\[\\da-fA-F]{1,6}" + R + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
                q = "\\[" + R + "*(" + H + ")(?:" + R + "*([*^$|!~]?=)" + R + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + H + "))|)" + R + "*\\]",
                F = ":(" + H + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + q + ")*)|.*)\\)|)",
                W = new RegExp(R + "+", "g"),
                B = new RegExp("^" + R + "+|((?:^|[^\\\\])(?:\\\\.)*)" + R + "+$", "g"),
                V = new RegExp("^" + R + "*," + R + "*"),
                U = new RegExp("^" + R + "*([>+~]|" + R + ")" + R + "*"),
                G = new RegExp(R + "|>"),
                X = new RegExp(F),
                Y = new RegExp("^" + H + "$"),
                K = {
                    ID: new RegExp("^#(" + H + ")"),
                    CLASS: new RegExp("^\\.(" + H + ")"),
                    TAG: new RegExp("^(" + H + "|[*])"),
                    ATTR: new RegExp("^" + q),
                    PSEUDO: new RegExp("^" + F),
                    CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + R + "*(even|odd|(([+-]|)(\\d*)n|)" + R + "*(?:([+-]|)" + R + "*(\\d+)|))" + R + "*\\)|)", "i"),
                    bool: new RegExp("^(?:" + j + ")$", "i"),
                    needsContext: new RegExp("^" + R + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + R + "*((?:-\\d)?\\d*)" + R + "*\\)|)(?=[^-]|$)", "i"),
                },
                Z = /HTML$/i,
                Q = /^(?:input|select|textarea|button)$/i,
                J = /^h\d$/i,
                ee = /^[^{]+\{\s*\[native \w/,
                te = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
                ne = /[+~]/,
                ie = new RegExp("\\\\[\\da-fA-F]{1,6}" + R + "?|\\\\([^\\r\\n\\f])", "g"),
                oe = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
                se = function (e, t) {
                    return t ? ("\0" === e ? "�" : e.slice(0, -1) + "\\" + e.charCodeAt(e.length - 1).toString(16) + " ") : "\\" + e;
                },
                re = ye(
                    function (e) {
                        return !0 === e.disabled && "fieldset" === e.nodeName.toLowerCase();
                    },
                    { dir: "parentNode", next: "legend" }
                );
            try {
                z.apply((L = I.call(C.childNodes)), C.childNodes), L[C.childNodes.length].nodeType;
            } catch (i) {
                z = {
                    apply: L.length
                        ? function (e, t) {
                              O.apply(e, I.call(t));
                          }
                        : function (e, t) {
                              for (var n = e.length, i = 0; (e[n++] = t[i++]); );
                              e.length = n - 1;
                          },
                };
            }
            function ae(e, t, n, i) {
                var s,
                    r,
                    a,
                    c,
                    u,
                    p,
                    h = t && t.ownerDocument,
                    g = t ? t.nodeType : 9;
                if (((n = n || []), "string" != typeof e || !e || (1 !== g && 9 !== g && 11 !== g))) return n;
                if (!i && (f(t), (t = t || m), v)) {
                    if (11 !== g && (c = te.exec(e)))
                        if ((p = c[1])) {
                            if (9 === g) {
                                if (!(r = t.getElementById(p))) return n;
                                if (r.id === p) return n.push(r), n;
                            } else if (h && (r = h.getElementById(p)) && x(t, r) && r.id === p) return n.push(r), n;
                        } else {
                            if (c[2]) return z.apply(n, t.getElementsByTagName(e)), n;
                            if ((p = c[3]) && o.getElementsByClassName && t.getElementsByClassName) return z.apply(n, t.getElementsByClassName(p)), n;
                        }
                    if (o.qsa && !A[e + " "] && (!y || !y.test(e)) && (1 !== g || "object" !== t.nodeName.toLowerCase())) {
                        if (((p = e), (h = t), 1 === g && (G.test(e) || U.test(e)))) {
                            for (((h = (ne.test(e) && me(t.parentNode)) || t) === t && o.scope) || ((a = t.getAttribute("id")) ? (a = a.replace(oe, se)) : t.setAttribute("id", (a = T))), s = (u = l(e)).length; s--; )
                                u[s] = (a ? "#" + a : ":scope") + " " + ve(u[s]);
                            p = u.join(",");
                        }
                        try {
                            return z.apply(n, h.querySelectorAll(p)), n;
                        } catch (t) {
                            A(e, !0);
                        } finally {
                            a === T && t.removeAttribute("id");
                        }
                    }
                }
                return d(e.replace(B, "$1"), t, n, i);
            }
            function le() {
                var e = [];
                return function t(n, i) {
                    return e.push(n + " ") > s.cacheLength && delete t[e.shift()], (t[n + " "] = i);
                };
            }
            function ce(e) {
                return (e[T] = !0), e;
            }
            function de(e) {
                var t = m.createElement("fieldset");
                try {
                    return !!e(t);
                } catch (e) {
                    return !1;
                } finally {
                    t.parentNode && t.parentNode.removeChild(t), (t = null);
                }
            }
            function ue(e, t) {
                for (var n = e.split("|"), i = n.length; i--; ) s.attrHandle[n[i]] = t;
            }
            function pe(e, t) {
                var n = t && e,
                    i = n && 1 === e.nodeType && 1 === t.nodeType && e.sourceIndex - t.sourceIndex;
                if (i) return i;
                if (n) for (; (n = n.nextSibling); ) if (n === t) return -1;
                return e ? 1 : -1;
            }
            function he(e) {
                return function (t) {
                    return "form" in t
                        ? t.parentNode && !1 === t.disabled
                            ? "label" in t
                                ? "label" in t.parentNode
                                    ? t.parentNode.disabled === e
                                    : t.disabled === e
                                : t.isDisabled === e || (t.isDisabled !== !e && re(t) === e)
                            : t.disabled === e
                        : "label" in t && t.disabled === e;
                };
            }
            function fe(e) {
                return ce(function (t) {
                    return (
                        (t = +t),
                        ce(function (n, i) {
                            for (var o, s = e([], n.length, t), r = s.length; r--; ) n[(o = s[r])] && (n[o] = !(i[o] = n[o]));
                        })
                    );
                });
            }
            function me(e) {
                return e && void 0 !== e.getElementsByTagName && e;
            }
            for (i in ((o = ae.support = {}),
            (a = ae.isXML = function (e) {
                var t = e.namespaceURI;
                return (e = (e.ownerDocument || e).documentElement), !Z.test(t || (e && e.nodeName) || "HTML");
            }),
            (f = ae.setDocument = function (e) {
                var i;
                return (
                    (e = e ? e.ownerDocument || e : C) != m &&
                        9 === e.nodeType &&
                        e.documentElement &&
                        ((g = (m = e).documentElement),
                        (v = !a(m)),
                        C != m && (i = m.defaultView) && i.top !== i && (i.addEventListener ? i.addEventListener("unload", n, !1) : i.attachEvent && i.attachEvent("onunload", n)),
                        (o.scope = de(function (e) {
                            return g.appendChild(e).appendChild(m.createElement("div")), void 0 !== e.querySelectorAll && !e.querySelectorAll(":scope fieldset div").length;
                        })),
                        (o.attributes = de(function (e) {
                            return (e.className = "i"), !e.getAttribute("className");
                        })),
                        (o.getElementsByTagName = de(function (e) {
                            return e.appendChild(m.createComment("")), !e.getElementsByTagName("*").length;
                        })),
                        (o.getElementsByClassName = ee.test(m.getElementsByClassName)),
                        (o.getById = de(function (e) {
                            return (g.appendChild(e).id = T), !m.getElementsByName || !m.getElementsByName(T).length;
                        })),
                        o.getById
                            ? ((s.filter.ID = function (e) {
                                  var n = e.replace(ie, t);
                                  return function (e) {
                                      return e.getAttribute("id") === n;
                                  };
                              }),
                              (s.find.ID = function (e, t) {
                                  if (void 0 !== t.getElementById && v) return (e = t.getElementById(e)) ? [e] : [];
                              }))
                            : ((s.filter.ID = function (e) {
                                  var n = e.replace(ie, t);
                                  return function (e) {
                                      return (e = void 0 !== e.getAttributeNode && e.getAttributeNode("id")) && e.value === n;
                                  };
                              }),
                              (s.find.ID = function (e, t) {
                                  if (void 0 !== t.getElementById && v) {
                                      var n,
                                          i,
                                          o,
                                          s = t.getElementById(e);
                                      if (s) {
                                          if ((n = s.getAttributeNode("id")) && n.value === e) return [s];
                                          for (o = t.getElementsByName(e), i = 0; (s = o[i++]); ) if ((n = s.getAttributeNode("id")) && n.value === e) return [s];
                                      }
                                      return [];
                                  }
                              })),
                        (s.find.TAG = o.getElementsByTagName
                            ? function (e, t) {
                                  return void 0 !== t.getElementsByTagName ? t.getElementsByTagName(e) : o.qsa ? t.querySelectorAll(e) : void 0;
                              }
                            : function (e, t) {
                                  var n,
                                      i = [],
                                      o = 0,
                                      s = t.getElementsByTagName(e);
                                  if ("*" !== e) return s;
                                  for (; (n = s[o++]); ) 1 === n.nodeType && i.push(n);
                                  return i;
                              }),
                        (s.find.CLASS =
                            o.getElementsByClassName &&
                            function (e, t) {
                                if (void 0 !== t.getElementsByClassName && v) return t.getElementsByClassName(e);
                            }),
                        (b = []),
                        (y = []),
                        (o.qsa = ee.test(m.querySelectorAll)) &&
                            (de(function (e) {
                                var t;
                                (g.appendChild(e).innerHTML = "<a id='" + T + "'></a><select id='" + T + "-\r\\' msallowcapture=''><option selected=''></option></select>"),
                                    e.querySelectorAll("[msallowcapture^='']").length && y.push("[*^$]=" + R + "*(?:''|\"\")"),
                                    e.querySelectorAll("[selected]").length || y.push("\\[" + R + "*(?:value|" + j + ")"),
                                    e.querySelectorAll("[id~=" + T + "-]").length || y.push("~="),
                                    (t = m.createElement("input")).setAttribute("name", ""),
                                    e.appendChild(t),
                                    e.querySelectorAll("[name='']").length || y.push("\\[" + R + "*name" + R + "*=" + R + "*(?:''|\"\")"),
                                    e.querySelectorAll(":checked").length || y.push(":checked"),
                                    e.querySelectorAll("a#" + T + "+*").length || y.push(".#.+[+~]"),
                                    e.querySelectorAll("\\\f"),
                                    y.push("[\\r\\n\\f]");
                            }),
                            de(function (e) {
                                e.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                                var t = m.createElement("input");
                                t.setAttribute("type", "hidden"),
                                    e.appendChild(t).setAttribute("name", "D"),
                                    e.querySelectorAll("[name=d]").length && y.push("name" + R + "*[*^$|!~]?="),
                                    2 !== e.querySelectorAll(":enabled").length && y.push(":enabled", ":disabled"),
                                    (g.appendChild(e).disabled = !0),
                                    2 !== e.querySelectorAll(":disabled").length && y.push(":enabled", ":disabled"),
                                    e.querySelectorAll("*,:x"),
                                    y.push(",.*:");
                            })),
                        (o.matchesSelector = ee.test((w = g.matches || g.webkitMatchesSelector || g.mozMatchesSelector || g.oMatchesSelector || g.msMatchesSelector))) &&
                            de(function (e) {
                                (o.disconnectedMatch = w.call(e, "*")), w.call(e, "[s!='']:x"), b.push("!=", F);
                            }),
                        (y = y.length && new RegExp(y.join("|"))),
                        (b = b.length && new RegExp(b.join("|"))),
                        (i = ee.test(g.compareDocumentPosition)),
                        (x =
                            i || ee.test(g.contains)
                                ? function (e, t) {
                                      var n = 9 === e.nodeType ? e.documentElement : e;
                                      return e === (t = t && t.parentNode) || !(!t || 1 !== t.nodeType || !(n.contains ? n.contains(t) : e.compareDocumentPosition && 16 & e.compareDocumentPosition(t)));
                                  }
                                : function (e, t) {
                                      if (t) for (; (t = t.parentNode); ) if (t === e) return !0;
                                      return !1;
                                  }),
                        (M = i
                            ? function (e, t) {
                                  if (e === t) return (h = !0), 0;
                                  var n = !e.compareDocumentPosition - !t.compareDocumentPosition;
                                  return (
                                      n ||
                                      (1 & (n = (e.ownerDocument || e) == (t.ownerDocument || t) ? e.compareDocumentPosition(t) : 1) || (!o.sortDetached && t.compareDocumentPosition(e) === n)
                                          ? e == m || (e.ownerDocument == C && x(C, e))
                                              ? -1
                                              : t == m || (t.ownerDocument == C && x(C, t))
                                              ? 1
                                              : p
                                              ? N(p, e) - N(p, t)
                                              : 0
                                          : 4 & n
                                          ? -1
                                          : 1)
                                  );
                              }
                            : function (e, t) {
                                  if (e === t) return (h = !0), 0;
                                  var n,
                                      i = 0,
                                      o = e.parentNode,
                                      s = t.parentNode,
                                      r = [e],
                                      a = [t];
                                  if (!o || !s) return e == m ? -1 : t == m ? 1 : o ? -1 : s ? 1 : p ? N(p, e) - N(p, t) : 0;
                                  if (o === s) return pe(e, t);
                                  for (n = e; (n = n.parentNode); ) r.unshift(n);
                                  for (n = t; (n = n.parentNode); ) a.unshift(n);
                                  for (; r[i] === a[i]; ) i++;
                                  return i ? pe(r[i], a[i]) : r[i] == C ? -1 : a[i] == C ? 1 : 0;
                              })),
                    m
                );
            }),
            (ae.matches = function (e, t) {
                return ae(e, null, null, t);
            }),
            (ae.matchesSelector = function (e, t) {
                if ((f(e), o.matchesSelector && v && !A[t + " "] && (!b || !b.test(t)) && (!y || !y.test(t))))
                    try {
                        var n = w.call(e, t);
                        if (n || o.disconnectedMatch || (e.document && 11 !== e.document.nodeType)) return n;
                    } catch (e) {
                        A(t, !0);
                    }
                return 0 < ae(t, m, null, [e]).length;
            }),
            (ae.contains = function (e, t) {
                return (e.ownerDocument || e) != m && f(e), x(e, t);
            }),
            (ae.attr = function (e, t) {
                var n;
                return (
                    (e.ownerDocument || e) != m && f(e),
                    void 0 !== (n = (n = s.attrHandle[t.toLowerCase()]) && P.call(s.attrHandle, t.toLowerCase()) ? n(e, t, !v) : void 0)
                        ? n
                        : o.attributes || !v
                        ? e.getAttribute(t)
                        : (n = e.getAttributeNode(t)) && n.specified
                        ? n.value
                        : null
                );
            }),
            (ae.escape = function (e) {
                return (e + "").replace(oe, se);
            }),
            (ae.error = function (e) {
                throw new Error("Syntax error, unrecognized expression: " + e);
            }),
            (ae.uniqueSort = function (e) {
                var t,
                    n = [],
                    i = 0,
                    s = 0;
                if (((h = !o.detectDuplicates), (p = !o.sortStable && e.slice(0)), e.sort(M), h)) {
                    for (; (t = e[s++]); ) t === e[s] && (i = n.push(s));
                    for (; i--; ) e.splice(n[i], 1);
                }
                return (p = null), e;
            }),
            (r = ae.getText = function (e) {
                var t,
                    n = "",
                    i = 0,
                    o = e.nodeType;
                if (o) {
                    if (1 === o || 9 === o || 11 === o) {
                        if ("string" == typeof e.textContent) return e.textContent;
                        for (e = e.firstChild; e; e = e.nextSibling) n += r(e);
                    } else if (3 === o || 4 === o) return e.nodeValue;
                } else for (; (t = e[i++]); ) n += r(t);
                return n;
            }),
            ((s = ae.selectors = {
                cacheLength: 50,
                createPseudo: ce,
                match: K,
                attrHandle: {},
                find: {},
                relative: { ">": { dir: "parentNode", first: !0 }, " ": { dir: "parentNode" }, "+": { dir: "previousSibling", first: !0 }, "~": { dir: "previousSibling" } },
                preFilter: {
                    ATTR: function (e) {
                        return (e[1] = e[1].replace(ie, t)), (e[3] = (e[3] || e[4] || e[5] || "").replace(ie, t)), "~=" === e[2] && (e[3] = " " + e[3] + " "), e.slice(0, 4);
                    },
                    CHILD: function (e) {
                        return (
                            (e[1] = e[1].toLowerCase()),
                            "nth" === e[1].slice(0, 3) ? (e[3] || ae.error(e[0]), (e[4] = +(e[4] ? e[5] + (e[6] || 1) : 2 * ("even" === e[3] || "odd" === e[3]))), (e[5] = +(e[7] + e[8] || "odd" === e[3]))) : e[3] && ae.error(e[0]),
                            e
                        );
                    },
                    PSEUDO: function (e) {
                        var t,
                            n = !e[6] && e[2];
                        return K.CHILD.test(e[0])
                            ? null
                            : (e[3] ? (e[2] = e[4] || e[5] || "") : n && X.test(n) && (t = l(n, !0)) && (t = n.indexOf(")", n.length - t) - n.length) && ((e[0] = e[0].slice(0, t)), (e[2] = n.slice(0, t))), e.slice(0, 3));
                    },
                },
                filter: {
                    TAG: function (e) {
                        var n = e.replace(ie, t).toLowerCase();
                        return "*" === e
                            ? function () {
                                  return !0;
                              }
                            : function (e) {
                                  return e.nodeName && e.nodeName.toLowerCase() === n;
                              };
                    },
                    CLASS: function (e) {
                        var t = $[e + " "];
                        return (
                            t ||
                            ((t = new RegExp("(^|" + R + ")" + e + "(" + R + "|$)")) &&
                                $(e, function (e) {
                                    return t.test(("string" == typeof e.className && e.className) || (void 0 !== e.getAttribute && e.getAttribute("class")) || "");
                                }))
                        );
                    },
                    ATTR: function (e, t, n) {
                        return function (i) {
                            return null == (i = ae.attr(i, e))
                                ? "!=" === t
                                : !t ||
                                      ((i += ""),
                                      "=" === t
                                          ? i === n
                                          : "!=" === t
                                          ? i !== n
                                          : "^=" === t
                                          ? n && 0 === i.indexOf(n)
                                          : "*=" === t
                                          ? n && -1 < i.indexOf(n)
                                          : "$=" === t
                                          ? n && i.slice(-n.length) === n
                                          : "~=" === t
                                          ? -1 < (" " + i.replace(W, " ") + " ").indexOf(n)
                                          : "|=" === t && (i === n || i.slice(0, n.length + 1) === n + "-"));
                        };
                    },
                    CHILD: function (e, t, n, i, o) {
                        var s = "nth" !== e.slice(0, 3),
                            r = "last" !== e.slice(-4),
                            a = "of-type" === t;
                        return 1 === i && 0 === o
                            ? function (e) {
                                  return !!e.parentNode;
                              }
                            : function (t, n, l) {
                                  var c,
                                      d,
                                      u,
                                      p,
                                      h,
                                      f,
                                      m = s != r ? "nextSibling" : "previousSibling",
                                      g = t.parentNode,
                                      v = a && t.nodeName.toLowerCase(),
                                      y = !l && !a,
                                      b = !1;
                                  if (g) {
                                      if (s) {
                                          for (; m; ) {
                                              for (p = t; (p = p[m]); ) if (a ? p.nodeName.toLowerCase() === v : 1 === p.nodeType) return !1;
                                              f = m = "only" === e && !f && "nextSibling";
                                          }
                                          return !0;
                                      }
                                      if (((f = [r ? g.firstChild : g.lastChild]), r && y)) {
                                          for (
                                              b = (h = (c = (d = (u = (p = g)[T] || (p[T] = {}))[p.uniqueID] || (u[p.uniqueID] = {}))[e] || [])[0] === S && c[1]) && c[2], p = h && g.childNodes[h];
                                              (p = (++h && p && p[m]) || (b = h = 0) || f.pop());

                                          )
                                              if (1 === p.nodeType && ++b && p === t) {
                                                  d[e] = [S, h, b];
                                                  break;
                                              }
                                      } else if (!1 === (b = y ? (h = (c = (d = (u = (p = t)[T] || (p[T] = {}))[p.uniqueID] || (u[p.uniqueID] = {}))[e] || [])[0] === S && c[1]) : b))
                                          for (
                                              ;
                                              (p = (++h && p && p[m]) || (b = h = 0) || f.pop()) &&
                                              ((a ? p.nodeName.toLowerCase() !== v : 1 !== p.nodeType) || !++b || (y && ((d = (u = p[T] || (p[T] = {}))[p.uniqueID] || (u[p.uniqueID] = {}))[e] = [S, b]), p !== t));

                                          );
                                      return (b -= o) === i || (b % i == 0 && 0 <= b / i);
                                  }
                              };
                    },
                    PSEUDO: function (e, t) {
                        var n,
                            i = s.pseudos[e] || s.setFilters[e.toLowerCase()] || ae.error("unsupported pseudo: " + e);
                        return i[T]
                            ? i(t)
                            : 1 < i.length
                            ? ((n = [e, e, "", t]),
                              s.setFilters.hasOwnProperty(e.toLowerCase())
                                  ? ce(function (e, n) {
                                        for (var o, s = i(e, t), r = s.length; r--; ) e[(o = N(e, s[r]))] = !(n[o] = s[r]);
                                    })
                                  : function (e) {
                                        return i(e, 0, n);
                                    })
                            : i;
                    },
                },
                pseudos: {
                    not: ce(function (e) {
                        var t = [],
                            n = [],
                            i = c(e.replace(B, "$1"));
                        return i[T]
                            ? ce(function (e, t, n, o) {
                                  for (var s, r = i(e, null, o, []), a = e.length; a--; ) (s = r[a]) && (e[a] = !(t[a] = s));
                              })
                            : function (e, o, s) {
                                  return (t[0] = e), i(t, null, s, n), (t[0] = null), !n.pop();
                              };
                    }),
                    has: ce(function (e) {
                        return function (t) {
                            return 0 < ae(e, t).length;
                        };
                    }),
                    contains: ce(function (e) {
                        return (
                            (e = e.replace(ie, t)),
                            function (t) {
                                return -1 < (t.textContent || r(t)).indexOf(e);
                            }
                        );
                    }),
                    lang: ce(function (e) {
                        return (
                            Y.test(e || "") || ae.error("unsupported lang: " + e),
                            (e = e.replace(ie, t).toLowerCase()),
                            function (t) {
                                var n;
                                do {
                                    if ((n = v ? t.lang : t.getAttribute("xml:lang") || t.getAttribute("lang"))) return (n = n.toLowerCase()) === e || 0 === n.indexOf(e + "-");
                                } while ((t = t.parentNode) && 1 === t.nodeType);
                                return !1;
                            }
                        );
                    }),
                    target: function (t) {
                        var n = e.location && e.location.hash;
                        return n && n.slice(1) === t.id;
                    },
                    root: function (e) {
                        return e === g;
                    },
                    focus: function (e) {
                        return e === m.activeElement && (!m.hasFocus || m.hasFocus()) && !!(e.type || e.href || ~e.tabIndex);
                    },
                    enabled: he(!1),
                    disabled: he(!0),
                    checked: function (e) {
                        var t = e.nodeName.toLowerCase();
                        return ("input" === t && !!e.checked) || ("option" === t && !!e.selected);
                    },
                    selected: function (e) {
                        return e.parentNode && e.parentNode.selectedIndex, !0 === e.selected;
                    },
                    empty: function (e) {
                        for (e = e.firstChild; e; e = e.nextSibling) if (e.nodeType < 6) return !1;
                        return !0;
                    },
                    parent: function (e) {
                        return !s.pseudos.empty(e);
                    },
                    header: function (e) {
                        return J.test(e.nodeName);
                    },
                    input: function (e) {
                        return Q.test(e.nodeName);
                    },
                    button: function (e) {
                        var t = e.nodeName.toLowerCase();
                        return ("input" === t && "button" === e.type) || "button" === t;
                    },
                    text: function (e) {
                        return "input" === e.nodeName.toLowerCase() && "text" === e.type && (null == (e = e.getAttribute("type")) || "text" === e.toLowerCase());
                    },
                    first: fe(function () {
                        return [0];
                    }),
                    last: fe(function (e, t) {
                        return [t - 1];
                    }),
                    eq: fe(function (e, t, n) {
                        return [n < 0 ? n + t : n];
                    }),
                    even: fe(function (e, t) {
                        for (var n = 0; n < t; n += 2) e.push(n);
                        return e;
                    }),
                    odd: fe(function (e, t) {
                        for (var n = 1; n < t; n += 2) e.push(n);
                        return e;
                    }),
                    lt: fe(function (e, t, n) {
                        for (var i = n < 0 ? n + t : t < n ? t : n; 0 <= --i; ) e.push(i);
                        return e;
                    }),
                    gt: fe(function (e, t, n) {
                        for (var i = n < 0 ? n + t : n; ++i < t; ) e.push(i);
                        return e;
                    }),
                },
            }).pseudos.nth = s.pseudos.eq),
            { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 }))
                s.pseudos[i] = (function (e) {
                    return function (t) {
                        return "input" === t.nodeName.toLowerCase() && t.type === e;
                    };
                })(i);
            for (i in { submit: !0, reset: !0 })
                s.pseudos[i] = (function (e) {
                    return function (t) {
                        var n = t.nodeName.toLowerCase();
                        return ("input" === n || "button" === n) && t.type === e;
                    };
                })(i);
            function ge() {}
            function ve(e) {
                for (var t = 0, n = e.length, i = ""; t < n; t++) i += e[t].value;
                return i;
            }
            function ye(e, t, n) {
                var i = t.dir,
                    o = t.next,
                    s = o || i,
                    r = n && "parentNode" === s,
                    a = k++;
                return t.first
                    ? function (t, n, o) {
                          for (; (t = t[i]); ) if (1 === t.nodeType || r) return e(t, n, o);
                          return !1;
                      }
                    : function (t, n, l) {
                          var c,
                              d,
                              u = [S, a];
                          if (l) {
                              for (; (t = t[i]); ) if ((1 === t.nodeType || r) && e(t, n, l)) return !0;
                          } else
                              for (; (t = t[i]); )
                                  if (1 === t.nodeType || r)
                                      if (((c = (d = t[T] || (t[T] = {}))[t.uniqueID] || (d[t.uniqueID] = {})), o && o === t.nodeName.toLowerCase())) t = t[i] || t;
                                      else {
                                          if ((d = c[s]) && d[0] === S && d[1] === a) return (u[2] = d[2]);
                                          if (((c[s] = u)[2] = e(t, n, l))) return !0;
                                      }
                          return !1;
                      };
            }
            function be(e) {
                return 1 < e.length
                    ? function (t, n, i) {
                          for (var o = e.length; o--; ) if (!e[o](t, n, i)) return !1;
                          return !0;
                      }
                    : e[0];
            }
            function we(e, t, n, i, o) {
                for (var s, r = [], a = 0, l = e.length, c = null != t; a < l; a++) (s = e[a]) && ((n && !n(s, i, o)) || (r.push(s), c && t.push(a)));
                return r;
            }
            function xe(e) {
                for (
                    var t,
                        n,
                        i,
                        o = e.length,
                        r = s.relative[e[0].type],
                        a = r || s.relative[" "],
                        l = r ? 1 : 0,
                        c = ye(
                            function (e) {
                                return e === t;
                            },
                            a,
                            !0
                        ),
                        d = ye(
                            function (e) {
                                return -1 < N(t, e);
                            },
                            a,
                            !0
                        ),
                        p = [
                            function (e, n, i) {
                                return (i = (!r && (i || n !== u)) || ((t = n).nodeType ? c : d)(e, n, i)), (t = null), i;
                            },
                        ];
                    l < o;
                    l++
                )
                    if ((n = s.relative[e[l].type])) p = [ye(be(p), n)];
                    else {
                        if ((n = s.filter[e[l].type].apply(null, e[l].matches))[T]) {
                            for (i = ++l; i < o && !s.relative[e[i].type]; i++);
                            return (function e(t, n, i, o, s, r) {
                                return (
                                    o && !o[T] && (o = e(o)),
                                    s && !s[T] && (s = e(s, r)),
                                    ce(function (e, r, a, l) {
                                        var c,
                                            d,
                                            u,
                                            p = [],
                                            h = [],
                                            f = r.length,
                                            m =
                                                e ||
                                                (function (e, t, n) {
                                                    for (var i = 0, o = t.length; i < o; i++) ae(e, t[i], n);
                                                    return n;
                                                })(n || "*", a.nodeType ? [a] : a, []),
                                            g = !t || (!e && n) ? m : we(m, p, t, a, l),
                                            v = i ? (s || (e ? t : f || o) ? [] : r) : g;
                                        if ((i && i(g, v, a, l), o)) for (c = we(v, h), o(c, [], a, l), d = c.length; d--; ) (u = c[d]) && (v[h[d]] = !(g[h[d]] = u));
                                        if (e) {
                                            if (s || t) {
                                                if (s) {
                                                    for (c = [], d = v.length; d--; ) (u = v[d]) && c.push((g[d] = u));
                                                    s(null, (v = []), c, l);
                                                }
                                                for (d = v.length; d--; ) (u = v[d]) && -1 < (c = s ? N(e, u) : p[d]) && (e[c] = !(r[c] = u));
                                            }
                                        } else (v = we(v === r ? v.splice(f, v.length) : v)), s ? s(null, r, v, l) : z.apply(r, v);
                                    })
                                );
                            })(1 < l && be(p), 1 < l && ve(e.slice(0, l - 1).concat({ value: " " === e[l - 2].type ? "*" : "" })).replace(B, "$1"), n, l < i && xe(e.slice(l, i)), i < o && xe((e = e.slice(i))), i < o && ve(e));
                        }
                        p.push(n);
                    }
                return be(p);
            }
            return (
                (ge.prototype = s.filters = s.pseudos),
                (s.setFilters = new ge()),
                (l = ae.tokenize = function (e, t) {
                    var n,
                        i,
                        o,
                        r,
                        a,
                        l,
                        c,
                        d = _[e + " "];
                    if (d) return t ? 0 : d.slice(0);
                    for (a = e, l = [], c = s.preFilter; a; ) {
                        for (r in ((n && !(i = V.exec(a))) || (i && (a = a.slice(i[0].length) || a), l.push((o = []))),
                        (n = !1),
                        (i = U.exec(a)) && ((n = i.shift()), o.push({ value: n, type: i[0].replace(B, " ") }), (a = a.slice(n.length))),
                        s.filter))
                            !(i = K[r].exec(a)) || (c[r] && !(i = c[r](i))) || ((n = i.shift()), o.push({ value: n, type: r, matches: i }), (a = a.slice(n.length)));
                        if (!n) break;
                    }
                    return t ? a.length : a ? ae.error(e) : _(e, l).slice(0);
                }),
                (c = ae.compile = function (e, t) {
                    var n,
                        i,
                        o,
                        r,
                        a,
                        c,
                        d = [],
                        p = [],
                        h = E[e + " "];
                    if (!h) {
                        for (n = (t = t || l(e)).length; n--; ) ((h = xe(t[n]))[T] ? d : p).push(h);
                        (h = E(
                            e,
                            ((r = 0 < (o = d).length),
                            (a = 0 < (i = p).length),
                            (c = function (e, t, n, l, c) {
                                var d,
                                    p,
                                    h,
                                    g = 0,
                                    y = "0",
                                    b = e && [],
                                    w = [],
                                    x = u,
                                    T = e || (a && s.find.TAG("*", c)),
                                    C = (S += null == x ? 1 : Math.random() || 0.1),
                                    k = T.length;
                                for (c && (u = t == m || t || c); y !== k && null != (d = T[y]); y++) {
                                    if (a && d) {
                                        for (p = 0, t || d.ownerDocument == m || (f(d), (n = !v)); (h = i[p++]); )
                                            if (h(d, t || m, n)) {
                                                l.push(d);
                                                break;
                                            }
                                        c && (S = C);
                                    }
                                    r && ((d = !h && d) && g--, e && b.push(d));
                                }
                                if (((g += y), r && y !== g)) {
                                    for (p = 0; (h = o[p++]); ) h(b, w, t, n);
                                    if (e) {
                                        if (0 < g) for (; y--; ) b[y] || w[y] || (w[y] = D.call(l));
                                        w = we(w);
                                    }
                                    z.apply(l, w), c && !e && 0 < w.length && 1 < g + o.length && ae.uniqueSort(l);
                                }
                                return c && ((S = C), (u = x)), b;
                            }),
                            r ? ce(c) : c)
                        )).selector = e;
                    }
                    return h;
                }),
                (d = ae.select = function (e, n, i, o) {
                    var r,
                        a,
                        d,
                        u,
                        p,
                        h = "function" == typeof e && e,
                        f = !o && l((e = h.selector || e));
                    if (((i = i || []), 1 === f.length)) {
                        if (2 < (a = f[0] = f[0].slice(0)).length && "ID" === (d = a[0]).type && 9 === n.nodeType && v && s.relative[a[1].type]) {
                            if (!(n = (s.find.ID(d.matches[0].replace(ie, t), n) || [])[0])) return i;
                            h && (n = n.parentNode), (e = e.slice(a.shift().value.length));
                        }
                        for (r = K.needsContext.test(e) ? 0 : a.length; r-- && ((d = a[r]), !s.relative[(u = d.type)]); )
                            if ((p = s.find[u]) && (o = p(d.matches[0].replace(ie, t), (ne.test(a[0].type) && me(n.parentNode)) || n))) {
                                if ((a.splice(r, 1), !(e = o.length && ve(a)))) return z.apply(i, o), i;
                                break;
                            }
                    }
                    return (h || c(e, f))(o, n, !v, i, !n || (ne.test(e) && me(n.parentNode)) || n), i;
                }),
                (o.sortStable = T.split("").sort(M).join("") === T),
                (o.detectDuplicates = !!h),
                f(),
                (o.sortDetached = de(function (e) {
                    return 1 & e.compareDocumentPosition(m.createElement("fieldset"));
                })),
                de(function (e) {
                    return (e.innerHTML = "<a href='#'></a>"), "#" === e.firstChild.getAttribute("href");
                }) ||
                    ue("type|href|height|width", function (e, t, n) {
                        if (!n) return e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2);
                    }),
                (o.attributes &&
                    de(function (e) {
                        return (e.innerHTML = "<input/>"), e.firstChild.setAttribute("value", ""), "" === e.firstChild.getAttribute("value");
                    })) ||
                    ue("value", function (e, t, n) {
                        if (!n && "input" === e.nodeName.toLowerCase()) return e.defaultValue;
                    }),
                de(function (e) {
                    return null == e.getAttribute("disabled");
                }) ||
                    ue(j, function (e, t, n) {
                        if (!n) return !0 === e[t] ? t.toLowerCase() : (t = e.getAttributeNode(t)) && t.specified ? t.value : null;
                    }),
                ae
            );
        })(e);
        function S(e, t, n) {
            for (var i = [], o = void 0 !== n; (e = e[t]) && 9 !== e.nodeType; )
                if (1 === e.nodeType) {
                    if (o && x(e).is(n)) break;
                    i.push(e);
                }
            return i;
        }
        function k(e, t) {
            for (var n = []; e; e = e.nextSibling) 1 === e.nodeType && e !== t && n.push(e);
            return n;
        }
        (x.find = C), (x.expr = C.selectors), (x.expr[":"] = x.expr.pseudos), (x.uniqueSort = x.unique = C.uniqueSort), (x.text = C.getText), (x.isXMLDoc = C.isXML), (x.contains = C.contains), (x.escapeSelector = C.escape);
        var $ = x.expr.match.needsContext;
        function _(e, t) {
            return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase();
        }
        var E = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
        function A(e, t, n) {
            return m(t)
                ? x.grep(e, function (e, i) {
                      return !!t.call(e, i, e) !== n;
                  })
                : t.nodeType
                ? x.grep(e, function (e) {
                      return (e === t) !== n;
                  })
                : "string" != typeof t
                ? x.grep(e, function (e) {
                      return -1 < l.call(t, e) !== n;
                  })
                : x.filter(t, e, n);
        }
        (x.filter = function (e, t, n) {
            var i = t[0];
            return (
                n && (e = ":not(" + e + ")"),
                1 === t.length && 1 === i.nodeType
                    ? x.find.matchesSelector(i, e)
                        ? [i]
                        : []
                    : x.find.matches(
                          e,
                          x.grep(t, function (e) {
                              return 1 === e.nodeType;
                          })
                      )
            );
        }),
            x.fn.extend({
                find: function (e) {
                    var t,
                        n,
                        i = this.length,
                        o = this;
                    if ("string" != typeof e)
                        return this.pushStack(
                            x(e).filter(function () {
                                for (t = 0; t < i; t++) if (x.contains(o[t], this)) return !0;
                            })
                        );
                    for (n = this.pushStack([]), t = 0; t < i; t++) x.find(e, o[t], n);
                    return 1 < i ? x.uniqueSort(n) : n;
                },
                filter: function (e) {
                    return this.pushStack(A(this, e || [], !1));
                },
                not: function (e) {
                    return this.pushStack(A(this, e || [], !0));
                },
                is: function (e) {
                    return !!A(this, "string" == typeof e && $.test(e) ? x(e) : e || [], !1).length;
                },
            });
        var M = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
        (x.fn.init = function (e, t, n) {
            if (!e) return this;
            if (((n = n || P), "string" != typeof e)) return e.nodeType ? ((this[0] = e), (this.length = 1), this) : m(e) ? (void 0 !== n.ready ? n.ready(e) : e(x)) : x.makeArray(e, this);
            if (!(i = "<" === e[0] && ">" === e[e.length - 1] && 3 <= e.length ? [null, e, null] : M.exec(e)) || (!i[1] && t)) return (!t || t.jquery ? t || n : this.constructor(t)).find(e);
            if (i[1]) {
                if (((t = t instanceof x ? t[0] : t), x.merge(this, x.parseHTML(i[1], t && t.nodeType ? t.ownerDocument || t : g, !0)), E.test(i[1]) && x.isPlainObject(t))) for (var i in t) m(this[i]) ? this[i](t[i]) : this.attr(i, t[i]);
                return this;
            }
            return (e = g.getElementById(i[2])) && ((this[0] = e), (this.length = 1)), this;
        }).prototype = x.fn;
        var P = x(g),
            L = /^(?:parents|prev(?:Until|All))/,
            D = { children: !0, contents: !0, next: !0, prev: !0 };
        function O(e, t) {
            for (; (e = e[t]) && 1 !== e.nodeType; );
            return e;
        }
        x.fn.extend({
            has: function (e) {
                var t = x(e, this),
                    n = t.length;
                return this.filter(function () {
                    for (var e = 0; e < n; e++) if (x.contains(this, t[e])) return !0;
                });
            },
            closest: function (e, t) {
                var n,
                    i = 0,
                    o = this.length,
                    s = [],
                    r = "string" != typeof e && x(e);
                if (!$.test(e))
                    for (; i < o; i++)
                        for (n = this[i]; n && n !== t; n = n.parentNode)
                            if (n.nodeType < 11 && (r ? -1 < r.index(n) : 1 === n.nodeType && x.find.matchesSelector(n, e))) {
                                s.push(n);
                                break;
                            }
                return this.pushStack(1 < s.length ? x.uniqueSort(s) : s);
            },
            index: function (e) {
                return e ? ("string" == typeof e ? l.call(x(e), this[0]) : l.call(this, e.jquery ? e[0] : e)) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            },
            add: function (e, t) {
                return this.pushStack(x.uniqueSort(x.merge(this.get(), x(e, t))));
            },
            addBack: function (e) {
                return this.add(null == e ? this.prevObject : this.prevObject.filter(e));
            },
        }),
            x.each(
                {
                    parent: function (e) {
                        return (e = e.parentNode) && 11 !== e.nodeType ? e : null;
                    },
                    parents: function (e) {
                        return S(e, "parentNode");
                    },
                    parentsUntil: function (e, t, n) {
                        return S(e, "parentNode", n);
                    },
                    next: function (e) {
                        return O(e, "nextSibling");
                    },
                    prev: function (e) {
                        return O(e, "previousSibling");
                    },
                    nextAll: function (e) {
                        return S(e, "nextSibling");
                    },
                    prevAll: function (e) {
                        return S(e, "previousSibling");
                    },
                    nextUntil: function (e, t, n) {
                        return S(e, "nextSibling", n);
                    },
                    prevUntil: function (e, t, n) {
                        return S(e, "previousSibling", n);
                    },
                    siblings: function (e) {
                        return k((e.parentNode || {}).firstChild, e);
                    },
                    children: function (e) {
                        return k(e.firstChild);
                    },
                    contents: function (e) {
                        return null != e.contentDocument && o(e.contentDocument) ? e.contentDocument : (_(e, "template") && (e = e.content || e), x.merge([], e.childNodes));
                    },
                },
                function (e, t) {
                    x.fn[e] = function (n, i) {
                        var o = x.map(this, t, n);
                        return (i = "Until" !== e.slice(-5) ? n : i) && "string" == typeof i && (o = x.filter(i, o)), 1 < this.length && (D[e] || x.uniqueSort(o), L.test(e) && o.reverse()), this.pushStack(o);
                    };
                }
            );
        var z = /[^\x20\t\r\n\f]+/g;
        function I(e) {
            return e;
        }
        function N(e) {
            throw e;
        }
        function j(e, t, n, i) {
            var o;
            try {
                e && m((o = e.promise)) ? o.call(e).done(t).fail(n) : e && m((o = e.then)) ? o.call(e, t, n) : t.apply(void 0, [e].slice(i));
            } catch (e) {
                n.apply(void 0, [e]);
            }
        }
        (x.Callbacks = function (e) {
            var t;
            function n() {
                for (r = r || e.once, s = i = !0; l.length; c = -1) for (o = l.shift(); ++c < a.length; ) !1 === a[c].apply(o[0], o[1]) && e.stopOnFalse && ((c = a.length), (o = !1));
                e.memory || (o = !1), (i = !1), r && (a = o ? [] : "");
            }
            e =
                "string" == typeof e
                    ? ((t = {}),
                      x.each(e.match(z) || [], function (e, n) {
                          t[n] = !0;
                      }),
                      t)
                    : x.extend({}, e);
            var i,
                o,
                s,
                r,
                a = [],
                l = [],
                c = -1,
                d = {
                    add: function () {
                        return (
                            a &&
                                (o && !i && ((c = a.length - 1), l.push(o)),
                                (function t(n) {
                                    x.each(n, function (n, i) {
                                        m(i) ? (e.unique && d.has(i)) || a.push(i) : i && i.length && "string" !== b(i) && t(i);
                                    });
                                })(arguments),
                                o && !i && n()),
                            this
                        );
                    },
                    remove: function () {
                        return (
                            x.each(arguments, function (e, t) {
                                for (var n; -1 < (n = x.inArray(t, a, n)); ) a.splice(n, 1), n <= c && c--;
                            }),
                            this
                        );
                    },
                    has: function (e) {
                        return e ? -1 < x.inArray(e, a) : 0 < a.length;
                    },
                    empty: function () {
                        return (a = a && []), this;
                    },
                    disable: function () {
                        return (r = l = []), (a = o = ""), this;
                    },
                    disabled: function () {
                        return !a;
                    },
                    lock: function () {
                        return (r = l = []), o || i || (a = o = ""), this;
                    },
                    locked: function () {
                        return !!r;
                    },
                    fireWith: function (e, t) {
                        return r || ((t = [e, (t = t || []).slice ? t.slice() : t]), l.push(t), i || n()), this;
                    },
                    fire: function () {
                        return d.fireWith(this, arguments), this;
                    },
                    fired: function () {
                        return !!s;
                    },
                };
            return d;
        }),
            x.extend({
                Deferred: function (t) {
                    var n = [
                            ["notify", "progress", x.Callbacks("memory"), x.Callbacks("memory"), 2],
                            ["resolve", "done", x.Callbacks("once memory"), x.Callbacks("once memory"), 0, "resolved"],
                            ["reject", "fail", x.Callbacks("once memory"), x.Callbacks("once memory"), 1, "rejected"],
                        ],
                        i = "pending",
                        o = {
                            state: function () {
                                return i;
                            },
                            always: function () {
                                return s.done(arguments).fail(arguments), this;
                            },
                            catch: function (e) {
                                return o.then(null, e);
                            },
                            pipe: function () {
                                var e = arguments;
                                return x
                                    .Deferred(function (t) {
                                        x.each(n, function (n, i) {
                                            var o = m(e[i[4]]) && e[i[4]];
                                            s[i[1]](function () {
                                                var e = o && o.apply(this, arguments);
                                                e && m(e.promise) ? e.promise().progress(t.notify).done(t.resolve).fail(t.reject) : t[i[0] + "With"](this, o ? [e] : arguments);
                                            });
                                        }),
                                            (e = null);
                                    })
                                    .promise();
                            },
                            then: function (t, i, o) {
                                var s = 0;
                                function r(t, n, i, o) {
                                    return function () {
                                        function a() {
                                            var e, a;
                                            if (!(t < s)) {
                                                if ((e = i.apply(l, c)) === n.promise()) throw new TypeError("Thenable self-resolution");
                                                (a = e && ("object" == _typeof(e) || "function" == typeof e) && e.then),
                                                    m(a)
                                                        ? o
                                                            ? a.call(e, r(s, n, I, o), r(s, n, N, o))
                                                            : (s++, a.call(e, r(s, n, I, o), r(s, n, N, o), r(s, n, I, n.notifyWith)))
                                                        : (i !== I && ((l = void 0), (c = [e])), (o || n.resolveWith)(l, c));
                                            }
                                        }
                                        var l = this,
                                            c = arguments,
                                            d = o
                                                ? a
                                                : function () {
                                                      try {
                                                          a();
                                                      } catch (e) {
                                                          x.Deferred.exceptionHook && x.Deferred.exceptionHook(e, d.stackTrace), s <= t + 1 && (i !== N && ((l = void 0), (c = [e])), n.rejectWith(l, c));
                                                      }
                                                  };
                                        t ? d() : (x.Deferred.getStackHook && (d.stackTrace = x.Deferred.getStackHook()), e.setTimeout(d));
                                    };
                                }
                                return x
                                    .Deferred(function (e) {
                                        n[0][3].add(r(0, e, m(o) ? o : I, e.notifyWith)), n[1][3].add(r(0, e, m(t) ? t : I)), n[2][3].add(r(0, e, m(i) ? i : N));
                                    })
                                    .promise();
                            },
                            promise: function (e) {
                                return null != e ? x.extend(e, o) : o;
                            },
                        },
                        s = {};
                    return (
                        x.each(n, function (e, t) {
                            var r = t[2],
                                a = t[5];
                            (o[t[1]] = r.add),
                                a &&
                                    r.add(
                                        function () {
                                            i = a;
                                        },
                                        n[3 - e][2].disable,
                                        n[3 - e][3].disable,
                                        n[0][2].lock,
                                        n[0][3].lock
                                    ),
                                r.add(t[3].fire),
                                (s[t[0]] = function () {
                                    return s[t[0] + "With"](this === s ? void 0 : this, arguments), this;
                                }),
                                (s[t[0] + "With"] = r.fireWith);
                        }),
                        o.promise(s),
                        t && t.call(s, s),
                        s
                    );
                },
                when: function (e) {
                    function t(e) {
                        return function (t) {
                            (o[e] = this), (r[e] = 1 < arguments.length ? s.call(arguments) : t), --n || a.resolveWith(o, r);
                        };
                    }
                    var n = arguments.length,
                        i = n,
                        o = Array(i),
                        r = s.call(arguments),
                        a = x.Deferred();
                    if (n <= 1 && (j(e, a.done(t(i)).resolve, a.reject, !n), "pending" === a.state() || m(r[i] && r[i].then))) return a.then();
                    for (; i--; ) j(r[i], t(i), a.reject);
                    return a.promise();
                },
            });
        var R = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
        (x.Deferred.exceptionHook = function (t, n) {
            e.console && e.console.warn && t && R.test(t.name) && e.console.warn("jQuery.Deferred exception: " + t.message, t.stack, n);
        }),
            (x.readyException = function (t) {
                e.setTimeout(function () {
                    throw t;
                });
            });
        var H = x.Deferred();
        function q() {
            g.removeEventListener("DOMContentLoaded", q), e.removeEventListener("load", q), x.ready();
        }
        function F(e, t, n, i, o, s, r) {
            var a = 0,
                l = e.length,
                c = null == n;
            if ("object" === b(n)) for (a in ((o = !0), n)) F(e, t, a, n[a], !0, s, r);
            else if (
                void 0 !== i &&
                ((o = !0),
                m(i) || (r = !0),
                (t = c
                    ? r
                        ? (t.call(e, i), null)
                        : ((c = t),
                          function (e, t, n) {
                              return c.call(x(e), n);
                          })
                    : t))
            )
                for (; a < l; a++) t(e[a], n, r ? i : i.call(e[a], a, t(e[a], n)));
            return o ? e : c ? t.call(e) : l ? t(e[0], n) : s;
        }
        (x.fn.ready = function (e) {
            return (
                H.then(e).catch(function (e) {
                    x.readyException(e);
                }),
                this
            );
        }),
            x.extend({
                isReady: !1,
                readyWait: 1,
                ready: function (e) {
                    (!0 === e ? --x.readyWait : x.isReady) || ((x.isReady = !0) !== e && 0 < --x.readyWait) || H.resolveWith(g, [x]);
                },
            }),
            (x.ready.then = H.then),
            "complete" === g.readyState || ("loading" !== g.readyState && !g.documentElement.doScroll) ? e.setTimeout(x.ready) : (g.addEventListener("DOMContentLoaded", q), e.addEventListener("load", q));
        var W = /^-ms-/,
            B = /-([a-z])/g;
        function V(e, t) {
            return t.toUpperCase();
        }
        function U(e) {
            return e.replace(W, "ms-").replace(B, V);
        }
        function G(e) {
            return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType;
        }
        function X() {
            this.expando = x.expando + X.uid++;
        }
        (X.uid = 1),
            (X.prototype = {
                cache: function (e) {
                    var t = e[this.expando];
                    return t || ((t = {}), G(e) && (e.nodeType ? (e[this.expando] = t) : Object.defineProperty(e, this.expando, { value: t, configurable: !0 }))), t;
                },
                set: function (e, t, n) {
                    var i,
                        o = this.cache(e);
                    if ("string" == typeof t) o[U(t)] = n;
                    else for (i in t) o[U(i)] = t[i];
                    return o;
                },
                get: function (e, t) {
                    return void 0 === t ? this.cache(e) : e[this.expando] && e[this.expando][U(t)];
                },
                access: function (e, t, n) {
                    return void 0 === t || (t && "string" == typeof t && void 0 === n) ? this.get(e, t) : (this.set(e, t, n), void 0 !== n ? n : t);
                },
                remove: function (e, t) {
                    var n,
                        i = e[this.expando];
                    if (void 0 !== i) {
                        if (void 0 !== t) {
                            n = (t = Array.isArray(t) ? t.map(U) : (t = U(t)) in i ? [t] : t.match(z) || []).length;
                            for (; n--; ) delete i[t[n]];
                        }
                        (void 0 !== t && !x.isEmptyObject(i)) || (e.nodeType ? (e[this.expando] = void 0) : delete e[this.expando]);
                    }
                },
                hasData: function (e) {
                    return void 0 !== (e = e[this.expando]) && !x.isEmptyObject(e);
                },
            });
        var Y = new X(),
            K = new X(),
            Z = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
            Q = /[A-Z]/g;
        function J(e, t, n) {
            var i, o;
            if (void 0 === n && 1 === e.nodeType)
                if (((i = "data-" + t.replace(Q, "-$&").toLowerCase()), "string" == typeof (n = e.getAttribute(i)))) {
                    try {
                        n = "true" === (o = n) || ("false" !== o && ("null" === o ? null : o === +o + "" ? +o : Z.test(o) ? JSON.parse(o) : o));
                    } catch (e) {}
                    K.set(e, t, n);
                } else n = void 0;
            return n;
        }
        x.extend({
            hasData: function (e) {
                return K.hasData(e) || Y.hasData(e);
            },
            data: function (e, t, n) {
                return K.access(e, t, n);
            },
            removeData: function (e, t) {
                K.remove(e, t);
            },
            _data: function (e, t, n) {
                return Y.access(e, t, n);
            },
            _removeData: function (e, t) {
                Y.remove(e, t);
            },
        }),
            x.fn.extend({
                data: function (e, t) {
                    var n,
                        i,
                        o,
                        s = this[0],
                        r = s && s.attributes;
                    if (void 0 !== e)
                        return "object" == _typeof(e)
                            ? this.each(function () {
                                  K.set(this, e);
                              })
                            : F(
                                  this,
                                  function (t) {
                                      var n;
                                      return s && void 0 === t
                                          ? void 0 !== (n = K.get(s, e)) || void 0 !== (n = J(s, e))
                                              ? n
                                              : void 0
                                          : void this.each(function () {
                                                K.set(this, e, t);
                                            });
                                  },
                                  null,
                                  t,
                                  1 < arguments.length,
                                  null,
                                  !0
                              );
                    if (this.length && ((o = K.get(s)), 1 === s.nodeType && !Y.get(s, "hasDataAttrs"))) {
                        for (n = r.length; n--; ) r[n] && 0 === (i = r[n].name).indexOf("data-") && ((i = U(i.slice(5))), J(s, i, o[i]));
                        Y.set(s, "hasDataAttrs", !0);
                    }
                    return o;
                },
                removeData: function (e) {
                    return this.each(function () {
                        K.remove(this, e);
                    });
                },
            }),
            x.extend({
                queue: function (e, t, n) {
                    var i;
                    if (e) return (i = Y.get(e, (t = (t || "fx") + "queue"))), n && (!i || Array.isArray(n) ? (i = Y.access(e, t, x.makeArray(n))) : i.push(n)), i || [];
                },
                dequeue: function (e, t) {
                    var n = x.queue(e, (t = t || "fx")),
                        i = n.length,
                        o = n.shift(),
                        s = x._queueHooks(e, t);
                    "inprogress" === o && ((o = n.shift()), i--),
                        o &&
                            ("fx" === t && n.unshift("inprogress"),
                            delete s.stop,
                            o.call(
                                e,
                                function () {
                                    x.dequeue(e, t);
                                },
                                s
                            )),
                        !i && s && s.empty.fire();
                },
                _queueHooks: function (e, t) {
                    var n = t + "queueHooks";
                    return (
                        Y.get(e, n) ||
                        Y.access(e, n, {
                            empty: x.Callbacks("once memory").add(function () {
                                Y.remove(e, [t + "queue", n]);
                            }),
                        })
                    );
                },
            }),
            x.fn.extend({
                queue: function (e, t) {
                    var n = 2;
                    return (
                        "string" != typeof e && ((t = e), (e = "fx"), n--),
                        arguments.length < n
                            ? x.queue(this[0], e)
                            : void 0 === t
                            ? this
                            : this.each(function () {
                                  var n = x.queue(this, e, t);
                                  x._queueHooks(this, e), "fx" === e && "inprogress" !== n[0] && x.dequeue(this, e);
                              })
                    );
                },
                dequeue: function (e) {
                    return this.each(function () {
                        x.dequeue(this, e);
                    });
                },
                clearQueue: function (e) {
                    return this.queue(e || "fx", []);
                },
                promise: function (e, t) {
                    function n() {
                        --o || s.resolveWith(r, [r]);
                    }
                    var i,
                        o = 1,
                        s = x.Deferred(),
                        r = this,
                        a = this.length;
                    for ("string" != typeof e && ((t = e), (e = void 0)), e = e || "fx"; a--; ) (i = Y.get(r[a], e + "queueHooks")) && i.empty && (o++, i.empty.add(n));
                    return n(), s.promise(t);
                },
            });
        var ee = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
            te = new RegExp("^(?:([+-])=|)(" + ee + ")([a-z%]*)$", "i"),
            ne = ["Top", "Right", "Bottom", "Left"],
            ie = g.documentElement,
            oe = function (e) {
                return x.contains(e.ownerDocument, e);
            },
            se = { composed: !0 };
        function re(e, t) {
            return "none" === (e = t || e).style.display || ("" === e.style.display && oe(e) && "none" === x.css(e, "display"));
        }
        function ae(e, t, n, i) {
            var o,
                s,
                r = 20,
                a = i
                    ? function () {
                          return i.cur();
                      }
                    : function () {
                          return x.css(e, t, "");
                      },
                l = a(),
                c = (n && n[3]) || (x.cssNumber[t] ? "" : "px"),
                d = e.nodeType && (x.cssNumber[t] || ("px" !== c && +l)) && te.exec(x.css(e, t));
            if (d && d[3] !== c) {
                for (c = c || d[3], d = +(l /= 2) || 1; r--; ) x.style(e, t, d + c), (1 - s) * (1 - (s = a() / l || 0.5)) <= 0 && (r = 0), (d /= s);
                x.style(e, t, (d *= 2) + c), (n = n || []);
            }
            return n && ((d = +d || +l || 0), (o = n[1] ? d + (n[1] + 1) * n[2] : +n[2]), i && ((i.unit = c), (i.start = d), (i.end = o))), o;
        }
        ie.getRootNode &&
            (oe = function (e) {
                return x.contains(e.ownerDocument, e) || e.getRootNode(se) === e.ownerDocument;
            });
        var le = {};
        function ce(e, t) {
            for (var n, i, o, s, r, a, l = [], c = 0, d = e.length; c < d; c++)
                (i = e[c]).style &&
                    ((n = i.style.display),
                    t
                        ? ("none" === n && ((l[c] = Y.get(i, "display") || null), l[c] || (i.style.display = "")),
                          "" === i.style.display &&
                              re(i) &&
                              (l[c] =
                                  ((a = s = o = void 0),
                                  (s = i.ownerDocument),
                                  (r = i.nodeName),
                                  (a = le[r]) || ((o = s.body.appendChild(s.createElement(r))), (a = x.css(o, "display")), o.parentNode.removeChild(o), (le[r] = a = "none" === a ? "block" : a)))))
                        : "none" !== n && ((l[c] = "none"), Y.set(i, "display", n)));
            for (c = 0; c < d; c++) null != l[c] && (e[c].style.display = l[c]);
            return e;
        }
        x.fn.extend({
            show: function () {
                return ce(this, !0);
            },
            hide: function () {
                return ce(this);
            },
            toggle: function (e) {
                return "boolean" == typeof e
                    ? e
                        ? this.show()
                        : this.hide()
                    : this.each(function () {
                          re(this) ? x(this).show() : x(this).hide();
                      });
            },
        });
        var de = /^(?:checkbox|radio)$/i,
            ue = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i,
            pe = /^$|^module$|\/(?:java|ecma)script/i;
        (w = g.createDocumentFragment().appendChild(g.createElement("div"))),
            (C = g.createElement("input")).setAttribute("type", "radio"),
            C.setAttribute("checked", "checked"),
            C.setAttribute("name", "t"),
            w.appendChild(C),
            (f.checkClone = w.cloneNode(!0).cloneNode(!0).lastChild.checked),
            (w.innerHTML = "<textarea>x</textarea>"),
            (f.noCloneChecked = !!w.cloneNode(!0).lastChild.defaultValue),
            (w.innerHTML = "<option></option>"),
            (f.option = !!w.lastChild);
        var he = { thead: [1, "<table>", "</table>"], col: [2, "<table><colgroup>", "</colgroup></table>"], tr: [2, "<table><tbody>", "</tbody></table>"], td: [3, "<table><tbody><tr>", "</tr></tbody></table>"], _default: [0, "", ""] };
        function fe(e, t) {
            var n = void 0 !== e.getElementsByTagName ? e.getElementsByTagName(t || "*") : void 0 !== e.querySelectorAll ? e.querySelectorAll(t || "*") : [];
            return void 0 === t || (t && _(e, t)) ? x.merge([e], n) : n;
        }
        function me(e, t) {
            for (var n = 0, i = e.length; n < i; n++) Y.set(e[n], "globalEval", !t || Y.get(t[n], "globalEval"));
        }
        (he.tbody = he.tfoot = he.colgroup = he.caption = he.thead), (he.th = he.td), f.option || (he.optgroup = he.option = [1, "<select multiple='multiple'>", "</select>"]);
        var ge = /<|&#?\w+;/;
        function ve(e, t, n, i, o) {
            for (var s, r, a, l, c, d = t.createDocumentFragment(), u = [], p = 0, h = e.length; p < h; p++)
                if ((s = e[p]) || 0 === s)
                    if ("object" === b(s)) x.merge(u, s.nodeType ? [s] : s);
                    else if (ge.test(s)) {
                        for (r = r || d.appendChild(t.createElement("div")), a = (ue.exec(s) || ["", ""])[1].toLowerCase(), a = he[a] || he._default, r.innerHTML = a[1] + x.htmlPrefilter(s) + a[2], c = a[0]; c--; ) r = r.lastChild;
                        x.merge(u, r.childNodes), ((r = d.firstChild).textContent = "");
                    } else u.push(t.createTextNode(s));
            for (d.textContent = "", p = 0; (s = u[p++]); )
                if (i && -1 < x.inArray(s, i)) o && o.push(s);
                else if (((l = oe(s)), (r = fe(d.appendChild(s), "script")), l && me(r), n)) for (c = 0; (s = r[c++]); ) pe.test(s.type || "") && n.push(s);
            return d;
        }
        var ye = /^key/,
            be = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
            we = /^([^.]*)(?:\.(.+)|)/;
        function xe() {
            return !0;
        }
        function Te() {
            return !1;
        }
        function Ce(e, t) {
            return (
                (e ===
                    (function () {
                        try {
                            return g.activeElement;
                        } catch (e) {}
                    })()) ==
                ("focus" === t)
            );
        }
        function Se(e, t, n, i, o, s) {
            var r, a;
            if ("object" == _typeof(t)) {
                for (a in ("string" != typeof n && ((i = i || n), (n = void 0)), t)) Se(e, a, n, i, t[a], s);
                return e;
            }
            if ((null == i && null == o ? ((o = n), (i = n = void 0)) : null == o && ("string" == typeof n ? ((o = i), (i = void 0)) : ((o = i), (i = n), (n = void 0))), !1 === o)) o = Te;
            else if (!o) return e;
            return (
                1 === s &&
                    ((r = o),
                    ((o = function (e) {
                        return x().off(e), r.apply(this, arguments);
                    }).guid = r.guid || (r.guid = x.guid++))),
                e.each(function () {
                    x.event.add(this, t, o, i, n);
                })
            );
        }
        function ke(e, t, n) {
            n
                ? (Y.set(e, t, !1),
                  x.event.add(e, t, {
                      namespace: !1,
                      handler: function (e) {
                          var i,
                              o,
                              r = Y.get(this, t);
                          if (1 & e.isTrigger && this[t]) {
                              if (r.length) (x.event.special[t] || {}).delegateType && e.stopPropagation();
                              else if (((r = s.call(arguments)), Y.set(this, t, r), (i = n(this, t)), this[t](), r !== (o = Y.get(this, t)) || i ? Y.set(this, t, !1) : (o = {}), r !== o))
                                  return e.stopImmediatePropagation(), e.preventDefault(), o.value;
                          } else r.length && (Y.set(this, t, { value: x.event.trigger(x.extend(r[0], x.Event.prototype), r.slice(1), this) }), e.stopImmediatePropagation());
                      },
                  }))
                : void 0 === Y.get(e, t) && x.event.add(e, t, xe);
        }
        (x.event = {
            global: {},
            add: function (e, t, n, i, o) {
                var s,
                    r,
                    a,
                    l,
                    c,
                    d,
                    u,
                    p,
                    h,
                    f = Y.get(e);
                if (G(e))
                    for (
                        n.handler && ((n = (s = n).handler), (o = s.selector)),
                            o && x.find.matchesSelector(ie, o),
                            n.guid || (n.guid = x.guid++),
                            (a = f.events) || (a = f.events = Object.create(null)),
                            (r = f.handle) ||
                                (r = f.handle = function (t) {
                                    return void 0 !== x && x.event.triggered !== t.type ? x.event.dispatch.apply(e, arguments) : void 0;
                                }),
                            l = (t = (t || "").match(z) || [""]).length;
                        l--;

                    )
                        (u = h = (c = we.exec(t[l]) || [])[1]),
                            (p = (c[2] || "").split(".").sort()),
                            u &&
                                ((d = x.event.special[u] || {}),
                                (u = (o ? d.delegateType : d.bindType) || u),
                                (d = x.event.special[u] || {}),
                                (c = x.extend({ type: u, origType: h, data: i, handler: n, guid: n.guid, selector: o, needsContext: o && x.expr.match.needsContext.test(o), namespace: p.join(".") }, s)),
                                (h = a[u]) || (((h = a[u] = []).delegateCount = 0), (d.setup && !1 !== d.setup.call(e, i, p, r)) || (e.addEventListener && e.addEventListener(u, r))),
                                d.add && (d.add.call(e, c), c.handler.guid || (c.handler.guid = n.guid)),
                                o ? h.splice(h.delegateCount++, 0, c) : h.push(c),
                                (x.event.global[u] = !0));
            },
            remove: function (e, t, n, i, o) {
                var s,
                    r,
                    a,
                    l,
                    c,
                    d,
                    u,
                    p,
                    h,
                    f,
                    m,
                    g = Y.hasData(e) && Y.get(e);
                if (g && (l = g.events)) {
                    for (c = (t = (t || "").match(z) || [""]).length; c--; )
                        if (((h = m = (a = we.exec(t[c]) || [])[1]), (f = (a[2] || "").split(".").sort()), h)) {
                            for (u = x.event.special[h] || {}, p = l[(h = (i ? u.delegateType : u.bindType) || h)] || [], a = a[2] && new RegExp("(^|\\.)" + f.join("\\.(?:.*\\.|)") + "(\\.|$)"), r = s = p.length; s--; )
                                (d = p[s]),
                                    (!o && m !== d.origType) ||
                                        (n && n.guid !== d.guid) ||
                                        (a && !a.test(d.namespace)) ||
                                        (i && i !== d.selector && ("**" !== i || !d.selector)) ||
                                        (p.splice(s, 1), d.selector && p.delegateCount--, u.remove && u.remove.call(e, d));
                            r && !p.length && ((u.teardown && !1 !== u.teardown.call(e, f, g.handle)) || x.removeEvent(e, h, g.handle), delete l[h]);
                        } else for (h in l) x.event.remove(e, h + t[c], n, i, !0);
                    x.isEmptyObject(l) && Y.remove(e, "handle events");
                }
            },
            dispatch: function (e) {
                var t,
                    n,
                    i,
                    o,
                    s,
                    r = new Array(arguments.length),
                    a = x.event.fix(e),
                    l = (Y.get(this, "events") || Object.create(null))[a.type] || [];
                for (e = x.event.special[a.type] || {}, r[0] = a, t = 1; t < arguments.length; t++) r[t] = arguments[t];
                if (((a.delegateTarget = this), !e.preDispatch || !1 !== e.preDispatch.call(this, a))) {
                    for (s = x.event.handlers.call(this, a, l), t = 0; (i = s[t++]) && !a.isPropagationStopped(); )
                        for (a.currentTarget = i.elem, n = 0; (o = i.handlers[n++]) && !a.isImmediatePropagationStopped(); )
                            (a.rnamespace && !1 !== o.namespace && !a.rnamespace.test(o.namespace)) ||
                                ((a.handleObj = o), (a.data = o.data), void 0 !== (o = ((x.event.special[o.origType] || {}).handle || o.handler).apply(i.elem, r)) && !1 === (a.result = o) && (a.preventDefault(), a.stopPropagation()));
                    return e.postDispatch && e.postDispatch.call(this, a), a.result;
                }
            },
            handlers: function (e, t) {
                var n,
                    i,
                    o,
                    s,
                    r,
                    a = [],
                    l = t.delegateCount,
                    c = e.target;
                if (l && c.nodeType && !("click" === e.type && 1 <= e.button))
                    for (; c !== this; c = c.parentNode || this)
                        if (1 === c.nodeType && ("click" !== e.type || !0 !== c.disabled)) {
                            for (s = [], r = {}, n = 0; n < l; n++) void 0 === r[(o = (i = t[n]).selector + " ")] && (r[o] = i.needsContext ? -1 < x(o, this).index(c) : x.find(o, this, null, [c]).length), r[o] && s.push(i);
                            s.length && a.push({ elem: c, handlers: s });
                        }
                return (c = this), l < t.length && a.push({ elem: c, handlers: t.slice(l) }), a;
            },
            addProp: function (e, t) {
                Object.defineProperty(x.Event.prototype, e, {
                    enumerable: !0,
                    configurable: !0,
                    get: m(t)
                        ? function () {
                              if (this.originalEvent) return t(this.originalEvent);
                          }
                        : function () {
                              if (this.originalEvent) return this.originalEvent[e];
                          },
                    set: function (t) {
                        Object.defineProperty(this, e, { enumerable: !0, configurable: !0, writable: !0, value: t });
                    },
                });
            },
            fix: function (e) {
                return e[x.expando] ? e : new x.Event(e);
            },
            special: {
                load: { noBubble: !0 },
                click: {
                    setup: function (e) {
                        return (e = this || e), de.test(e.type) && e.click && _(e, "input") && ke(e, "click", xe), !1;
                    },
                    trigger: function (e) {
                        return (e = this || e), de.test(e.type) && e.click && _(e, "input") && ke(e, "click"), !0;
                    },
                    _default: function (e) {
                        return (e = e.target), (de.test(e.type) && e.click && _(e, "input") && Y.get(e, "click")) || _(e, "a");
                    },
                },
                beforeunload: {
                    postDispatch: function (e) {
                        void 0 !== e.result && e.originalEvent && (e.originalEvent.returnValue = e.result);
                    },
                },
            },
        }),
            (x.removeEvent = function (e, t, n) {
                e.removeEventListener && e.removeEventListener(t, n);
            }),
            (x.Event = function (e, t) {
                if (!(this instanceof x.Event)) return new x.Event(e, t);
                e && e.type
                    ? ((this.originalEvent = e),
                      (this.type = e.type),
                      (this.isDefaultPrevented = e.defaultPrevented || (void 0 === e.defaultPrevented && !1 === e.returnValue) ? xe : Te),
                      (this.target = e.target && 3 === e.target.nodeType ? e.target.parentNode : e.target),
                      (this.currentTarget = e.currentTarget),
                      (this.relatedTarget = e.relatedTarget))
                    : (this.type = e),
                    t && x.extend(this, t),
                    (this.timeStamp = (e && e.timeStamp) || Date.now()),
                    (this[x.expando] = !0);
            }),
            (x.Event.prototype = {
                constructor: x.Event,
                isDefaultPrevented: Te,
                isPropagationStopped: Te,
                isImmediatePropagationStopped: Te,
                isSimulated: !1,
                preventDefault: function () {
                    var e = this.originalEvent;
                    (this.isDefaultPrevented = xe), e && !this.isSimulated && e.preventDefault();
                },
                stopPropagation: function () {
                    var e = this.originalEvent;
                    (this.isPropagationStopped = xe), e && !this.isSimulated && e.stopPropagation();
                },
                stopImmediatePropagation: function () {
                    var e = this.originalEvent;
                    (this.isImmediatePropagationStopped = xe), e && !this.isSimulated && e.stopImmediatePropagation(), this.stopPropagation();
                },
            }),
            x.each(
                {
                    altKey: !0,
                    bubbles: !0,
                    cancelable: !0,
                    changedTouches: !0,
                    ctrlKey: !0,
                    detail: !0,
                    eventPhase: !0,
                    metaKey: !0,
                    pageX: !0,
                    pageY: !0,
                    shiftKey: !0,
                    view: !0,
                    char: !0,
                    code: !0,
                    charCode: !0,
                    key: !0,
                    keyCode: !0,
                    button: !0,
                    buttons: !0,
                    clientX: !0,
                    clientY: !0,
                    offsetX: !0,
                    offsetY: !0,
                    pointerId: !0,
                    pointerType: !0,
                    screenX: !0,
                    screenY: !0,
                    targetTouches: !0,
                    toElement: !0,
                    touches: !0,
                    which: function (e) {
                        var t = e.button;
                        return null == e.which && ye.test(e.type) ? (null != e.charCode ? e.charCode : e.keyCode) : !e.which && void 0 !== t && be.test(e.type) ? (1 & t ? 1 : 2 & t ? 3 : 4 & t ? 2 : 0) : e.which;
                    },
                },
                x.event.addProp
            ),
            x.each({ focus: "focusin", blur: "focusout" }, function (e, t) {
                x.event.special[e] = {
                    setup: function () {
                        return ke(this, e, Ce), !1;
                    },
                    trigger: function () {
                        return ke(this, e), !0;
                    },
                    delegateType: t,
                };
            }),
            x.each({ mouseenter: "mouseover", mouseleave: "mouseout", pointerenter: "pointerover", pointerleave: "pointerout" }, function (e, t) {
                x.event.special[e] = {
                    delegateType: t,
                    bindType: t,
                    handle: function (e) {
                        var n,
                            i = e.relatedTarget,
                            o = e.handleObj;
                        return (i && (i === this || x.contains(this, i))) || ((e.type = o.origType), (n = o.handler.apply(this, arguments)), (e.type = t)), n;
                    },
                };
            }),
            x.fn.extend({
                on: function (e, t, n, i) {
                    return Se(this, e, t, n, i);
                },
                one: function (e, t, n, i) {
                    return Se(this, e, t, n, i, 1);
                },
                off: function (e, t, n) {
                    var i, o;
                    if (e && e.preventDefault && e.handleObj) return (i = e.handleObj), x(e.delegateTarget).off(i.namespace ? i.origType + "." + i.namespace : i.origType, i.selector, i.handler), this;
                    if ("object" != _typeof(e))
                        return (
                            (!1 !== t && "function" != typeof t) || ((n = t), (t = void 0)),
                            !1 === n && (n = Te),
                            this.each(function () {
                                x.event.remove(this, e, n, t);
                            })
                        );
                    for (o in e) this.off(o, t, e[o]);
                    return this;
                },
            });
        var $e = /<script|<style|<link/i,
            _e = /checked\s*(?:[^=]|=\s*.checked.)/i,
            Ee = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
        function Ae(e, t) {
            return (_(e, "table") && _(11 !== t.nodeType ? t : t.firstChild, "tr") && x(e).children("tbody")[0]) || e;
        }
        function Me(e) {
            return (e.type = (null !== e.getAttribute("type")) + "/" + e.type), e;
        }
        function Pe(e) {
            return "true/" === (e.type || "").slice(0, 5) ? (e.type = e.type.slice(5)) : e.removeAttribute("type"), e;
        }
        function Le(e, t) {
            var n, i, o, s;
            if (1 === t.nodeType) {
                if (Y.hasData(e) && (s = Y.get(e).events)) for (o in (Y.remove(t, "handle events"), s)) for (n = 0, i = s[o].length; n < i; n++) x.event.add(t, o, s[o][n]);
                K.hasData(e) && ((e = K.access(e)), (e = x.extend({}, e)), K.set(t, e));
            }
        }
        function De(e, t, n, i) {
            t = r(t);
            var o,
                s,
                a,
                l,
                c,
                d,
                u = 0,
                p = e.length,
                h = p - 1,
                g = t[0],
                v = m(g);
            if (v || (1 < p && "string" == typeof g && !f.checkClone && _e.test(g)))
                return e.each(function (o) {
                    var s = e.eq(o);
                    v && (t[0] = g.call(this, o, s.html())), De(s, t, n, i);
                });
            if (p && ((s = (o = ve(t, e[0].ownerDocument, !1, e, i)).firstChild), 1 === o.childNodes.length && (o = s), s || i)) {
                for (l = (a = x.map(fe(o, "script"), Me)).length; u < p; u++) (c = o), u !== h && ((c = x.clone(c, !0, !0)), l && x.merge(a, fe(c, "script"))), n.call(e[u], c, u);
                if (l)
                    for (d = a[a.length - 1].ownerDocument, x.map(a, Pe), u = 0; u < l; u++)
                        (c = a[u]),
                            pe.test(c.type || "") &&
                                !Y.access(c, "globalEval") &&
                                x.contains(d, c) &&
                                (c.src && "module" !== (c.type || "").toLowerCase() ? x._evalUrl && !c.noModule && x._evalUrl(c.src, { nonce: c.nonce || c.getAttribute("nonce") }, d) : y(c.textContent.replace(Ee, ""), c, d));
            }
            return e;
        }
        function Oe(e, t, n) {
            for (var i, o = t ? x.filter(t, e) : e, s = 0; null != (i = o[s]); s++) n || 1 !== i.nodeType || x.cleanData(fe(i)), i.parentNode && (n && oe(i) && me(fe(i, "script")), i.parentNode.removeChild(i));
            return e;
        }
        function ze(e, t, n) {
            var i,
                o = {};
            for (i in t) (o[i] = e.style[i]), (e.style[i] = t[i]);
            for (i in ((n = n.call(e)), t)) e.style[i] = o[i];
            return n;
        }
        x.extend({
            htmlPrefilter: function (e) {
                return e;
            },
            clone: function (e, t, n) {
                var i,
                    o,
                    s,
                    r,
                    a,
                    l,
                    c,
                    d = e.cloneNode(!0),
                    u = oe(e);
                if (!(f.noCloneChecked || (1 !== e.nodeType && 11 !== e.nodeType) || x.isXMLDoc(e)))
                    for (r = fe(d), i = 0, o = (s = fe(e)).length; i < o; i++)
                        (a = s[i]), "input" === (c = (l = r[i]).nodeName.toLowerCase()) && de.test(a.type) ? (l.checked = a.checked) : ("input" !== c && "textarea" !== c) || (l.defaultValue = a.defaultValue);
                if (t)
                    if (n) for (s = s || fe(e), r = r || fe(d), i = 0, o = s.length; i < o; i++) Le(s[i], r[i]);
                    else Le(e, d);
                return 0 < (r = fe(d, "script")).length && me(r, !u && fe(e, "script")), d;
            },
            cleanData: function (e) {
                for (var t, n, i, o = x.event.special, s = 0; void 0 !== (n = e[s]); s++)
                    if (G(n)) {
                        if ((t = n[Y.expando])) {
                            if (t.events) for (i in t.events) o[i] ? x.event.remove(n, i) : x.removeEvent(n, i, t.handle);
                            n[Y.expando] = void 0;
                        }
                        n[K.expando] && (n[K.expando] = void 0);
                    }
            },
        }),
            x.fn.extend({
                detach: function (e) {
                    return Oe(this, e, !0);
                },
                remove: function (e) {
                    return Oe(this, e);
                },
                text: function (e) {
                    return F(
                        this,
                        function (e) {
                            return void 0 === e
                                ? x.text(this)
                                : this.empty().each(function () {
                                      (1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType) || (this.textContent = e);
                                  });
                        },
                        null,
                        e,
                        arguments.length
                    );
                },
                append: function () {
                    return De(this, arguments, function (e) {
                        (1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType) || Ae(this, e).appendChild(e);
                    });
                },
                prepend: function () {
                    return De(this, arguments, function (e) {
                        var t;
                        (1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType) || (t = Ae(this, e)).insertBefore(e, t.firstChild);
                    });
                },
                before: function () {
                    return De(this, arguments, function (e) {
                        this.parentNode && this.parentNode.insertBefore(e, this);
                    });
                },
                after: function () {
                    return De(this, arguments, function (e) {
                        this.parentNode && this.parentNode.insertBefore(e, this.nextSibling);
                    });
                },
                empty: function () {
                    for (var e, t = 0; null != (e = this[t]); t++) 1 === e.nodeType && (x.cleanData(fe(e, !1)), (e.textContent = ""));
                    return this;
                },
                clone: function (e, t) {
                    return (
                        (e = null != e && e),
                        (t = null == t ? e : t),
                        this.map(function () {
                            return x.clone(this, e, t);
                        })
                    );
                },
                html: function (e) {
                    return F(
                        this,
                        function (e) {
                            var t = this[0] || {},
                                n = 0,
                                i = this.length;
                            if (void 0 === e && 1 === t.nodeType) return t.innerHTML;
                            if ("string" == typeof e && !$e.test(e) && !he[(ue.exec(e) || ["", ""])[1].toLowerCase()]) {
                                e = x.htmlPrefilter(e);
                                try {
                                    for (; n < i; n++) 1 === (t = this[n] || {}).nodeType && (x.cleanData(fe(t, !1)), (t.innerHTML = e));
                                    t = 0;
                                } catch (e) {}
                            }
                            t && this.empty().append(e);
                        },
                        null,
                        e,
                        arguments.length
                    );
                },
                replaceWith: function () {
                    var e = [];
                    return De(
                        this,
                        arguments,
                        function (t) {
                            var n = this.parentNode;
                            x.inArray(this, e) < 0 && (x.cleanData(fe(this)), n && n.replaceChild(t, this));
                        },
                        e
                    );
                },
            }),
            x.each({ appendTo: "append", prependTo: "prepend", insertBefore: "before", insertAfter: "after", replaceAll: "replaceWith" }, function (e, t) {
                x.fn[e] = function (e) {
                    for (var n, i = [], o = x(e), s = o.length - 1, r = 0; r <= s; r++) (n = r === s ? this : this.clone(!0)), x(o[r])[t](n), a.apply(i, n.get());
                    return this.pushStack(i);
                };
            });
        var Ie,
            Ne,
            je,
            Re,
            He,
            qe,
            Fe,
            We,
            Be = new RegExp("^(" + ee + ")(?!px)[a-z%]+$", "i"),
            Ve = function (t) {
                var n = t.ownerDocument.defaultView;
                return (n = n && n.opener ? n : e).getComputedStyle(t);
            },
            Ue = new RegExp(ne.join("|"), "i");
        function Ge(e, t, n) {
            var i,
                o,
                s = e.style;
            return (
                (n = n || Ve(e)) &&
                    ("" !== (o = n.getPropertyValue(t) || n[t]) || oe(e) || (o = x.style(e, t)),
                    !f.pixelBoxStyles() && Be.test(o) && Ue.test(t) && ((i = s.width), (e = s.minWidth), (t = s.maxWidth), (s.minWidth = s.maxWidth = s.width = o), (o = n.width), (s.width = i), (s.minWidth = e), (s.maxWidth = t))),
                void 0 !== o ? o + "" : o
            );
        }
        function Xe(e, t) {
            return {
                get: function () {
                    if (!e()) return (this.get = t).apply(this, arguments);
                    delete this.get;
                },
            };
        }
        function Ye() {
            var t;
            We &&
                ((Fe.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0"),
                (We.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%"),
                ie.appendChild(Fe).appendChild(We),
                (t = e.getComputedStyle(We)),
                (Ie = "1%" !== t.top),
                (qe = 12 === Ke(t.marginLeft)),
                (We.style.right = "60%"),
                (Re = 36 === Ke(t.right)),
                (Ne = 36 === Ke(t.width)),
                (We.style.position = "absolute"),
                (je = 12 === Ke(We.offsetWidth / 3)),
                ie.removeChild(Fe),
                (We = null));
        }
        function Ke(e) {
            return Math.round(parseFloat(e));
        }
        (Fe = g.createElement("div")),
            (We = g.createElement("div")).style &&
                ((We.style.backgroundClip = "content-box"),
                (We.cloneNode(!0).style.backgroundClip = ""),
                (f.clearCloneStyle = "content-box" === We.style.backgroundClip),
                x.extend(f, {
                    boxSizingReliable: function () {
                        return Ye(), Ne;
                    },
                    pixelBoxStyles: function () {
                        return Ye(), Re;
                    },
                    pixelPosition: function () {
                        return Ye(), Ie;
                    },
                    reliableMarginLeft: function () {
                        return Ye(), qe;
                    },
                    scrollboxSize: function () {
                        return Ye(), je;
                    },
                    reliableTrDimensions: function () {
                        var t, n, i;
                        return (
                            null == He &&
                                ((t = g.createElement("table")),
                                (i = g.createElement("tr")),
                                (n = g.createElement("div")),
                                (t.style.cssText = "position:absolute;left:-11111px"),
                                (i.style.height = "1px"),
                                (n.style.height = "9px"),
                                ie.appendChild(t).appendChild(i).appendChild(n),
                                (i = e.getComputedStyle(i)),
                                (He = 3 < parseInt(i.height)),
                                ie.removeChild(t)),
                            He
                        );
                    },
                }));
        var Ze = ["Webkit", "Moz", "ms"],
            Qe = g.createElement("div").style,
            Je = {};
        function et(e) {
            return (
                x.cssProps[e] ||
                Je[e] ||
                (e in Qe
                    ? e
                    : (Je[e] =
                          (function (e) {
                              for (var t = e[0].toUpperCase() + e.slice(1), n = Ze.length; n--; ) if ((e = Ze[n] + t) in Qe) return e;
                          })(e) || e))
            );
        }
        var tt = /^(none|table(?!-c[ea]).+)/,
            nt = /^--/,
            it = { position: "absolute", visibility: "hidden", display: "block" },
            ot = { letterSpacing: "0", fontWeight: "400" };
        function st(e, t, n) {
            var i = te.exec(t);
            return i ? Math.max(0, i[2] - (n || 0)) + (i[3] || "px") : t;
        }
        function rt(e, t, n, i, o, s) {
            var r = "width" === t ? 1 : 0,
                a = 0,
                l = 0;
            if (n === (i ? "border" : "content")) return 0;
            for (; r < 4; r += 2)
                "margin" === n && (l += x.css(e, n + ne[r], !0, o)),
                    i
                        ? ("content" === n && (l -= x.css(e, "padding" + ne[r], !0, o)), "margin" !== n && (l -= x.css(e, "border" + ne[r] + "Width", !0, o)))
                        : ((l += x.css(e, "padding" + ne[r], !0, o)), "padding" !== n ? (l += x.css(e, "border" + ne[r] + "Width", !0, o)) : (a += x.css(e, "border" + ne[r] + "Width", !0, o)));
            return !i && 0 <= s && (l += Math.max(0, Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - s - l - a - 0.5)) || 0), l;
        }
        function at(e, t, n) {
            var i = Ve(e),
                o = (!f.boxSizingReliable() || n) && "border-box" === x.css(e, "boxSizing", !1, i),
                s = o,
                r = Ge(e, t, i),
                a = "offset" + t[0].toUpperCase() + t.slice(1);
            if (Be.test(r)) {
                if (!n) return r;
                r = "auto";
            }
            return (
                ((!f.boxSizingReliable() && o) || (!f.reliableTrDimensions() && _(e, "tr")) || "auto" === r || (!parseFloat(r) && "inline" === x.css(e, "display", !1, i))) &&
                    e.getClientRects().length &&
                    ((o = "border-box" === x.css(e, "boxSizing", !1, i)), (s = a in e) && (r = e[a])),
                (r = parseFloat(r) || 0) + rt(e, t, n || (o ? "border" : "content"), s, i, r) + "px"
            );
        }
        function lt(e, t, n, i, o) {
            return new lt.prototype.init(e, t, n, i, o);
        }
        x.extend({
            cssHooks: {
                opacity: {
                    get: function (e, t) {
                        if (t) return "" === (e = Ge(e, "opacity")) ? "1" : e;
                    },
                },
            },
            cssNumber: {
                animationIterationCount: !0,
                columnCount: !0,
                fillOpacity: !0,
                flexGrow: !0,
                flexShrink: !0,
                fontWeight: !0,
                gridArea: !0,
                gridColumn: !0,
                gridColumnEnd: !0,
                gridColumnStart: !0,
                gridRow: !0,
                gridRowEnd: !0,
                gridRowStart: !0,
                lineHeight: !0,
                opacity: !0,
                order: !0,
                orphans: !0,
                widows: !0,
                zIndex: !0,
                zoom: !0,
            },
            cssProps: {},
            style: function (e, t, n, i) {
                if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
                    var o,
                        s,
                        r,
                        a = U(t),
                        l = nt.test(t),
                        c = e.style;
                    if ((l || (t = et(a)), (r = x.cssHooks[t] || x.cssHooks[a]), void 0 === n)) return r && "get" in r && void 0 !== (o = r.get(e, !1, i)) ? o : c[t];
                    "string" === (s = _typeof(n)) && (o = te.exec(n)) && o[1] && ((n = ae(e, t, o)), (s = "number")),
                        null != n &&
                            n == n &&
                            ("number" !== s || l || (n += (o && o[3]) || (x.cssNumber[a] ? "" : "px")),
                            f.clearCloneStyle || "" !== n || 0 !== t.indexOf("background") || (c[t] = "inherit"),
                            (r && "set" in r && void 0 === (n = r.set(e, n, i))) || (l ? c.setProperty(t, n) : (c[t] = n)));
                }
            },
            css: function (e, t, n, i) {
                var o,
                    s = U(t);
                return (
                    nt.test(t) || (t = et(s)),
                    "normal" === (o = void 0 === (o = (s = x.cssHooks[t] || x.cssHooks[s]) && "get" in s ? s.get(e, !0, n) : o) ? Ge(e, t, i) : o) && t in ot && (o = ot[t]),
                    "" === n || n ? ((t = parseFloat(o)), !0 === n || isFinite(t) ? t || 0 : o) : o
                );
            },
        }),
            x.each(["height", "width"], function (e, t) {
                x.cssHooks[t] = {
                    get: function (e, n, i) {
                        if (n)
                            return !tt.test(x.css(e, "display")) || (e.getClientRects().length && e.getBoundingClientRect().width)
                                ? at(e, t, i)
                                : ze(e, it, function () {
                                      return at(e, t, i);
                                  });
                    },
                    set: function (e, n, i) {
                        var o,
                            s = Ve(e),
                            r = !f.scrollboxSize() && "absolute" === s.position,
                            a = (r || i) && "border-box" === x.css(e, "boxSizing", !1, s);
                        return (
                            (i = i ? rt(e, t, i, a, s) : 0),
                            a && r && (i -= Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - parseFloat(s[t]) - rt(e, t, "border", !1, s) - 0.5)),
                            i && (o = te.exec(n)) && "px" !== (o[3] || "px") && ((e.style[t] = n), (n = x.css(e, t))),
                            st(0, n, i)
                        );
                    },
                };
            }),
            (x.cssHooks.marginLeft = Xe(f.reliableMarginLeft, function (e, t) {
                if (t)
                    return (
                        (parseFloat(Ge(e, "marginLeft")) ||
                            e.getBoundingClientRect().left -
                                ze(e, { marginLeft: 0 }, function () {
                                    return e.getBoundingClientRect().left;
                                })) + "px"
                    );
            })),
            x.each({ margin: "", padding: "", border: "Width" }, function (e, t) {
                (x.cssHooks[e + t] = {
                    expand: function (n) {
                        for (var i = 0, o = {}, s = "string" == typeof n ? n.split(" ") : [n]; i < 4; i++) o[e + ne[i] + t] = s[i] || s[i - 2] || s[0];
                        return o;
                    },
                }),
                    "margin" !== e && (x.cssHooks[e + t].set = st);
            }),
            x.fn.extend({
                css: function (e, t) {
                    return F(
                        this,
                        function (e, t, n) {
                            var i,
                                o,
                                s = {},
                                r = 0;
                            if (Array.isArray(t)) {
                                for (i = Ve(e), o = t.length; r < o; r++) s[t[r]] = x.css(e, t[r], !1, i);
                                return s;
                            }
                            return void 0 !== n ? x.style(e, t, n) : x.css(e, t);
                        },
                        e,
                        t,
                        1 < arguments.length
                    );
                },
            }),
            (((x.Tween = lt).prototype = {
                constructor: lt,
                init: function (e, t, n, i, o, s) {
                    (this.elem = e), (this.prop = n), (this.easing = o || x.easing._default), (this.options = t), (this.start = this.now = this.cur()), (this.end = i), (this.unit = s || (x.cssNumber[n] ? "" : "px"));
                },
                cur: function () {
                    var e = lt.propHooks[this.prop];
                    return (e && e.get ? e : lt.propHooks._default).get(this);
                },
                run: function (e) {
                    var t,
                        n = lt.propHooks[this.prop];
                    return (
                        this.options.duration ? (this.pos = t = x.easing[this.easing](e, this.options.duration * e, 0, 1, this.options.duration)) : (this.pos = t = e),
                        (this.now = (this.end - this.start) * t + this.start),
                        this.options.step && this.options.step.call(this.elem, this.now, this),
                        (n && n.set ? n : lt.propHooks._default).set(this),
                        this
                    );
                },
            }).init.prototype = lt.prototype),
            ((lt.propHooks = {
                _default: {
                    get: function (e) {
                        return 1 !== e.elem.nodeType || (null != e.elem[e.prop] && null == e.elem.style[e.prop]) ? e.elem[e.prop] : (e = x.css(e.elem, e.prop, "")) && "auto" !== e ? e : 0;
                    },
                    set: function (e) {
                        x.fx.step[e.prop] ? x.fx.step[e.prop](e) : 1 !== e.elem.nodeType || (!x.cssHooks[e.prop] && null == e.elem.style[et(e.prop)]) ? (e.elem[e.prop] = e.now) : x.style(e.elem, e.prop, e.now + e.unit);
                    },
                },
            }).scrollTop = lt.propHooks.scrollLeft = {
                set: function (e) {
                    e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now);
                },
            }),
            (x.easing = {
                linear: function (e) {
                    return e;
                },
                swing: function (e) {
                    return 0.5 - Math.cos(e * Math.PI) / 2;
                },
                _default: "swing",
            }),
            (x.fx = lt.prototype.init),
            (x.fx.step = {});
        var ct,
            dt,
            ut = /^(?:toggle|show|hide)$/,
            pt = /queueHooks$/;
        function ht() {
            dt && (!1 === g.hidden && e.requestAnimationFrame ? e.requestAnimationFrame(ht) : e.setTimeout(ht, x.fx.interval), x.fx.tick());
        }
        function ft() {
            return (
                e.setTimeout(function () {
                    ct = void 0;
                }),
                (ct = Date.now())
            );
        }
        function mt(e, t) {
            var n,
                i = 0,
                o = { height: e };
            for (t = t ? 1 : 0; i < 4; i += 2 - t) o["margin" + (n = ne[i])] = o["padding" + n] = e;
            return t && (o.opacity = o.width = e), o;
        }
        function gt(e, t, n) {
            for (var i, o = (vt.tweeners[t] || []).concat(vt.tweeners["*"]), s = 0, r = o.length; s < r; s++) if ((i = o[s].call(n, t, e))) return i;
        }
        function vt(e, t, n) {
            var i,
                o,
                s = 0,
                r = vt.prefilters.length,
                a = x.Deferred().always(function () {
                    delete l.elem;
                }),
                l = function () {
                    if (o) return !1;
                    for (var t = ct || ft(), n = 1 - ((t = Math.max(0, c.startTime + c.duration - t)) / c.duration || 0), i = 0, s = c.tweens.length; i < s; i++) c.tweens[i].run(n);
                    return a.notifyWith(e, [c, n, t]), n < 1 && s ? t : (s || a.notifyWith(e, [c, 1, 0]), a.resolveWith(e, [c]), !1);
                },
                c = a.promise({
                    elem: e,
                    props: x.extend({}, t),
                    opts: x.extend(!0, { specialEasing: {}, easing: x.easing._default }, n),
                    originalProperties: t,
                    originalOptions: n,
                    startTime: ct || ft(),
                    duration: n.duration,
                    tweens: [],
                    createTween: function (t, n) {
                        return (t = x.Tween(e, c.opts, t, n, c.opts.specialEasing[t] || c.opts.easing)), c.tweens.push(t), t;
                    },
                    stop: function (t) {
                        var n = 0,
                            i = t ? c.tweens.length : 0;
                        if (o) return this;
                        for (o = !0; n < i; n++) c.tweens[n].run(1);
                        return t ? (a.notifyWith(e, [c, 1, 0]), a.resolveWith(e, [c, t])) : a.rejectWith(e, [c, t]), this;
                    },
                }),
                d = c.props;
            for (
                (function (e, t) {
                    var n, i, o, s, r;
                    for (n in e)
                        if (((o = t[(i = U(n))]), (s = e[n]), Array.isArray(s) && ((o = s[1]), (s = e[n] = s[0])), n !== i && ((e[i] = s), delete e[n]), (r = x.cssHooks[i]) && ("expand" in r)))
                            for (n in ((s = r.expand(s)), delete e[i], s)) (n in e) || ((e[n] = s[n]), (t[n] = o));
                        else t[i] = o;
                })(d, c.opts.specialEasing);
                s < r;
                s++
            )
                if ((i = vt.prefilters[s].call(c, e, d, c.opts))) return m(i.stop) && (x._queueHooks(c.elem, c.opts.queue).stop = i.stop.bind(i)), i;
            return (
                x.map(d, gt, c),
                m(c.opts.start) && c.opts.start.call(e, c),
                c.progress(c.opts.progress).done(c.opts.done, c.opts.complete).fail(c.opts.fail).always(c.opts.always),
                x.fx.timer(x.extend(l, { elem: e, anim: c, queue: c.opts.queue })),
                c
            );
        }
        (x.Animation = x.extend(vt, {
            tweeners: {
                "*": [
                    function (e, t) {
                        var n = this.createTween(e, t);
                        return ae(n.elem, e, te.exec(t), n), n;
                    },
                ],
            },
            tweener: function (e, t) {
                for (var n, i = 0, o = (e = m(e) ? ((t = e), ["*"]) : e.match(z)).length; i < o; i++) (n = e[i]), (vt.tweeners[n] = vt.tweeners[n] || []), vt.tweeners[n].unshift(t);
            },
            prefilters: [
                function (e, t, n) {
                    var i,
                        o,
                        s,
                        r,
                        a,
                        l,
                        c,
                        d = "width" in t || "height" in t,
                        u = this,
                        p = {},
                        h = e.style,
                        f = e.nodeType && re(e),
                        m = Y.get(e, "fxshow");
                    for (i in (n.queue ||
                        (null == (r = x._queueHooks(e, "fx")).unqueued &&
                            ((r.unqueued = 0),
                            (a = r.empty.fire),
                            (r.empty.fire = function () {
                                r.unqueued || a();
                            })),
                        r.unqueued++,
                        u.always(function () {
                            u.always(function () {
                                r.unqueued--, x.queue(e, "fx").length || r.empty.fire();
                            });
                        })),
                    t))
                        if (((o = t[i]), ut.test(o))) {
                            if ((delete t[i], (s = s || "toggle" === o), o === (f ? "hide" : "show"))) {
                                if ("show" !== o || !m || void 0 === m[i]) continue;
                                f = !0;
                            }
                            p[i] = (m && m[i]) || x.style(e, i);
                        }
                    if ((l = !x.isEmptyObject(t)) || !x.isEmptyObject(p))
                        for (i in (d &&
                            1 === e.nodeType &&
                            ((n.overflow = [h.overflow, h.overflowX, h.overflowY]),
                            null == (c = m && m.display) && (c = Y.get(e, "display")),
                            "none" === (d = x.css(e, "display")) && (c ? (d = c) : (ce([e], !0), (c = e.style.display || c), (d = x.css(e, "display")), ce([e]))),
                            ("inline" === d || ("inline-block" === d && null != c)) &&
                                "none" === x.css(e, "float") &&
                                (l ||
                                    (u.done(function () {
                                        h.display = c;
                                    }),
                                    null == c && ((d = h.display), (c = "none" === d ? "" : d))),
                                (h.display = "inline-block"))),
                        n.overflow &&
                            ((h.overflow = "hidden"),
                            u.always(function () {
                                (h.overflow = n.overflow[0]), (h.overflowX = n.overflow[1]), (h.overflowY = n.overflow[2]);
                            })),
                        (l = !1),
                        p))
                            l ||
                                (m ? "hidden" in m && (f = m.hidden) : (m = Y.access(e, "fxshow", { display: c })),
                                s && (m.hidden = !f),
                                f && ce([e], !0),
                                u.done(function () {
                                    for (i in (f || ce([e]), Y.remove(e, "fxshow"), p)) x.style(e, i, p[i]);
                                })),
                                (l = gt(f ? m[i] : 0, i, u)),
                                i in m || ((m[i] = l.start), f && ((l.end = l.start), (l.start = 0)));
                },
            ],
            prefilter: function (e, t) {
                t ? vt.prefilters.unshift(e) : vt.prefilters.push(e);
            },
        })),
            (x.speed = function (e, t, n) {
                var i = e && "object" == _typeof(e) ? x.extend({}, e) : { complete: n || (!n && t) || (m(e) && e), duration: e, easing: (n && t) || (t && !m(t) && t) };
                return (
                    x.fx.off ? (i.duration = 0) : "number" != typeof i.duration && (i.duration in x.fx.speeds ? (i.duration = x.fx.speeds[i.duration]) : (i.duration = x.fx.speeds._default)),
                    (null != i.queue && !0 !== i.queue) || (i.queue = "fx"),
                    (i.old = i.complete),
                    (i.complete = function () {
                        m(i.old) && i.old.call(this), i.queue && x.dequeue(this, i.queue);
                    }),
                    i
                );
            }),
            x.fn.extend({
                fadeTo: function (e, t, n, i) {
                    return this.filter(re).css("opacity", 0).show().end().animate({ opacity: t }, e, n, i);
                },
                animate: function (e, t, n, i) {
                    var o = x.isEmptyObject(e),
                        s = x.speed(t, n, i);
                    return (
                        (i = function () {
                            var t = vt(this, x.extend({}, e), s);
                            (o || Y.get(this, "finish")) && t.stop(!0);
                        }),
                        (i.finish = i),
                        o || !1 === s.queue ? this.each(i) : this.queue(s.queue, i)
                    );
                },
                stop: function (e, t, n) {
                    function i(e) {
                        var t = e.stop;
                        delete e.stop, t(n);
                    }
                    return (
                        "string" != typeof e && ((n = t), (t = e), (e = void 0)),
                        t && this.queue(e || "fx", []),
                        this.each(function () {
                            var t = !0,
                                o = null != e && e + "queueHooks",
                                s = x.timers,
                                r = Y.get(this);
                            if (o) r[o] && r[o].stop && i(r[o]);
                            else for (o in r) r[o] && r[o].stop && pt.test(o) && i(r[o]);
                            for (o = s.length; o--; ) s[o].elem !== this || (null != e && s[o].queue !== e) || (s[o].anim.stop(n), (t = !1), s.splice(o, 1));
                            (!t && n) || x.dequeue(this, e);
                        })
                    );
                },
                finish: function (e) {
                    return (
                        !1 !== e && (e = e || "fx"),
                        this.each(function () {
                            var t,
                                n = Y.get(this),
                                i = n[e + "queue"],
                                o = n[e + "queueHooks"],
                                s = x.timers,
                                r = i ? i.length : 0;
                            for (n.finish = !0, x.queue(this, e, []), o && o.stop && o.stop.call(this, !0), t = s.length; t--; ) s[t].elem === this && s[t].queue === e && (s[t].anim.stop(!0), s.splice(t, 1));
                            for (t = 0; t < r; t++) i[t] && i[t].finish && i[t].finish.call(this);
                            delete n.finish;
                        })
                    );
                },
            }),
            x.each(["toggle", "show", "hide"], function (e, t) {
                var n = x.fn[t];
                x.fn[t] = function (e, i, o) {
                    return null == e || "boolean" == typeof e ? n.apply(this, arguments) : this.animate(mt(t, !0), e, i, o);
                };
            }),
            x.each({ slideDown: mt("show"), slideUp: mt("hide"), slideToggle: mt("toggle"), fadeIn: { opacity: "show" }, fadeOut: { opacity: "hide" }, fadeToggle: { opacity: "toggle" } }, function (e, t) {
                x.fn[e] = function (e, n, i) {
                    return this.animate(t, e, n, i);
                };
            }),
            (x.timers = []),
            (x.fx.tick = function () {
                var e,
                    t = 0,
                    n = x.timers;
                for (ct = Date.now(); t < n.length; t++) (e = n[t])() || n[t] !== e || n.splice(t--, 1);
                n.length || x.fx.stop(), (ct = void 0);
            }),
            (x.fx.timer = function (e) {
                x.timers.push(e), x.fx.start();
            }),
            (x.fx.interval = 13),
            (x.fx.start = function () {
                dt || ((dt = !0), ht());
            }),
            (x.fx.stop = function () {
                dt = null;
            }),
            (x.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
            (x.fn.delay = function (t, n) {
                return (
                    (t = (x.fx && x.fx.speeds[t]) || t),
                    this.queue((n = n || "fx"), function (n, i) {
                        var o = e.setTimeout(n, t);
                        i.stop = function () {
                            e.clearTimeout(o);
                        };
                    })
                );
            }),
            (w = g.createElement("input")),
            (ee = g.createElement("select").appendChild(g.createElement("option"))),
            (w.type = "checkbox"),
            (f.checkOn = "" !== w.value),
            (f.optSelected = ee.selected),
            ((w = g.createElement("input")).value = "t"),
            (w.type = "radio"),
            (f.radioValue = "t" === w.value);
        var yt,
            bt = x.expr.attrHandle;
        x.fn.extend({
            attr: function (e, t) {
                return F(this, x.attr, e, t, 1 < arguments.length);
            },
            removeAttr: function (e) {
                return this.each(function () {
                    x.removeAttr(this, e);
                });
            },
        }),
            x.extend({
                attr: function (e, t, n) {
                    var i,
                        o,
                        s = e.nodeType;
                    if (3 !== s && 8 !== s && 2 !== s)
                        return void 0 === e.getAttribute
                            ? x.prop(e, t, n)
                            : ((1 === s && x.isXMLDoc(e)) || (o = x.attrHooks[t.toLowerCase()] || (x.expr.match.bool.test(t) ? yt : void 0)),
                              void 0 !== n
                                  ? null === n
                                      ? void x.removeAttr(e, t)
                                      : o && "set" in o && void 0 !== (i = o.set(e, n, t))
                                      ? i
                                      : (e.setAttribute(t, n + ""), n)
                                  : (o && "get" in o && null !== (i = o.get(e, t))) || null != (i = x.find.attr(e, t))
                                  ? i
                                  : void 0);
                },
                attrHooks: {
                    type: {
                        set: function (e, t) {
                            if (!f.radioValue && "radio" === t && _(e, "input")) {
                                var n = e.value;
                                return e.setAttribute("type", t), n && (e.value = n), t;
                            }
                        },
                    },
                },
                removeAttr: function (e, t) {
                    var n,
                        i = 0,
                        o = t && t.match(z);
                    if (o && 1 === e.nodeType) for (; (n = o[i++]); ) e.removeAttribute(n);
                },
            }),
            (yt = {
                set: function (e, t, n) {
                    return !1 === t ? x.removeAttr(e, n) : e.setAttribute(n, n), n;
                },
            }),
            x.each(x.expr.match.bool.source.match(/\w+/g), function (e, t) {
                var n = bt[t] || x.find.attr;
                bt[t] = function (e, t, i) {
                    var o,
                        s,
                        r = t.toLowerCase();
                    return i || ((s = bt[r]), (bt[r] = o), (o = null != n(e, t, i) ? r : null), (bt[r] = s)), o;
                };
            });
        var wt = /^(?:input|select|textarea|button)$/i,
            xt = /^(?:a|area)$/i;
        function Tt(e) {
            return (e.match(z) || []).join(" ");
        }
        function Ct(e) {
            return (e.getAttribute && e.getAttribute("class")) || "";
        }
        function St(e) {
            return Array.isArray(e) ? e : ("string" == typeof e && e.match(z)) || [];
        }
        x.fn.extend({
            prop: function (e, t) {
                return F(this, x.prop, e, t, 1 < arguments.length);
            },
            removeProp: function (e) {
                return this.each(function () {
                    delete this[x.propFix[e] || e];
                });
            },
        }),
            x.extend({
                prop: function (e, t, n) {
                    var i,
                        o,
                        s = e.nodeType;
                    if (3 !== s && 8 !== s && 2 !== s)
                        return (
                            (1 === s && x.isXMLDoc(e)) || ((t = x.propFix[t] || t), (o = x.propHooks[t])),
                            void 0 !== n ? (o && "set" in o && void 0 !== (i = o.set(e, n, t)) ? i : (e[t] = n)) : o && "get" in o && null !== (i = o.get(e, t)) ? i : e[t]
                        );
                },
                propHooks: {
                    tabIndex: {
                        get: function (e) {
                            var t = x.find.attr(e, "tabindex");
                            return t ? parseInt(t, 10) : wt.test(e.nodeName) || (xt.test(e.nodeName) && e.href) ? 0 : -1;
                        },
                    },
                },
                propFix: { for: "htmlFor", class: "className" },
            }),
            f.optSelected ||
                (x.propHooks.selected = {
                    get: function (e) {
                        return (e = e.parentNode) && e.parentNode && e.parentNode.selectedIndex, null;
                    },
                    set: function (e) {
                        (e = e.parentNode) && (e.selectedIndex, e.parentNode && e.parentNode.selectedIndex);
                    },
                }),
            x.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function () {
                x.propFix[this.toLowerCase()] = this;
            }),
            x.fn.extend({
                addClass: function (e) {
                    var t,
                        n,
                        i,
                        o,
                        s,
                        r,
                        a = 0;
                    if (m(e))
                        return this.each(function (t) {
                            x(this).addClass(e.call(this, t, Ct(this)));
                        });
                    if ((t = St(e)).length)
                        for (; (n = this[a++]); )
                            if (((r = Ct(n)), (i = 1 === n.nodeType && " " + Tt(r) + " "))) {
                                for (s = 0; (o = t[s++]); ) i.indexOf(" " + o + " ") < 0 && (i += o + " ");
                                r !== (r = Tt(i)) && n.setAttribute("class", r);
                            }
                    return this;
                },
                removeClass: function (e) {
                    var t,
                        n,
                        i,
                        o,
                        s,
                        r,
                        a = 0;
                    if (m(e))
                        return this.each(function (t) {
                            x(this).removeClass(e.call(this, t, Ct(this)));
                        });
                    if (!arguments.length) return this.attr("class", "");
                    if ((t = St(e)).length)
                        for (; (n = this[a++]); )
                            if (((r = Ct(n)), (i = 1 === n.nodeType && " " + Tt(r) + " "))) {
                                for (s = 0; (o = t[s++]); ) for (; -1 < i.indexOf(" " + o + " "); ) i = i.replace(" " + o + " ", " ");
                                r !== (r = Tt(i)) && n.setAttribute("class", r);
                            }
                    return this;
                },
                toggleClass: function (e, t) {
                    var n = _typeof(e),
                        i = "string" === n || Array.isArray(e);
                    return "boolean" == typeof t && i
                        ? t
                            ? this.addClass(e)
                            : this.removeClass(e)
                        : m(e)
                        ? this.each(function (n) {
                              x(this).toggleClass(e.call(this, n, Ct(this), t), t);
                          })
                        : this.each(function () {
                              var t, o, s, r;
                              if (i) for (o = 0, s = x(this), r = St(e); (t = r[o++]); ) s.hasClass(t) ? s.removeClass(t) : s.addClass(t);
                              else (void 0 !== e && "boolean" !== n) || ((t = Ct(this)) && Y.set(this, "__className__", t), this.setAttribute && this.setAttribute("class", (!t && !1 !== e && Y.get(this, "__className__")) || ""));
                          });
                },
                hasClass: function (e) {
                    for (var t, n = 0, i = " " + e + " "; (t = this[n++]); ) if (1 === t.nodeType && -1 < (" " + Tt(Ct(t)) + " ").indexOf(i)) return !0;
                    return !1;
                },
            });
        var kt = /\r/g;
        function $t(e) {
            e.stopPropagation();
        }
        x.fn.extend({
            val: function (e) {
                var t,
                    n,
                    i,
                    o = this[0];
                return arguments.length
                    ? ((i = m(e)),
                      this.each(function (n) {
                          1 === this.nodeType &&
                              (null == (n = i ? e.call(this, n, x(this).val()) : e)
                                  ? (n = "")
                                  : "number" == typeof n
                                  ? (n += "")
                                  : Array.isArray(n) &&
                                    (n = x.map(n, function (e) {
                                        return null == e ? "" : e + "";
                                    })),
                              ((t = x.valHooks[this.type] || x.valHooks[this.nodeName.toLowerCase()]) && "set" in t && void 0 !== t.set(this, n, "value")) || (this.value = n));
                      }))
                    : o
                    ? (t = x.valHooks[o.type] || x.valHooks[o.nodeName.toLowerCase()]) && "get" in t && void 0 !== (n = t.get(o, "value"))
                        ? n
                        : "string" == typeof (n = o.value)
                        ? n.replace(kt, "")
                        : null == n
                        ? ""
                        : n
                    : void 0;
            },
        }),
            x.extend({
                valHooks: {
                    option: {
                        get: function (e) {
                            var t = x.find.attr(e, "value");
                            return null != t ? t : Tt(x.text(e));
                        },
                    },
                    select: {
                        get: function (e) {
                            for (var t, n = e.options, i = e.selectedIndex, o = "select-one" === e.type, s = o ? null : [], r = o ? i + 1 : n.length, a = i < 0 ? r : o ? i : 0; a < r; a++)
                                if (((t = n[a]).selected || a === i) && !t.disabled && (!t.parentNode.disabled || !_(t.parentNode, "optgroup"))) {
                                    if (((t = x(t).val()), o)) return t;
                                    s.push(t);
                                }
                            return s;
                        },
                        set: function (e, t) {
                            for (var n, i, o = e.options, s = x.makeArray(t), r = o.length; r--; ) ((i = o[r]).selected = -1 < x.inArray(x.valHooks.option.get(i), s)) && (n = !0);
                            return n || (e.selectedIndex = -1), s;
                        },
                    },
                },
            }),
            x.each(["radio", "checkbox"], function () {
                (x.valHooks[this] = {
                    set: function (e, t) {
                        if (Array.isArray(t)) return (e.checked = -1 < x.inArray(x(e).val(), t));
                    },
                }),
                    f.checkOn ||
                        (x.valHooks[this].get = function (e) {
                            return null === e.getAttribute("value") ? "on" : e.value;
                        });
            }),
            (f.focusin = "onfocusin" in e);
        var _t = /^(?:focusinfocus|focusoutblur)$/;
        x.extend(x.event, {
            trigger: function (t, i, o, s) {
                var r,
                    a,
                    l,
                    c,
                    d,
                    p,
                    h,
                    f = [o || g],
                    v = u.call(t, "type") ? t.type : t,
                    y = u.call(t, "namespace") ? t.namespace.split(".") : [],
                    b = (h = a = o = o || g);
                if (
                    3 !== o.nodeType &&
                    8 !== o.nodeType &&
                    !_t.test(v + x.event.triggered) &&
                    (-1 < v.indexOf(".") && ((v = (y = v.split(".")).shift()), y.sort()),
                    (c = v.indexOf(":") < 0 && "on" + v),
                    ((t = t[x.expando] ? t : new x.Event(v, "object" == _typeof(t) && t)).isTrigger = s ? 2 : 3),
                    (t.namespace = y.join(".")),
                    (t.rnamespace = t.namespace ? new RegExp("(^|\\.)" + y.join("\\.(?:.*\\.|)") + "(\\.|$)") : null),
                    (t.result = void 0),
                    t.target || (t.target = o),
                    (i = null == i ? [t] : x.makeArray(i, [t])),
                    (p = x.event.special[v] || {}),
                    s || !p.trigger || !1 !== p.trigger.apply(o, i))
                ) {
                    if (!s && !p.noBubble && !n(o)) {
                        for (l = p.delegateType || v, _t.test(l + v) || (b = b.parentNode); b; b = b.parentNode) f.push(b), (a = b);
                        a === (o.ownerDocument || g) && f.push(a.defaultView || a.parentWindow || e);
                    }
                    for (r = 0; (b = f[r++]) && !t.isPropagationStopped(); )
                        (h = b),
                            (t.type = 1 < r ? l : p.bindType || v),
                            (d = (Y.get(b, "events") || Object.create(null))[t.type] && Y.get(b, "handle")) && d.apply(b, i),
                            (d = c && b[c]) && d.apply && G(b) && ((t.result = d.apply(b, i)), !1 === t.result && t.preventDefault());
                    return (
                        (t.type = v),
                        s ||
                            t.isDefaultPrevented() ||
                            (p._default && !1 !== p._default.apply(f.pop(), i)) ||
                            !G(o) ||
                            (c &&
                                m(o[v]) &&
                                !n(o) &&
                                ((a = o[c]) && (o[c] = null),
                                (x.event.triggered = v),
                                t.isPropagationStopped() && h.addEventListener(v, $t),
                                o[v](),
                                t.isPropagationStopped() && h.removeEventListener(v, $t),
                                (x.event.triggered = void 0),
                                a && (o[c] = a))),
                        t.result
                    );
                }
            },
            simulate: function (e, t, n) {
                (e = x.extend(new x.Event(), n, { type: e, isSimulated: !0 })), x.event.trigger(e, null, t);
            },
        }),
            x.fn.extend({
                trigger: function (e, t) {
                    return this.each(function () {
                        x.event.trigger(e, t, this);
                    });
                },
                triggerHandler: function (e, t) {
                    var n = this[0];
                    if (n) return x.event.trigger(e, t, n, !0);
                },
            }),
            f.focusin ||
                x.each({ focus: "focusin", blur: "focusout" }, function (e, t) {
                    function n(e) {
                        x.event.simulate(t, e.target, x.event.fix(e));
                    }
                    x.event.special[t] = {
                        setup: function () {
                            var i = this.ownerDocument || this.document || this,
                                o = Y.access(i, t);
                            o || i.addEventListener(e, n, !0), Y.access(i, t, (o || 0) + 1);
                        },
                        teardown: function () {
                            var i = this.ownerDocument || this.document || this,
                                o = Y.access(i, t) - 1;
                            o ? Y.access(i, t, o) : (i.removeEventListener(e, n, !0), Y.remove(i, t));
                        },
                    };
                });
        var Et = e.location,
            At = { guid: Date.now() },
            Mt = /\?/;
        x.parseXML = function (t) {
            var n;
            if (!t || "string" != typeof t) return null;
            try {
                n = new e.DOMParser().parseFromString(t, "text/xml");
            } catch (t) {
                n = void 0;
            }
            return (n && !n.getElementsByTagName("parsererror").length) || x.error("Invalid XML: " + t), n;
        };
        var Pt = /\[\]$/,
            Lt = /\r?\n/g,
            Dt = /^(?:submit|button|image|reset|file)$/i,
            Ot = /^(?:input|select|textarea|keygen)/i;
        (x.param = function (e, t) {
            function n(e, t) {
                (t = m(t) ? t() : t), (o[o.length] = encodeURIComponent(e) + "=" + encodeURIComponent(null == t ? "" : t));
            }
            var i,
                o = [];
            if (null == e) return "";
            if (Array.isArray(e) || (e.jquery && !x.isPlainObject(e)))
                x.each(e, function () {
                    n(this.name, this.value);
                });
            else
                for (i in e)
                    !(function e(t, n, i, o) {
                        if (Array.isArray(n))
                            x.each(n, function (n, s) {
                                i || Pt.test(t) ? o(t, s) : e(t + "[" + ("object" == _typeof(s) && null != s ? n : "") + "]", s, i, o);
                            });
                        else if (i || "object" !== b(n)) o(t, n);
                        else for (var s in n) e(t + "[" + s + "]", n[s], i, o);
                    })(i, e[i], t, n);
            return o.join("&");
        }),
            x.fn.extend({
                serialize: function () {
                    return x.param(this.serializeArray());
                },
                serializeArray: function () {
                    return this.map(function () {
                        var e = x.prop(this, "elements");
                        return e ? x.makeArray(e) : this;
                    })
                        .filter(function () {
                            var e = this.type;
                            return this.name && !x(this).is(":disabled") && Ot.test(this.nodeName) && !Dt.test(e) && (this.checked || !de.test(e));
                        })
                        .map(function (e, t) {
                            var n = x(this).val();
                            return null == n
                                ? null
                                : Array.isArray(n)
                                ? x.map(n, function (e) {
                                      return { name: t.name, value: e.replace(Lt, "\r\n") };
                                  })
                                : { name: t.name, value: n.replace(Lt, "\r\n") };
                        })
                        .get();
                },
            });
        var zt = /%20/g,
            It = /#.*$/,
            Nt = /([?&])_=[^&]*/,
            jt = /^(.*?):[ \t]*([^\r\n]*)$/gm,
            Rt = /^(?:GET|HEAD)$/,
            Ht = /^\/\//,
            qt = {},
            Ft = {},
            Wt = "*/".concat("*"),
            Bt = g.createElement("a");
        function Vt(e) {
            return function (t, n) {
                "string" != typeof t && ((n = t), (t = "*"));
                var i,
                    o = 0,
                    s = t.toLowerCase().match(z) || [];
                if (m(n)) for (; (i = s[o++]); ) "+" === i[0] ? ((i = i.slice(1) || "*"), (e[i] = e[i] || []).unshift(n)) : (e[i] = e[i] || []).push(n);
            };
        }
        function Ut(e, t, n, i) {
            var o = {},
                s = e === Ft;
            function r(a) {
                var l;
                return (
                    (o[a] = !0),
                    x.each(e[a] || [], function (e, a) {
                        return "string" != typeof (a = a(t, n, i)) || s || o[a] ? (s ? !(l = a) : void 0) : (t.dataTypes.unshift(a), r(a), !1);
                    }),
                    l
                );
            }
            return r(t.dataTypes[0]) || (!o["*"] && r("*"));
        }
        function Gt(e, t) {
            var n,
                i,
                o = x.ajaxSettings.flatOptions || {};
            for (n in t) void 0 !== t[n] && ((o[n] ? e : (i = i || {}))[n] = t[n]);
            return i && x.extend(!0, e, i), e;
        }
        (Bt.href = Et.href),
            x.extend({
                active: 0,
                lastModified: {},
                etag: {},
                ajaxSettings: {
                    url: Et.href,
                    type: "GET",
                    isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(Et.protocol),
                    global: !0,
                    processData: !0,
                    async: !0,
                    contentType: "application/x-www-form-urlencoded; charset=UTF-8",
                    accepts: { "*": Wt, text: "text/plain", html: "text/html", xml: "application/xml, text/xml", json: "application/json, text/javascript" },
                    contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ },
                    responseFields: { xml: "responseXML", text: "responseText", json: "responseJSON" },
                    converters: { "* text": String, "text html": !0, "text json": JSON.parse, "text xml": x.parseXML },
                    flatOptions: { url: !0, context: !0 },
                },
                ajaxSetup: function (e, t) {
                    return t ? Gt(Gt(e, x.ajaxSettings), t) : Gt(x.ajaxSettings, e);
                },
                ajaxPrefilter: Vt(qt),
                ajaxTransport: Vt(Ft),
                ajax: function (t, n) {
                    "object" == _typeof(t) && ((n = t), (t = void 0));
                    var i,
                        o,
                        s,
                        r,
                        a,
                        l,
                        c,
                        d,
                        u,
                        p = x.ajaxSetup({}, (n = n || {})),
                        h = p.context || p,
                        f = p.context && (h.nodeType || h.jquery) ? x(h) : x.event,
                        m = x.Deferred(),
                        v = x.Callbacks("once memory"),
                        y = p.statusCode || {},
                        b = {},
                        w = {},
                        T = "canceled",
                        C = {
                            readyState: 0,
                            getResponseHeader: function (e) {
                                var t;
                                if (l) {
                                    if (!r) for (r = {}; (t = jt.exec(s)); ) r[t[1].toLowerCase() + " "] = (r[t[1].toLowerCase() + " "] || []).concat(t[2]);
                                    t = r[e.toLowerCase() + " "];
                                }
                                return null == t ? null : t.join(", ");
                            },
                            getAllResponseHeaders: function () {
                                return l ? s : null;
                            },
                            setRequestHeader: function (e, t) {
                                return null == l && ((e = w[e.toLowerCase()] = w[e.toLowerCase()] || e), (b[e] = t)), this;
                            },
                            overrideMimeType: function (e) {
                                return null == l && (p.mimeType = e), this;
                            },
                            statusCode: function (e) {
                                if (e)
                                    if (l) C.always(e[C.status]);
                                    else for (var t in e) y[t] = [y[t], e[t]];
                                return this;
                            },
                            abort: function (e) {
                                return (e = e || T), i && i.abort(e), S(0, e), this;
                            },
                        };
                    if (
                        (m.promise(C),
                        (p.url = ((t || p.url || Et.href) + "").replace(Ht, Et.protocol + "//")),
                        (p.type = n.method || n.type || p.method || p.type),
                        (p.dataTypes = (p.dataType || "*").toLowerCase().match(z) || [""]),
                        null == p.crossDomain)
                    ) {
                        u = g.createElement("a");
                        try {
                            (u.href = p.url), (u.href = u.href), (p.crossDomain = Bt.protocol + "//" + Bt.host != u.protocol + "//" + u.host);
                        } catch (t) {
                            p.crossDomain = !0;
                        }
                    }
                    if ((p.data && p.processData && "string" != typeof p.data && (p.data = x.param(p.data, p.traditional)), Ut(qt, p, n, C), l)) return C;
                    for (d in ((c = x.event && p.global) && 0 == x.active++ && x.event.trigger("ajaxStart"),
                    (p.type = p.type.toUpperCase()),
                    (p.hasContent = !Rt.test(p.type)),
                    (o = p.url.replace(It, "")),
                    p.hasContent
                        ? p.data && p.processData && 0 === (p.contentType || "").indexOf("application/x-www-form-urlencoded") && (p.data = p.data.replace(zt, "+"))
                        : ((u = p.url.slice(o.length)),
                          p.data && (p.processData || "string" == typeof p.data) && ((o += (Mt.test(o) ? "&" : "?") + p.data), delete p.data),
                          !1 === p.cache && ((o = o.replace(Nt, "$1")), (u = (Mt.test(o) ? "&" : "?") + "_=" + At.guid++ + u)),
                          (p.url = o + u)),
                    p.ifModified && (x.lastModified[o] && C.setRequestHeader("If-Modified-Since", x.lastModified[o]), x.etag[o] && C.setRequestHeader("If-None-Match", x.etag[o])),
                    ((p.data && p.hasContent && !1 !== p.contentType) || n.contentType) && C.setRequestHeader("Content-Type", p.contentType),
                    C.setRequestHeader("Accept", p.dataTypes[0] && p.accepts[p.dataTypes[0]] ? p.accepts[p.dataTypes[0]] + ("*" !== p.dataTypes[0] ? ", " + Wt + "; q=0.01" : "") : p.accepts["*"]),
                    p.headers))
                        C.setRequestHeader(d, p.headers[d]);
                    if (p.beforeSend && (!1 === p.beforeSend.call(h, C, p) || l)) return C.abort();
                    if (((T = "abort"), v.add(p.complete), C.done(p.success), C.fail(p.error), (i = Ut(Ft, p, n, C)))) {
                        if (((C.readyState = 1), c && f.trigger("ajaxSend", [C, p]), l)) return C;
                        p.async &&
                            0 < p.timeout &&
                            (a = e.setTimeout(function () {
                                C.abort("timeout");
                            }, p.timeout));
                        try {
                            (l = !1), i.send(b, S);
                        } catch (t) {
                            if (l) throw t;
                            S(-1, t);
                        }
                    } else S(-1, "No Transport");
                    function S(t, n, r, d) {
                        var u,
                            g,
                            b,
                            w = n;
                        l ||
                            ((l = !0),
                            a && e.clearTimeout(a),
                            (i = void 0),
                            (s = d || ""),
                            (C.readyState = 0 < t ? 4 : 0),
                            (d = (200 <= t && t < 300) || 304 === t),
                            r &&
                                (b = (function (e, t, n) {
                                    for (var i, o, s, r, a = e.contents, l = e.dataTypes; "*" === l[0]; ) l.shift(), void 0 === i && (i = e.mimeType || t.getResponseHeader("Content-Type"));
                                    if (i)
                                        for (o in a)
                                            if (a[o] && a[o].test(i)) {
                                                l.unshift(o);
                                                break;
                                            }
                                    if (l[0] in n) s = l[0];
                                    else {
                                        for (o in n) {
                                            if (!l[0] || e.converters[o + " " + l[0]]) {
                                                s = o;
                                                break;
                                            }
                                            r = r || o;
                                        }
                                        s = s || r;
                                    }
                                    if (s) return s !== l[0] && l.unshift(s), n[s];
                                })(p, C, r)),
                            !d && -1 < x.inArray("script", p.dataTypes) && (p.converters["text script"] = function () {}),
                            (b = (function (e, t, n, i) {
                                var o,
                                    s,
                                    r,
                                    a,
                                    l,
                                    c = {},
                                    d = e.dataTypes.slice();
                                if (d[1]) for (r in e.converters) c[r.toLowerCase()] = e.converters[r];
                                for (s = d.shift(); s; )
                                    if ((e.responseFields[s] && (n[e.responseFields[s]] = t), !l && i && e.dataFilter && (t = e.dataFilter(t, e.dataType)), (l = s), (s = d.shift())))
                                        if ("*" === s) s = l;
                                        else if ("*" !== l && l !== s) {
                                            if (!(r = c[l + " " + s] || c["* " + s]))
                                                for (o in c)
                                                    if ((a = o.split(" "))[1] === s && (r = c[l + " " + a[0]] || c["* " + a[0]])) {
                                                        !0 === r ? (r = c[o]) : !0 !== c[o] && ((s = a[0]), d.unshift(a[1]));
                                                        break;
                                                    }
                                            if (!0 !== r)
                                                if (r && e.throws) t = r(t);
                                                else
                                                    try {
                                                        t = r(t);
                                                    } catch (e) {
                                                        return { state: "parsererror", error: r ? e : "No conversion from " + l + " to " + s };
                                                    }
                                        }
                                return { state: "success", data: t };
                            })(p, b, C, d)),
                            d
                                ? (p.ifModified && ((r = C.getResponseHeader("Last-Modified")) && (x.lastModified[o] = r), (r = C.getResponseHeader("etag")) && (x.etag[o] = r)),
                                  204 === t || "HEAD" === p.type ? (w = "nocontent") : 304 === t ? (w = "notmodified") : ((w = b.state), (u = b.data), (d = !(g = b.error))))
                                : ((g = w), (!t && w) || ((w = "error"), t < 0 && (t = 0))),
                            (C.status = t),
                            (C.statusText = (n || w) + ""),
                            d ? m.resolveWith(h, [u, w, C]) : m.rejectWith(h, [C, w, g]),
                            C.statusCode(y),
                            (y = void 0),
                            c && f.trigger(d ? "ajaxSuccess" : "ajaxError", [C, p, d ? u : g]),
                            v.fireWith(h, [C, w]),
                            c && (f.trigger("ajaxComplete", [C, p]), --x.active || x.event.trigger("ajaxStop")));
                    }
                    return C;
                },
                getJSON: function (e, t, n) {
                    return x.get(e, t, n, "json");
                },
                getScript: function (e, t) {
                    return x.get(e, void 0, t, "script");
                },
            }),
            x.each(["get", "post"], function (e, t) {
                x[t] = function (e, n, i, o) {
                    return m(n) && ((o = o || i), (i = n), (n = void 0)), x.ajax(x.extend({ url: e, type: t, dataType: o, data: n, success: i }, x.isPlainObject(e) && e));
                };
            }),
            x.ajaxPrefilter(function (e) {
                for (var t in e.headers) "content-type" === t.toLowerCase() && (e.contentType = e.headers[t] || "");
            }),
            (x._evalUrl = function (e, t, n) {
                return x.ajax({
                    url: e,
                    type: "GET",
                    dataType: "script",
                    cache: !0,
                    async: !1,
                    global: !1,
                    converters: { "text script": function () {} },
                    dataFilter: function (e) {
                        x.globalEval(e, t, n);
                    },
                });
            }),
            x.fn.extend({
                wrapAll: function (e) {
                    return (
                        this[0] &&
                            (m(e) && (e = e.call(this[0])),
                            (e = x(e, this[0].ownerDocument).eq(0).clone(!0)),
                            this[0].parentNode && e.insertBefore(this[0]),
                            e
                                .map(function () {
                                    for (var e = this; e.firstElementChild; ) e = e.firstElementChild;
                                    return e;
                                })
                                .append(this)),
                        this
                    );
                },
                wrapInner: function (e) {
                    return m(e)
                        ? this.each(function (t) {
                              x(this).wrapInner(e.call(this, t));
                          })
                        : this.each(function () {
                              var t = x(this),
                                  n = t.contents();
                              n.length ? n.wrapAll(e) : t.append(e);
                          });
                },
                wrap: function (e) {
                    var t = m(e);
                    return this.each(function (n) {
                        x(this).wrapAll(t ? e.call(this, n) : e);
                    });
                },
                unwrap: function (e) {
                    return (
                        this.parent(e)
                            .not("body")
                            .each(function () {
                                x(this).replaceWith(this.childNodes);
                            }),
                        this
                    );
                },
            }),
            (x.expr.pseudos.hidden = function (e) {
                return !x.expr.pseudos.visible(e);
            }),
            (x.expr.pseudos.visible = function (e) {
                return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length);
            }),
            (x.ajaxSettings.xhr = function () {
                try {
                    return new e.XMLHttpRequest();
                } catch (e) {}
            });
        var Xt = { 0: 200, 1223: 204 },
            Yt = x.ajaxSettings.xhr();
        (f.cors = !!Yt && "withCredentials" in Yt),
            (f.ajax = Yt = !!Yt),
            x.ajaxTransport(function (t) {
                var n, i;
                if (f.cors || (Yt && !t.crossDomain))
                    return {
                        send: function (o, s) {
                            var r,
                                a = t.xhr();
                            if ((a.open(t.type, t.url, t.async, t.username, t.password), t.xhrFields)) for (r in t.xhrFields) a[r] = t.xhrFields[r];
                            for (r in (t.mimeType && a.overrideMimeType && a.overrideMimeType(t.mimeType), t.crossDomain || o["X-Requested-With"] || (o["X-Requested-With"] = "XMLHttpRequest"), o)) a.setRequestHeader(r, o[r]);
                            (n = function (e) {
                                return function () {
                                    n &&
                                        ((n = i = a.onload = a.onerror = a.onabort = a.ontimeout = a.onreadystatechange = null),
                                        "abort" === e
                                            ? a.abort()
                                            : "error" === e
                                            ? "number" != typeof a.status
                                                ? s(0, "error")
                                                : s(a.status, a.statusText)
                                            : s(
                                                  Xt[a.status] || a.status,
                                                  a.statusText,
                                                  "text" !== (a.responseType || "text") || "string" != typeof a.responseText ? { binary: a.response } : { text: a.responseText },
                                                  a.getAllResponseHeaders()
                                              ));
                                };
                            }),
                                (a.onload = n()),
                                (i = a.onerror = a.ontimeout = n("error")),
                                void 0 !== a.onabort
                                    ? (a.onabort = i)
                                    : (a.onreadystatechange = function () {
                                          4 === a.readyState &&
                                              e.setTimeout(function () {
                                                  n && i();
                                              });
                                      }),
                                (n = n("abort"));
                            try {
                                a.send((t.hasContent && t.data) || null);
                            } catch (o) {
                                if (n) throw o;
                            }
                        },
                        abort: function () {
                            n && n();
                        },
                    };
            }),
            x.ajaxPrefilter(function (e) {
                e.crossDomain && (e.contents.script = !1);
            }),
            x.ajaxSetup({
                accepts: { script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript" },
                contents: { script: /\b(?:java|ecma)script\b/ },
                converters: {
                    "text script": function (e) {
                        return x.globalEval(e), e;
                    },
                },
            }),
            x.ajaxPrefilter("script", function (e) {
                void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = "GET");
            }),
            x.ajaxTransport("script", function (e) {
                var t, n;
                if (e.crossDomain || e.scriptAttrs)
                    return {
                        send: function (i, o) {
                            (t = x("<script>")
                                .attr(e.scriptAttrs || {})
                                .prop({ charset: e.scriptCharset, src: e.url })
                                .on(
                                    "load error",
                                    (n = function (e) {
                                        t.remove(), (n = null), e && o("error" === e.type ? 404 : 200, e.type);
                                    })
                                )),
                                g.head.appendChild(t[0]);
                        },
                        abort: function () {
                            n && n();
                        },
                    };
            });
        var Kt = [],
            Zt = /(=)\?(?=&|$)|\?\?/;
        x.ajaxSetup({
            jsonp: "callback",
            jsonpCallback: function () {
                var e = Kt.pop() || x.expando + "_" + At.guid++;
                return (this[e] = !0), e;
            },
        }),
            x.ajaxPrefilter("json jsonp", function (t, n, i) {
                var o,
                    s,
                    r,
                    a = !1 !== t.jsonp && (Zt.test(t.url) ? "url" : "string" == typeof t.data && 0 === (t.contentType || "").indexOf("application/x-www-form-urlencoded") && Zt.test(t.data) && "data");
                if (a || "jsonp" === t.dataTypes[0])
                    return (
                        (o = t.jsonpCallback = m(t.jsonpCallback) ? t.jsonpCallback() : t.jsonpCallback),
                        a ? (t[a] = t[a].replace(Zt, "$1" + o)) : !1 !== t.jsonp && (t.url += (Mt.test(t.url) ? "&" : "?") + t.jsonp + "=" + o),
                        (t.converters["script json"] = function () {
                            return r || x.error(o + " was not called"), r[0];
                        }),
                        (t.dataTypes[0] = "json"),
                        (s = e[o]),
                        (e[o] = function () {
                            r = arguments;
                        }),
                        i.always(function () {
                            void 0 === s ? x(e).removeProp(o) : (e[o] = s), t[o] && ((t.jsonpCallback = n.jsonpCallback), Kt.push(o)), r && m(s) && s(r[0]), (r = s = void 0);
                        }),
                        "script"
                    );
            }),
            (f.createHTMLDocument = (((w = g.implementation.createHTMLDocument("").body).innerHTML = "<form></form><form></form>"), 2 === w.childNodes.length)),
            (x.parseHTML = function (e, t, n) {
                return "string" != typeof e
                    ? []
                    : ("boolean" == typeof t && ((n = t), (t = !1)),
                      t || (f.createHTMLDocument ? (((i = (t = g.implementation.createHTMLDocument("")).createElement("base")).href = g.location.href), t.head.appendChild(i)) : (t = g)),
                      (i = !n && []),
                      (n = E.exec(e)) ? [t.createElement(n[1])] : ((n = ve([e], t, i)), i && i.length && x(i).remove(), x.merge([], n.childNodes)));
                var i;
            }),
            (x.fn.load = function (e, t, n) {
                var i,
                    o,
                    s,
                    r = this,
                    a = e.indexOf(" ");
                return (
                    -1 < a && ((i = Tt(e.slice(a))), (e = e.slice(0, a))),
                    m(t) ? ((n = t), (t = void 0)) : t && "object" == _typeof(t) && (o = "POST"),
                    0 < r.length &&
                        x
                            .ajax({ url: e, type: o || "GET", dataType: "html", data: t })
                            .done(function (e) {
                                (s = arguments), r.html(i ? x("<div>").append(x.parseHTML(e)).find(i) : e);
                            })
                            .always(
                                n &&
                                    function (e, t) {
                                        r.each(function () {
                                            n.apply(this, s || [e.responseText, t, e]);
                                        });
                                    }
                            ),
                    this
                );
            }),
            (x.expr.pseudos.animated = function (e) {
                return x.grep(x.timers, function (t) {
                    return e === t.elem;
                }).length;
            }),
            (x.offset = {
                setOffset: function (e, t, n) {
                    var i,
                        o,
                        s,
                        r,
                        a = x.css(e, "position"),
                        l = x(e),
                        c = {};
                    "static" === a && (e.style.position = "relative"),
                        (s = l.offset()),
                        (i = x.css(e, "top")),
                        (r = x.css(e, "left")),
                        (r = ("absolute" === a || "fixed" === a) && -1 < (i + r).indexOf("auto") ? ((o = (a = l.position()).top), a.left) : ((o = parseFloat(i) || 0), parseFloat(r) || 0)),
                        null != (t = m(t) ? t.call(e, n, x.extend({}, s)) : t).top && (c.top = t.top - s.top + o),
                        null != t.left && (c.left = t.left - s.left + r),
                        "using" in t ? t.using.call(e, c) : ("number" == typeof c.top && (c.top += "px"), "number" == typeof c.left && (c.left += "px"), l.css(c));
                },
            }),
            x.fn.extend({
                offset: function (e) {
                    if (arguments.length)
                        return void 0 === e
                            ? this
                            : this.each(function (t) {
                                  x.offset.setOffset(this, e, t);
                              });
                    var t,
                        n = this[0];
                    return n ? (n.getClientRects().length ? ((t = n.getBoundingClientRect()), (n = n.ownerDocument.defaultView), { top: t.top + n.pageYOffset, left: t.left + n.pageXOffset }) : { top: 0, left: 0 }) : void 0;
                },
                position: function () {
                    if (this[0]) {
                        var e,
                            t,
                            n,
                            i = this[0],
                            o = { top: 0, left: 0 };
                        if ("fixed" === x.css(i, "position")) t = i.getBoundingClientRect();
                        else {
                            for (t = this.offset(), n = i.ownerDocument, e = i.offsetParent || n.documentElement; e && (e === n.body || e === n.documentElement) && "static" === x.css(e, "position"); ) e = e.parentNode;
                            e && e !== i && 1 === e.nodeType && (((o = x(e).offset()).top += x.css(e, "borderTopWidth", !0)), (o.left += x.css(e, "borderLeftWidth", !0)));
                        }
                        return { top: t.top - o.top - x.css(i, "marginTop", !0), left: t.left - o.left - x.css(i, "marginLeft", !0) };
                    }
                },
                offsetParent: function () {
                    return this.map(function () {
                        for (var e = this.offsetParent; e && "static" === x.css(e, "position"); ) e = e.offsetParent;
                        return e || ie;
                    });
                },
            }),
            x.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function (e, t) {
                var i = "pageYOffset" === t;
                x.fn[e] = function (o) {
                    return F(
                        this,
                        function (e, o, s) {
                            var r;
                            return n(e) ? (r = e) : 9 === e.nodeType && (r = e.defaultView), void 0 === s ? (r ? r[t] : e[o]) : void (r ? r.scrollTo(i ? r.pageXOffset : s, i ? s : r.pageYOffset) : (e[o] = s));
                        },
                        e,
                        o,
                        arguments.length
                    );
                };
            }),
            x.each(["top", "left"], function (e, t) {
                x.cssHooks[t] = Xe(f.pixelPosition, function (e, n) {
                    if (n) return (n = Ge(e, t)), Be.test(n) ? x(e).position()[t] + "px" : n;
                });
            }),
            x.each({ Height: "height", Width: "width" }, function (e, t) {
                x.each({ padding: "inner" + e, content: t, "": "outer" + e }, function (i, o) {
                    x.fn[o] = function (s, r) {
                        var a = arguments.length && (i || "boolean" != typeof s),
                            l = i || (!0 === s || !0 === r ? "margin" : "border");
                        return F(
                            this,
                            function (t, i, s) {
                                var r;
                                return n(t)
                                    ? 0 === o.indexOf("outer")
                                        ? t["inner" + e]
                                        : t.document.documentElement["client" + e]
                                    : 9 === t.nodeType
                                    ? ((r = t.documentElement), Math.max(t.body["scroll" + e], r["scroll" + e], t.body["offset" + e], r["offset" + e], r["client" + e]))
                                    : void 0 === s
                                    ? x.css(t, i, l)
                                    : x.style(t, i, s, l);
                            },
                            t,
                            a ? s : void 0,
                            a
                        );
                    };
                });
            }),
            x.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function (e, t) {
                x.fn[t] = function (e) {
                    return this.on(t, e);
                };
            }),
            x.fn.extend({
                bind: function (e, t, n) {
                    return this.on(e, null, t, n);
                },
                unbind: function (e, t) {
                    return this.off(e, null, t);
                },
                delegate: function (e, t, n, i) {
                    return this.on(t, e, n, i);
                },
                undelegate: function (e, t, n) {
                    return 1 === arguments.length ? this.off(e, "**") : this.off(t, e || "**", n);
                },
                hover: function (e, t) {
                    return this.mouseenter(e).mouseleave(t || e);
                },
            }),
            x.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function (e, t) {
                x.fn[t] = function (e, n) {
                    return 0 < arguments.length ? this.on(t, null, e, n) : this.trigger(t);
                };
            });
        var Qt = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
        (x.proxy = function (e, t) {
            var n, i;
            if (("string" == typeof t && ((i = e[t]), (t = e), (e = i)), m(e)))
                return (
                    (n = s.call(arguments, 2)),
                    ((i = function () {
                        return e.apply(t || this, n.concat(s.call(arguments)));
                    }).guid = e.guid = e.guid || x.guid++),
                    i
                );
        }),
            (x.holdReady = function (e) {
                e ? x.readyWait++ : x.ready(!0);
            }),
            (x.isArray = Array.isArray),
            (x.parseJSON = JSON.parse),
            (x.nodeName = _),
            (x.isFunction = m),
            (x.isWindow = n),
            (x.camelCase = U),
            (x.type = b),
            (x.now = Date.now),
            (x.isNumeric = function (e) {
                var t = x.type(e);
                return ("number" === t || "string" === t) && !isNaN(e - parseFloat(e));
            }),
            (x.trim = function (e) {
                return null == e ? "" : (e + "").replace(Qt, "");
            }),
            "function" == typeof define &&
                define.amd &&
                define("jquery", [], function () {
                    return x;
                });
        var Jt = e.jQuery,
            en = e.$;
        return (
            (x.noConflict = function (t) {
                return e.$ === x && (e.$ = en), t && e.jQuery === x && (e.jQuery = Jt), x;
            }),
            void 0 === t && (e.jQuery = e.$ = x),
            x
        );
    }),
    (theme.jQuery = $),
    (function (e) {
        var t,
            n,
            i,
            o,
            s,
            r,
            a,
            l,
            c,
            d,
            u,
            p,
            h,
            f,
            m,
            g,
            v,
            y,
            b,
            w,
            x,
            T,
            C,
            S,
            k,
            $,
            _,
            E,
            A,
            M,
            P,
            L,
            D,
            O,
            z,
            I,
            N,
            j,
            R,
            H,
            q,
            F,
            W,
            B,
            V,
            U,
            G,
            X,
            Y,
            K,
            Z,
            Q,
            J,
            ee,
            te,
            ne,
            ie,
            oe,
            se,
            re,
            ae,
            le,
            ce,
            de,
            ue,
            pe,
            he,
            fe,
            me,
            ge,
            ve,
            ye;
        function be() {
            n(t.lazySizes), t.removeEventListener("lazyunveilread", be, !0);
        }
        function we() {
            o(i.lazySizes), i.removeEventListener("lazyunveilread", we, !0);
        }
        function xe() {
            r(s.lazySizes), s.removeEventListener("lazyunveilread", xe, !0);
        }
        function Te() {
            l(a.lazySizes), a.removeEventListener("lazyunveilread", Te, !0);
        }
        function Ce() {
            d(c.lazySizes), c.removeEventListener("lazyunveilread", Ce, !0);
        }
        function Se(e, t, n) {
            return (e = f.createElement(e)), t && (e.id = te + t), n && (e.style.cssText = n), h(e);
        }
        function ke() {
            return m.innerHeight || h(m).height();
        }
        function $e(e, t) {
            t !== Object(t) && (t = {}),
                (this.cache = {}),
                (this.el = e),
                (this.value = function (e) {
                    var n;
                    return void 0 === this.cache[e] && (void 0 !== (n = h(this.el).attr("data-cbox-" + e)) ? (this.cache[e] = n) : void 0 !== t[e] ? (this.cache[e] = t[e]) : void 0 !== J[e] && (this.cache[e] = J[e])), this.cache[e];
                }),
                (this.get = function (e) {
                    return (e = this.value(e)), h.isFunction(e) ? e.call(this.el, this) : e;
                });
        }
        function _e(e) {
            var t = S.length;
            return (e = (q + e) % t) < 0 ? t + e : e;
        }
        function Ee(e, t) {
            return Math.round((/%/.test(e) ? ("x" === t ? k.width() : ke()) / 100 : 1) * parseInt(e, 10));
        }
        function Ae(e, t) {
            return e.get("photo") || e.get("photoRegex").test(t);
        }
        function Me(e, t) {
            return e.get("retinaUrl") && 1 < m.devicePixelRatio ? t.replace(e.get("photoRegex"), e.get("retinaSuffix")) : t;
        }
        function Pe(e) {
            "contains" in v[0] && !v[0].contains(e.target) && e.target !== g[0] && (e.stopPropagation(), v.focus());
        }
        function Le(e) {
            Le.str !== e && (v.add(g).removeClass(Le.str).addClass(e), (Le.str = e));
        }
        function De(e) {
            h(f).trigger(e), ce.triggerHandler(e);
        }
        function Oe(e) {
            var t, n, i, o;
            V ||
                ((n = h(e).data(ee)),
                (I = new $e(e, n)),
                (o = I.get("rel")),
                (q = 0),
                o && !1 !== o && "nofollow" !== o
                    ? ((S = h("." + ne).filter(function () {
                          return new $e(this, h.data(this, ee)).get("rel") === o;
                      })),
                      -1 === (q = S.index(I.el)) && ((S = S.add(I.el)), (q = S.length - 1)))
                    : (S = h(I.el)),
                W ||
                    ((W = B = !0),
                    Le(I.get("className")),
                    v.css({ visibility: "hidden", display: "block", opacity: "" }),
                    ($ = Se(de, "LoadedContent", "width:0; height:0; overflow:hidden; visibility:hidden")),
                    b.css({ width: "", height: "" }).append($),
                    (N = w.height() + C.height() + b.outerHeight(!0) - b.height()),
                    (j = x.width() + T.width() + b.outerWidth(!0) - b.width()),
                    (R = $.outerHeight(!0)),
                    (H = $.outerWidth(!0)),
                    (t = Ee(I.get("initialWidth"), "x")),
                    (i = Ee(I.get("initialHeight"), "y")),
                    (e = I.get("maxWidth")),
                    (n = I.get("maxHeight")),
                    (I.w = Math.max((!1 !== e ? Math.min(t, Ee(e, "x")) : t) - H - j, 0)),
                    (I.h = Math.max((!1 !== n ? Math.min(i, Ee(n, "y")) : i) - R - N, 0)),
                    $.css({ width: "", height: I.h }),
                    G.position(),
                    De(ie),
                    I.get("onOpen"),
                    z.add(A).hide(),
                    v.focus(),
                    I.get("trapFocus") &&
                        f.addEventListener &&
                        (f.addEventListener("focus", Pe, !0),
                        ce.one(ae, function () {
                            f.removeEventListener("focus", Pe, !0);
                        })),
                    I.get("returnFocus") &&
                        ce.one(ae, function () {
                            h(I.el).focus();
                        })),
                (i = parseFloat(I.get("opacity"))),
                g.css({ opacity: i == i ? i : "", cursor: I.get("overlayClose") ? "pointer" : "", visibility: "visible" }).show(),
                I.get("closeButton") ? O.html(I.get("close")).appendTo(b) : O.appendTo("<div/>"),
                (function () {
                    var e,
                        t,
                        n,
                        i,
                        o = G.prep,
                        s = ++ue;
                    (F = !(B = !0)),
                        De(le),
                        De(oe),
                        I.get("onLoad"),
                        (I.h = I.get("height") ? Ee(I.get("height"), "y") - R - N : I.get("innerHeight") && Ee(I.get("innerHeight"), "y")),
                        (I.w = I.get("width") ? Ee(I.get("width"), "x") - H - j : I.get("innerWidth") && Ee(I.get("innerWidth"), "x")),
                        (I.mw = I.w),
                        (I.mh = I.h),
                        I.get("maxWidth") && ((I.mw = Ee(I.get("maxWidth"), "x") - H - j), (I.mw = I.w && I.w < I.mw ? I.w : I.mw)),
                        I.get("maxHeight") && ((I.mh = Ee(I.get("maxHeight"), "y") - R - N), (I.mh = I.h && I.h < I.mh ? I.h : I.mh)),
                        (e = I.get("href")),
                        (U = setTimeout(function () {
                            E.show();
                        }, 100)),
                        I.get("inline")
                            ? ((i = h(e).eq(0)),
                              (n = h("<div>").hide().insertBefore(i)),
                              ce.one(le, function () {
                                  n.replaceWith(i);
                              }),
                              o(i))
                            : I.get("iframe")
                            ? o(" ")
                            : I.get("html")
                            ? o(I.get("html"))
                            : Ae(I, e)
                            ? ((e = Me(I, e)),
                              (F = I.get("createImg")),
                              h(F)
                                  .addClass(te + "Photo")
                                  .bind("error." + te, function () {
                                      o(Se(de, "Error").html(I.get("imgError")));
                                  })
                                  .one("load", function () {
                                      s === ue &&
                                          setTimeout(function () {
                                              var e;
                                              I.get("retinaImage") && 1 < m.devicePixelRatio && ((F.height = F.height / m.devicePixelRatio), (F.width = F.width / m.devicePixelRatio)),
                                                  I.get("scalePhotos") &&
                                                      ((t = function () {
                                                          (F.height -= F.height * e), (F.width -= F.width * e);
                                                      }),
                                                      I.mw && F.width > I.mw && ((e = (F.width - I.mw) / F.width), t()),
                                                      I.mh && F.height > I.mh && ((e = (F.height - I.mh) / F.height), t())),
                                                  I.h && (F.style.marginTop = Math.max(I.mh - F.height, 0) / 2 + "px"),
                                                  S[1] &&
                                                      (I.get("loop") || S[q + 1]) &&
                                                      ((F.style.cursor = "pointer"),
                                                      h(F).bind("click." + te, function () {
                                                          G.next();
                                                      })),
                                                  (F.style.width = F.width + "px"),
                                                  (F.style.height = F.height + "px"),
                                                  o(F);
                                          }, 1);
                                  }),
                              (F.src = e))
                            : e &&
                              _.load(e, I.get("data"), function (e, t) {
                                  s === ue && o("error" === t ? Se(de, "Error").html(I.get("xhrError")) : h(this).contents());
                              });
                })());
        }
        function ze() {
            v ||
                ((X = !1),
                (k = h(m)),
                (v = Se(de)
                    .attr({ id: ee, class: !1 === h.support.opacity ? te + "IE" : "", role: "dialog", tabindex: "-1" })
                    .hide()),
                (g = Se(de, "Overlay").hide()),
                (E = h([Se(de, "LoadingOverlay")[0], Se(de, "LoadingGraphic")[0]])),
                (y = Se(de, "Wrapper")),
                (b = Se(de, "Content").append(
                    (A = Se(de, "Title")),
                    (M = Se(de, "Current")),
                    (D = h('<button type="button" aria-label="' + theme.strings.previous + '"/>').attr({ id: te + "Previous" })),
                    (L = h('<button type="button" aria-label="' + theme.strings.next + '"/>').attr({ id: te + "Next" })),
                    (P = h('<button type="button" aria-label="' + theme.strings.slideshow + '"/>').attr({ id: te + "Slideshow" })),
                    E
                )),
                (O = h('<button type="button" aria-label="' + theme.strings.close + '"/>').attr({ id: te + "Close" })),
                y
                    .append(
                        Se(de).append(Se(de, "TopLeft"), (w = Se(de, "TopCenter")), Se(de, "TopRight")),
                        Se(de, !1, "clear:left").append((x = Se(de, "MiddleLeft")), b, (T = Se(de, "MiddleRight"))),
                        Se(de, !1, "clear:left").append(Se(de, "BottomLeft"), (C = Se(de, "BottomCenter")), Se(de, "BottomRight"))
                    )
                    .find("div div")
                    .css({ float: "left" }),
                (_ = Se(de, !1, "position:absolute; width:9999px; visibility:hidden; display:none; max-width:none;")),
                (z = L.add(D).add(M).add(P))),
                f.body && !v.parent().length && h(f.body).append(g, v.append(y, _));
        }
        function Ie() {
            clearTimeout(K);
        }
        function Ne() {
            (I.get("loop") || S[q + 1]) && (Ie(), (K = setTimeout(G.next, I.get("slideshowSpeed"))));
        }
        function je() {
            P.html(I.get("slideshowStop")).unbind(Q).one(Q, Re), ce.bind(se, Ne).bind(oe, Ie), v.removeClass(Z + "off").addClass(Z + "on");
        }
        function Re() {
            Ie(),
                ce.unbind(se, Ne).unbind(oe, Ie),
                P.html(I.get("slideshowStart"))
                    .unbind(Q)
                    .one(Q, function () {
                        G.next(), je();
                    }),
                v.removeClass(Z + "on").addClass(Z + "off");
        }
        function He() {
            (Y = !1), P.hide(), Ie(), ce.unbind(se, Ne).unbind(oe, Ie), v.removeClass(Z + "off " + Z + "on");
        }
        (e = jQuery = e),
            (function (e, t, n) {
                function i(e, t) {
                    return _typeof(e) === t;
                }
                function o(e) {
                    return "function" != typeof t.createElement ? t.createElement(e) : g ? t.createElementNS.call(t, "http://www.w3.org/2000/svg", e) : t.createElement.apply(t, arguments);
                }
                function s(e, n, i, s) {
                    var r,
                        a,
                        l,
                        c = "modernizr",
                        d = o("div"),
                        u = ((l = t.body) || ((l = o(g ? "svg" : "body")).fake = !0), l);
                    if (parseInt(i, 10)) for (; i--; ) ((r = o("div")).id = s ? s[i] : c + (i + 1)), d.appendChild(r);
                    return (
                        ((l = o("style")).type = "text/css"),
                        (l.id = "s" + c),
                        (u.fake ? u : d).appendChild(l),
                        u.appendChild(d),
                        l.styleSheet ? (l.styleSheet.cssText = e) : l.appendChild(t.createTextNode(e)),
                        (d.id = c),
                        u.fake && ((u.style.background = ""), (u.style.overflow = "hidden"), (a = m.style.overflow), (m.style.overflow = "hidden"), m.appendChild(u)),
                        (e = n(d, e)),
                        u.fake ? (u.parentNode.removeChild(u), (m.style.overflow = a), m.offsetHeight) : d.parentNode.removeChild(d),
                        !!e
                    );
                }
                function r(e) {
                    return e
                        .replace(/([A-Z])/g, function (e, t) {
                            return "-" + t.toLowerCase();
                        })
                        .replace(/^ms-/, "-ms-");
                }
                function a(t, a, l, c) {
                    function d() {
                        p && (delete E.style, delete E.modElem);
                    }
                    if (((c = !i(c, "undefined") && c), !i(l, "undefined"))) {
                        var u = (function (t, i) {
                            var o = t.length;
                            if ("CSS" in e && "supports" in e.CSS) {
                                for (; o--; ) if (e.CSS.supports(r(t[o]), i)) return !0;
                                return !1;
                            }
                            if ("CSSSupportsRule" in e) {
                                for (var a = []; o--; ) a.push("(" + r(t[o]) + ":" + i + ")");
                                return s("@supports (" + (a = a.join(" or ")) + ") { #modernizr { position: absolute; } }", function (e) {
                                    return "absolute" == getComputedStyle(e, null).position;
                                });
                            }
                            return n;
                        })(t, l);
                        if (!i(u, "undefined")) return u;
                    }
                    for (var p, h, f, m, g, v = ["modernizr", "tspan", "samp"]; !E.style && v.length; ) (p = !0), (E.modElem = o(v.shift())), (E.style = E.modElem.style);
                    for (f = t.length, h = 0; h < f; h++)
                        if (
                            ((m = t[h]),
                            (g = E.style[m]),
                            ~("" + m).indexOf("-") &&
                                (m = m
                                    .replace(/([a-z])-([a-z])/g, function (e, t, n) {
                                        return t + n.toUpperCase();
                                    })
                                    .replace(/^-/, "")),
                            E.style[m] !== n)
                        ) {
                            if (c || i(l, "undefined")) return d(), "pfx" != a || m;
                            try {
                                E.style[m] = l;
                            } catch (t) {}
                            if (E.style[m] != g) return d(), "pfx" != a || m;
                        }
                    return d(), !1;
                }
                function l(e, t, n, o, s) {
                    var r = e.charAt(0).toUpperCase() + e.slice(1),
                        l = (e + " " + x.join(r + " ") + r).split(" ");
                    return i(t, "string") || i(t, "undefined")
                        ? a(l, t, o, s)
                        : (function (e, t, n) {
                              var o, s;
                              for (s in e)
                                  if (e[s] in t)
                                      return !1 === n
                                          ? e[s]
                                          : i((o = t[e[s]]), "function")
                                          ? (function (e, t) {
                                                return function () {
                                                    return e.apply(t, arguments);
                                                };
                                            })(o, n || t)
                                          : o;
                              return !1;
                          })((l = (e + " " + y.join(r + " ") + r).split(" ")), t, n);
                }
                function c(e, t, i) {
                    return l(e, n, n, t, i);
                }
                var d = [],
                    u = [],
                    p = {
                        _version: "3.3.1",
                        _config: { classPrefix: "", enableClasses: !0, enableJSClass: !0, usePrefixes: !0 },
                        _q: [],
                        on: function (e, t) {
                            var n = this;
                            setTimeout(function () {
                                t(n[e]);
                            }, 0);
                        },
                        addTest: function (e, t, n) {
                            u.push({ name: e, fn: t, options: n });
                        },
                        addAsyncTest: function (e) {
                            u.push({ name: null, fn: e });
                        },
                    },
                    h = function () {};
                (h.prototype = p), (h = new h()).addTest("svg", !!t.createElementNS && !!t.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGRect);
                var f = p._config.usePrefixes ? " -webkit- -moz- -o- -ms- ".split(" ") : ["", ""];
                p._prefixes = f;
                var m = t.documentElement,
                    g = "svg" === m.nodeName.toLowerCase(),
                    v = "Moz O ms Webkit",
                    y = p._config.usePrefixes ? v.toLowerCase().split(" ") : [];
                p._domPrefixes = y;
                var b = "CSS" in e && "supports" in e.CSS,
                    w = "supportsCSS" in e;
                h.addTest("supports", b || w), h.addTest("placeholder", "placeholder" in o("input") && "placeholder" in o("textarea"));
                var x = p._config.usePrefixes ? v.split(" ") : [];
                p._cssomPrefixes = x;
                var T = (p.testStyles = s);
                h.addTest("touchevents", function () {
                    var n, i;
                    return (
                        "ontouchstart" in e || (e.DocumentTouch && t instanceof DocumentTouch)
                            ? (n = !0)
                            : ((i = ["@media (", f.join("touch-enabled),("), "heartz", ")", "{#modernizr{top:9px;position:absolute}}"].join("")),
                              T(i, function (e) {
                                  n = 9 === e.offsetTop;
                              })),
                        n
                    );
                });
                var C = { elem: o("modernizr") };
                h._q.push(function () {
                    delete C.elem;
                });
                var S,
                    k,
                    $,
                    _,
                    E = { style: C.elem.style };
                h._q.unshift(function () {
                    delete E.style;
                }),
                    (p.testProp = function (e, t, i) {
                        return a([e], n, t, i);
                    }),
                    (p.testAllProps = l),
                    (p.testAllProps = c),
                    h.addTest("csstransforms", function () {
                        return -1 === navigator.userAgent.indexOf("Android 2.") && c("transform", "scale(1)", !0);
                    }),
                    h.addTest("csstransforms3d", function () {
                        var e,
                            t = !!c("perspective", "1px", !0),
                            n = h._config.usePrefixes;
                        return (
                            t &&
                                (!n || "webkitPerspective" in m.style) &&
                                (h.supports ? (e = "@supports (perspective: 1px)") : ((e = "@media (transform-3d)"), n && (e += ",(-webkit-transform-3d)")),
                                T("#modernizr{width:0;height:0}" + (e += "{#modernizr{width:7px;height:18px;margin:0;padding:0;border:0}}"), function (e) {
                                    t = 7 === e.offsetWidth && 18 === e.offsetHeight;
                                })),
                            t
                        );
                    }),
                    h.addTest("flexbox", c("flexBasis", "1px", !0)),
                    (function () {
                        var e, t, n, o, s, r, a;
                        for (a in u)
                            if (u.hasOwnProperty(a)) {
                                if (((e = []), (t = u[a]).name && (e.push(t.name.toLowerCase()), t.options && t.options.aliases && t.options.aliases.length)))
                                    for (n = 0; n < t.options.aliases.length; n++) e.push(t.options.aliases[n].toLowerCase());
                                for (o = i(t.fn, "function") ? t.fn() : t.fn, s = 0; s < e.length; s++)
                                    1 === (r = e[s].split(".")).length ? (h[r[0]] = o) : (!h[r[0]] || h[r[0]] instanceof Boolean || (h[r[0]] = new Boolean(h[r[0]])), (h[r[0]][r[1]] = o)), d.push((o ? "" : "no-") + r.join("-"));
                            }
                    })(),
                    (S = d),
                    ($ = m.className),
                    (_ = h._config.classPrefix || ""),
                    g && ($ = $.baseVal),
                    h._config.enableJSClass && ((k = new RegExp("(^|\\s)" + _ + "no-js(\\s|$)")), ($ = $.replace(k, "$1" + _ + "js$2"))),
                    h._config.enableClasses && (($ += " " + _ + S.join(" " + _)), g ? (m.className.baseVal = $) : (m.className = $)),
                    delete p.addTest,
                    delete p.addAsyncTest;
                for (var A = 0; A < h._q.length; A++) h._q[A]();
                e.Modernizr = h;
            })(window, document),
            (p = (function (e, t) {
                "use strict";
                if (t.getElementsByClassName) {
                    var n,
                        i,
                        o = t.documentElement,
                        s = e.Date,
                        r = e.HTMLPictureElement,
                        a = "addEventListener",
                        l = "getAttribute",
                        c = e[a],
                        d = e.setTimeout,
                        u = e.requestAnimationFrame || d,
                        p = e.requestIdleCallback,
                        h = /^picture$/i,
                        f = ["load", "error", "lazyincluded", "_lazyloaded"],
                        m = {},
                        g = Array.prototype.forEach,
                        v = function (e, t) {
                            return m[t] || (m[t] = new RegExp("(\\s|^)" + t + "(\\s|$)")), m[t].test(e[l]("class") || "") && m[t];
                        },
                        y = function (e, t) {
                            v(e, t) || e.setAttribute("class", (e[l]("class") || "").trim() + " " + t);
                        },
                        b = function (e, t) {
                            var n;
                            (n = v(e, t)) && e.setAttribute("class", (e[l]("class") || "").replace(n, " "));
                        },
                        w = function e(t, n, i) {
                            var o = i ? a : "removeEventListener";
                            i && e(t, n),
                                f.forEach(function (e) {
                                    t[o](e, n);
                                });
                        },
                        x = function (e, i, o, s, r) {
                            var a = t.createEvent("CustomEvent");
                            return o || (o = {}), (o.instance = n), a.initCustomEvent(i, !s, !r, o), e.dispatchEvent(a), a;
                        },
                        T = function (t, n) {
                            var o;
                            !r && (o = e.picturefill || i.pf) ? o({ reevaluate: !0, elements: [t] }) : n && n.src && (t.src = n.src);
                        },
                        C = function (e, t) {
                            return (getComputedStyle(e, null) || {})[t];
                        },
                        S = function (e, t, n) {
                            for (n = n || e.offsetWidth; n < i.minSize && t && !e._lazysizesWidth; ) (n = t.offsetWidth), (t = t.parentNode);
                            return n;
                        },
                        k = (function () {
                            var e,
                                n,
                                i = [],
                                o = [],
                                s = i,
                                r = function () {
                                    var t = s;
                                    for (s = i.length ? o : i, e = !0, n = !1; t.length; ) t.shift()();
                                    e = !1;
                                },
                                a = function (i, o) {
                                    e && !o ? i.apply(this, arguments) : (s.push(i), n || ((n = !0), (t.hidden ? d : u)(r)));
                                };
                            return (a._lsFlush = r), a;
                        })(),
                        $ = function (e, t) {
                            return t
                                ? function () {
                                      k(e);
                                  }
                                : function () {
                                      var t = this,
                                          n = arguments;
                                      k(function () {
                                          e.apply(t, n);
                                      });
                                  };
                        },
                        _ = function (e) {
                            var t,
                                n = 0,
                                o = i.ricTimeout,
                                r = function () {
                                    (t = !1), (n = s.now()), e();
                                },
                                a =
                                    p && i.ricTimeout
                                        ? function () {
                                              p(r, { timeout: o }), o !== i.ricTimeout && (o = i.ricTimeout);
                                          }
                                        : $(function () {
                                              d(r);
                                          }, !0);
                            return function (e) {
                                var i;
                                (e = !0 === e) && (o = 33), t || ((t = !0), 0 > (i = 125 - (s.now() - n)) && (i = 0), e || (9 > i && p) ? a() : d(a, i));
                            };
                        },
                        E = function (e) {
                            var t,
                                n,
                                i = function () {
                                    (t = null), e();
                                },
                                o = function e() {
                                    var t = s.now() - n;
                                    99 > t ? d(e, 99 - t) : (p || i)(i);
                                };
                            return function () {
                                (n = s.now()), t || (t = d(o, 99));
                            };
                        };
                    !(function () {
                        var t,
                            n = {
                                lazyClass: "lazyload",
                                loadedClass: "lazyloaded",
                                loadingClass: "lazyloading",
                                preloadClass: "lazypreload",
                                errorClass: "lazyerror",
                                autosizesClass: "lazyautosizes",
                                srcAttr: "data-src",
                                srcsetAttr: "data-srcset",
                                sizesAttr: "data-sizes",
                                minSize: 40,
                                customMedia: {},
                                init: !0,
                                expFactor: 1.5,
                                hFac: 0.8,
                                loadMode: 2,
                                loadHidden: !0,
                                ricTimeout: 300,
                            };
                        for (t in ((i = e.lazySizesConfig || e.lazysizesConfig || {}), n)) t in i || (i[t] = n[t]);
                        (e.lazySizesConfig = i),
                            d(function () {
                                i.init && P();
                            });
                    })();
                    var A = (function () {
                            var r,
                                u,
                                p,
                                f,
                                m,
                                S,
                                A,
                                P,
                                L,
                                D,
                                O,
                                z,
                                I,
                                N,
                                j = /^img$/i,
                                R = /^iframe$/i,
                                H = "onscroll" in e && !/glebot/.test(navigator.userAgent),
                                q = 0,
                                F = 0,
                                W = -1,
                                B = function e(t) {
                                    F--, t && t.target && w(t.target, e), (!t || 0 > F || !t.target) && (F = 0);
                                },
                                V = function (e, n) {
                                    var i,
                                        s = e,
                                        r = "hidden" == C(t.body, "visibility") || "hidden" != C(e, "visibility");
                                    for (P -= n, O += n, L -= n, D += n; r && (s = s.offsetParent) && s != t.body && s != o; )
                                        (r = (C(s, "opacity") || 1) > 0) && "visible" != C(s, "overflow") && ((i = s.getBoundingClientRect()), (r = D > i.left && L < i.right && O > i.top - 1 && P < i.bottom + 1));
                                    return r;
                                },
                                U = function () {
                                    var e,
                                        s,
                                        a,
                                        c,
                                        d,
                                        p,
                                        h,
                                        m,
                                        g,
                                        v = n.elements;
                                    if ((f = i.loadMode) && 8 > F && (e = v.length)) {
                                        (s = 0),
                                            W++,
                                            null == I && ("expand" in i || (i.expand = o.clientHeight > 500 && o.clientWidth > 500 ? 500 : 370), (z = i.expand), (I = z * i.expFactor)),
                                            I > q && 1 > F && W > 2 && f > 2 && !t.hidden ? ((q = I), (W = 0)) : (q = f > 1 && W > 1 && 6 > F ? z : 0);
                                        for (; e > s; s++)
                                            if (v[s] && !v[s]._lazyRace)
                                                if (H)
                                                    if (
                                                        (((m = v[s][l]("data-expand")) && (p = 1 * m)) || (p = q),
                                                        g !== p && ((S = innerWidth + p * N), (A = innerHeight + p), (h = -1 * p), (g = p)),
                                                        (a = v[s].getBoundingClientRect()),
                                                        (O = a.bottom) >= h &&
                                                            (P = a.top) <= A &&
                                                            (D = a.right) >= h * N &&
                                                            (L = a.left) <= S &&
                                                            (O || D || L || P) &&
                                                            (i.loadHidden || "hidden" != C(v[s], "visibility")) &&
                                                            ((u && 3 > F && !m && (3 > f || 4 > W)) || V(v[s], p)))
                                                    ) {
                                                        if ((J(v[s]), (d = !0), F > 9)) break;
                                                    } else !d && u && !c && 4 > F && 4 > W && f > 2 && (r[0] || i.preloadAfterLoad) && (r[0] || (!m && (O || D || L || P || "auto" != v[s][l](i.sizesAttr)))) && (c = r[0] || v[s]);
                                                else J(v[s]);
                                        c && !d && J(c);
                                    }
                                },
                                G = _(U),
                                X = function (e) {
                                    y(e.target, i.loadedClass), b(e.target, i.loadingClass), w(e.target, K), x(e.target, "lazyloaded");
                                },
                                Y = $(X),
                                K = function (e) {
                                    Y({ target: e.target });
                                },
                                Z = function (e) {
                                    var t,
                                        n = e[l](i.srcsetAttr);
                                    (t = i.customMedia[e[l]("data-media") || e[l]("media")]) && e.setAttribute("media", t), n && e.setAttribute("srcset", n);
                                },
                                Q = $(function (e, t, n, o, s) {
                                    var r, a, c, u, f, m;
                                    (f = x(e, "lazybeforeunveil", t)).defaultPrevented ||
                                        (o && (n ? y(e, i.autosizesClass) : e.setAttribute("sizes", o)),
                                        (a = e[l](i.srcsetAttr)),
                                        (r = e[l](i.srcAttr)),
                                        s && (u = (c = e.parentNode) && h.test(c.nodeName || "")),
                                        (m = t.firesLoad || ("src" in e && (a || r || u))),
                                        (f = { target: e }),
                                        m && (w(e, B, !0), clearTimeout(p), (p = d(B, 2500)), y(e, i.loadingClass), w(e, K, !0)),
                                        u && g.call(c.getElementsByTagName("source"), Z),
                                        a
                                            ? e.setAttribute("srcset", a)
                                            : r &&
                                              !u &&
                                              (R.test(e.nodeName)
                                                  ? (function (e, t) {
                                                        try {
                                                            e.contentWindow.location.replace(t);
                                                        } catch (n) {
                                                            e.src = t;
                                                        }
                                                    })(e, r)
                                                  : (e.src = r)),
                                        s && (a || u) && T(e, { src: r })),
                                        e._lazyRace && delete e._lazyRace,
                                        b(e, i.lazyClass),
                                        k(function () {
                                            (!m || (e.complete && e.naturalWidth > 1)) && (m ? B(f) : F--, X(f));
                                        }, !0);
                                }),
                                J = function (e) {
                                    var t,
                                        n = j.test(e.nodeName),
                                        o = n && (e[l](i.sizesAttr) || e[l]("sizes")),
                                        s = "auto" == o;
                                    ((!s && u) || !n || (!e[l]("src") && !e.srcset) || e.complete || v(e, i.errorClass) || !v(e, i.lazyClass)) &&
                                        ((t = x(e, "lazyunveilread").detail), s && M.updateElem(e, !0, e.offsetWidth), (e._lazyRace = !0), F++, Q(e, t, s, o, n));
                                },
                                ee = function e() {
                                    if (!u) {
                                        if (s.now() - m < 999) return void d(e, 999);
                                        var t = E(function () {
                                            (i.loadMode = 3), G();
                                        });
                                        (u = !0),
                                            (i.loadMode = 3),
                                            G(),
                                            c(
                                                "scroll",
                                                function () {
                                                    3 == i.loadMode && (i.loadMode = 2), t();
                                                },
                                                !0
                                            );
                                    }
                                };
                            return {
                                _: function () {
                                    (m = s.now()),
                                        (n.elements = t.getElementsByClassName(i.lazyClass)),
                                        (r = t.getElementsByClassName(i.lazyClass + " " + i.preloadClass)),
                                        (N = i.hFac),
                                        c("scroll", G, !0),
                                        c("resize", G, !0),
                                        e.MutationObserver ? new MutationObserver(G).observe(o, { childList: !0, subtree: !0, attributes: !0 }) : (o[a]("DOMNodeInserted", G, !0), o[a]("DOMAttrModified", G, !0), setInterval(G, 999)),
                                        c("hashchange", G, !0),
                                        ["focus", "mouseover", "click", "load", "transitionend", "animationend", "webkitAnimationEnd"].forEach(function (e) {
                                            t[a](e, G, !0);
                                        }),
                                        /d$|^c/.test(t.readyState) ? ee() : (c("load", ee), t[a]("DOMContentLoaded", G), d(ee, 2e4)),
                                        n.elements.length ? (U(), k._lsFlush()) : G();
                                },
                                checkElems: G,
                                unveil: J,
                            };
                        })(),
                        M = (function () {
                            var e,
                                n = $(function (e, t, n, i) {
                                    var o, s, r;
                                    if (((e._lazysizesWidth = i), (i += "px"), e.setAttribute("sizes", i), h.test(t.nodeName || ""))) for (s = 0, r = (o = t.getElementsByTagName("source")).length; r > s; s++) o[s].setAttribute("sizes", i);
                                    n.detail.dataAttr || T(e, n.detail);
                                }),
                                o = function (e, t, i) {
                                    var o,
                                        s = e.parentNode;
                                    s && ((i = S(e, s, i)), (o = x(e, "lazybeforesizes", { width: i, dataAttr: !!t })).defaultPrevented || ((i = o.detail.width) && i !== e._lazysizesWidth && n(e, s, o, i)));
                                },
                                s = E(function () {
                                    var t,
                                        n = e.length;
                                    if (n) for (t = 0; n > t; t++) o(e[t]);
                                });
                            return {
                                _: function () {
                                    (e = t.getElementsByClassName(i.autosizesClass)), c("resize", s);
                                },
                                checkElems: s,
                                updateElem: o,
                            };
                        })(),
                        P = function e() {
                            e.i || ((e.i = !0), M._(), A._());
                        };
                    return (n = { cfg: i, autoSizer: M, loader: A, init: P, uP: T, aC: y, rC: b, hC: v, fire: x, gW: S, rAF: k });
                }
            })((u = window), u.document)),
            (u.lazySizes = p),
            "object" == ("undefined" == typeof module ? "undefined" : _typeof(module)) && module.exports && (module.exports = p),
            (t = window),
            (n = (n = function (e, t, n) {
                "use strict";
                function i(e, n, i) {
                    var o,
                        s,
                        a,
                        c = 0,
                        d = 0,
                        f = i;
                    if (e) {
                        if ("container" === n.ratio) {
                            for (c = f.scrollWidth, d = f.scrollHeight; !((c && d) || f === t); ) (c = (f = f.parentNode).scrollWidth), (d = f.scrollHeight);
                            c && d && (n.ratio = d / c);
                        }
                        (o = e),
                            (s = n),
                            ((a = []).srcset = []),
                            s.absUrl && (g.setAttribute("href", o), (o = g.href)),
                            (o = ((s.prefix || "") + o + (s.postfix || "")).replace(h, function (e, t) {
                                return l[_typeof(s[t])] ? s[t] : e;
                            })),
                            s.widths.forEach(function (e) {
                                var t = s.widthmap[e] || e;
                                (t = { u: o.replace(u, t).replace(p, s.ratio ? Math.round(e * s.ratio) : ""), w: e }), a.push(t), a.srcset.push((t.c = t.u + " " + e + "w"));
                            }),
                            ((e = a).isPicture = n.isPicture),
                            y && "IMG" == i.nodeName.toUpperCase() ? i.removeAttribute(r.srcsetAttr) : i.setAttribute(r.srcsetAttr, e.srcset.join(", ")),
                            Object.defineProperty(i, "_lazyrias", { value: e, writable: !0 });
                    }
                }
                function o(t, i) {
                    return (
                        (i = (function (t, n) {
                            var i,
                                o = e.getComputedStyle(t),
                                s = t.parentNode,
                                r = { isPicture: !(!s || !d.test(s.nodeName || "")) },
                                l = function (e, n) {
                                    var i,
                                        s = t.getAttribute("data-" + e);
                                    if ((s || ((i = o.getPropertyValue("--ls-" + e)) && (s = i.trim())), s)) {
                                        if ("true" == s) s = !0;
                                        else if ("false" == s) s = !1;
                                        else if (c.test(s)) s = parseFloat(s);
                                        else if ("function" == typeof a[e]) s = a[e](t, s);
                                        else if (f.test(s))
                                            try {
                                                s = JSON.parse(s);
                                            } catch (e) {}
                                        r[e] = s;
                                    } else e in a && "function" != typeof a[e] ? (r[e] = a[e]) : n && "function" == typeof a[e] && (r[e] = a[e](t, s));
                                };
                            for (i in a) l(i);
                            return (
                                n.replace(h, function (e, t) {
                                    t in r || l(t, !0);
                                }),
                                r
                            );
                        })(t, i)),
                        a.modifyOptions.call(t, { target: t, details: i, detail: i }),
                        n.fire(t, "lazyriasmodifyoptions", i),
                        i
                    );
                }
                function s(e) {
                    return e.getAttribute(e.getAttribute("data-srcattr") || a.srcAttr) || e.getAttribute(r.srcsetAttr) || e.getAttribute(r.srcAttr) || e.getAttribute("data-pfsrcset") || "";
                }
                var r,
                    a,
                    l = { string: 1, number: 1 },
                    c = /^\-*\+*\d+\.*\d*$/,
                    d = /^picture$/i,
                    u = /\s*\{\s*width\s*\}\s*/i,
                    p = /\s*\{\s*height\s*\}\s*/i,
                    h = /\s*\{\s*([a-z0-9]+)\s*\}\s*/gi,
                    f = /^\[.*\]|\{.*\}$/,
                    m = /^(?:auto|\d+(px)?)$/,
                    g = t.createElement("a"),
                    v = t.createElement("img"),
                    y = "srcset" in v && !("sizes" in v),
                    b = !!e.HTMLPictureElement && !y;
                !(function () {
                    var t,
                        i = { prefix: "", postfix: "", srcAttr: "data-src", absUrl: !1, modifyOptions: function () {}, widthmap: {}, ratio: !1 };
                    for (t in ((r = (n && n.cfg) || e.lazySizesConfig) || ((r = {}), (e.lazySizesConfig = r)),
                    r.supportsType ||
                        (r.supportsType = function (e) {
                            return !e;
                        }),
                    r.rias || (r.rias = {}),
                    "widths" in (a = r.rias) ||
                        ((a.widths = []),
                        (function (e) {
                            for (var t, n = 0; !t || t < 3e3; ) 30 < (n += 5) && (n += 1), e.push((t = 36 * n));
                        })(a.widths)),
                    i))
                        t in a || (a[t] = i[t]);
                })(),
                    addEventListener(
                        "lazybeforesizes",
                        function (e) {
                            if (e.detail.instance == n) {
                                var t,
                                    l,
                                    c,
                                    d,
                                    p,
                                    h,
                                    f,
                                    g,
                                    v,
                                    y = e.target;
                                if (e.detail.dataAttr && !e.defaultPrevented && !a.disabled && (f = y.getAttribute(r.sizesAttr) || y.getAttribute("sizes")) && m.test(f)) {
                                    if (((t = o(y, (e = s(y)))), (g = u.test(t.prefix) || u.test(t.postfix)), t.isPicture && (l = y.parentNode)))
                                        for (d = 0, p = (c = l.getElementsByTagName("source")).length; d < p; d++) (g || u.test((h = s(c[d])))) && (i(h, t, c[d]), (v = !0));
                                    g || u.test(e) ? (i(e, t, y), (v = !0)) : v && (((e = []).srcset = []), (e.isPicture = !0), Object.defineProperty(y, "_lazyrias", { value: e, writable: !0 })),
                                        v && (b ? y.removeAttribute(r.srcAttr) : "auto" != f && ((f = { width: parseInt(f, 10) }), x({ target: y, detail: f })));
                                }
                            }
                        },
                        !0
                    );
                var w,
                    x =
                        ((w = function (i) {
                            if (i.detail.instance == n) {
                                var o,
                                    s = i.target;
                                return !y && (e.respimage || e.picturefill || lazySizesConfig.pf)
                                    ? void t.removeEventListener("lazybeforesizes", w)
                                    : void (
                                          ("_lazyrias" in s || (i.detail.dataAttr && C(s, !0))) &&
                                          (o = (function (t, i) {
                                              var o,
                                                  s,
                                                  r,
                                                  a,
                                                  l,
                                                  c = t._lazyrias;
                                              if (c.isPicture && e.matchMedia)
                                                  for (s = 0, r = (o = t.parentNode.getElementsByTagName("source")).length; s < r; s++)
                                                      if (C(o[s]) && !o[s].getAttribute("type") && (!(a = o[s].getAttribute("media")) || (matchMedia(a) || {}).matches)) {
                                                          c = o[s]._lazyrias;
                                                          break;
                                                      }
                                              return (
                                                  (!c.w || c.w < i) &&
                                                      ((c.w = i),
                                                      (c.d = ((l = e.devicePixelRatio || 1), (t = n.getX && n.getX(t)), Math.min(t || l, 2.4, l))),
                                                      (l = (function (e) {
                                                          for (var t, n, i = e.length, o = e[i - 1], s = 0; s < i; s++)
                                                              if ((((o = e[s]).d = o.w / e.w), o.d >= e.d)) {
                                                                  !o.cached &&
                                                                      (t = e[s - 1]) &&
                                                                      t.d > e.d - 0.13 * Math.pow(e.d, 2.2) &&
                                                                      ((n = Math.pow(t.d - 0.6, 1.6)), t.cached && (t.d += 0.15 * n), t.d + (o.d - e.d) * n > e.d && (o = t));
                                                                  break;
                                                              }
                                                          return o;
                                                      })(c.sort(T)))),
                                                  l
                                              );
                                          })(s, i.detail.width)) &&
                                          o.u &&
                                          s._lazyrias.cur != o.u &&
                                          ((s._lazyrias.cur = o.u),
                                          (o.cached = !0),
                                          n.rAF(function () {
                                              s.setAttribute(r.srcAttr, o.u), s.setAttribute("src", o.u);
                                          }))
                                      );
                            }
                        }),
                        b ? (w = function () {}) : addEventListener("lazybeforesizes", w),
                        w);
                function T(e, t) {
                    return e.w - t.w;
                }
                function C(e, t) {
                    var i;
                    return (
                        !e._lazyrias &&
                            n.pWS &&
                            (i = n.pWS(e.getAttribute(r.srcsetAttr || ""))).length &&
                            (Object.defineProperty(e, "_lazyrias", { value: i, writable: !0 }), t && e.parentNode && (i.isPicture = "PICTURE" == e.parentNode.nodeName.toUpperCase())),
                        e._lazyrias
                    );
                }
            }).bind(null, t, t.document)),
            "object" == ("undefined" == typeof module ? "undefined" : _typeof(module)) && module.exports ? n(require("lazysizes")) : t.lazySizes ? be() : t.addEventListener("lazyunveilread", be, !0),
            (function (e, t) {
                "use strict";
                var n, i, o, s, r, a, l, c, d, u;
                function p(e, t, n, i, o) {
                    var s,
                        r = e[o];
                    r && ((s = r.index), a[o](r, t, n), (r.dirty && s == r.index) || (r.cSrcset.join(", "), e.setAttribute(i, r.cSrcset.join(", ")), (r.dirty = !0)));
                }
                function h(e, t) {
                    return e.w - t.w;
                }
                function f(e, t) {
                    var n = { srcset: e.getAttribute(lazySizes.cfg.srcsetAttr) || "" },
                        i = s(n.srcset);
                    return (
                        Object.defineProperty(e, t, { value: n, writable: !0 }),
                        (n.cands = i),
                        (n.index = 0),
                        (n.dirty = !1),
                        i[0] && i[0].w ? (i.sort(h), (n.cSrcset = [i[n.index].c])) : ((n.cSrcset = n.srcset ? [n.srcset] : []), (n.cands = [])),
                        n
                    );
                }
                function m(e, t, n, i, o, s, r, a) {
                    d.push({ c: t, u: n, w: +("w" == a ? r : i) });
                }
                e.addEventListener &&
                    ((i = /^picture$/i),
                    (o = t.documentElement),
                    (u = /(([^,\s].[^\s]+)\s+(\d+)(w|h)(\s+(\d+)(w|h))?)/g),
                    (s = function (e) {
                        return (d = []), e.replace(u, m), d;
                    }),
                    (r = function (e, t) {
                        var n, o, s, r;
                        if (!e[t] && ((r = e.parentNode || {}), (e[t] = f(e, t)), (e[t].isImg = !0), i.test(r.nodeName || "")))
                            for (e[t].picture = !0, o = 0, s = (n = r.getElementsByTagName("source")).length; o < s; o++) f(n[o], t).isImg = !1;
                        return e[t];
                    }),
                    (a = {
                        _lazyOptimumx: function (e, t, n) {
                            for (var i, o, s, r, a, l = 0; l < e.cands.length; l++)
                                if ((((i = e.cands[l]).d = (i.w || 1) / t), !(e.index >= l))) {
                                    if (
                                        !(
                                            i.d <= n ||
                                            ((o = e.cands[l - 1]),
                                            (s = i.d),
                                            (r = n),
                                            (a = void 0),
                                            !o || !o.d || (!(o.d >= r) && ((a = Math.pow(o.d - (0.7 < r ? 0.6 : 0.4), 1.6) || 0.1) < 0.1 ? (a = 0.1) : 3 < a && (a = 3), o.d + (s - r) * a < r)))
                                        )
                                    )
                                        break;
                                    e.cSrcset.push(i.c), (e.index = l);
                                }
                        },
                    }),
                    (l = function (e, t, n, i, o) {
                        var s,
                            r,
                            a,
                            l,
                            c = e[o];
                        if (((c.width = t), c.picture && (r = e.parentNode))) for (l = 0, a = (s = r.getElementsByTagName("source")).length; l < a; l++) p(s[l], t, n, i, o);
                        p(e, t, n, i, o);
                    }),
                    (c = function (e) {
                        var t = e.getAttribute("data-optimumx") || e.getAttribute("data-maxdpr");
                        return (t = !t && n.constrainPixelDensity ? "auto" : t) && ("auto" == t ? n.getOptimumX(e) : parseFloat(t, 10));
                    }),
                    (t = function t() {
                        e.lazySizes && !e.lazySizes.getOptimumX && ((lazySizes.getX = c), (lazySizes.pWS = s), o.removeEventListener("lazybeforeunveil", t));
                    }),
                    o.addEventListener("lazybeforeunveil", t),
                    setTimeout(t),
                    (n = (e.lazySizes && lazySizes.cfg) || e.lazySizesConfig) || (e.lazySizesConfig = n = {}),
                    "function" != typeof n.getOptimumX &&
                        (n.getOptimumX = function () {
                            var t = e.devicePixelRatio || 1;
                            return 2.6 < t ? (t *= 0.6) : 1.9 < t ? (t *= 0.8) : (t -= 0.01), Math.min(Math.round(100 * t) / 100, 2);
                        }),
                    e.devicePixelRatio &&
                        addEventListener("lazybeforesizes", function (e) {
                            var t,
                                i,
                                o,
                                s = e.target,
                                a = e.detail,
                                d = a.dataAttr;
                            e.defaultPrevented ||
                                !(t = c(s)) ||
                                t >= devicePixelRatio ||
                                (!d || !s._lazyOptimumx || a.reloaded || (n.unloadedClass && lazySizes.hC(s, n.unloadedClass)) || (s._lazyOptimumx = null),
                                (e = r(s, "_lazyOptimumx")),
                                (i = a.width) &&
                                    (e.width || 0) < i &&
                                    ((o = d ? lazySizes.cfg.srcsetAttr : "srcset"),
                                    lazySizes.rAF(function () {
                                        l(s, i, t, o, "_lazyOptimumx");
                                    })));
                        }));
            })(window, document),
            (i = window),
            (o = (o = function (e, t, n) {
                "use strict";
                var i, o;
                "srcset" in t.createElement("img") &&
                    ((i = /^img$/i),
                    t.addEventListener(
                        "lazybeforeunveil",
                        function (e) {
                            var t;
                            e.detail.instance == n &&
                                ((t = e.target),
                                !i.test(t.nodeName) || ((e = t.getAttribute("src")) && ((t.style.backgroundSize = "100% 100%"), (t.style.backgroundImage = "url(" + e + ")"), t.removeAttribute("src"), t.addEventListener("load", o))));
                        },
                        !(o = function (e) {
                            (e.target.style.backgroundSize = ""), (e.target.style.backgroundImage = ""), e.target.removeEventListener(e.type, o);
                        })
                    ));
            }).bind(null, i, i.document)),
            "object" == ("undefined" == typeof module ? "undefined" : _typeof(module)) && module.exports ? o(require("lazysizes")) : i.lazySizes ? we() : i.addEventListener("lazyunveilread", we, !0),
            (s = window),
            (r = (r = function (e, t, n) {
                "use strict";
                var i, o, s, r, a;
                e.addEventListener &&
                    ((i = /\s+(\d+)(w|h)\s+(\d+)(w|h)/),
                    (o = /parent-fit["']*\s*:\s*["']*(contain|cover|width)/),
                    (s = /parent-container["']*\s*:\s*["']*(.+?)(?=(\s|$|,|'|"|;))/),
                    (r = /^picture$/i),
                    (n.parentFit = a = {
                        getParent: function (t, n) {
                            var i = t,
                                o = t.parentNode;
                            return (
                                (n && "prev" != n) || !o || !r.test(o.nodeName || "") || (o = o.parentNode),
                                "self" != n ? ("prev" == n ? t.previousElementSibling : (n && (o.closest || e.jQuery) && (o.closest ? o.closest(n) : jQuery(o).closest(n)[0])) || o) : i
                            );
                        },
                        getFit: function (e) {
                            var t,
                                n,
                                i = getComputedStyle(e, null) || {},
                                r = i.content || i.fontFamily,
                                l = { fit: e._lazysizesParentFit || e.getAttribute("data-parent-fit") };
                            return (
                                !l.fit && r && (t = r.match(o)) && (l.fit = t[1]),
                                l.fit ? (!(n = e._lazysizesParentContainer || e.getAttribute("data-parent-container")) && r && (t = r.match(s)) && (n = t[1]), (l.parent = a.getParent(e, n))) : (l.fit = i.objectFit),
                                l
                            );
                        },
                        getImageRatio: function (t) {
                            for (var n, o, s, a = t.parentNode, l = a && r.test(a.nodeName || "") ? a.querySelectorAll("source, img") : [t], c = 0; c < l.length; c++)
                                if (
                                    ((n = (t = l[c]).getAttribute(lazySizesConfig.srcsetAttr) || t.getAttribute("srcset") || t.getAttribute("data-pfsrcset") || t.getAttribute("data-risrcset") || ""),
                                    (o = t._lsMedia || t.getAttribute("media")),
                                    (o = lazySizesConfig.customMedia[t.getAttribute("data-media") || o] || o),
                                    n && (!o || ((e.matchMedia && matchMedia(o)) || {}).matches))
                                ) {
                                    !(s = parseFloat(t.getAttribute("data-aspectratio"))) && n.match(i) && (s = "w" == RegExp.$2 ? RegExp.$1 / RegExp.$3 : RegExp.$3 / RegExp.$1);
                                    break;
                                }
                            return s;
                        },
                        calculateSize: function (e, t) {
                            var n,
                                i,
                                o = (s = this.getFit(e)).fit,
                                s = s.parent;
                            return "width" == o || (("contain" == o || "cover" == o) && (i = this.getImageRatio(e)))
                                ? (s ? (t = s.clientWidth) : (s = e), (e = t), "width" == o ? (e = t) : 40 < (s = s.clientHeight) && (n = t / s) && (("cover" == o && n < i) || ("contain" == o && i < n)) && (e = t * (i / n)), e)
                                : t;
                        },
                    }),
                    t.addEventListener("lazybeforesizes", function (e) {
                        var t;
                        e.defaultPrevented || e.detail.instance != n || ((t = e.target), (e.detail.width = a.calculateSize(t, e.detail.width)));
                    }));
            }).bind(null, s, s.document)),
            "object" == ("undefined" == typeof module ? "undefined" : _typeof(module)) && module.exports ? r(require("lazysizes")) : s.lazySizes ? xe() : s.addEventListener("lazyunveilread", xe, !0),
            (a = window),
            (l = (l = function (e, t, n) {
                "use strict";
                var i,
                    o,
                    s,
                    r,
                    a,
                    l,
                    c,
                    d,
                    u,
                    p,
                    h = (n && n.cfg) || e.lazySizesConfig,
                    f = "sizes" in (g = t.createElement("img")) && "srcset" in g,
                    m = /\s+\d+h/g,
                    g =
                        ((o = /\s+(\d+)(w|h)\s+(\d+)(w|h)/),
                        (s = Array.prototype.forEach),
                        function (e) {
                            function n(e) {
                                var t,
                                    n = e.getAttribute(lazySizesConfig.srcsetAttr);
                                n && (!(t = n.match(o)) || ((t = "w" == t[2] ? t[1] / t[3] : t[3] / t[1]) && e.setAttribute("data-aspectratio", t)), e.setAttribute(lazySizesConfig.srcsetAttr, n.replace(m, "")));
                            }
                            function i(e) {
                                var t = e.target.parentNode;
                                t && "PICTURE" == t.nodeName && s.call(t.getElementsByTagName("source"), n), n(e.target);
                            }
                            function r() {
                                a.currentSrc && t.removeEventListener("lazybeforeunveil", i);
                            }
                            var a = t.createElement("img");
                            e[1] && (t.addEventListener("lazybeforeunveil", i), (a.onload = r), (a.onerror = r), (a.srcset = "data:,a 1w 1h"), a.complete && r());
                        });
                if (
                    (h || (e.lazySizesConfig = h = {}),
                    h.supportsType ||
                        (h.supportsType = function (e) {
                            return !e;
                        }),
                    !e.picturefill && !h.pf)
                ) {
                    if (e.HTMLPictureElement && f) return t.msElementsFromPoint && g(navigator.userAgent.match(/Edge\/(\d+)/)), void (h.pf = function () {});
                    (h.pf = function (t) {
                        var n, o;
                        if (!e.picturefill) for (n = 0, o = t.elements.length; n < o; n++) i(t.elements[n]);
                    }),
                        (d = /^\s*\d+\.*\d*px\s*$/),
                        (l = /(([^,\s].[^\s]+)\s+(\d+)w)/g),
                        (c = /\s/),
                        (p = function (t) {
                            return e.matchMedia
                                ? (p = function (e) {
                                      return !e || (matchMedia(e) || {}).matches;
                                  })(t)
                                : !t;
                        }),
                        (w.parse = u = function (e) {
                            return (a = []), (e = e.trim()).replace(m, "").replace(l, x), a.length || !e || c.test(e) || a.push({ c: e, u: e, w: 99 }), a;
                        }),
                        (i = w),
                        h.loadedClass &&
                            h.loadingClass &&
                            ((r = []),
                            ['img[sizes$="px"][srcset].', "picture > img:not([srcset])."].forEach(function (e) {
                                r.push(e + h.loadedClass), r.push(e + h.loadingClass);
                            }),
                            h.pf({ elements: t.querySelectorAll(r.join(", ")) }));
                }
                function v(e, t) {
                    return e.w - t.w;
                }
                function y() {
                    function e() {
                        for (var e = 0, t = o.length; e < t; e++) i(o[e]);
                    }
                    var n, o;
                    y.init ||
                        ((y.init = !0),
                        addEventListener(
                            "resize",
                            ((o = t.getElementsByClassName("lazymatchmedia")),
                            function () {
                                clearTimeout(n), (n = setTimeout(e, 66));
                            })
                        ));
                }
                function b(t, i) {
                    var o,
                        s = t.getAttribute("srcset") || t.getAttribute(h.srcsetAttr);
                    !s && i && (s = t._lazypolyfill ? t._lazypolyfill._set : t.getAttribute(h.srcAttr) || t.getAttribute("src")),
                        (t._lazypolyfill && t._lazypolyfill._set == s) ||
                            ((o = u(s || "")),
                            i && t.parentNode && ((o.isPicture = "PICTURE" == t.parentNode.nodeName.toUpperCase()), o.isPicture && e.matchMedia && (n.aC(t, "lazymatchmedia"), y())),
                            (o._set = s),
                            Object.defineProperty(t, "_lazypolyfill", { value: o, writable: !0 }));
                }
                function w(t) {
                    var i;
                    (f && t.parentNode && "PICTURE" != t.parentNode.nodeName.toUpperCase()) ||
                        ((i = (function (t) {
                            var i,
                                o,
                                s,
                                r,
                                a,
                                l,
                                c,
                                u,
                                f = t;
                            if ((b(f, !0), (r = f._lazypolyfill).isPicture))
                                for (o = 0, s = (i = t.parentNode.getElementsByTagName("source")).length; o < s; o++)
                                    if (h.supportsType(i[o].getAttribute("type"), t) && p(i[o].getAttribute("media"))) {
                                        b((f = i[o])), (r = f._lazypolyfill);
                                        break;
                                    }
                            return (
                                1 < r.length
                                    ? ((l = f.getAttribute("sizes") || ""),
                                      (l = (d.test(l) && parseInt(l, 10)) || n.gW(t, t.parentNode)),
                                      (r.d = ((c = t), (u = e.devicePixelRatio || 1), (c = n.getX && n.getX(c)), Math.min(c || u, 2.5, u))),
                                      !r.src || !r.w || r.w < l
                                          ? ((r.w = l),
                                            (a = (function (e) {
                                                for (var t, n, i = e.length, o = e[i - 1], s = 0; s < i; s++)
                                                    if ((((o = e[s]).d = o.w / e.w), o.d >= e.d)) {
                                                        !o.cached && (t = e[s - 1]) && t.d > e.d - 0.13 * Math.pow(e.d, 2.2) && ((n = Math.pow(t.d - 0.6, 1.6)), t.cached && (t.d += 0.15 * n), t.d + (o.d - e.d) * n > e.d && (o = t));
                                                        break;
                                                    }
                                                return o;
                                            })(r.sort(v))),
                                            (r.src = a))
                                          : (a = r.src))
                                    : (a = r[0]),
                                a
                            );
                        })(t)) &&
                            i.u &&
                            t._lazypolyfill.cur != i.u &&
                            ((t._lazypolyfill.cur = i.u), (i.cached = !0), t.setAttribute(h.srcAttr, i.u), t.setAttribute("src", i.u)));
                }
                function x(e, t, n, i) {
                    a.push({ c: t, u: n, w: +i });
                }
            }).bind(null, a, a.document)),
            "object" == ("undefined" == typeof module ? "undefined" : _typeof(module)) && module.exports
                ? l(require("lazysizes"), require("../fix-ios-sizes/fix-ios-sizes"))
                : a.lazySizes
                ? Te()
                : a.addEventListener("lazyunveilread", Te, !0),
            (c = window),
            (d = (d = function (e, t, n) {
                "use strict";
                var i, o, s, r, a, l;
                e.addEventListener &&
                    ((i = /\s+/g),
                    (o = /\s*\|\s+|\s+\|\s*/g),
                    (s = /^(.+?)(?:\s+\[\s*(.+?)\s*\])?$/),
                    (r = /\(|\)|'/),
                    (a = { contain: 1, cover: 1 }),
                    (l = function (e) {
                        var t, i;
                        e.target._lazybgset &&
                            ((i = (t = e.target)._lazybgset),
                            (e = t.currentSrc || t.src) && (i.style.backgroundImage = "url(" + (r.test(e) ? JSON.stringify(e) : e) + ")"),
                            t._lazybgsetLoading && (n.fire(i, "_lazyloaded", {}, !1, !0), delete t._lazybgsetLoading));
                    }),
                    addEventListener("lazybeforeunveil", function (e) {
                        var r, a, c, d, u, p, h;
                        !e.defaultPrevented &&
                            (p = e.target.getAttribute("data-bgset")) &&
                            ((h = e.target),
                            ((r = t.createElement("img")).alt = ""),
                            (r._lazybgsetLoading = !0),
                            (e.detail.firesLoad = !0),
                            (a = p),
                            (c = h),
                            (e = r),
                            (d = t.createElement("picture")),
                            (u = c.getAttribute(lazySizesConfig.sizesAttr)),
                            (p = c.getAttribute("data-ratio")),
                            (h = c.getAttribute("data-optimumx")),
                            c._lazybgset && c._lazybgset.parentNode == c && c.removeChild(c._lazybgset),
                            Object.defineProperty(e, "_lazybgset", { value: c, writable: !0 }),
                            Object.defineProperty(c, "_lazybgset", { value: d, writable: !0 }),
                            (a = a.replace(i, " ").split(o)),
                            (d.style.display = "none"),
                            (e.className = lazySizesConfig.lazyClass),
                            1 != a.length || u || (u = "auto"),
                            a.forEach(function (e) {
                                var n = t.createElement("source");
                                u && "auto" != u && n.setAttribute("sizes", u),
                                    e.match(s) && (n.setAttribute(lazySizesConfig.srcsetAttr, RegExp.$1), RegExp.$2 && n.setAttribute("media", lazySizesConfig.customMedia[RegExp.$2] || RegExp.$2)),
                                    d.appendChild(n);
                            }),
                            u && (e.setAttribute(lazySizesConfig.sizesAttr, u), c.removeAttribute(lazySizesConfig.sizesAttr), c.removeAttribute("sizes")),
                            h && e.setAttribute("data-optimumx", h),
                            p && e.setAttribute("data-ratio", p),
                            d.appendChild(e),
                            c.appendChild(d),
                            setTimeout(function () {
                                n.loader.unveil(r),
                                    n.rAF(function () {
                                        n.fire(r, "_lazyloaded", {}, !0, !0), r.complete && l({ target: r });
                                    });
                            }));
                    }),
                    t.addEventListener("load", l, !0),
                    e.addEventListener(
                        "lazybeforesizes",
                        function (e) {
                            var t, i, o;
                            e.detail.instance == n &&
                                e.target._lazybgset &&
                                e.detail.dataAttr &&
                                ((i = o = e.target._lazybgset),
                                (o = (getComputedStyle(i) || { getPropertyValue: function () {} }).getPropertyValue("background-size")),
                                (t = o = !a[o] && a[i.style.backgroundSize] ? i.style.backgroundSize : o),
                                a[t] &&
                                    ((e.target._lazysizesParentFit = t),
                                    n.rAF(function () {
                                        e.target.setAttribute("data-parent-fit", t), e.target._lazysizesParentFit && delete e.target._lazysizesParentFit;
                                    })));
                        },
                        !0
                    ),
                    t.documentElement.addEventListener("lazybeforesizes", function (e) {
                        var t;
                        !e.defaultPrevented &&
                            e.target._lazybgset &&
                            e.detail.instance == n &&
                            (e.detail.width = ((t = e.target._lazybgset), (e = n.gW(t, t.parentNode)), (!t._lazysizesWidth || e > t._lazysizesWidth) && (t._lazysizesWidth = e), t._lazysizesWidth));
                    }));
            }).bind(null, c, c.document)),
            "object" == ("undefined" == typeof module ? "undefined" : _typeof(module)) && module.exports ? d(require("lazysizes")) : c.lazySizes ? Ce() : c.addEventListener("lazyunveilread", Ce, !0),
            document.addEventListener("lazyloaded", function (e) {
                e.target.parentElement.className = e.target.parentElement.className.replace("lazyload--placeholder", "");
            }),
            (u = this),
            (p = function () {
                "use strict";
                return function (e, t, n, i) {
                    var o = {
                        features: null,
                        bind: function (e, t, n, i) {
                            var o = (i ? "remove" : "add") + "EventListener";
                            t = t.split(" ");
                            for (var s = 0; s < t.length; s++) t[s] && e[o](t[s], n, !1);
                        },
                        isArray: function (e) {
                            return e instanceof Array;
                        },
                        createEl: function (e, t) {
                            return (t = document.createElement(t || "div")), e && (t.className = e), t;
                        },
                        getScrollY: function () {
                            var e = window.pageYOffset;
                            return void 0 !== e ? e : document.documentElement.scrollTop;
                        },
                        unbind: function (e, t, n) {
                            o.bind(e, t, n, !0);
                        },
                        removeClass: function (e, t) {
                            (t = new RegExp("(\\s|^)" + t + "(\\s|$)")),
                                (e.className = e.className
                                    .replace(t, " ")
                                    .replace(/^\s\s*/, "")
                                    .replace(/\s\s*$/, ""));
                        },
                        addClass: function (e, t) {
                            o.hasClass(e, t) || (e.className += (e.className ? " " : "") + t);
                        },
                        hasClass: function (e, t) {
                            return e.className && new RegExp("(^|\\s)" + t + "(\\s|$)").test(e.className);
                        },
                        getChildByClass: function (e, t) {
                            for (var n = e.firstChild; n; ) {
                                if (o.hasClass(n, t)) return n;
                                n = n.nextSibling;
                            }
                        },
                        arraySearch: function (e, t, n) {
                            for (var i = e.length; i--; ) if (e[i][n] === t) return i;
                            return -1;
                        },
                        extend: function (e, t, n) {
                            for (var i in t) t.hasOwnProperty(i) && ((n && e.hasOwnProperty(i)) || (e[i] = t[i]));
                        },
                        easing: {
                            sine: {
                                out: function (e) {
                                    return Math.sin(e * (Math.PI / 2));
                                },
                                inOut: function (e) {
                                    return -(Math.cos(Math.PI * e) - 1) / 2;
                                },
                            },
                            cubic: {
                                out: function (e) {
                                    return --e * e * e + 1;
                                },
                            },
                        },
                        detectFeatures: function () {
                            if (o.features) return o.features;
                            var e,
                                t,
                                n = o.createEl().style,
                                i = "",
                                s = {};
                            (s.oldIE = document.all && !document.addEventListener),
                                (s.touch = "ontouchstart" in window),
                                window.requestAnimationFrame && ((s.raf = window.requestAnimationFrame), (s.caf = window.cancelAnimationFrame)),
                                (s.pointerEvent = navigator.pointerEnabled || navigator.msPointerEnabled),
                                s.pointerEvent ||
                                    ((e = navigator.userAgent),
                                    !/iP(hone|od)/.test(navigator.platform) || ((t = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/)) && 0 < t.length && 1 <= (t = parseInt(t[1], 10)) && t < 8 && (s.isOldIOSPhone = !0)),
                                    (t = (t = e.match(/Android\s([0-9\.]*)/)) ? t[1] : 0),
                                    1 <= (t = parseFloat(t)) && (t < 4.4 && (s.isOldAndroid = !0), (s.androidVersion = t)),
                                    (s.isMobileOpera = /opera mini|opera mobi/i.test(e)));
                            for (var r, a, l, c = ["transform", "perspective", "animationName"], d = ["", "webkit", "Moz", "ms", "O"], u = 0; u < 4; u++) {
                                i = d[u];
                                for (var p = 0; p < 3; p++) (r = c[p]), (a = i + (i ? r.charAt(0).toUpperCase() + r.slice(1) : r)), !s[r] && a in n && (s[r] = a);
                                i && !s.raf && ((i = i.toLowerCase()), (s.raf = window[i + "RequestAnimationFrame"]), s.raf && (s.caf = window[i + "CancelAnimationFrame"] || window[i + "CancelRequestAnimationFrame"]));
                            }
                            return (
                                s.raf ||
                                    ((l = 0),
                                    (s.raf = function (e) {
                                        var t = new Date().getTime(),
                                            n = Math.max(0, 16 - (t - l)),
                                            i = window.setTimeout(function () {
                                                e(t + n);
                                            }, n);
                                        return (l = t + n), i;
                                    }),
                                    (s.caf = function (e) {
                                        clearTimeout(e);
                                    })),
                                (s.svg = !!document.createElementNS && !!document.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGRect),
                                (o.features = s)
                            );
                        },
                    };
                    o.detectFeatures(),
                        o.features.oldIE &&
                            (o.bind = function (e, t, n, i) {
                                t = t.split(" ");
                                for (
                                    var o,
                                        s = (i ? "detach" : "attach") + "Event",
                                        r = function () {
                                            n.handleEvent.call(n);
                                        },
                                        a = 0;
                                    a < t.length;
                                    a++
                                )
                                    if ((o = t[a]))
                                        if ("object" == _typeof(n) && n.handleEvent) {
                                            if (i) {
                                                if (!n["oldIE" + o]) return !1;
                                            } else n["oldIE" + o] = r;
                                            e[s]("on" + o, n["oldIE" + o]);
                                        } else e[s]("on" + o, n);
                            });
                    var s = this,
                        r = {
                            allowPanToNext: !0,
                            spacing: 0.12,
                            bgOpacity: 1,
                            mouseUsed: !1,
                            loop: !0,
                            pinchToClose: !0,
                            closeOnScroll: !0,
                            closeOnVerticalDrag: !0,
                            verticalDragRange: 0.75,
                            hideAnimationDuration: 333,
                            showAnimationDuration: 333,
                            showHideOpacity: !1,
                            focus: !0,
                            escKey: !0,
                            arrowKeys: !0,
                            mainScrollEndFriction: 0.35,
                            panEndFriction: 0.35,
                            isClickableElement: function (e) {
                                return "A" === e.tagName;
                            },
                            getDoubleTapZoom: function (e, t) {
                                return e || t.initialZoomLevel < 0.7 ? 1 : 1.33;
                            },
                            maxSpreadZoom: 1.33,
                            modal: !0,
                            scaleMode: "fit",
                        };
                    function a(e, t) {
                        o.extend(s, t.publicMethods), Je.push(e);
                    }
                    function l(e) {
                        var t = Bt();
                        return t - 1 < e ? e - t : e < 0 ? t + e : e;
                    }
                    function c(e, t) {
                        return nt[e] || (nt[e] = []), nt[e].push(t);
                    }
                    function d(e) {
                        var t = nt[e];
                        if (t) {
                            var n = Array.prototype.slice.call(arguments);
                            n.shift();
                            for (var i = 0; i < t.length; i++) t[i].apply(s, n);
                        }
                    }
                    function u() {
                        return new Date().getTime();
                    }
                    function p(e) {
                        (qe = e), (s.bg.style.opacity = e * r.bgOpacity);
                    }
                    function h(e, t, n, i, o) {
                        (!tt || (o && o !== s.currItem)) && (i /= (o || s.currItem).fitRatio), (e[ce] = J + t + "px, " + n + "px" + ee + " scale(" + i + ")");
                    }
                    function f(e, t) {
                        var n;
                        !r.loop && t && ((n = V + (Ke.x * Xe - e) / Ke.x), (t = Math.round(e - xt.x)), ((n < 0 && 0 < t) || (n >= Bt() - 1 && t < 0)) && (e = xt.x + t * r.mainScrollEndFriction)), (xt.x = e), st(e, U);
                    }
                    function m(e, t) {
                        var n = Tt[e] - Ye[e];
                        return Ve[e] + Be[e] + n - (t / Q) * n;
                    }
                    function g(e, t) {
                        (e.x = t.x), (e.y = t.y), t.id && (e.id = t.id);
                    }
                    function v(e) {
                        (e.x = Math.round(e.x)), (e.y = Math.round(e.y));
                    }
                    function y() {
                        rt && (o.unbind(document, "mousemove", y), o.addClass(e, "pswp--has_mouse"), (r.mouseUsed = !0), d("mouseUsed")),
                            (rt = setTimeout(function () {
                                rt = null;
                            }, 100));
                    }
                    function b(e, t) {
                        return (e = Yt(s.currItem, Ge, e)), t && (ze = e), e;
                    }
                    function w(e) {
                        return (e = e || s.currItem).initialZoomLevel;
                    }
                    function x(e) {
                        return 0 < (e = e || s.currItem).w ? r.maxSpreadZoom : 1;
                    }
                    function T(e, t, n, i) {
                        return i === s.currItem.initialZoomLevel ? ((n[e] = s.currItem.initialPosition[e]), !0) : ((n[e] = m(e, i)), n[e] > t.min[e] ? ((n[e] = t.min[e]), !0) : n[e] < t.max[e] && ((n[e] = t.max[e]), !0));
                    }
                    function C(e) {
                        var t = "";
                        r.escKey && 27 === e.keyCode ? (t = "close") : r.arrowKeys && (37 === e.keyCode ? (t = "prev") : 39 === e.keyCode && (t = "next")),
                            t && (e.ctrlKey || e.altKey || e.shiftKey || e.metaKey || (e.preventDefault ? e.preventDefault() : (e.returnValue = !1), s[t]()));
                    }
                    function S(e) {
                        e && (Ae || Ee || Ne || Se) && (e.preventDefault(), e.stopPropagation());
                    }
                    function k() {
                        s.setScrollOffset(0, o.getScrollY());
                    }
                    function $(e) {
                        at[e] && (at[e].raf && he(at[e].raf), lt--, delete at[e]);
                    }
                    function _(e) {
                        at[e] && $(e), at[e] || (lt++, (at[e] = {}));
                    }
                    function E() {
                        for (var e in at) at.hasOwnProperty(e) && $(e);
                    }
                    function A(e, t, n, i, o, s, r) {
                        var a,
                            l = u();
                        _(e),
                            (function c() {
                                if (at[e]) {
                                    if (((a = u() - l), i <= a)) return $(e), s(n), void (r && r());
                                    s((n - t) * o(a / i) + t), (at[e].raf = pe(c));
                                }
                            })();
                    }
                    function M(e, t) {
                        return (vt.x = Math.abs(e.x - t.x)), (vt.y = Math.abs(e.y - t.y)), Math.sqrt(vt.x * vt.x + vt.y * vt.y);
                    }
                    function P() {
                        $e && ((Me = pe(P)), At());
                    }
                    function L(e, t) {
                        return !(!e || e === document) && !(e.getAttribute("class") && -1 < e.getAttribute("class").indexOf("pswp__scroll-wrap")) && (t(e) ? e : L(e.parentNode, t));
                    }
                    function D(e, t) {
                        return (kt.prevent = !L(e.target, r.isClickableElement)), d("preventDragEvent", e, t, kt), kt.prevent;
                    }
                    function O(e, t) {
                        return (t.x = e.pageX), (t.y = e.pageY), (t.id = e.identifier), t;
                    }
                    function z(e, t, n) {
                        (n.x = 0.5 * (e.x + t.x)), (n.y = 0.5 * (e.y + t.y));
                    }
                    function I() {
                        var e = Ue.y - s.currItem.initialPosition.y;
                        return 1 - Math.abs(e / (Ge.y / 2));
                    }
                    function N(e) {
                        for (; 0 < Et.length; ) Et.pop();
                        return (
                            de
                                ? ((We = 0),
                                  ft.forEach(function (e) {
                                      0 === We ? (Et[0] = e) : 1 === We && (Et[1] = e), We++;
                                  }))
                                : -1 < e.type.indexOf("touch")
                                ? e.touches && 0 < e.touches.length && ((Et[0] = O(e.touches[0], $t)), 1 < e.touches.length && (Et[1] = O(e.touches[1], _t)))
                                : (($t.x = e.pageX), ($t.y = e.pageY), ($t.id = ""), (Et[0] = $t)),
                            Et
                        );
                    }
                    function j(e, t) {
                        var n,
                            i,
                            o,
                            a = Ue[e] + t[e],
                            l = 0 < t[e],
                            c = xt.x + t.x,
                            d = xt.x - mt.x,
                            u = a > ze.min[e] || a < ze.max[e] ? r.panEndFriction : 1;
                        return (
                            (a = Ue[e] + t[e] * u),
                            (!r.allowPanToNext && Z !== s.currItem.initialZoomLevel) ||
                            (Ie
                                ? "h" !== je ||
                                  "x" !== e ||
                                  Ee ||
                                  (l
                                      ? (a > ze.min[e] && ((u = r.panEndFriction), ze.min[e], (n = ze.min[e] - Ve[e])), (n <= 0 || d < 0) && 1 < Bt() ? ((o = c), d < 0 && c > mt.x && (o = mt.x)) : ze.min.x !== ze.max.x && (i = a))
                                      : (a < ze.max[e] && ((u = r.panEndFriction), ze.max[e], (n = Ve[e] - ze.max[e])), (n <= 0 || 0 < d) && 1 < Bt() ? ((o = c), 0 < d && c < mt.x && (o = mt.x)) : ze.min.x !== ze.max.x && (i = a)))
                                : (o = c),
                            "x" !== e)
                                ? void (Ne || Pe || (Z > s.currItem.fitRatio && (Ue[e] += t[e] * u)))
                                : (void 0 !== o && (f(o, !0), (Pe = o !== mt.x)), ze.min.x !== ze.max.x && (void 0 !== i ? (Ue.x = i) : Pe || (Ue.x += t.x * u)), void 0 !== o)
                        );
                    }
                    function R(e) {
                        var t;
                        ("mousedown" === e.type && 0 < e.button) ||
                            (Ft
                                ? e.preventDefault()
                                : (ke && "mousedown" === e.type) ||
                                  (D(e, !0) && e.preventDefault(),
                                  d("pointerDown"),
                                  de && ((t = o.arraySearch(ft, e.pointerId, "id")) < 0 && (t = ft.length), (ft[t] = { x: e.pageX, y: e.pageY, id: e.pointerId })),
                                  (e = (t = N(e)).length),
                                  (Le = null),
                                  E(),
                                  ($e && 1 !== e) ||
                                      (($e = Re = !0),
                                      o.bind(window, X, s),
                                      (Ce = Fe = He = Se = Pe = Ae = _e = Ee = !1),
                                      (je = null),
                                      d("firstTouchStart", t),
                                      g(Ve, Ue),
                                      (Be.x = Be.y = 0),
                                      g(pt, t[0]),
                                      g(ht, pt),
                                      (mt.x = Ke.x * Xe),
                                      (gt = [{ x: pt.x, y: pt.y }]),
                                      (xe = we = u()),
                                      b(Z, !0),
                                      St(),
                                      P()),
                                  !De &&
                                      1 < e &&
                                      !Ne &&
                                      !Pe &&
                                      ((Q = Z), (De = _e = !(Ee = !1)), (Be.y = Be.x = 0), g(Ve, Ue), g(ct, t[0]), g(dt, t[1]), z(ct, dt, Ct), (Tt.x = Math.abs(Ct.x) - Ue.x), (Tt.y = Math.abs(Ct.y) - Ue.y), (Oe = M(ct, dt)))));
                    }
                    function H(e) {
                        var t, n;
                        e.preventDefault(),
                            de && -1 < (t = o.arraySearch(ft, e.pointerId, "id")) && (((n = ft[t]).x = e.pageX), (n.y = e.pageY)),
                            $e && ((n = N(e)), je || Ae || De ? (Le = n) : xt.x !== Ke.x * Xe ? (je = "h") : ((e = Math.abs(n[0].x - pt.x) - Math.abs(n[0].y - pt.y)), 10 <= Math.abs(e) && ((je = 0 < e ? "h" : "v"), (Le = n))));
                    }
                    function q(e) {
                        if (ye.isOldAndroid) {
                            if (ke && "mouseup" === e.type) return;
                            -1 < e.type.indexOf("touch") &&
                                (clearTimeout(ke),
                                (ke = setTimeout(function () {
                                    ke = 0;
                                }, 600)));
                        }
                        d("pointerUp"),
                            D(e, !1) && e.preventDefault(),
                            !de ||
                                (-1 < (n = o.arraySearch(ft, e.pointerId, "id")) &&
                                    ((l = ft.splice(n, 1)[0]),
                                    navigator.pointerEnabled ? (l.type = e.pointerType || "mouse") : ((l.type = { 4: "mouse", 2: "touch", 3: "pen" }[e.pointerType]), l.type || (l.type = e.pointerType || "mouse"))));
                        var t = N(e),
                            n = t.length;
                        if (2 === (n = "mouseup" === e.type ? 0 : n)) return !(Le = null);
                        1 === n && g(ht, t[0]),
                            0 !== n ||
                                je ||
                                Ne ||
                                (l || ("mouseup" === e.type ? (l = { x: e.pageX, y: e.pageY, type: "mouse" }) : e.changedTouches && e.changedTouches[0] && (l = { x: e.changedTouches[0].pageX, y: e.changedTouches[0].pageY, type: "touch" })),
                                d("touchRelease", e, l));
                        var i,
                            a,
                            l = -1;
                        if (
                            (0 === n && (($e = !1), o.unbind(window, X, s), St(), De ? (l = 0) : -1 !== wt && (l = u() - wt)),
                            (wt = 1 === n ? u() : -1),
                            (l = -1 !== l && l < 150 ? "zoom" : "swipe"),
                            De && n < 2 && ((De = !1), 1 === n && (l = "zoomPointerUp"), d("zoomGestureEnded")),
                            (Le = null),
                            Ae || Ee || Ne || Se)
                        )
                            if ((E(), (Te = Te || Mt()).calculateSwipeSpeed("x"), Se))
                                I() < r.verticalDragRange
                                    ? s.close()
                                    : ((i = Ue.y),
                                      (a = qe),
                                      A("verticalDrag", 0, 1, 300, o.easing.cubic.out, function (e) {
                                          (Ue.y = (s.currItem.initialPosition.y - i) * e + i), p((1 - a) * e + a), it();
                                      }),
                                      d("onVerticalDrag", 1));
                            else {
                                if ((Pe || Ne) && 0 === n) {
                                    if (Lt(l, Te)) return;
                                    l = "zoomPointerUp";
                                }
                                if (!Ne) return "swipe" !== l ? void Ot() : void (!Pe && Z > s.currItem.fitRatio && Pt(Te));
                            }
                    }
                    o.extend(r, i);
                    var F,
                        W,
                        B,
                        V,
                        U,
                        G,
                        X,
                        Y,
                        K,
                        Z,
                        Q,
                        J,
                        ee,
                        te,
                        ne,
                        ie,
                        oe,
                        se,
                        re,
                        ae,
                        le,
                        ce,
                        de,
                        ue,
                        pe,
                        he,
                        fe,
                        me,
                        ge,
                        ve,
                        ye,
                        be,
                        we,
                        xe,
                        Te,
                        Ce,
                        Se,
                        ke,
                        $e,
                        _e,
                        Ee,
                        Ae,
                        Me,
                        Pe,
                        Le,
                        De,
                        Oe,
                        ze,
                        Ie,
                        Ne,
                        je,
                        Re,
                        He,
                        qe,
                        Fe,
                        We,
                        Be = { x: 0, y: 0 },
                        Ve = { x: 0, y: 0 },
                        Ue = { x: 0, y: 0 },
                        Ge = {},
                        Xe = 0,
                        Ye = {},
                        Ke = { x: 0, y: 0 },
                        Ze = 0,
                        Qe = !0,
                        Je = [],
                        et = {},
                        tt = !1,
                        nt = {},
                        it = function (e) {
                            Ie && (e && (Z > s.currItem.fitRatio ? tt || (Kt(s.currItem, !1, !0), (tt = !0)) : tt && (Kt(s.currItem), (tt = !1))), h(Ie, Ue.x, Ue.y, Z));
                        },
                        ot = function (e) {
                            e.container && h(e.container.style, e.initialPosition.x, e.initialPosition.y, e.initialZoomLevel, e);
                        },
                        st = function (e, t) {
                            t[ce] = J + e + "px, 0px" + ee;
                        },
                        rt = null,
                        at = {},
                        lt = 0,
                        ct =
                            ((i = {
                                shout: d,
                                listen: c,
                                viewportSize: Ge,
                                options: r,
                                isMainScrollAnimating: function () {
                                    return Ne;
                                },
                                getZoomLevel: function () {
                                    return Z;
                                },
                                getCurrentIndex: function () {
                                    return V;
                                },
                                isDragging: function () {
                                    return $e;
                                },
                                isZooming: function () {
                                    return De;
                                },
                                setScrollOffset: function (e, t) {
                                    (Ye.x = e), (ve = Ye.y = t), d("updateScrollOffset", Ye);
                                },
                                applyZoomPan: function (e, t, n, i) {
                                    (Ue.x = t), (Ue.y = n), (Z = e), it(i);
                                },
                                init: function () {
                                    if (!F && !W) {
                                        var n;
                                        (s.framework = o),
                                            (s.template = e),
                                            (s.bg = o.getChildByClass(e, "pswp__bg")),
                                            (fe = e.className),
                                            (F = !0),
                                            (ye = o.detectFeatures()),
                                            (pe = ye.raf),
                                            (he = ye.caf),
                                            (ce = ye.transform),
                                            (ge = ye.oldIE),
                                            (s.scrollWrap = o.getChildByClass(e, "pswp__scroll-wrap")),
                                            (s.container = o.getChildByClass(s.scrollWrap, "pswp__container")),
                                            (U = s.container.style),
                                            (s.itemHolders = ie = [
                                                { el: s.container.children[0], wrap: 0, index: -1 },
                                                { el: s.container.children[1], wrap: 0, index: -1 },
                                                { el: s.container.children[2], wrap: 0, index: -1 },
                                            ]),
                                            (ie[0].el.style.display = ie[2].el.style.display = "none"),
                                            (function () {
                                                if (ce) {
                                                    var t = ye.perspective && !ue;
                                                    return (J = "translate" + (t ? "3d(" : "(")), (ee = ye.perspective ? ", 0px)" : ")");
                                                }
                                                (ce = "left"),
                                                    o.addClass(e, "pswp--ie"),
                                                    (st = function (e, t) {
                                                        t.left = e + "px";
                                                    }),
                                                    (ot = function (e) {
                                                        var t = 1 < e.fitRatio ? 1 : e.fitRatio,
                                                            n = e.container.style,
                                                            i = t * e.w;
                                                        (t *= e.h), (n.width = i + "px"), (n.height = t + "px"), (n.left = e.initialPosition.x + "px"), (n.top = e.initialPosition.y + "px");
                                                    }),
                                                    (it = function () {
                                                        var e, t, n;
                                                        Ie && ((t = (n = 1 < (e = s.currItem).fitRatio ? 1 : e.fitRatio) * e.w), (n *= e.h), ((e = Ie).width = t + "px"), (e.height = n + "px"), (e.left = Ue.x + "px"), (e.top = Ue.y + "px"));
                                                    });
                                            })(),
                                            (K = {
                                                resize: s.updateSize,
                                                orientationchange: function () {
                                                    clearTimeout(be),
                                                        (be = setTimeout(function () {
                                                            Ge.x !== s.scrollWrap.clientWidth && s.updateSize();
                                                        }, 500));
                                                },
                                                scroll: k,
                                                keydown: C,
                                                click: S,
                                            });
                                        var i = ye.isOldIOSPhone || ye.isOldAndroid || ye.isMobileOpera;
                                        for ((ye.animationName && ye.transform && !i) || (r.showAnimationDuration = r.hideAnimationDuration = 0), n = 0; n < Je.length; n++) s["init" + Je[n]]();
                                        for (
                                            t && (s.ui = new t(s, o)).init(),
                                                d("firstUpdate"),
                                                V = V || r.index || 0,
                                                (isNaN(V) || V < 0 || V >= Bt()) && (V = 0),
                                                s.currItem = Wt(V),
                                                (ye.isOldIOSPhone || ye.isOldAndroid) && (Qe = !1),
                                                e.setAttribute("aria-hidden", "false"),
                                                r.modal && (Qe ? (e.style.position = "fixed") : ((e.style.position = "absolute"), (e.style.top = o.getScrollY() + "px"))),
                                                void 0 === ve && (d("initialLayout"), (ve = me = o.getScrollY())),
                                                i = "pswp--open ",
                                                r.mainClass && (i += r.mainClass + " "),
                                                r.showHideOpacity && (i += "pswp--animate_opacity "),
                                                i += ue ? "pswp--touch" : "pswp--notouch",
                                                i += ye.animationName ? " pswp--css_animation" : "",
                                                i += ye.svg ? " pswp--svg" : "",
                                                o.addClass(e, i),
                                                s.updateSize(),
                                                G = -1,
                                                Ze = null,
                                                n = 0;
                                            n < 3;
                                            n++
                                        )
                                            st((n + G) * Ke.x, ie[n].el.style);
                                        ge || o.bind(s.scrollWrap, Y, s),
                                            c("initialZoomInEnd", function () {
                                                s.setContent(ie[0], V - 1),
                                                    s.setContent(ie[2], V + 1),
                                                    (ie[0].el.style.display = ie[2].el.style.display = "block"),
                                                    r.focus && e.focus(),
                                                    o.bind(document, "keydown", s),
                                                    ye.transform && o.bind(s.scrollWrap, "click", s),
                                                    r.mouseUsed || o.bind(document, "mousemove", y),
                                                    o.bind(window, "resize scroll orientationchange", s),
                                                    d("bindEvents");
                                            }),
                                            s.setContent(ie[1], V),
                                            s.updateCurrItem(),
                                            d("afterInit"),
                                            Qe ||
                                                (te = setInterval(function () {
                                                    lt || $e || De || Z !== s.currItem.initialZoomLevel || s.updateSize();
                                                }, 1e3)),
                                            o.addClass(e, "pswp--visible");
                                    }
                                },
                                close: function () {
                                    F &&
                                        ((W = !(F = !1)),
                                        d("close"),
                                        o.unbind(window, "resize scroll orientationchange", s),
                                        o.unbind(window, "scroll", K.scroll),
                                        o.unbind(document, "keydown", s),
                                        o.unbind(document, "mousemove", y),
                                        ye.transform && o.unbind(s.scrollWrap, "click", s),
                                        $e && o.unbind(window, X, s),
                                        clearTimeout(be),
                                        d("unbindEvents"),
                                        Vt(s.currItem, null, !0, s.destroy));
                                },
                                destroy: function () {
                                    d("destroy"),
                                        Rt && clearTimeout(Rt),
                                        e.setAttribute("aria-hidden", "true"),
                                        (e.className = fe),
                                        te && clearInterval(te),
                                        o.unbind(s.scrollWrap, Y, s),
                                        o.unbind(window, "scroll", s),
                                        St(),
                                        E(),
                                        (nt = null);
                                },
                                panTo: function (e, t, n) {
                                    n || (e > ze.min.x ? (e = ze.min.x) : e < ze.max.x && (e = ze.max.x), t > ze.min.y ? (t = ze.min.y) : t < ze.max.y && (t = ze.max.y)), (Ue.x = e), (Ue.y = t), it();
                                },
                                handleEvent: function (e) {
                                    (e = e || window.event), K[e.type] && K[e.type](e);
                                },
                                goTo: function (e) {
                                    var t = (e = l(e)) - V;
                                    (Ze = t), (V = e), (s.currItem = Wt(V)), (Xe -= t), f(Ke.x * Xe), E(), (Ne = !1), s.updateCurrItem();
                                },
                                next: function () {
                                    s.goTo(V + 1);
                                },
                                prev: function () {
                                    s.goTo(V - 1);
                                },
                                updateCurrZoomItem: function (e) {
                                    var t;
                                    e && d("beforeChange", 0),
                                        (Ie = ie[1].el.children.length ? ((t = ie[1].el.children[0]), o.hasClass(t, "pswp__zoom-wrap") ? t.style : null) : null),
                                        (ze = s.currItem.bounds),
                                        (Q = Z = s.currItem.initialZoomLevel),
                                        (Ue.x = ze.center.x),
                                        (Ue.y = ze.center.y),
                                        e && d("afterChange");
                                },
                                invalidateCurrItems: function () {
                                    ne = !0;
                                    for (var e = 0; e < 3; e++) ie[e].item && (ie[e].item.needsUpdate = !0);
                                },
                                updateCurrItem: function (e) {
                                    if (0 !== Ze) {
                                        var t,
                                            n = Math.abs(Ze);
                                        if (!(e && n < 2)) {
                                            (s.currItem = Wt(V)), (tt = !1), d("beforeChange", Ze), 3 <= n && ((G += Ze + (0 < Ze ? -3 : 3)), (n = 3));
                                            for (var i = 0; i < n; i++)
                                                0 < Ze
                                                    ? ((t = ie.shift()), (ie[2] = t), st((2 + ++G) * Ke.x, t.el.style), s.setContent(t, V - n + i + 1 + 1))
                                                    : ((t = ie.pop()), ie.unshift(t), st(--G * Ke.x, t.el.style), s.setContent(t, V + n - i - 1 - 1));
                                            !Ie || 1 !== Math.abs(Ze) || ((e = Wt(oe)).initialZoomLevel !== Z && (Yt(e, Ge), Kt(e), ot(e))), (Ze = 0), s.updateCurrZoomItem(), (oe = V), d("afterChange");
                                        }
                                    }
                                },
                                updateSize: function (t) {
                                    if (!Qe && r.modal) {
                                        var n = o.getScrollY();
                                        if ((ve !== n && ((e.style.top = n + "px"), (ve = n)), !t && et.x === window.innerWidth && et.y === window.innerHeight)) return;
                                        (et.x = window.innerWidth), (et.y = window.innerHeight), (e.style.height = et.y + "px");
                                    }
                                    if (((Ge.x = s.scrollWrap.clientWidth), (Ge.y = s.scrollWrap.clientHeight), k(), (Ke.x = Ge.x + Math.round(Ge.x * r.spacing)), (Ke.y = Ge.y), f(Ke.x * Xe), d("beforeResize"), void 0 !== G)) {
                                        for (var i, a, c, u = 0; u < 3; u++)
                                            (i = ie[u]),
                                                st((u + G) * Ke.x, i.el.style),
                                                (c = V + u - 1),
                                                r.loop && 2 < Bt() && (c = l(c)),
                                                (a = Wt(c)) && (ne || a.needsUpdate || !a.bounds)
                                                    ? (s.cleanSlide(a), s.setContent(i, c), 1 === u && ((s.currItem = a), s.updateCurrZoomItem(!0)), (a.needsUpdate = !1))
                                                    : -1 === i.index && 0 <= c && s.setContent(i, c),
                                                a && a.container && (Yt(a, Ge), Kt(a), ot(a));
                                        ne = !1;
                                    }
                                    (Q = Z = s.currItem.initialZoomLevel), (ze = s.currItem.bounds) && ((Ue.x = ze.center.x), (Ue.y = ze.center.y), it(!0)), d("resize");
                                },
                                zoomTo: function (e, t, n, i, s) {
                                    t && ((Q = Z), (Tt.x = Math.abs(t.x) - Ue.x), (Tt.y = Math.abs(t.y) - Ue.y), g(Ve, Ue)), (t = b(e, !1));
                                    var r = {};
                                    T("x", t, r, e), T("y", t, r, e);
                                    var a = Z,
                                        l = Ue.x,
                                        c = Ue.y;
                                    v(r),
                                        (t = function (t) {
                                            1 === t ? ((Z = e), (Ue.x = r.x), (Ue.y = r.y)) : ((Z = (e - a) * t + a), (Ue.x = (r.x - l) * t + l), (Ue.y = (r.y - c) * t + c)), s && s(t), it(1 === t);
                                        }),
                                        n ? A("customZoomTo", 0, 1, n, i || o.easing.sine.inOut, t) : t(1);
                                },
                            }),
                            {}),
                        dt = {},
                        ut = {},
                        pt = {},
                        ht = {},
                        ft = [],
                        mt = {},
                        gt = [],
                        vt = {},
                        yt = 0,
                        bt = { x: 0, y: 0 },
                        wt = 0,
                        xt = { x: 0, y: 0 },
                        Tt = { x: 0, y: 0 },
                        Ct = { x: 0, y: 0 },
                        St = function () {
                            Me && (he(Me), (Me = null));
                        },
                        kt = {},
                        $t = {},
                        _t = {},
                        Et = [],
                        At = function () {
                            if (Le) {
                                var e = Le.length;
                                if (0 !== e)
                                    if ((g(ct, Le[0]), (ut.x = ct.x - pt.x), (ut.y = ct.y - pt.y), De && 1 < e))
                                        (pt.x = ct.x),
                                            (pt.y = ct.y),
                                            (ut.x || ut.y || ((a = Le[1]), (l = dt), a.x !== l.x || a.y !== l.y)) &&
                                                (g(dt, Le[1]),
                                                Ee || ((Ee = !0), d("zoomGestureStarted")),
                                                (i = M(ct, dt)),
                                                (o = Dt(i)) > s.currItem.initialZoomLevel + s.currItem.initialZoomLevel / 15 && (Fe = !0),
                                                (n = 1),
                                                (e = w()),
                                                (a = x()),
                                                o < e
                                                    ? r.pinchToClose && !Fe && Q <= s.currItem.initialZoomLevel
                                                        ? (p((l = 1 - (e - o) / (e / 1.2))), d("onPinchClose", l), (He = !0))
                                                        : (o = e - (n = 1 < (n = (e - o) / e) ? 1 : n) * (e / 3))
                                                    : a < o && (o = a + (n = 1 < (n = (o - a) / (6 * e)) ? 1 : n) * e),
                                                n < 0 && (n = 0),
                                                z(ct, dt, bt),
                                                (Be.x += bt.x - Ct.x),
                                                (Be.y += bt.y - Ct.y),
                                                g(Ct, bt),
                                                (Ue.x = m("x", o)),
                                                (Ue.y = m("y", o)),
                                                (Ce = Z < o),
                                                (Z = o),
                                                it());
                                    else if (je && (Re && ((Re = !1), 10 <= Math.abs(ut.x) && (ut.x -= Le[0].x - ht.x), 10 <= Math.abs(ut.y) && (ut.y -= Le[0].y - ht.y)), (pt.x = ct.x), (pt.y = ct.y), 0 !== ut.x || 0 !== ut.y)) {
                                        if ("v" === je && r.closeOnVerticalDrag && "fit" === r.scaleMode && Z === s.currItem.initialZoomLevel) {
                                            (Be.y += ut.y), (Ue.y += ut.y);
                                            var t = I();
                                            return (Se = !0), d("onVerticalDrag", t), p(t), void it();
                                        }
                                        (n = u()),
                                            (i = ct.x),
                                            (o = ct.y),
                                            50 < n - xe && (((t = 2 < gt.length ? gt.shift() : {}).x = i), (t.y = o), gt.push(t), (xe = n)),
                                            (Ae = !0),
                                            (ze = s.currItem.bounds),
                                            j("x", ut) || (j("y", ut), v(Ue), it());
                                    }
                            }
                            var n, i, o, a, l;
                        },
                        Mt = function () {
                            var e,
                                t,
                                n = {
                                    lastFlickOffset: {},
                                    lastFlickDist: {},
                                    lastFlickSpeed: {},
                                    slowDownRatio: {},
                                    slowDownRatioReverse: {},
                                    speedDecelerationRatio: {},
                                    speedDecelerationRatioAbs: {},
                                    distanceOffset: {},
                                    backAnimDestination: {},
                                    backAnimStarted: {},
                                    calculateSwipeSpeed: function (i) {
                                        (t = 1 < gt.length ? ((e = u() - xe + 50), gt[gt.length - 2][i]) : ((e = u() - we), ht[i])),
                                            (n.lastFlickOffset[i] = pt[i] - t),
                                            (n.lastFlickDist[i] = Math.abs(n.lastFlickOffset[i])),
                                            20 < n.lastFlickDist[i] ? (n.lastFlickSpeed[i] = n.lastFlickOffset[i] / e) : (n.lastFlickSpeed[i] = 0),
                                            Math.abs(n.lastFlickSpeed[i]) < 0.1 && (n.lastFlickSpeed[i] = 0),
                                            (n.slowDownRatio[i] = 0.95),
                                            (n.slowDownRatioReverse[i] = 1 - n.slowDownRatio[i]),
                                            (n.speedDecelerationRatio[i] = 1);
                                    },
                                    calculateOverBoundsAnimOffset: function (e, t) {
                                        n.backAnimStarted[e] ||
                                            (Ue[e] > ze.min[e] ? (n.backAnimDestination[e] = ze.min[e]) : Ue[e] < ze.max[e] && (n.backAnimDestination[e] = ze.max[e]),
                                            void 0 !== n.backAnimDestination[e] &&
                                                ((n.slowDownRatio[e] = 0.7),
                                                (n.slowDownRatioReverse[e] = 1 - n.slowDownRatio[e]),
                                                n.speedDecelerationRatioAbs[e] < 0.05 &&
                                                    ((n.lastFlickSpeed[e] = 0),
                                                    (n.backAnimStarted[e] = !0),
                                                    A("bounceZoomPan" + e, Ue[e], n.backAnimDestination[e], t || 300, o.easing.sine.out, function (t) {
                                                        (Ue[e] = t), it();
                                                    }))));
                                    },
                                    calculateAnimOffset: function (e) {
                                        n.backAnimStarted[e] ||
                                            ((n.speedDecelerationRatio[e] = n.speedDecelerationRatio[e] * (n.slowDownRatio[e] + n.slowDownRatioReverse[e] - (n.slowDownRatioReverse[e] * n.timeDiff) / 10)),
                                            (n.speedDecelerationRatioAbs[e] = Math.abs(n.lastFlickSpeed[e] * n.speedDecelerationRatio[e])),
                                            (n.distanceOffset[e] = n.lastFlickSpeed[e] * n.speedDecelerationRatio[e] * n.timeDiff),
                                            (Ue[e] += n.distanceOffset[e]));
                                    },
                                    panAnimLoop: function () {
                                        if (
                                            at.zoomPan &&
                                            ((at.zoomPan.raf = pe(n.panAnimLoop)),
                                            (n.now = u()),
                                            (n.timeDiff = n.now - n.lastNow),
                                            (n.lastNow = n.now),
                                            n.calculateAnimOffset("x"),
                                            n.calculateAnimOffset("y"),
                                            it(),
                                            n.calculateOverBoundsAnimOffset("x"),
                                            n.calculateOverBoundsAnimOffset("y"),
                                            n.speedDecelerationRatioAbs.x < 0.05 && n.speedDecelerationRatioAbs.y < 0.05)
                                        )
                                            return (Ue.x = Math.round(Ue.x)), (Ue.y = Math.round(Ue.y)), it(), void $("zoomPan");
                                    },
                                };
                            return n;
                        },
                        Pt = function (e) {
                            return (
                                e.calculateSwipeSpeed("y"),
                                (ze = s.currItem.bounds),
                                (e.backAnimDestination = {}),
                                (e.backAnimStarted = {}),
                                Math.abs(e.lastFlickSpeed.x) <= 0.05 && Math.abs(e.lastFlickSpeed.y) <= 0.05
                                    ? ((e.speedDecelerationRatioAbs.x = e.speedDecelerationRatioAbs.y = 0), e.calculateOverBoundsAnimOffset("x"), e.calculateOverBoundsAnimOffset("y"), !0)
                                    : (_("zoomPan"), (e.lastNow = u()), void e.panAnimLoop())
                            );
                        },
                        Lt = function (e, t) {
                            var n, i;
                            Ne || (yt = V),
                                "swipe" === e && ((i = pt.x - ht.x), (e = t.lastFlickDist.x < 10), 30 < i && (e || 20 < t.lastFlickOffset.x) ? (l = -1) : i < -30 && (e || t.lastFlickOffset.x < -20) && (l = 1)),
                                l && ((V += l) < 0 ? ((V = r.loop ? Bt() - 1 : 0), (a = !0)) : V >= Bt() && ((V = r.loop ? 0 : Bt() - 1), (a = !0)), (a && !r.loop) || ((Ze += l), (Xe -= l), (n = !0)));
                            var a = Ke.x * Xe,
                                l = Math.abs(a - xt.x),
                                c = n || a > xt.x == 0 < t.lastFlickSpeed.x ? ((c = 0 < Math.abs(t.lastFlickSpeed.x) ? l / Math.abs(t.lastFlickSpeed.x) : 333), (c = Math.min(c, 400)), Math.max(c, 250)) : 333;
                            return (
                                yt === V && (n = !1),
                                (Ne = !0),
                                d("mainScrollAnimStart"),
                                A("mainScroll", xt.x, a, c, o.easing.cubic.out, f, function () {
                                    E(), (Ne = !1), (yt = -1), (!n && yt === V) || s.updateCurrItem(), d("mainScrollAnimComplete");
                                }),
                                n && s.updateCurrItem(!0),
                                n
                            );
                        },
                        Dt = function (e) {
                            return (1 / Oe) * e * Q;
                        },
                        Ot = function () {
                            var e = Z,
                                t = w(),
                                n = x();
                            Z < t ? (e = t) : n < Z && (e = n);
                            var i,
                                r = qe;
                            return (
                                He && !Ce && !Fe && Z < t
                                    ? s.close()
                                    : s.zoomTo(
                                          e,
                                          0,
                                          200,
                                          o.easing.cubic.out,
                                          (i = He
                                              ? function (e) {
                                                    p((1 - r) * e + r);
                                                }
                                              : i)
                                      ),
                                !0
                            );
                        };
                    function zt(e, t, n, i, o, r) {
                        t.loadError ||
                            (i &&
                                ((t.imageAppended = !0),
                                Kt(t, i, t === s.currItem && tt),
                                n.appendChild(i),
                                r &&
                                    setTimeout(function () {
                                        t && t.loaded && t.placeholder && ((t.placeholder.style.display = "none"), (t.placeholder = null));
                                    }, 500)));
                    }
                    function It(e) {
                        function t() {
                            (e.loading = !1), (e.loaded = !0), e.loadComplete ? e.loadComplete(e) : (e.img = null), (n.onload = n.onerror = null), (n = null);
                        }
                        (e.loading = !0), (e.loaded = !1);
                        var n = (e.img = o.createEl("pswp__img", "img"));
                        return (
                            (n.onload = t),
                            (n.onerror = function () {
                                (e.loadError = !0), t();
                            }),
                            (n.src = e.src),
                            n
                        );
                    }
                    function Nt(e, t) {
                        return e.src && e.loadError && e.container && (t && (e.container.innerHTML = ""), (e.container.innerHTML = r.errorMsg.replace("%url%", e.src)), 1);
                    }
                    function jt() {
                        if (Gt.length) {
                            for (var e, t = 0; t < Gt.length; t++) (e = Gt[t]).holder.index === e.index && zt(e.index, e.item, e.baseDiv, e.img, 0, e.clearPlaceholder);
                            Gt = [];
                        }
                    }
                    a("Gestures", {
                        publicMethods: {
                            initGestures: function () {
                                function e(e, t, n, i, o) {
                                    (se = e + t), (re = e + n), (ae = e + i), (le = o ? e + o : "");
                                }
                                (de = ye.pointerEvent) && ye.touch && (ye.touch = !1),
                                    de
                                        ? navigator.pointerEnabled
                                            ? e("pointer", "down", "move", "up", "cancel")
                                            : e("MSPointer", "Down", "Move", "Up", "Cancel")
                                        : ye.touch
                                        ? (e("touch", "start", "move", "end", "cancel"), (ue = !0))
                                        : e("mouse", "down", "move", "up"),
                                    (X = re + " " + ae + " " + le),
                                    (Y = se),
                                    de && !ue && (ue = 1 < navigator.maxTouchPoints || 1 < navigator.msMaxTouchPoints),
                                    (s.likelyTouchDevice = ue),
                                    (K[se] = R),
                                    (K[re] = H),
                                    (K[ae] = q),
                                    le && (K[le] = K[ae]),
                                    ye.touch && ((Y += " mousedown"), (X += " mousemove mouseup"), (K.mousedown = K[se]), (K.mousemove = K[re]), (K.mouseup = K[ae])),
                                    ue || (r.allowPanToNext = !1);
                            },
                        },
                    });
                    var Rt,
                        Ht,
                        qt,
                        Ft,
                        Wt,
                        Bt,
                        Vt = function (t, n, i, a) {
                            var l;
                            function c() {
                                $("initialZoom"),
                                    i ? (s.template.removeAttribute("style"), s.bg.removeAttribute("style")) : (p(1), n && (n.style.display = "block"), o.addClass(e, "pswp--animated-in"), d("initialZoom" + (i ? "OutEnd" : "InEnd"))),
                                    a && a(),
                                    (Ft = !1);
                            }
                            Rt && clearTimeout(Rt), (qt = Ft = !0), t.initialLayout ? ((l = t.initialLayout), (t.initialLayout = null)) : (l = r.getThumbBoundsFn && r.getThumbBoundsFn(V));
                            var u,
                                h,
                                f = i ? r.hideAnimationDuration : r.showAnimationDuration;
                            if (!f || !l || void 0 === l.x)
                                return (
                                    d("initialZoom" + (i ? "Out" : "In")),
                                    (Z = t.initialZoomLevel),
                                    g(Ue, t.initialPosition),
                                    it(),
                                    (e.style.opacity = i ? 0 : 1),
                                    p(1),
                                    void (f
                                        ? setTimeout(function () {
                                              c();
                                          }, f)
                                        : c())
                                );
                            (u = B),
                                (h = !s.currItem.src || s.currItem.loadError || r.showHideOpacity),
                                t.miniImg && (t.miniImg.style.webkitBackfaceVisibility = "hidden"),
                                i || ((Z = l.w / t.w), (Ue.x = l.x), (Ue.y = l.y - me), (s[h ? "template" : "bg"].style.opacity = 0.001), it()),
                                _("initialZoom"),
                                i && !u && o.removeClass(e, "pswp--animated-in"),
                                h &&
                                    (i
                                        ? o[(u ? "remove" : "add") + "Class"](e, "pswp--animate_opacity")
                                        : setTimeout(function () {
                                              o.addClass(e, "pswp--animate_opacity");
                                          }, 30)),
                                (Rt = setTimeout(
                                    function () {
                                        var n, s, r, a, m, v;
                                        d("initialZoom" + (i ? "Out" : "In")),
                                            i
                                                ? ((n = l.w / t.w),
                                                  (s = Ue.x),
                                                  (r = Ue.y),
                                                  (a = Z),
                                                  (m = qe),
                                                  (v = function (t) {
                                                      1 === t ? ((Z = n), (Ue.x = l.x), (Ue.y = l.y - ve)) : ((Z = (n - a) * t + a), (Ue.x = (l.x - s) * t + s), (Ue.y = (l.y - ve - r) * t + r)),
                                                          it(),
                                                          h ? (e.style.opacity = 1 - t) : p(m - t * m);
                                                  }),
                                                  u ? A("initialZoom", 0, 1, f, o.easing.cubic.out, v, c) : (v(1), (Rt = setTimeout(c, f + 20))))
                                                : ((Z = t.initialZoomLevel), g(Ue, t.initialPosition), it(), p(1), h ? (e.style.opacity = 1) : p(1), (Rt = setTimeout(c, f + 20)));
                                    },
                                    i ? 25 : 90
                                ));
                        },
                        Ut = {},
                        Gt = [],
                        Xt = {
                            index: 0,
                            errorMsg: '<div class="pswp__error-msg"><a href="%url%" target="_blank">The image</a> could not be loaded.</div>',
                            forceProgressiveLoading: !1,
                            preload: [1, 1],
                            getNumItemsFn: function () {
                                return Ht.length;
                            },
                        },
                        Yt = function (e, t, n) {
                            if (!e.src || e.loadError)
                                return (e.w = e.h = 0), (e.initialZoomLevel = e.fitRatio = 1), (e.bounds = { center: { x: 0, y: 0 }, max: { x: 0, y: 0 }, min: { x: 0, y: 0 } }), (e.initialPosition = e.bounds.center), e.bounds;
                            var i,
                                o,
                                s,
                                a = !n;
                            return (
                                a && (e.vGap || (e.vGap = { top: 0, bottom: 0 }), d("parseVerticalMargin", e)),
                                (Ut.x = t.x),
                                (Ut.y = t.y - e.vGap.top - e.vGap.bottom),
                                a &&
                                    ((i = Ut.x / e.w),
                                    (o = Ut.y / e.h),
                                    (e.fitRatio = i < o ? i : o),
                                    "orig" === (s = r.scaleMode) ? (n = 1) : "fit" === s && (n = e.fitRatio),
                                    (e.initialZoomLevel = n = 1 < n ? 1 : n),
                                    e.bounds || (e.bounds = { center: { x: 0, y: 0 }, max: { x: 0, y: 0 }, min: { x: 0, y: 0 } })),
                                n
                                    ? ((i = (t = e).w * n),
                                      (o = e.h * n),
                                      ((s = t.bounds).center.x = Math.round((Ut.x - i) / 2)),
                                      (s.center.y = Math.round((Ut.y - o) / 2) + t.vGap.top),
                                      (s.max.x = i > Ut.x ? Math.round(Ut.x - i) : s.center.x),
                                      (s.max.y = o > Ut.y ? Math.round(Ut.y - o) + t.vGap.top : s.center.y),
                                      (s.min.x = i > Ut.x ? 0 : s.center.x),
                                      (s.min.y = o > Ut.y ? t.vGap.top : s.center.y),
                                      a && n === e.initialZoomLevel && (e.initialPosition = e.bounds.center),
                                      e.bounds)
                                    : void 0
                            );
                        },
                        Kt = function (e, t, n) {
                            var i;
                            e.src &&
                                ((t = t || e.container.lastChild),
                                (i = n ? e.w : Math.round(e.w * e.fitRatio)),
                                (n = n ? e.h : Math.round(e.h * e.fitRatio)),
                                e.placeholder && !e.loaded && ((e.placeholder.style.width = i + "px"), (e.placeholder.style.height = n + "px")),
                                (t.style.width = i + "px"),
                                (t.style.height = n + "px"));
                        };
                    function Zt(e, t, n) {
                        var i = document.createEvent("CustomEvent");
                        (n = { origEvent: e, target: e.target, releasePoint: t, pointerType: n || "touch" }), i.initCustomEvent("pswpTap", !0, !0, n), e.target.dispatchEvent(i);
                    }
                    a("Controller", {
                        publicMethods: {
                            lazyLoadItem: function (e) {
                                e = l(e);
                                var t = Wt(e);
                                t && ((!t.loaded && !t.loading) || ne) && (d("gettingData", e, t), t.src && It(t));
                            },
                            initController: function () {
                                o.extend(r, Xt, !0),
                                    (s.items = Ht = n),
                                    (Wt = s.getItemAt),
                                    (Bt = r.getNumItemsFn),
                                    r.loop,
                                    Bt() < 3 && (r.loop = !1),
                                    c("beforeChange", function (e) {
                                        for (var t = r.preload, n = null === e || 0 <= e, i = Math.min(t[0], Bt()), o = Math.min(t[1], Bt()), a = 1; a <= (n ? o : i); a++) s.lazyLoadItem(V + a);
                                        for (a = 1; a <= (n ? i : o); a++) s.lazyLoadItem(V - a);
                                    }),
                                    c("initialLayout", function () {
                                        s.currItem.initialLayout = r.getThumbBoundsFn && r.getThumbBoundsFn(V);
                                    }),
                                    c("mainScrollAnimComplete", jt),
                                    c("initialZoomInEnd", jt),
                                    c("destroy", function () {
                                        for (var e, t = 0; t < Ht.length; t++)
                                            (e = Ht[t]).container && (e.container = null), e.placeholder && (e.placeholder = null), e.img && (e.img = null), e.preloader && (e.preloader = null), e.loadError && (e.loaded = e.loadError = !1);
                                        Gt = null;
                                    });
                            },
                            getItemAt: function (e) {
                                return 0 <= e && void 0 !== Ht[e] && Ht[e];
                            },
                            allowProgressiveImg: function () {
                                return r.forceProgressiveLoading || !ue || r.mouseUsed || 1200 < screen.width;
                            },
                            setContent: function (e, t) {
                                r.loop && (t = l(t));
                                var n = s.getItemAt(e.index);
                                n && (n.container = null);
                                var i,
                                    a,
                                    c = s.getItemAt(t);
                                c
                                    ? (d("gettingData", t, c),
                                      (e.index = t),
                                      (a = (e.item = c).container = o.createEl("pswp__zoom-wrap")),
                                      !c.src && c.html && (c.html.tagName ? a.appendChild(c.html) : (a.innerHTML = c.html)),
                                      Nt(c),
                                      Yt(c, Ge),
                                      !c.src || c.loadError || c.loaded
                                          ? c.src && !c.loadError && (((i = o.createEl("pswp__img", "img")).style.opacity = 1), (i.src = c.src), Kt(c, i), zt(0, c, a, i))
                                          : ((c.loadComplete = function (n) {
                                                if (F) {
                                                    if (e && e.index === t) {
                                                        if (Nt(n, !0)) return (n.loadComplete = n.img = null), Yt(n, Ge), ot(n), void (e.index === V && s.updateCurrZoomItem());
                                                        n.imageAppended
                                                            ? !Ft && n.placeholder && ((n.placeholder.style.display = "none"), (n.placeholder = null))
                                                            : ye.transform && (Ne || Ft)
                                                            ? Gt.push({ item: n, baseDiv: a, img: n.img, index: t, holder: e, clearPlaceholder: !0 })
                                                            : zt(0, n, a, n.img, 0, !0);
                                                    }
                                                    (n.loadComplete = null), (n.img = null), d("imageLoadComplete", t, n);
                                                }
                                            }),
                                            o.features.transform &&
                                                ((n = "pswp__img pswp__img--placeholder"),
                                                (n += c.msrc ? "" : " pswp__img--placeholder--blank"),
                                                (n = o.createEl(n, c.msrc ? "img" : "")),
                                                c.msrc && (n.src = c.msrc),
                                                Kt(c, n),
                                                a.appendChild(n),
                                                (c.placeholder = n)),
                                            c.loading || It(c),
                                            s.allowProgressiveImg() && (!qt && ye.transform ? Gt.push({ item: c, baseDiv: a, img: c.img, index: t, holder: e }) : zt(0, c, a, c.img, 0, !0))),
                                      qt || t !== V ? ot(c) : ((Ie = a.style), Vt(c, i || c.img)),
                                      (e.el.innerHTML = ""),
                                      e.el.appendChild(a))
                                    : (e.el.innerHTML = "");
                            },
                            cleanSlide: function (e) {
                                e.img && (e.img.onload = e.img.onerror = null), (e.loaded = e.loading = e.img = e.imageAppended = !1);
                            },
                        },
                    });
                    var Qt,
                        Jt,
                        en = {};
                    function tn() {
                        return gn.hash.substring(1);
                    }
                    function nn() {
                        rn && clearTimeout(rn), ln && clearTimeout(ln);
                    }
                    function on() {
                        var e = tn(),
                            t = {};
                        if (e.length < 5) return t;
                        var n,
                            i = e.split("&");
                        for (s = 0; s < i.length; s++) i[s] && ((n = i[s].split("=")).length < 2 || (t[n[0]] = n[1]));
                        if (r.galleryPIDs) {
                            for (var o = t.pid, s = (t.pid = 0); s < Ht.length; s++)
                                if (Ht[s].pid === o) {
                                    t.pid = s;
                                    break;
                                }
                        } else t.pid = parseInt(t.pid, 10) - 1;
                        return t.pid < 0 && (t.pid = 0), t;
                    }
                    function sn() {
                        var e, t;
                        ln && clearTimeout(ln),
                            lt || $e
                                ? (ln = setTimeout(sn, 500))
                                : (cn ? clearTimeout(an) : (cn = !0),
                                  (t = V + 1),
                                  (e = Wt(V)).hasOwnProperty("pid") && (t = e.pid),
                                  (e = pn + "&gid=" + r.galleryUID + "&pid=" + t),
                                  hn || (-1 === gn.hash.indexOf(e) && (mn = !0)),
                                  (t = gn.href.split("#")[0] + "#" + e),
                                  vn ? "#" + e !== window.location.hash && history[hn ? "replaceState" : "pushState"]("", document.title, t) : hn ? gn.replace(t) : (gn.hash = e),
                                  (hn = !0),
                                  (an = setTimeout(function () {
                                      cn = !1;
                                  }, 60)));
                    }
                    a("Tap", {
                        publicMethods: {
                            initTap: function () {
                                c("firstTouchStart", s.onTapStart),
                                    c("touchRelease", s.onTapRelease),
                                    c("destroy", function () {
                                        (en = {}), (Qt = null);
                                    });
                            },
                            onTapStart: function (e) {
                                1 < e.length && (clearTimeout(Qt), (Qt = null));
                            },
                            onTapRelease: function (e, t) {
                                var n, i, s;
                                !t ||
                                    Ae ||
                                    _e ||
                                    lt ||
                                    ((n = t),
                                    Qt && (clearTimeout(Qt), (Qt = null), (i = n), (s = en), Math.abs(i.x - s.x) < 25 && Math.abs(i.y - s.y) < 25)
                                        ? d("doubleTap", n)
                                        : "mouse" !== t.type
                                        ? "BUTTON" === e.target.tagName.toUpperCase() || o.hasClass(e.target, "pswp__single-tap")
                                            ? Zt(e, t)
                                            : (g(en, n),
                                              (Qt = setTimeout(function () {
                                                  Zt(e, t), (Qt = null);
                                              }, 300)))
                                        : Zt(e, t, "mouse"));
                            },
                        },
                    }),
                        a("DesktopZoom", {
                            publicMethods: {
                                initDesktopZoom: function () {
                                    ge ||
                                        (ue
                                            ? c("mouseUsed", function () {
                                                  s.setupDesktopZoom();
                                              })
                                            : s.setupDesktopZoom(!0));
                                },
                                setupDesktopZoom: function (t) {
                                    Jt = {};
                                    var n = "wheel mousewheel DOMMouseScroll";
                                    function i() {
                                        s.mouseZoomedIn && (o.removeClass(e, "pswp--zoomed-in"), (s.mouseZoomedIn = !1)), Z < 1 ? o.addClass(e, "pswp--zoom-allowed") : o.removeClass(e, "pswp--zoom-allowed"), a();
                                    }
                                    c("bindEvents", function () {
                                        o.bind(e, n, s.handleMouseWheel);
                                    }),
                                        c("unbindEvents", function () {
                                            Jt && o.unbind(e, n, s.handleMouseWheel);
                                        }),
                                        (s.mouseZoomedIn = !1);
                                    var r,
                                        a = function () {
                                            r && (o.removeClass(e, "pswp--dragging"), (r = !1));
                                        };
                                    c("resize", i),
                                        c("afterChange", i),
                                        c("pointerDown", function () {
                                            s.mouseZoomedIn && ((r = !0), o.addClass(e, "pswp--dragging"));
                                        }),
                                        c("pointerUp", a),
                                        t || i();
                                },
                                handleMouseWheel: function (e) {
                                    if (Z <= s.currItem.fitRatio) return r.modal && (!r.closeOnScroll || lt || $e ? e.preventDefault() : ce && 2 < Math.abs(e.deltaY) && ((B = !0), s.close())), !0;
                                    if ((e.stopPropagation(), (Jt.x = 0), "deltaX" in e)) 1 === e.deltaMode ? ((Jt.x = 18 * e.deltaX), (Jt.y = 18 * e.deltaY)) : ((Jt.x = e.deltaX), (Jt.y = e.deltaY));
                                    else if ("wheelDelta" in e) e.wheelDeltaX && (Jt.x = -0.16 * e.wheelDeltaX), e.wheelDeltaY ? (Jt.y = -0.16 * e.wheelDeltaY) : (Jt.y = -0.16 * e.wheelDelta);
                                    else {
                                        if (!("detail" in e)) return;
                                        Jt.y = e.detail;
                                    }
                                    b(Z, !0);
                                    var t = Ue.x - Jt.x,
                                        n = Ue.y - Jt.y;
                                    (r.modal || (t <= ze.min.x && t >= ze.max.x && n <= ze.min.y && n >= ze.max.y)) && e.preventDefault(), s.panTo(t, n);
                                },
                                toggleDesktopZoom: function (t) {
                                    t = t || { x: Ge.x / 2 + Ye.x, y: Ge.y / 2 + Ye.y };
                                    var n = r.getDoubleTapZoom(!0, s.currItem),
                                        i = Z === n;
                                    (s.mouseZoomedIn = !i), s.zoomTo(i ? s.currItem.initialZoomLevel : n, t, 333), o[(i ? "remove" : "add") + "Class"](e, "pswp--zoomed-in");
                                },
                            },
                        });
                    var rn,
                        an,
                        ln,
                        cn,
                        dn,
                        un,
                        pn,
                        hn,
                        fn,
                        mn,
                        gn,
                        vn,
                        yn = { history: !0, galleryUID: 1 };
                    a("History", {
                        publicMethods: {
                            initHistory: function () {
                                var e, t;
                                o.extend(r, yn, !0),
                                    r.history &&
                                        ((gn = window.location),
                                        (hn = fn = mn = !1),
                                        (pn = tn()),
                                        (vn = "pushState" in history),
                                        -1 < pn.indexOf("gid=") && (pn = (pn = pn.split("&gid=")[0]).split("?gid=")[0]),
                                        c("afterChange", s.updateURL),
                                        c("unbindEvents", function () {
                                            o.unbind(window, "hashchange", s.onHashChange);
                                        }),
                                        (e = function () {
                                            (un = !0), fn || (mn ? history.back() : pn ? (gn.hash = pn) : vn ? history.pushState("", document.title, gn.pathname + gn.search) : (gn.hash = "")), nn();
                                        }),
                                        c("unbindEvents", function () {
                                            B && e();
                                        }),
                                        c("destroy", function () {
                                            un || e();
                                        }),
                                        c("firstUpdate", function () {
                                            V = on().pid;
                                        }),
                                        -1 < (t = pn.indexOf("pid=")) && "&" === (pn = pn.substring(0, t)).slice(-1) && (pn = pn.slice(0, -1)),
                                        setTimeout(function () {
                                            F && o.bind(window, "hashchange", s.onHashChange);
                                        }, 40));
                            },
                            onHashChange: function () {
                                return tn() === pn ? ((fn = !0), void s.close()) : void (cn || ((dn = !0), s.goTo(on().pid), (dn = !1)));
                            },
                            updateURL: function () {
                                nn(), dn || (hn ? (rn = setTimeout(sn, 800)) : sn());
                            },
                        },
                    }),
                        o.extend(s, i);
                };
            }),
            "object" == ("undefined" == typeof exports ? "undefined" : _typeof(exports)) ? (module.exports = p()) : (u.PhotoSwipe = p()),
            (u = this),
            (p = function () {
                "use strict";
                return function (e, t) {
                    function n(e) {
                        if ($) return !0;
                        (e = e || window.event), k.timeToIdle && k.mouseUsed && !b && I();
                        for (var n, i, o = (e.target || e.srcElement).getAttribute("class") || "", s = 0; s < j.length; s++) (n = j[s]).onTap && -1 < o.indexOf("pswp__" + n.name) && (n.onTap(), (i = !0));
                        i &&
                            (e.stopPropagation && e.stopPropagation(),
                            ($ = !0),
                            (e = t.features.isOldAndroid ? 600 : 30),
                            setTimeout(function () {
                                $ = !1;
                            }, e));
                    }
                    function i(e, n, i) {
                        t[(i ? "add" : "remove") + "Class"](e, "pswp__" + n);
                    }
                    function o() {
                        var e = 1 === k.getNumItemsFn();
                        e !== S && (i(p, "ui--one-slide", e), (S = e));
                    }
                    function s() {
                        i(v, "share-modal--hidden", L);
                    }
                    function r() {
                        return (
                            (L = !L)
                                ? (t.removeClass(v, "pswp__share-modal--fade-in"),
                                  setTimeout(function () {
                                      L && s();
                                  }, 300))
                                : (s(),
                                  setTimeout(function () {
                                      L || t.addClass(v, "pswp__share-modal--fade-in");
                                  }, 30)),
                            L || O(),
                            0
                        );
                    }
                    function a(t) {
                        var n = (t = t || window.event).target || t.srcElement;
                        return (
                            e.shout("shareLinkClick", t, n),
                            !(
                                !n.href ||
                                (!n.hasAttribute("download") &&
                                    (window.open(n.href, "pswp_share", "scrollbars=yes,resizable=yes,toolbar=no,location=yes,width=550,height=420,top=100,left=" + (window.screen ? Math.round(screen.width / 2 - 275) : 100)), L || r(), 1))
                            )
                        );
                    }
                    function l(e) {
                        for (var n = 0; n < k.closeElClasses.length; n++) if (t.hasClass(e, "pswp__" + k.closeElClasses[n])) return !0;
                    }
                    function c(e) {
                        ((e = (e = e || window.event).relatedTarget || e.toElement) && "HTML" !== e.nodeName) ||
                            (clearTimeout(E),
                            (E = setTimeout(function () {
                                A.setIdle(!0);
                            }, k.timeToIdleOutside)));
                    }
                    function d(n) {
                        var i,
                            o = n.vGap;
                        !e.likelyTouchDevice || k.mouseUsed || screen.width > k.fitControlsWidth
                            ? ((i = k.barsSize),
                              k.captionEl && "auto" === i.bottom
                                  ? (f || ((f = t.createEl("pswp__caption pswp__caption--fake")).appendChild(t.createEl("pswp__caption__center")), p.insertBefore(f, h), t.addClass(p, "pswp__ui--fit")),
                                    k.addCaptionHTMLFn(n, f, !0) ? ((n = f.clientHeight), (o.bottom = parseInt(n, 10) || 44)) : (o.bottom = i.top))
                                  : (o.bottom = "auto" === i.bottom ? 0 : i.bottom),
                              (o.top = i.top))
                            : (o.top = o.bottom = 0);
                    }
                    var u,
                        p,
                        h,
                        f,
                        m,
                        g,
                        v,
                        y,
                        b,
                        w,
                        x,
                        T,
                        C,
                        S,
                        k,
                        $,
                        _,
                        E,
                        A = this,
                        M = !1,
                        P = !0,
                        L = !0,
                        D = {
                            barsSize: { top: 44, bottom: "auto" },
                            closeElClasses: ["item", "caption", "zoom-wrap", "ui", "top-bar"],
                            timeToIdle: 4e3,
                            timeToIdleOutside: 1e3,
                            loadingIndicatorDelay: 1e3,
                            addCaptionHTMLFn: function (e, t) {
                                return e.title ? ((t.children[0].innerHTML = e.title), !0) : ((t.children[0].innerHTML = ""), !1);
                            },
                            closeEl: !0,
                            captionEl: !0,
                            fullscreenEl: !0,
                            zoomEl: !0,
                            shareEl: !0,
                            counterEl: !0,
                            arrowEl: !0,
                            preloaderEl: !0,
                            tapToClose: !1,
                            tapToToggleControls: !0,
                            clickToCloseNonZoomable: !0,
                            shareButtons: [
                                { id: "facebook", label: "Share on Facebook", url: "https://www.facebook.com/sharer/sharer.php?u={{url}}" },
                                { id: "twitter", label: "Tweet", url: "https://twitter.com/intent/tweet?text={{text}}&url={{url}}" },
                                { id: "pinterest", label: "Pin it", url: "http://www.pinterest.com/pin/create/button/?url={{url}}&media={{image_url}}&description={{text}}" },
                                { id: "download", label: "Download image", url: "{{raw_image_url}}", download: !0 },
                            ],
                            getImageURLForShare: function () {
                                return e.currItem.src || "";
                            },
                            getPageURLForShare: function () {
                                return window.location.href;
                            },
                            getTextForShare: function () {
                                return e.currItem.title || "";
                            },
                            indexIndicatorSep: " / ",
                            fitControlsWidth: 1200,
                        },
                        O = function () {
                            for (var e, t, n, i, o = "", s = 0; s < k.shareButtons.length; s++)
                                (e = k.shareButtons[s]),
                                    (t = k.getImageURLForShare(e)),
                                    (n = k.getPageURLForShare(e)),
                                    (i = k.getTextForShare(e)),
                                    (o +=
                                        '<a href="' +
                                        e.url.replace("{{url}}", encodeURIComponent(n)).replace("{{image_url}}", encodeURIComponent(t)).replace("{{raw_image_url}}", t).replace("{{text}}", encodeURIComponent(i)) +
                                        '" target="_blank" class="pswp__share--' +
                                        e.id +
                                        '"' +
                                        (e.download ? "download" : "") +
                                        ">" +
                                        e.label +
                                        "</a>"),
                                    k.parseShareButtonOut && (o = k.parseShareButtonOut(e, o));
                            (v.children[0].innerHTML = o), (v.children[0].onclick = a);
                        },
                        z = 0,
                        I = function () {
                            clearTimeout(E), (z = 0), b && A.setIdle(!1);
                        },
                        N = function (e) {
                            T !== e && (i(x, "preloader--active", !e), (T = e));
                        },
                        j = [
                            {
                                name: "caption",
                                option: "captionEl",
                                onInit: function (e) {
                                    h = e;
                                },
                            },
                            {
                                name: "share-modal",
                                option: "shareEl",
                                onInit: function (e) {
                                    v = e;
                                },
                                onTap: function () {
                                    r();
                                },
                            },
                            {
                                name: "button--share",
                                option: "shareEl",
                                onInit: function (e) {
                                    g = e;
                                },
                                onTap: function () {
                                    r();
                                },
                            },
                            { name: "button--zoom", option: "zoomEl", onTap: e.toggleDesktopZoom },
                            {
                                name: "counter",
                                option: "counterEl",
                                onInit: function (e) {
                                    m = e;
                                },
                            },
                            { name: "button--close", option: "closeEl", onTap: e.close },
                            { name: "button--arrow--left", option: "arrowEl", onTap: e.prev },
                            { name: "button--arrow--right", option: "arrowEl", onTap: e.next },
                            {
                                name: "button--fs",
                                option: "fullscreenEl",
                                onTap: function () {
                                    u.isFullscreen() ? u.exit() : u.enter();
                                },
                            },
                            {
                                name: "preloader",
                                option: "preloaderEl",
                                onInit: function (e) {
                                    x = e;
                                },
                            },
                        ];
                    (A.init = function () {
                        var i;
                        t.extend(e.options, D, !0),
                            (k = e.options),
                            (p = t.getChildByClass(e.scrollWrap, "pswp__ui")),
                            (w = e.listen)("onVerticalDrag", function (e) {
                                P && e < 0.95 ? A.hideControls() : !P && 0.95 <= e && A.showControls();
                            }),
                            w("onPinchClose", function (e) {
                                P && e < 0.9 ? (A.hideControls(), (i = !0)) : i && !P && 0.9 < e && A.showControls();
                            }),
                            w("zoomGestureEnded", function () {
                                (i = !1) && !P && A.showControls();
                            }),
                            w("beforeChange", A.update),
                            w("doubleTap", function (t) {
                                var n = e.currItem.initialZoomLevel;
                                e.getZoomLevel() !== n ? e.zoomTo(n, t, 333) : e.zoomTo(k.getDoubleTapZoom(!1, e.currItem), t, 333);
                            }),
                            w("preventDragEvent", function (e, t, n) {
                                var i = e.target || e.srcElement;
                                i && i.getAttribute("class") && -1 < e.type.indexOf("mouse") && (0 < i.getAttribute("class").indexOf("__caption") || /(SMALL|STRONG|EM)/i.test(i.tagName)) && (n.prevent = !1);
                            }),
                            w("bindEvents", function () {
                                t.bind(p, "pswpTap click", n), t.bind(e.scrollWrap, "pswpTap", A.onGlobalTap), e.likelyTouchDevice || t.bind(e.scrollWrap, "mouseover", A.onMouseOver);
                            }),
                            w("unbindEvents", function () {
                                L || r(),
                                    _ && clearInterval(_),
                                    t.unbind(document, "mouseout", c),
                                    t.unbind(document, "mousemove", I),
                                    t.unbind(p, "pswpTap click", n),
                                    t.unbind(e.scrollWrap, "pswpTap", A.onGlobalTap),
                                    t.unbind(e.scrollWrap, "mouseover", A.onMouseOver),
                                    u && (t.unbind(document, u.eventK, A.updateFullscreen), u.isFullscreen() && ((k.hideAnimationDuration = 0), u.exit()), (u = null));
                            }),
                            w("destroy", function () {
                                k.captionEl && (f && p.removeChild(f), t.removeClass(h, "pswp__caption--empty")),
                                    v && (v.children[0].onclick = null),
                                    t.removeClass(p, "pswp__ui--over-close"),
                                    t.addClass(p, "pswp__ui--hidden"),
                                    A.setIdle(!1);
                            }),
                            k.showAnimationDuration || t.removeClass(p, "pswp__ui--hidden"),
                            w("initialZoomIn", function () {
                                k.showAnimationDuration && t.removeClass(p, "pswp__ui--hidden");
                            }),
                            w("initialZoomOut", function () {
                                t.addClass(p, "pswp__ui--hidden");
                            }),
                            w("parseVerticalMargin", d),
                            (function () {
                                function e(e) {
                                    if (e)
                                        for (var s = e.length, r = 0; r < s; r++) {
                                            (n = e[r]), (i = n.className);
                                            for (var a = 0; a < j.length; a++)
                                                (o = j[a]), -1 < i.indexOf("pswp__" + o.name) && (k[o.option] ? (t.removeClass(n, "pswp__element--disabled"), o.onInit && o.onInit(n)) : t.addClass(n, "pswp__element--disabled"));
                                        }
                                }
                                var n, i, o;
                                e(p.children);
                                var s = t.getChildByClass(p, "pswp__top-bar");
                                s && e(s.children);
                            })(),
                            k.shareEl && g && v && (L = !0),
                            o(),
                            k.timeToIdle &&
                                w("mouseUsed", function () {
                                    t.bind(document, "mousemove", I),
                                        t.bind(document, "mouseout", c),
                                        (_ = setInterval(function () {
                                            2 == ++z && A.setIdle(!0);
                                        }, k.timeToIdle / 2));
                                }),
                            k.fullscreenEl &&
                                !t.features.isOldAndroid &&
                                ((u = u || A.getFullscreenAPI()) ? (t.bind(document, u.eventK, A.updateFullscreen), A.updateFullscreen(), t.addClass(e.template, "pswp--supports-fs")) : t.removeClass(e.template, "pswp--supports-fs")),
                            k.preloaderEl &&
                                (N(!0),
                                w("beforeChange", function () {
                                    clearTimeout(C),
                                        (C = setTimeout(function () {
                                            e.currItem && e.currItem.loading ? (e.allowProgressiveImg() && (!e.currItem.img || e.currItem.img.naturalWidth)) || N(!1) : N(!0);
                                        }, k.loadingIndicatorDelay));
                                }),
                                w("imageLoadComplete", function (t, n) {
                                    e.currItem === n && N(!0);
                                }));
                    }),
                        (A.setIdle = function (e) {
                            i(p, "ui--idle", (b = e));
                        }),
                        (A.update = function () {
                            (M = !(!P || !e.currItem || (A.updateIndexIndicator(), k.captionEl && (k.addCaptionHTMLFn(e.currItem, h), i(h, "caption--empty", !e.currItem.title)), 0))), L || r(), o();
                        }),
                        (A.updateFullscreen = function (n) {
                            n &&
                                setTimeout(function () {
                                    e.setScrollOffset(0, t.getScrollY());
                                }, 50),
                                t[(u.isFullscreen() ? "add" : "remove") + "Class"](e.template, "pswp--fs");
                        }),
                        (A.updateIndexIndicator = function () {
                            k.counterEl && (m.innerHTML = e.getCurrentIndex() + 1 + k.indexIndicatorSep + k.getNumItemsFn());
                        }),
                        (A.onGlobalTap = function (n) {
                            var i = (n = n || window.event).target || n.srcElement;
                            if (!$)
                                if (n.detail && "mouse" === n.detail.pointerType)
                                    l(i) ? e.close() : t.hasClass(i, "pswp__img") && (1 === e.getZoomLevel() && e.getZoomLevel() <= e.currItem.fitRatio ? k.clickToCloseNonZoomable && e.close() : e.toggleDesktopZoom(n.detail.releasePoint));
                                else if ((k.tapToToggleControls && (P ? A.hideControls() : A.showControls()), k.tapToClose && (t.hasClass(i, "pswp__img") || l(i)))) return void e.close();
                        }),
                        (A.onMouseOver = function (e) {
                            (e = (e = e || window.event).target || e.srcElement), i(p, "ui--over-close", l(e));
                        }),
                        (A.hideControls = function () {
                            t.addClass(p, "pswp__ui--hidden"), (P = !1);
                        }),
                        (A.showControls = function () {
                            (P = !0), M || A.update(), t.removeClass(p, "pswp__ui--hidden");
                        }),
                        (A.supportsFullscreen = function () {
                            var e = document;
                            return !!(e.exitFullscreen || e.mozCancelFullScreen || e.webkitExitFullscreen || e.msExitFullscreen);
                        }),
                        (A.getFullscreenAPI = function () {
                            var t,
                                n = document.documentElement,
                                i = "fullscreenchange";
                            return (
                                n.requestFullscreen
                                    ? (t = { enterK: "requestFullscreen", exitK: "exitFullscreen", elementK: "fullscreenElement", eventK: i })
                                    : n.mozRequestFullScreen
                                    ? (t = { enterK: "mozRequestFullScreen", exitK: "mozCancelFullScreen", elementK: "mozFullScreenElement", eventK: "moz" + i })
                                    : n.webkitRequestFullscreen
                                    ? (t = { enterK: "webkitRequestFullscreen", exitK: "webkitExitFullscreen", elementK: "webkitFullscreenElement", eventK: "webkit" + i })
                                    : n.msRequestFullscreen && (t = { enterK: "msRequestFullscreen", exitK: "msExitFullscreen", elementK: "msFullscreenElement", eventK: "MSFullscreenChange" }),
                                t &&
                                    ((t.enter = function () {
                                        return (y = k.closeOnScroll), (k.closeOnScroll = !1), "webkitRequestFullscreen" !== this.enterK ? e.template[this.enterK]() : void e.template[this.enterK](Element.ALLOW_KEYBOARD_INPUT);
                                    }),
                                    (t.exit = function () {
                                        return (k.closeOnScroll = y), document[this.exitK]();
                                    }),
                                    (t.isFullscreen = function () {
                                        return document[this.elementK];
                                    })),
                                t
                            );
                        });
                };
            }),
            "object" == ("undefined" == typeof exports ? "undefined" : _typeof(exports)) ? (module.exports = p()) : (u.PhotoSwipeUI_Default = p()),
            (function (e) {
                "use strict";
                "undefined" != typeof exports ? (module.exports = e(require("jquery"))) : e(jQuery);
            })(function (e) {
                "use strict";
                var t,
                    n = window.Slick || {};
                (t = 0),
                    ((n = function (n, i) {
                        var o = this;
                        (o.defaults = {
                            accessibility: !0,
                            adaptiveHeight: !1,
                            appendArrows: e(n),
                            appendDots: e(n),
                            arrows: !0,
                            asNavFor: null,
                            prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="' + theme.strings.previous + '" tabindex="0" role="button">' + theme.strings.previous + "</button>",
                            nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="' + theme.strings.next + '" tabindex="0" role="button">' + theme.strings.next + "</button>",
                            autoplay: !1,
                            autoplaySpeed: 3e3,
                            centerMode: !1,
                            centerPadding: "50px",
                            cssEase: "ease",
                            customPaging: function (t, n) {
                                return e('<button type="button" data-role="none" role="button" tabindex="0" />').text(n + 1);
                            },
                            dots: !1,
                            dotsClass: "slick-dots",
                            draggable: !0,
                            easing: "linear",
                            edgeFriction: 0.35,
                            fade: !1,
                            focusOnSelect: !1,
                            infinite: !0,
                            initialSlide: 0,
                            lazyLoad: "ondemand",
                            mobileFirst: !1,
                            pauseOnHover: !0,
                            pauseOnFocus: !0,
                            pauseOnDotsHover: !1,
                            respondTo: "window",
                            responsive: null,
                            rows: 1,
                            rtl: !1,
                            slide: "",
                            slidesPerRow: 1,
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            speed: 500,
                            swipe: !0,
                            swipeToSlide: !1,
                            touchMove: !0,
                            touchThreshold: 5,
                            useCSS: !0,
                            useTransform: !0,
                            variableWidth: !1,
                            vertical: !1,
                            verticalSwiping: !1,
                            waitForAnimate: !0,
                            zIndex: 1e3,
                        }),
                            (o.initials = {
                                animating: !1,
                                dragging: !1,
                                autoPlayTimer: null,
                                currentDirection: 0,
                                currentLeft: null,
                                currentSlide: 0,
                                direction: 1,
                                $dots: null,
                                listWidth: null,
                                listHeight: null,
                                loadIndex: 0,
                                $nextArrow: null,
                                $prevArrow: null,
                                slideCount: null,
                                slideWidth: null,
                                $slideTrack: null,
                                $slides: null,
                                sliding: !1,
                                slideOffset: 0,
                                swipeLeft: null,
                                $list: null,
                                touchObject: {},
                                transformsEnabled: !1,
                                unslicked: !1,
                            }),
                            e.extend(o, o.initials),
                            (o.activeBreakpoint = null),
                            (o.animType = null),
                            (o.animProp = null),
                            (o.breakpoints = []),
                            (o.breakpointSettings = []),
                            (o.cssTransitions = !1),
                            (o.focussed = !1),
                            (o.interrupted = !1),
                            (o.hidden = "hidden"),
                            (o.paused = !0),
                            (o.positionProp = null),
                            (o.respondTo = null),
                            (o.rowCount = 1),
                            (o.shouldClick = !0),
                            (o.$slider = e(n)),
                            (o.$slidesCache = null),
                            (o.transformType = null),
                            (o.transitionType = null),
                            (o.visibilityChange = "visibilitychange"),
                            (o.windowWidth = 0),
                            (o.windowTimer = null),
                            (n = e(n).data("slick") || {}),
                            (o.options = e.extend({}, o.defaults, i, n)),
                            (o.currentSlide = o.options.initialSlide),
                            (o.originalSettings = o.options),
                            void 0 !== document.mozHidden
                                ? ((o.hidden = "mozHidden"), (o.visibilityChange = "mozvisibilitychange"))
                                : void 0 !== document.webkitHidden && ((o.hidden = "webkitHidden"), (o.visibilityChange = "webkitvisibilitychange")),
                            (o.autoPlay = e.proxy(o.autoPlay, o)),
                            (o.autoPlayClear = e.proxy(o.autoPlayClear, o)),
                            (o.autoPlayIterator = e.proxy(o.autoPlayIterator, o)),
                            (o.changeSlide = e.proxy(o.changeSlide, o)),
                            (o.clickHandler = e.proxy(o.clickHandler, o)),
                            (o.selectHandler = e.proxy(o.selectHandler, o)),
                            (o.setPosition = e.proxy(o.setPosition, o)),
                            (o.swipeHandler = e.proxy(o.swipeHandler, o)),
                            (o.dragHandler = e.proxy(o.dragHandler, o)),
                            (o.keyHandler = e.proxy(o.keyHandler, o)),
                            (o.instanceUid = t++),
                            (o.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/),
                            o.registerBreakpoints(),
                            o.init(!0);
                    }).prototype.activateADA = function () {
                        this.$slideTrack.find(".slick-active").attr({ "aria-hidden": "false" }).find("a, input, button, select").attr({ tabindex: "0" });
                    }),
                    (n.prototype.addSlide = n.prototype.slickAdd = function (t, n, i) {
                        var o = this;
                        if ("boolean" == typeof n) (i = n), (n = null);
                        else if (n < 0 || n >= o.slideCount) return !1;
                        o.unload(),
                            "number" == typeof n
                                ? 0 === n && 0 === o.$slides.length
                                    ? e(t).appendTo(o.$slideTrack)
                                    : i
                                    ? e(t).insertBefore(o.$slides.eq(n))
                                    : e(t).insertAfter(o.$slides.eq(n))
                                : !0 === i
                                ? e(t).prependTo(o.$slideTrack)
                                : e(t).appendTo(o.$slideTrack),
                            (o.$slides = o.$slideTrack.children(this.options.slide)),
                            o.$slideTrack.children(this.options.slide).detach(),
                            o.$slideTrack.append(o.$slides),
                            o.$slides.each(function (t, n) {
                                e(n).attr("data-slick-index", t);
                            }),
                            (o.$slidesCache = o.$slides),
                            o.reinit();
                    }),
                    (n.prototype.animateHeight = function () {
                        var e;
                        1 === this.options.slidesToShow &&
                            !0 === this.options.adaptiveHeight &&
                            !1 === this.options.vertical &&
                            ((e = this.$slides.eq(this.currentSlide).outerHeight(!0)), this.$list.animate({ height: e }, this.options.speed));
                    }),
                    (n.prototype.animateSlide = function (t, n) {
                        var i = {},
                            o = this;
                        o.animateHeight(),
                            !0 === o.options.rtl && !1 === o.options.vertical && (t = -t),
                            !1 === o.transformsEnabled
                                ? !1 === o.options.vertical
                                    ? o.$slideTrack.animate({ left: t }, o.options.speed, o.options.easing, n)
                                    : o.$slideTrack.animate({ top: t }, o.options.speed, o.options.easing, n)
                                : !1 === o.cssTransitions
                                ? (!0 === o.options.rtl && (o.currentLeft = -o.currentLeft),
                                  e({ animStart: o.currentLeft }).animate(
                                      { animStart: t },
                                      {
                                          duration: o.options.speed,
                                          easing: o.options.easing,
                                          step: function (e) {
                                              (e = Math.ceil(e)), !1 === o.options.vertical ? (i[o.animType] = "translate(" + e + "px, 0px)") : (i[o.animType] = "translate(0px," + e + "px)"), o.$slideTrack.css(i);
                                          },
                                          complete: function () {
                                              n && n.call();
                                          },
                                      }
                                  ))
                                : (o.applyTransition(),
                                  (t = Math.ceil(t)),
                                  !1 === o.options.vertical ? (i[o.animType] = "translate3d(" + t + "px, 0px, 0px)") : (i[o.animType] = "translate3d(0px," + t + "px, 0px)"),
                                  o.$slideTrack.css(i),
                                  n &&
                                      setTimeout(function () {
                                          o.disableTransition(), n.call();
                                      }, o.options.speed));
                    }),
                    (n.prototype.getNavTarget = function () {
                        var t = this.options.asNavFor;
                        return t && null !== t ? e(t).not(this.$slider) : t;
                    }),
                    (n.prototype.asNavFor = function (t) {
                        var n = this.getNavTarget();
                        null !== n &&
                            "object" == _typeof(n) &&
                            n.each(function () {
                                var n = e(this).slick("getSlick");
                                n.unslicked || n.slideHandler(t, !0);
                            });
                    }),
                    (n.prototype.applyTransition = function (e) {
                        var t = this,
                            n = {};
                        !1 === t.options.fade ? (n[t.transitionType] = t.transformType + " " + t.options.speed + "ms " + t.options.cssEase) : (n[t.transitionType] = "opacity " + t.options.speed + "ms " + t.options.cssEase),
                            (!1 === t.options.fade ? t.$slideTrack : t.$slides.eq(e)).css(n);
                    }),
                    (n.prototype.autoPlay = function () {
                        this.autoPlayClear(), this.slideCount > this.options.slidesToShow && (this.autoPlayTimer = setInterval(this.autoPlayIterator, this.options.autoplaySpeed));
                    }),
                    (n.prototype.autoPlayClear = function () {
                        this.autoPlayTimer && clearInterval(this.autoPlayTimer);
                    }),
                    (n.prototype.autoPlayIterator = function () {
                        var e = this,
                            t = e.currentSlide + e.options.slidesToScroll;
                        e.paused ||
                            e.interrupted ||
                            e.focussed ||
                            (!1 === e.options.infinite &&
                                (1 === e.direction && e.currentSlide + 1 === e.slideCount - 1 ? (e.direction = 0) : 0 === e.direction && ((t = e.currentSlide - e.options.slidesToScroll), e.currentSlide - 1 == 0 && (e.direction = 1))),
                            e.slideHandler(t));
                    }),
                    (n.prototype.buildArrows = function () {
                        var t = this;
                        !0 === t.options.arrows &&
                            ((t.$prevArrow = e(t.options.prevArrow).addClass("slick-arrow")),
                            (t.$nextArrow = e(t.options.nextArrow).addClass("slick-arrow")),
                            t.slideCount > t.options.slidesToShow
                                ? (t.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),
                                  t.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),
                                  t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.prependTo(t.options.appendArrows),
                                  t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.appendTo(t.options.appendArrows),
                                  !0 !== t.options.infinite && t.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"))
                                : t.$prevArrow.add(t.$nextArrow).addClass("slick-hidden").attr({ "aria-disabled": "true", tabindex: "-1" }));
                    }),
                    (n.prototype.buildDots = function () {
                        var t,
                            n,
                            i = this;
                        if (!0 === i.options.dots && i.slideCount > i.options.slidesToShow) {
                            for (i.$slider.addClass("slick-dotted"), n = e("<ul />").addClass(i.options.dotsClass), t = 0; t <= i.getDotCount(); t += 1) n.append(e("<li />").append(i.options.customPaging.call(this, i, t)));
                            (i.$dots = n.appendTo(i.options.appendDots)), i.$dots.find("li").first().addClass("slick-active").attr("aria-hidden", "false");
                        }
                    }),
                    (n.prototype.buildOut = function () {
                        var t = this;
                        (t.$slides = t.$slider.children(t.options.slide + ":not(.slick-cloned)").addClass("slick-slide")),
                            (t.slideCount = t.$slides.length),
                            t.$slides.each(function (t, n) {
                                e(n)
                                    .attr("data-slick-index", t)
                                    .data("originalStyling", e(n).attr("style") || "");
                            }),
                            t.$slider.addClass("slick-slider"),
                            (t.$slideTrack =
                                0 === t.slideCount
                                    ? e('<div class="slick-track" aria-label="'.concat(theme.strings.imageSlider || "", '"/>')).appendTo(t.$slider)
                                    : t.$slides.wrapAll('<div class="slick-track" aria-label="'.concat(theme.strings.imageSlider || "", '"/>')).parent()),
                            (t.$list = t.$slideTrack.wrap('<div aria-live="polite" class="slick-list"/>').parent()),
                            t.$slideTrack.css("opacity", 0),
                            (!0 !== t.options.centerMode && !0 !== t.options.swipeToSlide) || (t.options.slidesToScroll = 1),
                            e("img[data-lazy]", t.$slider).not("[src]").addClass("slick-loading"),
                            t.setupInfinite(),
                            t.buildArrows(),
                            t.buildDots(),
                            t.updateDots(),
                            t.setSlideClasses("number" == typeof t.currentSlide ? t.currentSlide : 0),
                            !0 === t.options.draggable && t.$list.addClass("draggable");
                    }),
                    (n.prototype.buildRows = function () {
                        var e,
                            t,
                            n,
                            i = this,
                            o = document.createDocumentFragment(),
                            s = i.$slider.children();
                        if (1 < i.options.rows) {
                            for (n = i.options.slidesPerRow * i.options.rows, t = Math.ceil(s.length / n), e = 0; e < t; e++) {
                                for (var r = document.createElement("div"), a = 0; a < i.options.rows; a++) {
                                    for (var l = document.createElement("div"), c = 0; c < i.options.slidesPerRow; c++) {
                                        var d = e * n + (a * i.options.slidesPerRow + c);
                                        s.get(d) && l.appendChild(s.get(d));
                                    }
                                    r.appendChild(l);
                                }
                                o.appendChild(r);
                            }
                            i.$slider.empty().append(o),
                                i.$slider
                                    .children()
                                    .children()
                                    .children()
                                    .css({ width: 100 / i.options.slidesPerRow + "%", display: "inline-block" });
                        }
                    }),
                    (n.prototype.checkResponsive = function (t, n) {
                        var i,
                            o,
                            s,
                            r = this,
                            a = !1,
                            l = r.$slider.width(),
                            c = window.innerWidth || e(window).width();
                        if (("window" === r.respondTo ? (s = c) : "slider" === r.respondTo ? (s = l) : "min" === r.respondTo && (s = Math.min(c, l)), r.options.responsive && r.options.responsive.length && null !== r.options.responsive)) {
                            for (i in ((o = null), r.breakpoints)) r.breakpoints.hasOwnProperty(i) && (!1 === r.originalSettings.mobileFirst ? s < r.breakpoints[i] && (o = r.breakpoints[i]) : s > r.breakpoints[i] && (o = r.breakpoints[i]));
                            null !== o
                                ? (null !== r.activeBreakpoint && o === r.activeBreakpoint && !n) ||
                                  ((r.activeBreakpoint = o),
                                  "unslick" === r.breakpointSettings[o] ? r.unslick(o) : ((r.options = e.extend({}, r.originalSettings, r.breakpointSettings[o])), !0 === t && (r.currentSlide = r.options.initialSlide), r.refresh(t)),
                                  (a = o))
                                : null !== r.activeBreakpoint && ((r.activeBreakpoint = null), (r.options = r.originalSettings), !0 === t && (r.currentSlide = r.options.initialSlide), r.refresh(t), (a = o)),
                                t || !1 === a || r.$slider.trigger("breakpoint", [r, a]);
                        }
                    }),
                    (n.prototype.changeSlide = function (t, n) {
                        var i,
                            o = this,
                            s = e(t.currentTarget);
                        switch ((s.is("a") && t.preventDefault(), s.is("li") || (s = s.closest("li")), (i = o.slideCount % o.options.slidesToScroll != 0 ? 0 : (o.slideCount - o.currentSlide) % o.options.slidesToScroll), t.data.message)) {
                            case "previous":
                                (r = 0 == i ? o.options.slidesToScroll : o.options.slidesToShow - i), o.slideCount > o.options.slidesToShow && o.slideHandler(o.currentSlide - r, !1, n);
                                break;
                            case "next":
                                (r = 0 == i ? o.options.slidesToScroll : i), o.slideCount > o.options.slidesToShow && o.slideHandler(o.currentSlide + r, !1, n);
                                break;
                            case "index":
                                var r = 0 === t.data.index ? 0 : t.data.index || s.index() * o.options.slidesToScroll;
                                o.slideHandler(o.checkNavigable(r), !1, n), s.children().trigger("focus");
                                break;
                            default:
                                return;
                        }
                    }),
                    (n.prototype.checkNavigable = function (e) {
                        var t = this.getNavigableIndexes(),
                            n = 0;
                        if (e > t[t.length - 1]) e = t[t.length - 1];
                        else
                            for (var i in t) {
                                if (e < t[i]) {
                                    e = n;
                                    break;
                                }
                                n = t[i];
                            }
                        return e;
                    }),
                    (n.prototype.cleanUpEvents = function () {
                        var t = this;
                        t.options.dots && null !== t.$dots && e("li", t.$dots).off("click.slick", t.changeSlide).off("mouseenter.slick", e.proxy(t.interrupt, t, !0)).off("mouseleave.slick", e.proxy(t.interrupt, t, !1)),
                            t.$slider.off("focus.slick blur.slick"),
                            !0 === t.options.arrows && t.slideCount > t.options.slidesToShow && (t.$prevArrow && t.$prevArrow.off("click.slick", t.changeSlide), t.$nextArrow && t.$nextArrow.off("click.slick", t.changeSlide)),
                            t.$list.off("touchstart.slick mousedown.slick", t.swipeHandler),
                            t.$list.off("touchmove.slick mousemove.slick", t.swipeHandler),
                            t.$list.off("touchend.slick mouseup.slick", t.swipeHandler),
                            t.$list.off("touchcancel.slick mouseleave.slick", t.swipeHandler),
                            t.$list.off("click.slick", t.clickHandler),
                            e(document).off(t.visibilityChange, t.visibility),
                            t.cleanUpSlideEvents(),
                            !0 === t.options.accessibility && t.$list.off("keydown.slick", t.keyHandler),
                            !0 === t.options.focusOnSelect && e(t.$slideTrack).children().off("click.slick", t.selectHandler),
                            e(window).off("orientationchange.slick.slick-" + t.instanceUid, t.orientationChange),
                            e(window).off("resize.slick.slick-" + t.instanceUid, t.resize),
                            e("[draggable!=true]", t.$slideTrack).off("dragstart", t.preventDefault),
                            e(window).off("load.slick.slick-" + t.instanceUid, t.setPosition),
                            e(document).off("ready.slick.slick-" + t.instanceUid, t.setPosition);
                    }),
                    (n.prototype.cleanUpSlideEvents = function () {
                        this.$list.off("mouseenter.slick", e.proxy(this.interrupt, this, !0)), this.$list.off("mouseleave.slick", e.proxy(this.interrupt, this, !1));
                    }),
                    (n.prototype.cleanUpRows = function () {
                        var e;
                        1 < this.options.rows && ((e = this.$slides.children().children()).removeAttr("style"), this.$slider.empty().append(e));
                    }),
                    (n.prototype.clickHandler = function (e) {
                        !1 === this.shouldClick && (e.stopImmediatePropagation(), e.stopPropagation(), e.preventDefault());
                    }),
                    (n.prototype.destroy = function (t) {
                        var n = this;
                        n.autoPlayClear(),
                            (n.touchObject = {}),
                            n.cleanUpEvents(),
                            e(".slick-cloned", n.$slider).detach(),
                            n.$dots && n.$dots.remove(),
                            n.$prevArrow &&
                                n.$prevArrow.length &&
                                (n.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), n.htmlExpr.test(n.options.prevArrow) && n.$prevArrow.remove()),
                            n.$nextArrow &&
                                n.$nextArrow.length &&
                                (n.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), n.htmlExpr.test(n.options.nextArrow) && n.$nextArrow.remove()),
                            n.$slides &&
                                (n.$slides
                                    .removeClass("slick-slide slick-active slick-center slick-visible slick-current")
                                    .removeAttr("aria-hidden")
                                    .removeAttr("data-slick-index")
                                    .each(function () {
                                        e(this).attr("style", e(this).data("originalStyling"));
                                    }),
                                n.$slideTrack.children(this.options.slide).detach(),
                                n.$slideTrack.detach(),
                                n.$list.detach(),
                                n.$slider.append(n.$slides)),
                            n.cleanUpRows(),
                            n.$slider.removeClass("slick-slider"),
                            n.$slider.removeClass("slick-initialized"),
                            n.$slider.removeClass("slick-dotted"),
                            (n.unslicked = !0),
                            t || n.$slider.trigger("destroy", [n]);
                    }),
                    (n.prototype.disableTransition = function (e) {
                        var t = {};
                        (t[this.transitionType] = ""), (!1 === this.options.fade ? this.$slideTrack : this.$slides.eq(e)).css(t);
                    }),
                    (n.prototype.fadeSlide = function (e, t) {
                        var n = this;
                        !1 === n.cssTransitions
                            ? (n.$slides.eq(e).css({ zIndex: n.options.zIndex }), n.$slides.eq(e).animate({ opacity: 1 }, n.options.speed, n.options.easing, t))
                            : (n.applyTransition(e),
                              n.$slides.eq(e).css({ opacity: 1, zIndex: n.options.zIndex }),
                              t &&
                                  setTimeout(function () {
                                      n.disableTransition(e), t.call();
                                  }, n.options.speed));
                    }),
                    (n.prototype.fadeSlideOut = function (e) {
                        !1 === this.cssTransitions
                            ? this.$slides.eq(e).animate({ opacity: 0, zIndex: this.options.zIndex - 2 }, this.options.speed, this.options.easing)
                            : (this.applyTransition(e), this.$slides.eq(e).css({ opacity: 0, zIndex: this.options.zIndex - 2 }));
                    }),
                    (n.prototype.filterSlides = n.prototype.slickFilter = function (e) {
                        null !== e && ((this.$slidesCache = this.$slides), this.unload(), this.$slideTrack.children(this.options.slide).detach(), this.$slidesCache.filter(e).appendTo(this.$slideTrack), this.reinit());
                    }),
                    (n.prototype.focusHandler = function () {
                        var t = this;
                        t.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick", "*:not(.slick-arrow)", function (n) {
                            var i = e(this);
                            setTimeout(function () {
                                t.options.pauseOnFocus && ((t.focussed = i.is(":focus")), t.autoPlay());
                            }, 0);
                        });
                    }),
                    (n.prototype.getCurrent = n.prototype.slickCurrentSlide = function () {
                        return this.currentSlide;
                    }),
                    (n.prototype.getDotCount = function () {
                        var e = this,
                            t = 0,
                            n = 0,
                            i = 0;
                        if (!0 === e.options.infinite) for (; t < e.slideCount; ) ++i, (t = n + e.options.slidesToScroll), (n += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow);
                        else if (!0 === e.options.centerMode) i = e.slideCount;
                        else if (e.options.asNavFor) for (; t < e.slideCount; ) ++i, (t = n + e.options.slidesToScroll), (n += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow);
                        else i = 1 + Math.ceil((e.slideCount - e.options.slidesToShow) / e.options.slidesToScroll);
                        return i - 1;
                    }),
                    (n.prototype.getLeft = function (e) {
                        var t,
                            n = this,
                            i = 0;
                        return (
                            (n.slideOffset = 0),
                            (t = n.$slides.first().outerHeight(!0)),
                            !0 === n.options.infinite
                                ? (n.slideCount > n.options.slidesToShow && ((n.slideOffset = n.slideWidth * n.options.slidesToShow * -1), (i = t * n.options.slidesToShow * -1)),
                                  n.slideCount % n.options.slidesToScroll != 0 &&
                                      e + n.options.slidesToScroll > n.slideCount &&
                                      n.slideCount > n.options.slidesToShow &&
                                      (i =
                                          e > n.slideCount
                                              ? ((n.slideOffset = (n.options.slidesToShow - (e - n.slideCount)) * n.slideWidth * -1), (n.options.slidesToShow - (e - n.slideCount)) * t * -1)
                                              : ((n.slideOffset = (n.slideCount % n.options.slidesToScroll) * n.slideWidth * -1), (n.slideCount % n.options.slidesToScroll) * t * -1)))
                                : e + n.options.slidesToShow > n.slideCount && ((n.slideOffset = (e + n.options.slidesToShow - n.slideCount) * n.slideWidth), (i = (e + n.options.slidesToShow - n.slideCount) * t)),
                            n.slideCount <= n.options.slidesToShow && (i = n.slideOffset = 0),
                            !0 === n.options.centerMode && !0 === n.options.infinite
                                ? (n.slideOffset += n.slideWidth * Math.floor(n.options.slidesToShow / 2) - n.slideWidth)
                                : !0 === n.options.centerMode && ((n.slideOffset = 0), (n.slideOffset += n.slideWidth * Math.floor(n.options.slidesToShow / 2))),
                            (t = !1 === n.options.vertical ? e * n.slideWidth * -1 + n.slideOffset : e * t * -1 + i),
                            !0 === n.options.variableWidth &&
                                ((i = n.slideCount <= n.options.slidesToShow || !1 === n.options.infinite ? n.$slideTrack.children(".slick-slide").eq(e) : n.$slideTrack.children(".slick-slide").eq(e + n.options.slidesToShow)),
                                (t = !0 === n.options.rtl ? (i[0] ? -1 * (n.$slideTrack.width() - i[0].offsetLeft - i.width()) : 0) : i[0] ? -1 * i[0].offsetLeft : 0),
                                !0 === n.options.centerMode &&
                                    ((i = n.slideCount <= n.options.slidesToShow || !1 === n.options.infinite ? n.$slideTrack.children(".slick-slide").eq(e) : n.$slideTrack.children(".slick-slide").eq(e + n.options.slidesToShow + 1)),
                                    (t = !0 === n.options.rtl ? (i[0] ? -1 * (n.$slideTrack.width() - i[0].offsetLeft - i.width()) : 0) : i[0] ? -1 * i[0].offsetLeft : 0),
                                    (t += (n.$list.width() - i.outerWidth()) / 2))),
                            t
                        );
                    }),
                    (n.prototype.getOption = n.prototype.slickGetOption = function (e) {
                        return this.options[e];
                    }),
                    (n.prototype.getNavigableIndexes = function () {
                        for (var e = this, t = 0, n = 0, i = [], o = !1 === e.options.infinite ? e.slideCount : ((t = -1 * e.options.slidesToScroll), (n = -1 * e.options.slidesToScroll), 2 * e.slideCount); t < o; )
                            i.push(t), (t = n + e.options.slidesToScroll), (n += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow);
                        return i;
                    }),
                    (n.prototype.getSlick = function () {
                        return this;
                    }),
                    (n.prototype.getSlideCount = function () {
                        var t,
                            n = this,
                            i = !0 === n.options.centerMode ? n.slideWidth * Math.floor(n.options.slidesToShow / 2) : 0;
                        return !0 === n.options.swipeToSlide
                            ? (n.$slideTrack.find(".slick-slide").each(function (o, s) {
                                  return s.offsetLeft - i + e(s).outerWidth() / 2 > -1 * n.swipeLeft ? ((t = s), !1) : void 0;
                              }),
                              Math.abs(e(t).attr("data-slick-index") - n.currentSlide) || 1)
                            : n.options.slidesToScroll;
                    }),
                    (n.prototype.goTo = n.prototype.slickGoTo = function (e, t) {
                        this.changeSlide({ data: { message: "index", index: parseInt(e) } }, t);
                    }),
                    (n.prototype.init = function (t) {
                        var n = this;
                        e(n.$slider).hasClass("slick-initialized") ||
                            (e(n.$slider).addClass("slick-initialized"),
                            n.buildRows(),
                            n.buildOut(),
                            n.setProps(),
                            n.startLoad(),
                            n.loadSlider(),
                            n.initializeEvents(),
                            n.updateArrows(),
                            n.updateDots(),
                            n.checkResponsive(!0),
                            n.focusHandler()),
                            t && n.$slider.trigger("init", [n]),
                            !0 === n.options.accessibility && n.initADA(),
                            n.options.autoplay && ((n.paused = !1), n.autoPlay());
                    }),
                    (n.prototype.initADA = function () {
                        var t = this;
                        t.$slides.add(t.$slideTrack.find(".slick-cloned")).attr({ "aria-hidden": "true", tabindex: "-1" }).find("a, input, button, select").attr({ tabindex: "-1" }),
                            t.$slideTrack.attr("role", "listbox"),
                            t.$slides.not(t.$slideTrack.find(".slick-cloned")).each(function (t) {
                                e(this).attr({ role: "option" });
                            }),
                            null !== t.$dots &&
                                t.$dots
                                    .attr("aria-hidden", "true")
                                    .find("li")
                                    .each(function (n) {
                                        e(this).attr({ role: "presentation", "aria-selected": "false", "aria-controls": "navigation" + t.instanceUid + n, id: "slick-slide" + t.instanceUid + n });
                                    })
                                    .first()
                                    .attr("aria-selected", "true")
                                    .end()
                                    .find("button")
                                    .attr("role", "button")
                                    .end()
                                    .closest("div")
                                    .attr("role", "toolbar"),
                            t.activateADA();
                    }),
                    (n.prototype.initArrowEvents = function () {
                        !0 === this.options.arrows &&
                            this.slideCount > this.options.slidesToShow &&
                            (this.$prevArrow.off("click.slick").on("click.slick", { message: "previous" }, this.changeSlide), this.$nextArrow.off("click.slick").on("click.slick", { message: "next" }, this.changeSlide));
                    }),
                    (n.prototype.initDotEvents = function () {
                        var t = this;
                        !0 === t.options.dots && t.slideCount > t.options.slidesToShow && e("li", t.$dots).on("click.slick", { message: "index" }, t.changeSlide),
                            !0 === t.options.dots && !0 === t.options.pauseOnDotsHover && e("li", t.$dots).on("mouseenter.slick", e.proxy(t.interrupt, t, !0)).on("mouseleave.slick", e.proxy(t.interrupt, t, !1));
                    }),
                    (n.prototype.initSlideEvents = function () {
                        this.options.pauseOnHover && (this.$list.on("mouseenter.slick", e.proxy(this.interrupt, this, !0)), this.$list.on("mouseleave.slick", e.proxy(this.interrupt, this, !1)));
                    }),
                    (n.prototype.initializeEvents = function () {
                        var t = this;
                        t.initArrowEvents(),
                            t.initDotEvents(),
                            t.initSlideEvents(),
                            t.$list.on("touchstart.slick mousedown.slick", { action: "start" }, t.swipeHandler),
                            t.$list.on("touchmove.slick mousemove.slick", { action: "move" }, t.swipeHandler),
                            t.$list.on("touchend.slick mouseup.slick", { action: "end" }, t.swipeHandler),
                            t.$list.on("touchcancel.slick mouseleave.slick", { action: "end" }, t.swipeHandler),
                            t.$list.on("click.slick", t.clickHandler),
                            e(document).on(t.visibilityChange, e.proxy(t.visibility, t)),
                            !0 === t.options.accessibility && t.$list.on("keydown.slick", t.keyHandler),
                            !0 === t.options.focusOnSelect && e(t.$slideTrack).children().on("click.slick", t.selectHandler),
                            e(window).on("orientationchange.slick.slick-" + t.instanceUid, e.proxy(t.orientationChange, t)),
                            e(window).on("resize.slick.slick-" + t.instanceUid, e.proxy(t.resize, t)),
                            e("[draggable!=true]", t.$slideTrack).on("dragstart", t.preventDefault),
                            e(window).on("load.slick.slick-" + t.instanceUid, t.setPosition),
                            e(document).on("ready.slick.slick-" + t.instanceUid, t.setPosition);
                    }),
                    (n.prototype.initUI = function () {
                        !0 === this.options.arrows && this.slideCount > this.options.slidesToShow && (this.$prevArrow.show(), this.$nextArrow.show()),
                            !0 === this.options.dots && this.slideCount > this.options.slidesToShow && this.$dots.show();
                    }),
                    (n.prototype.keyHandler = function (e) {
                        e.target.tagName.match("TEXTAREA|INPUT|SELECT") ||
                            (37 === e.keyCode && !0 === this.options.accessibility
                                ? this.changeSlide({ data: { message: !0 === this.options.rtl ? "next" : "previous" } })
                                : 39 === e.keyCode && !0 === this.options.accessibility && this.changeSlide({ data: { message: !0 === this.options.rtl ? "previous" : "next" } }));
                    }),
                    (n.prototype.lazyLoad = function () {
                        function t(t) {
                            e("img[data-lazy]", t).each(function () {
                                var t = e(this),
                                    n = e(this).attr("data-lazy"),
                                    i = document.createElement("img");
                                (i.onload = function () {
                                    t.animate({ opacity: 0 }, 100, function () {
                                        t.attr("src", n).animate({ opacity: 1 }, 200, function () {
                                            t.removeAttr("data-lazy").removeClass("slick-loading");
                                        }),
                                            o.$slider.trigger("lazyLoaded", [o, t, n]);
                                    });
                                }),
                                    (i.onerror = function () {
                                        t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), o.$slider.trigger("lazyLoadError", [o, t, n]);
                                    }),
                                    (i.src = n);
                            });
                        }
                        var n,
                            i,
                            o = this;
                        !0 === o.options.centerMode
                            ? (i =
                                  !0 === o.options.infinite
                                      ? (n = o.currentSlide + (o.options.slidesToShow / 2 + 1)) + o.options.slidesToShow + 2
                                      : ((n = Math.max(0, o.currentSlide - (o.options.slidesToShow / 2 + 1))), o.options.slidesToShow / 2 + 1 + 2 + o.currentSlide))
                            : ((n = o.options.infinite ? o.options.slidesToShow + o.currentSlide : o.currentSlide), (i = Math.ceil(n + o.options.slidesToShow)), !0 === o.options.fade && (0 < n && n--, i <= o.slideCount && i++)),
                            t(o.$slider.find(".slick-slide").slice(n, i)),
                            o.slideCount <= o.options.slidesToShow
                                ? t(o.$slider.find(".slick-slide"))
                                : o.currentSlide >= o.slideCount - o.options.slidesToShow
                                ? t(o.$slider.find(".slick-cloned").slice(0, o.options.slidesToShow))
                                : 0 === o.currentSlide && t(o.$slider.find(".slick-cloned").slice(-1 * o.options.slidesToShow));
                    }),
                    (n.prototype.loadSlider = function () {
                        this.setPosition(), this.$slideTrack.css({ opacity: 1 }), this.$slider.removeClass("slick-loading"), this.initUI(), "progressive" === this.options.lazyLoad && this.progressiveLazyLoad();
                    }),
                    (n.prototype.next = n.prototype.slickNext = function () {
                        this.changeSlide({ data: { message: "next" } });
                    }),
                    (n.prototype.orientationChange = function () {
                        this.checkResponsive(), this.setPosition();
                    }),
                    (n.prototype.pause = n.prototype.slickPause = function () {
                        this.autoPlayClear(), (this.paused = !0);
                    }),
                    (n.prototype.play = n.prototype.slickPlay = function () {
                        this.autoPlay(), (this.options.autoplay = !0), (this.paused = !1), (this.focussed = !1), (this.interrupted = !1);
                    }),
                    (n.prototype.postSlide = function (e) {
                        var t = this;
                        t.unslicked || (t.$slider.trigger("afterChange", [t, e]), (t.animating = !1), t.setPosition(), (t.swipeLeft = null), t.options.autoplay && t.autoPlay(), !0 === t.options.accessibility && t.initADA());
                    }),
                    (n.prototype.prev = n.prototype.slickPrev = function () {
                        this.changeSlide({ data: { message: "previous" } });
                    }),
                    (n.prototype.preventDefault = function (e) {
                        e.preventDefault();
                    }),
                    (n.prototype.progressiveLazyLoad = function (t) {
                        t = t || 1;
                        var n,
                            i,
                            o = this,
                            s = e("img[data-lazy]", o.$slider);
                        s.length
                            ? ((n = s.first()),
                              (i = n.attr("data-lazy")),
                              ((s = document.createElement("img")).onload = function () {
                                  n.attr("src", i).removeAttr("data-lazy").removeClass("slick-loading"), !0 === o.options.adaptiveHeight && o.setPosition(), o.$slider.trigger("lazyLoaded", [o, n, i]), o.progressiveLazyLoad();
                              }),
                              (s.onerror = function () {
                                  t < 3
                                      ? setTimeout(function () {
                                            o.progressiveLazyLoad(t + 1);
                                        }, 500)
                                      : (n.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), o.$slider.trigger("lazyLoadError", [o, n, i]), o.progressiveLazyLoad());
                              }),
                              (s.src = i))
                            : o.$slider.trigger("allImagesLoaded", [o]);
                    }),
                    (n.prototype.refresh = function (t) {
                        var n = this,
                            i = n.slideCount - n.options.slidesToShow;
                        !n.options.infinite && n.currentSlide > i && (n.currentSlide = i),
                            n.slideCount <= n.options.slidesToShow && (n.currentSlide = 0),
                            (i = n.currentSlide),
                            n.destroy(!0),
                            e.extend(n, n.initials, { currentSlide: i }),
                            n.init(),
                            t || n.changeSlide({ data: { message: "index", index: i } }, !1);
                    }),
                    (n.prototype.registerBreakpoints = function () {
                        var t,
                            n,
                            i,
                            o = this,
                            s = o.options.responsive || null;
                        if ("array" === e.type(s) && s.length) {
                            for (t in ((o.respondTo = o.options.respondTo || "window"), s))
                                if (((i = o.breakpoints.length - 1), (n = s[t].breakpoint), s.hasOwnProperty(t))) {
                                    for (; 0 <= i; ) o.breakpoints[i] && o.breakpoints[i] === n && o.breakpoints.splice(i, 1), i--;
                                    o.breakpoints.push(n), (o.breakpointSettings[n] = s[t].settings);
                                }
                            o.breakpoints.sort(function (e, t) {
                                return o.options.mobileFirst ? e - t : t - e;
                            });
                        }
                    }),
                    (n.prototype.reinit = function () {
                        var t = this;
                        (t.$slides = t.$slideTrack.children(t.options.slide).addClass("slick-slide")),
                            (t.slideCount = t.$slides.length),
                            t.currentSlide >= t.slideCount && 0 !== t.currentSlide && (t.currentSlide = t.currentSlide - t.options.slidesToScroll),
                            t.slideCount <= t.options.slidesToShow && (t.currentSlide = 0),
                            t.registerBreakpoints(),
                            t.setProps(),
                            t.setupInfinite(),
                            t.buildArrows(),
                            t.updateArrows(),
                            t.initArrowEvents(),
                            t.buildDots(),
                            t.updateDots(),
                            t.initDotEvents(),
                            t.cleanUpSlideEvents(),
                            t.initSlideEvents(),
                            t.checkResponsive(!1, !0),
                            !0 === t.options.focusOnSelect && e(t.$slideTrack).children().on("click.slick", t.selectHandler),
                            t.setSlideClasses("number" == typeof t.currentSlide ? t.currentSlide : 0),
                            t.setPosition(),
                            t.focusHandler(),
                            (t.paused = !t.options.autoplay),
                            t.autoPlay(),
                            t.$slider.trigger("reInit", [t]);
                    }),
                    (n.prototype.resize = function () {
                        var t = this;
                        e(window).width() !== t.windowWidth &&
                            (clearTimeout(t.windowDelay),
                            (t.windowDelay = window.setTimeout(function () {
                                (t.windowWidth = e(window).width()), t.checkResponsive(), t.unslicked || t.setPosition();
                            }, 50)));
                    }),
                    (n.prototype.removeSlide = n.prototype.slickRemove = function (e, t, n) {
                        var i = this;
                        return (
                            (e = "boolean" == typeof e ? (!0 === (t = e) ? 0 : i.slideCount - 1) : !0 === t ? --e : e),
                            !(i.slideCount < 1 || e < 0 || e > i.slideCount - 1) &&
                                (i.unload(),
                                (!0 === n ? i.$slideTrack.children() : i.$slideTrack.children(this.options.slide).eq(e)).remove(),
                                (i.$slides = i.$slideTrack.children(this.options.slide)),
                                i.$slideTrack.children(this.options.slide).detach(),
                                i.$slideTrack.append(i.$slides),
                                (i.$slidesCache = i.$slides),
                                void i.reinit())
                        );
                    }),
                    (n.prototype.setCSS = function (e) {
                        var t,
                            n,
                            i = this,
                            o = {};
                        !0 === i.options.rtl && (e = -e),
                            (t = "left" == i.positionProp ? Math.ceil(e) + "px" : "0px"),
                            (n = "top" == i.positionProp ? Math.ceil(e) + "px" : "0px"),
                            (o[i.positionProp] = e),
                            !1 === i.transformsEnabled || (!(o = {}) === i.cssTransitions ? (o[i.animType] = "translate(" + t + ", " + n + ")") : (o[i.animType] = "translate3d(" + t + ", " + n + ", 0px)")),
                            i.$slideTrack.css(o);
                    }),
                    (n.prototype.setDimensions = function () {
                        var e = this;
                        !1 === e.options.vertical
                            ? !0 === e.options.centerMode && e.$list.css({ padding: "0px " + e.options.centerPadding })
                            : (e.$list.height(e.$slides.first().outerHeight(!0) * e.options.slidesToShow), !0 === e.options.centerMode && e.$list.css({ padding: e.options.centerPadding + " 0px" })),
                            (e.listWidth = e.$list.width()),
                            (e.listHeight = e.$list.height()),
                            !1 === e.options.vertical && !1 === e.options.variableWidth
                                ? ((e.slideWidth = Math.ceil(e.listWidth / e.options.slidesToShow)), e.$slideTrack.width(Math.ceil(e.slideWidth * e.$slideTrack.children(".slick-slide").length)))
                                : !0 === e.options.variableWidth
                                ? e.$slideTrack.width(5e3 * e.slideCount)
                                : ((e.slideWidth = Math.ceil(e.listWidth)), e.$slideTrack.height(Math.ceil(e.$slides.first().outerHeight(!0) * e.$slideTrack.children(".slick-slide").length)));
                        var t = e.$slides.first().outerWidth(!0) - e.$slides.first().width();
                        !1 === e.options.variableWidth && e.$slideTrack.children(".slick-slide").width(e.slideWidth - t);
                    }),
                    (n.prototype.setFade = function () {
                        var t,
                            n = this;
                        n.$slides.each(function (i, o) {
                            (t = n.slideWidth * i * -1),
                                !0 === n.options.rtl
                                    ? e(o).css({ position: "relative", right: t, top: 0, zIndex: n.options.zIndex - 2, opacity: 0 })
                                    : e(o).css({ position: "relative", left: t, top: 0, zIndex: n.options.zIndex - 2, opacity: 0 });
                        }),
                            n.$slides.eq(n.currentSlide).css({ zIndex: n.options.zIndex - 1, opacity: 1 });
                    }),
                    (n.prototype.setHeight = function () {
                        var e;
                        1 === this.options.slidesToShow && !0 === this.options.adaptiveHeight && !1 === this.options.vertical && ((e = this.$slides.eq(this.currentSlide).outerHeight(!0)), this.$list.css("height", e));
                    }),
                    (n.prototype.setOption = n.prototype.slickSetOption = function () {
                        var t,
                            n,
                            i,
                            o,
                            s,
                            r = this,
                            a = !1;
                        if (
                            ("object" === e.type(arguments[0])
                                ? ((i = arguments[0]), (a = arguments[1]), (s = "multiple"))
                                : "string" === e.type(arguments[0]) &&
                                  ((i = arguments[0]), (o = arguments[1]), (a = arguments[2]), "responsive" === arguments[0] && "array" === e.type(arguments[1]) ? (s = "responsive") : void 0 !== arguments[1] && (s = "single")),
                            "single" === s)
                        )
                            r.options[i] = o;
                        else if ("multiple" === s)
                            e.each(i, function (e, t) {
                                r.options[e] = t;
                            });
                        else if ("responsive" === s)
                            for (n in o)
                                if ("array" !== e.type(r.options.responsive)) r.options.responsive = [o[n]];
                                else {
                                    for (t = r.options.responsive.length - 1; 0 <= t; ) r.options.responsive[t].breakpoint === o[n].breakpoint && r.options.responsive.splice(t, 1), t--;
                                    r.options.responsive.push(o[n]);
                                }
                        a && (r.unload(), r.reinit());
                    }),
                    (n.prototype.setPosition = function () {
                        this.setDimensions(), this.setHeight(), !1 === this.options.fade ? this.setCSS(this.getLeft(this.currentSlide)) : this.setFade(), this.$slider.trigger("setPosition", [this]);
                    }),
                    (n.prototype.setProps = function () {
                        var e = this,
                            t = document.body.style;
                        (e.positionProp = !0 === e.options.vertical ? "top" : "left"),
                            "top" === e.positionProp ? e.$slider.addClass("slick-vertical") : e.$slider.removeClass("slick-vertical"),
                            (void 0 === t.WebkitTransition && void 0 === t.MozTransition && void 0 === t.msTransition) || !0 !== e.options.useCSS || (e.cssTransitions = !0),
                            e.options.fade && ("number" == typeof e.options.zIndex ? e.options.zIndex < 3 && (e.options.zIndex = 3) : (e.options.zIndex = e.defaults.zIndex)),
                            void 0 !== t.OTransform &&
                                ((e.animType = "OTransform"), (e.transformType = "-o-transform"), (e.transitionType = "OTransition"), void 0 === t.perspectiveProperty && void 0 === t.webkitPerspective && (e.animType = !1)),
                            void 0 !== t.MozTransform &&
                                ((e.animType = "MozTransform"), (e.transformType = "-moz-transform"), (e.transitionType = "MozTransition"), void 0 === t.perspectiveProperty && void 0 === t.MozPerspective && (e.animType = !1)),
                            void 0 !== t.webkitTransform &&
                                ((e.animType = "webkitTransform"), (e.transformType = "-webkit-transform"), (e.transitionType = "webkitTransition"), void 0 === t.perspectiveProperty && void 0 === t.webkitPerspective && (e.animType = !1)),
                            void 0 !== t.msTransform && ((e.animType = "msTransform"), (e.transformType = "-ms-transform"), (e.transitionType = "msTransition"), void 0 === t.msTransform && (e.animType = !1)),
                            void 0 !== t.transform && !1 !== e.animType && ((e.animType = "transform"), (e.transformType = "transform"), (e.transitionType = "transition")),
                            (e.transformsEnabled = e.options.useTransform && null !== e.animType && !1 !== e.animType);
                    }),
                    (n.prototype.setSlideClasses = function (e) {
                        var t,
                            n,
                            i = this,
                            o = i.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden", "true");
                        i.$slides.eq(e).addClass("slick-current"),
                            !0 === i.options.centerMode
                                ? ((n = Math.floor(i.options.slidesToShow / 2)),
                                  !0 === i.options.infinite &&
                                      (n <= e && e <= i.slideCount - 1 - n
                                          ? i.$slides
                                                .slice(e - n, e + n + 1)
                                                .addClass("slick-active")
                                                .attr("aria-hidden", "false")
                                          : ((t = i.options.slidesToShow + e),
                                            o
                                                .slice(t - n + 1, t + n + 2)
                                                .addClass("slick-active")
                                                .attr("aria-hidden", "false")),
                                      0 === e ? o.eq(o.length - 1 - i.options.slidesToShow).addClass("slick-center") : e === i.slideCount - 1 && o.eq(i.options.slidesToShow).addClass("slick-center")),
                                  i.$slides.eq(e).addClass("slick-center"))
                                : 0 <= e && e <= i.slideCount - i.options.slidesToShow
                                ? i.$slides
                                      .slice(e, e + i.options.slidesToShow)
                                      .addClass("slick-active")
                                      .attr("aria-hidden", "false")
                                : o.length <= i.options.slidesToShow
                                ? o.addClass("slick-active").attr("aria-hidden", "false")
                                : ((n = i.slideCount % i.options.slidesToShow),
                                  (t = !0 === i.options.infinite ? i.options.slidesToShow + e : e),
                                  (i.options.slidesToShow == i.options.slidesToScroll && i.slideCount - e < i.options.slidesToShow ? o.slice(t - (i.options.slidesToShow - n), t + n) : o.slice(t, t + i.options.slidesToShow))
                                      .addClass("slick-active")
                                      .attr("aria-hidden", "false")),
                            "ondemand" === i.options.lazyLoad && i.lazyLoad();
                    }),
                    (n.prototype.setupInfinite = function () {
                        var t,
                            n,
                            i,
                            o = this;
                        if ((!0 === o.options.fade && (o.options.centerMode = !1), !0 === o.options.infinite && !1 === o.options.fade && ((n = null), o.slideCount > o.options.slidesToShow))) {
                            for (i = !0 === o.options.centerMode ? o.options.slidesToShow + 1 : o.options.slidesToShow, t = o.slideCount; t > o.slideCount - i; --t)
                                e(o.$slides[(n = t - 1)])
                                    .clone(!0)
                                    .attr("id", "")
                                    .attr("data-slick-index", n - o.slideCount)
                                    .prependTo(o.$slideTrack)
                                    .addClass("slick-cloned");
                            for (t = 0; t < i; t += 1)
                                e(o.$slides[(n = t)])
                                    .clone(!0)
                                    .attr("id", "")
                                    .attr("data-slick-index", n + o.slideCount)
                                    .appendTo(o.$slideTrack)
                                    .addClass("slick-cloned");
                            o.$slideTrack
                                .find(".slick-cloned")
                                .find("[id]")
                                .each(function () {
                                    e(this).attr("id", "");
                                });
                        }
                    }),
                    (n.prototype.interrupt = function (e) {
                        e || this.autoPlay(), (this.interrupted = e);
                    }),
                    (n.prototype.selectHandler = function (t) {
                        return (
                            (t = e(t.target).is(".slick-slide") ? e(t.target) : e(t.target).parents(".slick-slide")),
                            (t = (t = parseInt(t.attr("data-slick-index"))) || 0),
                            this.slideCount <= this.options.slidesToShow ? (this.setSlideClasses(t), void this.asNavFor(t)) : void this.slideHandler(t)
                        );
                    }),
                    (n.prototype.slideHandler = function (e, t, n) {
                        var i,
                            o,
                            s,
                            r = this;
                        return (
                            (t = t || !1),
                            (!0 === r.animating && !0 === r.options.waitForAnimate) || (!0 === r.options.fade && r.currentSlide === e) || r.slideCount <= r.options.slidesToShow
                                ? void 0
                                : (!1 === t && r.asNavFor(e),
                                  (s = r.getLeft((i = e))),
                                  (t = r.getLeft(r.currentSlide)),
                                  (r.currentLeft = null === r.swipeLeft ? t : r.swipeLeft),
                                  (!1 === r.options.infinite && !1 === r.options.centerMode && (e < 0 || e > r.getDotCount() * r.options.slidesToScroll)) ||
                                  (!1 === r.options.infinite && !0 === r.options.centerMode && (e < 0 || e > r.slideCount - r.options.slidesToScroll))
                                      ? void (
                                            !1 === r.options.fade &&
                                            ((i = r.currentSlide),
                                            !0 !== n
                                                ? r.animateSlide(t, function () {
                                                      r.postSlide(i);
                                                  })
                                                : r.postSlide(i))
                                        )
                                      : (r.options.autoplay && clearInterval(r.autoPlayTimer),
                                        (o =
                                            i < 0
                                                ? r.slideCount % r.options.slidesToScroll != 0
                                                    ? r.slideCount - (r.slideCount % r.options.slidesToScroll)
                                                    : r.slideCount + i
                                                : i >= r.slideCount
                                                ? r.slideCount % r.options.slidesToScroll != 0
                                                    ? 0
                                                    : i - r.slideCount
                                                : i),
                                        (r.animating = !0),
                                        r.$slider.trigger("beforeChange", [r, r.currentSlide, o]),
                                        (e = r.currentSlide),
                                        (r.currentSlide = o),
                                        r.setSlideClasses(r.currentSlide),
                                        r.options.asNavFor && (t = (t = r.getNavTarget()).slick("getSlick")).slideCount <= t.options.slidesToShow && t.setSlideClasses(r.currentSlide),
                                        r.updateDots(),
                                        r.updateArrows(),
                                        !0 === r.options.fade
                                            ? (!0 !== n
                                                  ? (r.fadeSlideOut(e),
                                                    r.fadeSlide(o, function () {
                                                        r.postSlide(o);
                                                    }))
                                                  : r.postSlide(o),
                                              void r.animateHeight())
                                            : void (!0 !== n
                                                  ? r.animateSlide(s, function () {
                                                        r.postSlide(o);
                                                    })
                                                  : r.postSlide(o))))
                        );
                    }),
                    (n.prototype.startLoad = function () {
                        var e = this;
                        !0 === e.options.arrows && e.slideCount > e.options.slidesToShow && (e.$prevArrow.hide(), e.$nextArrow.hide()),
                            !0 === e.options.dots && e.slideCount > e.options.slidesToShow && e.$dots.hide(),
                            e.$slider.addClass("slick-loading");
                    }),
                    (n.prototype.swipeDirection = function () {
                        var e = this.touchObject.startX - this.touchObject.curX,
                            t = this.touchObject.startY - this.touchObject.curY;
                        return (
                            (e = Math.atan2(t, e)),
                            ((e = (e = Math.round((180 * e) / Math.PI)) < 0 ? 360 - Math.abs(e) : e) <= 45 && 0 <= e) || (e <= 360 && 315 <= e)
                                ? !1 === this.options.rtl
                                    ? "left"
                                    : "right"
                                : 135 <= e && e <= 225
                                ? !1 === this.options.rtl
                                    ? "right"
                                    : "left"
                                : !0 === this.options.verticalSwiping
                                ? 35 <= e && e <= 135
                                    ? "down"
                                    : "up"
                                : "vertical"
                        );
                    }),
                    (n.prototype.swipeEnd = function (e) {
                        var t,
                            n,
                            i = this;
                        if (((i.dragging = !1), (i.interrupted = !1), (i.shouldClick = !(10 < i.touchObject.swipeLength)), void 0 === i.touchObject.curX)) return !1;
                        if ((!0 === i.touchObject.edgeHit && i.$slider.trigger("edge", [i, i.swipeDirection()]), i.touchObject.swipeLength >= i.touchObject.minSwipe)) {
                            switch ((n = i.swipeDirection())) {
                                case "left":
                                case "down":
                                    (t = i.options.swipeToSlide ? i.checkNavigable(i.currentSlide + i.getSlideCount()) : i.currentSlide + i.getSlideCount()), (i.currentDirection = 0);
                                    break;
                                case "right":
                                case "up":
                                    (t = i.options.swipeToSlide ? i.checkNavigable(i.currentSlide - i.getSlideCount()) : i.currentSlide - i.getSlideCount()), (i.currentDirection = 1);
                            }
                            "vertical" != n && (i.slideHandler(t), (i.touchObject = {}), i.$slider.trigger("swipe", [i, n]));
                        } else i.touchObject.startX !== i.touchObject.curX && (i.slideHandler(i.currentSlide), (i.touchObject = {}));
                    }),
                    (n.prototype.swipeHandler = function (e) {
                        var t = this;
                        if (!(!1 === t.options.swipe || ("ontouchend" in document && !1 === t.options.swipe) || (!1 === t.options.draggable && -1 !== e.type.indexOf("mouse"))))
                            switch (
                                ((t.touchObject.fingerCount = e.originalEvent && void 0 !== e.originalEvent.touches ? e.originalEvent.touches.length : 1),
                                (t.touchObject.minSwipe = t.listWidth / t.options.touchThreshold),
                                !0 === t.options.verticalSwiping && (t.touchObject.minSwipe = t.listHeight / t.options.touchThreshold),
                                e.data.action)
                            ) {
                                case "start":
                                    t.swipeStart(e);
                                    break;
                                case "move":
                                    t.swipeMove(e);
                                    break;
                                case "end":
                                    t.swipeEnd(e);
                            }
                    }),
                    (n.prototype.swipeMove = function (e) {
                        var t,
                            n,
                            i = this,
                            o = void 0 !== e.originalEvent ? e.originalEvent.touches : null;
                        return (
                            !(!i.dragging || (o && 1 !== o.length)) &&
                            ((t = i.getLeft(i.currentSlide)),
                            (i.touchObject.curX = void 0 !== o ? o[0].pageX : e.clientX),
                            (i.touchObject.curY = void 0 !== o ? o[0].pageY : e.clientY),
                            (i.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(i.touchObject.curX - i.touchObject.startX, 2)))),
                            !0 === i.options.verticalSwiping && (i.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(i.touchObject.curY - i.touchObject.startY, 2)))),
                            "vertical" !== (n = i.swipeDirection())
                                ? (void 0 !== e.originalEvent && 4 < i.touchObject.swipeLength && e.preventDefault(),
                                  (o = (!1 === i.options.rtl ? 1 : -1) * (i.touchObject.curX > i.touchObject.startX ? 1 : -1)),
                                  !0 === i.options.verticalSwiping && (o = i.touchObject.curY > i.touchObject.startY ? 1 : -1),
                                  (e = i.touchObject.swipeLength),
                                  (i.touchObject.edgeHit = !1) === i.options.infinite &&
                                      ((0 === i.currentSlide && "right" === n) || (i.currentSlide >= i.getDotCount() && "left" === n)) &&
                                      ((e = i.touchObject.swipeLength * i.options.edgeFriction), (i.touchObject.edgeHit = !0)),
                                  !1 === i.options.vertical ? (i.swipeLeft = t + e * o) : (i.swipeLeft = t + e * (i.$list.height() / i.listWidth) * o),
                                  !0 === i.options.verticalSwiping && (i.swipeLeft = t + e * o),
                                  !0 !== i.options.fade && !1 !== i.options.touchMove && (!0 === i.animating ? ((i.swipeLeft = null), !1) : void i.setCSS(i.swipeLeft)))
                                : void 0)
                        );
                    }),
                    (n.prototype.swipeStart = function (e) {
                        var t,
                            n = this;
                        return (
                            (n.interrupted = !0),
                            1 !== n.touchObject.fingerCount || n.slideCount <= n.options.slidesToShow
                                ? !(n.touchObject = {})
                                : (void 0 !== e.originalEvent && void 0 !== e.originalEvent.touches && (t = e.originalEvent.touches[0]),
                                  (n.touchObject.startX = n.touchObject.curX = void 0 !== t ? t.pageX : e.clientX),
                                  (n.touchObject.startY = n.touchObject.curY = void 0 !== t ? t.pageY : e.clientY),
                                  void (n.dragging = !0))
                        );
                    }),
                    (n.prototype.unfilterSlides = n.prototype.slickUnfilter = function () {
                        null !== this.$slidesCache && (this.unload(), this.$slideTrack.children(this.options.slide).detach(), this.$slidesCache.appendTo(this.$slideTrack), this.reinit());
                    }),
                    (n.prototype.unload = function () {
                        var t = this;
                        e(".slick-cloned", t.$slider).remove(),
                            t.$dots && t.$dots.remove(),
                            t.$prevArrow && t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.remove(),
                            t.$nextArrow && t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.remove(),
                            t.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden", "true").css("width", "");
                    }),
                    (n.prototype.unslick = function (e) {
                        this.$slider.trigger("unslick", [this, e]), this.destroy();
                    }),
                    (n.prototype.updateArrows = function () {
                        var e = this;
                        Math.floor(e.options.slidesToShow / 2),
                            !0 === e.options.arrows &&
                                e.slideCount > e.options.slidesToShow &&
                                !e.options.infinite &&
                                (e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"),
                                e.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"),
                                0 === e.currentSlide
                                    ? (e.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"), e.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"))
                                    : ((e.currentSlide >= e.slideCount - e.options.slidesToShow && !1 === e.options.centerMode) || (e.currentSlide >= e.slideCount - 1 && !0 === e.options.centerMode)) &&
                                      (e.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")));
                    }),
                    (n.prototype.updateDots = function () {
                        null !== this.$dots &&
                            (this.$dots.find("li").removeClass("slick-active").attr("aria-hidden", "true"),
                            this.$dots
                                .find("li")
                                .eq(Math.floor(this.currentSlide / this.options.slidesToScroll))
                                .addClass("slick-active")
                                .attr("aria-hidden", "false"));
                    }),
                    (n.prototype.visibility = function () {
                        this.options.autoplay && (document[this.hidden] ? (this.interrupted = !0) : (this.interrupted = !1));
                    }),
                    (e.fn.slick = function () {
                        for (var e, t = arguments[0], i = Array.prototype.slice.call(arguments, 1), o = this.length, s = 0; s < o; s++)
                            if (("object" == _typeof(t) || void 0 === t ? (this[s].slick = new n(this[s], t)) : (e = this[s].slick[t].apply(this[s].slick, i)), void 0 !== e)) return e;
                        return this;
                    });
            }),
            (h = jQuery),
            (f = document),
            (m = window),
            (J = {
                html: !1,
                photo: !1,
                iframe: !1,
                inline: !1,
                transition: "elastic",
                speed: 300,
                fadeOut: 300,
                width: !1,
                initialWidth: "600",
                innerWidth: !1,
                maxWidth: !1,
                height: !1,
                initialHeight: "450",
                innerHeight: !1,
                maxHeight: !1,
                scalePhotos: !0,
                scrolling: !0,
                opacity: 0.9,
                preloading: !0,
                className: !1,
                overlayClose: !0,
                escKey: !0,
                arrowKey: !0,
                top: !1,
                bottom: !1,
                left: !1,
                right: !1,
                fixed: !1,
                data: void 0,
                closeButton: !0,
                fastIframe: !0,
                open: !1,
                reposition: !0,
                loop: !0,
                slideshow: !1,
                slideshowAuto: !0,
                slideshowSpeed: 2500,
                slideshowStart: "start slideshow",
                slideshowStop: "stop slideshow",
                photoRegex: /\.(gif|png|jp(e|g|eg)|bmp|ico|webp|jxr|svg)((#|\?).*)?$/i,
                retinaImage: !1,
                retinaUrl: !1,
                retinaSuffix: "@2x.$1",
                current: "image {current} of {total}",
                previous: "previous",
                next: "next",
                close: "close",
                xhrError: "This content failed to load.",
                imgError: "This image failed to load.",
                returnFocus: !0,
                trapFocus: !0,
                onOpen: !1,
                onLoad: !1,
                onComplete: !1,
                onCleanup: !1,
                onClosed: !1,
                rel: function () {
                    return this.rel;
                },
                href: function () {
                    return h(this).attr("href");
                },
                title: function () {
                    return this.title;
                },
                createImg: function () {
                    var e = new Image(),
                        t = h(this).data("cbox-img-attrs");
                    return (
                        "object" == _typeof(t) &&
                            h.each(t, function (t, n) {
                                e[t] = n;
                            }),
                        e
                    );
                },
                createIframe: function () {
                    var e = f.createElement("iframe"),
                        t = h(this).data("cbox-iframe-attrs");
                    return (
                        "object" == _typeof(t) &&
                            h.each(t, function (t, n) {
                                e[t] = n;
                            }),
                        "frameBorder" in e && (e.frameBorder = 0),
                        "allowTransparency" in e && (e.allowTransparency = "true"),
                        (e.name = new Date().getTime()),
                        (e.allowFullscreen = !0),
                        e
                    );
                },
            }),
            (ee = "colorbox"),
            (ne = (te = "cbox") + "Element"),
            (ie = te + "_open"),
            (oe = te + "_load"),
            (se = te + "_complete"),
            (re = te + "_cleanup"),
            (ae = te + "_closed"),
            (le = te + "_purge"),
            (ce = h("<a/>")),
            (de = "div"),
            (ue = 0),
            (pe = {}),
            (Z = te + "Slideshow_"),
            (Q = "click." + te),
            (he = function () {
                Y ? I.get("slideshow") || (ce.unbind(re, He), He()) : I.get("slideshow") && S[1] && ((Y = !0), ce.one(re, He), (I.get("slideshowAuto") ? je : Re)(), P.show());
            }),
            h[ee] ||
                (h(ze),
                ((G = h.fn[ee] = h[ee] = function (e, t) {
                    var n = this;
                    return (
                        (e = e || {}),
                        h.isFunction(n) && ((n = h("<a/>")), (e.open = !0)),
                        n[0] &&
                            (ze(),
                            v &&
                                (X ||
                                    ((X = !0),
                                    L.click(function () {
                                        G.next();
                                    }),
                                    D.click(function () {
                                        G.prev();
                                    }),
                                    O.click(function () {
                                        G.close();
                                    }),
                                    g.click(function () {
                                        I.get("overlayClose") && G.close();
                                    }),
                                    h(f).bind("keydown." + te, function (e) {
                                        var t = e.keyCode;
                                        W && I.get("escKey") && 27 === t && (e.preventDefault(), G.close()),
                                            W && I.get("arrowKey") && S[1] && !e.altKey && (37 === t ? (e.preventDefault(), D.click()) : 39 === t && (e.preventDefault(), L.click()));
                                    }),
                                    h.isFunction(h.fn.on) ? h(f).on("click." + te, "." + ne, i) : h("." + ne).live("click." + te, i)),
                                1) &&
                                (t && (e.onComplete = t),
                                n
                                    .each(function () {
                                        var t = h.data(this, ee) || {};
                                        h.data(this, ee, h.extend(t, e));
                                    })
                                    .addClass(ne),
                                new $e(n[0], e).get("open") && Oe(n[0]))),
                        n
                    );
                    function i(e) {
                        1 < e.which || e.shiftKey || e.altKey || e.metaKey || e.ctrlKey || (e.preventDefault(), Oe(this));
                    }
                }).position = function (e, t) {
                    function n() {
                        (w[0].style.width = C[0].style.width = b[0].style.width = parseInt(v[0].style.width, 10) - j + "px"), (b[0].style.height = x[0].style.height = T[0].style.height = parseInt(v[0].style.height, 10) - N + "px");
                    }
                    var i,
                        o,
                        s,
                        r,
                        a = 0,
                        l = 0,
                        c = v.offset();
                    k.unbind("resize." + te),
                        v.css({ top: -9e4, left: -9e4 }),
                        (o = k.scrollTop()),
                        (s = k.scrollLeft()),
                        I.get("fixed") ? ((c.top -= o), (c.left -= s), v.css({ position: "fixed" })) : ((a = o), (l = s), v.css({ position: "absolute" })),
                        (l += !1 !== I.get("right") ? Math.max(k.width() - I.w - H - j - Ee(I.get("right"), "x"), 0) : !1 !== I.get("left") ? Ee(I.get("left"), "x") : Math.round(Math.max(k.width() - I.w - H - j, 0) / 2)),
                        (a += !1 !== I.get("bottom") ? Math.max(ke() - I.h - R - N - Ee(I.get("bottom"), "y"), 0) : !1 !== I.get("top") ? Ee(I.get("top"), "y") : Math.round(Math.max(ke() - I.h - R - N, 0) / 2)),
                        v.css({ top: c.top, left: c.left, visibility: "visible" }),
                        (y[0].style.width = y[0].style.height = "9999px"),
                        (i = { width: I.w + H + j, height: I.h + R + N, top: a, left: l }),
                        e &&
                            ((r = 0),
                            h.each(i, function (t) {
                                return i[t] !== pe[t] ? void (r = e) : void 0;
                            }),
                            (e = r)),
                        (pe = i),
                        e || v.css(i),
                        v.dequeue().animate(i, {
                            duration: e || 0,
                            complete: function () {
                                n(),
                                    (B = !1),
                                    (y[0].style.width = I.w + H + j + "px"),
                                    (y[0].style.height = I.h + R + N + "px"),
                                    I.get("reposition") &&
                                        setTimeout(function () {
                                            k.bind("resize." + te, G.position);
                                        }, 1),
                                    h.isFunction(t) && t();
                            },
                            step: n,
                        });
                }),
                (G.resize = function (e) {
                    var t;
                    W &&
                        ((e = e || {}).width && (I.w = Ee(e.width, "x") - H - j),
                        e.innerWidth && (I.w = Ee(e.innerWidth, "x")),
                        $.css({ width: I.w }),
                        e.height && (I.h = Ee(e.height, "y") - R - N),
                        e.innerHeight && (I.h = Ee(e.innerHeight, "y")),
                        e.innerHeight || e.height || ((t = $.scrollTop()), $.css({ height: "auto" }), (I.h = $.height())),
                        $.css({ height: I.h }),
                        t && $.scrollTop(t),
                        G.position("none" === I.get("transition") ? 0 : I.get("speed")));
                }),
                (G.prep = function (e) {
                    var t, n;
                    W &&
                        ((n = "none" === I.get("transition") ? 0 : I.get("speed")),
                        $.remove(),
                        ($ = Se(de, "LoadedContent").append(e))
                            .hide()
                            .appendTo(_.show())
                            .css({ width: ((I.w = I.w || $.width()), (I.w = I.mw && I.mw < I.w ? I.mw : I.w), I.w), overflow: I.get("scrolling") ? "auto" : "hidden" })
                            .css({ height: ((I.h = I.h || $.height()), (I.h = I.mh && I.mh < I.h ? I.mh : I.h), I.h) })
                            .prependTo(b),
                        _.hide(),
                        h(F).css({ float: "none" }),
                        Le(I.get("className")),
                        (t = function () {
                            function e() {
                                !1 === h.support.opacity && v[0].style.removeAttribute("filter");
                            }
                            var t,
                                i,
                                o = S.length;
                            W &&
                                ((i = function () {
                                    clearTimeout(U), E.hide(), De(se), I.get("onComplete");
                                }),
                                A.html(I.get("title")).show(),
                                $.show(),
                                1 < o
                                    ? ("string" == typeof I.get("current") &&
                                          M.html(
                                              I.get("current")
                                                  .replace("{current}", q + 1)
                                                  .replace("{total}", o)
                                          ).show(),
                                      L[I.get("loop") || q < o - 1 ? "show" : "hide"]().html(I.get("next")),
                                      D[I.get("loop") || q ? "show" : "hide"]().html(I.get("previous")),
                                      he(),
                                      I.get("preloading") &&
                                          h.each([_e(-1), _e(1)], function () {
                                              var e,
                                                  t = new $e((e = S[this]), h.data(e, ee));
                                              (e = t.get("href")) && Ae(t, e) && ((e = Me(t, e)), (f.createElement("img").src = e));
                                          }))
                                    : z.hide(),
                                I.get("iframe")
                                    ? ((t = I.get("createIframe")),
                                      I.get("scrolling") || (t.scrolling = "no"),
                                      h(t)
                                          .attr({ src: I.get("href"), class: te + "Iframe" })
                                          .one("load", i)
                                          .appendTo($),
                                      ce.one(le, function () {
                                          t.src = "//about:blank";
                                      }),
                                      I.get("fastIframe") && h(t).trigger("load"))
                                    : i(),
                                "fade" === I.get("transition") ? v.fadeTo(n, 1, e) : e());
                        }),
                        "fade" === I.get("transition")
                            ? v.fadeTo(n, 0, function () {
                                  G.position(0, t);
                              })
                            : G.position(n, t));
                }),
                (G.next = function () {
                    !B && S[1] && (I.get("loop") || S[q + 1]) && ((q = _e(1)), Oe(S[q]));
                }),
                (G.prev = function () {
                    !B && S[1] && (I.get("loop") || q) && ((q = _e(-1)), Oe(S[q]));
                }),
                (G.close = function () {
                    W &&
                        !V &&
                        ((W = !(V = !0)),
                        De(re),
                        I.get("onCleanup"),
                        k.unbind("." + te),
                        g.fadeTo(I.get("fadeOut") || 0, 0),
                        v.stop().fadeTo(I.get("fadeOut") || 0, 0, function () {
                            v.hide(),
                                g.hide(),
                                De(le),
                                $.remove(),
                                setTimeout(function () {
                                    (V = !1), De(ae), I.get("onClosed");
                                }, 1);
                        }));
                }),
                (G.remove = function () {
                    v &&
                        (v.stop(),
                        h[ee].close(),
                        v.stop(!1, !0).remove(),
                        g.remove(),
                        (V = !1),
                        (v = null),
                        h("." + ne)
                            .removeData(ee)
                            .removeClass(ne),
                        h(f)
                            .unbind("click." + te)
                            .unbind("keydown." + te));
                }),
                (G.element = function () {
                    return h(I.el);
                }),
                (G.settings = J)),
            (fe = function (t) {
                var n,
                    i,
                    o,
                    s,
                    r,
                    a,
                    l,
                    c,
                    d,
                    u,
                    p,
                    h,
                    f,
                    m,
                    g =
                        (((v = t && t.fn && t.fn.select2 && t.fn.select2.amd ? t.fn.select2.amd : v) && v.requirejs) ||
                            (v ? (i = v) : (v = {}),
                            (c = {}),
                            (d = {}),
                            (u = {}),
                            (p = {}),
                            (h = Object.prototype.hasOwnProperty),
                            (f = [].slice),
                            (m = /\.js$/),
                            (a = function (e, t) {
                                var n,
                                    i,
                                    o = T(e),
                                    s = o[0];
                                return (
                                    (t = t[1]),
                                    (e = o[1]),
                                    s && (n = x((s = b(s, t)))),
                                    s
                                        ? (e =
                                              n && n.normalize
                                                  ? n.normalize(
                                                        e,
                                                        ((i = t),
                                                        function (e) {
                                                            return b(e, i);
                                                        })
                                                    )
                                                  : b(e, t))
                                        : ((s = (o = T((e = b(e, t))))[0]), (e = o[1]), s && (n = x(s))),
                                    { f: s ? s + "!" + e : e, n: e, pr: s, p: n }
                                );
                            }),
                            (l = {
                                require: function (e) {
                                    return w(e);
                                },
                                exports: function (e) {
                                    var t = c[e];
                                    return void 0 !== t ? t : (c[e] = {});
                                },
                                module: function (e) {
                                    return {
                                        id: e,
                                        uri: "",
                                        exports: c[e],
                                        config:
                                            ((t = e),
                                            function () {
                                                return (u && u.config && u.config[t]) || {};
                                            }),
                                    };
                                    var t;
                                },
                            }),
                            (s = function (e, t, n, i) {
                                var s,
                                    r,
                                    u,
                                    h,
                                    f,
                                    m = [],
                                    g = _typeof(n),
                                    v = C((i = i || e));
                                if ("undefined" == g || "function" == g) {
                                    for (t = !t.length && n.length ? ["require", "exports", "module"] : t, h = 0; h < t.length; h += 1)
                                        if ("require" === (r = (u = a(t[h], v)).f)) m[h] = l.require(e);
                                        else if ("exports" === r) (m[h] = l.exports(e)), (f = !0);
                                        else if ("module" === r) s = m[h] = l.module(e);
                                        else if (y(c, r) || y(d, r) || y(p, r)) m[h] = x(r);
                                        else {
                                            if (!u.p) throw new Error(e + " missing " + r);
                                            u.p.load(
                                                u.n,
                                                w(i, !0),
                                                (function (e) {
                                                    return function (t) {
                                                        c[e] = t;
                                                    };
                                                })(r),
                                                {}
                                            ),
                                                (m[h] = c[r]);
                                        }
                                    (g = n ? n.apply(c[e], m) : void 0), e && (s && s.exports !== o && s.exports !== c[e] ? (c[e] = s.exports) : (g === o && f) || (c[e] = g));
                                } else e && (c[e] = n);
                            }),
                            (n = i = r = function (e, t, n, i, c) {
                                if ("string" == typeof e) return l[e] ? l[e](t) : x(a(e, C(t)).f);
                                if (!e.splice) {
                                    if (((u = e).deps && r(u.deps, u.callback), !t)) return;
                                    t.splice ? ((e = t), (t = n), (n = null)) : (e = o);
                                }
                                return (
                                    (t = t || function () {}),
                                    "function" == typeof n && ((n = i), (i = c)),
                                    i
                                        ? s(o, e, t, n)
                                        : setTimeout(function () {
                                              s(o, e, t, n);
                                          }, 4),
                                    r
                                );
                            }),
                            (r.config = function (e) {
                                return r(e);
                            }),
                            (n._defined = c),
                            ((g = function (e, t, n) {
                                if ("string" != typeof e) throw new Error("See almond README: incorrect module build, no module name");
                                t.splice || ((n = t), (t = [])), y(c, e) || y(d, e) || (d[e] = [e, t, n]);
                            }).amd = { jQuery: !0 }),
                            (v.requirejs = n),
                            (v.require = i),
                            (v.define = g)),
                        v.define("almond", function () {}),
                        v.define("jquery", [], function () {
                            var n = t || e;
                            return (
                                null == n && console && console.error && console.error("Select2: An instance of jQuery or a jQuery-compatible library was not found. Make sure that you are including jQuery before Select2 on your web page."),
                                n
                            );
                        }),
                        v.define("select2/utils", ["jquery"], function (e) {
                            var t = {};
                            function n(e) {
                                var t,
                                    n = e.prototype,
                                    i = [];
                                for (t in n) "function" == typeof n[t] && "constructor" !== t && i.push(t);
                                return i;
                            }
                            function i() {
                                this.listeners = {};
                            }
                            (t.Extend = function (e, t) {
                                var n,
                                    i = {}.hasOwnProperty;
                                function o() {
                                    this.constructor = e;
                                }
                                for (n in t) i.call(t, n) && (e[n] = t[n]);
                                return (o.prototype = t.prototype), (e.prototype = new o()), (e.__super__ = t.prototype), e;
                            }),
                                (t.Decorate = function (e, t) {
                                    var i = n(t),
                                        o = n(e);
                                    function s() {
                                        var n = Array.prototype.unshift,
                                            i = t.prototype.constructor.length,
                                            o = e.prototype.constructor;
                                        0 < i && (n.call(arguments, e.prototype.constructor), (o = t.prototype.constructor)), o.apply(this, arguments);
                                    }
                                    (t.displayName = e.displayName),
                                        (s.prototype = new (function () {
                                            this.constructor = s;
                                        })());
                                    for (var r = 0; r < o.length; r++) {
                                        var a = o[r];
                                        s.prototype[a] = e.prototype[a];
                                    }
                                    for (var l = 0; l < i.length; l++) {
                                        var c = i[l];
                                        s.prototype[c] = (function (e) {
                                            var n = function () {};
                                            e in s.prototype && (n = s.prototype[e]);
                                            var i = t.prototype[e];
                                            return function () {
                                                return Array.prototype.unshift.call(arguments, n), i.apply(this, arguments);
                                            };
                                        })(c);
                                    }
                                    return s;
                                }),
                                (i.prototype.on = function (e, t) {
                                    (this.listeners = this.listeners || {}), e in this.listeners ? this.listeners[e].push(t) : (this.listeners[e] = [t]);
                                }),
                                (i.prototype.trigger = function (e) {
                                    var t = Array.prototype.slice,
                                        n = t.call(arguments, 1);
                                    (this.listeners = this.listeners || {}),
                                        0 === (n = null == n ? [] : n).length && n.push({}),
                                        (n[0]._type = e) in this.listeners && this.invoke(this.listeners[e], t.call(arguments, 1)),
                                        "*" in this.listeners && this.invoke(this.listeners["*"], arguments);
                                }),
                                (i.prototype.invoke = function (e, t) {
                                    for (var n = 0, i = e.length; n < i; n++) e[n].apply(this, t);
                                }),
                                (t.Observable = i),
                                (t.generateChars = function (e) {
                                    for (var t = "", n = 0; n < e; n++) t += Math.floor(36 * Math.random()).toString(36);
                                    return t;
                                }),
                                (t.bind = function (e, t) {
                                    return function () {
                                        e.apply(t, arguments);
                                    };
                                }),
                                (t._convertData = function (e) {
                                    for (var t in e) {
                                        var n = t.split("-"),
                                            i = e;
                                        if (1 !== n.length) {
                                            for (var o = 0; o < n.length; o++) {
                                                var s = n[o];
                                                (s = s.substring(0, 1).toLowerCase() + s.substring(1)) in i || (i[s] = {}), o == n.length - 1 && (i[s] = e[t]), (i = i[s]);
                                            }
                                            delete e[t];
                                        }
                                    }
                                    return e;
                                }),
                                (t.hasScroll = function (t, n) {
                                    var i = e(n),
                                        o = n.style.overflowX,
                                        s = n.style.overflowY;
                                    return (o !== s || ("hidden" !== s && "visible" !== s)) && ("scroll" === o || "scroll" === s || i.innerHeight() < n.scrollHeight || i.innerWidth() < n.scrollWidth);
                                }),
                                (t.escapeMarkup = function (e) {
                                    var t = { "\\": "&#92;", "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;", "/": "&#47;" };
                                    return "string" != typeof e
                                        ? e
                                        : String(e).replace(/[&<>"'\/\\]/g, function (e) {
                                              return t[e];
                                          });
                                }),
                                (t.appendMany = function (t, n) {
                                    var i;
                                    "1.7" === e.fn.jquery.substr(0, 3) &&
                                        ((i = e()),
                                        e.map(n, function (e) {
                                            i = i.add(e);
                                        }),
                                        (n = i)),
                                        t.append(n);
                                }),
                                (t.__cache = {});
                            var o = 0;
                            return (
                                (t.GetUniqueElementId = function (e) {
                                    var t = e.getAttribute("data-select2-id");
                                    return null == t && (e.id ? ((t = e.id), e.setAttribute("data-select2-id", t)) : (e.setAttribute("data-select2-id", ++o), (t = o.toString()))), t;
                                }),
                                (t.StoreData = function (e, n, i) {
                                    (e = t.GetUniqueElementId(e)), t.__cache[e] || (t.__cache[e] = {}), (t.__cache[e][n] = i);
                                }),
                                (t.GetData = function (n, i) {
                                    var o = t.GetUniqueElementId(n);
                                    return i ? (t.__cache[o] && null != t.__cache[o][i] ? t.__cache[o][i] : e(n).data(i)) : t.__cache[o];
                                }),
                                (t.RemoveData = function (e) {
                                    var n = t.GetUniqueElementId(e);
                                    null != t.__cache[n] && delete t.__cache[n], e.removeAttribute("data-select2-id");
                                }),
                                t
                            );
                        }),
                        v.define("select2/results", ["jquery", "./utils"], function (e, t) {
                            function n(e, t, i) {
                                (this.$element = e), (this.data = i), (this.options = t), n.__super__.constructor.call(this);
                            }
                            return (
                                t.Extend(n, t.Observable),
                                (n.prototype.render = function () {
                                    var t = e('<ul class="select2-results__options" role="listbox"></ul>');
                                    return this.options.get("multiple") && t.attr("aria-multiselectable", "true"), (this.$results = t);
                                }),
                                (n.prototype.clear = function () {
                                    this.$results.empty();
                                }),
                                (n.prototype.displayMessage = function (t) {
                                    var n = this.options.get("escapeMarkup");
                                    this.clear(), this.hideLoading();
                                    var i = e('<li role="alert" aria-live="assertive" class="select2-results__option"></li>'),
                                        o = this.options.get("translations").get(t.message);
                                    i.append(n(o(t.args))), (i[0].className += " select2-results__message"), this.$results.append(i);
                                }),
                                (n.prototype.hideMessages = function () {
                                    this.$results.find(".select2-results__message").remove();
                                }),
                                (n.prototype.append = function (e) {
                                    this.hideLoading();
                                    var t = [];
                                    if (null != e.results && 0 !== e.results.length) {
                                        e.results = this.sort(e.results);
                                        for (var n = 0; n < e.results.length; n++) {
                                            var i = e.results[n];
                                            (i = this.option(i)), t.push(i);
                                        }
                                        this.$results.append(t);
                                    } else 0 === this.$results.children().length && this.trigger("results:message", { message: "noResults" });
                                }),
                                (n.prototype.position = function (e, t) {
                                    t.find(".select2-results").append(e);
                                }),
                                (n.prototype.sort = function (e) {
                                    return this.options.get("sorter")(e);
                                }),
                                (n.prototype.highlightFirstItem = function () {
                                    var e = this.$results.find(".select2-results__option[aria-selected]"),
                                        t = e.filter("[aria-selected=true]");
                                    (0 < t.length ? t : e).first().trigger("mouseenter"), this.ensureHighlightVisible();
                                }),
                                (n.prototype.setClasses = function () {
                                    var n = this;
                                    this.data.current(function (i) {
                                        var o = e.map(i, function (e) {
                                            return e.id.toString();
                                        });
                                        n.$results.find(".select2-results__option[aria-selected]").each(function () {
                                            var n = e(this),
                                                i = t.GetData(this, "data"),
                                                s = "" + i.id;
                                            (null != i.element && i.element.selected) || (null == i.element && -1 < e.inArray(s, o)) ? n.attr("aria-selected", "true") : n.attr("aria-selected", "false");
                                        });
                                    });
                                }),
                                (n.prototype.showLoading = function (e) {
                                    this.hideLoading(), (e = { disabled: !0, loading: !0, text: this.options.get("translations").get("searching")(e) }), ((e = this.option(e)).className += " loading-results"), this.$results.prepend(e);
                                }),
                                (n.prototype.hideLoading = function () {
                                    this.$results.find(".loading-results").remove();
                                }),
                                (n.prototype.option = function (n) {
                                    var i = document.createElement("li");
                                    i.className = "select2-results__option";
                                    var o,
                                        s = { role: "option", "aria-selected": "false" },
                                        r = window.Element.prototype.matches || window.Element.prototype.msMatchesSelector || window.Element.prototype.webkitMatchesSelector;
                                    for (o in (((null != n.element && r.call(n.element, ":disabled")) || (null == n.element && n.disabled)) && (delete s["aria-selected"], (s["aria-disabled"] = "true")),
                                    null == n.id && delete s["aria-selected"],
                                    null != n._resultId && (i.id = n._resultId),
                                    n.title && (i.title = n.title),
                                    n.children && ((s.role = "group"), (s["aria-label"] = n.text), delete s["aria-selected"]),
                                    s)) {
                                        var a = s[o];
                                        i.setAttribute(o, a);
                                    }
                                    if (n.children) {
                                        var l = e(i),
                                            c = document.createElement("strong");
                                        (c.className = "select2-results__group"), e(c), this.template(n, c);
                                        for (var d = [], u = 0; u < n.children.length; u++) {
                                            var p = n.children[u];
                                            (p = this.option(p)), d.push(p);
                                        }
                                        (r = e("<ul></ul>", { class: "select2-results__options select2-results__options--nested" })).append(d), l.append(c), l.append(r);
                                    } else this.template(n, i);
                                    return t.StoreData(i, "data", n), i;
                                }),
                                (n.prototype.bind = function (n, i) {
                                    var o = this,
                                        s = n.id + "-results";
                                    this.$results.attr("id", s),
                                        n.on("results:all", function (e) {
                                            o.clear(), o.append(e.data), n.isOpen() && (o.setClasses(), o.highlightFirstItem());
                                        }),
                                        n.on("results:append", function (e) {
                                            o.append(e.data), n.isOpen() && o.setClasses();
                                        }),
                                        n.on("query", function (e) {
                                            o.hideMessages(), o.showLoading(e);
                                        }),
                                        n.on("select", function () {
                                            n.isOpen() && (o.setClasses(), o.options.get("scrollAfterSelect") && o.highlightFirstItem());
                                        }),
                                        n.on("unselect", function () {
                                            n.isOpen() && (o.setClasses(), o.options.get("scrollAfterSelect") && o.highlightFirstItem());
                                        }),
                                        n.on("open", function () {
                                            o.$results.attr("aria-expanded", "true"), o.$results.attr("aria-hidden", "false"), o.setClasses(), o.ensureHighlightVisible();
                                        }),
                                        n.on("close", function () {
                                            o.$results.attr("aria-expanded", "false"), o.$results.attr("aria-hidden", "true"), o.$results.removeAttr("aria-activedescendant");
                                        }),
                                        n.on("results:toggle", function () {
                                            var e = o.getHighlightedResults();
                                            0 !== e.length && e.trigger("mouseup");
                                        }),
                                        n.on("results:select", function () {
                                            var e,
                                                n = o.getHighlightedResults();
                                            0 !== n.length && ((e = t.GetData(n[0], "data")), "true" == n.attr("aria-selected") ? o.trigger("close", {}) : o.trigger("select", { data: e }));
                                        }),
                                        n.on("results:previous", function () {
                                            var e,
                                                t = o.getHighlightedResults(),
                                                n = o.$results.find("[aria-selected]"),
                                                i = n.index(t);
                                            i <= 0 ||
                                                ((e = i - 1),
                                                0 === t.length && (e = 0),
                                                (i = n.eq(e)).trigger("mouseenter"),
                                                (t = o.$results.offset().top),
                                                (n = i.offset().top),
                                                (i = o.$results.scrollTop() + (n - t)),
                                                0 === e ? o.$results.scrollTop(0) : n - t < 0 && o.$results.scrollTop(i));
                                        }),
                                        n.on("results:next", function () {
                                            var e,
                                                t = o.getHighlightedResults(),
                                                n = o.$results.find("[aria-selected]"),
                                                i = n.index(t) + 1;
                                            i >= n.length ||
                                                ((e = n.eq(i)).trigger("mouseenter"),
                                                (t = o.$results.offset().top + o.$results.outerHeight(!1)),
                                                (n = e.offset().top + e.outerHeight(!1)),
                                                (e = o.$results.scrollTop() + n - t),
                                                0 === i ? o.$results.scrollTop(0) : t < n && o.$results.scrollTop(e));
                                        }),
                                        n.on("results:focus", function (e) {
                                            e.element.addClass("select2-results__option--highlighted");
                                        }),
                                        n.on("results:message", function (e) {
                                            o.displayMessage(e);
                                        }),
                                        e.fn.mousewheel &&
                                            this.$results.on("mousewheel", function (e) {
                                                var t = o.$results.scrollTop(),
                                                    n = o.$results.get(0).scrollHeight - t + e.deltaY;
                                                (t = 0 < e.deltaY && t - e.deltaY <= 0),
                                                    (n = e.deltaY < 0 && n <= o.$results.height()),
                                                    t
                                                        ? (o.$results.scrollTop(0), e.preventDefault(), e.stopPropagation())
                                                        : n && (o.$results.scrollTop(o.$results.get(0).scrollHeight - o.$results.height()), e.preventDefault(), e.stopPropagation());
                                            }),
                                        this.$results.on("mouseup", ".select2-results__option[aria-selected]", function (n) {
                                            var i = e(this),
                                                s = t.GetData(this, "data");
                                            "true" !== i.attr("aria-selected") ? o.trigger("select", { originalEvent: n, data: s }) : o.options.get("multiple") ? o.trigger("unselect", { originalEvent: n, data: s }) : o.trigger("close", {});
                                        }),
                                        this.$results.on("mouseenter", ".select2-results__option[aria-selected]", function (n) {
                                            var i = t.GetData(this, "data");
                                            o.getHighlightedResults().removeClass("select2-results__option--highlighted"), o.trigger("results:focus", { data: i, element: e(this) });
                                        });
                                }),
                                (n.prototype.getHighlightedResults = function () {
                                    return this.$results.find(".select2-results__option--highlighted");
                                }),
                                (n.prototype.destroy = function () {
                                    this.$results.remove();
                                }),
                                (n.prototype.ensureHighlightVisible = function () {
                                    var e,
                                        t,
                                        n,
                                        i,
                                        o = this.getHighlightedResults();
                                    0 !== o.length &&
                                        ((e = this.$results.find("[aria-selected]").index(o)),
                                        (i = this.$results.offset().top),
                                        (t = o.offset().top),
                                        (n = this.$results.scrollTop() + (t - i)),
                                        (i = t - i),
                                        (n -= 2 * o.outerHeight(!1)),
                                        e <= 2 ? this.$results.scrollTop(0) : (i > this.$results.outerHeight() || i < 0) && this.$results.scrollTop(n));
                                }),
                                (n.prototype.template = function (t, n) {
                                    var i = this.options.get("templateResult"),
                                        o = this.options.get("escapeMarkup");
                                    null == (t = i(t, n)) ? (n.style.display = "none") : "string" == typeof t ? (n.innerHTML = o(t)) : e(n).append(t);
                                }),
                                n
                            );
                        }),
                        v.define("select2/keys", [], function () {
                            return { BACKSPACE: 8, TAB: 9, ENTER: 13, SHIFT: 16, CTRL: 17, ALT: 18, ESC: 27, SPACE: 32, PAGE_UP: 33, PAGE_DOWN: 34, END: 35, HOME: 36, LEFT: 37, UP: 38, RIGHT: 39, DOWN: 40, DELETE: 46 };
                        }),
                        v.define("select2/selection/base", ["jquery", "../utils", "../keys"], function (e, t, n) {
                            function i(e, t) {
                                (this.$element = e), (this.options = t), i.__super__.constructor.call(this);
                            }
                            return (
                                t.Extend(i, t.Observable),
                                (i.prototype.render = function () {
                                    var n = e('<span class="select2-selection" role="combobox"  aria-haspopup="true" aria-expanded="false"></span>');
                                    return (
                                        (this._tabindex = 0),
                                        null != t.GetData(this.$element[0], "old-tabindex")
                                            ? (this._tabindex = t.GetData(this.$element[0], "old-tabindex"))
                                            : null != this.$element.attr("tabindex") && (this._tabindex = this.$element.attr("tabindex")),
                                        n.attr("title", this.$element.attr("title")),
                                        n.attr("tabindex", this._tabindex),
                                        n.attr("aria-disabled", "false"),
                                        (this.$selection = n)
                                    );
                                }),
                                (i.prototype.bind = function (e, t) {
                                    var i = this,
                                        o = e.id + "-results";
                                    (this.container = e),
                                        this.$selection.on("focus", function (e) {
                                            i.trigger("focus", e);
                                        }),
                                        this.$selection.on("blur", function (e) {
                                            i._handleBlur(e);
                                        }),
                                        this.$selection.on("keydown", function (e) {
                                            i.trigger("keypress", e), e.which === n.SPACE && e.preventDefault();
                                        }),
                                        e.on("results:focus", function (e) {
                                            i.$selection.attr("aria-activedescendant", e.data._resultId);
                                        }),
                                        e.on("selection:update", function (e) {
                                            i.update(e.data);
                                        }),
                                        e.on("open", function () {
                                            i.$selection.attr("aria-expanded", "true"), i.$selection.attr("aria-owns", o), i._attachCloseHandler(e);
                                        }),
                                        e.on("close", function () {
                                            i.$selection.attr("aria-expanded", "false"), i.$selection.removeAttr("aria-activedescendant"), i.$selection.removeAttr("aria-owns"), i.$selection.trigger("focus"), i._detachCloseHandler(e);
                                        }),
                                        e.on("enable", function () {
                                            i.$selection.attr("tabindex", i._tabindex), i.$selection.attr("aria-disabled", "false");
                                        }),
                                        e.on("disable", function () {
                                            i.$selection.attr("tabindex", "-1"), i.$selection.attr("aria-disabled", "true");
                                        });
                                }),
                                (i.prototype._handleBlur = function (t) {
                                    var n = this;
                                    window.setTimeout(function () {
                                        document.activeElement == n.$selection[0] || e.contains(n.$selection[0], document.activeElement) || n.trigger("blur", t);
                                    }, 1);
                                }),
                                (i.prototype._attachCloseHandler = function (n) {
                                    e(document.body).on("mousedown.select2." + n.id, function (n) {
                                        var i = e(n.target).closest(".select2");
                                        e(".select2.select2-container--open").each(function () {
                                            this != i[0] && t.GetData(this, "element").select2("close");
                                        });
                                    });
                                }),
                                (i.prototype._detachCloseHandler = function (t) {
                                    e(document.body).off("mousedown.select2." + t.id);
                                }),
                                (i.prototype.position = function (e, t) {
                                    t.find(".selection").append(e);
                                }),
                                (i.prototype.destroy = function () {
                                    this._detachCloseHandler(this.container);
                                }),
                                (i.prototype.update = function (e) {
                                    throw new Error("The `update` method must be defined in child classes.");
                                }),
                                i
                            );
                        }),
                        v.define("select2/selection/single", ["jquery", "./base", "../utils", "../keys"], function (e, t, n, i) {
                            function o() {
                                o.__super__.constructor.apply(this, arguments);
                            }
                            return (
                                n.Extend(o, t),
                                (o.prototype.render = function () {
                                    var e = o.__super__.render.call(this);
                                    return e.addClass("select2-selection--single"), e.html('<span class="select2-selection__rendered"></span><span class="select2-selection__arrow" role="presentation"><b role="presentation"></b></span>'), e;
                                }),
                                (o.prototype.bind = function (e, t) {
                                    var n = this;
                                    o.__super__.bind.apply(this, arguments);
                                    var i = e.id + "-container";
                                    this.$selection.find(".select2-selection__rendered").attr("id", i).attr("role", "textbox").attr("aria-readonly", "true"),
                                        this.$selection.attr("aria-labelledby", i),
                                        this.$selection.on("mousedown", function (e) {
                                            1 === e.which && n.trigger("toggle", { originalEvent: e });
                                        }),
                                        this.$selection.on("focus", function (e) {}),
                                        this.$selection.on("blur", function (e) {}),
                                        e.on("focus", function (t) {
                                            e.isOpen() || n.$selection.trigger("focus");
                                        });
                                }),
                                (o.prototype.clear = function () {
                                    var e = this.$selection.find(".select2-selection__rendered");
                                    e.empty(), e.removeAttr("title");
                                }),
                                (o.prototype.display = function (e, t) {
                                    var n = this.options.get("templateSelection");
                                    return this.options.get("escapeMarkup")(n(e, t));
                                }),
                                (o.prototype.selectionContainer = function () {
                                    return e("<span></span>");
                                }),
                                (o.prototype.update = function (e) {
                                    var t, n;
                                    0 !== e.length
                                        ? ((n = e[0]), (t = this.$selection.find(".select2-selection__rendered")), (e = this.display(n, t)), t.empty().append(e), (n = n.title || n.text) ? t.attr("title", n) : t.removeAttr("title"))
                                        : this.clear();
                                }),
                                o
                            );
                        }),
                        v.define("select2/selection/multiple", ["jquery", "./base", "../utils"], function (e, t, n) {
                            function i(e, t) {
                                i.__super__.constructor.apply(this, arguments);
                            }
                            return (
                                n.Extend(i, t),
                                (i.prototype.render = function () {
                                    var e = i.__super__.render.call(this);
                                    return e.addClass("select2-selection--multiple"), e.html('<ul class="select2-selection__rendered"></ul>'), e;
                                }),
                                (i.prototype.bind = function (t, o) {
                                    var s = this;
                                    i.__super__.bind.apply(this, arguments),
                                        this.$selection.on("click", function (e) {
                                            s.trigger("toggle", { originalEvent: e });
                                        }),
                                        this.$selection.on("click", ".select2-selection__choice__remove", function (t) {
                                            var i;
                                            s.options.get("disabled") || ((i = e(this).parent()), (i = n.GetData(i[0], "data")), s.trigger("unselect", { originalEvent: t, data: i }));
                                        });
                                }),
                                (i.prototype.clear = function () {
                                    var e = this.$selection.find(".select2-selection__rendered");
                                    e.empty(), e.removeAttr("title");
                                }),
                                (i.prototype.display = function (e, t) {
                                    var n = this.options.get("templateSelection");
                                    return this.options.get("escapeMarkup")(n(e, t));
                                }),
                                (i.prototype.selectionContainer = function () {
                                    return e('<li class="select2-selection__choice"><span class="select2-selection__choice__remove" role="presentation">&times;</span></li>');
                                }),
                                (i.prototype.update = function (e) {
                                    if ((this.clear(), 0 !== e.length)) {
                                        for (var t = [], i = 0; i < e.length; i++) {
                                            var o = e[i],
                                                s = this.selectionContainer(),
                                                r = this.display(o, s);
                                            s.append(r), (r = o.title || o.text) && s.attr("title", r), n.StoreData(s[0], "data", o), t.push(s);
                                        }
                                        var a = this.$selection.find(".select2-selection__rendered");
                                        n.appendMany(a, t);
                                    }
                                }),
                                i
                            );
                        }),
                        v.define("select2/selection/placeholder", ["../utils"], function (e) {
                            function t(e, t, n) {
                                (this.placeholder = this.normalizePlaceholder(n.get("placeholder"))), e.call(this, t, n);
                            }
                            return (
                                (t.prototype.normalizePlaceholder = function (e, t) {
                                    return "string" == typeof t ? { id: "", text: t } : t;
                                }),
                                (t.prototype.createPlaceholder = function (e, t) {
                                    var n = this.selectionContainer();
                                    return n.html(this.display(t)), n.addClass("select2-selection__placeholder").removeClass("select2-selection__choice"), n;
                                }),
                                (t.prototype.update = function (e, t) {
                                    var n = 1 == t.length && t[0].id != this.placeholder.id;
                                    if (1 < t.length || n) return e.call(this, t);
                                    this.clear(), (t = this.createPlaceholder(this.placeholder)), this.$selection.find(".select2-selection__rendered").append(t);
                                }),
                                t
                            );
                        }),
                        v.define("select2/selection/allowClear", ["jquery", "../keys", "../utils"], function (e, t, n) {
                            function i() {}
                            return (
                                (i.prototype.bind = function (e, t, n) {
                                    var i = this;
                                    e.call(this, t, n),
                                        null == this.placeholder &&
                                            this.options.get("debug") &&
                                            window.console &&
                                            console.error &&
                                            console.error("Select2: The `allowClear` option should be used in combination with the `placeholder` option."),
                                        this.$selection.on("mousedown", ".select2-selection__clear", function (e) {
                                            i._handleClear(e);
                                        }),
                                        t.on("keypress", function (e) {
                                            i._handleKeyboardClear(e, t);
                                        });
                                }),
                                (i.prototype._handleClear = function (e, t) {
                                    if (!this.options.get("disabled")) {
                                        var i = this.$selection.find(".select2-selection__clear");
                                        if (0 !== i.length) {
                                            t.stopPropagation();
                                            var o = n.GetData(i[0], "data"),
                                                s = this.$element.val();
                                            this.$element.val(this.placeholder.id);
                                            var r = { data: o };
                                            if ((this.trigger("clear", r), r.prevented)) this.$element.val(s);
                                            else {
                                                for (var a = 0; a < o.length; a++) if (((r = { data: o[a] }), this.trigger("unselect", r), r.prevented)) return void this.$element.val(s);
                                                this.$element.trigger("change"), this.trigger("toggle", {});
                                            }
                                        }
                                    }
                                }),
                                (i.prototype._handleKeyboardClear = function (e, n, i) {
                                    i.isOpen() || (n.which != t.DELETE && n.which != t.BACKSPACE) || this._handleClear(n);
                                }),
                                (i.prototype.update = function (t, i) {
                                    t.call(this, i),
                                        0 < this.$selection.find(".select2-selection__placeholder").length ||
                                            0 === i.length ||
                                            ((t = this.options.get("translations").get("removeAllItems")),
                                            (t = e('<span class="select2-selection__clear" title="' + t() + '">&times;</span>')),
                                            n.StoreData(t[0], "data", i),
                                            this.$selection.find(".select2-selection__rendered").prepend(t));
                                }),
                                i
                            );
                        }),
                        v.define("select2/selection/search", ["jquery", "../utils", "../keys"], function (e, t, n) {
                            function i(e, t, n) {
                                e.call(this, t, n);
                            }
                            return (
                                (i.prototype.render = function (t) {
                                    var n = e(
                                        '<li class="select2-search select2-search--inline"><input class="select2-search__field" type="search" tabindex="-1" autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false" role="searchbox" aria-autocomplete="list" /></li>'
                                    );
                                    return (this.$searchContainer = n), (this.$search = n.find("input")), (t = t.call(this)), this._transferTabIndex(), t;
                                }),
                                (i.prototype.bind = function (e, i, o) {
                                    var s = this,
                                        r = i.id + "-results";
                                    e.call(this, i, o),
                                        i.on("open", function () {
                                            s.$search.attr("aria-controls", r), s.$search.trigger("focus");
                                        }),
                                        i.on("close", function () {
                                            s.$search.val(""), s.$search.removeAttr("aria-controls"), s.$search.removeAttr("aria-activedescendant"), s.$search.trigger("focus");
                                        }),
                                        i.on("enable", function () {
                                            s.$search.prop("disabled", !1), s._transferTabIndex();
                                        }),
                                        i.on("disable", function () {
                                            s.$search.prop("disabled", !0);
                                        }),
                                        i.on("focus", function (e) {
                                            s.$search.trigger("focus");
                                        }),
                                        i.on("results:focus", function (e) {
                                            e.data._resultId ? s.$search.attr("aria-activedescendant", e.data._resultId) : s.$search.removeAttr("aria-activedescendant");
                                        }),
                                        this.$selection.on("focusin", ".select2-search--inline", function (e) {
                                            s.trigger("focus", e);
                                        }),
                                        this.$selection.on("focusout", ".select2-search--inline", function (e) {
                                            s._handleBlur(e);
                                        }),
                                        this.$selection.on("keydown", ".select2-search--inline", function (e) {
                                            var i;
                                            e.stopPropagation(),
                                                s.trigger("keypress", e),
                                                (s._keyUpPrevented = e.isDefaultPrevented()),
                                                e.which === n.BACKSPACE &&
                                                    "" === s.$search.val() &&
                                                    0 < (i = s.$searchContainer.prev(".select2-selection__choice")).length &&
                                                    ((i = t.GetData(i[0], "data")), s.searchRemoveChoice(i), e.preventDefault());
                                        }),
                                        this.$selection.on("click", ".select2-search--inline", function (e) {
                                            s.$search.val() && e.stopPropagation();
                                        });
                                    var a = (i = document.documentMode) && i <= 11;
                                    this.$selection.on("input.searchcheck", ".select2-search--inline", function (e) {
                                        a ? s.$selection.off("input.search input.searchcheck") : s.$selection.off("keyup.search");
                                    }),
                                        this.$selection.on("keyup.search input.search", ".select2-search--inline", function (e) {
                                            var t;
                                            a && "input" === e.type ? s.$selection.off("input.search input.searchcheck") : (t = e.which) != n.SHIFT && t != n.CTRL && t != n.ALT && t != n.TAB && s.handleSearch(e);
                                        });
                                }),
                                (i.prototype._transferTabIndex = function (e) {
                                    this.$search.attr("tabindex", this.$selection.attr("tabindex")), this.$selection.attr("tabindex", "-1");
                                }),
                                (i.prototype.createPlaceholder = function (e, t) {
                                    this.$search.attr("placeholder", t.text);
                                }),
                                (i.prototype.update = function (e, t) {
                                    var n = this.$search[0] == document.activeElement;
                                    this.$search.attr("placeholder", ""), e.call(this, t), this.$selection.find(".select2-selection__rendered").append(this.$searchContainer), this.resizeSearch(), n && this.$search.trigger("focus");
                                }),
                                (i.prototype.handleSearch = function () {
                                    var e;
                                    this.resizeSearch(), this._keyUpPrevented || ((e = this.$search.val()), this.trigger("query", { term: e })), (this._keyUpPrevented = !1);
                                }),
                                (i.prototype.searchRemoveChoice = function (e, t) {
                                    this.trigger("unselect", { data: t }), this.$search.val(t.text), this.handleSearch();
                                }),
                                (i.prototype.resizeSearch = function () {
                                    this.$search.css("width", "25px");
                                    var e = "" !== this.$search.attr("placeholder") ? this.$selection.find(".select2-selection__rendered").width() : 0.75 * (this.$search.val().length + 1) + "em";
                                    this.$search.css("width", e);
                                }),
                                i
                            );
                        }),
                        v.define("select2/selection/eventRelay", ["jquery"], function (e) {
                            function t() {}
                            return (
                                (t.prototype.bind = function (t, n, i) {
                                    var o = this,
                                        s = ["open", "opening", "close", "closing", "select", "selecting", "unselect", "unselecting", "clear", "clearing"],
                                        r = ["opening", "closing", "selecting", "unselecting", "clearing"];
                                    t.call(this, n, i),
                                        n.on("*", function (t, n) {
                                            var i;
                                            -1 !== e.inArray(t, s) && ((i = e.Event("select2:" + t, { params: (n = n || {}) })), o.$element.trigger(i), -1 !== e.inArray(t, r) && (n.prevented = i.isDefaultPrevented()));
                                        });
                                }),
                                t
                            );
                        }),
                        v.define("select2/translation", ["jquery", "require"], function (e, t) {
                            function n(e) {
                                this.dict = e || {};
                            }
                            return (
                                (n.prototype.all = function () {
                                    return this.dict;
                                }),
                                (n.prototype.get = function (e) {
                                    return this.dict[e];
                                }),
                                (n.prototype.extend = function (t) {
                                    this.dict = e.extend({}, t.all(), this.dict);
                                }),
                                (n._cache = {}),
                                (n.loadPath = function (e) {
                                    var i;
                                    return e in n._cache || ((i = t(e)), (n._cache[e] = i)), new n(n._cache[e]);
                                }),
                                n
                            );
                        }),
                        v.define("select2/diacritics", [], function () {
                            return {
                                "Ⓐ": "A",
                                Ａ: "A",
                                À: "A",
                                Á: "A",
                                Â: "A",
                                Ầ: "A",
                                Ấ: "A",
                                Ẫ: "A",
                                Ẩ: "A",
                                Ã: "A",
                                Ā: "A",
                                Ă: "A",
                                Ằ: "A",
                                Ắ: "A",
                                Ẵ: "A",
                                Ẳ: "A",
                                Ȧ: "A",
                                Ǡ: "A",
                                Ä: "A",
                                Ǟ: "A",
                                Ả: "A",
                                Å: "A",
                                Ǻ: "A",
                                Ǎ: "A",
                                Ȁ: "A",
                                Ȃ: "A",
                                Ạ: "A",
                                Ậ: "A",
                                Ặ: "A",
                                Ḁ: "A",
                                Ą: "A",
                                Ⱥ: "A",
                                Ɐ: "A",
                                Ꜳ: "AA",
                                Æ: "AE",
                                Ǽ: "AE",
                                Ǣ: "AE",
                                Ꜵ: "AO",
                                Ꜷ: "AU",
                                Ꜹ: "AV",
                                Ꜻ: "AV",
                                Ꜽ: "AY",
                                "Ⓑ": "B",
                                Ｂ: "B",
                                Ḃ: "B",
                                Ḅ: "B",
                                Ḇ: "B",
                                Ƀ: "B",
                                Ƃ: "B",
                                Ɓ: "B",
                                "Ⓒ": "C",
                                Ｃ: "C",
                                Ć: "C",
                                Ĉ: "C",
                                Ċ: "C",
                                Č: "C",
                                Ç: "C",
                                Ḉ: "C",
                                Ƈ: "C",
                                Ȼ: "C",
                                Ꜿ: "C",
                                "Ⓓ": "D",
                                Ｄ: "D",
                                Ḋ: "D",
                                Ď: "D",
                                Ḍ: "D",
                                Ḑ: "D",
                                Ḓ: "D",
                                Ḏ: "D",
                                Đ: "D",
                                Ƌ: "D",
                                Ɗ: "D",
                                Ɖ: "D",
                                Ꝺ: "D",
                                Ǳ: "DZ",
                                Ǆ: "DZ",
                                ǲ: "Dz",
                                ǅ: "Dz",
                                "Ⓔ": "E",
                                Ｅ: "E",
                                È: "E",
                                É: "E",
                                Ê: "E",
                                Ề: "E",
                                Ế: "E",
                                Ễ: "E",
                                Ể: "E",
                                Ẽ: "E",
                                Ē: "E",
                                Ḕ: "E",
                                Ḗ: "E",
                                Ĕ: "E",
                                Ė: "E",
                                Ë: "E",
                                Ẻ: "E",
                                Ě: "E",
                                Ȅ: "E",
                                Ȇ: "E",
                                Ẹ: "E",
                                Ệ: "E",
                                Ȩ: "E",
                                Ḝ: "E",
                                Ę: "E",
                                Ḙ: "E",
                                Ḛ: "E",
                                Ɛ: "E",
                                Ǝ: "E",
                                "Ⓕ": "F",
                                Ｆ: "F",
                                Ḟ: "F",
                                Ƒ: "F",
                                Ꝼ: "F",
                                "Ⓖ": "G",
                                Ｇ: "G",
                                Ǵ: "G",
                                Ĝ: "G",
                                Ḡ: "G",
                                Ğ: "G",
                                Ġ: "G",
                                Ǧ: "G",
                                Ģ: "G",
                                Ǥ: "G",
                                Ɠ: "G",
                                Ꞡ: "G",
                                Ᵹ: "G",
                                Ꝿ: "G",
                                "Ⓗ": "H",
                                Ｈ: "H",
                                Ĥ: "H",
                                Ḣ: "H",
                                Ḧ: "H",
                                Ȟ: "H",
                                Ḥ: "H",
                                Ḩ: "H",
                                Ḫ: "H",
                                Ħ: "H",
                                Ⱨ: "H",
                                Ⱶ: "H",
                                Ɥ: "H",
                                "Ⓘ": "I",
                                Ｉ: "I",
                                Ì: "I",
                                Í: "I",
                                Î: "I",
                                Ĩ: "I",
                                Ī: "I",
                                Ĭ: "I",
                                İ: "I",
                                Ï: "I",
                                Ḯ: "I",
                                Ỉ: "I",
                                Ǐ: "I",
                                Ȉ: "I",
                                Ȋ: "I",
                                Ị: "I",
                                Į: "I",
                                Ḭ: "I",
                                Ɨ: "I",
                                "Ⓙ": "J",
                                Ｊ: "J",
                                Ĵ: "J",
                                Ɉ: "J",
                                "Ⓚ": "K",
                                Ｋ: "K",
                                Ḱ: "K",
                                Ǩ: "K",
                                Ḳ: "K",
                                Ķ: "K",
                                Ḵ: "K",
                                Ƙ: "K",
                                Ⱪ: "K",
                                Ꝁ: "K",
                                Ꝃ: "K",
                                Ꝅ: "K",
                                Ꞣ: "K",
                                "Ⓛ": "L",
                                Ｌ: "L",
                                Ŀ: "L",
                                Ĺ: "L",
                                Ľ: "L",
                                Ḷ: "L",
                                Ḹ: "L",
                                Ļ: "L",
                                Ḽ: "L",
                                Ḻ: "L",
                                Ł: "L",
                                Ƚ: "L",
                                Ɫ: "L",
                                Ⱡ: "L",
                                Ꝉ: "L",
                                Ꝇ: "L",
                                Ꞁ: "L",
                                Ǉ: "LJ",
                                ǈ: "Lj",
                                "Ⓜ": "M",
                                Ｍ: "M",
                                Ḿ: "M",
                                Ṁ: "M",
                                Ṃ: "M",
                                Ɱ: "M",
                                Ɯ: "M",
                                "Ⓝ": "N",
                                Ｎ: "N",
                                Ǹ: "N",
                                Ń: "N",
                                Ñ: "N",
                                Ṅ: "N",
                                Ň: "N",
                                Ṇ: "N",
                                Ņ: "N",
                                Ṋ: "N",
                                Ṉ: "N",
                                Ƞ: "N",
                                Ɲ: "N",
                                Ꞑ: "N",
                                Ꞥ: "N",
                                Ǌ: "NJ",
                                ǋ: "Nj",
                                "Ⓞ": "O",
                                Ｏ: "O",
                                Ò: "O",
                                Ó: "O",
                                Ô: "O",
                                Ồ: "O",
                                Ố: "O",
                                Ỗ: "O",
                                Ổ: "O",
                                Õ: "O",
                                Ṍ: "O",
                                Ȭ: "O",
                                Ṏ: "O",
                                Ō: "O",
                                Ṑ: "O",
                                Ṓ: "O",
                                Ŏ: "O",
                                Ȯ: "O",
                                Ȱ: "O",
                                Ö: "O",
                                Ȫ: "O",
                                Ỏ: "O",
                                Ő: "O",
                                Ǒ: "O",
                                Ȍ: "O",
                                Ȏ: "O",
                                Ơ: "O",
                                Ờ: "O",
                                Ớ: "O",
                                Ỡ: "O",
                                Ở: "O",
                                Ợ: "O",
                                Ọ: "O",
                                Ộ: "O",
                                Ǫ: "O",
                                Ǭ: "O",
                                Ø: "O",
                                Ǿ: "O",
                                Ɔ: "O",
                                Ɵ: "O",
                                Ꝋ: "O",
                                Ꝍ: "O",
                                Œ: "OE",
                                Ƣ: "OI",
                                Ꝏ: "OO",
                                Ȣ: "OU",
                                "Ⓟ": "P",
                                Ｐ: "P",
                                Ṕ: "P",
                                Ṗ: "P",
                                Ƥ: "P",
                                Ᵽ: "P",
                                Ꝑ: "P",
                                Ꝓ: "P",
                                Ꝕ: "P",
                                "Ⓠ": "Q",
                                Ｑ: "Q",
                                Ꝗ: "Q",
                                Ꝙ: "Q",
                                Ɋ: "Q",
                                "Ⓡ": "R",
                                Ｒ: "R",
                                Ŕ: "R",
                                Ṙ: "R",
                                Ř: "R",
                                Ȑ: "R",
                                Ȓ: "R",
                                Ṛ: "R",
                                Ṝ: "R",
                                Ŗ: "R",
                                Ṟ: "R",
                                Ɍ: "R",
                                Ɽ: "R",
                                Ꝛ: "R",
                                Ꞧ: "R",
                                Ꞃ: "R",
                                "Ⓢ": "S",
                                Ｓ: "S",
                                ẞ: "S",
                                Ś: "S",
                                Ṥ: "S",
                                Ŝ: "S",
                                Ṡ: "S",
                                Š: "S",
                                Ṧ: "S",
                                Ṣ: "S",
                                Ṩ: "S",
                                Ș: "S",
                                Ş: "S",
                                Ȿ: "S",
                                Ꞩ: "S",
                                Ꞅ: "S",
                                "Ⓣ": "T",
                                Ｔ: "T",
                                Ṫ: "T",
                                Ť: "T",
                                Ṭ: "T",
                                Ț: "T",
                                Ţ: "T",
                                Ṱ: "T",
                                Ṯ: "T",
                                Ŧ: "T",
                                Ƭ: "T",
                                Ʈ: "T",
                                Ⱦ: "T",
                                Ꞇ: "T",
                                Ꜩ: "TZ",
                                "Ⓤ": "U",
                                Ｕ: "U",
                                Ù: "U",
                                Ú: "U",
                                Û: "U",
                                Ũ: "U",
                                Ṹ: "U",
                                Ū: "U",
                                Ṻ: "U",
                                Ŭ: "U",
                                Ü: "U",
                                Ǜ: "U",
                                Ǘ: "U",
                                Ǖ: "U",
                                Ǚ: "U",
                                Ủ: "U",
                                Ů: "U",
                                Ű: "U",
                                Ǔ: "U",
                                Ȕ: "U",
                                Ȗ: "U",
                                Ư: "U",
                                Ừ: "U",
                                Ứ: "U",
                                Ữ: "U",
                                Ử: "U",
                                Ự: "U",
                                Ụ: "U",
                                Ṳ: "U",
                                Ų: "U",
                                Ṷ: "U",
                                Ṵ: "U",
                                Ʉ: "U",
                                "Ⓥ": "V",
                                Ｖ: "V",
                                Ṽ: "V",
                                Ṿ: "V",
                                Ʋ: "V",
                                Ꝟ: "V",
                                Ʌ: "V",
                                Ꝡ: "VY",
                                "Ⓦ": "W",
                                Ｗ: "W",
                                Ẁ: "W",
                                Ẃ: "W",
                                Ŵ: "W",
                                Ẇ: "W",
                                Ẅ: "W",
                                Ẉ: "W",
                                Ⱳ: "W",
                                "Ⓧ": "X",
                                Ｘ: "X",
                                Ẋ: "X",
                                Ẍ: "X",
                                "Ⓨ": "Y",
                                Ｙ: "Y",
                                Ỳ: "Y",
                                Ý: "Y",
                                Ŷ: "Y",
                                Ỹ: "Y",
                                Ȳ: "Y",
                                Ẏ: "Y",
                                Ÿ: "Y",
                                Ỷ: "Y",
                                Ỵ: "Y",
                                Ƴ: "Y",
                                Ɏ: "Y",
                                Ỿ: "Y",
                                "Ⓩ": "Z",
                                Ｚ: "Z",
                                Ź: "Z",
                                Ẑ: "Z",
                                Ż: "Z",
                                Ž: "Z",
                                Ẓ: "Z",
                                Ẕ: "Z",
                                Ƶ: "Z",
                                Ȥ: "Z",
                                Ɀ: "Z",
                                Ⱬ: "Z",
                                Ꝣ: "Z",
                                "ⓐ": "a",
                                ａ: "a",
                                ẚ: "a",
                                à: "a",
                                á: "a",
                                â: "a",
                                ầ: "a",
                                ấ: "a",
                                ẫ: "a",
                                ẩ: "a",
                                ã: "a",
                                ā: "a",
                                ă: "a",
                                ằ: "a",
                                ắ: "a",
                                ẵ: "a",
                                ẳ: "a",
                                ȧ: "a",
                                ǡ: "a",
                                ä: "a",
                                ǟ: "a",
                                ả: "a",
                                å: "a",
                                ǻ: "a",
                                ǎ: "a",
                                ȁ: "a",
                                ȃ: "a",
                                ạ: "a",
                                ậ: "a",
                                ặ: "a",
                                ḁ: "a",
                                ą: "a",
                                ⱥ: "a",
                                ɐ: "a",
                                ꜳ: "aa",
                                æ: "ae",
                                ǽ: "ae",
                                ǣ: "ae",
                                ꜵ: "ao",
                                ꜷ: "au",
                                ꜹ: "av",
                                ꜻ: "av",
                                ꜽ: "ay",
                                "ⓑ": "b",
                                ｂ: "b",
                                ḃ: "b",
                                ḅ: "b",
                                ḇ: "b",
                                ƀ: "b",
                                ƃ: "b",
                                ɓ: "b",
                                "ⓒ": "c",
                                ｃ: "c",
                                ć: "c",
                                ĉ: "c",
                                ċ: "c",
                                č: "c",
                                ç: "c",
                                ḉ: "c",
                                ƈ: "c",
                                ȼ: "c",
                                ꜿ: "c",
                                ↄ: "c",
                                "ⓓ": "d",
                                ｄ: "d",
                                ḋ: "d",
                                ď: "d",
                                ḍ: "d",
                                ḑ: "d",
                                ḓ: "d",
                                ḏ: "d",
                                đ: "d",
                                ƌ: "d",
                                ɖ: "d",
                                ɗ: "d",
                                ꝺ: "d",
                                ǳ: "dz",
                                ǆ: "dz",
                                "ⓔ": "e",
                                ｅ: "e",
                                è: "e",
                                é: "e",
                                ê: "e",
                                ề: "e",
                                ế: "e",
                                ễ: "e",
                                ể: "e",
                                ẽ: "e",
                                ē: "e",
                                ḕ: "e",
                                ḗ: "e",
                                ĕ: "e",
                                ė: "e",
                                ë: "e",
                                ẻ: "e",
                                ě: "e",
                                ȅ: "e",
                                ȇ: "e",
                                ẹ: "e",
                                ệ: "e",
                                ȩ: "e",
                                ḝ: "e",
                                ę: "e",
                                ḙ: "e",
                                ḛ: "e",
                                ɇ: "e",
                                ɛ: "e",
                                ǝ: "e",
                                "ⓕ": "f",
                                ｆ: "f",
                                ḟ: "f",
                                ƒ: "f",
                                ꝼ: "f",
                                "ⓖ": "g",
                                ｇ: "g",
                                ǵ: "g",
                                ĝ: "g",
                                ḡ: "g",
                                ğ: "g",
                                ġ: "g",
                                ǧ: "g",
                                ģ: "g",
                                ǥ: "g",
                                ɠ: "g",
                                ꞡ: "g",
                                ᵹ: "g",
                                ꝿ: "g",
                                "ⓗ": "h",
                                ｈ: "h",
                                ĥ: "h",
                                ḣ: "h",
                                ḧ: "h",
                                ȟ: "h",
                                ḥ: "h",
                                ḩ: "h",
                                ḫ: "h",
                                ẖ: "h",
                                ħ: "h",
                                ⱨ: "h",
                                ⱶ: "h",
                                ɥ: "h",
                                ƕ: "hv",
                                "ⓘ": "i",
                                ｉ: "i",
                                ì: "i",
                                í: "i",
                                î: "i",
                                ĩ: "i",
                                ī: "i",
                                ĭ: "i",
                                ï: "i",
                                ḯ: "i",
                                ỉ: "i",
                                ǐ: "i",
                                ȉ: "i",
                                ȋ: "i",
                                ị: "i",
                                į: "i",
                                ḭ: "i",
                                ɨ: "i",
                                ı: "i",
                                "ⓙ": "j",
                                ｊ: "j",
                                ĵ: "j",
                                ǰ: "j",
                                ɉ: "j",
                                "ⓚ": "k",
                                ｋ: "k",
                                ḱ: "k",
                                ǩ: "k",
                                ḳ: "k",
                                ķ: "k",
                                ḵ: "k",
                                ƙ: "k",
                                ⱪ: "k",
                                ꝁ: "k",
                                ꝃ: "k",
                                ꝅ: "k",
                                ꞣ: "k",
                                "ⓛ": "l",
                                ｌ: "l",
                                ŀ: "l",
                                ĺ: "l",
                                ľ: "l",
                                ḷ: "l",
                                ḹ: "l",
                                ļ: "l",
                                ḽ: "l",
                                ḻ: "l",
                                ſ: "l",
                                ł: "l",
                                ƚ: "l",
                                ɫ: "l",
                                ⱡ: "l",
                                ꝉ: "l",
                                ꞁ: "l",
                                ꝇ: "l",
                                ǉ: "lj",
                                "ⓜ": "m",
                                ｍ: "m",
                                ḿ: "m",
                                ṁ: "m",
                                ṃ: "m",
                                ɱ: "m",
                                ɯ: "m",
                                "ⓝ": "n",
                                ｎ: "n",
                                ǹ: "n",
                                ń: "n",
                                ñ: "n",
                                ṅ: "n",
                                ň: "n",
                                ṇ: "n",
                                ņ: "n",
                                ṋ: "n",
                                ṉ: "n",
                                ƞ: "n",
                                ɲ: "n",
                                ŉ: "n",
                                ꞑ: "n",
                                ꞥ: "n",
                                ǌ: "nj",
                                "ⓞ": "o",
                                ｏ: "o",
                                ò: "o",
                                ó: "o",
                                ô: "o",
                                ồ: "o",
                                ố: "o",
                                ỗ: "o",
                                ổ: "o",
                                õ: "o",
                                ṍ: "o",
                                ȭ: "o",
                                ṏ: "o",
                                ō: "o",
                                ṑ: "o",
                                ṓ: "o",
                                ŏ: "o",
                                ȯ: "o",
                                ȱ: "o",
                                ö: "o",
                                ȫ: "o",
                                ỏ: "o",
                                ő: "o",
                                ǒ: "o",
                                ȍ: "o",
                                ȏ: "o",
                                ơ: "o",
                                ờ: "o",
                                ớ: "o",
                                ỡ: "o",
                                ở: "o",
                                ợ: "o",
                                ọ: "o",
                                ộ: "o",
                                ǫ: "o",
                                ǭ: "o",
                                ø: "o",
                                ǿ: "o",
                                ɔ: "o",
                                ꝋ: "o",
                                ꝍ: "o",
                                ɵ: "o",
                                œ: "oe",
                                ƣ: "oi",
                                ȣ: "ou",
                                ꝏ: "oo",
                                "ⓟ": "p",
                                ｐ: "p",
                                ṕ: "p",
                                ṗ: "p",
                                ƥ: "p",
                                ᵽ: "p",
                                ꝑ: "p",
                                ꝓ: "p",
                                ꝕ: "p",
                                "ⓠ": "q",
                                ｑ: "q",
                                ɋ: "q",
                                ꝗ: "q",
                                ꝙ: "q",
                                "ⓡ": "r",
                                ｒ: "r",
                                ŕ: "r",
                                ṙ: "r",
                                ř: "r",
                                ȑ: "r",
                                ȓ: "r",
                                ṛ: "r",
                                ṝ: "r",
                                ŗ: "r",
                                ṟ: "r",
                                ɍ: "r",
                                ɽ: "r",
                                ꝛ: "r",
                                ꞧ: "r",
                                ꞃ: "r",
                                "ⓢ": "s",
                                ｓ: "s",
                                ß: "s",
                                ś: "s",
                                ṥ: "s",
                                ŝ: "s",
                                ṡ: "s",
                                š: "s",
                                ṧ: "s",
                                ṣ: "s",
                                ṩ: "s",
                                ș: "s",
                                ş: "s",
                                ȿ: "s",
                                ꞩ: "s",
                                ꞅ: "s",
                                ẛ: "s",
                                "ⓣ": "t",
                                ｔ: "t",
                                ṫ: "t",
                                ẗ: "t",
                                ť: "t",
                                ṭ: "t",
                                ț: "t",
                                ţ: "t",
                                ṱ: "t",
                                ṯ: "t",
                                ŧ: "t",
                                ƭ: "t",
                                ʈ: "t",
                                ⱦ: "t",
                                ꞇ: "t",
                                ꜩ: "tz",
                                "ⓤ": "u",
                                ｕ: "u",
                                ù: "u",
                                ú: "u",
                                û: "u",
                                ũ: "u",
                                ṹ: "u",
                                ū: "u",
                                ṻ: "u",
                                ŭ: "u",
                                ü: "u",
                                ǜ: "u",
                                ǘ: "u",
                                ǖ: "u",
                                ǚ: "u",
                                ủ: "u",
                                ů: "u",
                                ű: "u",
                                ǔ: "u",
                                ȕ: "u",
                                ȗ: "u",
                                ư: "u",
                                ừ: "u",
                                ứ: "u",
                                ữ: "u",
                                ử: "u",
                                ự: "u",
                                ụ: "u",
                                ṳ: "u",
                                ų: "u",
                                ṷ: "u",
                                ṵ: "u",
                                ʉ: "u",
                                "ⓥ": "v",
                                ｖ: "v",
                                ṽ: "v",
                                ṿ: "v",
                                ʋ: "v",
                                ꝟ: "v",
                                ʌ: "v",
                                ꝡ: "vy",
                                "ⓦ": "w",
                                ｗ: "w",
                                ẁ: "w",
                                ẃ: "w",
                                ŵ: "w",
                                ẇ: "w",
                                ẅ: "w",
                                ẘ: "w",
                                ẉ: "w",
                                ⱳ: "w",
                                "ⓧ": "x",
                                ｘ: "x",
                                ẋ: "x",
                                ẍ: "x",
                                "ⓨ": "y",
                                ｙ: "y",
                                ỳ: "y",
                                ý: "y",
                                ŷ: "y",
                                ỹ: "y",
                                ȳ: "y",
                                ẏ: "y",
                                ÿ: "y",
                                ỷ: "y",
                                ẙ: "y",
                                ỵ: "y",
                                ƴ: "y",
                                ɏ: "y",
                                ỿ: "y",
                                "ⓩ": "z",
                                ｚ: "z",
                                ź: "z",
                                ẑ: "z",
                                ż: "z",
                                ž: "z",
                                ẓ: "z",
                                ẕ: "z",
                                ƶ: "z",
                                ȥ: "z",
                                ɀ: "z",
                                ⱬ: "z",
                                ꝣ: "z",
                                Ά: "Α",
                                Έ: "Ε",
                                Ή: "Η",
                                Ί: "Ι",
                                Ϊ: "Ι",
                                Ό: "Ο",
                                Ύ: "Υ",
                                Ϋ: "Υ",
                                Ώ: "Ω",
                                ά: "α",
                                έ: "ε",
                                ή: "η",
                                ί: "ι",
                                ϊ: "ι",
                                ΐ: "ι",
                                ό: "ο",
                                ύ: "υ",
                                ϋ: "υ",
                                ΰ: "υ",
                                ώ: "ω",
                                ς: "σ",
                                "’": "'",
                            };
                        }),
                        v.define("select2/data/base", ["../utils"], function (e) {
                            function t(e, n) {
                                t.__super__.constructor.call(this);
                            }
                            return (
                                e.Extend(t, e.Observable),
                                (t.prototype.current = function (e) {
                                    throw new Error("The `current` method must be defined in child classes.");
                                }),
                                (t.prototype.query = function (e, t) {
                                    throw new Error("The `query` method must be defined in child classes.");
                                }),
                                (t.prototype.bind = function (e, t) {}),
                                (t.prototype.destroy = function () {}),
                                (t.prototype.generateResultId = function (t, n) {
                                    return (t = t.id + "-result-"), (t += e.generateChars(4)), null != n.id ? (t += "-" + n.id.toString()) : (t += "-" + e.generateChars(4)), t;
                                }),
                                t
                            );
                        }),
                        v.define("select2/data/select", ["./base", "../utils", "jquery"], function (e, t, n) {
                            function i(e, t) {
                                (this.$element = e), (this.options = t), i.__super__.constructor.call(this);
                            }
                            return (
                                t.Extend(i, e),
                                (i.prototype.current = function (e) {
                                    var t = [],
                                        i = this;
                                    this.$element.find(":selected").each(function () {
                                        var e = n(this);
                                        (e = i.item(e)), t.push(e);
                                    }),
                                        e(t);
                                }),
                                (i.prototype.select = function (e) {
                                    var t,
                                        i = this;
                                    if (((e.selected = !0), n(e.element).is("option"))) return (e.element.selected = !0), void this.$element.trigger("change");
                                    this.$element.prop("multiple")
                                        ? this.current(function (t) {
                                              var o = [];
                                              (e = [e]).push.apply(e, t);
                                              for (var s = 0; s < e.length; s++) {
                                                  var r = e[s].id;
                                                  -1 === n.inArray(r, o) && o.push(r);
                                              }
                                              i.$element.val(o), i.$element.trigger("change");
                                          })
                                        : ((t = e.id), this.$element.val(t), this.$element.trigger("change"));
                                }),
                                (i.prototype.unselect = function (e) {
                                    var t = this;
                                    if (this.$element.prop("multiple")) {
                                        if (((e.selected = !1), n(e.element).is("option"))) return (e.element.selected = !1), void this.$element.trigger("change");
                                        this.current(function (i) {
                                            for (var o = [], s = 0; s < i.length; s++) {
                                                var r = i[s].id;
                                                r !== e.id && -1 === n.inArray(r, o) && o.push(r);
                                            }
                                            t.$element.val(o), t.$element.trigger("change");
                                        });
                                    }
                                }),
                                (i.prototype.bind = function (e, t) {
                                    var n = this;
                                    (this.container = e).on("select", function (e) {
                                        n.select(e.data);
                                    }),
                                        e.on("unselect", function (e) {
                                            n.unselect(e.data);
                                        });
                                }),
                                (i.prototype.destroy = function () {
                                    this.$element.find("*").each(function () {
                                        t.RemoveData(this);
                                    });
                                }),
                                (i.prototype.query = function (e, t) {
                                    var i = [],
                                        o = this;
                                    this.$element.children().each(function () {
                                        var t = n(this);
                                        (t.is("option") || t.is("optgroup")) && ((t = o.item(t)), null !== (t = o.matches(e, t)) && i.push(t));
                                    }),
                                        t({ results: i });
                                }),
                                (i.prototype.addOptions = function (e) {
                                    t.appendMany(this.$element, e);
                                }),
                                (i.prototype.option = function (e) {
                                    var i;
                                    e.children ? ((i = document.createElement("optgroup")).label = e.text) : void 0 !== (i = document.createElement("option")).textContent ? (i.textContent = e.text) : (i.innerText = e.text),
                                        void 0 !== e.id && (i.value = e.id),
                                        e.disabled && (i.disabled = !0),
                                        e.selected && (i.selected = !0),
                                        e.title && (i.title = e.title);
                                    var o = n(i);
                                    return ((e = this._normalizeItem(e)).element = i), t.StoreData(i, "data", e), o;
                                }),
                                (i.prototype.item = function (e) {
                                    var i = {};
                                    if (null != (i = t.GetData(e[0], "data"))) return i;
                                    if (e.is("option")) i = { id: e.val(), text: e.text(), disabled: e.prop("disabled"), selected: e.prop("selected"), title: e.prop("title") };
                                    else if (e.is("optgroup")) {
                                        i = { text: e.prop("label"), children: [], title: e.prop("title") };
                                        for (var o = e.children("option"), s = [], r = 0; r < o.length; r++) {
                                            var a = n(o[r]);
                                            (a = this.item(a)), s.push(a);
                                        }
                                        i.children = s;
                                    }
                                    return ((i = this._normalizeItem(i)).element = e[0]), t.StoreData(e[0], "data", i), i;
                                }),
                                (i.prototype._normalizeItem = function (e) {
                                    return (
                                        e !== Object(e) && (e = { id: e, text: e }),
                                        null != (e = n.extend({}, { text: "" }, e)).id && (e.id = e.id.toString()),
                                        null != e.text && (e.text = e.text.toString()),
                                        null == e._resultId && e.id && null != this.container && (e._resultId = this.generateResultId(this.container, e)),
                                        n.extend({}, { selected: !1, disabled: !1 }, e)
                                    );
                                }),
                                (i.prototype.matches = function (e, t) {
                                    return this.options.get("matcher")(e, t);
                                }),
                                i
                            );
                        }),
                        v.define("select2/data/array", ["./select", "../utils", "jquery"], function (e, t, n) {
                            function i(e, t) {
                                (this._dataToConvert = t.get("data") || []), i.__super__.constructor.call(this, e, t);
                            }
                            return (
                                t.Extend(i, e),
                                (i.prototype.bind = function (e, t) {
                                    i.__super__.bind.call(this, e, t), this.addOptions(this.convertToOptions(this._dataToConvert));
                                }),
                                (i.prototype.select = function (e) {
                                    var t = this.$element.find("option").filter(function (t, n) {
                                        return n.value == e.id.toString();
                                    });
                                    0 === t.length && ((t = this.option(e)), this.addOptions(t)), i.__super__.select.call(this, e);
                                }),
                                (i.prototype.convertToOptions = function (e) {
                                    for (
                                        var i = this,
                                            o = this.$element.find("option"),
                                            s = o
                                                .map(function () {
                                                    return i.item(n(this)).id;
                                                })
                                                .get(),
                                            r = [],
                                            a = 0;
                                        a < e.length;
                                        a++
                                    ) {
                                        var l,
                                            c,
                                            d = this._normalizeItem(e[a]);
                                        0 <= n.inArray(d.id, s)
                                            ? ((l = o.filter(
                                                  (function (e) {
                                                      return function () {
                                                          return n(this).val() == e.id;
                                                      };
                                                  })(d)
                                              )),
                                              (c = this.item(l)),
                                              (c = n.extend(!0, {}, d, c)),
                                              (c = this.option(c)),
                                              l.replaceWith(c))
                                            : ((c = this.option(d)), d.children && ((d = this.convertToOptions(d.children)), t.appendMany(c, d)), r.push(c));
                                    }
                                    return r;
                                }),
                                i
                            );
                        }),
                        v.define("select2/data/ajax", ["./array", "../utils", "jquery"], function (e, t, n) {
                            function i(e, t) {
                                (this.ajaxOptions = this._applyDefaults(t.get("ajax"))), null != this.ajaxOptions.processResults && (this.processResults = this.ajaxOptions.processResults), i.__super__.constructor.call(this, e, t);
                            }
                            return (
                                t.Extend(i, e),
                                (i.prototype._applyDefaults = function (e) {
                                    var t = {
                                        data: function (e) {
                                            return n.extend({}, e, { q: e.term });
                                        },
                                        transport: function (e, t, i) {
                                            return (e = n.ajax(e)).then(t), e.fail(i), e;
                                        },
                                    };
                                    return n.extend({}, t, e, !0);
                                }),
                                (i.prototype.processResults = function (e) {
                                    return e;
                                }),
                                (i.prototype.query = function (e, t) {
                                    var i = this;
                                    null != this._request && (n.isFunction(this._request.abort) && this._request.abort(), (this._request = null));
                                    var o = n.extend({ type: "GET" }, this.ajaxOptions);
                                    function s() {
                                        var s = o.transport(
                                            o,
                                            function (o) {
                                                (o = i.processResults(o, e)),
                                                    i.options.get("debug") &&
                                                        window.console &&
                                                        console.error &&
                                                        ((o && o.results && n.isArray(o.results)) || console.error("Select2: The AJAX results did not return an array in the `results` key of the response.")),
                                                    t(o);
                                            },
                                            function () {
                                                ("status" in s && (0 === s.status || "0" === s.status)) || i.trigger("results:message", { message: "errorLoading" });
                                            }
                                        );
                                        i._request = s;
                                    }
                                    "function" == typeof o.url && (o.url = o.url.call(this.$element, e)),
                                        "function" == typeof o.data && (o.data = o.data.call(this.$element, e)),
                                        this.ajaxOptions.delay && null != e.term ? (this._queryTimeout && window.clearTimeout(this._queryTimeout), (this._queryTimeout = window.setTimeout(s, this.ajaxOptions.delay))) : s();
                                }),
                                i
                            );
                        }),
                        v.define("select2/data/tags", ["jquery"], function (e) {
                            function t(t, n, i) {
                                var o = i.get("tags"),
                                    s = i.get("createTag");
                                if ((void 0 !== s && (this.createTag = s), void 0 !== (s = i.get("insertTag")) && (this.insertTag = s), t.call(this, n, i), e.isArray(o)))
                                    for (var r = 0; r < o.length; r++) {
                                        var a = o[r];
                                        (a = this._normalizeItem(a)), (a = this.option(a)), this.$element.append(a);
                                    }
                            }
                            return (
                                (t.prototype.query = function (e, t, n) {
                                    var i = this;
                                    this._removeOldTags(),
                                        null != t.term && null == t.page
                                            ? e.call(this, t, function e(o, s) {
                                                  for (var r = o.results, a = 0; a < r.length; a++) {
                                                      var l = r[a],
                                                          c = null != l.children && !e({ results: l.children }, !0);
                                                      if ((l.text || "").toUpperCase() === (t.term || "").toUpperCase() || c) return !s && ((o.data = r), void n(o));
                                                  }
                                                  if (s) return !0;
                                                  var d,
                                                      u = i.createTag(t);
                                                  null != u && ((d = i.option(u)).attr("data-select2-tag", !0), i.addOptions([d]), i.insertTag(r, u)), (o.results = r), n(o);
                                              })
                                            : e.call(this, t, n);
                                }),
                                (t.prototype.createTag = function (t, n) {
                                    return "" === (n = e.trim(n.term)) ? null : { id: n, text: n };
                                }),
                                (t.prototype.insertTag = function (e, t, n) {
                                    t.unshift(n);
                                }),
                                (t.prototype._removeOldTags = function (t) {
                                    this.$element.find("option[data-select2-tag]").each(function () {
                                        this.selected || e(this).remove();
                                    });
                                }),
                                t
                            );
                        }),
                        v.define("select2/data/tokenizer", ["jquery"], function (e) {
                            function t(e, t, n) {
                                var i = n.get("tokenizer");
                                void 0 !== i && (this.tokenizer = i), e.call(this, t, n);
                            }
                            return (
                                (t.prototype.bind = function (e, t, n) {
                                    e.call(this, t, n), (this.$search = t.dropdown.$search || t.selection.$search || n.find(".select2-search__field"));
                                }),
                                (t.prototype.query = function (t, n, i) {
                                    var o = this;
                                    n.term = n.term || "";
                                    var s = this.tokenizer(n, this.options, function (t) {
                                        var n = o._normalizeItem(t);
                                        o.$element.find("option").filter(function () {
                                            return e(this).val() === n.id;
                                        }).length || ((t = o.option(n)).attr("data-select2-tag", !0), o._removeOldTags(), o.addOptions([t])),
                                            o.trigger("select", { data: n });
                                    });
                                    s.term !== n.term && (this.$search.length && (this.$search.val(s.term), this.$search.trigger("focus")), (n.term = s.term)), t.call(this, n, i);
                                }),
                                (t.prototype.tokenizer = function (t, n, i, o) {
                                    for (
                                        var s = i.get("tokenSeparators") || [],
                                            r = n.term,
                                            a = 0,
                                            l =
                                                this.createTag ||
                                                function (e) {
                                                    return { id: e.term, text: e.term };
                                                };
                                        a < r.length;

                                    ) {
                                        var c = r[a];
                                        -1 !== e.inArray(c, s) ? ((c = r.substr(0, a)), null != (c = l(e.extend({}, n, { term: c }))) ? (o(c), (r = r.substr(a + 1) || ""), (a = 0)) : a++) : a++;
                                    }
                                    return { term: r };
                                }),
                                t
                            );
                        }),
                        v.define("select2/data/minimumInputLength", [], function () {
                            function e(e, t, n) {
                                (this.minimumInputLength = n.get("minimumInputLength")), e.call(this, t, n);
                            }
                            return (
                                (e.prototype.query = function (e, t, n) {
                                    (t.term = t.term || ""),
                                        t.term.length < this.minimumInputLength ? this.trigger("results:message", { message: "inputTooShort", args: { minimum: this.minimumInputLength, input: t.term, params: t } }) : e.call(this, t, n);
                                }),
                                e
                            );
                        }),
                        v.define("select2/data/maximumInputLength", [], function () {
                            function e(e, t, n) {
                                (this.maximumInputLength = n.get("maximumInputLength")), e.call(this, t, n);
                            }
                            return (
                                (e.prototype.query = function (e, t, n) {
                                    (t.term = t.term || ""),
                                        0 < this.maximumInputLength && t.term.length > this.maximumInputLength
                                            ? this.trigger("results:message", { message: "inputTooLong", args: { maximum: this.maximumInputLength, input: t.term, params: t } })
                                            : e.call(this, t, n);
                                }),
                                e
                            );
                        }),
                        v.define("select2/data/maximumSelectionLength", [], function () {
                            function e(e, t, n) {
                                (this.maximumSelectionLength = n.get("maximumSelectionLength")), e.call(this, t, n);
                            }
                            return (
                                (e.prototype.bind = function (e, t, n) {
                                    var i = this;
                                    e.call(this, t, n),
                                        t.on("select", function () {
                                            i._checkIfMaximumSelected();
                                        });
                                }),
                                (e.prototype.query = function (e, t, n) {
                                    var i = this;
                                    this._checkIfMaximumSelected(function () {
                                        e.call(i, t, n);
                                    });
                                }),
                                (e.prototype._checkIfMaximumSelected = function (e, t) {
                                    var n = this;
                                    this.current(function (e) {
                                        (e = null != e ? e.length : 0),
                                            0 < n.maximumSelectionLength && e >= n.maximumSelectionLength ? n.trigger("results:message", { message: "maximumSelected", args: { maximum: n.maximumSelectionLength } }) : t && t();
                                    });
                                }),
                                e
                            );
                        }),
                        v.define("select2/dropdown", ["jquery", "./utils"], function (e, t) {
                            function n(e, t) {
                                (this.$element = e), (this.options = t), n.__super__.constructor.call(this);
                            }
                            return (
                                t.Extend(n, t.Observable),
                                (n.prototype.render = function () {
                                    var t = e('<span class="select2-dropdown"><span class="select2-results"></span></span>');
                                    return t.attr("dir", this.options.get("dir")), (this.$dropdown = t);
                                }),
                                (n.prototype.bind = function () {}),
                                (n.prototype.position = function (e, t) {}),
                                (n.prototype.destroy = function () {
                                    this.$dropdown.remove();
                                }),
                                n
                            );
                        }),
                        v.define("select2/dropdown/search", ["jquery", "../utils"], function (e, t) {
                            function n() {}
                            return (
                                (n.prototype.render = function (t) {
                                    var n = t.call(this);
                                    return (
                                        (t = e(
                                            '<span class="select2-search select2-search--dropdown"><input class="select2-search__field" type="search" tabindex="-1" autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false" role="searchbox" aria-autocomplete="list" /></span>'
                                        )),
                                        (this.$searchContainer = t),
                                        (this.$search = t.find("input")),
                                        n.prepend(t),
                                        n
                                    );
                                }),
                                (n.prototype.bind = function (t, n, i) {
                                    var o = this,
                                        s = n.id + "-results";
                                    t.call(this, n, i),
                                        this.$search.on("keydown", function (e) {
                                            o.trigger("keypress", e), (o._keyUpPrevented = e.isDefaultPrevented());
                                        }),
                                        this.$search.on("input", function (t) {
                                            e(this).off("keyup");
                                        }),
                                        this.$search.on("keyup input", function (e) {
                                            o.handleSearch(e);
                                        }),
                                        n.on("open", function () {
                                            o.$search.attr("tabindex", 0),
                                                o.$search.attr("aria-controls", s),
                                                o.$search.trigger("focus"),
                                                window.setTimeout(function () {
                                                    o.$search.trigger("focus");
                                                }, 0);
                                        }),
                                        n.on("close", function () {
                                            o.$search.attr("tabindex", -1), o.$search.removeAttr("aria-controls"), o.$search.removeAttr("aria-activedescendant"), o.$search.val(""), o.$search.trigger("blur");
                                        }),
                                        n.on("focus", function () {
                                            n.isOpen() || o.$search.trigger("focus");
                                        }),
                                        n.on("results:all", function (e) {
                                            (null != e.query.term && "" !== e.query.term) || (o.showSearch(e) ? o.$searchContainer.removeClass("select2-search--hide") : o.$searchContainer.addClass("select2-search--hide"));
                                        }),
                                        n.on("results:focus", function (e) {
                                            e.data._resultId ? o.$search.attr("aria-activedescendant", e.data._resultId) : o.$search.removeAttr("aria-activedescendant");
                                        });
                                }),
                                (n.prototype.handleSearch = function (e) {
                                    var t;
                                    this._keyUpPrevented || ((t = this.$search.val()), this.trigger("query", { term: t })), (this._keyUpPrevented = !1);
                                }),
                                (n.prototype.showSearch = function (e, t) {
                                    return !0;
                                }),
                                n
                            );
                        }),
                        v.define("select2/dropdown/hidePlaceholder", [], function () {
                            function e(e, t, n, i) {
                                (this.placeholder = this.normalizePlaceholder(n.get("placeholder"))), e.call(this, t, n, i);
                            }
                            return (
                                (e.prototype.append = function (e, t) {
                                    (t.results = this.removePlaceholder(t.results)), e.call(this, t);
                                }),
                                (e.prototype.normalizePlaceholder = function (e, t) {
                                    return "string" == typeof t ? { id: "", text: t } : t;
                                }),
                                (e.prototype.removePlaceholder = function (e, t) {
                                    for (var n = t.slice(0), i = t.length - 1; 0 <= i; i--) {
                                        var o = t[i];
                                        this.placeholder.id === o.id && n.splice(i, 1);
                                    }
                                    return n;
                                }),
                                e
                            );
                        }),
                        v.define("select2/dropdown/infiniteScroll", ["jquery"], function (e) {
                            function t(e, t, n, i) {
                                (this.lastParams = {}), e.call(this, t, n, i), (this.$loadingMore = this.createLoadingMore()), (this.loading = !1);
                            }
                            return (
                                (t.prototype.append = function (e, t) {
                                    this.$loadingMore.remove(), (this.loading = !1), e.call(this, t), this.showLoadingMore(t) && (this.$results.append(this.$loadingMore), this.loadMoreIfNeeded());
                                }),
                                (t.prototype.bind = function (e, t, n) {
                                    var i = this;
                                    e.call(this, t, n),
                                        t.on("query", function (e) {
                                            (i.lastParams = e), (i.loading = !0);
                                        }),
                                        t.on("query:append", function (e) {
                                            (i.lastParams = e), (i.loading = !0);
                                        }),
                                        this.$results.on("scroll", this.loadMoreIfNeeded.bind(this));
                                }),
                                (t.prototype.loadMoreIfNeeded = function () {
                                    var t = e.contains(document.documentElement, this.$loadingMore[0]);
                                    !this.loading && t && ((t = this.$results.offset().top + this.$results.outerHeight(!1)), this.$loadingMore.offset().top + this.$loadingMore.outerHeight(!1) <= t + 50 && this.loadMore());
                                }),
                                (t.prototype.loadMore = function () {
                                    this.loading = !0;
                                    var t = e.extend({}, { page: 1 }, this.lastParams);
                                    t.page++, this.trigger("query:append", t);
                                }),
                                (t.prototype.showLoadingMore = function (e, t) {
                                    return t.pagination && t.pagination.more;
                                }),
                                (t.prototype.createLoadingMore = function () {
                                    var t = e('<li class="select2-results__option select2-results__option--load-more"role="option" aria-disabled="true"></li>'),
                                        n = this.options.get("translations").get("loadingMore");
                                    return t.html(n(this.lastParams)), t;
                                }),
                                t
                            );
                        }),
                        v.define("select2/dropdown/attachBody", ["jquery", "../utils"], function (e, t) {
                            function n(t, n, i) {
                                (this.$dropdownParent = e(i.get("dropdownParent") || document.body)), t.call(this, n, i);
                            }
                            return (
                                (n.prototype.bind = function (e, t, n) {
                                    var i = this;
                                    e.call(this, t, n),
                                        t.on("open", function () {
                                            i._showDropdown(), i._attachPositioningHandler(t), i._bindContainerResultHandlers(t);
                                        }),
                                        t.on("close", function () {
                                            i._hideDropdown(), i._detachPositioningHandler(t);
                                        }),
                                        this.$dropdownContainer.on("mousedown", function (e) {
                                            e.stopPropagation();
                                        });
                                }),
                                (n.prototype.destroy = function (e) {
                                    e.call(this), this.$dropdownContainer.remove();
                                }),
                                (n.prototype.position = function (e, t, n) {
                                    t.attr("class", n.attr("class")), t.removeClass("select2"), t.addClass("select2-container--open"), t.css({ position: "absolute", top: -999999 }), (this.$container = n);
                                }),
                                (n.prototype.render = function (t) {
                                    var n = e("<span></span>");
                                    return (t = t.call(this)), n.append(t), (this.$dropdownContainer = n);
                                }),
                                (n.prototype._hideDropdown = function (e) {
                                    this.$dropdownContainer.detach();
                                }),
                                (n.prototype._bindContainerResultHandlers = function (e, t) {
                                    var n;
                                    this._containerResultsHandlersBound ||
                                        ((n = this),
                                        t.on("results:all", function () {
                                            n._positionDropdown(), n._resizeDropdown();
                                        }),
                                        t.on("results:append", function () {
                                            n._positionDropdown(), n._resizeDropdown();
                                        }),
                                        t.on("results:message", function () {
                                            n._positionDropdown(), n._resizeDropdown();
                                        }),
                                        t.on("select", function () {
                                            n._positionDropdown(), n._resizeDropdown();
                                        }),
                                        t.on("unselect", function () {
                                            n._positionDropdown(), n._resizeDropdown();
                                        }),
                                        (this._containerResultsHandlersBound = !0));
                                }),
                                (n.prototype._attachPositioningHandler = function (n, i) {
                                    var o = this,
                                        s = "scroll.select2." + i.id,
                                        r = "resize.select2." + i.id,
                                        a = "orientationchange.select2." + i.id;
                                    (i = this.$container.parents().filter(t.hasScroll)).each(function () {
                                        t.StoreData(this, "select2-scroll-position", { x: e(this).scrollLeft(), y: e(this).scrollTop() });
                                    }),
                                        i.on(s, function (n) {
                                            var i = t.GetData(this, "select2-scroll-position");
                                            e(this).scrollTop(i.y);
                                        }),
                                        e(window).on(s + " " + r + " " + a, function (e) {
                                            o._positionDropdown(), o._resizeDropdown();
                                        });
                                }),
                                (n.prototype._detachPositioningHandler = function (n, i) {
                                    var o = "scroll.select2." + i.id,
                                        s = "resize.select2." + i.id;
                                    (i = "orientationchange.select2." + i.id), this.$container.parents().filter(t.hasScroll).off(o), e(window).off(o + " " + s + " " + i);
                                }),
                                (n.prototype._positionDropdown = function () {
                                    var t = e(window),
                                        n = this.$dropdown.hasClass("select2-dropdown--above"),
                                        i = this.$dropdown.hasClass("select2-dropdown--below"),
                                        o = null,
                                        s = this.$container.offset();
                                    s.bottom = s.top + this.$container.outerHeight(!1);
                                    var r = { height: this.$container.outerHeight(!1) };
                                    (r.top = s.top), (r.bottom = s.top + r.height);
                                    var a = this.$dropdown.outerHeight(!1),
                                        l = t.scrollTop(),
                                        c = t.scrollTop() + t.height(),
                                        d = l < s.top - a;
                                    (t = c > s.bottom + a),
                                        (l = { left: s.left, top: r.bottom }),
                                        "static" === (c = this.$dropdownParent).css("position") && (c = c.offsetParent()),
                                        (s = { top: 0, left: 0 }),
                                        (e.contains(document.body, c[0]) || c[0].isConnected) && (s = c.offset()),
                                        (l.top -= s.top),
                                        (l.left -= s.left),
                                        n || i || (o = "below"),
                                        t || !d || n ? !d && t && n && (o = "below") : (o = "above"),
                                        ("above" == o || (n && "below" !== o)) && (l.top = r.top - s.top - a),
                                        null != o &&
                                            (this.$dropdown.removeClass("select2-dropdown--below select2-dropdown--above").addClass("select2-dropdown--" + o),
                                            this.$container.removeClass("select2-container--below select2-container--above").addClass("select2-container--" + o)),
                                        this.$dropdownContainer.css(l);
                                }),
                                (n.prototype._resizeDropdown = function () {
                                    var e = { width: this.$container.outerWidth(!1) + "px" };
                                    this.options.get("dropdownAutoWidth") && ((e.minWidth = e.width), (e.position = "relative"), (e.width = "auto")), this.$dropdown.css(e);
                                }),
                                (n.prototype._showDropdown = function (e) {
                                    this.$dropdownContainer.appendTo(this.$dropdownParent), this._positionDropdown(), this._resizeDropdown();
                                }),
                                n
                            );
                        }),
                        v.define("select2/dropdown/minimumResultsForSearch", [], function () {
                            function e(e, t, n, i) {
                                (this.minimumResultsForSearch = n.get("minimumResultsForSearch")), this.minimumResultsForSearch < 0 && (this.minimumResultsForSearch = 1 / 0), e.call(this, t, n, i);
                            }
                            return (
                                (e.prototype.showSearch = function (e, t) {
                                    return (
                                        !(
                                            (function e(t) {
                                                for (var n = 0, i = 0; i < t.length; i++) {
                                                    var o = t[i];
                                                    o.children ? (n += e(o.children)) : n++;
                                                }
                                                return n;
                                            })(t.data.results) < this.minimumResultsForSearch
                                        ) && e.call(this, t)
                                    );
                                }),
                                e
                            );
                        }),
                        v.define("select2/dropdown/selectOnClose", ["../utils"], function (e) {
                            function t() {}
                            return (
                                (t.prototype.bind = function (e, t, n) {
                                    var i = this;
                                    e.call(this, t, n),
                                        t.on("close", function (e) {
                                            i._handleSelectOnClose(e);
                                        });
                                }),
                                (t.prototype._handleSelectOnClose = function (t, n) {
                                    if (n && null != n.originalSelect2Event) {
                                        var i = n.originalSelect2Event;
                                        if ("select" === i._type || "unselect" === i._type) return;
                                    }
                                    (i = this.getHighlightedResults()).length < 1 || (null != (i = e.GetData(i[0], "data")).element && i.element.selected) || (null == i.element && i.selected) || this.trigger("select", { data: i });
                                }),
                                t
                            );
                        }),
                        v.define("select2/dropdown/closeOnSelect", [], function () {
                            function e() {}
                            return (
                                (e.prototype.bind = function (e, t, n) {
                                    var i = this;
                                    e.call(this, t, n),
                                        t.on("select", function (e) {
                                            i._selectTriggered(e);
                                        }),
                                        t.on("unselect", function (e) {
                                            i._selectTriggered(e);
                                        });
                                }),
                                (e.prototype._selectTriggered = function (e, t) {
                                    var n = t.originalEvent;
                                    (n && (n.ctrlKey || n.metaKey)) || this.trigger("close", { originalEvent: n, originalSelect2Event: t });
                                }),
                                e
                            );
                        }),
                        v.define("select2/i18n/en", [], function () {
                            return {
                                errorLoading: function () {
                                    return "The results could not be loaded.";
                                },
                                inputTooLong: function (e) {
                                    var t = e.input.length - e.maximum;
                                    return (e = "Please delete " + t + " character"), 1 != t && (e += "s"), e;
                                },
                                inputTooShort: function (e) {
                                    return "Please enter " + (e.minimum - e.input.length) + " or more characters";
                                },
                                loadingMore: function () {
                                    return "Loading more results…";
                                },
                                maximumSelected: function (e) {
                                    var t = "You can only select " + e.maximum + " item";
                                    return 1 != e.maximum && (t += "s"), t;
                                },
                                noResults: function () {
                                    return "No results found";
                                },
                                searching: function () {
                                    return "Searching…";
                                },
                                removeAllItems: function () {
                                    return "Remove all items";
                                },
                            };
                        }),
                        v.define(
                            "select2/defaults",
                            [
                                "jquery",
                                "require",
                                "./results",
                                "./selection/single",
                                "./selection/multiple",
                                "./selection/placeholder",
                                "./selection/allowClear",
                                "./selection/search",
                                "./selection/eventRelay",
                                "./utils",
                                "./translation",
                                "./diacritics",
                                "./data/select",
                                "./data/array",
                                "./data/ajax",
                                "./data/tags",
                                "./data/tokenizer",
                                "./data/minimumInputLength",
                                "./data/maximumInputLength",
                                "./data/maximumSelectionLength",
                                "./dropdown",
                                "./dropdown/search",
                                "./dropdown/hidePlaceholder",
                                "./dropdown/infiniteScroll",
                                "./dropdown/attachBody",
                                "./dropdown/minimumResultsForSearch",
                                "./dropdown/selectOnClose",
                                "./dropdown/closeOnSelect",
                                "./i18n/en",
                            ],
                            function (e, t, n, i, o, s, r, a, l, c, d, u, p, h, f, m, g, v, y, b, w, x, T, C, S, k, $, _, E) {
                                function A() {
                                    this.reset();
                                }
                                return (
                                    (A.prototype.apply = function (d) {
                                        var u, E, A;
                                        null == (d = e.extend(!0, {}, this.defaults, d)).dataAdapter &&
                                            (null != d.ajax ? (d.dataAdapter = f) : null != d.data ? (d.dataAdapter = h) : (d.dataAdapter = p),
                                            0 < d.minimumInputLength && (d.dataAdapter = c.Decorate(d.dataAdapter, v)),
                                            0 < d.maximumInputLength && (d.dataAdapter = c.Decorate(d.dataAdapter, y)),
                                            0 < d.maximumSelectionLength && (d.dataAdapter = c.Decorate(d.dataAdapter, b)),
                                            d.tags && (d.dataAdapter = c.Decorate(d.dataAdapter, m)),
                                            (null == d.tokenSeparators && null == d.tokenizer) || (d.dataAdapter = c.Decorate(d.dataAdapter, g)),
                                            null != d.query && ((u = t(d.amdBase + "compat/query")), (d.dataAdapter = c.Decorate(d.dataAdapter, u))),
                                            null != d.initSelection && ((E = t(d.amdBase + "compat/initSelection")), (d.dataAdapter = c.Decorate(d.dataAdapter, E)))),
                                            null == d.resultsAdapter &&
                                                ((d.resultsAdapter = n),
                                                null != d.ajax && (d.resultsAdapter = c.Decorate(d.resultsAdapter, C)),
                                                null != d.placeholder && (d.resultsAdapter = c.Decorate(d.resultsAdapter, T)),
                                                d.selectOnClose && (d.resultsAdapter = c.Decorate(d.resultsAdapter, $))),
                                            null == d.dropdownAdapter &&
                                                (d.multiple ? (d.dropdownAdapter = w) : ((E = c.Decorate(w, x)), (d.dropdownAdapter = E)),
                                                0 !== d.minimumResultsForSearch && (d.dropdownAdapter = c.Decorate(d.dropdownAdapter, k)),
                                                d.closeOnSelect && (d.dropdownAdapter = c.Decorate(d.dropdownAdapter, _)),
                                                (null == d.dropdownCssClass && null == d.dropdownCss && null == d.adaptDropdownCssClass) || ((A = t(d.amdBase + "compat/dropdownCss")), (d.dropdownAdapter = c.Decorate(d.dropdownAdapter, A))),
                                                (d.dropdownAdapter = c.Decorate(d.dropdownAdapter, S))),
                                            null == d.selectionAdapter &&
                                                (d.multiple ? (d.selectionAdapter = o) : (d.selectionAdapter = i),
                                                null != d.placeholder && (d.selectionAdapter = c.Decorate(d.selectionAdapter, s)),
                                                d.allowClear && (d.selectionAdapter = c.Decorate(d.selectionAdapter, r)),
                                                d.multiple && (d.selectionAdapter = c.Decorate(d.selectionAdapter, a)),
                                                (null == d.containerCssClass && null == d.containerCss && null == d.adaptContainerCssClass) ||
                                                    ((A = t(d.amdBase + "compat/containerCss")), (d.selectionAdapter = c.Decorate(d.selectionAdapter, A))),
                                                (d.selectionAdapter = c.Decorate(d.selectionAdapter, l))),
                                            (d.language = this._resolveLanguage(d.language)),
                                            d.language.push("en");
                                        for (var M = [], P = 0; P < d.language.length; P++) {
                                            var L = d.language[P];
                                            -1 === M.indexOf(L) && M.push(L);
                                        }
                                        return (d.language = M), (d.translations = this._processTranslations(d.language, d.debug)), d;
                                    }),
                                    (A.prototype.reset = function () {
                                        function t(e) {
                                            return e.replace(/[^\u0000-\u007E]/g, function (e) {
                                                return u[e] || e;
                                            });
                                        }
                                        this.defaults = {
                                            amdBase: "./",
                                            amdLanguageBase: "./i18n/",
                                            closeOnSelect: !0,
                                            debug: !1,
                                            dropdownAutoWidth: !1,
                                            escapeMarkup: c.escapeMarkup,
                                            language: {},
                                            matcher: function n(i, o) {
                                                if ("" === e.trim(i.term)) return o;
                                                if (o.children && 0 < o.children.length) {
                                                    for (var s = e.extend(!0, {}, o), r = o.children.length - 1; 0 <= r; r--) null == n(i, o.children[r]) && s.children.splice(r, 1);
                                                    return 0 < s.children.length ? s : n(i, s);
                                                }
                                                var a = t(o.text).toUpperCase(),
                                                    l = t(i.term).toUpperCase();
                                                return -1 < a.indexOf(l) ? o : null;
                                            },
                                            minimumInputLength: 0,
                                            maximumInputLength: 0,
                                            maximumSelectionLength: 0,
                                            minimumResultsForSearch: 0,
                                            selectOnClose: !1,
                                            scrollAfterSelect: !1,
                                            sorter: function (e) {
                                                return e;
                                            },
                                            templateResult: function (e) {
                                                return e.text;
                                            },
                                            templateSelection: function (e) {
                                                return e.text;
                                            },
                                            theme: "default",
                                            width: "resolve",
                                        };
                                    }),
                                    (A.prototype.applyFromElement = function (e, t) {
                                        var n = e.language,
                                            i = this.defaults.language,
                                            o = t.prop("lang");
                                        return (
                                            (t = t.closest("[lang]").prop("lang")),
                                            (t = Array.prototype.concat.call(this._resolveLanguage(o), this._resolveLanguage(n), this._resolveLanguage(i), this._resolveLanguage(t))),
                                            (e.language = t),
                                            e
                                        );
                                    }),
                                    (A.prototype._resolveLanguage = function (t) {
                                        if (!t) return [];
                                        if (e.isEmptyObject(t)) return [];
                                        if (e.isPlainObject(t)) return [t];
                                        for (var n, i = e.isArray(t) ? t : [t], o = [], s = 0; s < i.length; s++) o.push(i[s]), "string" == typeof i[s] && 0 < i[s].indexOf("-") && ((n = i[s].split("-")[0]), o.push(n));
                                        return o;
                                    }),
                                    (A.prototype._processTranslations = function (t, n) {
                                        for (var i = new d(), o = 0; o < t.length; o++) {
                                            var s = new d(),
                                                r = t[o];
                                            if ("string" == typeof r)
                                                try {
                                                    s = d.loadPath(r);
                                                } catch (t) {
                                                    try {
                                                        (r = this.defaults.amdLanguageBase + r), (s = d.loadPath(r));
                                                    } catch (t) {
                                                        n && window.console && console.warn && console.warn('Select2: The language file for "' + r + '" could not be automatically loaded. A fallback will be used instead.');
                                                    }
                                                }
                                            else s = e.isPlainObject(r) ? new d(r) : r;
                                            i.extend(s);
                                        }
                                        return i;
                                    }),
                                    (A.prototype.set = function (t, n) {
                                        var i = {};
                                        (i[e.camelCase(t)] = n), (i = c._convertData(i)), e.extend(!0, this.defaults, i);
                                    }),
                                    new A()
                                );
                            }
                        ),
                        v.define("select2/options", ["require", "jquery", "./defaults", "./utils"], function (e, t, n, i) {
                            function o(t, o) {
                                (this.options = t),
                                    null != o && this.fromElement(o),
                                    null != o && (this.options = n.applyFromElement(this.options, o)),
                                    (this.options = n.apply(this.options)),
                                    o && o.is("input") && ((o = e(this.get("amdBase") + "compat/inputData")), (this.options.dataAdapter = i.Decorate(this.options.dataAdapter, o)));
                            }
                            return (
                                (o.prototype.fromElement = function (e) {
                                    var n = ["select2"];
                                    null == this.options.multiple && (this.options.multiple = e.prop("multiple")),
                                        null == this.options.disabled && (this.options.disabled = e.prop("disabled")),
                                        null == this.options.dir && (e.prop("dir") ? (this.options.dir = e.prop("dir")) : e.closest("[dir]").prop("dir") ? (this.options.dir = e.closest("[dir]").prop("dir")) : (this.options.dir = "ltr")),
                                        e.prop("disabled", this.options.disabled),
                                        e.prop("multiple", this.options.multiple),
                                        i.GetData(e[0], "select2Tags") &&
                                            (this.options.debug &&
                                                window.console &&
                                                console.warn &&
                                                console.warn('Select2: The `data-select2-tags` attribute has been changed to use the `data-data` and `data-tags="true"` attributes and will be removed in future versions of Select2.'),
                                            i.StoreData(e[0], "data", i.GetData(e[0], "select2Tags")),
                                            i.StoreData(e[0], "tags", !0)),
                                        i.GetData(e[0], "ajaxUrl") &&
                                            (this.options.debug &&
                                                window.console &&
                                                console.warn &&
                                                console.warn("Select2: The `data-ajax-url` attribute has been changed to `data-ajax--url` and support for the old attribute will be removed in future versions of Select2."),
                                            e.attr("ajax--url", i.GetData(e[0], "ajaxUrl")),
                                            i.StoreData(e[0], "ajax-Url", i.GetData(e[0], "ajaxUrl")));
                                    var o = {};
                                    function s(e, t) {
                                        return t.toUpperCase();
                                    }
                                    for (var r = 0; r < e[0].attributes.length; r++) {
                                        var a,
                                            l = e[0].attributes[r].name;
                                        "data-" == l.substr(0, 5) && ((a = l.substring(5)), (l = i.GetData(e[0], a)), (o[a.replace(/-([a-z])/g, s)] = l));
                                    }
                                    t.fn.jquery && "1." == t.fn.jquery.substr(0, 2) && e[0].dataset && (o = t.extend(!0, {}, e[0].dataset, o));
                                    var c,
                                        d = t.extend(!0, {}, i.GetData(e[0]), o);
                                    for (c in (d = i._convertData(d))) -1 < t.inArray(c, n) || (t.isPlainObject(this.options[c]) ? t.extend(this.options[c], d[c]) : (this.options[c] = d[c]));
                                    return this;
                                }),
                                (o.prototype.get = function (e) {
                                    return this.options[e];
                                }),
                                (o.prototype.set = function (e, t) {
                                    this.options[e] = t;
                                }),
                                o
                            );
                        }),
                        v.define("select2/core", ["jquery", "./options", "./utils", "./keys"], function (e, t, n, i) {
                            function o(e, i) {
                                null != n.GetData(e[0], "select2") && n.GetData(e[0], "select2").destroy(), (this.$element = e), (this.id = this._generateId(e)), (this.options = new t((i = i || {}), e)), o.__super__.constructor.call(this);
                                var s = e.attr("tabindex") || 0;
                                n.StoreData(e[0], "old-tabindex", s),
                                    e.attr("tabindex", "-1"),
                                    (i = this.options.get("dataAdapter")),
                                    (this.dataAdapter = new i(e, this.options)),
                                    (s = this.render()),
                                    this._placeContainer(s),
                                    (i = this.options.get("selectionAdapter")),
                                    (this.selection = new i(e, this.options)),
                                    (this.$selection = this.selection.render()),
                                    this.selection.position(this.$selection, s),
                                    (i = this.options.get("dropdownAdapter")),
                                    (this.dropdown = new i(e, this.options)),
                                    (this.$dropdown = this.dropdown.render()),
                                    this.dropdown.position(this.$dropdown, s),
                                    (s = this.options.get("resultsAdapter")),
                                    (this.results = new s(e, this.options, this.dataAdapter)),
                                    (this.$results = this.results.render()),
                                    this.results.position(this.$results, this.$dropdown);
                                var r = this;
                                this._bindAdapters(),
                                    this._registerDomEvents(),
                                    this._registerDataEvents(),
                                    this._registerSelectionEvents(),
                                    this._registerDropdownEvents(),
                                    this._registerResultsEvents(),
                                    this._registerEvents(),
                                    this.dataAdapter.current(function (e) {
                                        r.trigger("selection:update", { data: e });
                                    }),
                                    e.addClass("select2-hidden-accessible"),
                                    e.attr("aria-hidden", "true"),
                                    this._syncAttributes(),
                                    n.StoreData(e[0], "select2", this),
                                    e.data("select2", this);
                            }
                            return (
                                n.Extend(o, n.Observable),
                                (o.prototype._generateId = function (e) {
                                    return "select2-" + (null != e.attr("id") ? e.attr("id") : null != e.attr("name") ? e.attr("name") + "-" + n.generateChars(2) : n.generateChars(4)).replace(/(:|\.|\[|\]|,)/g, "");
                                }),
                                (o.prototype._placeContainer = function (e) {
                                    e.insertAfter(this.$element);
                                    var t = this._resolveWidth(this.$element, this.options.get("width"));
                                    null != t && e.css("width", t);
                                }),
                                (o.prototype._resolveWidth = function (e, t) {
                                    var n = /^width:(([-+]?([0-9]*\.)?[0-9]+)(px|em|ex|%|in|cm|mm|pt|pc))/i;
                                    if ("resolve" == t) {
                                        var i = this._resolveWidth(e, "style");
                                        return null != i ? i : this._resolveWidth(e, "element");
                                    }
                                    if ("element" == t) return (i = e.outerWidth(!1)) <= 0 ? "auto" : i + "px";
                                    if ("style" != t) return "computedstyle" != t ? t : window.getComputedStyle(e[0]).width;
                                    if ("string" != typeof (e = e.attr("style"))) return null;
                                    for (var o = e.split(";"), s = 0, r = o.length; s < r; s += 1) {
                                        var a = o[s].replace(/\s/g, "").match(n);
                                        if (null !== a && 1 <= a.length) return a[1];
                                    }
                                    return null;
                                }),
                                (o.prototype._bindAdapters = function () {
                                    this.dataAdapter.bind(this, this.$container), this.selection.bind(this, this.$container), this.dropdown.bind(this, this.$container), this.results.bind(this, this.$container);
                                }),
                                (o.prototype._registerDomEvents = function () {
                                    var t = this;
                                    this.$element.on("change.select2", function () {
                                        t.dataAdapter.current(function (e) {
                                            t.trigger("selection:update", { data: e });
                                        });
                                    }),
                                        this.$element.on("focus.select2", function (e) {
                                            t.trigger("focus", e);
                                        }),
                                        (this._syncA = n.bind(this._syncAttributes, this)),
                                        (this._syncS = n.bind(this._syncSubtree, this)),
                                        this.$element[0].attachEvent && this.$element[0].attachEvent("onpropertychange", this._syncA);
                                    var i = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
                                    null != i
                                        ? ((this._observer = new i(function (n) {
                                              e.each(n, t._syncA), e.each(n, t._syncS);
                                          })),
                                          this._observer.observe(this.$element[0], { attributes: !0, childList: !0, subtree: !1 }))
                                        : this.$element[0].addEventListener &&
                                          (this.$element[0].addEventListener("DOMAttrModified", t._syncA, !1),
                                          this.$element[0].addEventListener("DOMNodeInserted", t._syncS, !1),
                                          this.$element[0].addEventListener("DOMNodeRemoved", t._syncS, !1));
                                }),
                                (o.prototype._registerDataEvents = function () {
                                    var e = this;
                                    this.dataAdapter.on("*", function (t, n) {
                                        e.trigger(t, n);
                                    });
                                }),
                                (o.prototype._registerSelectionEvents = function () {
                                    var t = this,
                                        n = ["toggle", "focus"];
                                    this.selection.on("toggle", function () {
                                        t.toggleDropdown();
                                    }),
                                        this.selection.on("focus", function (e) {
                                            t.focus(e);
                                        }),
                                        this.selection.on("*", function (i, o) {
                                            -1 === e.inArray(i, n) && t.trigger(i, o);
                                        });
                                }),
                                (o.prototype._registerDropdownEvents = function () {
                                    var e = this;
                                    this.dropdown.on("*", function (t, n) {
                                        e.trigger(t, n);
                                    });
                                }),
                                (o.prototype._registerResultsEvents = function () {
                                    var e = this;
                                    this.results.on("*", function (t, n) {
                                        e.trigger(t, n);
                                    });
                                }),
                                (o.prototype._registerEvents = function () {
                                    var e = this;
                                    this.on("open", function () {
                                        e.$container.addClass("select2-container--open");
                                    }),
                                        this.on("close", function () {
                                            e.$container.removeClass("select2-container--open");
                                        }),
                                        this.on("enable", function () {
                                            e.$container.removeClass("select2-container--disabled");
                                        }),
                                        this.on("disable", function () {
                                            e.$container.addClass("select2-container--disabled");
                                        }),
                                        this.on("blur", function () {
                                            e.$container.removeClass("select2-container--focus");
                                        }),
                                        this.on("query", function (t) {
                                            e.isOpen() || e.trigger("open", {}),
                                                this.dataAdapter.query(t, function (n) {
                                                    e.trigger("results:all", { data: n, query: t });
                                                });
                                        }),
                                        this.on("query:append", function (t) {
                                            this.dataAdapter.query(t, function (n) {
                                                e.trigger("results:append", { data: n, query: t });
                                            });
                                        }),
                                        this.on("keypress", function (t) {
                                            var n = t.which;
                                            e.isOpen()
                                                ? n === i.ESC || n === i.TAB || (n === i.UP && t.altKey)
                                                    ? (e.close(), t.preventDefault())
                                                    : n === i.ENTER
                                                    ? (e.trigger("results:select", {}), t.preventDefault())
                                                    : n === i.SPACE && t.ctrlKey
                                                    ? (e.trigger("results:toggle", {}), t.preventDefault())
                                                    : n === i.UP
                                                    ? (e.trigger("results:previous", {}), t.preventDefault())
                                                    : n === i.DOWN && (e.trigger("results:next", {}), t.preventDefault())
                                                : (n === i.ENTER || n === i.SPACE || (n === i.DOWN && t.altKey)) && (e.open(), t.preventDefault());
                                        });
                                }),
                                (o.prototype._syncAttributes = function () {
                                    this.options.set("disabled", this.$element.prop("disabled")), this.options.get("disabled") ? (this.isOpen() && this.close(), this.trigger("disable", {})) : this.trigger("enable", {});
                                }),
                                (o.prototype._syncSubtree = function (e, t) {
                                    var n = !1,
                                        i = this;
                                    if (!e || !e.target || "OPTION" === e.target.nodeName || "OPTGROUP" === e.target.nodeName) {
                                        if (t)
                                            if (t.addedNodes && 0 < t.addedNodes.length) for (var o = 0; o < t.addedNodes.length; o++) t.addedNodes[o].selected && (n = !0);
                                            else t.removedNodes && 0 < t.removedNodes.length && (n = !0);
                                        else n = !0;
                                        n &&
                                            this.dataAdapter.current(function (e) {
                                                i.trigger("selection:update", { data: e });
                                            });
                                    }
                                }),
                                (o.prototype.trigger = function (e, t) {
                                    var n = o.__super__.trigger,
                                        i = { open: "opening", close: "closing", select: "selecting", unselect: "unselecting", clear: "clearing" };
                                    if ((void 0 === t && (t = {}), e in i)) {
                                        var s = { prevented: !1, name: e, args: t };
                                        if ((n.call(this, i[e], s), s.prevented)) return void (t.prevented = !0);
                                    }
                                    n.call(this, e, t);
                                }),
                                (o.prototype.toggleDropdown = function () {
                                    this.options.get("disabled") || (this.isOpen() ? this.close() : this.open());
                                }),
                                (o.prototype.open = function () {
                                    this.isOpen() || this.trigger("query", {});
                                }),
                                (o.prototype.close = function () {
                                    this.isOpen() && this.trigger("close", {});
                                }),
                                (o.prototype.isOpen = function () {
                                    return this.$container.hasClass("select2-container--open");
                                }),
                                (o.prototype.hasFocus = function () {
                                    return this.$container.hasClass("select2-container--focus");
                                }),
                                (o.prototype.focus = function (e) {
                                    this.hasFocus() || (this.$container.addClass("select2-container--focus"), this.trigger("focus", {}));
                                }),
                                (o.prototype.enable = function (e) {
                                    this.options.get("debug") &&
                                        window.console &&
                                        console.warn &&
                                        console.warn('Select2: The `select2("enable")` method has been deprecated and will be removed in later Select2 versions. Use $element.prop("disabled") instead.'),
                                        (e = !(e = null == e || 0 === e.length ? [!0] : e)[0]),
                                        this.$element.prop("disabled", e);
                                }),
                                (o.prototype.data = function () {
                                    this.options.get("debug") &&
                                        0 < arguments.length &&
                                        window.console &&
                                        console.warn &&
                                        console.warn('Select2: Data can no longer be set using `select2("data")`. You should consider setting the value instead using `$element.val()`.');
                                    var e = [];
                                    return (
                                        this.dataAdapter.current(function (t) {
                                            e = t;
                                        }),
                                        e
                                    );
                                }),
                                (o.prototype.val = function (t) {
                                    if (
                                        (this.options.get("debug") &&
                                            window.console &&
                                            console.warn &&
                                            console.warn('Select2: The `select2("val")` method has been deprecated and will be removed in later Select2 versions. Use $element.val() instead.'),
                                        null == t || 0 === t.length)
                                    )
                                        return this.$element.val();
                                    (t = t[0]),
                                        e.isArray(t) &&
                                            (t = e.map(t, function (e) {
                                                return e.toString();
                                            })),
                                        this.$element.val(t).trigger("change");
                                }),
                                (o.prototype.destroy = function () {
                                    this.$container.remove(),
                                        this.$element[0].detachEvent && this.$element[0].detachEvent("onpropertychange", this._syncA),
                                        null != this._observer
                                            ? (this._observer.disconnect(), (this._observer = null))
                                            : this.$element[0].removeEventListener &&
                                              (this.$element[0].removeEventListener("DOMAttrModified", this._syncA, !1),
                                              this.$element[0].removeEventListener("DOMNodeInserted", this._syncS, !1),
                                              this.$element[0].removeEventListener("DOMNodeRemoved", this._syncS, !1)),
                                        (this._syncA = null),
                                        (this._syncS = null),
                                        this.$element.off(".select2"),
                                        this.$element.attr("tabindex", n.GetData(this.$element[0], "old-tabindex")),
                                        this.$element.removeClass("select2-hidden-accessible"),
                                        this.$element.attr("aria-hidden", "false"),
                                        n.RemoveData(this.$element[0]),
                                        this.$element.removeData("select2"),
                                        this.dataAdapter.destroy(),
                                        this.selection.destroy(),
                                        this.dropdown.destroy(),
                                        this.results.destroy(),
                                        (this.dataAdapter = null),
                                        (this.selection = null),
                                        (this.dropdown = null),
                                        (this.results = null);
                                }),
                                (o.prototype.render = function () {
                                    var t = e('<span class="select2 select2-container"><span class="selection"></span><span class="dropdown-wrapper" aria-hidden="true"></span></span>');
                                    return t.attr("dir", this.options.get("dir")), (this.$container = t), this.$container.addClass("select2-container--" + this.options.get("theme")), n.StoreData(t[0], "element", this.$element), t;
                                }),
                                o
                            );
                        }),
                        v.define("select2/compat/utils", ["jquery"], function (e) {
                            return {
                                syncCssClasses: function (t, n, i) {
                                    var o,
                                        s,
                                        r = [];
                                    (o = e.trim(t.attr("class"))) &&
                                        e((o = "" + o).split(/\s+/)).each(function () {
                                            0 === this.indexOf("select2-") && r.push(this);
                                        }),
                                        (o = e.trim(n.attr("class"))) &&
                                            e((o = "" + o).split(/\s+/)).each(function () {
                                                0 !== this.indexOf("select2-") && null != (s = i(this)) && r.push(s);
                                            }),
                                        t.attr("class", r.join(" "));
                                },
                            };
                        }),
                        v.define("select2/compat/containerCss", ["jquery", "./utils"], function (e, t) {
                            function n(e) {
                                return null;
                            }
                            function i() {}
                            return (
                                (i.prototype.render = function (i) {
                                    var o = i.call(this),
                                        s = this.options.get("containerCssClass") || "";
                                    e.isFunction(s) && (s = s(this.$element));
                                    var r,
                                        a = this.options.get("adaptContainerCssClass");
                                    return (
                                        (a = a || n),
                                        -1 !== s.indexOf(":all:") &&
                                            ((s = s.replace(":all:", "")),
                                            (r = a),
                                            (a = function (e) {
                                                var t = r(e);
                                                return null != t ? t + " " + e : e;
                                            })),
                                        (i = this.options.get("containerCss") || {}),
                                        e.isFunction(i) && (i = i(this.$element)),
                                        t.syncCssClasses(o, this.$element, a),
                                        o.css(i),
                                        o.addClass(s),
                                        o
                                    );
                                }),
                                i
                            );
                        }),
                        v.define("select2/compat/dropdownCss", ["jquery", "./utils"], function (e, t) {
                            function n(e) {
                                return null;
                            }
                            function i() {}
                            return (
                                (i.prototype.render = function (i) {
                                    var o = i.call(this),
                                        s = this.options.get("dropdownCssClass") || "";
                                    e.isFunction(s) && (s = s(this.$element));
                                    var r,
                                        a = this.options.get("adaptDropdownCssClass");
                                    return (
                                        (a = a || n),
                                        -1 !== s.indexOf(":all:") &&
                                            ((s = s.replace(":all:", "")),
                                            (r = a),
                                            (a = function (e) {
                                                var t = r(e);
                                                return null != t ? t + " " + e : e;
                                            })),
                                        (i = this.options.get("dropdownCss") || {}),
                                        e.isFunction(i) && (i = i(this.$element)),
                                        t.syncCssClasses(o, this.$element, a),
                                        o.css(i),
                                        o.addClass(s),
                                        o
                                    );
                                }),
                                i
                            );
                        }),
                        v.define("select2/compat/initSelection", ["jquery"], function (e) {
                            function t(e, t, n) {
                                n.get("debug") &&
                                    window.console &&
                                    console.warn &&
                                    console.warn(
                                        "Select2: The `initSelection` option has been deprecated in favor of a custom data adapter that overrides the `current` method. This method is now called multiple times instead of a single time when the instance is initialized. Support will be removed for the `initSelection` option in future versions of Select2"
                                    ),
                                    (this.initSelection = n.get("initSelection")),
                                    (this._isInitialized = !1),
                                    e.call(this, t, n);
                            }
                            return (
                                (t.prototype.current = function (t, n) {
                                    var i = this;
                                    this._isInitialized
                                        ? t.call(this, n)
                                        : this.initSelection.call(null, this.$element, function (t) {
                                              (i._isInitialized = !0), e.isArray(t) || (t = [t]), n(t);
                                          });
                                }),
                                t
                            );
                        }),
                        v.define("select2/compat/inputData", ["jquery", "../utils"], function (e, t) {
                            function n(e, t, n) {
                                (this._currentData = []),
                                    (this._valueSeparator = n.get("valueSeparator") || ","),
                                    "hidden" === t.prop("type") &&
                                        n.get("debug") &&
                                        console &&
                                        console.warn &&
                                        console.warn("Select2: Using a hidden input with Select2 is no longer supported and may stop working in the future. It is recommended to use a `<select>` element instead."),
                                    e.call(this, t, n);
                            }
                            return (
                                (n.prototype.current = function (t, n) {
                                    for (var i = [], o = 0; o < this._currentData.length; o++) {
                                        var s = this._currentData[o];
                                        i.push.apply(
                                            i,
                                            (function t(n, i) {
                                                var o = [];
                                                return n.selected || -1 !== e.inArray(n.id, i) ? ((n.selected = !0), o.push(n)) : (n.selected = !1), n.children && o.push.apply(o, t(n.children, i)), o;
                                            })(s, this.$element.val().split(this._valueSeparator))
                                        );
                                    }
                                    n(i);
                                }),
                                (n.prototype.select = function (t, n) {
                                    var i;
                                    this.options.get("multiple")
                                        ? ((i = this.$element.val()), (i += this._valueSeparator + n.id), this.$element.val(i))
                                        : (this.current(function (t) {
                                              e.map(t, function (e) {
                                                  e.selected = !1;
                                              });
                                          }),
                                          this.$element.val(n.id)),
                                        this.$element.trigger("change");
                                }),
                                (n.prototype.unselect = function (e, t) {
                                    var n = this;
                                    (t.selected = !1),
                                        this.current(function (e) {
                                            for (var i = [], o = 0; o < e.length; o++) {
                                                var s = e[o];
                                                t.id != s.id && i.push(s.id);
                                            }
                                            n.$element.val(i.join(n._valueSeparator)), n.$element.trigger("change");
                                        });
                                }),
                                (n.prototype.query = function (e, t, n) {
                                    for (var i = [], o = 0; o < this._currentData.length; o++) {
                                        var s = this._currentData[o];
                                        null !== (s = this.matches(t, s)) && i.push(s);
                                    }
                                    n({ results: i });
                                }),
                                (n.prototype.addOptions = function (n, i) {
                                    (i = e.map(i, function (e) {
                                        return t.GetData(e[0], "data");
                                    })),
                                        this._currentData.push.apply(this._currentData, i);
                                }),
                                n
                            );
                        }),
                        v.define("select2/compat/matcher", ["jquery"], function (e) {
                            return function (t) {
                                return function (n, i) {
                                    var o = e.extend(!0, {}, i);
                                    if (null == n.term || "" === e.trim(n.term)) return o;
                                    if (i.children) {
                                        for (var s = i.children.length - 1; 0 <= s; s--) {
                                            var r = i.children[s];
                                            t(n.term, r.text, r) || o.children.splice(s, 1);
                                        }
                                        if (0 < o.children.length) return o;
                                    }
                                    return t(n.term, i.text, i) ? o : null;
                                };
                            };
                        }),
                        v.define("select2/compat/query", [], function () {
                            function e(e, t, n) {
                                n.get("debug") &&
                                    window.console &&
                                    console.warn &&
                                    console.warn(
                                        "Select2: The `query` option has been deprecated in favor of a custom data adapter that overrides the `query` method. Support will be removed for the `query` option in future versions of Select2."
                                    ),
                                    e.call(this, t, n);
                            }
                            return (
                                (e.prototype.query = function (e, t, n) {
                                    (t.callback = n), this.options.get("query").call(null, t);
                                }),
                                e
                            );
                        }),
                        v.define("select2/dropdown/attachContainer", [], function () {
                            function e(e, t, n) {
                                e.call(this, t, n);
                            }
                            return (
                                (e.prototype.position = function (e, t, n) {
                                    n.find(".dropdown-wrapper").append(t), t.addClass("select2-dropdown--below"), n.addClass("select2-container--below");
                                }),
                                e
                            );
                        }),
                        v.define("select2/dropdown/stopPropagation", [], function () {
                            function e() {}
                            return (
                                (e.prototype.bind = function (e, t, n) {
                                    e.call(this, t, n),
                                        this.$dropdown.on(
                                            [
                                                "blur",
                                                "change",
                                                "click",
                                                "dblclick",
                                                "focus",
                                                "focusin",
                                                "focusout",
                                                "input",
                                                "keydown",
                                                "keyup",
                                                "keypress",
                                                "mousedown",
                                                "mouseenter",
                                                "mouseleave",
                                                "mousemove",
                                                "mouseover",
                                                "mouseup",
                                                "search",
                                                "touchend",
                                                "touchstart",
                                            ].join(" "),
                                            function (e) {
                                                e.stopPropagation();
                                            }
                                        );
                                }),
                                e
                            );
                        }),
                        v.define("select2/selection/stopPropagation", [], function () {
                            function e() {}
                            return (
                                (e.prototype.bind = function (e, t, n) {
                                    e.call(this, t, n),
                                        this.$selection.on(
                                            [
                                                "blur",
                                                "change",
                                                "click",
                                                "dblclick",
                                                "focus",
                                                "focusin",
                                                "focusout",
                                                "input",
                                                "keydown",
                                                "keyup",
                                                "keypress",
                                                "mousedown",
                                                "mouseenter",
                                                "mouseleave",
                                                "mousemove",
                                                "mouseover",
                                                "mouseup",
                                                "search",
                                                "touchend",
                                                "touchstart",
                                            ].join(" "),
                                            function (e) {
                                                e.stopPropagation();
                                            }
                                        );
                                }),
                                e
                            );
                        }),
                        (g = function (e) {
                            var t,
                                n,
                                i = ["wheel", "mousewheel", "DOMMouseScroll", "MozMousePixelScroll"],
                                o = "onwheel" in document || 9 <= document.documentMode ? ["wheel"] : ["mousewheel", "DomMouseScroll", "MozMousePixelScroll"],
                                s = Array.prototype.slice;
                            if (e.event.fixHooks) for (var r = i.length; r; ) e.event.fixHooks[i[--r]] = e.event.mouseHooks;
                            var a = (e.event.special.mousewheel = {
                                version: "3.1.12",
                                setup: function () {
                                    if (this.addEventListener) for (var t = o.length; t; ) this.addEventListener(o[--t], l, !1);
                                    else this.onmousewheel = l;
                                    e.data(this, "mousewheel-line-height", a.getLineHeight(this)), e.data(this, "mousewheel-page-height", a.getPageHeight(this));
                                },
                                teardown: function () {
                                    if (this.removeEventListener) for (var t = o.length; t; ) this.removeEventListener(o[--t], l, !1);
                                    else this.onmousewheel = null;
                                    e.removeData(this, "mousewheel-line-height"), e.removeData(this, "mousewheel-page-height");
                                },
                                getLineHeight: function (t) {
                                    var n = e(t);
                                    return (t = n["offsetParent" in e.fn ? "offsetParent" : "parent"]()).length || (t = e("body")), parseInt(t.css("fontSize"), 10) || parseInt(n.css("fontSize"), 10) || 16;
                                },
                                getPageHeight: function (t) {
                                    return e(t).height();
                                },
                                settings: { adjustOldDeltas: !0, normalizeOffset: !0 },
                            });
                            function l(i) {
                                var o,
                                    r = i || window.event,
                                    l = s.call(arguments, 1),
                                    u = 0,
                                    p = 0,
                                    h = 0,
                                    f = 0,
                                    m = 0;
                                if (
                                    (((i = e.event.fix(r)).type = "mousewheel"),
                                    "detail" in r && (h = -1 * r.detail),
                                    "wheelDelta" in r && (h = r.wheelDelta),
                                    "wheelDeltaY" in r && (h = r.wheelDeltaY),
                                    "wheelDeltaX" in r && (p = -1 * r.wheelDeltaX),
                                    "axis" in r && r.axis === r.HORIZONTAL_AXIS && ((p = -1 * h), (h = 0)),
                                    (u = 0 === h ? p : h),
                                    "deltaY" in r && (u = h = -1 * r.deltaY),
                                    "deltaX" in r && ((p = r.deltaX), 0 === h && (u = -1 * p)),
                                    0 !== h || 0 !== p)
                                ) {
                                    1 === r.deltaMode ? ((u *= o = e.data(this, "mousewheel-line-height")), (h *= o), (p *= o)) : 2 === r.deltaMode && ((u *= g = e.data(this, "mousewheel-page-height")), (h *= g), (p *= g));
                                    var g = Math.max(Math.abs(h), Math.abs(p));
                                    return (
                                        (!n || g < n) && d(r, (n = g)) && (n /= 40),
                                        d(r, g) && ((u /= 40), (p /= 40), (h /= 40)),
                                        (u = Math[1 <= u ? "floor" : "ceil"](u / n)),
                                        (p = Math[1 <= p ? "floor" : "ceil"](p / n)),
                                        (h = Math[1 <= h ? "floor" : "ceil"](h / n)),
                                        a.settings.normalizeOffset && this.getBoundingClientRect && ((g = this.getBoundingClientRect()), (f = i.clientX - g.left), (m = i.clientY - g.top)),
                                        (i.deltaX = p),
                                        (i.deltaY = h),
                                        (i.deltaFactor = n),
                                        (i.offsetX = f),
                                        (i.offsetY = m),
                                        (i.deltaMode = 0),
                                        l.unshift(i, u, p, h),
                                        t && clearTimeout(t),
                                        (t = setTimeout(c, 200)),
                                        (e.event.dispatch || e.event.handle).apply(this, l)
                                    );
                                }
                            }
                            function c() {
                                n = null;
                            }
                            function d(e, t) {
                                return a.settings.adjustOldDeltas && "mousewheel" === e.type && t % 120 == 0;
                            }
                            e.fn.extend({
                                mousewheel: function (e) {
                                    return e ? this.bind("mousewheel", e) : this.trigger("mousewheel");
                                },
                                unmousewheel: function (e) {
                                    return this.unbind("mousewheel", e);
                                },
                            });
                        }),
                        "function" == typeof v.define && v.define.amd ? v.define("jquery-mousewheel", ["jquery"], g) : "object" == ("undefined" == typeof exports ? "undefined" : _typeof(exports)) ? (module.exports = g) : g(t),
                        v.define("jquery.select2", ["jquery", "jquery-mousewheel", "./select2/core", "./select2/defaults", "./select2/utils"], function (e, t, n, i, o) {
                            var s;
                            return (
                                null == e.fn.select2 &&
                                    ((s = ["open", "close", "destroy"]),
                                    (e.fn.select2 = function (t) {
                                        if ("object" == _typeof((t = t || {})))
                                            return (
                                                this.each(function () {
                                                    var i = e.extend(!0, {}, t);
                                                    new n(e(this), i);
                                                }),
                                                this
                                            );
                                        if ("string" != typeof t) throw new Error("Invalid arguments for Select2: " + t);
                                        var i,
                                            r = Array.prototype.slice.call(arguments, 1);
                                        return (
                                            this.each(function () {
                                                var e = o.GetData(this, "select2");
                                                null == e && window.console && console.error && console.error("The select2('" + t + "') method was called on an element that is not using Select2."), (i = e[t].apply(e, r));
                                            }),
                                            -1 < e.inArray(t, s) ? this : i
                                        );
                                    })),
                                null == e.fn.select2.defaults && (e.fn.select2.defaults = i),
                                n
                            );
                        }),
                        { define: v.define, require: v.require }),
                    v = g.require("jquery.select2");
                function y(e, t) {
                    return h.call(e, t);
                }
                function b(e, t) {
                    var n,
                        i,
                        o,
                        s,
                        r,
                        a,
                        l,
                        c,
                        d,
                        p,
                        h = t && t.split("/"),
                        f = u.map,
                        g = (f && f["*"]) || {};
                    if (e) {
                        for (t = (e = e.split("/")).length - 1, u.nodeIdCompat && m.test(e[t]) && (e[t] = e[t].replace(m, "")), "." === e[0].charAt(0) && h && (e = h.slice(0, h.length - 1).concat(e)), c = 0; c < e.length; c++)
                            "." === (p = e[c]) ? (e.splice(c, 1), --c) : ".." === p && (0 === c || (1 === c && ".." === e[2]) || ".." === e[c - 1] || (0 < c && (e.splice(c - 1, 2), (c -= 2))));
                        e = e.join("/");
                    }
                    if ((h || g) && f) {
                        for (c = (n = e.split("/")).length; 0 < c; --c) {
                            if (((i = n.slice(0, c).join("/")), h))
                                for (d = h.length; 0 < d; --d)
                                    if ((o = (o = f[h.slice(0, d).join("/")]) && o[i])) {
                                        (s = o), (r = c);
                                        break;
                                    }
                            if (s) break;
                            !a && g && g[i] && ((a = g[i]), (l = c));
                        }
                        !s && a && ((s = a), (r = l)), s && (n.splice(0, r, s), (e = n.join("/")));
                    }
                    return e;
                }
                function w(e, t) {
                    return function () {
                        var n = f.call(arguments, 0);
                        return "string" != typeof n[0] && 1 === n.length && n.push(null), r.apply(o, n.concat([e, t]));
                    };
                }
                function x(e) {
                    var t;
                    if ((y(d, e) && ((t = d[e]), delete d[e], (p[e] = !0), s.apply(o, t)), !y(c, e) && !y(p, e))) throw new Error("No " + e);
                    return c[e];
                }
                function T(e) {
                    var t,
                        n = e ? e.indexOf("!") : -1;
                    return -1 < n && ((t = e.substring(0, n)), (e = e.substring(n + 1, e.length))), [t, e];
                }
                function C(e) {
                    return e ? T(e) : [];
                }
                return (t.fn.select2.amd = g), v;
            }),
            "object" == ("undefined" == typeof module ? "undefined" : _typeof(module)) && module.exports
                ? (module.exports = function (e, t) {
                      return void 0 === t && (t = "undefined" != typeof window ? require("jquery") : require("jquery")(e)), fe(t), t;
                  })
                : fe(jQuery),
            (ge = e.event),
            (ve = window.innerWidth),
            (ye = ge.special.debouncedresize = {
                setup: function () {
                    e(this).on("resize", ye.handler);
                },
                teardown: function () {
                    e(this).off("resize", ye.handler);
                },
                handler: function (e, t) {
                    function n() {
                        (e.type = "debouncedresize"), ge.dispatch.apply(i, o), ve !== window.innerWidth && ((e.type = "debouncedresizewidth"), ge.dispatch.apply(i, o), (ve = window.innerWidth));
                    }
                    var i = this,
                        o = arguments;
                    me && clearTimeout(me), t ? n() : (me = setTimeout(n, ye.threshold));
                },
                threshold: 150,
            }),
            (function () {
                for (
                    var e = [
                            { base: "A", letters: "AⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ" },
                            { base: "AA", letters: "Ꜳ" },
                            { base: "AE", letters: "ÆǼǢ" },
                            { base: "AO", letters: "Ꜵ" },
                            { base: "AU", letters: "Ꜷ" },
                            { base: "AV", letters: "ꜸꜺ" },
                            { base: "AY", letters: "Ꜽ" },
                            { base: "B", letters: "BⒷＢḂḄḆɃƂƁ" },
                            { base: "C", letters: "CⒸＣĆĈĊČÇḈƇȻꜾ" },
                            { base: "D", letters: "DⒹＤḊĎḌḐḒḎĐƋƊƉꝹÐ" },
                            { base: "DZ", letters: "ǱǄ" },
                            { base: "Dz", letters: "ǲǅ" },
                            { base: "E", letters: "EⒺＥÈÉÊỀẾỄỂẼĒḔḖĔĖËẺĚȄȆẸỆȨḜĘḘḚƐƎ" },
                            { base: "F", letters: "FⒻＦḞƑꝻ" },
                            { base: "G", letters: "GⒼＧǴĜḠĞĠǦĢǤƓꞠꝽꝾ" },
                            { base: "H", letters: "HⒽＨĤḢḦȞḤḨḪĦⱧⱵꞍ" },
                            { base: "I", letters: "IⒾＩÌÍÎĨĪĬİÏḮỈǏȈȊỊĮḬƗ" },
                            { base: "J", letters: "JⒿＪĴɈ" },
                            { base: "K", letters: "KⓀＫḰǨḲĶḴƘⱩꝀꝂꝄꞢ" },
                            { base: "L", letters: "LⓁＬĿĹĽḶḸĻḼḺŁȽⱢⱠꝈꝆꞀ" },
                            { base: "LJ", letters: "Ǉ" },
                            { base: "Lj", letters: "ǈ" },
                            { base: "M", letters: "MⓂＭḾṀṂⱮƜ" },
                            { base: "N", letters: "NⓃＮǸŃÑṄŇṆŅṊṈȠƝꞐꞤ" },
                            { base: "NJ", letters: "Ǌ" },
                            { base: "Nj", letters: "ǋ" },
                            { base: "O", letters: "OⓄＯÒÓÔỒỐỖỔÕṌȬṎŌṐṒŎȮȰÖȪỎŐǑȌȎƠỜỚỠỞỢỌỘǪǬØǾƆƟꝊꝌ" },
                            { base: "OI", letters: "Ƣ" },
                            { base: "OO", letters: "Ꝏ" },
                            { base: "OU", letters: "Ȣ" },
                            { base: "OE", letters: "Œ" },
                            { base: "oe", letters: "œ" },
                            { base: "P", letters: "PⓅＰṔṖƤⱣꝐꝒꝔ" },
                            { base: "Q", letters: "QⓆＱꝖꝘɊ" },
                            { base: "R", letters: "RⓇＲŔṘŘȐȒṚṜŖṞɌⱤꝚꞦꞂ" },
                            { base: "S", letters: "SⓈＳẞŚṤŜṠŠṦṢṨȘŞⱾꞨꞄ" },
                            { base: "T", letters: "TⓉＴṪŤṬȚŢṰṮŦƬƮȾꞆ" },
                            { base: "TZ", letters: "Ꜩ" },
                            { base: "U", letters: "UⓊＵÙÚÛŨṸŪṺŬÜǛǗǕǙỦŮŰǓȔȖƯỪỨỮỬỰỤṲŲṶṴɄ" },
                            { base: "V", letters: "VⓋＶṼṾƲꝞɅ" },
                            { base: "VY", letters: "Ꝡ" },
                            { base: "W", letters: "WⓌＷẀẂŴẆẄẈⱲ" },
                            { base: "X", letters: "XⓍＸẊẌ" },
                            { base: "Y", letters: "YⓎＹỲÝŶỸȲẎŸỶỴƳɎỾ" },
                            { base: "Z", letters: "ZⓏＺŹẐŻŽẒẔƵȤⱿⱫꝢ" },
                            { base: "a", letters: "aⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐ" },
                            { base: "aa", letters: "ꜳ" },
                            { base: "ae", letters: "æǽǣ" },
                            { base: "ao", letters: "ꜵ" },
                            { base: "au", letters: "ꜷ" },
                            { base: "av", letters: "ꜹꜻ" },
                            { base: "ay", letters: "ꜽ" },
                            { base: "b", letters: "bⓑｂḃḅḇƀƃɓ" },
                            { base: "c", letters: "cⓒｃćĉċčçḉƈȼꜿↄ" },
                            { base: "d", letters: "dⓓｄḋďḍḑḓḏđƌɖɗꝺ" },
                            { base: "dz", letters: "ǳǆ" },
                            { base: "e", letters: "eⓔｅèéêềếễểẽēḕḗĕėëẻěȅȇẹệȩḝęḙḛɇɛǝ" },
                            { base: "f", letters: "fⓕｆḟƒꝼ" },
                            { base: "g", letters: "gⓖｇǵĝḡğġǧģǥɠꞡᵹꝿ" },
                            { base: "h", letters: "hⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥ" },
                            { base: "hv", letters: "ƕ" },
                            { base: "i", letters: "iⓘｉìíîĩīĭïḯỉǐȉȋịįḭɨı" },
                            { base: "j", letters: "jⓙｊĵǰɉ" },
                            { base: "k", letters: "kⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣ" },
                            { base: "l", letters: "lⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇ" },
                            { base: "lj", letters: "ǉ" },
                            { base: "m", letters: "mⓜｍḿṁṃɱɯ" },
                            { base: "n", letters: "nⓝｎǹńñṅňṇņṋṉƞɲŉꞑꞥ" },
                            { base: "nj", letters: "ǌ" },
                            { base: "o", letters: "oⓞｏòóôồốỗổõṍȭṏōṑṓŏȯȱöȫỏőǒȍȏơờớỡởợọộǫǭøǿɔꝋꝍɵ" },
                            { base: "oi", letters: "ƣ" },
                            { base: "ou", letters: "ȣ" },
                            { base: "oo", letters: "ꝏ" },
                            { base: "p", letters: "pⓟｐṕṗƥᵽꝑꝓꝕ" },
                            { base: "q", letters: "qⓠｑɋꝗꝙ" },
                            { base: "r", letters: "rⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃ" },
                            { base: "s", letters: "sⓢｓßśṥŝṡšṧṣṩșşȿꞩꞅẛ" },
                            { base: "t", letters: "tⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇ" },
                            { base: "tz", letters: "ꜩ" },
                            { base: "u", letters: "uⓤｕùúûũṹūṻŭüǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉ" },
                            { base: "v", letters: "vⓥｖṽṿʋꝟʌ" },
                            { base: "vy", letters: "ꝡ" },
                            { base: "w", letters: "wⓦｗẁẃŵẇẅẘẉⱳ" },
                            { base: "x", letters: "xⓧｘẋẍ" },
                            { base: "y", letters: "yⓨｙỳýŷỹȳẏÿỷẙỵƴɏỿ" },
                            { base: "z", letters: "zⓩｚźẑżžẓẕƶȥɀⱬꝣ" },
                        ],
                        t = {},
                        n = 0;
                    n < e.length;
                    n++
                )
                    for (var i = e[n].letters, o = 0; o < i.length; o++) t[i[o]] = e[n].base;
                window.removeDiacritics = function (e) {
                    return "string" != typeof e
                        ? (console.warn("Invalid parameter passed to window.removeDiacritics (".concat(_typeof(e), ")"), e), e)
                        : e.replace(/[^\u0000-\u007E]/g, function (e) {
                              return t[e] || e;
                          });
                };
            })(),
            (jQuery.cookie = function (e, t, n) {
                if (void 0 === t) {
                    var i = null;
                    if (document.cookie && "" != document.cookie)
                        for (var o = document.cookie.split(";"), s = 0; s < o.length; s++) {
                            var r = jQuery.trim(o[s]);
                            if (r.substring(0, e.length + 1) == e + "=") {
                                i = decodeURIComponent(r.substring(e.length + 1));
                                break;
                            }
                        }
                    return i;
                }
                (n = n || {}), null === t && ((t = ""), (n.expires = -1));
                var a = "";
                n.expires &&
                    ("number" == typeof n.expires || n.expires.toUTCString) &&
                    ("number" == typeof n.expires ? (c = new Date()).setTime(c.getTime() + 24 * n.expires * 60 * 60 * 1e3) : (c = n.expires), (a = "; expires=" + c.toUTCString()));
                var l = n.path ? "; path=" + n.path : "",
                    c = n.domain ? "; domain=" + n.domain : "";
                (n = n.secure ? "; secure" : ""), (document.cookie = [e, "=", encodeURIComponent(t), a, l, c, n].join(""));
            });
    })(theme.jQuery),
    (function (e, t) {
        "object" == typeof exports && "undefined" != typeof module ? (module.exports = t()) : "function" == typeof define && define.amd ? define(t) : ((e = "undefined" != typeof globalThis ? globalThis : e || self).Swiper = t());
    })(this, function () {
        "use strict";
        function e(e) {
            return null !== e && "object" == typeof e && "constructor" in e && e.constructor === Object;
        }
        function t(n = {}, i = {}) {
            Object.keys(i).forEach((o) => {
                void 0 === n[o] ? (n[o] = i[o]) : e(i[o]) && e(n[o]) && Object.keys(i[o]).length > 0 && t(n[o], i[o]);
            });
        }
        const n = {
            body: {},
            addEventListener() {},
            removeEventListener() {},
            activeElement: { blur() {}, nodeName: "" },
            querySelector: () => null,
            querySelectorAll: () => [],
            getElementById: () => null,
            createEvent: () => ({ initEvent() {} }),
            createElement: () => ({ children: [], childNodes: [], style: {}, setAttribute() {}, getElementsByTagName: () => [] }),
            createElementNS: () => ({}),
            importNode: () => null,
            location: { hash: "", host: "", hostname: "", href: "", origin: "", pathname: "", protocol: "", search: "" },
        };
        function i() {
            const e = "undefined" != typeof document ? document : {};
            return t(e, n), e;
        }
        const o = {
            document: n,
            navigator: { userAgent: "" },
            location: { hash: "", host: "", hostname: "", href: "", origin: "", pathname: "", protocol: "", search: "" },
            history: { replaceState() {}, pushState() {}, go() {}, back() {} },
            CustomEvent: function () {
                return this;
            },
            addEventListener() {},
            removeEventListener() {},
            getComputedStyle: () => ({ getPropertyValue: () => "" }),
            Image() {},
            Date() {},
            screen: {},
            setTimeout() {},
            clearTimeout() {},
            matchMedia: () => ({}),
            requestAnimationFrame: (e) => ("undefined" == typeof setTimeout ? (e(), null) : setTimeout(e, 0)),
            cancelAnimationFrame(e) {
                "undefined" != typeof setTimeout && clearTimeout(e);
            },
        };
        function s() {
            const e = "undefined" != typeof window ? window : {};
            return t(e, o), e;
        }
        class r extends Array {
            constructor(e) {
                super(...(e || [])),
                    (function (e) {
                        const t = e.__proto__;
                        Object.defineProperty(e, "__proto__", {
                            get: () => t,
                            set(e) {
                                t.__proto__ = e;
                            },
                        });
                    })(this);
            }
        }
        function a(e = []) {
            const t = [];
            return (
                e.forEach((e) => {
                    Array.isArray(e) ? t.push(...a(e)) : t.push(e);
                }),
                t
            );
        }
        function l(e, t) {
            return Array.prototype.filter.call(e, t);
        }
        function c(e, t) {
            const n = s(),
                o = i();
            let a = [];
            if (!t && e instanceof r) return e;
            if (!e) return new r(a);
            if ("string" == typeof e) {
                const n = e.trim();
                if (n.indexOf("<") >= 0 && n.indexOf(">") >= 0) {
                    let e = "div";
                    0 === n.indexOf("<li") && (e = "ul"),
                        0 === n.indexOf("<tr") && (e = "tbody"),
                        (0 !== n.indexOf("<td") && 0 !== n.indexOf("<th")) || (e = "tr"),
                        0 === n.indexOf("<tbody") && (e = "table"),
                        0 === n.indexOf("<option") && (e = "select");
                    const t = o.createElement(e);
                    t.innerHTML = n;
                    for (let e = 0; e < t.childNodes.length; e += 1) a.push(t.childNodes[e]);
                } else
                    a = (function (e, t) {
                        if ("string" != typeof e) return [e];
                        const n = [],
                            i = t.querySelectorAll(e);
                        for (let e = 0; e < i.length; e += 1) n.push(i[e]);
                        return n;
                    })(e.trim(), t || o);
            } else if (e.nodeType || e === n || e === o) a.push(e);
            else if (Array.isArray(e)) {
                if (e instanceof r) return e;
                a = e;
            }
            return new r(
                (function (e) {
                    const t = [];
                    for (let n = 0; n < e.length; n += 1) -1 === t.indexOf(e[n]) && t.push(e[n]);
                    return t;
                })(a)
            );
        }
        c.fn = r.prototype;
        const d = {
            addClass: function (...e) {
                const t = a(e.map((e) => e.split(" ")));
                return (
                    this.forEach((e) => {
                        e.classList.add(...t);
                    }),
                    this
                );
            },
            removeClass: function (...e) {
                const t = a(e.map((e) => e.split(" ")));
                return (
                    this.forEach((e) => {
                        e.classList.remove(...t);
                    }),
                    this
                );
            },
            hasClass: function (...e) {
                const t = a(e.map((e) => e.split(" ")));
                return l(this, (e) => t.filter((t) => e.classList.contains(t)).length > 0).length > 0;
            },
            toggleClass: function (...e) {
                const t = a(e.map((e) => e.split(" ")));
                this.forEach((e) => {
                    t.forEach((t) => {
                        e.classList.toggle(t);
                    });
                });
            },
            attr: function (e, t) {
                if (1 === arguments.length && "string" == typeof e) return this[0] ? this[0].getAttribute(e) : void 0;
                for (let n = 0; n < this.length; n += 1)
                    if (2 === arguments.length) this[n].setAttribute(e, t);
                    else for (const t in e) (this[n][t] = e[t]), this[n].setAttribute(t, e[t]);
                return this;
            },
            removeAttr: function (e) {
                for (let t = 0; t < this.length; t += 1) this[t].removeAttribute(e);
                return this;
            },
            transform: function (e) {
                for (let t = 0; t < this.length; t += 1) this[t].style.transform = e;
                return this;
            },
            transition: function (e) {
                for (let t = 0; t < this.length; t += 1) this[t].style.transitionDuration = "string" != typeof e ? `${e}ms` : e;
                return this;
            },
            on: function (...e) {
                let [t, n, i, o] = e;
                function s(e) {
                    const t = e.target;
                    if (!t) return;
                    const o = e.target.dom7EventData || [];
                    if ((o.indexOf(e) < 0 && o.unshift(e), c(t).is(n))) i.apply(t, o);
                    else {
                        const e = c(t).parents();
                        for (let t = 0; t < e.length; t += 1) c(e[t]).is(n) && i.apply(e[t], o);
                    }
                }
                function r(e) {
                    const t = (e && e.target && e.target.dom7EventData) || [];
                    t.indexOf(e) < 0 && t.unshift(e), i.apply(this, t);
                }
                "function" == typeof e[1] && (([t, i, o] = e), (n = void 0)), o || (o = !1);
                const a = t.split(" ");
                let l;
                for (let e = 0; e < this.length; e += 1) {
                    const t = this[e];
                    if (n)
                        for (l = 0; l < a.length; l += 1) {
                            const e = a[l];
                            t.dom7LiveListeners || (t.dom7LiveListeners = {}), t.dom7LiveListeners[e] || (t.dom7LiveListeners[e] = []), t.dom7LiveListeners[e].push({ listener: i, proxyListener: s }), t.addEventListener(e, s, o);
                        }
                    else
                        for (l = 0; l < a.length; l += 1) {
                            const e = a[l];
                            t.dom7Listeners || (t.dom7Listeners = {}), t.dom7Listeners[e] || (t.dom7Listeners[e] = []), t.dom7Listeners[e].push({ listener: i, proxyListener: r }), t.addEventListener(e, r, o);
                        }
                }
                return this;
            },
            off: function (...e) {
                let [t, n, i, o] = e;
                "function" == typeof e[1] && (([t, i, o] = e), (n = void 0)), o || (o = !1);
                const s = t.split(" ");
                for (let e = 0; e < s.length; e += 1) {
                    const t = s[e];
                    for (let e = 0; e < this.length; e += 1) {
                        const s = this[e];
                        let r;
                        if ((!n && s.dom7Listeners ? (r = s.dom7Listeners[t]) : n && s.dom7LiveListeners && (r = s.dom7LiveListeners[t]), r && r.length))
                            for (let e = r.length - 1; e >= 0; e -= 1) {
                                const n = r[e];
                                (i && n.listener === i) || (i && n.listener && n.listener.dom7proxy && n.listener.dom7proxy === i)
                                    ? (s.removeEventListener(t, n.proxyListener, o), r.splice(e, 1))
                                    : i || (s.removeEventListener(t, n.proxyListener, o), r.splice(e, 1));
                            }
                    }
                }
                return this;
            },
            trigger: function (...e) {
                const t = s(),
                    n = e[0].split(" "),
                    i = e[1];
                for (let o = 0; o < n.length; o += 1) {
                    const s = n[o];
                    for (let n = 0; n < this.length; n += 1) {
                        const o = this[n];
                        if (t.CustomEvent) {
                            const n = new t.CustomEvent(s, { detail: i, bubbles: !0, cancelable: !0 });
                            (o.dom7EventData = e.filter((e, t) => t > 0)), o.dispatchEvent(n), (o.dom7EventData = []), delete o.dom7EventData;
                        }
                    }
                }
                return this;
            },
            transitionEnd: function (e) {
                const t = this;
                return (
                    e &&
                        t.on("transitionend", function n(i) {
                            i.target === this && (e.call(this, i), t.off("transitionend", n));
                        }),
                    this
                );
            },
            outerWidth: function (e) {
                if (this.length > 0) {
                    if (e) {
                        const e = this.styles();
                        return this[0].offsetWidth + parseFloat(e.getPropertyValue("margin-right")) + parseFloat(e.getPropertyValue("margin-left"));
                    }
                    return this[0].offsetWidth;
                }
                return null;
            },
            outerHeight: function (e) {
                if (this.length > 0) {
                    if (e) {
                        const e = this.styles();
                        return this[0].offsetHeight + parseFloat(e.getPropertyValue("margin-top")) + parseFloat(e.getPropertyValue("margin-bottom"));
                    }
                    return this[0].offsetHeight;
                }
                return null;
            },
            styles: function () {
                const e = s();
                return this[0] ? e.getComputedStyle(this[0], null) : {};
            },
            offset: function () {
                if (this.length > 0) {
                    const e = s(),
                        t = i(),
                        n = this[0],
                        o = n.getBoundingClientRect(),
                        r = t.body,
                        a = n.clientTop || r.clientTop || 0,
                        l = n.clientLeft || r.clientLeft || 0,
                        c = n === e ? e.scrollY : n.scrollTop,
                        d = n === e ? e.scrollX : n.scrollLeft;
                    return { top: o.top + c - a, left: o.left + d - l };
                }
                return null;
            },
            css: function (e, t) {
                const n = s();
                let i;
                if (1 === arguments.length) {
                    if ("string" != typeof e) {
                        for (i = 0; i < this.length; i += 1) for (const t in e) this[i].style[t] = e[t];
                        return this;
                    }
                    if (this[0]) return n.getComputedStyle(this[0], null).getPropertyValue(e);
                }
                if (2 === arguments.length && "string" == typeof e) {
                    for (i = 0; i < this.length; i += 1) this[i].style[e] = t;
                    return this;
                }
                return this;
            },
            each: function (e) {
                return e
                    ? (this.forEach((t, n) => {
                          e.apply(t, [t, n]);
                      }),
                      this)
                    : this;
            },
            html: function (e) {
                if (void 0 === e) return this[0] ? this[0].innerHTML : null;
                for (let t = 0; t < this.length; t += 1) this[t].innerHTML = e;
                return this;
            },
            text: function (e) {
                if (void 0 === e) return this[0] ? this[0].textContent.trim() : null;
                for (let t = 0; t < this.length; t += 1) this[t].textContent = e;
                return this;
            },
            is: function (e) {
                const t = s(),
                    n = i(),
                    o = this[0];
                let a, l;
                if (!o || void 0 === e) return !1;
                if ("string" == typeof e) {
                    if (o.matches) return o.matches(e);
                    if (o.webkitMatchesSelector) return o.webkitMatchesSelector(e);
                    if (o.msMatchesSelector) return o.msMatchesSelector(e);
                    for (a = c(e), l = 0; l < a.length; l += 1) if (a[l] === o) return !0;
                    return !1;
                }
                if (e === n) return o === n;
                if (e === t) return o === t;
                if (e.nodeType || e instanceof r) {
                    for (a = e.nodeType ? [e] : e, l = 0; l < a.length; l += 1) if (a[l] === o) return !0;
                    return !1;
                }
                return !1;
            },
            index: function () {
                let e,
                    t = this[0];
                if (t) {
                    for (e = 0; null !== (t = t.previousSibling); ) 1 === t.nodeType && (e += 1);
                    return e;
                }
            },
            eq: function (e) {
                if (void 0 === e) return this;
                const t = this.length;
                if (e > t - 1) return c([]);
                if (e < 0) {
                    const n = t + e;
                    return c(n < 0 ? [] : [this[n]]);
                }
                return c([this[e]]);
            },
            append: function (...e) {
                let t;
                const n = i();
                for (let i = 0; i < e.length; i += 1) {
                    t = e[i];
                    for (let e = 0; e < this.length; e += 1)
                        if ("string" == typeof t) {
                            const i = n.createElement("div");
                            for (i.innerHTML = t; i.firstChild; ) this[e].appendChild(i.firstChild);
                        } else if (t instanceof r) for (let n = 0; n < t.length; n += 1) this[e].appendChild(t[n]);
                        else this[e].appendChild(t);
                }
                return this;
            },
            prepend: function (e) {
                const t = i();
                let n, o;
                for (n = 0; n < this.length; n += 1)
                    if ("string" == typeof e) {
                        const i = t.createElement("div");
                        for (i.innerHTML = e, o = i.childNodes.length - 1; o >= 0; o -= 1) this[n].insertBefore(i.childNodes[o], this[n].childNodes[0]);
                    } else if (e instanceof r) for (o = 0; o < e.length; o += 1) this[n].insertBefore(e[o], this[n].childNodes[0]);
                    else this[n].insertBefore(e, this[n].childNodes[0]);
                return this;
            },
            next: function (e) {
                return this.length > 0 ? (e ? (this[0].nextElementSibling && c(this[0].nextElementSibling).is(e) ? c([this[0].nextElementSibling]) : c([])) : this[0].nextElementSibling ? c([this[0].nextElementSibling]) : c([])) : c([]);
            },
            nextAll: function (e) {
                const t = [];
                let n = this[0];
                if (!n) return c([]);
                for (; n.nextElementSibling; ) {
                    const i = n.nextElementSibling;
                    e ? c(i).is(e) && t.push(i) : t.push(i), (n = i);
                }
                return c(t);
            },
            prev: function (e) {
                if (this.length > 0) {
                    const t = this[0];
                    return e ? (t.previousElementSibling && c(t.previousElementSibling).is(e) ? c([t.previousElementSibling]) : c([])) : t.previousElementSibling ? c([t.previousElementSibling]) : c([]);
                }
                return c([]);
            },
            prevAll: function (e) {
                const t = [];
                let n = this[0];
                if (!n) return c([]);
                for (; n.previousElementSibling; ) {
                    const i = n.previousElementSibling;
                    e ? c(i).is(e) && t.push(i) : t.push(i), (n = i);
                }
                return c(t);
            },
            parent: function (e) {
                const t = [];
                for (let n = 0; n < this.length; n += 1) null !== this[n].parentNode && (e ? c(this[n].parentNode).is(e) && t.push(this[n].parentNode) : t.push(this[n].parentNode));
                return c(t);
            },
            parents: function (e) {
                const t = [];
                for (let n = 0; n < this.length; n += 1) {
                    let i = this[n].parentNode;
                    for (; i; ) e ? c(i).is(e) && t.push(i) : t.push(i), (i = i.parentNode);
                }
                return c(t);
            },
            closest: function (e) {
                let t = this;
                return void 0 === e ? c([]) : (t.is(e) || (t = t.parents(e).eq(0)), t);
            },
            find: function (e) {
                const t = [];
                for (let n = 0; n < this.length; n += 1) {
                    const i = this[n].querySelectorAll(e);
                    for (let e = 0; e < i.length; e += 1) t.push(i[e]);
                }
                return c(t);
            },
            children: function (e) {
                const t = [];
                for (let n = 0; n < this.length; n += 1) {
                    const i = this[n].children;
                    for (let n = 0; n < i.length; n += 1) (e && !c(i[n]).is(e)) || t.push(i[n]);
                }
                return c(t);
            },
            filter: function (e) {
                return c(l(this, e));
            },
            remove: function () {
                for (let e = 0; e < this.length; e += 1) this[e].parentNode && this[e].parentNode.removeChild(this[e]);
                return this;
            },
        };
        function u(e, t = 0) {
            return setTimeout(e, t);
        }
        function p() {
            return Date.now();
        }
        function h(e, t = "x") {
            const n = s();
            let i, o, r;
            const a = (function (e) {
                const t = s();
                let n;
                return t.getComputedStyle && (n = t.getComputedStyle(e, null)), !n && e.currentStyle && (n = e.currentStyle), n || (n = e.style), n;
            })(e);
            return (
                n.WebKitCSSMatrix
                    ? ((o = a.transform || a.webkitTransform),
                      o.split(",").length > 6 &&
                          (o = o
                              .split(", ")
                              .map((e) => e.replace(",", "."))
                              .join(", ")),
                      (r = new n.WebKitCSSMatrix("none" === o ? "" : o)))
                    : ((r = a.MozTransform || a.OTransform || a.MsTransform || a.msTransform || a.transform || a.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,")), (i = r.toString().split(","))),
                "x" === t && (o = n.WebKitCSSMatrix ? r.m41 : 16 === i.length ? parseFloat(i[12]) : parseFloat(i[4])),
                "y" === t && (o = n.WebKitCSSMatrix ? r.m42 : 16 === i.length ? parseFloat(i[13]) : parseFloat(i[5])),
                o || 0
            );
        }
        function f(e) {
            return "object" == typeof e && null !== e && e.constructor && "Object" === Object.prototype.toString.call(e).slice(8, -1);
        }
        function m(...e) {
            const t = Object(e[0]),
                n = ["__proto__", "constructor", "prototype"];
            for (let o = 1; o < e.length; o += 1) {
                const s = e[o];
                if (null != s && ((i = s), !("undefined" != typeof window && void 0 !== window.HTMLElement ? i instanceof HTMLElement : i && (1 === i.nodeType || 11 === i.nodeType)))) {
                    const e = Object.keys(Object(s)).filter((e) => n.indexOf(e) < 0);
                    for (let n = 0, i = e.length; n < i; n += 1) {
                        const i = e[n],
                            o = Object.getOwnPropertyDescriptor(s, i);
                        void 0 !== o && o.enumerable && (f(t[i]) && f(s[i]) ? (s[i].__swiper__ ? (t[i] = s[i]) : m(t[i], s[i])) : !f(t[i]) && f(s[i]) ? ((t[i] = {}), s[i].__swiper__ ? (t[i] = s[i]) : m(t[i], s[i])) : (t[i] = s[i]));
                    }
                }
            }
            var i;
            return t;
        }
        function g(e, t, n) {
            e.style.setProperty(t, n);
        }
        function v({ swiper: e, targetPosition: t, side: n }) {
            const i = s(),
                o = -e.translate;
            let r,
                a = null;
            const l = e.params.speed;
            (e.wrapperEl.style.scrollSnapType = "none"), i.cancelAnimationFrame(e.cssModeFrameID);
            const c = t > o ? "next" : "prev",
                d = (e, t) => ("next" === c && e >= t) || ("prev" === c && e <= t),
                u = () => {
                    (r = new Date().getTime()), null === a && (a = r);
                    const s = Math.max(Math.min((r - a) / l, 1), 0),
                        c = 0.5 - Math.cos(s * Math.PI) / 2;
                    let p = o + c * (t - o);
                    if ((d(p, t) && (p = t), e.wrapperEl.scrollTo({ [n]: p }), d(p, t)))
                        return (
                            (e.wrapperEl.style.overflow = "hidden"),
                            (e.wrapperEl.style.scrollSnapType = ""),
                            setTimeout(() => {
                                (e.wrapperEl.style.overflow = ""), e.wrapperEl.scrollTo({ [n]: p });
                            }),
                            void i.cancelAnimationFrame(e.cssModeFrameID)
                        );
                    e.cssModeFrameID = i.requestAnimationFrame(u);
                };
            u();
        }
        let y, b, w;
        function x() {
            return (
                y ||
                    (y = (function () {
                        const e = s(),
                            t = i();
                        return {
                            smoothScroll: t.documentElement && "scrollBehavior" in t.documentElement.style,
                            touch: !!("ontouchstart" in e || (e.DocumentTouch && t instanceof e.DocumentTouch)),
                            passiveListener: (function () {
                                let t = !1;
                                try {
                                    const n = Object.defineProperty({}, "passive", {
                                        get() {
                                            t = !0;
                                        },
                                    });
                                    e.addEventListener("testPassiveListener", null, n);
                                } catch (e) {}
                                return t;
                            })(),
                            gestures: "ongesturestart" in e,
                        };
                    })()),
                y
            );
        }
        function T(e = {}) {
            return (
                b ||
                    (b = (function ({ userAgent: e } = {}) {
                        const t = x(),
                            n = s(),
                            i = n.navigator.platform,
                            o = e || n.navigator.userAgent,
                            r = { ios: !1, android: !1 },
                            a = n.screen.width,
                            l = n.screen.height,
                            c = o.match(/(Android);?[\s\/]+([\d.]+)?/);
                        let d = o.match(/(iPad).*OS\s([\d_]+)/);
                        const u = o.match(/(iPod)(.*OS\s([\d_]+))?/),
                            p = !d && o.match(/(iPhone\sOS|iOS)\s([\d_]+)/),
                            h = "Win32" === i;
                        let f = "MacIntel" === i;
                        return (
                            !d &&
                                f &&
                                t.touch &&
                                ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"].indexOf(`${a}x${l}`) >= 0 &&
                                ((d = o.match(/(Version)\/([\d.]+)/)), d || (d = [0, 1, "13_0_0"]), (f = !1)),
                            c && !h && ((r.os = "android"), (r.android = !0)),
                            (d || p || u) && ((r.os = "ios"), (r.ios = !0)),
                            r
                        );
                    })(e)),
                b
            );
        }
        function C() {
            return (
                w ||
                    (w = (function () {
                        const e = s();
                        return {
                            isSafari: (function () {
                                const t = e.navigator.userAgent.toLowerCase();
                                return t.indexOf("safari") >= 0 && t.indexOf("chrome") < 0 && t.indexOf("android") < 0;
                            })(),
                            isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(e.navigator.userAgent),
                        };
                    })()),
                w
            );
        }
        Object.keys(d).forEach((e) => {
            Object.defineProperty(c.fn, e, { value: d[e], writable: !0 });
        });
        var S = {
            on(e, t, n) {
                const i = this;
                if ("function" != typeof t) return i;
                const o = n ? "unshift" : "push";
                return (
                    e.split(" ").forEach((e) => {
                        i.eventsListeners[e] || (i.eventsListeners[e] = []), i.eventsListeners[e][o](t);
                    }),
                    i
                );
            },
            once(e, t, n) {
                const i = this;
                if ("function" != typeof t) return i;
                function o(...n) {
                    i.off(e, o), o.__emitterProxy && delete o.__emitterProxy, t.apply(i, n);
                }
                return (o.__emitterProxy = t), i.on(e, o, n);
            },
            onAny(e, t) {
                const n = this;
                if ("function" != typeof e) return n;
                const i = t ? "unshift" : "push";
                return n.eventsAnyListeners.indexOf(e) < 0 && n.eventsAnyListeners[i](e), n;
            },
            offAny(e) {
                const t = this;
                if (!t.eventsAnyListeners) return t;
                const n = t.eventsAnyListeners.indexOf(e);
                return n >= 0 && t.eventsAnyListeners.splice(n, 1), t;
            },
            off(e, t) {
                const n = this;
                return n.eventsListeners
                    ? (e.split(" ").forEach((e) => {
                          void 0 === t
                              ? (n.eventsListeners[e] = [])
                              : n.eventsListeners[e] &&
                                n.eventsListeners[e].forEach((i, o) => {
                                    (i === t || (i.__emitterProxy && i.__emitterProxy === t)) && n.eventsListeners[e].splice(o, 1);
                                });
                      }),
                      n)
                    : n;
            },
            emit(...e) {
                const t = this;
                if (!t.eventsListeners) return t;
                let n, i, o;
                return (
                    "string" == typeof e[0] || Array.isArray(e[0]) ? ((n = e[0]), (i = e.slice(1, e.length)), (o = t)) : ((n = e[0].events), (i = e[0].data), (o = e[0].context || t)),
                    i.unshift(o),
                    (Array.isArray(n) ? n : n.split(" ")).forEach((e) => {
                        t.eventsAnyListeners &&
                            t.eventsAnyListeners.length &&
                            t.eventsAnyListeners.forEach((t) => {
                                t.apply(o, [e, ...i]);
                            }),
                            t.eventsListeners &&
                                t.eventsListeners[e] &&
                                t.eventsListeners[e].forEach((e) => {
                                    e.apply(o, i);
                                });
                    }),
                    t
                );
            },
        };
        function k({ swiper: e, runCallbacks: t, direction: n, step: i }) {
            const { activeIndex: o, previousIndex: s } = e;
            let r = n;
            if ((r || (r = o > s ? "next" : o < s ? "prev" : "reset"), e.emit(`transition${i}`), t && o !== s)) {
                if ("reset" === r) return void e.emit(`slideResetTransition${i}`);
                e.emit(`slideChangeTransition${i}`), "next" === r ? e.emit(`slideNextTransition${i}`) : e.emit(`slidePrevTransition${i}`);
            }
        }
        function $(e) {
            const t = this,
                n = i(),
                o = s(),
                r = t.touchEventsData,
                { params: a, touches: l, enabled: d } = t;
            if (!d) return;
            if (t.animating && a.preventInteractionOnTransition) return;
            !t.animating && a.cssMode && a.loop && t.loopFix();
            let u = e;
            u.originalEvent && (u = u.originalEvent);
            let h = c(u.target);
            if ("wrapper" === a.touchEventsTarget && !h.closest(t.wrapperEl).length) return;
            if (((r.isTouchEvent = "touchstart" === u.type), !r.isTouchEvent && "which" in u && 3 === u.which)) return;
            if (!r.isTouchEvent && "button" in u && u.button > 0) return;
            if (r.isTouched && r.isMoved) return;
            a.noSwipingClass && "" !== a.noSwipingClass && u.target && u.target.shadowRoot && e.path && e.path[0] && (h = c(e.path[0]));
            const f = a.noSwipingSelector ? a.noSwipingSelector : `.${a.noSwipingClass}`,
                m = !(!u.target || !u.target.shadowRoot);
            if (
                a.noSwiping &&
                (m
                    ? (function (e, t = this) {
                          return (function t(n) {
                              return n && n !== i() && n !== s() ? (n.assignedSlot && (n = n.assignedSlot), n.closest(e) || t(n.getRootNode().host)) : null;
                          })(t);
                      })(f, u.target)
                    : h.closest(f)[0])
            )
                return void (t.allowClick = !0);
            if (a.swipeHandler && !h.closest(a.swipeHandler)[0]) return;
            (l.currentX = "touchstart" === u.type ? u.targetTouches[0].pageX : u.pageX), (l.currentY = "touchstart" === u.type ? u.targetTouches[0].pageY : u.pageY);
            const g = l.currentX,
                v = l.currentY,
                y = a.edgeSwipeDetection || a.iOSEdgeSwipeDetection,
                b = a.edgeSwipeThreshold || a.iOSEdgeSwipeThreshold;
            if (y && (g <= b || g >= o.innerWidth - b)) {
                if ("prevent" !== y) return;
                e.preventDefault();
            }
            if (
                (Object.assign(r, { isTouched: !0, isMoved: !1, allowTouchCallbacks: !0, isScrolling: void 0, startMoving: void 0 }),
                (l.startX = g),
                (l.startY = v),
                (r.touchStartTime = p()),
                (t.allowClick = !0),
                t.updateSize(),
                (t.swipeDirection = void 0),
                a.threshold > 0 && (r.allowThresholdMove = !1),
                "touchstart" !== u.type)
            ) {
                let e = !0;
                h.is(r.focusableElements) && (e = !1), n.activeElement && c(n.activeElement).is(r.focusableElements) && n.activeElement !== h[0] && n.activeElement.blur();
                const i = e && t.allowTouchMove && a.touchStartPreventDefault;
                (!a.touchStartForcePreventDefault && !i) || h[0].isContentEditable || u.preventDefault();
            }
            t.emit("touchStart", u);
        }
        function _(e) {
            const t = i(),
                n = this,
                o = n.touchEventsData,
                { params: s, touches: r, rtlTranslate: a, enabled: l } = n;
            if (!l) return;
            let d = e;
            if ((d.originalEvent && (d = d.originalEvent), !o.isTouched)) return void (o.startMoving && o.isScrolling && n.emit("touchMoveOpposite", d));
            if (o.isTouchEvent && "touchmove" !== d.type) return;
            const u = "touchmove" === d.type && d.targetTouches && (d.targetTouches[0] || d.changedTouches[0]),
                h = "touchmove" === d.type ? u.pageX : d.pageX,
                f = "touchmove" === d.type ? u.pageY : d.pageY;
            if (d.preventedByNestedSwiper) return (r.startX = h), void (r.startY = f);
            if (!n.allowTouchMove) return (n.allowClick = !1), void (o.isTouched && (Object.assign(r, { startX: h, startY: f, currentX: h, currentY: f }), (o.touchStartTime = p())));
            if (o.isTouchEvent && s.touchReleaseOnEdges && !s.loop)
                if (n.isVertical()) {
                    if ((f < r.startY && n.translate <= n.maxTranslate()) || (f > r.startY && n.translate >= n.minTranslate())) return (o.isTouched = !1), void (o.isMoved = !1);
                } else if ((h < r.startX && n.translate <= n.maxTranslate()) || (h > r.startX && n.translate >= n.minTranslate())) return;
            if (o.isTouchEvent && t.activeElement && d.target === t.activeElement && c(d.target).is(o.focusableElements)) return (o.isMoved = !0), void (n.allowClick = !1);
            if ((o.allowTouchCallbacks && n.emit("touchMove", d), d.targetTouches && d.targetTouches.length > 1)) return;
            (r.currentX = h), (r.currentY = f);
            const m = r.currentX - r.startX,
                g = r.currentY - r.startY;
            if (n.params.threshold && Math.sqrt(m ** 2 + g ** 2) < n.params.threshold) return;
            if (void 0 === o.isScrolling) {
                let e;
                (n.isHorizontal() && r.currentY === r.startY) || (n.isVertical() && r.currentX === r.startX)
                    ? (o.isScrolling = !1)
                    : m * m + g * g >= 25 && ((e = (180 * Math.atan2(Math.abs(g), Math.abs(m))) / Math.PI), (o.isScrolling = n.isHorizontal() ? e > s.touchAngle : 90 - e > s.touchAngle));
            }
            if ((o.isScrolling && n.emit("touchMoveOpposite", d), void 0 === o.startMoving && ((r.currentX === r.startX && r.currentY === r.startY) || (o.startMoving = !0)), o.isScrolling)) return void (o.isTouched = !1);
            if (!o.startMoving) return;
            (n.allowClick = !1),
                !s.cssMode && d.cancelable && d.preventDefault(),
                s.touchMoveStopPropagation && !s.nested && d.stopPropagation(),
                o.isMoved ||
                    (s.loop && !s.cssMode && n.loopFix(),
                    (o.startTranslate = n.getTranslate()),
                    n.setTransition(0),
                    n.animating && n.$wrapperEl.trigger("webkitTransitionEnd transitionend"),
                    (o.allowMomentumBounce = !1),
                    !s.grabCursor || (!0 !== n.allowSlideNext && !0 !== n.allowSlidePrev) || n.setGrabCursor(!0),
                    n.emit("sliderFirstMove", d)),
                n.emit("sliderMove", d),
                (o.isMoved = !0);
            let v = n.isHorizontal() ? m : g;
            (r.diff = v), (v *= s.touchRatio), a && (v = -v), (n.swipeDirection = v > 0 ? "prev" : "next"), (o.currentTranslate = v + o.startTranslate);
            let y = !0,
                b = s.resistanceRatio;
            if (
                (s.touchReleaseOnEdges && (b = 0),
                v > 0 && o.currentTranslate > n.minTranslate()
                    ? ((y = !1), s.resistance && (o.currentTranslate = n.minTranslate() - 1 + (-n.minTranslate() + o.startTranslate + v) ** b))
                    : v < 0 && o.currentTranslate < n.maxTranslate() && ((y = !1), s.resistance && (o.currentTranslate = n.maxTranslate() + 1 - (n.maxTranslate() - o.startTranslate - v) ** b)),
                y && (d.preventedByNestedSwiper = !0),
                !n.allowSlideNext && "next" === n.swipeDirection && o.currentTranslate < o.startTranslate && (o.currentTranslate = o.startTranslate),
                !n.allowSlidePrev && "prev" === n.swipeDirection && o.currentTranslate > o.startTranslate && (o.currentTranslate = o.startTranslate),
                n.allowSlidePrev || n.allowSlideNext || (o.currentTranslate = o.startTranslate),
                s.threshold > 0)
            ) {
                if (!(Math.abs(v) > s.threshold || o.allowThresholdMove)) return void (o.currentTranslate = o.startTranslate);
                if (!o.allowThresholdMove)
                    return (o.allowThresholdMove = !0), (r.startX = r.currentX), (r.startY = r.currentY), (o.currentTranslate = o.startTranslate), void (r.diff = n.isHorizontal() ? r.currentX - r.startX : r.currentY - r.startY);
            }
            s.followFinger &&
                !s.cssMode &&
                (((s.freeMode && s.freeMode.enabled && n.freeMode) || s.watchSlidesProgress) && (n.updateActiveIndex(), n.updateSlidesClasses()),
                n.params.freeMode && s.freeMode.enabled && n.freeMode && n.freeMode.onTouchMove(),
                n.updateProgress(o.currentTranslate),
                n.setTranslate(o.currentTranslate));
        }
        function E(e) {
            const t = this,
                n = t.touchEventsData,
                { params: i, touches: o, rtlTranslate: s, slidesGrid: r, enabled: a } = t;
            if (!a) return;
            let l = e;
            if ((l.originalEvent && (l = l.originalEvent), n.allowTouchCallbacks && t.emit("touchEnd", l), (n.allowTouchCallbacks = !1), !n.isTouched))
                return n.isMoved && i.grabCursor && t.setGrabCursor(!1), (n.isMoved = !1), void (n.startMoving = !1);
            i.grabCursor && n.isMoved && n.isTouched && (!0 === t.allowSlideNext || !0 === t.allowSlidePrev) && t.setGrabCursor(!1);
            const c = p(),
                d = c - n.touchStartTime;
            if (
                (t.allowClick && (t.updateClickedSlide(l), t.emit("tap click", l), d < 300 && c - n.lastClickTime < 300 && t.emit("doubleTap doubleClick", l)),
                (n.lastClickTime = p()),
                u(() => {
                    t.destroyed || (t.allowClick = !0);
                }),
                !n.isTouched || !n.isMoved || !t.swipeDirection || 0 === o.diff || n.currentTranslate === n.startTranslate)
            )
                return (n.isTouched = !1), (n.isMoved = !1), void (n.startMoving = !1);
            let h;
            if (((n.isTouched = !1), (n.isMoved = !1), (n.startMoving = !1), (h = i.followFinger ? (s ? t.translate : -t.translate) : -n.currentTranslate), i.cssMode)) return;
            if (t.params.freeMode && i.freeMode.enabled) return void t.freeMode.onTouchEnd({ currentPos: h });
            let f = 0,
                m = t.slidesSizesGrid[0];
            for (let e = 0; e < r.length; e += e < i.slidesPerGroupSkip ? 1 : i.slidesPerGroup) {
                const t = e < i.slidesPerGroupSkip - 1 ? 1 : i.slidesPerGroup;
                void 0 !== r[e + t] ? h >= r[e] && h < r[e + t] && ((f = e), (m = r[e + t] - r[e])) : h >= r[e] && ((f = e), (m = r[r.length - 1] - r[r.length - 2]));
            }
            const g = (h - r[f]) / m,
                v = f < i.slidesPerGroupSkip - 1 ? 1 : i.slidesPerGroup;
            if (d > i.longSwipesMs) {
                if (!i.longSwipes) return void t.slideTo(t.activeIndex);
                "next" === t.swipeDirection && (g >= i.longSwipesRatio ? t.slideTo(f + v) : t.slideTo(f)), "prev" === t.swipeDirection && (g > 1 - i.longSwipesRatio ? t.slideTo(f + v) : t.slideTo(f));
            } else {
                if (!i.shortSwipes) return void t.slideTo(t.activeIndex);
                !t.navigation || (l.target !== t.navigation.nextEl && l.target !== t.navigation.prevEl)
                    ? ("next" === t.swipeDirection && t.slideTo(f + v), "prev" === t.swipeDirection && t.slideTo(f))
                    : l.target === t.navigation.nextEl
                    ? t.slideTo(f + v)
                    : t.slideTo(f);
            }
        }
        function A() {
            const e = this,
                { params: t, el: n } = e;
            if (n && 0 === n.offsetWidth) return;
            t.breakpoints && e.setBreakpoint();
            const { allowSlideNext: i, allowSlidePrev: o, snapGrid: s } = e;
            (e.allowSlideNext = !0),
                (e.allowSlidePrev = !0),
                e.updateSize(),
                e.updateSlides(),
                e.updateSlidesClasses(),
                ("auto" === t.slidesPerView || t.slidesPerView > 1) && e.isEnd && !e.isBeginning && !e.params.centeredSlides ? e.slideTo(e.slides.length - 1, 0, !1, !0) : e.slideTo(e.activeIndex, 0, !1, !0),
                e.autoplay && e.autoplay.running && e.autoplay.paused && e.autoplay.run(),
                (e.allowSlidePrev = o),
                (e.allowSlideNext = i),
                e.params.watchOverflow && s !== e.snapGrid && e.checkOverflow();
        }
        function M(e) {
            const t = this;
            t.enabled && (t.allowClick || (t.params.preventClicks && e.preventDefault(), t.params.preventClicksPropagation && t.animating && (e.stopPropagation(), e.stopImmediatePropagation())));
        }
        function P() {
            const e = this,
                { wrapperEl: t, rtlTranslate: n, enabled: i } = e;
            if (!i) return;
            let o;
            (e.previousTranslate = e.translate), e.isHorizontal() ? (e.translate = -t.scrollLeft) : (e.translate = -t.scrollTop), -0 === e.translate && (e.translate = 0), e.updateActiveIndex(), e.updateSlidesClasses();
            const s = e.maxTranslate() - e.minTranslate();
            (o = 0 === s ? 0 : (e.translate - e.minTranslate()) / s), o !== e.progress && e.updateProgress(n ? -e.translate : e.translate), e.emit("setTranslate", e.translate, !1);
        }
        let L = !1;
        function D() {}
        const O = (e, t) => {
                const n = i(),
                    { params: o, touchEvents: s, el: r, wrapperEl: a, device: l, support: c } = e,
                    d = !!o.nested,
                    u = "on" === t ? "addEventListener" : "removeEventListener",
                    p = t;
                if (c.touch) {
                    const t = !("touchstart" !== s.start || !c.passiveListener || !o.passiveListeners) && { passive: !0, capture: !1 };
                    r[u](s.start, e.onTouchStart, t), r[u](s.move, e.onTouchMove, c.passiveListener ? { passive: !1, capture: d } : d), r[u](s.end, e.onTouchEnd, t), s.cancel && r[u](s.cancel, e.onTouchEnd, t);
                } else r[u](s.start, e.onTouchStart, !1), n[u](s.move, e.onTouchMove, d), n[u](s.end, e.onTouchEnd, !1);
                (o.preventClicks || o.preventClicksPropagation) && r[u]("click", e.onClick, !0),
                    o.cssMode && a[u]("scroll", e.onScroll),
                    o.updateOnWindowResize ? e[p](l.ios || l.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", A, !0) : e[p]("observerUpdate", A, !0);
            },
            z = (e, t) => e.grid && t.grid && t.grid.rows > 1;
        var I = {
            init: !0,
            direction: "horizontal",
            touchEventsTarget: "wrapper",
            initialSlide: 0,
            speed: 300,
            cssMode: !1,
            updateOnWindowResize: !0,
            resizeObserver: !0,
            nested: !1,
            createElements: !1,
            enabled: !0,
            focusableElements: "input, select, option, textarea, button, video, label",
            width: null,
            height: null,
            preventInteractionOnTransition: !1,
            userAgent: null,
            url: null,
            edgeSwipeDetection: !1,
            edgeSwipeThreshold: 20,
            autoHeight: !1,
            setWrapperSize: !1,
            virtualTranslate: !1,
            effect: "slide",
            breakpoints: void 0,
            breakpointsBase: "window",
            spaceBetween: 0,
            slidesPerView: 1,
            slidesPerGroup: 1,
            slidesPerGroupSkip: 0,
            slidesPerGroupAuto: !1,
            centeredSlides: !1,
            centeredSlidesBounds: !1,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
            normalizeSlideIndex: !0,
            centerInsufficientSlides: !1,
            watchOverflow: !0,
            roundLengths: !1,
            touchRatio: 1,
            touchAngle: 45,
            simulateTouch: !0,
            shortSwipes: !0,
            longSwipes: !0,
            longSwipesRatio: 0.5,
            longSwipesMs: 300,
            followFinger: !0,
            allowTouchMove: !0,
            threshold: 0,
            touchMoveStopPropagation: !1,
            touchStartPreventDefault: !0,
            touchStartForcePreventDefault: !1,
            touchReleaseOnEdges: !1,
            uniqueNavElements: !0,
            resistance: !0,
            resistanceRatio: 0.85,
            watchSlidesProgress: !1,
            grabCursor: !1,
            preventClicks: !0,
            preventClicksPropagation: !0,
            slideToClickedSlide: !1,
            preloadImages: !0,
            updateOnImagesReady: !0,
            loop: !1,
            loopAdditionalSlides: 0,
            loopedSlides: null,
            loopFillGroupWithBlank: !1,
            loopPreventsSlide: !0,
            allowSlidePrev: !0,
            allowSlideNext: !0,
            swipeHandler: null,
            noSwiping: !0,
            noSwipingClass: "swiper-no-swiping",
            noSwipingSelector: null,
            passiveListeners: !0,
            containerModifierClass: "swiper-",
            slideClass: "swiper-slide",
            slideBlankClass: "swiper-slide-invisible-blank",
            slideActiveClass: "swiper-slide-active",
            slideDuplicateActiveClass: "swiper-slide-duplicate-active",
            slideVisibleClass: "swiper-slide-visible",
            slideDuplicateClass: "swiper-slide-duplicate",
            slideNextClass: "swiper-slide-next",
            slideDuplicateNextClass: "swiper-slide-duplicate-next",
            slidePrevClass: "swiper-slide-prev",
            slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
            wrapperClass: "swiper-wrapper",
            runCallbacksOnInit: !0,
            _emitClasses: !1,
        };
        function N(e, t) {
            return function (n = {}) {
                const i = Object.keys(n)[0],
                    o = n[i];
                "object" == typeof o && null !== o
                    ? (["navigation", "pagination", "scrollbar"].indexOf(i) >= 0 && !0 === e[i] && (e[i] = { auto: !0 }),
                      i in e && "enabled" in o ? (!0 === e[i] && (e[i] = { enabled: !0 }), "object" != typeof e[i] || "enabled" in e[i] || (e[i].enabled = !0), e[i] || (e[i] = { enabled: !1 }), m(t, n)) : m(t, n))
                    : m(t, n);
            };
        }
        const j = {
                eventsEmitter: S,
                update: {
                    updateSize: function () {
                        const e = this;
                        let t, n;
                        const i = e.$el;
                        (t = void 0 !== e.params.width && null !== e.params.width ? e.params.width : i[0].clientWidth),
                            (n = void 0 !== e.params.height && null !== e.params.height ? e.params.height : i[0].clientHeight),
                            (0 === t && e.isHorizontal()) ||
                                (0 === n && e.isVertical()) ||
                                ((t = t - parseInt(i.css("padding-left") || 0, 10) - parseInt(i.css("padding-right") || 0, 10)),
                                (n = n - parseInt(i.css("padding-top") || 0, 10) - parseInt(i.css("padding-bottom") || 0, 10)),
                                Number.isNaN(t) && (t = 0),
                                Number.isNaN(n) && (n = 0),
                                Object.assign(e, { width: t, height: n, size: e.isHorizontal() ? t : n }));
                    },
                    updateSlides: function () {
                        const e = this;
                        function t(t) {
                            return e.isHorizontal()
                                ? t
                                : {
                                      width: "height",
                                      "margin-top": "margin-left",
                                      "margin-bottom ": "margin-right",
                                      "margin-left": "margin-top",
                                      "margin-right": "margin-bottom",
                                      "padding-left": "padding-top",
                                      "padding-right": "padding-bottom",
                                      marginRight: "marginBottom",
                                  }[t];
                        }
                        function n(e, n) {
                            return parseFloat(e.getPropertyValue(t(n)) || 0);
                        }
                        const i = e.params,
                            { $wrapperEl: o, size: s, rtlTranslate: r, wrongRTL: a } = e,
                            l = e.virtual && i.virtual.enabled,
                            c = l ? e.virtual.slides.length : e.slides.length,
                            d = o.children(`.${e.params.slideClass}`),
                            u = l ? e.virtual.slides.length : d.length;
                        let p = [];
                        const h = [],
                            f = [];
                        let m = i.slidesOffsetBefore;
                        "function" == typeof m && (m = i.slidesOffsetBefore.call(e));
                        let v = i.slidesOffsetAfter;
                        "function" == typeof v && (v = i.slidesOffsetAfter.call(e));
                        const y = e.snapGrid.length,
                            b = e.slidesGrid.length;
                        let w = i.spaceBetween,
                            x = -m,
                            T = 0,
                            C = 0;
                        if (void 0 === s) return;
                        "string" == typeof w && w.indexOf("%") >= 0 && (w = (parseFloat(w.replace("%", "")) / 100) * s),
                            (e.virtualSize = -w),
                            r ? d.css({ marginLeft: "", marginBottom: "", marginTop: "" }) : d.css({ marginRight: "", marginBottom: "", marginTop: "" }),
                            i.centeredSlides && i.cssMode && (g(e.wrapperEl, "--swiper-centered-offset-before", ""), g(e.wrapperEl, "--swiper-centered-offset-after", ""));
                        const S = i.grid && i.grid.rows > 1 && e.grid;
                        let k;
                        S && e.grid.initSlides(u);
                        const $ = "auto" === i.slidesPerView && i.breakpoints && Object.keys(i.breakpoints).filter((e) => void 0 !== i.breakpoints[e].slidesPerView).length > 0;
                        for (let o = 0; o < u; o += 1) {
                            k = 0;
                            const r = d.eq(o);
                            if ((S && e.grid.updateSlide(o, r, u, t), "none" !== r.css("display"))) {
                                if ("auto" === i.slidesPerView) {
                                    $ && (d[o].style[t("width")] = "");
                                    const s = getComputedStyle(r[0]),
                                        a = r[0].style.transform,
                                        l = r[0].style.webkitTransform;
                                    if ((a && (r[0].style.transform = "none"), l && (r[0].style.webkitTransform = "none"), i.roundLengths)) k = e.isHorizontal() ? r.outerWidth(!0) : r.outerHeight(!0);
                                    else {
                                        const e = n(s, "width"),
                                            t = n(s, "padding-left"),
                                            i = n(s, "padding-right"),
                                            o = n(s, "margin-left"),
                                            a = n(s, "margin-right"),
                                            l = s.getPropertyValue("box-sizing");
                                        if (l && "border-box" === l) k = e + o + a;
                                        else {
                                            const { clientWidth: n, offsetWidth: s } = r[0];
                                            k = e + t + i + o + a + (s - n);
                                        }
                                    }
                                    a && (r[0].style.transform = a), l && (r[0].style.webkitTransform = l), i.roundLengths && (k = Math.floor(k));
                                } else (k = (s - (i.slidesPerView - 1) * w) / i.slidesPerView), i.roundLengths && (k = Math.floor(k)), d[o] && (d[o].style[t("width")] = `${k}px`);
                                d[o] && (d[o].swiperSlideSize = k),
                                    f.push(k),
                                    i.centeredSlides
                                        ? ((x = x + k / 2 + T / 2 + w),
                                          0 === T && 0 !== o && (x = x - s / 2 - w),
                                          0 === o && (x = x - s / 2 - w),
                                          Math.abs(x) < 0.001 && (x = 0),
                                          i.roundLengths && (x = Math.floor(x)),
                                          C % i.slidesPerGroup == 0 && p.push(x),
                                          h.push(x))
                                        : (i.roundLengths && (x = Math.floor(x)), (C - Math.min(e.params.slidesPerGroupSkip, C)) % e.params.slidesPerGroup == 0 && p.push(x), h.push(x), (x = x + k + w)),
                                    (e.virtualSize += k + w),
                                    (T = k),
                                    (C += 1);
                            }
                        }
                        if (
                            ((e.virtualSize = Math.max(e.virtualSize, s) + v),
                            r && a && ("slide" === i.effect || "coverflow" === i.effect) && o.css({ width: `${e.virtualSize + i.spaceBetween}px` }),
                            i.setWrapperSize && o.css({ [t("width")]: `${e.virtualSize + i.spaceBetween}px` }),
                            S && e.grid.updateWrapperSize(k, p, t),
                            !i.centeredSlides)
                        ) {
                            const t = [];
                            for (let n = 0; n < p.length; n += 1) {
                                let o = p[n];
                                i.roundLengths && (o = Math.floor(o)), p[n] <= e.virtualSize - s && t.push(o);
                            }
                            (p = t), Math.floor(e.virtualSize - s) - Math.floor(p[p.length - 1]) > 1 && p.push(e.virtualSize - s);
                        }
                        if ((0 === p.length && (p = [0]), 0 !== i.spaceBetween)) {
                            const n = e.isHorizontal() && r ? "marginLeft" : t("marginRight");
                            d.filter((e, t) => !i.cssMode || t !== d.length - 1).css({ [n]: `${w}px` });
                        }
                        if (i.centeredSlides && i.centeredSlidesBounds) {
                            let e = 0;
                            f.forEach((t) => {
                                e += t + (i.spaceBetween ? i.spaceBetween : 0);
                            }),
                                (e -= i.spaceBetween);
                            const t = e - s;
                            p = p.map((e) => (e < 0 ? -m : e > t ? t + v : e));
                        }
                        if (i.centerInsufficientSlides) {
                            let e = 0;
                            if (
                                (f.forEach((t) => {
                                    e += t + (i.spaceBetween ? i.spaceBetween : 0);
                                }),
                                (e -= i.spaceBetween),
                                e < s)
                            ) {
                                const t = (s - e) / 2;
                                p.forEach((e, n) => {
                                    p[n] = e - t;
                                }),
                                    h.forEach((e, n) => {
                                        h[n] = e + t;
                                    });
                            }
                        }
                        if ((Object.assign(e, { slides: d, snapGrid: p, slidesGrid: h, slidesSizesGrid: f }), i.centeredSlides && i.cssMode && !i.centeredSlidesBounds)) {
                            g(e.wrapperEl, "--swiper-centered-offset-before", -p[0] + "px"), g(e.wrapperEl, "--swiper-centered-offset-after", e.size / 2 - f[f.length - 1] / 2 + "px");
                            const t = -e.snapGrid[0],
                                n = -e.slidesGrid[0];
                            (e.snapGrid = e.snapGrid.map((e) => e + t)), (e.slidesGrid = e.slidesGrid.map((e) => e + n));
                        }
                        u !== c && e.emit("slidesLengthChange"),
                            p.length !== y && (e.params.watchOverflow && e.checkOverflow(), e.emit("snapGridLengthChange")),
                            h.length !== b && e.emit("slidesGridLengthChange"),
                            i.watchSlidesProgress && e.updateSlidesOffset();
                    },
                    updateAutoHeight: function (e) {
                        const t = this,
                            n = [],
                            i = t.virtual && t.params.virtual.enabled;
                        let o,
                            s = 0;
                        "number" == typeof e ? t.setTransition(e) : !0 === e && t.setTransition(t.params.speed);
                        const r = (e) => (i ? t.slides.filter((t) => parseInt(t.getAttribute("data-swiper-slide-index"), 10) === e)[0] : t.slides.eq(e)[0]);
                        if ("auto" !== t.params.slidesPerView && t.params.slidesPerView > 1)
                            if (t.params.centeredSlides)
                                t.visibleSlides.each((e) => {
                                    n.push(e);
                                });
                            else
                                for (o = 0; o < Math.ceil(t.params.slidesPerView); o += 1) {
                                    const e = t.activeIndex + o;
                                    if (e > t.slides.length && !i) break;
                                    n.push(r(e));
                                }
                        else n.push(r(t.activeIndex));
                        for (o = 0; o < n.length; o += 1)
                            if (void 0 !== n[o]) {
                                const e = n[o].offsetHeight;
                                s = e > s ? e : s;
                            }
                        s && t.$wrapperEl.css("height", `${s}px`);
                    },
                    updateSlidesOffset: function () {
                        const e = this,
                            t = e.slides;
                        for (let n = 0; n < t.length; n += 1) t[n].swiperSlideOffset = e.isHorizontal() ? t[n].offsetLeft : t[n].offsetTop;
                    },
                    updateSlidesProgress: function (e = (this && this.translate) || 0) {
                        const t = this,
                            n = t.params,
                            { slides: i, rtlTranslate: o } = t;
                        if (0 === i.length) return;
                        void 0 === i[0].swiperSlideOffset && t.updateSlidesOffset();
                        let s = -e;
                        o && (s = e), i.removeClass(n.slideVisibleClass), (t.visibleSlidesIndexes = []), (t.visibleSlides = []);
                        for (let e = 0; e < i.length; e += 1) {
                            const r = i[e];
                            let a = r.swiperSlideOffset;
                            n.cssMode && n.centeredSlides && (a -= i[0].swiperSlideOffset);
                            const l = (s + (n.centeredSlides ? t.minTranslate() : 0) - a) / (r.swiperSlideSize + n.spaceBetween),
                                c = -(s - a),
                                d = c + t.slidesSizesGrid[e];
                            ((c >= 0 && c < t.size - 1) || (d > 1 && d <= t.size) || (c <= 0 && d >= t.size)) && (t.visibleSlides.push(r), t.visibleSlidesIndexes.push(e), i.eq(e).addClass(n.slideVisibleClass)), (r.progress = o ? -l : l);
                        }
                        t.visibleSlides = c(t.visibleSlides);
                    },
                    updateProgress: function (e) {
                        const t = this;
                        if (void 0 === e) {
                            const n = t.rtlTranslate ? -1 : 1;
                            e = (t && t.translate && t.translate * n) || 0;
                        }
                        const n = t.params,
                            i = t.maxTranslate() - t.minTranslate();
                        let { progress: o, isBeginning: s, isEnd: r } = t;
                        const a = s,
                            l = r;
                        0 === i ? ((o = 0), (s = !0), (r = !0)) : ((o = (e - t.minTranslate()) / i), (s = o <= 0), (r = o >= 1)),
                            Object.assign(t, { progress: o, isBeginning: s, isEnd: r }),
                            (n.watchSlidesProgress || (n.centeredSlides && n.autoHeight)) && t.updateSlidesProgress(e),
                            s && !a && t.emit("reachBeginning toEdge"),
                            r && !l && t.emit("reachEnd toEdge"),
                            ((a && !s) || (l && !r)) && t.emit("fromEdge"),
                            t.emit("progress", o);
                    },
                    updateSlidesClasses: function () {
                        const e = this,
                            { slides: t, params: n, $wrapperEl: i, activeIndex: o, realIndex: s } = e,
                            r = e.virtual && n.virtual.enabled;
                        let a;
                        t.removeClass(`${n.slideActiveClass} ${n.slideNextClass} ${n.slidePrevClass} ${n.slideDuplicateActiveClass} ${n.slideDuplicateNextClass} ${n.slideDuplicatePrevClass}`),
                            (a = r ? e.$wrapperEl.find(`.${n.slideClass}[data-swiper-slide-index="${o}"]`) : t.eq(o)),
                            a.addClass(n.slideActiveClass),
                            n.loop &&
                                (a.hasClass(n.slideDuplicateClass)
                                    ? i.children(`.${n.slideClass}:not(.${n.slideDuplicateClass})[data-swiper-slide-index="${s}"]`).addClass(n.slideDuplicateActiveClass)
                                    : i.children(`.${n.slideClass}.${n.slideDuplicateClass}[data-swiper-slide-index="${s}"]`).addClass(n.slideDuplicateActiveClass));
                        let l = a.nextAll(`.${n.slideClass}`).eq(0).addClass(n.slideNextClass);
                        n.loop && 0 === l.length && ((l = t.eq(0)), l.addClass(n.slideNextClass));
                        let c = a.prevAll(`.${n.slideClass}`).eq(0).addClass(n.slidePrevClass);
                        n.loop && 0 === c.length && ((c = t.eq(-1)), c.addClass(n.slidePrevClass)),
                            n.loop &&
                                (l.hasClass(n.slideDuplicateClass)
                                    ? i.children(`.${n.slideClass}:not(.${n.slideDuplicateClass})[data-swiper-slide-index="${l.attr("data-swiper-slide-index")}"]`).addClass(n.slideDuplicateNextClass)
                                    : i.children(`.${n.slideClass}.${n.slideDuplicateClass}[data-swiper-slide-index="${l.attr("data-swiper-slide-index")}"]`).addClass(n.slideDuplicateNextClass),
                                c.hasClass(n.slideDuplicateClass)
                                    ? i.children(`.${n.slideClass}:not(.${n.slideDuplicateClass})[data-swiper-slide-index="${c.attr("data-swiper-slide-index")}"]`).addClass(n.slideDuplicatePrevClass)
                                    : i.children(`.${n.slideClass}.${n.slideDuplicateClass}[data-swiper-slide-index="${c.attr("data-swiper-slide-index")}"]`).addClass(n.slideDuplicatePrevClass)),
                            e.emitSlidesClasses();
                    },
                    updateActiveIndex: function (e) {
                        const t = this,
                            n = t.rtlTranslate ? t.translate : -t.translate,
                            { slidesGrid: i, snapGrid: o, params: s, activeIndex: r, realIndex: a, snapIndex: l } = t;
                        let c,
                            d = e;
                        if (void 0 === d) {
                            for (let e = 0; e < i.length; e += 1) void 0 !== i[e + 1] ? (n >= i[e] && n < i[e + 1] - (i[e + 1] - i[e]) / 2 ? (d = e) : n >= i[e] && n < i[e + 1] && (d = e + 1)) : n >= i[e] && (d = e);
                            s.normalizeSlideIndex && (d < 0 || void 0 === d) && (d = 0);
                        }
                        if (o.indexOf(n) >= 0) c = o.indexOf(n);
                        else {
                            const e = Math.min(s.slidesPerGroupSkip, d);
                            c = e + Math.floor((d - e) / s.slidesPerGroup);
                        }
                        if ((c >= o.length && (c = o.length - 1), d === r)) return void (c !== l && ((t.snapIndex = c), t.emit("snapIndexChange")));
                        const u = parseInt(t.slides.eq(d).attr("data-swiper-slide-index") || d, 10);
                        Object.assign(t, { snapIndex: c, realIndex: u, previousIndex: r, activeIndex: d }),
                            t.emit("activeIndexChange"),
                            t.emit("snapIndexChange"),
                            a !== u && t.emit("realIndexChange"),
                            (t.initialized || t.params.runCallbacksOnInit) && t.emit("slideChange");
                    },
                    updateClickedSlide: function (e) {
                        const t = this,
                            n = t.params,
                            i = c(e.target).closest(`.${n.slideClass}`)[0];
                        let o,
                            s = !1;
                        if (i)
                            for (let e = 0; e < t.slides.length; e += 1)
                                if (t.slides[e] === i) {
                                    (s = !0), (o = e);
                                    break;
                                }
                        if (!i || !s) return (t.clickedSlide = void 0), void (t.clickedIndex = void 0);
                        (t.clickedSlide = i),
                            t.virtual && t.params.virtual.enabled ? (t.clickedIndex = parseInt(c(i).attr("data-swiper-slide-index"), 10)) : (t.clickedIndex = o),
                            n.slideToClickedSlide && void 0 !== t.clickedIndex && t.clickedIndex !== t.activeIndex && t.slideToClickedSlide();
                    },
                },
                translate: {
                    getTranslate: function (e = this.isHorizontal() ? "x" : "y") {
                        const { params: t, rtlTranslate: n, translate: i, $wrapperEl: o } = this;
                        if (t.virtualTranslate) return n ? -i : i;
                        if (t.cssMode) return i;
                        let s = h(o[0], e);
                        return n && (s = -s), s || 0;
                    },
                    setTranslate: function (e, t) {
                        const n = this,
                            { rtlTranslate: i, params: o, $wrapperEl: s, wrapperEl: r, progress: a } = n;
                        let l,
                            c = 0,
                            d = 0;
                        n.isHorizontal() ? (c = i ? -e : e) : (d = e),
                            o.roundLengths && ((c = Math.floor(c)), (d = Math.floor(d))),
                            o.cssMode ? (r[n.isHorizontal() ? "scrollLeft" : "scrollTop"] = n.isHorizontal() ? -c : -d) : o.virtualTranslate || s.transform(`translate3d(${c}px, ${d}px, 0px)`),
                            (n.previousTranslate = n.translate),
                            (n.translate = n.isHorizontal() ? c : d);
                        const u = n.maxTranslate() - n.minTranslate();
                        (l = 0 === u ? 0 : (e - n.minTranslate()) / u), l !== a && n.updateProgress(e), n.emit("setTranslate", n.translate, t);
                    },
                    minTranslate: function () {
                        return -this.snapGrid[0];
                    },
                    maxTranslate: function () {
                        return -this.snapGrid[this.snapGrid.length - 1];
                    },
                    translateTo: function (e = 0, t = this.params.speed, n = !0, i = !0, o) {
                        const s = this,
                            { params: r, wrapperEl: a } = s;
                        if (s.animating && r.preventInteractionOnTransition) return !1;
                        const l = s.minTranslate(),
                            c = s.maxTranslate();
                        let d;
                        if (((d = i && e > l ? l : i && e < c ? c : e), s.updateProgress(d), r.cssMode)) {
                            const e = s.isHorizontal();
                            if (0 === t) a[e ? "scrollLeft" : "scrollTop"] = -d;
                            else {
                                if (!s.support.smoothScroll) return v({ swiper: s, targetPosition: -d, side: e ? "left" : "top" }), !0;
                                a.scrollTo({ [e ? "left" : "top"]: -d, behavior: "smooth" });
                            }
                            return !0;
                        }
                        return (
                            0 === t
                                ? (s.setTransition(0), s.setTranslate(d), n && (s.emit("beforeTransitionStart", t, o), s.emit("transitionEnd")))
                                : (s.setTransition(t),
                                  s.setTranslate(d),
                                  n && (s.emit("beforeTransitionStart", t, o), s.emit("transitionStart")),
                                  s.animating ||
                                      ((s.animating = !0),
                                      s.onTranslateToWrapperTransitionEnd ||
                                          (s.onTranslateToWrapperTransitionEnd = function (e) {
                                              s &&
                                                  !s.destroyed &&
                                                  e.target === this &&
                                                  (s.$wrapperEl[0].removeEventListener("transitionend", s.onTranslateToWrapperTransitionEnd),
                                                  s.$wrapperEl[0].removeEventListener("webkitTransitionEnd", s.onTranslateToWrapperTransitionEnd),
                                                  (s.onTranslateToWrapperTransitionEnd = null),
                                                  delete s.onTranslateToWrapperTransitionEnd,
                                                  n && s.emit("transitionEnd"));
                                          }),
                                      s.$wrapperEl[0].addEventListener("transitionend", s.onTranslateToWrapperTransitionEnd),
                                      s.$wrapperEl[0].addEventListener("webkitTransitionEnd", s.onTranslateToWrapperTransitionEnd))),
                            !0
                        );
                    },
                },
                transition: {
                    setTransition: function (e, t) {
                        const n = this;
                        n.params.cssMode || n.$wrapperEl.transition(e), n.emit("setTransition", e, t);
                    },
                    transitionStart: function (e = !0, t) {
                        const n = this,
                            { params: i } = n;
                        i.cssMode || (i.autoHeight && n.updateAutoHeight(), k({ swiper: n, runCallbacks: e, direction: t, step: "Start" }));
                    },
                    transitionEnd: function (e = !0, t) {
                        const n = this,
                            { params: i } = n;
                        (n.animating = !1), i.cssMode || (n.setTransition(0), k({ swiper: n, runCallbacks: e, direction: t, step: "End" }));
                    },
                },
                slide: {
                    slideTo: function (e = 0, t = this.params.speed, n = !0, i, o) {
                        if ("number" != typeof e && "string" != typeof e) throw new Error(`The 'index' argument cannot have type other than 'number' or 'string'. [${typeof e}] given.`);
                        if ("string" == typeof e) {
                            const t = parseInt(e, 10);
                            if (!isFinite(t)) throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${e}] given.`);
                            e = t;
                        }
                        const s = this;
                        let r = e;
                        r < 0 && (r = 0);
                        const { params: a, snapGrid: l, slidesGrid: c, previousIndex: d, activeIndex: u, rtlTranslate: p, wrapperEl: h, enabled: f } = s;
                        if ((s.animating && a.preventInteractionOnTransition) || (!f && !i && !o)) return !1;
                        const m = Math.min(s.params.slidesPerGroupSkip, r);
                        let g = m + Math.floor((r - m) / s.params.slidesPerGroup);
                        g >= l.length && (g = l.length - 1), (u || a.initialSlide || 0) === (d || 0) && n && s.emit("beforeSlideChangeStart");
                        const y = -l[g];
                        if ((s.updateProgress(y), a.normalizeSlideIndex))
                            for (let e = 0; e < c.length; e += 1) {
                                const t = -Math.floor(100 * y),
                                    n = Math.floor(100 * c[e]),
                                    i = Math.floor(100 * c[e + 1]);
                                void 0 !== c[e + 1] ? (t >= n && t < i - (i - n) / 2 ? (r = e) : t >= n && t < i && (r = e + 1)) : t >= n && (r = e);
                            }
                        if (s.initialized && r !== u) {
                            if (!s.allowSlideNext && y < s.translate && y < s.minTranslate()) return !1;
                            if (!s.allowSlidePrev && y > s.translate && y > s.maxTranslate() && (u || 0) !== r) return !1;
                        }
                        let b;
                        if (((b = r > u ? "next" : r < u ? "prev" : "reset"), (p && -y === s.translate) || (!p && y === s.translate)))
                            return s.updateActiveIndex(r), a.autoHeight && s.updateAutoHeight(), s.updateSlidesClasses(), "slide" !== a.effect && s.setTranslate(y), "reset" !== b && (s.transitionStart(n, b), s.transitionEnd(n, b)), !1;
                        if (a.cssMode) {
                            const e = s.isHorizontal(),
                                n = p ? y : -y;
                            if (0 === t) {
                                const t = s.virtual && s.params.virtual.enabled;
                                t && (s.wrapperEl.style.scrollSnapType = "none"),
                                    (h[e ? "scrollLeft" : "scrollTop"] = n),
                                    t &&
                                        requestAnimationFrame(() => {
                                            s.wrapperEl.style.scrollSnapType = "";
                                        });
                            } else {
                                if (!s.support.smoothScroll) return v({ swiper: s, targetPosition: n, side: e ? "left" : "top" }), !0;
                                h.scrollTo({ [e ? "left" : "top"]: n, behavior: "smooth" });
                            }
                            return !0;
                        }
                        return (
                            0 === t
                                ? (s.setTransition(0), s.setTranslate(y), s.updateActiveIndex(r), s.updateSlidesClasses(), s.emit("beforeTransitionStart", t, i), s.transitionStart(n, b), s.transitionEnd(n, b))
                                : (s.setTransition(t),
                                  s.setTranslate(y),
                                  s.updateActiveIndex(r),
                                  s.updateSlidesClasses(),
                                  s.emit("beforeTransitionStart", t, i),
                                  s.transitionStart(n, b),
                                  s.animating ||
                                      ((s.animating = !0),
                                      s.onSlideToWrapperTransitionEnd ||
                                          (s.onSlideToWrapperTransitionEnd = function (e) {
                                              s &&
                                                  !s.destroyed &&
                                                  e.target === this &&
                                                  (s.$wrapperEl[0].removeEventListener("transitionend", s.onSlideToWrapperTransitionEnd),
                                                  s.$wrapperEl[0].removeEventListener("webkitTransitionEnd", s.onSlideToWrapperTransitionEnd),
                                                  (s.onSlideToWrapperTransitionEnd = null),
                                                  delete s.onSlideToWrapperTransitionEnd,
                                                  s.transitionEnd(n, b));
                                          }),
                                      s.$wrapperEl[0].addEventListener("transitionend", s.onSlideToWrapperTransitionEnd),
                                      s.$wrapperEl[0].addEventListener("webkitTransitionEnd", s.onSlideToWrapperTransitionEnd))),
                            !0
                        );
                    },
                    slideToLoop: function (e = 0, t = this.params.speed, n = !0, i) {
                        const o = this;
                        let s = e;
                        return o.params.loop && (s += o.loopedSlides), o.slideTo(s, t, n, i);
                    },
                    slideNext: function (e = this.params.speed, t = !0, n) {
                        const i = this,
                            { animating: o, enabled: s, params: r } = i;
                        if (!s) return i;
                        let a = r.slidesPerGroup;
                        "auto" === r.slidesPerView && 1 === r.slidesPerGroup && r.slidesPerGroupAuto && (a = Math.max(i.slidesPerViewDynamic("current", !0), 1));
                        const l = i.activeIndex < r.slidesPerGroupSkip ? 1 : a;
                        if (r.loop) {
                            if (o && r.loopPreventsSlide) return !1;
                            i.loopFix(), (i._clientLeft = i.$wrapperEl[0].clientLeft);
                        }
                        return i.slideTo(i.activeIndex + l, e, t, n);
                    },
                    slidePrev: function (e = this.params.speed, t = !0, n) {
                        const i = this,
                            { params: o, animating: s, snapGrid: r, slidesGrid: a, rtlTranslate: l, enabled: c } = i;
                        if (!c) return i;
                        if (o.loop) {
                            if (s && o.loopPreventsSlide) return !1;
                            i.loopFix(), (i._clientLeft = i.$wrapperEl[0].clientLeft);
                        }
                        function d(e) {
                            return e < 0 ? -Math.floor(Math.abs(e)) : Math.floor(e);
                        }
                        const u = d(l ? i.translate : -i.translate),
                            p = r.map((e) => d(e));
                        let h = r[p.indexOf(u) - 1];
                        if (void 0 === h && o.cssMode) {
                            let e;
                            r.forEach((t, n) => {
                                u >= t && (e = n);
                            }),
                                void 0 !== e && (h = r[e > 0 ? e - 1 : e]);
                        }
                        let f = 0;
                        return (
                            void 0 !== h &&
                                ((f = a.indexOf(h)),
                                f < 0 && (f = i.activeIndex - 1),
                                "auto" === o.slidesPerView && 1 === o.slidesPerGroup && o.slidesPerGroupAuto && ((f = f - i.slidesPerViewDynamic("previous", !0) + 1), (f = Math.max(f, 0)))),
                            i.slideTo(f, e, t, n)
                        );
                    },
                    slideReset: function (e = this.params.speed, t = !0, n) {
                        return this.slideTo(this.activeIndex, e, t, n);
                    },
                    slideToClosest: function (e = this.params.speed, t = !0, n, i = 0.5) {
                        const o = this;
                        let s = o.activeIndex;
                        const r = Math.min(o.params.slidesPerGroupSkip, s),
                            a = r + Math.floor((s - r) / o.params.slidesPerGroup),
                            l = o.rtlTranslate ? o.translate : -o.translate;
                        if (l >= o.snapGrid[a]) {
                            const e = o.snapGrid[a];
                            l - e > (o.snapGrid[a + 1] - e) * i && (s += o.params.slidesPerGroup);
                        } else {
                            const e = o.snapGrid[a - 1];
                            l - e <= (o.snapGrid[a] - e) * i && (s -= o.params.slidesPerGroup);
                        }
                        return (s = Math.max(s, 0)), (s = Math.min(s, o.slidesGrid.length - 1)), o.slideTo(s, e, t, n);
                    },
                    slideToClickedSlide: function () {
                        const e = this,
                            { params: t, $wrapperEl: n } = e,
                            i = "auto" === t.slidesPerView ? e.slidesPerViewDynamic() : t.slidesPerView;
                        let o,
                            s = e.clickedIndex;
                        if (t.loop) {
                            if (e.animating) return;
                            (o = parseInt(c(e.clickedSlide).attr("data-swiper-slide-index"), 10)),
                                t.centeredSlides
                                    ? s < e.loopedSlides - i / 2 || s > e.slides.length - e.loopedSlides + i / 2
                                        ? (e.loopFix(),
                                          (s = n.children(`.${t.slideClass}[data-swiper-slide-index="${o}"]:not(.${t.slideDuplicateClass})`).eq(0).index()),
                                          u(() => {
                                              e.slideTo(s);
                                          }))
                                        : e.slideTo(s)
                                    : s > e.slides.length - i
                                    ? (e.loopFix(),
                                      (s = n.children(`.${t.slideClass}[data-swiper-slide-index="${o}"]:not(.${t.slideDuplicateClass})`).eq(0).index()),
                                      u(() => {
                                          e.slideTo(s);
                                      }))
                                    : e.slideTo(s);
                        } else e.slideTo(s);
                    },
                },
                loop: {
                    loopCreate: function () {
                        const e = this,
                            t = i(),
                            { params: n, $wrapperEl: o } = e;
                        o.children(`.${n.slideClass}.${n.slideDuplicateClass}`).remove();
                        let s = o.children(`.${n.slideClass}`);
                        if (n.loopFillGroupWithBlank) {
                            const e = n.slidesPerGroup - (s.length % n.slidesPerGroup);
                            if (e !== n.slidesPerGroup) {
                                for (let i = 0; i < e; i += 1) {
                                    const e = c(t.createElement("div")).addClass(`${n.slideClass} ${n.slideBlankClass}`);
                                    o.append(e);
                                }
                                s = o.children(`.${n.slideClass}`);
                            }
                        }
                        "auto" !== n.slidesPerView || n.loopedSlides || (n.loopedSlides = s.length),
                            (e.loopedSlides = Math.ceil(parseFloat(n.loopedSlides || n.slidesPerView, 10))),
                            (e.loopedSlides += n.loopAdditionalSlides),
                            e.loopedSlides > s.length && (e.loopedSlides = s.length);
                        const r = [],
                            a = [];
                        s.each((t, n) => {
                            const i = c(t);
                            n < e.loopedSlides && a.push(t), n < s.length && n >= s.length - e.loopedSlides && r.push(t), i.attr("data-swiper-slide-index", n);
                        });
                        for (let e = 0; e < a.length; e += 1) o.append(c(a[e].cloneNode(!0)).addClass(n.slideDuplicateClass));
                        for (let e = r.length - 1; e >= 0; e -= 1) o.prepend(c(r[e].cloneNode(!0)).addClass(n.slideDuplicateClass));
                    },
                    loopFix: function () {
                        const e = this;
                        e.emit("beforeLoopFix");
                        const { activeIndex: t, slides: n, loopedSlides: i, allowSlidePrev: o, allowSlideNext: s, snapGrid: r, rtlTranslate: a } = e;
                        let l;
                        (e.allowSlidePrev = !0), (e.allowSlideNext = !0);
                        const c = -r[t] - e.getTranslate();
                        t < i
                            ? ((l = n.length - 3 * i + t), (l += i), e.slideTo(l, 0, !1, !0) && 0 !== c && e.setTranslate((a ? -e.translate : e.translate) - c))
                            : t >= n.length - i && ((l = -n.length + t + i), (l += i), e.slideTo(l, 0, !1, !0) && 0 !== c && e.setTranslate((a ? -e.translate : e.translate) - c)),
                            (e.allowSlidePrev = o),
                            (e.allowSlideNext = s),
                            e.emit("loopFix");
                    },
                    loopDestroy: function () {
                        const { $wrapperEl: e, params: t, slides: n } = this;
                        e.children(`.${t.slideClass}.${t.slideDuplicateClass},.${t.slideClass}.${t.slideBlankClass}`).remove(), n.removeAttr("data-swiper-slide-index");
                    },
                },
                grabCursor: {
                    setGrabCursor: function (e) {
                        const t = this;
                        if (t.support.touch || !t.params.simulateTouch || (t.params.watchOverflow && t.isLocked) || t.params.cssMode) return;
                        const n = "container" === t.params.touchEventsTarget ? t.el : t.wrapperEl;
                        (n.style.cursor = "move"), (n.style.cursor = e ? "-webkit-grabbing" : "-webkit-grab"), (n.style.cursor = e ? "-moz-grabbin" : "-moz-grab"), (n.style.cursor = e ? "grabbing" : "grab");
                    },
                    unsetGrabCursor: function () {
                        const e = this;
                        e.support.touch || (e.params.watchOverflow && e.isLocked) || e.params.cssMode || (e["container" === e.params.touchEventsTarget ? "el" : "wrapperEl"].style.cursor = "");
                    },
                },
                events: {
                    attachEvents: function () {
                        const e = this,
                            t = i(),
                            { params: n, support: o } = e;
                        (e.onTouchStart = $.bind(e)),
                            (e.onTouchMove = _.bind(e)),
                            (e.onTouchEnd = E.bind(e)),
                            n.cssMode && (e.onScroll = P.bind(e)),
                            (e.onClick = M.bind(e)),
                            o.touch && !L && (t.addEventListener("touchstart", D), (L = !0)),
                            O(e, "on");
                    },
                    detachEvents: function () {
                        O(this, "off");
                    },
                },
                breakpoints: {
                    setBreakpoint: function () {
                        const e = this,
                            { activeIndex: t, initialized: n, loopedSlides: i = 0, params: o, $el: s } = e,
                            r = o.breakpoints;
                        if (!r || (r && 0 === Object.keys(r).length)) return;
                        const a = e.getBreakpoint(r, e.params.breakpointsBase, e.el);
                        if (!a || e.currentBreakpoint === a) return;
                        const l = (a in r ? r[a] : void 0) || e.originalParams,
                            c = z(e, o),
                            d = z(e, l),
                            u = o.enabled;
                        c && !d
                            ? (s.removeClass(`${o.containerModifierClass}grid ${o.containerModifierClass}grid-column`), e.emitContainerClasses())
                            : !c &&
                              d &&
                              (s.addClass(`${o.containerModifierClass}grid`),
                              ((l.grid.fill && "column" === l.grid.fill) || (!l.grid.fill && "column" === o.grid.fill)) && s.addClass(`${o.containerModifierClass}grid-column`),
                              e.emitContainerClasses());
                        const p = l.direction && l.direction !== o.direction,
                            h = o.loop && (l.slidesPerView !== o.slidesPerView || p);
                        p && n && e.changeDirection(), m(e.params, l);
                        const f = e.params.enabled;
                        Object.assign(e, { allowTouchMove: e.params.allowTouchMove, allowSlideNext: e.params.allowSlideNext, allowSlidePrev: e.params.allowSlidePrev }),
                            u && !f ? e.disable() : !u && f && e.enable(),
                            (e.currentBreakpoint = a),
                            e.emit("_beforeBreakpoint", l),
                            h && n && (e.loopDestroy(), e.loopCreate(), e.updateSlides(), e.slideTo(t - i + e.loopedSlides, 0, !1)),
                            e.emit("breakpoint", l);
                    },
                    getBreakpoint: function (e, t = "window", n) {
                        if (!e || ("container" === t && !n)) return;
                        let i = !1;
                        const o = s(),
                            r = "window" === t ? o.innerHeight : n.clientHeight,
                            a = Object.keys(e).map((e) => {
                                if ("string" == typeof e && 0 === e.indexOf("@")) {
                                    const t = parseFloat(e.substr(1));
                                    return { value: r * t, point: e };
                                }
                                return { value: e, point: e };
                            });
                        a.sort((e, t) => parseInt(e.value, 10) - parseInt(t.value, 10));
                        for (let e = 0; e < a.length; e += 1) {
                            const { point: s, value: r } = a[e];
                            "window" === t ? o.matchMedia(`(min-width: ${r}px)`).matches && (i = s) : r <= n.clientWidth && (i = s);
                        }
                        return i || "max";
                    },
                },
                checkOverflow: {
                    checkOverflow: function () {
                        const e = this,
                            { isLocked: t, params: n } = e,
                            { slidesOffsetBefore: i } = n;
                        if (i) {
                            const t = e.slides.length - 1,
                                n = e.slidesGrid[t] + e.slidesSizesGrid[t] + 2 * i;
                            e.isLocked = e.size > n;
                        } else e.isLocked = 1 === e.snapGrid.length;
                        !0 === n.allowSlideNext && (e.allowSlideNext = !e.isLocked),
                            !0 === n.allowSlidePrev && (e.allowSlidePrev = !e.isLocked),
                            t && t !== e.isLocked && (e.isEnd = !1),
                            t !== e.isLocked && e.emit(e.isLocked ? "lock" : "unlock");
                    },
                },
                classes: {
                    addClasses: function () {
                        const e = this,
                            { classNames: t, params: n, rtl: i, $el: o, device: s, support: r } = e,
                            a = (function (e, t) {
                                const n = [];
                                return (
                                    e.forEach((e) => {
                                        "object" == typeof e
                                            ? Object.keys(e).forEach((i) => {
                                                  e[i] && n.push(t + i);
                                              })
                                            : "string" == typeof e && n.push(t + e);
                                    }),
                                    n
                                );
                            })(
                                [
                                    "initialized",
                                    n.direction,
                                    { "pointer-events": !r.touch },
                                    { "free-mode": e.params.freeMode && n.freeMode.enabled },
                                    { autoheight: n.autoHeight },
                                    { rtl: i },
                                    { grid: n.grid && n.grid.rows > 1 },
                                    { "grid-column": n.grid && n.grid.rows > 1 && "column" === n.grid.fill },
                                    { android: s.android },
                                    { ios: s.ios },
                                    { "css-mode": n.cssMode },
                                    { centered: n.cssMode && n.centeredSlides },
                                ],
                                n.containerModifierClass
                            );
                        t.push(...a), o.addClass([...t].join(" ")), e.emitContainerClasses();
                    },
                    removeClasses: function () {
                        const { $el: e, classNames: t } = this;
                        e.removeClass(t.join(" ")), this.emitContainerClasses();
                    },
                },
                images: {
                    loadImage: function (e, t, n, i, o, r) {
                        const a = s();
                        let l;
                        function d() {
                            r && r();
                        }
                        c(e).parent("picture")[0] || (e.complete && o) ? d() : t ? ((l = new a.Image()), (l.onload = d), (l.onerror = d), i && (l.sizes = i), n && (l.srcset = n), t && (l.src = t)) : d();
                    },
                    preloadImages: function () {
                        const e = this;
                        function t() {
                            null != e && e && !e.destroyed && (void 0 !== e.imagesLoaded && (e.imagesLoaded += 1), e.imagesLoaded === e.imagesToLoad.length && (e.params.updateOnImagesReady && e.update(), e.emit("imagesReady")));
                        }
                        e.imagesToLoad = e.$el.find("img");
                        for (let n = 0; n < e.imagesToLoad.length; n += 1) {
                            const i = e.imagesToLoad[n];
                            e.loadImage(i, i.currentSrc || i.getAttribute("src"), i.srcset || i.getAttribute("srcset"), i.sizes || i.getAttribute("sizes"), !0, t);
                        }
                    },
                },
            },
            R = {};
        class H {
            constructor(...e) {
                let t, n;
                if ((1 === e.length && e[0].constructor && "Object" === Object.prototype.toString.call(e[0]).slice(8, -1) ? (n = e[0]) : ([t, n] = e), n || (n = {}), (n = m({}, n)), t && !n.el && (n.el = t), n.el && c(n.el).length > 1)) {
                    const e = [];
                    return (
                        c(n.el).each((t) => {
                            const i = m({}, n, { el: t });
                            e.push(new H(i));
                        }),
                        e
                    );
                }
                const i = this;
                (i.__swiper__ = !0),
                    (i.support = x()),
                    (i.device = T({ userAgent: n.userAgent })),
                    (i.browser = C()),
                    (i.eventsListeners = {}),
                    (i.eventsAnyListeners = []),
                    (i.modules = [...i.__modules__]),
                    n.modules && Array.isArray(n.modules) && i.modules.push(...n.modules);
                const o = {};
                i.modules.forEach((e) => {
                    e({ swiper: i, extendParams: N(n, o), on: i.on.bind(i), once: i.once.bind(i), off: i.off.bind(i), emit: i.emit.bind(i) });
                });
                const s = m({}, I, o);
                return (
                    (i.params = m({}, s, R, n)),
                    (i.originalParams = m({}, i.params)),
                    (i.passedParams = m({}, n)),
                    i.params &&
                        i.params.on &&
                        Object.keys(i.params.on).forEach((e) => {
                            i.on(e, i.params.on[e]);
                        }),
                    i.params && i.params.onAny && i.onAny(i.params.onAny),
                    (i.$ = c),
                    Object.assign(i, {
                        enabled: i.params.enabled,
                        el: t,
                        classNames: [],
                        slides: c(),
                        slidesGrid: [],
                        snapGrid: [],
                        slidesSizesGrid: [],
                        isHorizontal: () => "horizontal" === i.params.direction,
                        isVertical: () => "vertical" === i.params.direction,
                        activeIndex: 0,
                        realIndex: 0,
                        isBeginning: !0,
                        isEnd: !1,
                        translate: 0,
                        previousTranslate: 0,
                        progress: 0,
                        velocity: 0,
                        animating: !1,
                        allowSlideNext: i.params.allowSlideNext,
                        allowSlidePrev: i.params.allowSlidePrev,
                        touchEvents: (function () {
                            const e = ["touchstart", "touchmove", "touchend", "touchcancel"],
                                t = ["pointerdown", "pointermove", "pointerup"];
                            return (
                                (i.touchEventsTouch = { start: e[0], move: e[1], end: e[2], cancel: e[3] }),
                                (i.touchEventsDesktop = { start: t[0], move: t[1], end: t[2] }),
                                i.support.touch || !i.params.simulateTouch ? i.touchEventsTouch : i.touchEventsDesktop
                            );
                        })(),
                        touchEventsData: {
                            isTouched: void 0,
                            isMoved: void 0,
                            allowTouchCallbacks: void 0,
                            touchStartTime: void 0,
                            isScrolling: void 0,
                            currentTranslate: void 0,
                            startTranslate: void 0,
                            allowThresholdMove: void 0,
                            focusableElements: i.params.focusableElements,
                            lastClickTime: p(),
                            clickTimeout: void 0,
                            velocities: [],
                            allowMomentumBounce: void 0,
                            isTouchEvent: void 0,
                            startMoving: void 0,
                        },
                        allowClick: !0,
                        allowTouchMove: i.params.allowTouchMove,
                        touches: { startX: 0, startY: 0, currentX: 0, currentY: 0, diff: 0 },
                        imagesToLoad: [],
                        imagesLoaded: 0,
                    }),
                    i.emit("_swiper"),
                    i.params.init && i.init(),
                    i
                );
            }
            enable() {
                const e = this;
                e.enabled || ((e.enabled = !0), e.params.grabCursor && e.setGrabCursor(), e.emit("enable"));
            }
            disable() {
                const e = this;
                e.enabled && ((e.enabled = !1), e.params.grabCursor && e.unsetGrabCursor(), e.emit("disable"));
            }
            setProgress(e, t) {
                const n = this;
                e = Math.min(Math.max(e, 0), 1);
                const i = n.minTranslate(),
                    o = (n.maxTranslate() - i) * e + i;
                n.translateTo(o, void 0 === t ? 0 : t), n.updateActiveIndex(), n.updateSlidesClasses();
            }
            emitContainerClasses() {
                const e = this;
                if (!e.params._emitClasses || !e.el) return;
                const t = e.el.className.split(" ").filter((t) => 0 === t.indexOf("swiper") || 0 === t.indexOf(e.params.containerModifierClass));
                e.emit("_containerClasses", t.join(" "));
            }
            getSlideClasses(e) {
                const t = this;
                return e.className
                    .split(" ")
                    .filter((e) => 0 === e.indexOf("swiper-slide") || 0 === e.indexOf(t.params.slideClass))
                    .join(" ");
            }
            emitSlidesClasses() {
                const e = this;
                if (!e.params._emitClasses || !e.el) return;
                const t = [];
                e.slides.each((n) => {
                    const i = e.getSlideClasses(n);
                    t.push({ slideEl: n, classNames: i }), e.emit("_slideClass", n, i);
                }),
                    e.emit("_slideClasses", t);
            }
            slidesPerViewDynamic(e = "current", t = !1) {
                const { params: n, slides: i, slidesGrid: o, slidesSizesGrid: s, size: r, activeIndex: a } = this;
                let l = 1;
                if (n.centeredSlides) {
                    let e,
                        t = i[a].swiperSlideSize;
                    for (let n = a + 1; n < i.length; n += 1) i[n] && !e && ((t += i[n].swiperSlideSize), (l += 1), t > r && (e = !0));
                    for (let n = a - 1; n >= 0; n -= 1) i[n] && !e && ((t += i[n].swiperSlideSize), (l += 1), t > r && (e = !0));
                } else if ("current" === e) for (let e = a + 1; e < i.length; e += 1) (t ? o[e] + s[e] - o[a] < r : o[e] - o[a] < r) && (l += 1);
                else for (let e = a - 1; e >= 0; e -= 1) o[a] - o[e] < r && (l += 1);
                return l;
            }
            update() {
                const e = this;
                if (!e || e.destroyed) return;
                const { snapGrid: t, params: n } = e;
                function i() {
                    const t = e.rtlTranslate ? -1 * e.translate : e.translate,
                        n = Math.min(Math.max(t, e.maxTranslate()), e.minTranslate());
                    e.setTranslate(n), e.updateActiveIndex(), e.updateSlidesClasses();
                }
                let o;
                n.breakpoints && e.setBreakpoint(),
                    e.updateSize(),
                    e.updateSlides(),
                    e.updateProgress(),
                    e.updateSlidesClasses(),
                    e.params.freeMode && e.params.freeMode.enabled
                        ? (i(), e.params.autoHeight && e.updateAutoHeight())
                        : ((o = ("auto" === e.params.slidesPerView || e.params.slidesPerView > 1) && e.isEnd && !e.params.centeredSlides ? e.slideTo(e.slides.length - 1, 0, !1, !0) : e.slideTo(e.activeIndex, 0, !1, !0)), o || i()),
                    n.watchOverflow && t !== e.snapGrid && e.checkOverflow(),
                    e.emit("update");
            }
            changeDirection(e, t = !0) {
                const n = this,
                    i = n.params.direction;
                return (
                    e || (e = "horizontal" === i ? "vertical" : "horizontal"),
                    e === i ||
                        ("horizontal" !== e && "vertical" !== e) ||
                        (n.$el.removeClass(`${n.params.containerModifierClass}${i}`).addClass(`${n.params.containerModifierClass}${e}`),
                        n.emitContainerClasses(),
                        (n.params.direction = e),
                        n.slides.each((t) => {
                            "vertical" === e ? (t.style.width = "") : (t.style.height = "");
                        }),
                        n.emit("changeDirection"),
                        t && n.update()),
                    n
                );
            }
            mount(e) {
                const t = this;
                if (t.mounted) return !0;
                const n = c(e || t.params.el);
                if (!(e = n[0])) return !1;
                e.swiper = t;
                const o = () => `.${(t.params.wrapperClass || "").trim().split(" ").join(".")}`;
                let s = (() => {
                    if (e && e.shadowRoot && e.shadowRoot.querySelector) {
                        const t = c(e.shadowRoot.querySelector(o()));
                        return (t.children = (e) => n.children(e)), t;
                    }
                    return n.children(o());
                })();
                if (0 === s.length && t.params.createElements) {
                    const e = i().createElement("div");
                    (s = c(e)),
                        (e.className = t.params.wrapperClass),
                        n.append(e),
                        n.children(`.${t.params.slideClass}`).each((e) => {
                            s.append(e);
                        });
                }
                return (
                    Object.assign(t, {
                        $el: n,
                        el: e,
                        $wrapperEl: s,
                        wrapperEl: s[0],
                        mounted: !0,
                        rtl: "rtl" === e.dir.toLowerCase() || "rtl" === n.css("direction"),
                        rtlTranslate: "horizontal" === t.params.direction && ("rtl" === e.dir.toLowerCase() || "rtl" === n.css("direction")),
                        wrongRTL: "-webkit-box" === s.css("display"),
                    }),
                    !0
                );
            }
            init(e) {
                const t = this;
                return (
                    t.initialized ||
                        !1 === t.mount(e) ||
                        (t.emit("beforeInit"),
                        t.params.breakpoints && t.setBreakpoint(),
                        t.addClasses(),
                        t.params.loop && t.loopCreate(),
                        t.updateSize(),
                        t.updateSlides(),
                        t.params.watchOverflow && t.checkOverflow(),
                        t.params.grabCursor && t.enabled && t.setGrabCursor(),
                        t.params.preloadImages && t.preloadImages(),
                        t.params.loop ? t.slideTo(t.params.initialSlide + t.loopedSlides, 0, t.params.runCallbacksOnInit, !1, !0) : t.slideTo(t.params.initialSlide, 0, t.params.runCallbacksOnInit, !1, !0),
                        t.attachEvents(),
                        (t.initialized = !0),
                        t.emit("init"),
                        t.emit("afterInit")),
                    t
                );
            }
            destroy(e = !0, t = !0) {
                const n = this,
                    { params: i, $el: o, $wrapperEl: s, slides: r } = n;
                return (
                    void 0 === n.params ||
                        n.destroyed ||
                        (n.emit("beforeDestroy"),
                        (n.initialized = !1),
                        n.detachEvents(),
                        i.loop && n.loopDestroy(),
                        t &&
                            (n.removeClasses(),
                            o.removeAttr("style"),
                            s.removeAttr("style"),
                            r && r.length && r.removeClass([i.slideVisibleClass, i.slideActiveClass, i.slideNextClass, i.slidePrevClass].join(" ")).removeAttr("style").removeAttr("data-swiper-slide-index")),
                        n.emit("destroy"),
                        Object.keys(n.eventsListeners).forEach((e) => {
                            n.off(e);
                        }),
                        !1 !== e &&
                            ((n.$el[0].swiper = null),
                            (function (e) {
                                const t = e;
                                Object.keys(t).forEach((e) => {
                                    try {
                                        t[e] = null;
                                    } catch (e) {}
                                    try {
                                        delete t[e];
                                    } catch (e) {}
                                });
                            })(n)),
                        (n.destroyed = !0)),
                    null
                );
            }
            static extendDefaults(e) {
                m(R, e);
            }
            static get extendedDefaults() {
                return R;
            }
            static get defaults() {
                return I;
            }
            static installModule(e) {
                H.prototype.__modules__ || (H.prototype.__modules__ = []);
                const t = H.prototype.__modules__;
                "function" == typeof e && t.indexOf(e) < 0 && t.push(e);
            }
            static use(e) {
                return Array.isArray(e) ? (e.forEach((e) => H.installModule(e)), H) : (H.installModule(e), H);
            }
        }
        function q(e, t, n, o) {
            const s = i();
            return (
                e.params.createElements &&
                    Object.keys(o).forEach((i) => {
                        if (!n[i] && !0 === n.auto) {
                            let r = e.$el.children(`.${o[i]}`)[0];
                            r || ((r = s.createElement("div")), (r.className = o[i]), e.$el.append(r)), (n[i] = r), (t[i] = r);
                        }
                    }),
                n
            );
        }
        function F(e = "") {
            return `.${e
                .trim()
                .replace(/([\.:!\/])/g, "\\$1")
                .replace(/ /g, ".")}`;
        }
        function W(e) {
            const t = this,
                { $wrapperEl: n, params: i } = t;
            if ((i.loop && t.loopDestroy(), "object" == typeof e && "length" in e)) for (let t = 0; t < e.length; t += 1) e[t] && n.append(e[t]);
            else n.append(e);
            i.loop && t.loopCreate(), i.observer || t.update();
        }
        function B(e) {
            const t = this,
                { params: n, $wrapperEl: i, activeIndex: o } = t;
            n.loop && t.loopDestroy();
            let s = o + 1;
            if ("object" == typeof e && "length" in e) {
                for (let t = 0; t < e.length; t += 1) e[t] && i.prepend(e[t]);
                s = o + e.length;
            } else i.prepend(e);
            n.loop && t.loopCreate(), n.observer || t.update(), t.slideTo(s, 0, !1);
        }
        function V(e, t) {
            const n = this,
                { $wrapperEl: i, params: o, activeIndex: s } = n;
            let r = s;
            o.loop && ((r -= n.loopedSlides), n.loopDestroy(), (n.slides = i.children(`.${o.slideClass}`)));
            const a = n.slides.length;
            if (e <= 0) return void n.prependSlide(t);
            if (e >= a) return void n.appendSlide(t);
            let l = r > e ? r + 1 : r;
            const c = [];
            for (let t = a - 1; t >= e; t -= 1) {
                const e = n.slides.eq(t);
                e.remove(), c.unshift(e);
            }
            if ("object" == typeof t && "length" in t) {
                for (let e = 0; e < t.length; e += 1) t[e] && i.append(t[e]);
                l = r > e ? r + t.length : r;
            } else i.append(t);
            for (let e = 0; e < c.length; e += 1) i.append(c[e]);
            o.loop && n.loopCreate(), o.observer || n.update(), o.loop ? n.slideTo(l + n.loopedSlides, 0, !1) : n.slideTo(l, 0, !1);
        }
        function U(e) {
            const t = this,
                { params: n, $wrapperEl: i, activeIndex: o } = t;
            let s = o;
            n.loop && ((s -= t.loopedSlides), t.loopDestroy(), (t.slides = i.children(`.${n.slideClass}`)));
            let r,
                a = s;
            if ("object" == typeof e && "length" in e) {
                for (let n = 0; n < e.length; n += 1) (r = e[n]), t.slides[r] && t.slides.eq(r).remove(), r < a && (a -= 1);
                a = Math.max(a, 0);
            } else (r = e), t.slides[r] && t.slides.eq(r).remove(), r < a && (a -= 1), (a = Math.max(a, 0));
            n.loop && t.loopCreate(), n.observer || t.update(), n.loop ? t.slideTo(a + t.loopedSlides, 0, !1) : t.slideTo(a, 0, !1);
        }
        function G() {
            const e = this,
                t = [];
            for (let n = 0; n < e.slides.length; n += 1) t.push(n);
            e.removeSlide(t);
        }
        function X(e) {
            const { effect: t, swiper: n, on: i, setTranslate: o, setTransition: s, overwriteParams: r, perspective: a } = e;
            i("beforeInit", () => {
                if (n.params.effect !== t) return;
                n.classNames.push(`${n.params.containerModifierClass}${t}`), a && a() && n.classNames.push(`${n.params.containerModifierClass}3d`);
                const e = r ? r() : {};
                Object.assign(n.params, e), Object.assign(n.originalParams, e);
            }),
                i("setTranslate", () => {
                    n.params.effect === t && o();
                }),
                i("setTransition", (e, i) => {
                    n.params.effect === t && s(i);
                });
        }
        function Y(e, t) {
            return e.transformEl ? t.find(e.transformEl).css({ "backface-visibility": "hidden", "-webkit-backface-visibility": "hidden" }) : t;
        }
        function K({ swiper: e, duration: t, transformEl: n, allSlides: i }) {
            const { slides: o, activeIndex: s, $wrapperEl: r } = e;
            if (e.params.virtualTranslate && 0 !== t) {
                let t,
                    a = !1;
                (t = i ? (n ? o.find(n) : o) : n ? o.eq(s).find(n) : o.eq(s)),
                    t.transitionEnd(() => {
                        if (a) return;
                        if (!e || e.destroyed) return;
                        (a = !0), (e.animating = !1);
                        const t = ["webkitTransitionEnd", "transitionend"];
                        for (let e = 0; e < t.length; e += 1) r.trigger(t[e]);
                    });
            }
        }
        function Z(e, t, n) {
            const i = "swiper-slide-shadow" + (n ? `-${n}` : ""),
                o = e.transformEl ? t.find(e.transformEl) : t;
            let s = o.children(`.${i}`);
            return s.length || ((s = c(`<div class="swiper-slide-shadow${n ? `-${n}` : ""}"></div>`)), o.append(s)), s;
        }
        Object.keys(j).forEach((e) => {
            Object.keys(j[e]).forEach((t) => {
                H.prototype[t] = j[e][t];
            });
        }),
            H.use([
                function ({ swiper: e, on: t, emit: n }) {
                    const i = s();
                    let o = null;
                    const r = () => {
                            e && !e.destroyed && e.initialized && (n("beforeResize"), n("resize"));
                        },
                        a = () => {
                            e && !e.destroyed && e.initialized && n("orientationchange");
                        };
                    t("init", () => {
                        e.params.resizeObserver && void 0 !== i.ResizeObserver
                            ? e &&
                              !e.destroyed &&
                              e.initialized &&
                              ((o = new ResizeObserver((t) => {
                                  const { width: n, height: i } = e;
                                  let o = n,
                                      s = i;
                                  t.forEach(({ contentBoxSize: t, contentRect: n, target: i }) => {
                                      (i && i !== e.el) || ((o = n ? n.width : (t[0] || t).inlineSize), (s = n ? n.height : (t[0] || t).blockSize));
                                  }),
                                      (o === n && s === i) || r();
                              })),
                              o.observe(e.el))
                            : (i.addEventListener("resize", r), i.addEventListener("orientationchange", a));
                    }),
                        t("destroy", () => {
                            o && o.unobserve && e.el && (o.unobserve(e.el), (o = null)), i.removeEventListener("resize", r), i.removeEventListener("orientationchange", a);
                        });
                },
                function ({ swiper: e, extendParams: t, on: n, emit: i }) {
                    const o = [],
                        r = s(),
                        a = (e, t = {}) => {
                            const n = new (r.MutationObserver || r.WebkitMutationObserver)((e) => {
                                if (1 === e.length) return void i("observerUpdate", e[0]);
                                const t = function () {
                                    i("observerUpdate", e[0]);
                                };
                                r.requestAnimationFrame ? r.requestAnimationFrame(t) : r.setTimeout(t, 0);
                            });
                            n.observe(e, { attributes: void 0 === t.attributes || t.attributes, childList: void 0 === t.childList || t.childList, characterData: void 0 === t.characterData || t.characterData }), o.push(n);
                        };
                    t({ observer: !1, observeParents: !1, observeSlideChildren: !1 }),
                        n("init", () => {
                            if (e.params.observer) {
                                if (e.params.observeParents) {
                                    const t = e.$el.parents();
                                    for (let e = 0; e < t.length; e += 1) a(t[e]);
                                }
                                a(e.$el[0], { childList: e.params.observeSlideChildren }), a(e.$wrapperEl[0], { attributes: !1 });
                            }
                        }),
                        n("destroy", () => {
                            o.forEach((e) => {
                                e.disconnect();
                            }),
                                o.splice(0, o.length);
                        });
                },
            ]);
        const Q = [
            function ({ swiper: e, extendParams: t, on: n }) {
                function i(t, n) {
                    const i = e.params.virtual;
                    if (i.cache && e.virtual.cache[n]) return e.virtual.cache[n];
                    const o = i.renderSlide ? c(i.renderSlide.call(e, t, n)) : c(`<div class="${e.params.slideClass}" data-swiper-slide-index="${n}">${t}</div>`);
                    return o.attr("data-swiper-slide-index") || o.attr("data-swiper-slide-index", n), i.cache && (e.virtual.cache[n] = o), o;
                }
                function o(t) {
                    const { slidesPerView: n, slidesPerGroup: o, centeredSlides: s } = e.params,
                        { addSlidesBefore: r, addSlidesAfter: a } = e.params.virtual,
                        { from: l, to: c, slides: d, slidesGrid: u, offset: p } = e.virtual;
                    e.updateActiveIndex();
                    const h = e.activeIndex || 0;
                    let f, m, g;
                    (f = e.rtlTranslate ? "right" : e.isHorizontal() ? "left" : "top"), s ? ((m = Math.floor(n / 2) + o + a), (g = Math.floor(n / 2) + o + r)) : ((m = n + (o - 1) + a), (g = o + r));
                    const v = Math.max((h || 0) - g, 0),
                        y = Math.min((h || 0) + m, d.length - 1),
                        b = (e.slidesGrid[v] || 0) - (e.slidesGrid[0] || 0);
                    function w() {
                        e.updateSlides(), e.updateProgress(), e.updateSlidesClasses(), e.lazy && e.params.lazy.enabled && e.lazy.load();
                    }
                    if ((Object.assign(e.virtual, { from: v, to: y, offset: b, slidesGrid: e.slidesGrid }), l === v && c === y && !t)) return e.slidesGrid !== u && b !== p && e.slides.css(f, `${b}px`), void e.updateProgress();
                    if (e.params.virtual.renderExternal)
                        return (
                            e.params.virtual.renderExternal.call(e, {
                                offset: b,
                                from: v,
                                to: y,
                                slides: (function () {
                                    const e = [];
                                    for (let t = v; t <= y; t += 1) e.push(d[t]);
                                    return e;
                                })(),
                            }),
                            void (e.params.virtual.renderExternalUpdate && w())
                        );
                    const x = [],
                        T = [];
                    if (t) e.$wrapperEl.find(`.${e.params.slideClass}`).remove();
                    else for (let t = l; t <= c; t += 1) (t < v || t > y) && e.$wrapperEl.find(`.${e.params.slideClass}[data-swiper-slide-index="${t}"]`).remove();
                    for (let e = 0; e < d.length; e += 1) e >= v && e <= y && (void 0 === c || t ? T.push(e) : (e > c && T.push(e), e < l && x.push(e)));
                    T.forEach((t) => {
                        e.$wrapperEl.append(i(d[t], t));
                    }),
                        x
                            .sort((e, t) => t - e)
                            .forEach((t) => {
                                e.$wrapperEl.prepend(i(d[t], t));
                            }),
                        e.$wrapperEl.children(".swiper-slide").css(f, `${b}px`),
                        w();
                }
                t({ virtual: { enabled: !1, slides: [], cache: !0, renderSlide: null, renderExternal: null, renderExternalUpdate: !0, addSlidesBefore: 0, addSlidesAfter: 0 } }),
                    (e.virtual = { cache: {}, from: void 0, to: void 0, slides: [], offset: 0, slidesGrid: [] }),
                    n("beforeInit", () => {
                        e.params.virtual.enabled &&
                            ((e.virtual.slides = e.params.virtual.slides),
                            e.classNames.push(`${e.params.containerModifierClass}virtual`),
                            (e.params.watchSlidesProgress = !0),
                            (e.originalParams.watchSlidesProgress = !0),
                            e.params.initialSlide || o());
                    }),
                    n("setTranslate", () => {
                        e.params.virtual.enabled && o();
                    }),
                    n("init update resize", () => {
                        e.params.virtual.enabled && e.params.cssMode && g(e.wrapperEl, "--swiper-virtual-size", `${e.virtualSize}px`);
                    }),
                    Object.assign(e.virtual, {
                        appendSlide: function (t) {
                            if ("object" == typeof t && "length" in t) for (let n = 0; n < t.length; n += 1) t[n] && e.virtual.slides.push(t[n]);
                            else e.virtual.slides.push(t);
                            o(!0);
                        },
                        prependSlide: function (t) {
                            const n = e.activeIndex;
                            let i = n + 1,
                                s = 1;
                            if (Array.isArray(t)) {
                                for (let n = 0; n < t.length; n += 1) t[n] && e.virtual.slides.unshift(t[n]);
                                (i = n + t.length), (s = t.length);
                            } else e.virtual.slides.unshift(t);
                            if (e.params.virtual.cache) {
                                const t = e.virtual.cache,
                                    n = {};
                                Object.keys(t).forEach((e) => {
                                    const i = t[e],
                                        o = i.attr("data-swiper-slide-index");
                                    o && i.attr("data-swiper-slide-index", parseInt(o, 10) + 1), (n[parseInt(e, 10) + s] = i);
                                }),
                                    (e.virtual.cache = n);
                            }
                            o(!0), e.slideTo(i, 0);
                        },
                        removeSlide: function (t) {
                            if (null == t) return;
                            let n = e.activeIndex;
                            if (Array.isArray(t)) for (let i = t.length - 1; i >= 0; i -= 1) e.virtual.slides.splice(t[i], 1), e.params.virtual.cache && delete e.virtual.cache[t[i]], t[i] < n && (n -= 1), (n = Math.max(n, 0));
                            else e.virtual.slides.splice(t, 1), e.params.virtual.cache && delete e.virtual.cache[t], t < n && (n -= 1), (n = Math.max(n, 0));
                            o(!0), e.slideTo(n, 0);
                        },
                        removeAllSlides: function () {
                            (e.virtual.slides = []), e.params.virtual.cache && (e.virtual.cache = {}), o(!0), e.slideTo(0, 0);
                        },
                        update: o,
                    });
            },
            function ({ swiper: e, extendParams: t, on: n, emit: o }) {
                const r = i(),
                    a = s();
                function l(t) {
                    if (!e.enabled) return;
                    const { rtlTranslate: n } = e;
                    let i = t;
                    i.originalEvent && (i = i.originalEvent);
                    const s = i.keyCode || i.charCode,
                        l = e.params.keyboard.pageUpDown,
                        c = l && 33 === s,
                        d = l && 34 === s,
                        u = 37 === s,
                        p = 39 === s,
                        h = 38 === s,
                        f = 40 === s;
                    if (!e.allowSlideNext && ((e.isHorizontal() && p) || (e.isVertical() && f) || d)) return !1;
                    if (!e.allowSlidePrev && ((e.isHorizontal() && u) || (e.isVertical() && h) || c)) return !1;
                    if (!(i.shiftKey || i.altKey || i.ctrlKey || i.metaKey || (r.activeElement && r.activeElement.nodeName && ("input" === r.activeElement.nodeName.toLowerCase() || "textarea" === r.activeElement.nodeName.toLowerCase())))) {
                        if (e.params.keyboard.onlyInViewport && (c || d || u || p || h || f)) {
                            let t = !1;
                            if (e.$el.parents(`.${e.params.slideClass}`).length > 0 && 0 === e.$el.parents(`.${e.params.slideActiveClass}`).length) return;
                            const i = e.$el,
                                o = i[0].clientWidth,
                                s = i[0].clientHeight,
                                r = a.innerWidth,
                                l = a.innerHeight,
                                c = e.$el.offset();
                            n && (c.left -= e.$el[0].scrollLeft);
                            const d = [
                                [c.left, c.top],
                                [c.left + o, c.top],
                                [c.left, c.top + s],
                                [c.left + o, c.top + s],
                            ];
                            for (let e = 0; e < d.length; e += 1) {
                                const n = d[e];
                                if (n[0] >= 0 && n[0] <= r && n[1] >= 0 && n[1] <= l) {
                                    if (0 === n[0] && 0 === n[1]) continue;
                                    t = !0;
                                }
                            }
                            if (!t) return;
                        }
                        e.isHorizontal()
                            ? ((c || d || u || p) && (i.preventDefault ? i.preventDefault() : (i.returnValue = !1)), (((d || p) && !n) || ((c || u) && n)) && e.slideNext(), (((c || u) && !n) || ((d || p) && n)) && e.slidePrev())
                            : ((c || d || h || f) && (i.preventDefault ? i.preventDefault() : (i.returnValue = !1)), (d || f) && e.slideNext(), (c || h) && e.slidePrev()),
                            o("keyPress", s);
                    }
                }
                function d() {
                    e.keyboard.enabled || (c(r).on("keydown", l), (e.keyboard.enabled = !0));
                }
                function u() {
                    e.keyboard.enabled && (c(r).off("keydown", l), (e.keyboard.enabled = !1));
                }
                (e.keyboard = { enabled: !1 }),
                    t({ keyboard: { enabled: !1, onlyInViewport: !0, pageUpDown: !0 } }),
                    n("init", () => {
                        e.params.keyboard.enabled && d();
                    }),
                    n("destroy", () => {
                        e.keyboard.enabled && u();
                    }),
                    Object.assign(e.keyboard, { enable: d, disable: u });
            },
            function ({ swiper: e, extendParams: t, on: n, emit: i }) {
                const o = s();
                let r;
                t({ mousewheel: { enabled: !1, releaseOnEdges: !1, invert: !1, forceToAxis: !1, sensitivity: 1, eventsTarget: "container", thresholdDelta: null, thresholdTime: null } }), (e.mousewheel = { enabled: !1 });
                let a,
                    l = p();
                const d = [];
                function h() {
                    e.enabled && (e.mouseEntered = !0);
                }
                function f() {
                    e.enabled && (e.mouseEntered = !1);
                }
                function m(t) {
                    return !(
                        (e.params.mousewheel.thresholdDelta && t.delta < e.params.mousewheel.thresholdDelta) ||
                        (e.params.mousewheel.thresholdTime && p() - l < e.params.mousewheel.thresholdTime) ||
                        (!(t.delta >= 6 && p() - l < 60) &&
                            (t.direction < 0 ? (e.isEnd && !e.params.loop) || e.animating || (e.slideNext(), i("scroll", t.raw)) : (e.isBeginning && !e.params.loop) || e.animating || (e.slidePrev(), i("scroll", t.raw)),
                            (l = new o.Date().getTime()),
                            1))
                    );
                }
                function g(t) {
                    let n = t,
                        o = !0;
                    if (!e.enabled) return;
                    const s = e.params.mousewheel;
                    e.params.cssMode && n.preventDefault();
                    let l = e.$el;
                    if (("container" !== e.params.mousewheel.eventsTarget && (l = c(e.params.mousewheel.eventsTarget)), !e.mouseEntered && !l[0].contains(n.target) && !s.releaseOnEdges)) return !0;
                    n.originalEvent && (n = n.originalEvent);
                    let h = 0;
                    const f = e.rtlTranslate ? -1 : 1,
                        g = (function (e) {
                            let t = 0,
                                n = 0,
                                i = 0,
                                o = 0;
                            return (
                                "detail" in e && (n = e.detail),
                                "wheelDelta" in e && (n = -e.wheelDelta / 120),
                                "wheelDeltaY" in e && (n = -e.wheelDeltaY / 120),
                                "wheelDeltaX" in e && (t = -e.wheelDeltaX / 120),
                                "axis" in e && e.axis === e.HORIZONTAL_AXIS && ((t = n), (n = 0)),
                                (i = 10 * t),
                                (o = 10 * n),
                                "deltaY" in e && (o = e.deltaY),
                                "deltaX" in e && (i = e.deltaX),
                                e.shiftKey && !i && ((i = o), (o = 0)),
                                (i || o) && e.deltaMode && (1 === e.deltaMode ? ((i *= 40), (o *= 40)) : ((i *= 800), (o *= 800))),
                                i && !t && (t = i < 1 ? -1 : 1),
                                o && !n && (n = o < 1 ? -1 : 1),
                                { spinX: t, spinY: n, pixelX: i, pixelY: o }
                            );
                        })(n);
                    if (s.forceToAxis)
                        if (e.isHorizontal()) {
                            if (!(Math.abs(g.pixelX) > Math.abs(g.pixelY))) return !0;
                            h = -g.pixelX * f;
                        } else {
                            if (!(Math.abs(g.pixelY) > Math.abs(g.pixelX))) return !0;
                            h = -g.pixelY;
                        }
                    else h = Math.abs(g.pixelX) > Math.abs(g.pixelY) ? -g.pixelX * f : -g.pixelY;
                    if (0 === h) return !0;
                    s.invert && (h = -h);
                    let v = e.getTranslate() + h * s.sensitivity;
                    if (
                        (v >= e.minTranslate() && (v = e.minTranslate()),
                        v <= e.maxTranslate() && (v = e.maxTranslate()),
                        (o = !!e.params.loop || !(v === e.minTranslate() || v === e.maxTranslate())),
                        o && e.params.nested && n.stopPropagation(),
                        e.params.freeMode && e.params.freeMode.enabled)
                    ) {
                        const t = { time: p(), delta: Math.abs(h), direction: Math.sign(h) },
                            o = a && t.time < a.time + 500 && t.delta <= a.delta && t.direction === a.direction;
                        if (!o) {
                            (a = void 0), e.params.loop && e.loopFix();
                            let l = e.getTranslate() + h * s.sensitivity;
                            const c = e.isBeginning,
                                p = e.isEnd;
                            if (
                                (l >= e.minTranslate() && (l = e.minTranslate()),
                                l <= e.maxTranslate() && (l = e.maxTranslate()),
                                e.setTransition(0),
                                e.setTranslate(l),
                                e.updateProgress(),
                                e.updateActiveIndex(),
                                e.updateSlidesClasses(),
                                ((!c && e.isBeginning) || (!p && e.isEnd)) && e.updateSlidesClasses(),
                                e.params.freeMode.sticky)
                            ) {
                                clearTimeout(r), (r = void 0), d.length >= 15 && d.shift();
                                const n = d.length ? d[d.length - 1] : void 0,
                                    i = d[0];
                                if ((d.push(t), n && (t.delta > n.delta || t.direction !== n.direction))) d.splice(0);
                                else if (d.length >= 15 && t.time - i.time < 500 && i.delta - t.delta >= 1 && t.delta <= 6) {
                                    const n = h > 0 ? 0.8 : 0.2;
                                    (a = t),
                                        d.splice(0),
                                        (r = u(() => {
                                            e.slideToClosest(e.params.speed, !0, void 0, n);
                                        }, 0));
                                }
                                r ||
                                    (r = u(() => {
                                        (a = t), d.splice(0), e.slideToClosest(e.params.speed, !0, void 0, 0.5);
                                    }, 500));
                            }
                            if ((o || i("scroll", n), e.params.autoplay && e.params.autoplayDisableOnInteraction && e.autoplay.stop(), l === e.minTranslate() || l === e.maxTranslate())) return !0;
                        }
                    } else {
                        const n = { time: p(), delta: Math.abs(h), direction: Math.sign(h), raw: t };
                        d.length >= 2 && d.shift();
                        const i = d.length ? d[d.length - 1] : void 0;
                        if (
                            (d.push(n),
                            i ? (n.direction !== i.direction || n.delta > i.delta || n.time > i.time + 150) && m(n) : m(n),
                            (function (t) {
                                const n = e.params.mousewheel;
                                if (t.direction < 0) {
                                    if (e.isEnd && !e.params.loop && n.releaseOnEdges) return !0;
                                } else if (e.isBeginning && !e.params.loop && n.releaseOnEdges) return !0;
                                return !1;
                            })(n))
                        )
                            return !0;
                    }
                    return n.preventDefault ? n.preventDefault() : (n.returnValue = !1), !1;
                }
                function v(t) {
                    let n = e.$el;
                    "container" !== e.params.mousewheel.eventsTarget && (n = c(e.params.mousewheel.eventsTarget)), n[t]("mouseenter", h), n[t]("mouseleave", f), n[t]("wheel", g);
                }
                function y() {
                    return e.params.cssMode ? (e.wrapperEl.removeEventListener("wheel", g), !0) : !e.mousewheel.enabled && (v("on"), (e.mousewheel.enabled = !0), !0);
                }
                function b() {
                    return e.params.cssMode ? (e.wrapperEl.addEventListener(event, g), !0) : !!e.mousewheel.enabled && (v("off"), (e.mousewheel.enabled = !1), !0);
                }
                n("init", () => {
                    !e.params.mousewheel.enabled && e.params.cssMode && b(), e.params.mousewheel.enabled && y();
                }),
                    n("destroy", () => {
                        e.params.cssMode && y(), e.mousewheel.enabled && b();
                    }),
                    Object.assign(e.mousewheel, { enable: y, disable: b });
            },
            function ({ swiper: e, extendParams: t, on: n, emit: i }) {
                function o(t) {
                    let n;
                    return t && ((n = c(t)), e.params.uniqueNavElements && "string" == typeof t && n.length > 1 && 1 === e.$el.find(t).length && (n = e.$el.find(t))), n;
                }
                function s(t, n) {
                    const i = e.params.navigation;
                    t &&
                        t.length > 0 &&
                        (t[n ? "addClass" : "removeClass"](i.disabledClass), t[0] && "BUTTON" === t[0].tagName && (t[0].disabled = n), e.params.watchOverflow && e.enabled && t[e.isLocked ? "addClass" : "removeClass"](i.lockClass));
                }
                function r() {
                    if (e.params.loop) return;
                    const { $nextEl: t, $prevEl: n } = e.navigation;
                    s(n, e.isBeginning), s(t, e.isEnd);
                }
                function a(t) {
                    t.preventDefault(), (e.isBeginning && !e.params.loop) || e.slidePrev();
                }
                function l(t) {
                    t.preventDefault(), (e.isEnd && !e.params.loop) || e.slideNext();
                }
                function d() {
                    const t = e.params.navigation;
                    if (((e.params.navigation = q(e, e.originalParams.navigation, e.params.navigation, { nextEl: "swiper-button-next", prevEl: "swiper-button-prev" })), !t.nextEl && !t.prevEl)) return;
                    const n = o(t.nextEl),
                        i = o(t.prevEl);
                    n && n.length > 0 && n.on("click", l),
                        i && i.length > 0 && i.on("click", a),
                        Object.assign(e.navigation, { $nextEl: n, nextEl: n && n[0], $prevEl: i, prevEl: i && i[0] }),
                        e.enabled || (n && n.addClass(t.lockClass), i && i.addClass(t.lockClass));
                }
                function u() {
                    const { $nextEl: t, $prevEl: n } = e.navigation;
                    t && t.length && (t.off("click", l), t.removeClass(e.params.navigation.disabledClass)), n && n.length && (n.off("click", a), n.removeClass(e.params.navigation.disabledClass));
                }
                t({ navigation: { nextEl: null, prevEl: null, hideOnClick: !1, disabledClass: "swiper-button-disabled", hiddenClass: "swiper-button-hidden", lockClass: "swiper-button-lock" } }),
                    (e.navigation = { nextEl: null, $nextEl: null, prevEl: null, $prevEl: null }),
                    n("init", () => {
                        d(), r();
                    }),
                    n("toEdge fromEdge lock unlock", () => {
                        r();
                    }),
                    n("destroy", () => {
                        u();
                    }),
                    n("enable disable", () => {
                        const { $nextEl: t, $prevEl: n } = e.navigation;
                        t && t[e.enabled ? "removeClass" : "addClass"](e.params.navigation.lockClass), n && n[e.enabled ? "removeClass" : "addClass"](e.params.navigation.lockClass);
                    }),
                    n("click", (t, n) => {
                        const { $nextEl: o, $prevEl: s } = e.navigation,
                            r = n.target;
                        if (e.params.navigation.hideOnClick && !c(r).is(s) && !c(r).is(o)) {
                            if (e.pagination && e.params.pagination && e.params.pagination.clickable && (e.pagination.el === r || e.pagination.el.contains(r))) return;
                            let t;
                            o ? (t = o.hasClass(e.params.navigation.hiddenClass)) : s && (t = s.hasClass(e.params.navigation.hiddenClass)),
                                i(!0 === t ? "navigationShow" : "navigationHide"),
                                o && o.toggleClass(e.params.navigation.hiddenClass),
                                s && s.toggleClass(e.params.navigation.hiddenClass);
                        }
                    }),
                    Object.assign(e.navigation, { update: r, init: d, destroy: u });
            },
            function ({ swiper: e, extendParams: t, on: n, emit: i }) {
                const o = "swiper-pagination";
                let s;
                t({
                    pagination: {
                        el: null,
                        bulletElement: "span",
                        clickable: !1,
                        hideOnClick: !1,
                        renderBullet: null,
                        renderProgressbar: null,
                        renderFraction: null,
                        renderCustom: null,
                        progressbarOpposite: !1,
                        type: "bullets",
                        dynamicBullets: !1,
                        dynamicMainBullets: 1,
                        formatFractionCurrent: (e) => e,
                        formatFractionTotal: (e) => e,
                        bulletClass: `${o}-bullet`,
                        bulletActiveClass: `${o}-bullet-active`,
                        modifierClass: `${o}-`,
                        currentClass: `${o}-current`,
                        totalClass: `${o}-total`,
                        hiddenClass: `${o}-hidden`,
                        progressbarFillClass: `${o}-progressbar-fill`,
                        progressbarOppositeClass: `${o}-progressbar-opposite`,
                        clickableClass: `${o}-clickable`,
                        lockClass: `${o}-lock`,
                        horizontalClass: `${o}-horizontal`,
                        verticalClass: `${o}-vertical`,
                    },
                }),
                    (e.pagination = { el: null, $el: null, bullets: [] });
                let r = 0;
                function a() {
                    return !e.params.pagination.el || !e.pagination.el || !e.pagination.$el || 0 === e.pagination.$el.length;
                }
                function l(t, n) {
                    const { bulletActiveClass: i } = e.params.pagination;
                    t[n]().addClass(`${i}-${n}`)[n]().addClass(`${i}-${n}-${n}`);
                }
                function d() {
                    const t = e.rtl,
                        n = e.params.pagination;
                    if (a()) return;
                    const o = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length,
                        d = e.pagination.$el;
                    let u;
                    const p = e.params.loop ? Math.ceil((o - 2 * e.loopedSlides) / e.params.slidesPerGroup) : e.snapGrid.length;
                    if (
                        (e.params.loop
                            ? ((u = Math.ceil((e.activeIndex - e.loopedSlides) / e.params.slidesPerGroup)),
                              u > o - 1 - 2 * e.loopedSlides && (u -= o - 2 * e.loopedSlides),
                              u > p - 1 && (u -= p),
                              u < 0 && "bullets" !== e.params.paginationType && (u = p + u))
                            : (u = void 0 !== e.snapIndex ? e.snapIndex : e.activeIndex || 0),
                        "bullets" === n.type && e.pagination.bullets && e.pagination.bullets.length > 0)
                    ) {
                        const i = e.pagination.bullets;
                        let o, a, p;
                        if (
                            (n.dynamicBullets &&
                                ((s = i.eq(0)[e.isHorizontal() ? "outerWidth" : "outerHeight"](!0)),
                                d.css(e.isHorizontal() ? "width" : "height", s * (n.dynamicMainBullets + 4) + "px"),
                                n.dynamicMainBullets > 1 && void 0 !== e.previousIndex && ((r += u - e.previousIndex), r > n.dynamicMainBullets - 1 ? (r = n.dynamicMainBullets - 1) : r < 0 && (r = 0)),
                                (o = u - r),
                                (a = o + (Math.min(i.length, n.dynamicMainBullets) - 1)),
                                (p = (a + o) / 2)),
                            i.removeClass(["", "-next", "-next-next", "-prev", "-prev-prev", "-main"].map((e) => `${n.bulletActiveClass}${e}`).join(" ")),
                            d.length > 1)
                        )
                            i.each((e) => {
                                const t = c(e),
                                    i = t.index();
                                i === u && t.addClass(n.bulletActiveClass), n.dynamicBullets && (i >= o && i <= a && t.addClass(`${n.bulletActiveClass}-main`), i === o && l(t, "prev"), i === a && l(t, "next"));
                            });
                        else {
                            const t = i.eq(u),
                                s = t.index();
                            if ((t.addClass(n.bulletActiveClass), n.dynamicBullets)) {
                                const t = i.eq(o),
                                    r = i.eq(a);
                                for (let e = o; e <= a; e += 1) i.eq(e).addClass(`${n.bulletActiveClass}-main`);
                                if (e.params.loop)
                                    if (s >= i.length - n.dynamicMainBullets) {
                                        for (let e = n.dynamicMainBullets; e >= 0; e -= 1) i.eq(i.length - e).addClass(`${n.bulletActiveClass}-main`);
                                        i.eq(i.length - n.dynamicMainBullets - 1).addClass(`${n.bulletActiveClass}-prev`);
                                    } else l(t, "prev"), l(r, "next");
                                else l(t, "prev"), l(r, "next");
                            }
                        }
                        if (n.dynamicBullets) {
                            const o = Math.min(i.length, n.dynamicMainBullets + 4),
                                r = (s * o - s) / 2 - p * s,
                                a = t ? "right" : "left";
                            i.css(e.isHorizontal() ? a : "top", `${r}px`);
                        }
                    }
                    if (("fraction" === n.type && (d.find(F(n.currentClass)).text(n.formatFractionCurrent(u + 1)), d.find(F(n.totalClass)).text(n.formatFractionTotal(p))), "progressbar" === n.type)) {
                        let t;
                        t = n.progressbarOpposite ? (e.isHorizontal() ? "vertical" : "horizontal") : e.isHorizontal() ? "horizontal" : "vertical";
                        const i = (u + 1) / p;
                        let o = 1,
                            s = 1;
                        "horizontal" === t ? (o = i) : (s = i), d.find(F(n.progressbarFillClass)).transform(`translate3d(0,0,0) scaleX(${o}) scaleY(${s})`).transition(e.params.speed);
                    }
                    "custom" === n.type && n.renderCustom ? (d.html(n.renderCustom(e, u + 1, p)), i("paginationRender", d[0])) : i("paginationUpdate", d[0]),
                        e.params.watchOverflow && e.enabled && d[e.isLocked ? "addClass" : "removeClass"](n.lockClass);
                }
                function u() {
                    const t = e.params.pagination;
                    if (a()) return;
                    const n = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length,
                        o = e.pagination.$el;
                    let s = "";
                    if ("bullets" === t.type) {
                        let i = e.params.loop ? Math.ceil((n - 2 * e.loopedSlides) / e.params.slidesPerGroup) : e.snapGrid.length;
                        e.params.freeMode && e.params.freeMode.enabled && !e.params.loop && i > n && (i = n);
                        for (let n = 0; n < i; n += 1) t.renderBullet ? (s += t.renderBullet.call(e, n, t.bulletClass)) : (s += `<${t.bulletElement} class="${t.bulletClass}"></${t.bulletElement}>`);
                        o.html(s), (e.pagination.bullets = o.find(F(t.bulletClass)));
                    }
                    "fraction" === t.type && ((s = t.renderFraction ? t.renderFraction.call(e, t.currentClass, t.totalClass) : `<span class="${t.currentClass}"></span> / <span class="${t.totalClass}"></span>`), o.html(s)),
                        "progressbar" === t.type && ((s = t.renderProgressbar ? t.renderProgressbar.call(e, t.progressbarFillClass) : `<span class="${t.progressbarFillClass}"></span>`), o.html(s)),
                        "custom" !== t.type && i("paginationRender", e.pagination.$el[0]);
                }
                function p() {
                    e.params.pagination = q(e, e.originalParams.pagination, e.params.pagination, { el: "swiper-pagination" });
                    const t = e.params.pagination;
                    if (!t.el) return;
                    let n = c(t.el);
                    0 !== n.length &&
                        (e.params.uniqueNavElements && "string" == typeof t.el && n.length > 1 && ((n = e.$el.find(t.el)), n.length > 1 && (n = n.filter((t) => c(t).parents(".swiper")[0] === e.el))),
                        "bullets" === t.type && t.clickable && n.addClass(t.clickableClass),
                        n.addClass(t.modifierClass + t.type),
                        n.addClass(t.modifierClass + e.params.direction),
                        "bullets" === t.type && t.dynamicBullets && (n.addClass(`${t.modifierClass}${t.type}-dynamic`), (r = 0), t.dynamicMainBullets < 1 && (t.dynamicMainBullets = 1)),
                        "progressbar" === t.type && t.progressbarOpposite && n.addClass(t.progressbarOppositeClass),
                        t.clickable &&
                            n.on("click", F(t.bulletClass), function (t) {
                                t.preventDefault();
                                let n = c(this).index() * e.params.slidesPerGroup;
                                e.params.loop && (n += e.loopedSlides), e.slideTo(n);
                            }),
                        Object.assign(e.pagination, { $el: n, el: n[0] }),
                        e.enabled || n.addClass(t.lockClass));
                }
                function h() {
                    const t = e.params.pagination;
                    if (a()) return;
                    const n = e.pagination.$el;
                    n.removeClass(t.hiddenClass),
                        n.removeClass(t.modifierClass + t.type),
                        n.removeClass(t.modifierClass + e.params.direction),
                        e.pagination.bullets && e.pagination.bullets.removeClass && e.pagination.bullets.removeClass(t.bulletActiveClass),
                        t.clickable && n.off("click", F(t.bulletClass));
                }
                n("init", () => {
                    p(), u(), d();
                }),
                    n("activeIndexChange", () => {
                        (e.params.loop || void 0 === e.snapIndex) && d();
                    }),
                    n("snapIndexChange", () => {
                        e.params.loop || d();
                    }),
                    n("slidesLengthChange", () => {
                        e.params.loop && (u(), d());
                    }),
                    n("snapGridLengthChange", () => {
                        e.params.loop || (u(), d());
                    }),
                    n("destroy", () => {
                        h();
                    }),
                    n("enable disable", () => {
                        const { $el: t } = e.pagination;
                        t && t[e.enabled ? "removeClass" : "addClass"](e.params.pagination.lockClass);
                    }),
                    n("lock unlock", () => {
                        d();
                    }),
                    n("click", (t, n) => {
                        const o = n.target,
                            { $el: s } = e.pagination;
                        if (e.params.pagination.el && e.params.pagination.hideOnClick && s.length > 0 && !c(o).hasClass(e.params.pagination.bulletClass)) {
                            if (e.navigation && ((e.navigation.nextEl && o === e.navigation.nextEl) || (e.navigation.prevEl && o === e.navigation.prevEl))) return;
                            const t = s.hasClass(e.params.pagination.hiddenClass);
                            i(!0 === t ? "paginationShow" : "paginationHide"), s.toggleClass(e.params.pagination.hiddenClass);
                        }
                    }),
                    Object.assign(e.pagination, { render: u, update: d, init: p, destroy: h });
            },
            function ({ swiper: e, extendParams: t, on: n, emit: o }) {
                const s = i();
                let r,
                    a,
                    l,
                    d,
                    p = !1,
                    h = null,
                    f = null;
                function m() {
                    if (!e.params.scrollbar.el || !e.scrollbar.el) return;
                    const { scrollbar: t, rtlTranslate: n, progress: i } = e,
                        { $dragEl: o, $el: s } = t,
                        r = e.params.scrollbar;
                    let c = a,
                        d = (l - a) * i;
                    n ? ((d = -d), d > 0 ? ((c = a - d), (d = 0)) : -d + a > l && (c = l + d)) : d < 0 ? ((c = a + d), (d = 0)) : d + a > l && (c = l - d),
                        e.isHorizontal() ? (o.transform(`translate3d(${d}px, 0, 0)`), (o[0].style.width = `${c}px`)) : (o.transform(`translate3d(0px, ${d}px, 0)`), (o[0].style.height = `${c}px`)),
                        r.hide &&
                            (clearTimeout(h),
                            (s[0].style.opacity = 1),
                            (h = setTimeout(() => {
                                (s[0].style.opacity = 0), s.transition(400);
                            }, 1e3)));
                }
                function g() {
                    if (!e.params.scrollbar.el || !e.scrollbar.el) return;
                    const { scrollbar: t } = e,
                        { $dragEl: n, $el: i } = t;
                    (n[0].style.width = ""),
                        (n[0].style.height = ""),
                        (l = e.isHorizontal() ? i[0].offsetWidth : i[0].offsetHeight),
                        (d = e.size / (e.virtualSize + e.params.slidesOffsetBefore - (e.params.centeredSlides ? e.snapGrid[0] : 0))),
                        (a = "auto" === e.params.scrollbar.dragSize ? l * d : parseInt(e.params.scrollbar.dragSize, 10)),
                        e.isHorizontal() ? (n[0].style.width = `${a}px`) : (n[0].style.height = `${a}px`),
                        (i[0].style.display = d >= 1 ? "none" : ""),
                        e.params.scrollbar.hide && (i[0].style.opacity = 0),
                        e.params.watchOverflow && e.enabled && t.$el[e.isLocked ? "addClass" : "removeClass"](e.params.scrollbar.lockClass);
                }
                function v(t) {
                    return e.isHorizontal() ? ("touchstart" === t.type || "touchmove" === t.type ? t.targetTouches[0].clientX : t.clientX) : "touchstart" === t.type || "touchmove" === t.type ? t.targetTouches[0].clientY : t.clientY;
                }
                function y(t) {
                    const { scrollbar: n, rtlTranslate: i } = e,
                        { $el: o } = n;
                    let s;
                    (s = (v(t) - o.offset()[e.isHorizontal() ? "left" : "top"] - (null !== r ? r : a / 2)) / (l - a)), (s = Math.max(Math.min(s, 1), 0)), i && (s = 1 - s);
                    const c = e.minTranslate() + (e.maxTranslate() - e.minTranslate()) * s;
                    e.updateProgress(c), e.setTranslate(c), e.updateActiveIndex(), e.updateSlidesClasses();
                }
                function b(t) {
                    const n = e.params.scrollbar,
                        { scrollbar: i, $wrapperEl: s } = e,
                        { $el: a, $dragEl: l } = i;
                    (p = !0),
                        (r = t.target === l[0] || t.target === l ? v(t) - t.target.getBoundingClientRect()[e.isHorizontal() ? "left" : "top"] : null),
                        t.preventDefault(),
                        t.stopPropagation(),
                        s.transition(100),
                        l.transition(100),
                        y(t),
                        clearTimeout(f),
                        a.transition(0),
                        n.hide && a.css("opacity", 1),
                        e.params.cssMode && e.$wrapperEl.css("scroll-snap-type", "none"),
                        o("scrollbarDragStart", t);
                }
                function w(t) {
                    const { scrollbar: n, $wrapperEl: i } = e,
                        { $el: s, $dragEl: r } = n;
                    p && (t.preventDefault ? t.preventDefault() : (t.returnValue = !1), y(t), i.transition(0), s.transition(0), r.transition(0), o("scrollbarDragMove", t));
                }
                function x(t) {
                    const n = e.params.scrollbar,
                        { scrollbar: i, $wrapperEl: s } = e,
                        { $el: r } = i;
                    p &&
                        ((p = !1),
                        e.params.cssMode && (e.$wrapperEl.css("scroll-snap-type", ""), s.transition("")),
                        n.hide &&
                            (clearTimeout(f),
                            (f = u(() => {
                                r.css("opacity", 0), r.transition(400);
                            }, 1e3))),
                        o("scrollbarDragEnd", t),
                        n.snapOnRelease && e.slideToClosest());
                }
                function T(t) {
                    const { scrollbar: n, touchEventsTouch: i, touchEventsDesktop: o, params: r, support: a } = e,
                        l = n.$el[0],
                        c = !(!a.passiveListener || !r.passiveListeners) && { passive: !1, capture: !1 },
                        d = !(!a.passiveListener || !r.passiveListeners) && { passive: !0, capture: !1 };
                    if (!l) return;
                    const u = "on" === t ? "addEventListener" : "removeEventListener";
                    a.touch ? (l[u](i.start, b, c), l[u](i.move, w, c), l[u](i.end, x, d)) : (l[u](o.start, b, c), s[u](o.move, w, c), s[u](o.end, x, d));
                }
                function C() {
                    const { scrollbar: t, $el: n } = e;
                    e.params.scrollbar = q(e, e.originalParams.scrollbar, e.params.scrollbar, { el: "swiper-scrollbar" });
                    const i = e.params.scrollbar;
                    if (!i.el) return;
                    let o = c(i.el);
                    e.params.uniqueNavElements && "string" == typeof i.el && o.length > 1 && 1 === n.find(i.el).length && (o = n.find(i.el));
                    let s = o.find(`.${e.params.scrollbar.dragClass}`);
                    0 === s.length && ((s = c(`<div class="${e.params.scrollbar.dragClass}"></div>`)), o.append(s)),
                        Object.assign(t, { $el: o, el: o[0], $dragEl: s, dragEl: s[0] }),
                        i.draggable && e.params.scrollbar.el && T("on"),
                        o && o[e.enabled ? "removeClass" : "addClass"](e.params.scrollbar.lockClass);
                }
                function S() {
                    e.params.scrollbar.el && T("off");
                }
                t({ scrollbar: { el: null, dragSize: "auto", hide: !1, draggable: !1, snapOnRelease: !0, lockClass: "swiper-scrollbar-lock", dragClass: "swiper-scrollbar-drag" } }),
                    (e.scrollbar = { el: null, dragEl: null, $el: null, $dragEl: null }),
                    n("init", () => {
                        C(), g(), m();
                    }),
                    n("update resize observerUpdate lock unlock", () => {
                        g();
                    }),
                    n("setTranslate", () => {
                        m();
                    }),
                    n("setTransition", (t, n) => {
                        !(function (t) {
                            e.params.scrollbar.el && e.scrollbar.el && e.scrollbar.$dragEl.transition(t);
                        })(n);
                    }),
                    n("enable disable", () => {
                        const { $el: t } = e.scrollbar;
                        t && t[e.enabled ? "removeClass" : "addClass"](e.params.scrollbar.lockClass);
                    }),
                    n("destroy", () => {
                        S();
                    }),
                    Object.assign(e.scrollbar, { updateSize: g, setTranslate: m, init: C, destroy: S });
            },
            function ({ swiper: e, extendParams: t, on: n }) {
                t({ parallax: { enabled: !1 } });
                const i = (t, n) => {
                        const { rtl: i } = e,
                            o = c(t),
                            s = i ? -1 : 1,
                            r = o.attr("data-swiper-parallax") || "0";
                        let a = o.attr("data-swiper-parallax-x"),
                            l = o.attr("data-swiper-parallax-y");
                        const d = o.attr("data-swiper-parallax-scale"),
                            u = o.attr("data-swiper-parallax-opacity");
                        if (
                            (a || l ? ((a = a || "0"), (l = l || "0")) : e.isHorizontal() ? ((a = r), (l = "0")) : ((l = r), (a = "0")),
                            (a = a.indexOf("%") >= 0 ? parseInt(a, 10) * n * s + "%" : a * n * s + "px"),
                            (l = l.indexOf("%") >= 0 ? parseInt(l, 10) * n + "%" : l * n + "px"),
                            null != u)
                        ) {
                            const e = u - (u - 1) * (1 - Math.abs(n));
                            o[0].style.opacity = e;
                        }
                        if (null == d) o.transform(`translate3d(${a}, ${l}, 0px)`);
                        else {
                            const e = d - (d - 1) * (1 - Math.abs(n));
                            o.transform(`translate3d(${a}, ${l}, 0px) scale(${e})`);
                        }
                    },
                    o = () => {
                        const { $el: t, slides: n, progress: o, snapGrid: s } = e;
                        t.children("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each((e) => {
                            i(e, o);
                        }),
                            n.each((t, n) => {
                                let r = t.progress;
                                e.params.slidesPerGroup > 1 && "auto" !== e.params.slidesPerView && (r += Math.ceil(n / 2) - o * (s.length - 1)),
                                    (r = Math.min(Math.max(r, -1), 1)),
                                    c(t)
                                        .find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]")
                                        .each((e) => {
                                            i(e, r);
                                        });
                            });
                    };
                n("beforeInit", () => {
                    e.params.parallax.enabled && ((e.params.watchSlidesProgress = !0), (e.originalParams.watchSlidesProgress = !0));
                }),
                    n("init", () => {
                        e.params.parallax.enabled && o();
                    }),
                    n("setTranslate", () => {
                        e.params.parallax.enabled && o();
                    }),
                    n("setTransition", (t, n) => {
                        e.params.parallax.enabled &&
                            ((t = e.params.speed) => {
                                const { $el: n } = e;
                                n.find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each((e) => {
                                    const n = c(e);
                                    let i = parseInt(n.attr("data-swiper-parallax-duration"), 10) || t;
                                    0 === t && (i = 0), n.transition(i);
                                });
                            })(n);
                    });
            },
            function ({ swiper: e, extendParams: t, on: n, emit: i }) {
                const o = s();
                t({ zoom: { enabled: !1, maxRatio: 3, minRatio: 1, toggle: !0, containerClass: "swiper-zoom-container", zoomedSlideClass: "swiper-slide-zoomed" } }), (e.zoom = { enabled: !1 });
                let r,
                    a,
                    l,
                    d = 1,
                    u = !1;
                const p = { $slideEl: void 0, slideWidth: void 0, slideHeight: void 0, $imageEl: void 0, $imageWrapEl: void 0, maxRatio: 3 },
                    f = {
                        isTouched: void 0,
                        isMoved: void 0,
                        currentX: void 0,
                        currentY: void 0,
                        minX: void 0,
                        minY: void 0,
                        maxX: void 0,
                        maxY: void 0,
                        width: void 0,
                        height: void 0,
                        startX: void 0,
                        startY: void 0,
                        touchesStart: {},
                        touchesCurrent: {},
                    },
                    m = { x: void 0, y: void 0, prevPositionX: void 0, prevPositionY: void 0, prevTime: void 0 };
                let g = 1;
                function v(e) {
                    if (e.targetTouches.length < 2) return 1;
                    const t = e.targetTouches[0].pageX,
                        n = e.targetTouches[0].pageY,
                        i = e.targetTouches[1].pageX,
                        o = e.targetTouches[1].pageY;
                    return Math.sqrt((i - t) ** 2 + (o - n) ** 2);
                }
                function y(t) {
                    const n = e.support,
                        i = e.params.zoom;
                    if (((a = !1), (l = !1), !n.gestures)) {
                        if ("touchstart" !== t.type || ("touchstart" === t.type && t.targetTouches.length < 2)) return;
                        (a = !0), (p.scaleStart = v(t));
                    }
                    (p.$slideEl && p.$slideEl.length) ||
                    ((p.$slideEl = c(t.target).closest(`.${e.params.slideClass}`)),
                    0 === p.$slideEl.length && (p.$slideEl = e.slides.eq(e.activeIndex)),
                    (p.$imageEl = p.$slideEl.find(`.${i.containerClass}`).eq(0).find("img, svg, canvas, picture, .swiper-zoom-target")),
                    (p.$imageWrapEl = p.$imageEl.parent(`.${i.containerClass}`)),
                    (p.maxRatio = p.$imageWrapEl.attr("data-swiper-zoom") || i.maxRatio),
                    0 !== p.$imageWrapEl.length)
                        ? (p.$imageEl && p.$imageEl.transition(0), (u = !0))
                        : (p.$imageEl = void 0);
                }
                function b(t) {
                    const n = e.support,
                        i = e.params.zoom,
                        o = e.zoom;
                    if (!n.gestures) {
                        if ("touchmove" !== t.type || ("touchmove" === t.type && t.targetTouches.length < 2)) return;
                        (l = !0), (p.scaleMove = v(t));
                    }
                    p.$imageEl && 0 !== p.$imageEl.length
                        ? (n.gestures ? (o.scale = t.scale * d) : (o.scale = (p.scaleMove / p.scaleStart) * d),
                          o.scale > p.maxRatio && (o.scale = p.maxRatio - 1 + (o.scale - p.maxRatio + 1) ** 0.5),
                          o.scale < i.minRatio && (o.scale = i.minRatio + 1 - (i.minRatio - o.scale + 1) ** 0.5),
                          p.$imageEl.transform(`translate3d(0,0,0) scale(${o.scale})`))
                        : "gesturechange" === t.type && y(t);
                }
                function w(t) {
                    const n = e.device,
                        i = e.support,
                        o = e.params.zoom,
                        s = e.zoom;
                    if (!i.gestures) {
                        if (!a || !l) return;
                        if ("touchend" !== t.type || ("touchend" === t.type && t.changedTouches.length < 2 && !n.android)) return;
                        (a = !1), (l = !1);
                    }
                    p.$imageEl &&
                        0 !== p.$imageEl.length &&
                        ((s.scale = Math.max(Math.min(s.scale, p.maxRatio), o.minRatio)),
                        p.$imageEl.transition(e.params.speed).transform(`translate3d(0,0,0) scale(${s.scale})`),
                        (d = s.scale),
                        (u = !1),
                        1 === s.scale && (p.$slideEl = void 0));
                }
                function x(t) {
                    const n = e.zoom;
                    if (!p.$imageEl || 0 === p.$imageEl.length) return;
                    if (((e.allowClick = !1), !f.isTouched || !p.$slideEl)) return;
                    f.isMoved ||
                        ((f.width = p.$imageEl[0].offsetWidth),
                        (f.height = p.$imageEl[0].offsetHeight),
                        (f.startX = h(p.$imageWrapEl[0], "x") || 0),
                        (f.startY = h(p.$imageWrapEl[0], "y") || 0),
                        (p.slideWidth = p.$slideEl[0].offsetWidth),
                        (p.slideHeight = p.$slideEl[0].offsetHeight),
                        p.$imageWrapEl.transition(0));
                    const i = f.width * n.scale,
                        o = f.height * n.scale;
                    if (!(i < p.slideWidth && o < p.slideHeight)) {
                        if (
                            ((f.minX = Math.min(p.slideWidth / 2 - i / 2, 0)),
                            (f.maxX = -f.minX),
                            (f.minY = Math.min(p.slideHeight / 2 - o / 2, 0)),
                            (f.maxY = -f.minY),
                            (f.touchesCurrent.x = "touchmove" === t.type ? t.targetTouches[0].pageX : t.pageX),
                            (f.touchesCurrent.y = "touchmove" === t.type ? t.targetTouches[0].pageY : t.pageY),
                            !f.isMoved && !u)
                        ) {
                            if (e.isHorizontal() && ((Math.floor(f.minX) === Math.floor(f.startX) && f.touchesCurrent.x < f.touchesStart.x) || (Math.floor(f.maxX) === Math.floor(f.startX) && f.touchesCurrent.x > f.touchesStart.x)))
                                return void (f.isTouched = !1);
                            if (!e.isHorizontal() && ((Math.floor(f.minY) === Math.floor(f.startY) && f.touchesCurrent.y < f.touchesStart.y) || (Math.floor(f.maxY) === Math.floor(f.startY) && f.touchesCurrent.y > f.touchesStart.y)))
                                return void (f.isTouched = !1);
                        }
                        t.cancelable && t.preventDefault(),
                            t.stopPropagation(),
                            (f.isMoved = !0),
                            (f.currentX = f.touchesCurrent.x - f.touchesStart.x + f.startX),
                            (f.currentY = f.touchesCurrent.y - f.touchesStart.y + f.startY),
                            f.currentX < f.minX && (f.currentX = f.minX + 1 - (f.minX - f.currentX + 1) ** 0.8),
                            f.currentX > f.maxX && (f.currentX = f.maxX - 1 + (f.currentX - f.maxX + 1) ** 0.8),
                            f.currentY < f.minY && (f.currentY = f.minY + 1 - (f.minY - f.currentY + 1) ** 0.8),
                            f.currentY > f.maxY && (f.currentY = f.maxY - 1 + (f.currentY - f.maxY + 1) ** 0.8),
                            m.prevPositionX || (m.prevPositionX = f.touchesCurrent.x),
                            m.prevPositionY || (m.prevPositionY = f.touchesCurrent.y),
                            m.prevTime || (m.prevTime = Date.now()),
                            (m.x = (f.touchesCurrent.x - m.prevPositionX) / (Date.now() - m.prevTime) / 2),
                            (m.y = (f.touchesCurrent.y - m.prevPositionY) / (Date.now() - m.prevTime) / 2),
                            Math.abs(f.touchesCurrent.x - m.prevPositionX) < 2 && (m.x = 0),
                            Math.abs(f.touchesCurrent.y - m.prevPositionY) < 2 && (m.y = 0),
                            (m.prevPositionX = f.touchesCurrent.x),
                            (m.prevPositionY = f.touchesCurrent.y),
                            (m.prevTime = Date.now()),
                            p.$imageWrapEl.transform(`translate3d(${f.currentX}px, ${f.currentY}px,0)`);
                    }
                }
                function T() {
                    const t = e.zoom;
                    p.$slideEl &&
                        e.previousIndex !== e.activeIndex &&
                        (p.$imageEl && p.$imageEl.transform("translate3d(0,0,0) scale(1)"),
                        p.$imageWrapEl && p.$imageWrapEl.transform("translate3d(0,0,0)"),
                        (t.scale = 1),
                        (d = 1),
                        (p.$slideEl = void 0),
                        (p.$imageEl = void 0),
                        (p.$imageWrapEl = void 0));
                }
                function C(t) {
                    const n = e.zoom,
                        i = e.params.zoom;
                    if (
                        (p.$slideEl ||
                            (t && t.target && (p.$slideEl = c(t.target).closest(`.${e.params.slideClass}`)),
                            p.$slideEl || (e.params.virtual && e.params.virtual.enabled && e.virtual ? (p.$slideEl = e.$wrapperEl.children(`.${e.params.slideActiveClass}`)) : (p.$slideEl = e.slides.eq(e.activeIndex))),
                            (p.$imageEl = p.$slideEl.find(`.${i.containerClass}`).eq(0).find("img, svg, canvas, picture, .swiper-zoom-target")),
                            (p.$imageWrapEl = p.$imageEl.parent(`.${i.containerClass}`))),
                        !p.$imageEl || 0 === p.$imageEl.length || !p.$imageWrapEl || 0 === p.$imageWrapEl.length)
                    )
                        return;
                    let s, r, a, l, u, h, m, g, v, y, b, w, x, T, C, S, k, $;
                    e.params.cssMode && ((e.wrapperEl.style.overflow = "hidden"), (e.wrapperEl.style.touchAction = "none")),
                        p.$slideEl.addClass(`${i.zoomedSlideClass}`),
                        void 0 === f.touchesStart.x && t
                            ? ((s = "touchend" === t.type ? t.changedTouches[0].pageX : t.pageX), (r = "touchend" === t.type ? t.changedTouches[0].pageY : t.pageY))
                            : ((s = f.touchesStart.x), (r = f.touchesStart.y)),
                        (n.scale = p.$imageWrapEl.attr("data-swiper-zoom") || i.maxRatio),
                        (d = p.$imageWrapEl.attr("data-swiper-zoom") || i.maxRatio),
                        t
                            ? ((k = p.$slideEl[0].offsetWidth),
                              ($ = p.$slideEl[0].offsetHeight),
                              (a = p.$slideEl.offset().left + o.scrollX),
                              (l = p.$slideEl.offset().top + o.scrollY),
                              (u = a + k / 2 - s),
                              (h = l + $ / 2 - r),
                              (v = p.$imageEl[0].offsetWidth),
                              (y = p.$imageEl[0].offsetHeight),
                              (b = v * n.scale),
                              (w = y * n.scale),
                              (x = Math.min(k / 2 - b / 2, 0)),
                              (T = Math.min($ / 2 - w / 2, 0)),
                              (C = -x),
                              (S = -T),
                              (m = u * n.scale),
                              (g = h * n.scale),
                              m < x && (m = x),
                              m > C && (m = C),
                              g < T && (g = T),
                              g > S && (g = S))
                            : ((m = 0), (g = 0)),
                        p.$imageWrapEl.transition(300).transform(`translate3d(${m}px, ${g}px,0)`),
                        p.$imageEl.transition(300).transform(`translate3d(0,0,0) scale(${n.scale})`);
                }
                function S() {
                    const t = e.zoom,
                        n = e.params.zoom;
                    p.$slideEl ||
                        (e.params.virtual && e.params.virtual.enabled && e.virtual ? (p.$slideEl = e.$wrapperEl.children(`.${e.params.slideActiveClass}`)) : (p.$slideEl = e.slides.eq(e.activeIndex)),
                        (p.$imageEl = p.$slideEl.find(`.${n.containerClass}`).eq(0).find("img, svg, canvas, picture, .swiper-zoom-target")),
                        (p.$imageWrapEl = p.$imageEl.parent(`.${n.containerClass}`))),
                        p.$imageEl &&
                            0 !== p.$imageEl.length &&
                            p.$imageWrapEl &&
                            0 !== p.$imageWrapEl.length &&
                            (e.params.cssMode && ((e.wrapperEl.style.overflow = ""), (e.wrapperEl.style.touchAction = "")),
                            (t.scale = 1),
                            (d = 1),
                            p.$imageWrapEl.transition(300).transform("translate3d(0,0,0)"),
                            p.$imageEl.transition(300).transform("translate3d(0,0,0) scale(1)"),
                            p.$slideEl.removeClass(`${n.zoomedSlideClass}`),
                            (p.$slideEl = void 0));
                }
                function k(t) {
                    const n = e.zoom;
                    n.scale && 1 !== n.scale ? S() : C(t);
                }
                function $() {
                    const t = e.support;
                    return {
                        passiveListener: !("touchstart" !== e.touchEvents.start || !t.passiveListener || !e.params.passiveListeners) && { passive: !0, capture: !1 },
                        activeListenerWithCapture: !t.passiveListener || { passive: !1, capture: !0 },
                    };
                }
                function _() {
                    return `.${e.params.slideClass}`;
                }
                function E(t) {
                    const { passiveListener: n } = $(),
                        i = _();
                    e.$wrapperEl[t]("gesturestart", i, y, n), e.$wrapperEl[t]("gesturechange", i, b, n), e.$wrapperEl[t]("gestureend", i, w, n);
                }
                function A() {
                    r || ((r = !0), E("on"));
                }
                function M() {
                    r && ((r = !1), E("off"));
                }
                function P() {
                    const t = e.zoom;
                    if (t.enabled) return;
                    t.enabled = !0;
                    const n = e.support,
                        { passiveListener: i, activeListenerWithCapture: o } = $(),
                        s = _();
                    n.gestures
                        ? (e.$wrapperEl.on(e.touchEvents.start, A, i), e.$wrapperEl.on(e.touchEvents.end, M, i))
                        : "touchstart" === e.touchEvents.start &&
                          (e.$wrapperEl.on(e.touchEvents.start, s, y, i), e.$wrapperEl.on(e.touchEvents.move, s, b, o), e.$wrapperEl.on(e.touchEvents.end, s, w, i), e.touchEvents.cancel && e.$wrapperEl.on(e.touchEvents.cancel, s, w, i)),
                        e.$wrapperEl.on(e.touchEvents.move, `.${e.params.zoom.containerClass}`, x, o);
                }
                function L() {
                    const t = e.zoom;
                    if (!t.enabled) return;
                    const n = e.support;
                    t.enabled = !1;
                    const { passiveListener: i, activeListenerWithCapture: o } = $(),
                        s = _();
                    n.gestures
                        ? (e.$wrapperEl.off(e.touchEvents.start, A, i), e.$wrapperEl.off(e.touchEvents.end, M, i))
                        : "touchstart" === e.touchEvents.start &&
                          (e.$wrapperEl.off(e.touchEvents.start, s, y, i),
                          e.$wrapperEl.off(e.touchEvents.move, s, b, o),
                          e.$wrapperEl.off(e.touchEvents.end, s, w, i),
                          e.touchEvents.cancel && e.$wrapperEl.off(e.touchEvents.cancel, s, w, i)),
                        e.$wrapperEl.off(e.touchEvents.move, `.${e.params.zoom.containerClass}`, x, o);
                }
                Object.defineProperty(e.zoom, "scale", {
                    get: () => g,
                    set(e) {
                        if (g !== e) {
                            const t = p.$imageEl ? p.$imageEl[0] : void 0,
                                n = p.$slideEl ? p.$slideEl[0] : void 0;
                            i("zoomChange", e, t, n);
                        }
                        g = e;
                    },
                }),
                    n("init", () => {
                        e.params.zoom.enabled && P();
                    }),
                    n("destroy", () => {
                        L();
                    }),
                    n("touchStart", (t, n) => {
                        e.zoom.enabled &&
                            (function (t) {
                                const n = e.device;
                                p.$imageEl &&
                                    0 !== p.$imageEl.length &&
                                    (f.isTouched ||
                                        (n.android && t.cancelable && t.preventDefault(),
                                        (f.isTouched = !0),
                                        (f.touchesStart.x = "touchstart" === t.type ? t.targetTouches[0].pageX : t.pageX),
                                        (f.touchesStart.y = "touchstart" === t.type ? t.targetTouches[0].pageY : t.pageY)));
                            })(n);
                    }),
                    n("touchEnd", (t, n) => {
                        e.zoom.enabled &&
                            (function () {
                                const t = e.zoom;
                                if (!p.$imageEl || 0 === p.$imageEl.length) return;
                                if (!f.isTouched || !f.isMoved) return (f.isTouched = !1), void (f.isMoved = !1);
                                (f.isTouched = !1), (f.isMoved = !1);
                                let n = 300,
                                    i = 300;
                                const o = m.x * n,
                                    s = f.currentX + o,
                                    r = m.y * i,
                                    a = f.currentY + r;
                                0 !== m.x && (n = Math.abs((s - f.currentX) / m.x)), 0 !== m.y && (i = Math.abs((a - f.currentY) / m.y));
                                const l = Math.max(n, i);
                                (f.currentX = s), (f.currentY = a);
                                const c = f.width * t.scale,
                                    d = f.height * t.scale;
                                (f.minX = Math.min(p.slideWidth / 2 - c / 2, 0)),
                                    (f.maxX = -f.minX),
                                    (f.minY = Math.min(p.slideHeight / 2 - d / 2, 0)),
                                    (f.maxY = -f.minY),
                                    (f.currentX = Math.max(Math.min(f.currentX, f.maxX), f.minX)),
                                    (f.currentY = Math.max(Math.min(f.currentY, f.maxY), f.minY)),
                                    p.$imageWrapEl.transition(l).transform(`translate3d(${f.currentX}px, ${f.currentY}px,0)`);
                            })();
                    }),
                    n("doubleTap", (t, n) => {
                        !e.animating && e.params.zoom.enabled && e.zoom.enabled && e.params.zoom.toggle && k(n);
                    }),
                    n("transitionEnd", () => {
                        e.zoom.enabled && e.params.zoom.enabled && T();
                    }),
                    n("slideChange", () => {
                        e.zoom.enabled && e.params.zoom.enabled && e.params.cssMode && T();
                    }),
                    Object.assign(e.zoom, { enable: P, disable: L, in: C, out: S, toggle: k });
            },
            function ({ swiper: e, extendParams: t, on: n, emit: i }) {
                t({
                    lazy: {
                        checkInView: !1,
                        enabled: !1,
                        loadPrevNext: !1,
                        loadPrevNextAmount: 1,
                        loadOnTransitionStart: !1,
                        scrollingElement: "",
                        elementClass: "swiper-lazy",
                        loadingClass: "swiper-lazy-loading",
                        loadedClass: "swiper-lazy-loaded",
                        preloaderClass: "swiper-lazy-preloader",
                    },
                }),
                    (e.lazy = {});
                let o = !1,
                    r = !1;
                function a(t, n = !0) {
                    const o = e.params.lazy;
                    if (void 0 === t) return;
                    if (0 === e.slides.length) return;
                    const s = e.virtual && e.params.virtual.enabled ? e.$wrapperEl.children(`.${e.params.slideClass}[data-swiper-slide-index="${t}"]`) : e.slides.eq(t),
                        r = s.find(`.${o.elementClass}:not(.${o.loadedClass}):not(.${o.loadingClass})`);
                    !s.hasClass(o.elementClass) || s.hasClass(o.loadedClass) || s.hasClass(o.loadingClass) || r.push(s[0]),
                        0 !== r.length &&
                            r.each((t) => {
                                const r = c(t);
                                r.addClass(o.loadingClass);
                                const l = r.attr("data-background"),
                                    d = r.attr("data-src"),
                                    u = r.attr("data-srcset"),
                                    p = r.attr("data-sizes"),
                                    h = r.parent("picture");
                                e.loadImage(r[0], d || l, u, p, !1, () => {
                                    if (null != e && e && (!e || e.params) && !e.destroyed) {
                                        if (
                                            (l
                                                ? (r.css("background-image", `url("${l}")`), r.removeAttr("data-background"))
                                                : (u && (r.attr("srcset", u), r.removeAttr("data-srcset")),
                                                  p && (r.attr("sizes", p), r.removeAttr("data-sizes")),
                                                  h.length &&
                                                      h.children("source").each((e) => {
                                                          const t = c(e);
                                                          t.attr("data-srcset") && (t.attr("srcset", t.attr("data-srcset")), t.removeAttr("data-srcset"));
                                                      }),
                                                  d && (r.attr("src", d), r.removeAttr("data-src"))),
                                            r.addClass(o.loadedClass).removeClass(o.loadingClass),
                                            s.find(`.${o.preloaderClass}`).remove(),
                                            e.params.loop && n)
                                        ) {
                                            const t = s.attr("data-swiper-slide-index");
                                            s.hasClass(e.params.slideDuplicateClass)
                                                ? a(e.$wrapperEl.children(`[data-swiper-slide-index="${t}"]:not(.${e.params.slideDuplicateClass})`).index(), !1)
                                                : a(e.$wrapperEl.children(`.${e.params.slideDuplicateClass}[data-swiper-slide-index="${t}"]`).index(), !1);
                                        }
                                        i("lazyImageReady", s[0], r[0]), e.params.autoHeight && e.updateAutoHeight();
                                    }
                                }),
                                    i("lazyImageLoad", s[0], r[0]);
                            });
                }
                function l() {
                    const { $wrapperEl: t, params: n, slides: i, activeIndex: o } = e,
                        s = e.virtual && n.virtual.enabled,
                        l = n.lazy;
                    let d = n.slidesPerView;
                    function u(e) {
                        if (s) {
                            if (t.children(`.${n.slideClass}[data-swiper-slide-index="${e}"]`).length) return !0;
                        } else if (i[e]) return !0;
                        return !1;
                    }
                    function p(e) {
                        return s ? c(e).attr("data-swiper-slide-index") : c(e).index();
                    }
                    if (("auto" === d && (d = 0), r || (r = !0), e.params.watchSlidesProgress))
                        t.children(`.${n.slideVisibleClass}`).each((e) => {
                            a(s ? c(e).attr("data-swiper-slide-index") : c(e).index());
                        });
                    else if (d > 1) for (let e = o; e < o + d; e += 1) u(e) && a(e);
                    else a(o);
                    if (l.loadPrevNext)
                        if (d > 1 || (l.loadPrevNextAmount && l.loadPrevNextAmount > 1)) {
                            const e = l.loadPrevNextAmount,
                                t = d,
                                n = Math.min(o + t + Math.max(e, t), i.length),
                                s = Math.max(o - Math.max(t, e), 0);
                            for (let e = o + d; e < n; e += 1) u(e) && a(e);
                            for (let e = s; e < o; e += 1) u(e) && a(e);
                        } else {
                            const e = t.children(`.${n.slideNextClass}`);
                            e.length > 0 && a(p(e));
                            const i = t.children(`.${n.slidePrevClass}`);
                            i.length > 0 && a(p(i));
                        }
                }
                function d() {
                    const t = s();
                    if (!e || e.destroyed) return;
                    const n = e.params.lazy.scrollingElement ? c(e.params.lazy.scrollingElement) : c(t),
                        i = n[0] === t,
                        r = i ? t.innerWidth : n[0].offsetWidth,
                        a = i ? t.innerHeight : n[0].offsetHeight,
                        u = e.$el.offset(),
                        { rtlTranslate: p } = e;
                    let h = !1;
                    p && (u.left -= e.$el[0].scrollLeft);
                    const f = [
                        [u.left, u.top],
                        [u.left + e.width, u.top],
                        [u.left, u.top + e.height],
                        [u.left + e.width, u.top + e.height],
                    ];
                    for (let e = 0; e < f.length; e += 1) {
                        const t = f[e];
                        if (t[0] >= 0 && t[0] <= r && t[1] >= 0 && t[1] <= a) {
                            if (0 === t[0] && 0 === t[1]) continue;
                            h = !0;
                        }
                    }
                    const m = !("touchstart" !== e.touchEvents.start || !e.support.passiveListener || !e.params.passiveListeners) && { passive: !0, capture: !1 };
                    h ? (l(), n.off("scroll", d, m)) : o || ((o = !0), n.on("scroll", d, m));
                }
                n("beforeInit", () => {
                    e.params.lazy.enabled && e.params.preloadImages && (e.params.preloadImages = !1);
                }),
                    n("init", () => {
                        e.params.lazy.enabled && (e.params.lazy.checkInView ? d() : l());
                    }),
                    n("scroll", () => {
                        e.params.freeMode && e.params.freeMode.enabled && !e.params.freeMode.sticky && l();
                    }),
                    n("scrollbarDragMove resize _freeModeNoMomentumRelease", () => {
                        e.params.lazy.enabled && (e.params.lazy.checkInView ? d() : l());
                    }),
                    n("transitionStart", () => {
                        e.params.lazy.enabled && (e.params.lazy.loadOnTransitionStart || (!e.params.lazy.loadOnTransitionStart && !r)) && (e.params.lazy.checkInView ? d() : l());
                    }),
                    n("transitionEnd", () => {
                        e.params.lazy.enabled && !e.params.lazy.loadOnTransitionStart && (e.params.lazy.checkInView ? d() : l());
                    }),
                    n("slideChange", () => {
                        const { lazy: t, cssMode: n, watchSlidesProgress: i, touchReleaseOnEdges: o, resistanceRatio: s } = e.params;
                        t.enabled && (n || (i && (o || 0 === s))) && l();
                    }),
                    Object.assign(e.lazy, { load: l, loadInSlide: a });
            },
            function ({ swiper: e, extendParams: t, on: n }) {
                function i(e, t) {
                    const n = (function () {
                        let e, t, n;
                        return (i, o) => {
                            for (t = -1, e = i.length; e - t > 1; ) (n = (e + t) >> 1), i[n] <= o ? (t = n) : (e = n);
                            return e;
                        };
                    })();
                    let i, o;
                    return (
                        (this.x = e),
                        (this.y = t),
                        (this.lastIndex = e.length - 1),
                        (this.interpolate = function (e) {
                            return e ? ((o = n(this.x, e)), (i = o - 1), ((e - this.x[i]) * (this.y[o] - this.y[i])) / (this.x[o] - this.x[i]) + this.y[i]) : 0;
                        }),
                        this
                    );
                }
                function o() {
                    e.controller.control && e.controller.spline && ((e.controller.spline = void 0), delete e.controller.spline);
                }
                t({ controller: { control: void 0, inverse: !1, by: "slide" } }),
                    (e.controller = { control: void 0 }),
                    n("beforeInit", () => {
                        e.controller.control = e.params.controller.control;
                    }),
                    n("update", () => {
                        o();
                    }),
                    n("resize", () => {
                        o();
                    }),
                    n("observerUpdate", () => {
                        o();
                    }),
                    n("setTranslate", (t, n, i) => {
                        e.controller.control && e.controller.setTranslate(n, i);
                    }),
                    n("setTransition", (t, n, i) => {
                        e.controller.control && e.controller.setTransition(n, i);
                    }),
                    Object.assign(e.controller, {
                        setTranslate: function (t, n) {
                            const o = e.controller.control;
                            let s, r;
                            const a = e.constructor;
                            function l(t) {
                                const n = e.rtlTranslate ? -e.translate : e.translate;
                                "slide" === e.params.controller.by &&
                                    ((function (t) {
                                        e.controller.spline || (e.controller.spline = e.params.loop ? new i(e.slidesGrid, t.slidesGrid) : new i(e.snapGrid, t.snapGrid));
                                    })(t),
                                    (r = -e.controller.spline.interpolate(-n))),
                                    (r && "container" !== e.params.controller.by) || ((s = (t.maxTranslate() - t.minTranslate()) / (e.maxTranslate() - e.minTranslate())), (r = (n - e.minTranslate()) * s + t.minTranslate())),
                                    e.params.controller.inverse && (r = t.maxTranslate() - r),
                                    t.updateProgress(r),
                                    t.setTranslate(r, e),
                                    t.updateActiveIndex(),
                                    t.updateSlidesClasses();
                            }
                            if (Array.isArray(o)) for (let e = 0; e < o.length; e += 1) o[e] !== n && o[e] instanceof a && l(o[e]);
                            else o instanceof a && n !== o && l(o);
                        },
                        setTransition: function (t, n) {
                            const i = e.constructor,
                                o = e.controller.control;
                            let s;
                            function r(n) {
                                n.setTransition(t, e),
                                    0 !== t &&
                                        (n.transitionStart(),
                                        n.params.autoHeight &&
                                            u(() => {
                                                n.updateAutoHeight();
                                            }),
                                        n.$wrapperEl.transitionEnd(() => {
                                            o && (n.params.loop && "slide" === e.params.controller.by && n.loopFix(), n.transitionEnd());
                                        }));
                            }
                            if (Array.isArray(o)) for (s = 0; s < o.length; s += 1) o[s] !== n && o[s] instanceof i && r(o[s]);
                            else o instanceof i && n !== o && r(o);
                        },
                    });
            },
            function ({ swiper: e, extendParams: t, on: n }) {
                t({
                    a11y: {
                        enabled: !0,
                        notificationClass: "swiper-notification",
                        prevSlideMessage: "Previous slide",
                        nextSlideMessage: "Next slide",
                        firstSlideMessage: "This is the first slide",
                        lastSlideMessage: "This is the last slide",
                        paginationBulletMessage: "Go to slide {{index}}",
                        slideLabelMessage: "{{index}} / {{slidesLength}}",
                        containerMessage: null,
                        containerRoleDescriptionMessage: null,
                        itemRoleDescriptionMessage: null,
                        slideRole: "group",
                    },
                });
                let i = null;
                function o(e) {
                    const t = i;
                    0 !== t.length && (t.html(""), t.html(e));
                }
                function s(e) {
                    e.attr("tabIndex", "0");
                }
                function r(e) {
                    e.attr("tabIndex", "-1");
                }
                function a(e, t) {
                    e.attr("role", t);
                }
                function l(e, t) {
                    e.attr("aria-roledescription", t);
                }
                function d(e, t) {
                    e.attr("aria-label", t);
                }
                function u(e) {
                    e.attr("aria-disabled", !0);
                }
                function p(e) {
                    e.attr("aria-disabled", !1);
                }
                function h(t) {
                    if (13 !== t.keyCode && 32 !== t.keyCode) return;
                    const n = e.params.a11y,
                        i = c(t.target);
                    e.navigation && e.navigation.$nextEl && i.is(e.navigation.$nextEl) && ((e.isEnd && !e.params.loop) || e.slideNext(), e.isEnd ? o(n.lastSlideMessage) : o(n.nextSlideMessage)),
                        e.navigation && e.navigation.$prevEl && i.is(e.navigation.$prevEl) && ((e.isBeginning && !e.params.loop) || e.slidePrev(), e.isBeginning ? o(n.firstSlideMessage) : o(n.prevSlideMessage)),
                        e.pagination && i.is(F(e.params.pagination.bulletClass)) && i[0].click();
                }
                function f() {
                    if (e.params.loop || !e.navigation) return;
                    const { $nextEl: t, $prevEl: n } = e.navigation;
                    n && n.length > 0 && (e.isBeginning ? (u(n), r(n)) : (p(n), s(n))), t && t.length > 0 && (e.isEnd ? (u(t), r(t)) : (p(t), s(t)));
                }
                function m() {
                    return e.pagination && e.params.pagination.clickable && e.pagination.bullets && e.pagination.bullets.length;
                }
                const g = (e, t, n) => {
                    s(e),
                        "BUTTON" !== e[0].tagName && (a(e, "button"), e.on("keydown", h)),
                        d(e, n),
                        (function (e, t) {
                            e.attr("aria-controls", t);
                        })(e, t);
                };
                n("beforeInit", () => {
                    i = c(`<span class="${e.params.a11y.notificationClass}" aria-live="assertive" aria-atomic="true"></span>`);
                }),
                    n("afterInit", () => {
                        e.params.a11y.enabled &&
                            ((function () {
                                const t = e.params.a11y;
                                e.$el.append(i);
                                const n = e.$el;
                                t.containerRoleDescriptionMessage && l(n, t.containerRoleDescriptionMessage), t.containerMessage && d(n, t.containerMessage);
                                const o = e.$wrapperEl,
                                    s =
                                        o.attr("id") ||
                                        `swiper-wrapper-${(function (e = 16) {
                                            return "x".repeat(e).replace(/x/g, () => Math.round(16 * Math.random()).toString(16));
                                        })(16)}`,
                                    r = e.params.autoplay && e.params.autoplay.enabled ? "off" : "polite";
                                var u;
                                (u = s),
                                    o.attr("id", u),
                                    (function (e, t) {
                                        e.attr("aria-live", t);
                                    })(o, r),
                                    t.itemRoleDescriptionMessage && l(c(e.slides), t.itemRoleDescriptionMessage),
                                    a(c(e.slides), t.slideRole);
                                const p = e.params.loop ? e.slides.filter((t) => !t.classList.contains(e.params.slideDuplicateClass)).length : e.slides.length;
                                let f, v;
                                e.slides.each((n, i) => {
                                    const o = c(n),
                                        s = e.params.loop ? parseInt(o.attr("data-swiper-slide-index"), 10) : i;
                                    d(o, t.slideLabelMessage.replace(/\{\{index\}\}/, s + 1).replace(/\{\{slidesLength\}\}/, p));
                                }),
                                    e.navigation && e.navigation.$nextEl && (f = e.navigation.$nextEl),
                                    e.navigation && e.navigation.$prevEl && (v = e.navigation.$prevEl),
                                    f && f.length && g(f, s, t.nextSlideMessage),
                                    v && v.length && g(v, s, t.prevSlideMessage),
                                    m() && e.pagination.$el.on("keydown", F(e.params.pagination.bulletClass), h);
                            })(),
                            f());
                    }),
                    n("toEdge", () => {
                        e.params.a11y.enabled && f();
                    }),
                    n("fromEdge", () => {
                        e.params.a11y.enabled && f();
                    }),
                    n("paginationUpdate", () => {
                        e.params.a11y.enabled &&
                            (function () {
                                const t = e.params.a11y;
                                m() &&
                                    e.pagination.bullets.each((n) => {
                                        const i = c(n);
                                        s(i), e.params.pagination.renderBullet || (a(i, "button"), d(i, t.paginationBulletMessage.replace(/\{\{index\}\}/, i.index() + 1)));
                                    });
                            })();
                    }),
                    n("destroy", () => {
                        e.params.a11y.enabled &&
                            (function () {
                                let t, n;
                                i && i.length > 0 && i.remove(),
                                    e.navigation && e.navigation.$nextEl && (t = e.navigation.$nextEl),
                                    e.navigation && e.navigation.$prevEl && (n = e.navigation.$prevEl),
                                    t && t.off("keydown", h),
                                    n && n.off("keydown", h),
                                    m() && e.pagination.$el.off("keydown", F(e.params.pagination.bulletClass), h);
                            })();
                    });
            },
            function ({ swiper: e, extendParams: t, on: n }) {
                t({ history: { enabled: !1, root: "", replaceState: !1, key: "slides" } });
                let i = !1,
                    o = {};
                const r = (e) =>
                        e
                            .toString()
                            .replace(/\s+/g, "-")
                            .replace(/[^\w-]+/g, "")
                            .replace(/--+/g, "-")
                            .replace(/^-+/, "")
                            .replace(/-+$/, ""),
                    a = (e) => {
                        const t = s();
                        let n;
                        n = e ? new URL(e) : t.location;
                        const i = n.pathname
                                .slice(1)
                                .split("/")
                                .filter((e) => "" !== e),
                            o = i.length;
                        return { key: i[o - 2], value: i[o - 1] };
                    },
                    l = (t, n) => {
                        const o = s();
                        if (!i || !e.params.history.enabled) return;
                        let a;
                        a = e.params.url ? new URL(e.params.url) : o.location;
                        const l = e.slides.eq(n);
                        let c = r(l.attr("data-history"));
                        if (e.params.history.root.length > 0) {
                            let n = e.params.history.root;
                            "/" === n[n.length - 1] && (n = n.slice(0, n.length - 1)), (c = `${n}/${t}/${c}`);
                        } else a.pathname.includes(t) || (c = `${t}/${c}`);
                        const d = o.history.state;
                        (d && d.value === c) || (e.params.history.replaceState ? o.history.replaceState({ value: c }, null, c) : o.history.pushState({ value: c }, null, c));
                    },
                    c = (t, n, i) => {
                        if (n)
                            for (let o = 0, s = e.slides.length; o < s; o += 1) {
                                const s = e.slides.eq(o);
                                if (r(s.attr("data-history")) === n && !s.hasClass(e.params.slideDuplicateClass)) {
                                    const n = s.index();
                                    e.slideTo(n, t, i);
                                }
                            }
                        else e.slideTo(0, t, i);
                    },
                    d = () => {
                        (o = a(e.params.url)), c(e.params.speed, e.paths.value, !1);
                    };
                n("init", () => {
                    e.params.history.enabled &&
                        (() => {
                            const t = s();
                            if (e.params.history) {
                                if (!t.history || !t.history.pushState) return (e.params.history.enabled = !1), void (e.params.hashNavigation.enabled = !0);
                                (i = !0), (o = a(e.params.url)), (o.key || o.value) && (c(0, o.value, e.params.runCallbacksOnInit), e.params.history.replaceState || t.addEventListener("popstate", d));
                            }
                        })();
                }),
                    n("destroy", () => {
                        e.params.history.enabled &&
                            (() => {
                                const t = s();
                                e.params.history.replaceState || t.removeEventListener("popstate", d);
                            })();
                    }),
                    n("transitionEnd _freeModeNoMomentumRelease", () => {
                        i && l(e.params.history.key, e.activeIndex);
                    }),
                    n("slideChange", () => {
                        i && e.params.cssMode && l(e.params.history.key, e.activeIndex);
                    });
            },
            function ({ swiper: e, extendParams: t, emit: n, on: o }) {
                let r = !1;
                const a = i(),
                    l = s();
                t({ hashNavigation: { enabled: !1, replaceState: !1, watchState: !1 } });
                const d = () => {
                        n("hashChange");
                        const t = a.location.hash.replace("#", "");
                        if (t !== e.slides.eq(e.activeIndex).attr("data-hash")) {
                            const n = e.$wrapperEl.children(`.${e.params.slideClass}[data-hash="${t}"]`).index();
                            if (void 0 === n) return;
                            e.slideTo(n);
                        }
                    },
                    u = () => {
                        if (r && e.params.hashNavigation.enabled)
                            if (e.params.hashNavigation.replaceState && l.history && l.history.replaceState) l.history.replaceState(null, null, `#${e.slides.eq(e.activeIndex).attr("data-hash")}` || ""), n("hashSet");
                            else {
                                const t = e.slides.eq(e.activeIndex),
                                    i = t.attr("data-hash") || t.attr("data-history");
                                (a.location.hash = i || ""), n("hashSet");
                            }
                    };
                o("init", () => {
                    e.params.hashNavigation.enabled &&
                        (() => {
                            if (!e.params.hashNavigation.enabled || (e.params.history && e.params.history.enabled)) return;
                            r = !0;
                            const t = a.location.hash.replace("#", "");
                            if (t) {
                                const n = 0;
                                for (let i = 0, o = e.slides.length; i < o; i += 1) {
                                    const o = e.slides.eq(i);
                                    if ((o.attr("data-hash") || o.attr("data-history")) === t && !o.hasClass(e.params.slideDuplicateClass)) {
                                        const t = o.index();
                                        e.slideTo(t, n, e.params.runCallbacksOnInit, !0);
                                    }
                                }
                            }
                            e.params.hashNavigation.watchState && c(l).on("hashchange", d);
                        })();
                }),
                    o("destroy", () => {
                        e.params.hashNavigation.enabled && e.params.hashNavigation.watchState && c(l).off("hashchange", d);
                    }),
                    o("transitionEnd _freeModeNoMomentumRelease", () => {
                        r && u();
                    }),
                    o("slideChange", () => {
                        r && e.params.cssMode && u();
                    });
            },
            function ({ swiper: e, extendParams: t, on: n, emit: o }) {
                let s;
                function r() {
                    const t = e.slides.eq(e.activeIndex);
                    let n = e.params.autoplay.delay;
                    t.attr("data-swiper-autoplay") && (n = t.attr("data-swiper-autoplay") || e.params.autoplay.delay),
                        clearTimeout(s),
                        (s = u(() => {
                            let t;
                            e.params.autoplay.reverseDirection
                                ? e.params.loop
                                    ? (e.loopFix(), (t = e.slidePrev(e.params.speed, !0, !0)), o("autoplay"))
                                    : e.isBeginning
                                    ? e.params.autoplay.stopOnLastSlide
                                        ? l()
                                        : ((t = e.slideTo(e.slides.length - 1, e.params.speed, !0, !0)), o("autoplay"))
                                    : ((t = e.slidePrev(e.params.speed, !0, !0)), o("autoplay"))
                                : e.params.loop
                                ? (e.loopFix(), (t = e.slideNext(e.params.speed, !0, !0)), o("autoplay"))
                                : e.isEnd
                                ? e.params.autoplay.stopOnLastSlide
                                    ? l()
                                    : ((t = e.slideTo(0, e.params.speed, !0, !0)), o("autoplay"))
                                : ((t = e.slideNext(e.params.speed, !0, !0)), o("autoplay")),
                                ((e.params.cssMode && e.autoplay.running) || !1 === t) && r();
                        }, n));
                }
                function a() {
                    return void 0 === s && !e.autoplay.running && ((e.autoplay.running = !0), o("autoplayStart"), r(), !0);
                }
                function l() {
                    return !!e.autoplay.running && void 0 !== s && (s && (clearTimeout(s), (s = void 0)), (e.autoplay.running = !1), o("autoplayStop"), !0);
                }
                function c(t) {
                    e.autoplay.running &&
                        (e.autoplay.paused ||
                            (s && clearTimeout(s),
                            (e.autoplay.paused = !0),
                            0 !== t && e.params.autoplay.waitForTransition
                                ? ["transitionend", "webkitTransitionEnd"].forEach((t) => {
                                      e.$wrapperEl[0].addEventListener(t, p);
                                  })
                                : ((e.autoplay.paused = !1), r())));
                }
                function d() {
                    const t = i();
                    "hidden" === t.visibilityState && e.autoplay.running && c(), "visible" === t.visibilityState && e.autoplay.paused && (r(), (e.autoplay.paused = !1));
                }
                function p(t) {
                    e &&
                        !e.destroyed &&
                        e.$wrapperEl &&
                        t.target === e.$wrapperEl[0] &&
                        (["transitionend", "webkitTransitionEnd"].forEach((t) => {
                            e.$wrapperEl[0].removeEventListener(t, p);
                        }),
                        (e.autoplay.paused = !1),
                        e.autoplay.running ? r() : l());
                }
                function h() {
                    e.params.autoplay.disableOnInteraction ? l() : c(),
                        ["transitionend", "webkitTransitionEnd"].forEach((t) => {
                            e.$wrapperEl[0].removeEventListener(t, p);
                        });
                }
                function f() {
                    e.params.autoplay.disableOnInteraction || ((e.autoplay.paused = !1), r());
                }
                (e.autoplay = { running: !1, paused: !1 }),
                    t({ autoplay: { enabled: !1, delay: 3e3, waitForTransition: !0, disableOnInteraction: !0, stopOnLastSlide: !1, reverseDirection: !1, pauseOnMouseEnter: !1 } }),
                    n("init", () => {
                        e.params.autoplay.enabled && (a(), i().addEventListener("visibilitychange", d), e.params.autoplay.pauseOnMouseEnter && (e.$el.on("mouseenter", h), e.$el.on("mouseleave", f)));
                    }),
                    n("beforeTransitionStart", (t, n, i) => {
                        e.autoplay.running && (i || !e.params.autoplay.disableOnInteraction ? e.autoplay.pause(n) : l());
                    }),
                    n("sliderFirstMove", () => {
                        e.autoplay.running && (e.params.autoplay.disableOnInteraction ? l() : c());
                    }),
                    n("touchEnd", () => {
                        e.params.cssMode && e.autoplay.paused && !e.params.autoplay.disableOnInteraction && r();
                    }),
                    n("destroy", () => {
                        e.$el.off("mouseenter", h), e.$el.off("mouseleave", f), e.autoplay.running && l(), i().removeEventListener("visibilitychange", d);
                    }),
                    Object.assign(e.autoplay, { pause: c, run: r, start: a, stop: l });
            },
            function ({ swiper: e, extendParams: t, on: n }) {
                t({ thumbs: { swiper: null, multipleActiveThumbs: !0, autoScrollOffset: 0, slideThumbActiveClass: "swiper-slide-thumb-active", thumbsContainerClass: "swiper-thumbs" } });
                let i = !1,
                    o = !1;
                function s() {
                    const t = e.thumbs.swiper;
                    if (!t) return;
                    const n = t.clickedIndex,
                        i = t.clickedSlide;
                    if (i && c(i).hasClass(e.params.thumbs.slideThumbActiveClass)) return;
                    if (null == n) return;
                    let o;
                    if (((o = t.params.loop ? parseInt(c(t.clickedSlide).attr("data-swiper-slide-index"), 10) : n), e.params.loop)) {
                        let t = e.activeIndex;
                        e.slides.eq(t).hasClass(e.params.slideDuplicateClass) && (e.loopFix(), (e._clientLeft = e.$wrapperEl[0].clientLeft), (t = e.activeIndex));
                        const n = e.slides.eq(t).prevAll(`[data-swiper-slide-index="${o}"]`).eq(0).index(),
                            i = e.slides.eq(t).nextAll(`[data-swiper-slide-index="${o}"]`).eq(0).index();
                        o = void 0 === n ? i : void 0 === i ? n : i - t < t - n ? i : n;
                    }
                    e.slideTo(o);
                }
                function r() {
                    const { thumbs: t } = e.params;
                    if (i) return !1;
                    i = !0;
                    const n = e.constructor;
                    if (t.swiper instanceof n)
                        (e.thumbs.swiper = t.swiper),
                            Object.assign(e.thumbs.swiper.originalParams, { watchSlidesProgress: !0, slideToClickedSlide: !1 }),
                            Object.assign(e.thumbs.swiper.params, { watchSlidesProgress: !0, slideToClickedSlide: !1 });
                    else if (f(t.swiper)) {
                        const i = Object.assign({}, t.swiper);
                        Object.assign(i, { watchSlidesProgress: !0, slideToClickedSlide: !1 }), (e.thumbs.swiper = new n(i)), (o = !0);
                    }
                    return e.thumbs.swiper.$el.addClass(e.params.thumbs.thumbsContainerClass), e.thumbs.swiper.on("tap", s), !0;
                }
                function a(t) {
                    const n = e.thumbs.swiper;
                    if (!n) return;
                    const i = "auto" === n.params.slidesPerView ? n.slidesPerViewDynamic() : n.params.slidesPerView,
                        o = e.params.thumbs.autoScrollOffset,
                        s = o && !n.params.loop;
                    if (e.realIndex !== n.realIndex || s) {
                        let r,
                            a,
                            l = n.activeIndex;
                        if (n.params.loop) {
                            n.slides.eq(l).hasClass(n.params.slideDuplicateClass) && (n.loopFix(), (n._clientLeft = n.$wrapperEl[0].clientLeft), (l = n.activeIndex));
                            const t = n.slides.eq(l).prevAll(`[data-swiper-slide-index="${e.realIndex}"]`).eq(0).index(),
                                i = n.slides.eq(l).nextAll(`[data-swiper-slide-index="${e.realIndex}"]`).eq(0).index();
                            (r = void 0 === t ? i : void 0 === i ? t : i - l == l - t ? (n.params.slidesPerGroup > 1 ? i : l) : i - l < l - t ? i : t), (a = e.activeIndex > e.previousIndex ? "next" : "prev");
                        } else (r = e.realIndex), (a = r > e.previousIndex ? "next" : "prev");
                        s && (r += "next" === a ? o : -1 * o),
                            n.visibleSlidesIndexes &&
                                n.visibleSlidesIndexes.indexOf(r) < 0 &&
                                (n.params.centeredSlides ? (r = r > l ? r - Math.floor(i / 2) + 1 : r + Math.floor(i / 2) - 1) : r > l && n.params.slidesPerGroup, n.slideTo(r, t ? 0 : void 0));
                    }
                    let r = 1;
                    const a = e.params.thumbs.slideThumbActiveClass;
                    if (
                        (e.params.slidesPerView > 1 && !e.params.centeredSlides && (r = e.params.slidesPerView),
                        e.params.thumbs.multipleActiveThumbs || (r = 1),
                        (r = Math.floor(r)),
                        n.slides.removeClass(a),
                        n.params.loop || (n.params.virtual && n.params.virtual.enabled))
                    )
                        for (let t = 0; t < r; t += 1) n.$wrapperEl.children(`[data-swiper-slide-index="${e.realIndex + t}"]`).addClass(a);
                    else for (let t = 0; t < r; t += 1) n.slides.eq(e.realIndex + t).addClass(a);
                }
                (e.thumbs = { swiper: null }),
                    n("beforeInit", () => {
                        const { thumbs: t } = e.params;
                        t && t.swiper && (r(), a(!0));
                    }),
                    n("slideChange update resize observerUpdate", () => {
                        e.thumbs.swiper && a();
                    }),
                    n("setTransition", (t, n) => {
                        const i = e.thumbs.swiper;
                        i && i.setTransition(n);
                    }),
                    n("beforeDestroy", () => {
                        const t = e.thumbs.swiper;
                        t && o && t && t.destroy();
                    }),
                    Object.assign(e.thumbs, { init: r, update: a });
            },
            function ({ swiper: e, extendParams: t, emit: n, once: i }) {
                t({ freeMode: { enabled: !1, momentum: !0, momentumRatio: 1, momentumBounce: !0, momentumBounceRatio: 1, momentumVelocityRatio: 1, sticky: !1, minimumVelocity: 0.02 } }),
                    Object.assign(e, {
                        freeMode: {
                            onTouchMove: function () {
                                const { touchEventsData: t, touches: n } = e;
                                0 === t.velocities.length && t.velocities.push({ position: n[e.isHorizontal() ? "startX" : "startY"], time: t.touchStartTime }),
                                    t.velocities.push({ position: n[e.isHorizontal() ? "currentX" : "currentY"], time: p() });
                            },
                            onTouchEnd: function ({ currentPos: t }) {
                                const { params: o, $wrapperEl: s, rtlTranslate: r, snapGrid: a, touchEventsData: l } = e,
                                    c = p() - l.touchStartTime;
                                if (t < -e.minTranslate()) e.slideTo(e.activeIndex);
                                else if (t > -e.maxTranslate()) e.slides.length < a.length ? e.slideTo(a.length - 1) : e.slideTo(e.slides.length - 1);
                                else {
                                    if (o.freeMode.momentum) {
                                        if (l.velocities.length > 1) {
                                            const t = l.velocities.pop(),
                                                n = l.velocities.pop(),
                                                i = t.position - n.position,
                                                s = t.time - n.time;
                                            (e.velocity = i / s), (e.velocity /= 2), Math.abs(e.velocity) < o.freeMode.minimumVelocity && (e.velocity = 0), (s > 150 || p() - t.time > 300) && (e.velocity = 0);
                                        } else e.velocity = 0;
                                        (e.velocity *= o.freeMode.momentumVelocityRatio), (l.velocities.length = 0);
                                        let t = 1e3 * o.freeMode.momentumRatio;
                                        const c = e.velocity * t;
                                        let d = e.translate + c;
                                        r && (d = -d);
                                        let u,
                                            h = !1;
                                        const f = 20 * Math.abs(e.velocity) * o.freeMode.momentumBounceRatio;
                                        let m;
                                        if (d < e.maxTranslate())
                                            o.freeMode.momentumBounce ? (d + e.maxTranslate() < -f && (d = e.maxTranslate() - f), (u = e.maxTranslate()), (h = !0), (l.allowMomentumBounce = !0)) : (d = e.maxTranslate()),
                                                o.loop && o.centeredSlides && (m = !0);
                                        else if (d > e.minTranslate())
                                            o.freeMode.momentumBounce ? (d - e.minTranslate() > f && (d = e.minTranslate() + f), (u = e.minTranslate()), (h = !0), (l.allowMomentumBounce = !0)) : (d = e.minTranslate()),
                                                o.loop && o.centeredSlides && (m = !0);
                                        else if (o.freeMode.sticky) {
                                            let t;
                                            for (let e = 0; e < a.length; e += 1)
                                                if (a[e] > -d) {
                                                    t = e;
                                                    break;
                                                }
                                            (d = Math.abs(a[t] - d) < Math.abs(a[t - 1] - d) || "next" === e.swipeDirection ? a[t] : a[t - 1]), (d = -d);
                                        }
                                        if (
                                            (m &&
                                                i("transitionEnd", () => {
                                                    e.loopFix();
                                                }),
                                            0 !== e.velocity)
                                        ) {
                                            if (((t = r ? Math.abs((-d - e.translate) / e.velocity) : Math.abs((d - e.translate) / e.velocity)), o.freeMode.sticky)) {
                                                const n = Math.abs((r ? -d : d) - e.translate),
                                                    i = e.slidesSizesGrid[e.activeIndex];
                                                t = n < i ? o.speed : n < 2 * i ? 1.5 * o.speed : 2.5 * o.speed;
                                            }
                                        } else if (o.freeMode.sticky) return void e.slideToClosest();
                                        o.freeMode.momentumBounce && h
                                            ? (e.updateProgress(u),
                                              e.setTransition(t),
                                              e.setTranslate(d),
                                              e.transitionStart(!0, e.swipeDirection),
                                              (e.animating = !0),
                                              s.transitionEnd(() => {
                                                  e &&
                                                      !e.destroyed &&
                                                      l.allowMomentumBounce &&
                                                      (n("momentumBounce"),
                                                      e.setTransition(o.speed),
                                                      setTimeout(() => {
                                                          e.setTranslate(u),
                                                              s.transitionEnd(() => {
                                                                  e && !e.destroyed && e.transitionEnd();
                                                              });
                                                      }, 0));
                                              }))
                                            : e.velocity
                                            ? (n("_freeModeNoMomentumRelease"),
                                              e.updateProgress(d),
                                              e.setTransition(t),
                                              e.setTranslate(d),
                                              e.transitionStart(!0, e.swipeDirection),
                                              e.animating ||
                                                  ((e.animating = !0),
                                                  s.transitionEnd(() => {
                                                      e && !e.destroyed && e.transitionEnd();
                                                  })))
                                            : e.updateProgress(d),
                                            e.updateActiveIndex(),
                                            e.updateSlidesClasses();
                                    } else {
                                        if (o.freeMode.sticky) return void e.slideToClosest();
                                        o.freeMode && n("_freeModeNoMomentumRelease");
                                    }
                                    (!o.freeMode.momentum || c >= o.longSwipesMs) && (e.updateProgress(), e.updateActiveIndex(), e.updateSlidesClasses());
                                }
                            },
                        },
                    });
            },
            function ({ swiper: e, extendParams: t }) {
                let n, i, o;
                t({ grid: { rows: 1, fill: "column" } }),
                    (e.grid = {
                        initSlides: (t) => {
                            const { slidesPerView: s } = e.params,
                                { rows: r, fill: a } = e.params.grid;
                            (i = n / r), (o = Math.floor(t / r)), (n = Math.floor(t / r) === t / r ? t : Math.ceil(t / r) * r), "auto" !== s && "row" === a && (n = Math.max(n, s * r));
                        },
                        updateSlide: (t, s, r, a) => {
                            const { slidesPerGroup: l, spaceBetween: c } = e.params,
                                { rows: d, fill: u } = e.params.grid;
                            let p, h, f;
                            if ("row" === u && l > 1) {
                                const e = Math.floor(t / (l * d)),
                                    i = t - d * l * e,
                                    o = 0 === e ? l : Math.min(Math.ceil((r - e * d * l) / d), l);
                                (f = Math.floor(i / o)), (h = i - f * o + e * l), (p = h + (f * n) / d), s.css({ "-webkit-order": p, order: p });
                            } else "column" === u ? ((h = Math.floor(t / d)), (f = t - h * d), (h > o || (h === o && f === d - 1)) && ((f += 1), f >= d && ((f = 0), (h += 1)))) : ((f = Math.floor(t / i)), (h = t - f * i));
                            s.css(a("margin-top"), 0 !== f ? c && `${c}px` : "");
                        },
                        updateWrapperSize: (t, i, o) => {
                            const { spaceBetween: s, centeredSlides: r, roundLengths: a } = e.params,
                                { rows: l } = e.params.grid;
                            if (((e.virtualSize = (t + s) * n), (e.virtualSize = Math.ceil(e.virtualSize / l) - s), e.$wrapperEl.css({ [o("width")]: `${e.virtualSize + s}px` }), r)) {
                                i.splice(0, i.length);
                                const t = [];
                                for (let n = 0; n < i.length; n += 1) {
                                    let o = i[n];
                                    a && (o = Math.floor(o)), i[n] < e.virtualSize + i[0] && t.push(o);
                                }
                                i.push(...t);
                            }
                        },
                    });
            },
            function ({ swiper: e }) {
                Object.assign(e, { appendSlide: W.bind(e), prependSlide: B.bind(e), addSlide: V.bind(e), removeSlide: U.bind(e), removeAllSlides: G.bind(e) });
            },
            function ({ swiper: e, extendParams: t, on: n }) {
                t({ fadeEffect: { crossFade: !1, transformEl: null } }),
                    X({
                        effect: "fade",
                        swiper: e,
                        on: n,
                        setTranslate: () => {
                            const { slides: t } = e,
                                n = e.params.fadeEffect;
                            for (let i = 0; i < t.length; i += 1) {
                                const t = e.slides.eq(i);
                                let o = -t[0].swiperSlideOffset;
                                e.params.virtualTranslate || (o -= e.translate);
                                let s = 0;
                                e.isHorizontal() || ((s = o), (o = 0));
                                const r = e.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(t[0].progress), 0) : 1 + Math.min(Math.max(t[0].progress, -1), 0);
                                Y(n, t).css({ opacity: r }).transform(`translate3d(${o}px, ${s}px, 0px)`);
                            }
                        },
                        setTransition: (t) => {
                            const { transformEl: n } = e.params.fadeEffect;
                            (n ? e.slides.find(n) : e.slides).transition(t), K({ swiper: e, duration: t, transformEl: n, allSlides: !0 });
                        },
                        overwriteParams: () => ({ slidesPerView: 1, slidesPerGroup: 1, watchSlidesProgress: !0, spaceBetween: 0, virtualTranslate: !e.params.cssMode }),
                    });
            },
            function ({ swiper: e, extendParams: t, on: n }) {
                t({ cubeEffect: { slideShadows: !0, shadow: !0, shadowOffset: 20, shadowScale: 0.94 } }),
                    X({
                        effect: "cube",
                        swiper: e,
                        on: n,
                        setTranslate: () => {
                            const { $el: t, $wrapperEl: n, slides: i, width: o, height: s, rtlTranslate: r, size: a, browser: l } = e,
                                d = e.params.cubeEffect,
                                u = e.isHorizontal(),
                                p = e.virtual && e.params.virtual.enabled;
                            let h,
                                f = 0;
                            d.shadow &&
                                (u
                                    ? ((h = n.find(".swiper-cube-shadow")), 0 === h.length && ((h = c('<div class="swiper-cube-shadow"></div>')), n.append(h)), h.css({ height: `${o}px` }))
                                    : ((h = t.find(".swiper-cube-shadow")), 0 === h.length && ((h = c('<div class="swiper-cube-shadow"></div>')), t.append(h))));
                            for (let e = 0; e < i.length; e += 1) {
                                const t = i.eq(e);
                                let n = e;
                                p && (n = parseInt(t.attr("data-swiper-slide-index"), 10));
                                let o = 90 * n,
                                    s = Math.floor(o / 360);
                                r && ((o = -o), (s = Math.floor(-o / 360)));
                                const l = Math.max(Math.min(t[0].progress, 1), -1);
                                let h = 0,
                                    m = 0,
                                    g = 0;
                                n % 4 == 0 ? ((h = 4 * -s * a), (g = 0)) : (n - 1) % 4 == 0 ? ((h = 0), (g = 4 * -s * a)) : (n - 2) % 4 == 0 ? ((h = a + 4 * s * a), (g = a)) : (n - 3) % 4 == 0 && ((h = -a), (g = 3 * a + 4 * a * s)),
                                    r && (h = -h),
                                    u || ((m = h), (h = 0));
                                const v = `rotateX(${u ? 0 : -o}deg) rotateY(${u ? o : 0}deg) translate3d(${h}px, ${m}px, ${g}px)`;
                                if ((l <= 1 && l > -1 && ((f = 90 * n + 90 * l), r && (f = 90 * -n - 90 * l)), t.transform(v), d.slideShadows)) {
                                    let e = u ? t.find(".swiper-slide-shadow-left") : t.find(".swiper-slide-shadow-top"),
                                        n = u ? t.find(".swiper-slide-shadow-right") : t.find(".swiper-slide-shadow-bottom");
                                    0 === e.length && ((e = c(`<div class="swiper-slide-shadow-${u ? "left" : "top"}"></div>`)), t.append(e)),
                                        0 === n.length && ((n = c(`<div class="swiper-slide-shadow-${u ? "right" : "bottom"}"></div>`)), t.append(n)),
                                        e.length && (e[0].style.opacity = Math.max(-l, 0)),
                                        n.length && (n[0].style.opacity = Math.max(l, 0));
                                }
                            }
                            if ((n.css({ "-webkit-transform-origin": `50% 50% -${a / 2}px`, "transform-origin": `50% 50% -${a / 2}px` }), d.shadow))
                                if (u) h.transform(`translate3d(0px, ${o / 2 + d.shadowOffset}px, ${-o / 2}px) rotateX(90deg) rotateZ(0deg) scale(${d.shadowScale})`);
                                else {
                                    const e = Math.abs(f) - 90 * Math.floor(Math.abs(f) / 90),
                                        t = 1.5 - (Math.sin((2 * e * Math.PI) / 360) / 2 + Math.cos((2 * e * Math.PI) / 360) / 2),
                                        n = d.shadowScale,
                                        i = d.shadowScale / t,
                                        o = d.shadowOffset;
                                    h.transform(`scale3d(${n}, 1, ${i}) translate3d(0px, ${s / 2 + o}px, ${-s / 2 / i}px) rotateX(-90deg)`);
                                }
                            const m = l.isSafari || l.isWebView ? -a / 2 : 0;
                            n.transform(`translate3d(0px,0,${m}px) rotateX(${e.isHorizontal() ? 0 : f}deg) rotateY(${e.isHorizontal() ? -f : 0}deg)`);
                        },
                        setTransition: (t) => {
                            const { $el: n, slides: i } = e;
                            i.transition(t).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(t),
                                e.params.cubeEffect.shadow && !e.isHorizontal() && n.find(".swiper-cube-shadow").transition(t);
                        },
                        perspective: () => !0,
                        overwriteParams: () => ({ slidesPerView: 1, slidesPerGroup: 1, watchSlidesProgress: !0, resistanceRatio: 0, spaceBetween: 0, centeredSlides: !1, virtualTranslate: !0 }),
                    });
            },
            function ({ swiper: e, extendParams: t, on: n }) {
                t({ flipEffect: { slideShadows: !0, limitRotation: !0, transformEl: null } }),
                    X({
                        effect: "flip",
                        swiper: e,
                        on: n,
                        setTranslate: () => {
                            const { slides: t, rtlTranslate: n } = e,
                                i = e.params.flipEffect;
                            for (let o = 0; o < t.length; o += 1) {
                                const s = t.eq(o);
                                let r = s[0].progress;
                                e.params.flipEffect.limitRotation && (r = Math.max(Math.min(s[0].progress, 1), -1));
                                const a = s[0].swiperSlideOffset;
                                let l = -180 * r,
                                    c = 0,
                                    d = e.params.cssMode ? -a - e.translate : -a,
                                    u = 0;
                                if ((e.isHorizontal() ? n && (l = -l) : ((u = d), (d = 0), (c = -l), (l = 0)), (s[0].style.zIndex = -Math.abs(Math.round(r)) + t.length), i.slideShadows)) {
                                    let t = e.isHorizontal() ? s.find(".swiper-slide-shadow-left") : s.find(".swiper-slide-shadow-top"),
                                        n = e.isHorizontal() ? s.find(".swiper-slide-shadow-right") : s.find(".swiper-slide-shadow-bottom");
                                    0 === t.length && (t = Z(i, s, e.isHorizontal() ? "left" : "top")),
                                        0 === n.length && (n = Z(i, s, e.isHorizontal() ? "right" : "bottom")),
                                        t.length && (t[0].style.opacity = Math.max(-r, 0)),
                                        n.length && (n[0].style.opacity = Math.max(r, 0));
                                }
                                const p = `translate3d(${d}px, ${u}px, 0px) rotateX(${c}deg) rotateY(${l}deg)`;
                                Y(i, s).transform(p);
                            }
                        },
                        setTransition: (t) => {
                            const { transformEl: n } = e.params.flipEffect;
                            (n ? e.slides.find(n) : e.slides).transition(t).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(t),
                                K({ swiper: e, duration: t, transformEl: n });
                        },
                        perspective: () => !0,
                        overwriteParams: () => ({ slidesPerView: 1, slidesPerGroup: 1, watchSlidesProgress: !0, spaceBetween: 0, virtualTranslate: !e.params.cssMode }),
                    });
            },
            function ({ swiper: e, extendParams: t, on: n }) {
                t({ coverflowEffect: { rotate: 50, stretch: 0, depth: 100, scale: 1, modifier: 1, slideShadows: !0, transformEl: null } }),
                    X({
                        effect: "coverflow",
                        swiper: e,
                        on: n,
                        setTranslate: () => {
                            const { width: t, height: n, slides: i, slidesSizesGrid: o } = e,
                                s = e.params.coverflowEffect,
                                r = e.isHorizontal(),
                                a = e.translate,
                                l = r ? t / 2 - a : n / 2 - a,
                                c = r ? s.rotate : -s.rotate,
                                d = s.depth;
                            for (let e = 0, t = i.length; e < t; e += 1) {
                                const t = i.eq(e),
                                    n = o[e],
                                    a = ((l - t[0].swiperSlideOffset - n / 2) / n) * s.modifier;
                                let u = r ? c * a : 0,
                                    p = r ? 0 : c * a,
                                    h = -d * Math.abs(a),
                                    f = s.stretch;
                                "string" == typeof f && -1 !== f.indexOf("%") && (f = (parseFloat(s.stretch) / 100) * n);
                                let m = r ? 0 : f * a,
                                    g = r ? f * a : 0,
                                    v = 1 - (1 - s.scale) * Math.abs(a);
                                Math.abs(g) < 0.001 && (g = 0), Math.abs(m) < 0.001 && (m = 0), Math.abs(h) < 0.001 && (h = 0), Math.abs(u) < 0.001 && (u = 0), Math.abs(p) < 0.001 && (p = 0), Math.abs(v) < 0.001 && (v = 0);
                                const y = `translate3d(${g}px,${m}px,${h}px)  rotateX(${p}deg) rotateY(${u}deg) scale(${v})`;
                                if ((Y(s, t).transform(y), (t[0].style.zIndex = 1 - Math.abs(Math.round(a))), s.slideShadows)) {
                                    let e = r ? t.find(".swiper-slide-shadow-left") : t.find(".swiper-slide-shadow-top"),
                                        n = r ? t.find(".swiper-slide-shadow-right") : t.find(".swiper-slide-shadow-bottom");
                                    0 === e.length && (e = Z(s, t, r ? "left" : "top")),
                                        0 === n.length && (n = Z(s, t, r ? "right" : "bottom")),
                                        e.length && (e[0].style.opacity = a > 0 ? a : 0),
                                        n.length && (n[0].style.opacity = -a > 0 ? -a : 0);
                                }
                            }
                        },
                        setTransition: (t) => {
                            const { transformEl: n } = e.params.coverflowEffect;
                            (n ? e.slides.find(n) : e.slides).transition(t).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(t);
                        },
                        perspective: () => !0,
                        overwriteParams: () => ({ watchSlidesProgress: !0 }),
                    });
            },
            function ({ swiper: e, extendParams: t, on: n }) {
                t({
                    creativeEffect: {
                        transformEl: null,
                        limitProgress: 1,
                        shadowPerProgress: !1,
                        progressMultiplier: 1,
                        perspective: !0,
                        prev: { translate: [0, 0, 0], rotate: [0, 0, 0], opacity: 1, scale: 1 },
                        next: { translate: [0, 0, 0], rotate: [0, 0, 0], opacity: 1, scale: 1 },
                    },
                });
                const i = (e) => ("string" == typeof e ? e : `${e}px`);
                X({
                    effect: "creative",
                    swiper: e,
                    on: n,
                    setTranslate: () => {
                        const { slides: t } = e,
                            n = e.params.creativeEffect,
                            { progressMultiplier: o } = n;
                        for (let s = 0; s < t.length; s += 1) {
                            const r = t.eq(s),
                                a = r[0].progress,
                                l = Math.min(Math.max(r[0].progress, -n.limitProgress), n.limitProgress),
                                c = r[0].swiperSlideOffset,
                                d = [e.params.cssMode ? -c - e.translate : -c, 0, 0],
                                u = [0, 0, 0];
                            let p = !1;
                            e.isHorizontal() || ((d[1] = d[0]), (d[0] = 0));
                            let h = { translate: [0, 0, 0], rotate: [0, 0, 0], scale: 1, opacity: 1 };
                            l < 0 ? ((h = n.next), (p = !0)) : l > 0 && ((h = n.prev), (p = !0)),
                                d.forEach((e, t) => {
                                    d[t] = `calc(${e}px + (${i(h.translate[t])} * ${Math.abs(l * o)}))`;
                                }),
                                u.forEach((e, t) => {
                                    u[t] = h.rotate[t] * Math.abs(l * o);
                                }),
                                (r[0].style.zIndex = -Math.abs(Math.round(a)) + t.length);
                            const f = d.join(", "),
                                m = `rotateX(${u[0]}deg) rotateY(${u[1]}deg) rotateZ(${u[2]}deg)`,
                                g = l < 0 ? `scale(${1 + (1 - h.scale) * l * o})` : `scale(${1 - (1 - h.scale) * l * o})`,
                                v = l < 0 ? 1 + (1 - h.opacity) * l * o : 1 - (1 - h.opacity) * l * o,
                                y = `translate3d(${f}) ${m} ${g}`;
                            if ((p && h.shadow) || !p) {
                                let e = r.children(".swiper-slide-shadow");
                                if ((0 === e.length && h.shadow && (e = Z(n, r)), e.length)) {
                                    const t = n.shadowPerProgress ? l * (1 / n.limitProgress) : l;
                                    e[0].style.opacity = Math.min(Math.max(Math.abs(t), 0), 1);
                                }
                            }
                            const b = Y(n, r);
                            b.transform(y).css({ opacity: v }), h.origin && b.css("transform-origin", h.origin);
                        }
                    },
                    setTransition: (t) => {
                        const { transformEl: n } = e.params.creativeEffect;
                        (n ? e.slides.find(n) : e.slides).transition(t).find(".swiper-slide-shadow").transition(t), K({ swiper: e, duration: t, transformEl: n });
                    },
                    perspective: () => e.params.creativeEffect.perspective,
                    overwriteParams: () => ({ watchSlidesProgress: !0, virtualTranslate: !e.params.cssMode }),
                });
            },
            function ({ swiper: e, extendParams: t, on: n }) {
                t({ cardsEffect: { slideShadows: !0, transformEl: null } }),
                    X({
                        effect: "cards",
                        swiper: e,
                        on: n,
                        setTranslate: () => {
                            const { slides: t, activeIndex: n } = e,
                                i = e.params.cardsEffect,
                                { startTranslate: o, isTouched: s } = e.touchEventsData,
                                r = e.translate;
                            for (let a = 0; a < t.length; a += 1) {
                                const l = t.eq(a),
                                    c = l[0].progress,
                                    d = Math.min(Math.max(c, -4), 4);
                                let u = l[0].swiperSlideOffset;
                                e.params.centeredSlides && !e.params.cssMode && e.$wrapperEl.transform(`translateX(${e.minTranslate()}px)`), e.params.centeredSlides && e.params.cssMode && (u -= t[0].swiperSlideOffset);
                                let p = e.params.cssMode ? -u - e.translate : -u,
                                    h = 0;
                                const f = -100 * Math.abs(d);
                                let m = 1,
                                    g = -2 * d,
                                    v = 8 - 0.75 * Math.abs(d);
                                const y = (a === n || a === n - 1) && d > 0 && d < 1 && (s || e.params.cssMode) && r < o,
                                    b = (a === n || a === n + 1) && d < 0 && d > -1 && (s || e.params.cssMode) && r > o;
                                if (y || b) {
                                    const e = (1 - Math.abs((Math.abs(d) - 0.5) / 0.5)) ** 0.5;
                                    (g += -28 * d * e), (m += -0.5 * e), (v += 96 * e), (h = -25 * e * Math.abs(d) + "%");
                                }
                                if (((p = d < 0 ? `calc(${p}px + (${v * Math.abs(d)}%))` : d > 0 ? `calc(${p}px + (-${v * Math.abs(d)}%))` : `${p}px`), !e.isHorizontal())) {
                                    const e = h;
                                    (h = p), (p = e);
                                }
                                const w = `\n        translate3d(${p}, ${h}, ${f}px)\n        rotateZ(${g}deg)\n        scale(${d < 0 ? "" + (1 + (1 - m) * d) : "" + (1 - (1 - m) * d)})\n      `;
                                if (i.slideShadows) {
                                    let e = l.find(".swiper-slide-shadow");
                                    0 === e.length && (e = Z(i, l)), e.length && (e[0].style.opacity = Math.min(Math.max((Math.abs(d) - 0.5) / 0.5, 0), 1));
                                }
                                (l[0].style.zIndex = -Math.abs(Math.round(c)) + t.length), Y(i, l).transform(w);
                            }
                        },
                        setTransition: (t) => {
                            const { transformEl: n } = e.params.cardsEffect;
                            (n ? e.slides.find(n) : e.slides).transition(t).find(".swiper-slide-shadow").transition(t), K({ swiper: e, duration: t, transformEl: n });
                        },
                        perspective: () => !0,
                        overwriteParams: () => ({ watchSlidesProgress: !0, virtualTranslate: !e.params.cssMode }),
                    });
            },
        ];
        return H.use(Q), H;
    }),
    (function (e) {
        e = jQuery = e;
        var t,
            n,
            i,
            o,
            s = { sections: [] };
        (theme.cartNoteMonitor = {
            load: function (t) {
                t.on("change.themeCartNoteMonitor paste.themeCartNoteMonitor keyup.themeCartNoteMonitor", function () {
                    theme.cartNoteMonitor.postUpdate(e(this).val());
                });
            },
            unload: function (e) {
                e.off(".themeCartNoteMonitor");
            },
            updateThrottleTimeoutId: -1,
            updateThrottleInterval: 500,
            postUpdate: function (t) {
                clearTimeout(theme.cartNoteMonitor.updateThrottleTimeoutId),
                    (theme.cartNoteMonitor.updateThrottleTimeoutId = setTimeout(function () {
                        e.post(theme.routes.cart_url + "/update.js", { note: t }, function (e) {}, "json");
                    }, theme.cartNoteMonitor.updateThrottleInterval));
            },
        }),
            (theme.scriptsLoaded = {}),
            (theme.loadScriptOnce = function (e, t, n, i) {
                if (void 0 === theme.scriptsLoaded[e]) {
                    theme.scriptsLoaded[e] = [];
                    var o = document.createElement("script");
                    (o.src = e),
                        (i || n) && (o.async = !1),
                        n && n(),
                        "function" == typeof t &&
                            (theme.scriptsLoaded[e].push(t),
                            o.readyState
                                ? (o.onreadystatechange = function () {
                                      if ("loaded" == o.readyState || "complete" == o.readyState) {
                                          o.onreadystatechange = null;
                                          for (var e = 0; e < theme.scriptsLoaded[this].length; e++) theme.scriptsLoaded[this][e]();
                                          theme.scriptsLoaded[this] = !0;
                                      }
                                  }.bind(e))
                                : (o.onload = function () {
                                      for (var e = 0; e < theme.scriptsLoaded[this].length; e++) theme.scriptsLoaded[this][e]();
                                      theme.scriptsLoaded[this] = !0;
                                  }.bind(e)));
                    var s = document.getElementsByTagName("script")[0];
                    return s.parentNode.insertBefore(o, s), !0;
                }
                if ("object" !== _typeof(theme.scriptsLoaded[e]) || "function" != typeof t) return "function" == typeof t && t(), !1;
                theme.scriptsLoaded[e].push(t);
            }),
            (theme.loadStyleOnce = function (e) {
                var t = e.replace(/^https?:/, "");
                if (!document.querySelector('link[href="' + encodeURI(t) + '"]')) {
                    var n = document.createElement("link");
                    (n.href = t), (n.rel = "stylesheet"), (n.type = "text/css");
                    var i = document.getElementsByTagName("link")[0];
                    i.parentNode.insertBefore(n, i);
                }
            }),
            (theme.Disclosure = (function () {
                var t = "disclosure-list--visible";
                function n(e) {
                    (this.$container = e), (this.cache = {}), this._cacheSelectors(), this._connectOptions(), this._connectToggle(), this._onFocusOut();
                }
                return (
                    (n.prototype = e.extend({}, n.prototype, {
                        _cacheSelectors: function () {
                            this.cache = {
                                $disclosureList: this.$container.find("[data-disclosure-list]"),
                                $disclosureToggle: this.$container.find("[data-disclosure-toggle]"),
                                $disclosureInput: this.$container.find("[data-disclosure-input]"),
                                $disclosureOptions: this.$container.find("[data-disclosure-option]"),
                            };
                        },
                        _connectToggle: function () {
                            this.cache.$disclosureToggle.on(
                                "click",
                                function (n) {
                                    var i = "true" === e(n.currentTarget).attr("aria-expanded");
                                    e(n.currentTarget).attr("aria-expanded", !i), this.cache.$disclosureList.toggleClass(t);
                                }.bind(this)
                            );
                        },
                        _connectOptions: function () {
                            this.cache.$disclosureOptions.on(
                                "click",
                                function (t) {
                                    t.preventDefault(), this._submitForm(e(t.currentTarget).data("value"));
                                }.bind(this)
                            );
                        },
                        _onFocusOut: function () {
                            this.cache.$disclosureToggle.on(
                                "focusout",
                                function (e) {
                                    0 === this.$container.has(e.relatedTarget).length && this._hideList();
                                }.bind(this)
                            ),
                                this.cache.$disclosureList.on(
                                    "focusout",
                                    function (n) {
                                        var i = e(n.currentTarget).has(n.relatedTarget).length > 0;
                                        this.cache.$disclosureList.hasClass(t) && !i && this._hideList();
                                    }.bind(this)
                                ),
                                this.$container.on(
                                    "keyup",
                                    function (e) {
                                        27 === e.which && (this._hideList(), this.cache.$disclosureToggle.focus());
                                    }.bind(this)
                                ),
                                (this.bodyOnClick = function (e) {
                                    var n = this.$container.has(e.target).length > 0;
                                    this.cache.$disclosureList.hasClass(t) && !n && this._hideList();
                                }.bind(this)),
                                e("body").on("click", this.bodyOnClick);
                        },
                        _submitForm: function (e) {
                            this.cache.$disclosureInput.val(e), this.$container.parents("form").submit();
                        },
                        _hideList: function () {
                            this.cache.$disclosureList.removeClass(t), this.cache.$disclosureToggle.attr("aria-expanded", !1);
                        },
                        unload: function () {
                            e("body").off("click", this.bodyOnClick), this.cache.$disclosureOptions.off(), this.cache.$disclosureToggle.off(), this.cache.$disclosureList.off(), this.$container.off();
                        },
                    })),
                    n
                );
            })()),
            (e.fn.clickyBoxes = function (t) {
                if ("destroy" != t)
                    return e(this)
                        .filter("select:not(.clickybox-replaced)")
                        .addClass("clickybox-replaced")
                        .each(function () {
                            var t,
                                n = n || e(this).attr("id"),
                                i = e('<ul class="clickyboxes"/>')
                                    .attr("id", "clickyboxes-" + n)
                                    .data("select", e(this))
                                    .insertAfter(this);
                            (t = e(this).is("[id]") ? e('label[for="' + e(this).attr("id") + '"]') : e(this).siblings("label")).length > 0 &&
                                i.addClass(
                                    "options-" +
                                        removeDiacritics(t.text())
                                            .toLowerCase()
                                            .replace(/'/g, "")
                                            .replace(/[^a-z0-9]+/g, "-")
                                            .replace(/-+/g, "-")
                                            .replace(/-*$/, "")
                                ),
                                e(this)
                                    .find("option")
                                    .each(function () {
                                        e("<li/>")
                                            .appendTo(i)
                                            .append(
                                                e('<a data-href="#"/>')
                                                    .attr("data-value", e(this).val())
                                                    .html(e(this).html())
                                                    .addClass(
                                                        "opt--" +
                                                            removeDiacritics(e(this).text())
                                                                .toLowerCase()
                                                                .replace(/'/g, "")
                                                                .replace(/[^a-z0-9]+/g, "-")
                                                                .replace(/-+/g, "-")
                                                                .replace(/-*$/, "")
                                                    )
                                            );
                                    }),
                                e(this)
                                    .hide()
                                    .addClass("replaced")
                                    .on("change.clickyboxes keyup.clickyboxes", function () {
                                        var t = e(this).val();
                                        i.find("a")
                                            .removeClass("active")
                                            .filter(function () {
                                                return e(this).attr("data-value") == t;
                                            })
                                            .addClass("active");
                                    })
                                    .trigger("keyup"),
                                i.on("click.clickyboxes", "a", function () {
                                    if (!e(this).hasClass("active")) {
                                        var t = e(this).closest(".clickyboxes");
                                        t.data("select").val(e(this).data("value")).trigger("change"), t.trigger("change");
                                    }
                                    return !1;
                                });
                        });
                e(this).off(".clickyboxes"), e(this).next(".clickyboxes").off(".clickyboxes");
            }),
            (o = document.createEvent("Event")).initEvent("throttled-scroll", !0, !0),
            window.addEventListener(
                "scroll",
                ((t = function () {
                    window.dispatchEvent(o);
                }),
                (n = -1),
                (i = !1),
                function () {
                    clearTimeout(n),
                        (n = setTimeout(t, 200)),
                        i ||
                            (t.call(),
                            (i = !0),
                            setTimeout(function () {
                                i = !1;
                            }, 200));
                })
            ),
            (theme.Sections = new (function () {
                var t = this;
                (t._instances = []),
                    (t._deferredSectionTargets = []),
                    (t._sections = []),
                    (t._deferredLoadViewportExcess = 300),
                    (t._deferredWatcherRunning = !1),
                    (t.init = function () {
                        e(document)
                            .on("shopify:section:load", function (e) {
                                var n = t._themeSectionTargetFromShopifySectionTarget(e.target);
                                n && t.sectionLoad(n);
                            })
                            .on("shopify:section:unload", function (e) {
                                var n = t._themeSectionTargetFromShopifySectionTarget(e.target);
                                n && t.sectionUnload(n);
                            }),
                            e(window).on("throttled-scroll.themeSectionDeferredLoader debouncedresize.themeSectionDeferredLoader", t._processDeferredSections),
                            (t._deferredWatcherRunning = !0);
                    }),
                    (t.register = function (n, i, o) {
                        t._sections.push({ type: n, section: i, afterSectionLoadCallback: o ? o.afterLoad : null, afterSectionUnloadCallback: o ? o.afterUnload : null }),
                            e('[data-section-type="' + n + '"]').each(function () {
                                Shopify.designMode || (o && !1 === o.deferredLoad) || !t._deferredWatcherRunning ? t.sectionLoad(this) : t.sectionDeferredLoad(this, o);
                            });
                    }),
                    (t.sectionDeferredLoad = function (e, n) {
                        t._deferredSectionTargets.push({ target: e, deferredLoadViewportExcess: n && n.deferredLoadViewportExcess ? n.deferredLoadViewportExcess : t._deferredLoadViewportExcess }), t._processDeferredSections(!0);
                    }),
                    (t._processDeferredSections = function (n) {
                        if (t._deferredSectionTargets.length)
                            for (var i = e(window).scrollTop(), o = i + e(window).height(), s = !0 === n ? t._deferredSectionTargets.length - 1 : 0; s < t._deferredSectionTargets.length; s++) {
                                var r = t._deferredSectionTargets[s].target,
                                    a = t._deferredSectionTargets[s].deferredLoadViewportExcess,
                                    l = e(r).offset().top - a,
                                    c = l > i && l < o;
                                if (!c) {
                                    var d = l + e(r).outerHeight() + 2 * a;
                                    c = d > i && d < o;
                                }
                                (c || (l < i && d > o)) && (t.sectionLoad(r), t._deferredSectionTargets.splice(s, 1), s--);
                            }
                        !0 !== n && 0 === t._deferredSectionTargets.length && ((t._deferredWatcherRunning = !1), e(window).off(".themeSectionDeferredLoader"));
                    }),
                    (t.sectionLoad = function (n) {
                        var i,
                            o = t._sectionForTarget(n);
                        if (!1 !== (i = o.section ? o.section : o)) {
                            var s = { target: n, section: i, $shopifySectionContainer: e(n).closest(".shopify-section"), thisContext: { functions: i.functions, registeredEventListeners: [] } };
                            (s.thisContext.registerEventListener = t._registerEventListener.bind(s.thisContext)),
                                t._instances.push(s),
                                e(n).data("components") &&
                                    e(n)
                                        .data("components")
                                        .split(",")
                                        .forEach(function (t) {
                                            e(document).trigger("cc:component:load", [t, n]);
                                        }),
                                t._callSectionWith(i, "onSectionLoad", n, s.thisContext),
                                t._callSectionWith(i, "afterSectionLoadCallback", n, s.thisContext),
                                i.onSectionSelect &&
                                    s.$shopifySectionContainer.on("shopify:section:select", function (e) {
                                        t._callSectionWith(i, "onSectionSelect", e.target, s.thisContext);
                                    }),
                                i.onSectionDeselect &&
                                    s.$shopifySectionContainer.on("shopify:section:deselect", function (e) {
                                        t._callSectionWith(i, "onSectionDeselect", e.target, s.thisContext);
                                    }),
                                i.onBlockSelect &&
                                    e(n).on("shopify:block:select", function (e) {
                                        t._callSectionWith(i, "onBlockSelect", e.target, s.thisContext);
                                    }),
                                i.onBlockDeselect &&
                                    e(n).on("shopify:block:deselect", function (e) {
                                        t._callSectionWith(i, "onBlockDeselect", e.target, s.thisContext);
                                    });
                        }
                    }),
                    (t.sectionUnload = function (n) {
                        for (var i = t._sectionForTarget(n), o = -1, s = 0; s < t._instances.length; s++) t._instances[s].target == n && (o = s);
                        if (o > -1) {
                            var r = t._instances[o];
                            e(n).off("shopify:block:select shopify:block:deselect"),
                                r.$shopifySectionContainer.off("shopify:section:select shopify:section:deselect"),
                                t._callSectionWith(r.section, "onSectionUnload", n, r.thisContext),
                                t._unloadRegisteredEventListeners(r.thisContext.registeredEventListeners),
                                t._callSectionWith(i, "afterSectionUnloadCallback", n, r.thisContext),
                                t._instances.splice(o),
                                e(n).data("components") &&
                                    e(n)
                                        .data("components")
                                        .split(",")
                                        .forEach(function (t) {
                                            e(document).trigger("cc:component:unload", [t, n]);
                                        });
                        } else
                            for (s = 0; s < t._deferredSectionTargets.length; s++)
                                if (t._deferredSectionTargets[s].target == n) {
                                    t._deferredSectionTargets[s].splice(s, 1);
                                    break;
                                }
                    }),
                    (t._registerEventListener = function (e, t, n) {
                        e.addEventListener(t, n), this.registeredEventListeners.push({ element: e, eventType: t, callback: n });
                    }),
                    (t._unloadRegisteredEventListeners = function (e) {
                        e.forEach(function (e) {
                            e.element.removeEventListener(e.eventType, e.callback);
                        });
                    }),
                    (t._callSectionWith = function (e, t, n, i) {
                        if ("function" == typeof e[t])
                            try {
                                i ? e[t].bind(i)(n) : e[t](n);
                            } catch (e) {
                                var o = n.dataset.sectionType;
                                console.warn("Theme warning: '".concat(t, "' failed for section '").concat(o, "'")), console.debug(n, e);
                            }
                    }),
                    (t._themeSectionTargetFromShopifySectionTarget = function (t) {
                        var n = e("[data-section-type]:first", t);
                        return n.length > 0 && n[0];
                    }),
                    (t._sectionForTarget = function (n) {
                        for (var i = e(n).attr("data-section-type"), o = 0; o < t._sections.length; o++) if (t._sections[o].type == i) return t._sections[o];
                        return !1;
                    }),
                    (t._sectionAlreadyRegistered = function (e) {
                        for (var n = 0; n < t._sections.length; n++) if (t._sections[n].type == e) return !0;
                        return !1;
                    });
            })());
        var r = (function () {
            "use strict";
            function t(n) {
                var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ".cc-".concat(n);
                _classCallCheck(this, t);
                var o = this;
                (this.instances = []),
                    e(document).on("cc:component:load", function (t, s, r) {
                        s === n &&
                            e(r)
                                .find("".concat(i, ":not(.cc-initialized)"))
                                .each(function () {
                                    o.init(this);
                                });
                    }),
                    e(document).on("cc:component:unload", function (t, s, r) {
                        s === n &&
                            e(r)
                                .find(i)
                                .each(function () {
                                    o.destroy(this);
                                });
                    }),
                    e(i).each(function () {
                        o.init(this);
                    });
            }
            return (
                _createClass(t, [
                    {
                        key: "init",
                        value: function (t) {
                            e(t).addClass("cc-initialized");
                        },
                    },
                    {
                        key: "destroy",
                        value: function (t) {
                            e(t).removeClass("cc-initialized");
                        },
                    },
                    {
                        key: "registerInstance",
                        value: function (e, t) {
                            this.instances.push({ container: e, instance: t });
                        },
                    },
                    {
                        key: "destroyInstance",
                        value: function (e) {
                            this.instances = this.instances.filter(function (t) {
                                if (t.container === e) return "function" == typeof t.instance.destroy && t.instance.destroy(), t.container !== e;
                            });
                        },
                    },
                ]),
                t
            );
        })();
        (theme.showQuickPopup = function (t, n) {
            var i = e('<div class="simple-popup"/>'),
                o = n.offset();
            i.html(t).css({ left: o.left, top: o.top }).hide(),
                e("body").append(i),
                i.css({ marginTop: -i.outerHeight() - 10, marginLeft: -(i.outerWidth() - n.outerWidth()) / 2 }),
                i
                    .fadeIn(200)
                    .delay(3500)
                    .fadeOut(400, function () {
                        e(this).remove();
                    });
        }),
            (theme.Shopify = {
                formatMoney: function (e, t) {
                    function n(e, t) {
                        return void 0 === e ? t : e;
                    }
                    function i(e, t, i, o) {
                        if (((t = n(t, 2)), (i = n(i, ",")), (o = n(o, ".")), isNaN(e) || null == e)) return 0;
                        var s = (e = (e / 100).toFixed(t)).split(".");
                        return s[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) + (s[1] ? o + s[1] : "");
                    }
                    "string" == typeof e && (e = e.replace(".", ""));
                    var o = "",
                        s = /\{\{\s*(\w+)\s*\}\}/,
                        r = t || this.money_format;
                    switch (r.match(s)[1]) {
                        case "amount":
                            o = i(e, 2);
                            break;
                        case "amount_no_decimals":
                            o = i(e, 0);
                            break;
                        case "amount_with_comma_separator":
                            o = i(e, 2, ".", ",");
                            break;
                        case "amount_with_space_separator":
                            o = i(e, 2, " ", ",");
                            break;
                        case "amount_with_period_and_space_separator":
                            o = i(e, 2, " ", ".");
                            break;
                        case "amount_no_decimals_with_comma_separator":
                            o = i(e, 0, ".", ",");
                            break;
                        case "amount_no_decimals_with_space_separator":
                            o = i(e, 0, " ", "");
                            break;
                        case "amount_with_apostrophe_separator":
                            o = i(e, 2, "'", ".");
                            break;
                        case "amount_with_decimal_separator":
                            o = i(e, 2, ".", ".");
                    }
                    return r.replace(s, o);
                },
                formatImage: function (e, t) {
                    return e ? e.replace(/^(.*)\.([^\.]*)$/g, "$1_" + t + ".$2") : "";
                },
                Image: {
                    imageSize: function (e) {
                        var t = e.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
                        return null !== t ? t[1] : null;
                    },
                    getSizedImageUrl: function (e, t) {
                        if (null == t) return e;
                        if ("master" == t) return this.removeProtocol(e);
                        var n = e.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
                        if (null != n) {
                            var i = e.split(n[0]),
                                o = n[0];
                            return this.removeProtocol(i[0] + "_" + t + o);
                        }
                        return null;
                    },
                    removeProtocol: function (e) {
                        return e.replace(/http(s)?:/, "");
                    },
                },
            });
        var a = (function () {
                "use strict";
                function t(e, n) {
                    _classCallCheck(this, t), (this.$container = e), (this.namespace = n), (this.cssClasses = { visible: "cc-popup--visible", bodyNoScroll: "cc-popup-no-scroll", bodyNoScrollPadRight: "cc-popup-no-scroll-pad-right" });
                }
                return (
                    _createClass(t, [
                        {
                            key: "open",
                            value: function (t) {
                                var n = this;
                                if (this.$container.data("freeze-scroll")) {
                                    e("body").addClass(this.cssClasses.bodyNoScroll);
                                    var i = document.createElement("div");
                                    (i.className = "popup-scrollbar-measure"), document.body.appendChild(i);
                                    var o = i.getBoundingClientRect().width - i.clientWidth;
                                    document.body.removeChild(i),
                                        o > 0 &&
                                            e("body")
                                                .css("padding-right", o + "px")
                                                .addClass(this.cssClasses.bodyNoScrollPadRight);
                                }
                                this.$container.addClass(this.cssClasses.visible),
                                    (this.previouslyActiveElement = document.activeElement),
                                    setTimeout(function () {
                                        n.$container.find(".cc-popup-close")[0].focus();
                                    }, 500),
                                    e(window).on("keydown" + this.namespace, function (e) {
                                        27 === e.keyCode && n.close();
                                    }),
                                    t && t();
                            },
                        },
                        {
                            key: "close",
                            value: function (t) {
                                var n = this;
                                if (
                                    (this.$container.removeClass(this.cssClasses.visible),
                                    this.previouslyActiveElement && e(this.previouslyActiveElement).focus(),
                                    e(window).off("keydown" + this.namespace),
                                    this.$container.data("freeze-scroll"))
                                ) {
                                    var i = 500,
                                        o = this.$container.find(".cc-popup-modal");
                                    o.length && (i = parseFloat(getComputedStyle(o[0]).transitionDuration)) && i > 0 && (i *= 1e3),
                                        setTimeout(function () {
                                            e("body").removeClass(n.cssClasses.bodyNoScroll).removeClass(n.cssClasses.bodyNoScrollPadRight).css("padding-right", "0");
                                        }, i);
                                }
                                t && t();
                            },
                        },
                    ]),
                    t
                );
            })(),
            l = (function () {
                "use strict";
                function e(t) {
                    _classCallCheck(this, e),
                        (this.filteringEnabled = "true" === t.dataset.filtering),
                        (this.sortingEnabled = "true" === t.dataset.sorting),
                        (this.filtersControl = document.querySelector(".cc-filters-control")),
                        (this.filtersContainer = document.querySelector(".cc-filters-container")),
                        (this.productList = document.querySelector(".cc-product-list")),
                        this.filteringEnabled &&
                            ((this.filters = document.querySelector(".cc-filters")),
                            (this.filtersFooter = document.querySelector(".cc-filters__footer")),
                            (this.activeFilters = document.querySelector(".cc-active-filters")),
                            (this.clearFiltersBtn = document.querySelector(".js-clear-filters"))),
                        this.sortingEnabled && ((this.sortBy = document.querySelector(".cc-filter--sort")), (this.activeSortText = document.querySelector(".cc-sort-selected"))),
                        (this.utils = { hidden: "is-hidden", loading: "is-loading", open: "is-open", filtersOpen: "filters-open" }),
                        this.filteringEnabled && !this.filtersFooter.classList.contains(this.utils.hidden) && (this.filters.style.height = "calc(100% - ".concat(this.filtersFooter.offsetHeight, "px)")),
                        this.bindEvents();
                }
                return (
                    _createClass(e, [
                        {
                            key: "bindEvents",
                            value: function () {
                                this.filtersControl.addEventListener("click", this.handleControlClick.bind(this)),
                                    this.filtersContainer.addEventListener("click", this.handleFiltersClick.bind(this)),
                                    this.filtersContainer.addEventListener("input", this.debounce(this.handleFilterChange.bind(this), 500)),
                                    this.filteringEnabled &&
                                        (document.querySelector(".cc-price-range") && this.filtersContainer.addEventListener("change", this.debounce(this.handleFilterChange.bind(this), 500)),
                                        this.activeFilters.addEventListener("click", this.handleActiveFiltersClick.bind(this))),
                                    document.addEventListener("click", this.handleClickOutside.bind(this)),
                                    window.addEventListener("popstate", this.handleHistoryChange.bind(this));
                            },
                        },
                        {
                            key: "debounce",
                            value: function (e, t) {
                                var n,
                                    i = this;
                                return function () {
                                    for (var o = arguments.length, s = new Array(o), r = 0; r < o; r++) s[r] = arguments[r];
                                    clearTimeout(n),
                                        (n = setTimeout(function () {
                                            return e.apply(i, s);
                                        }, t));
                                };
                            },
                        },
                        {
                            key: "handleControlClick",
                            value: function (e) {
                                var t = this;
                                e.target.matches(".cc-filters-control__btn") &&
                                    (document.body.classList.add(this.utils.filtersOpen),
                                    e.target.matches(".js-show-filters")
                                        ? this.filters.classList.add(this.utils.open)
                                        : ((this.sortBy.open = !0),
                                          setTimeout(function () {
                                              t.sortBy.classList.add(t.utils.open);
                                          }, 10)));
                            },
                        },
                        {
                            key: "handleFiltersClick",
                            value: function (e) {
                                var t = this,
                                    n = e.target,
                                    i = n.closest(".cc-filter");
                                if (n.matches(".cc-filter-clear-btn")) return e.preventDefault(), void this.applyFilters(new URL(e.target.href).searchParams.toString(), e);
                                if (n.matches(".js-close-filters"))
                                    return (
                                        i &&
                                            setTimeout(function () {
                                                i.classList.remove(t.utils.open), (i.open = !1);
                                            }, 300),
                                        this.filteringEnabled && this.filters.classList.remove(this.utils.open),
                                        void document.body.classList.remove(this.utils.filtersOpen)
                                    );
                                if (n.matches(".cc-filter__toggle") || n.matches(".cc-filter-back-btn")) {
                                    var o = document.querySelector('.cc-filter[open]:not([data-index="'.concat(i.dataset.index, '"])'));
                                    o && this.closeFilter(o, !1),
                                        i.classList.contains(this.utils.open)
                                            ? (e.preventDefault(), this.closeFilter(i))
                                            : setTimeout(function () {
                                                  i.classList.add(t.utils.open);
                                              }, 10);
                                }
                            },
                        },
                        {
                            key: "handleClickOutside",
                            value: function (e) {
                                var t = document.querySelector(".cc-filter.".concat(this.utils.open));
                                if (t) {
                                    var n = e.target.closest(".cc-filter");
                                    (n && n === t) || (e.preventDefault(), this.closeFilter(t));
                                }
                            },
                        },
                        {
                            key: "handleFilterChange",
                            value: function (e) {
                                if ("change" !== e.type || (e.detail && "theme:component:price_range" === e.detail.sender)) {
                                    "input" === e.type && e.target.classList.contains("cc-price-range__input") && e.target.dispatchEvent(new Event("change", { bubbles: !0 }));
                                    var t = new FormData(document.getElementById("filters")),
                                        n = new URLSearchParams(t);
                                    this.applyFilters(n.toString(), e);
                                }
                            },
                        },
                        {
                            key: "handleActiveFiltersClick",
                            value: function (e) {
                                e.preventDefault(), "A" === e.target.tagName && this.applyFilters(new URL(e.target.href).searchParams.toString(), e);
                            },
                        },
                        {
                            key: "handleHistoryChange",
                            value: function (e) {
                                var t = "";
                                e.state && e.state.searchParams && (t = e.state.searchParams), this.applyFilters(t, null, !1);
                            },
                        },
                        {
                            key: "applyFilters",
                            value: function (e, t) {
                                var n = this,
                                    i = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
                                this.productList.classList.add(this.utils.loading),
                                    fetch("".concat(window.location.pathname, "?").concat(e))
                                        .then(function (e) {
                                            return e.text();
                                        })
                                        .then(function (e) {
                                            var i = e,
                                                o = new DOMParser().parseFromString(i, "text/html");
                                            n.updateFilters(o, t),
                                                (n.productList.innerHTML = o.querySelector(".cc-product-list").innerHTML),
                                                document.dispatchEvent(new CustomEvent("filters-applied", { bubbles: !0 })),
                                                n.productList.classList.remove(n.utils.loading);
                                        }),
                                    i && this.updateURL(e);
                            },
                        },
                        {
                            key: "updateFilters",
                            value: function (e, t) {
                                var n = this;
                                if (
                                    ((this.filtersControl.innerHTML = e.querySelector(".cc-filters-control").innerHTML),
                                    t && "sort_by" === t.target.name && (this.activeSortText.textContent = t.target.nextElementSibling.textContent),
                                    this.filteringEnabled)
                                ) {
                                    document.querySelectorAll(".cc-filter").forEach(function (i) {
                                        var o = i.dataset.index;
                                        if ("0" !== o) {
                                            var s = e.querySelector('.cc-filter[data-index="'.concat(o, '"]'));
                                            if ("price_range" === i.dataset.type)
                                                n.updateFilter(i, s, !1),
                                                    (t && "INPUT" === t.target.tagName) ||
                                                        i.querySelectorAll("input").forEach(function (t) {
                                                            (t.value = e.getElementById(t.id).value), t.dispatchEvent(new CustomEvent("change", { bubbles: !0, detail: { sender: "reset" } }));
                                                        });
                                            else if (t && "INPUT" === t.target.tagName) {
                                                var r = t.target.closest(".cc-filter");
                                                n.updateFilter(i, s, i.dataset.index !== r.dataset.index);
                                            } else n.updateFilter(i, s, !0);
                                        }
                                    }),
                                        this.updateActiveFilters(e),
                                        (this.clearFiltersBtn.hidden = e.querySelector(".js-clear-filters").hidden);
                                    var i = e.querySelector(".cc-filters__footer"),
                                        o = i.classList.contains(this.utils.hidden);
                                    (this.filtersFooter.innerHTML = i.innerHTML),
                                        this.filtersFooter.classList.toggle(this.utils.hidden, o),
                                        (this.filters.style.height = o ? null : "calc(100% - ".concat(this.filtersFooter.offsetHeight, "px)"));
                                }
                            },
                        },
                        {
                            key: "updateFilter",
                            value: function (e, t, n) {
                                n
                                    ? (e.innerHTML = t.innerHTML)
                                    : (e.replaceChild(t.querySelector(".cc-filter__toggle"), e.querySelector(".cc-filter__toggle")), (e.querySelector(".cc-filter__header").innerHTML = t.querySelector(".cc-filter__header").innerHTML));
                            },
                        },
                        {
                            key: "updateActiveFilters",
                            value: function (e) {
                                var t = e.querySelector(".cc-active-filters");
                                (this.activeFilters.innerHTML = t.innerHTML), (this.activeFilters.hidden = !this.activeFilters.querySelector(".cc-active-filter"));
                            },
                        },
                        {
                            key: "updateURL",
                            value: function (e) {
                                history.pushState({ searchParams: e }, "", "".concat(window.location.pathname).concat(e && "?".concat(e)));
                            },
                        },
                        {
                            key: "closeFilter",
                            value: function (e) {
                                var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                                clearTimeout(this.closeTimer),
                                    e.classList.remove(this.utils.open),
                                    (this.closeTimer = setTimeout(
                                        function () {
                                            e.open = !1;
                                        },
                                        t ? 300 : null
                                    ));
                            },
                        },
                    ]),
                    e
                );
            })(),
            c = (function (e) {
                "use strict";
                _inherits(n, e);
                var t = _createSuper(n);
                function n() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "faceted-filters",
                        i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ".cc-faceted-filters";
                    return _classCallCheck(this, n), t.call(this, e, i);
                }
                return (
                    _createClass(n, [
                        {
                            key: "init",
                            value: function (e) {
                                _get(_getPrototypeOf(n.prototype), "init", this).call(this, e), this.registerInstance(e, new l(e));
                            },
                        },
                        {
                            key: "destroy",
                            value: function (e) {
                                this.destroyInstance(e), _get(_getPrototypeOf(n.prototype), "destroy", this).call(this, e);
                            },
                        },
                    ]),
                    n
                );
            })(r);
        new c(),
            (theme.MapSection = new (function () {
                var t = this;
                (t.config = {
                    zoom: 14,
                    styles: {
                        default: [],
                        silver: [
                            { elementType: "geometry", stylers: [{ color: "#f5f5f5" }] },
                            { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
                            { elementType: "labels.text.fill", stylers: [{ color: "#616161" }] },
                            { elementType: "labels.text.stroke", stylers: [{ color: "#f5f5f5" }] },
                            { featureType: "administrative.land_parcel", elementType: "labels.text.fill", stylers: [{ color: "#bdbdbd" }] },
                            { featureType: "poi", elementType: "geometry", stylers: [{ color: "#eeeeee" }] },
                            { featureType: "poi", elementType: "labels.text.fill", stylers: [{ color: "#757575" }] },
                            { featureType: "poi.park", elementType: "geometry", stylers: [{ color: "#e5e5e5" }] },
                            { featureType: "poi.park", elementType: "labels.text.fill", stylers: [{ color: "#9e9e9e" }] },
                            { featureType: "road", elementType: "geometry", stylers: [{ color: "#ffffff" }] },
                            { featureType: "road.arterial", elementType: "labels.text.fill", stylers: [{ color: "#757575" }] },
                            { featureType: "road.highway", elementType: "geometry", stylers: [{ color: "#dadada" }] },
                            { featureType: "road.highway", elementType: "labels.text.fill", stylers: [{ color: "#616161" }] },
                            { featureType: "road.local", elementType: "labels.text.fill", stylers: [{ color: "#9e9e9e" }] },
                            { featureType: "transit.line", elementType: "geometry", stylers: [{ color: "#e5e5e5" }] },
                            { featureType: "transit.station", elementType: "geometry", stylers: [{ color: "#eeeeee" }] },
                            { featureType: "water", elementType: "geometry", stylers: [{ color: "#c9c9c9" }] },
                            { featureType: "water", elementType: "labels.text.fill", stylers: [{ color: "#9e9e9e" }] },
                        ],
                        retro: [
                            { elementType: "geometry", stylers: [{ color: "#ebe3cd" }] },
                            { elementType: "labels.text.fill", stylers: [{ color: "#523735" }] },
                            { elementType: "labels.text.stroke", stylers: [{ color: "#f5f1e6" }] },
                            { featureType: "administrative", elementType: "geometry.stroke", stylers: [{ color: "#c9b2a6" }] },
                            { featureType: "administrative.land_parcel", elementType: "geometry.stroke", stylers: [{ color: "#dcd2be" }] },
                            { featureType: "administrative.land_parcel", elementType: "labels.text.fill", stylers: [{ color: "#ae9e90" }] },
                            { featureType: "landscape.natural", elementType: "geometry", stylers: [{ color: "#dfd2ae" }] },
                            { featureType: "poi", elementType: "geometry", stylers: [{ color: "#dfd2ae" }] },
                            { featureType: "poi", elementType: "labels.text.fill", stylers: [{ color: "#93817c" }] },
                            { featureType: "poi.park", elementType: "geometry.fill", stylers: [{ color: "#a5b076" }] },
                            { featureType: "poi.park", elementType: "labels.text.fill", stylers: [{ color: "#447530" }] },
                            { featureType: "road", elementType: "geometry", stylers: [{ color: "#f5f1e6" }] },
                            { featureType: "road.arterial", elementType: "geometry", stylers: [{ color: "#fdfcf8" }] },
                            { featureType: "road.highway", elementType: "geometry", stylers: [{ color: "#f8c967" }] },
                            { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ color: "#e9bc62" }] },
                            { featureType: "road.highway.controlled_access", elementType: "geometry", stylers: [{ color: "#e98d58" }] },
                            { featureType: "road.highway.controlled_access", elementType: "geometry.stroke", stylers: [{ color: "#db8555" }] },
                            { featureType: "road.local", elementType: "labels.text.fill", stylers: [{ color: "#806b63" }] },
                            { featureType: "transit.line", elementType: "geometry", stylers: [{ color: "#dfd2ae" }] },
                            { featureType: "transit.line", elementType: "labels.text.fill", stylers: [{ color: "#8f7d77" }] },
                            { featureType: "transit.line", elementType: "labels.text.stroke", stylers: [{ color: "#ebe3cd" }] },
                            { featureType: "transit.station", elementType: "geometry", stylers: [{ color: "#dfd2ae" }] },
                            { featureType: "water", elementType: "geometry.fill", stylers: [{ color: "#b9d3c2" }] },
                            { featureType: "water", elementType: "labels.text.fill", stylers: [{ color: "#92998d" }] },
                        ],
                        dark: [
                            { elementType: "geometry", stylers: [{ color: "#212121" }] },
                            { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
                            { elementType: "labels.text.fill", stylers: [{ color: "#757575" }] },
                            { elementType: "labels.text.stroke", stylers: [{ color: "#212121" }] },
                            { featureType: "administrative", elementType: "geometry", stylers: [{ color: "#757575" }] },
                            { featureType: "administrative.country", elementType: "labels.text.fill", stylers: [{ color: "#9e9e9e" }] },
                            { featureType: "administrative.land_parcel", stylers: [{ visibility: "off" }] },
                            { featureType: "administrative.locality", elementType: "labels.text.fill", stylers: [{ color: "#bdbdbd" }] },
                            { featureType: "poi", elementType: "labels.text.fill", stylers: [{ color: "#757575" }] },
                            { featureType: "poi.park", elementType: "geometry", stylers: [{ color: "#181818" }] },
                            { featureType: "poi.park", elementType: "labels.text.fill", stylers: [{ color: "#616161" }] },
                            { featureType: "poi.park", elementType: "labels.text.stroke", stylers: [{ color: "#1b1b1b" }] },
                            { featureType: "road", elementType: "geometry.fill", stylers: [{ color: "#2c2c2c" }] },
                            { featureType: "road", elementType: "labels.text.fill", stylers: [{ color: "#8a8a8a" }] },
                            { featureType: "road.arterial", elementType: "geometry", stylers: [{ color: "#373737" }] },
                            { featureType: "road.highway", elementType: "geometry", stylers: [{ color: "#3c3c3c" }] },
                            { featureType: "road.highway.controlled_access", elementType: "geometry", stylers: [{ color: "#4e4e4e" }] },
                            { featureType: "road.local", elementType: "labels.text.fill", stylers: [{ color: "#616161" }] },
                            { featureType: "transit", elementType: "labels.text.fill", stylers: [{ color: "#757575" }] },
                            { featureType: "water", elementType: "geometry", stylers: [{ color: "#000000" }] },
                            { featureType: "water", elementType: "labels.text.fill", stylers: [{ color: "#3d3d3d" }] },
                        ],
                        night: [
                            { elementType: "geometry", stylers: [{ color: "#242f3e" }] },
                            { elementType: "labels.text.fill", stylers: [{ color: "#746855" }] },
                            { elementType: "labels.text.stroke", stylers: [{ color: "#242f3e" }] },
                            { featureType: "administrative.locality", elementType: "labels.text.fill", stylers: [{ color: "#d59563" }] },
                            { featureType: "poi", elementType: "labels.text.fill", stylers: [{ color: "#d59563" }] },
                            { featureType: "poi.park", elementType: "geometry", stylers: [{ color: "#263c3f" }] },
                            { featureType: "poi.park", elementType: "labels.text.fill", stylers: [{ color: "#6b9a76" }] },
                            { featureType: "road", elementType: "geometry", stylers: [{ color: "#38414e" }] },
                            { featureType: "road", elementType: "geometry.stroke", stylers: [{ color: "#212a37" }] },
                            { featureType: "road", elementType: "labels.text.fill", stylers: [{ color: "#9ca5b3" }] },
                            { featureType: "road.highway", elementType: "geometry", stylers: [{ color: "#746855" }] },
                            { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ color: "#1f2835" }] },
                            { featureType: "road.highway", elementType: "labels.text.fill", stylers: [{ color: "#f3d19c" }] },
                            { featureType: "transit", elementType: "geometry", stylers: [{ color: "#2f3948" }] },
                            { featureType: "transit.station", elementType: "labels.text.fill", stylers: [{ color: "#d59563" }] },
                            { featureType: "water", elementType: "geometry", stylers: [{ color: "#17263c" }] },
                            { featureType: "water", elementType: "labels.text.fill", stylers: [{ color: "#515c6d" }] },
                            { featureType: "water", elementType: "labels.text.stroke", stylers: [{ color: "#17263c" }] },
                        ],
                        aubergine: [
                            { elementType: "geometry", stylers: [{ color: "#1d2c4d" }] },
                            { elementType: "labels.text.fill", stylers: [{ color: "#8ec3b9" }] },
                            { elementType: "labels.text.stroke", stylers: [{ color: "#1a3646" }] },
                            { featureType: "administrative.country", elementType: "geometry.stroke", stylers: [{ color: "#4b6878" }] },
                            { featureType: "administrative.land_parcel", elementType: "labels.text.fill", stylers: [{ color: "#64779e" }] },
                            { featureType: "administrative.province", elementType: "geometry.stroke", stylers: [{ color: "#4b6878" }] },
                            { featureType: "landscape.man_made", elementType: "geometry.stroke", stylers: [{ color: "#334e87" }] },
                            { featureType: "landscape.natural", elementType: "geometry", stylers: [{ color: "#023e58" }] },
                            { featureType: "poi", elementType: "geometry", stylers: [{ color: "#283d6a" }] },
                            { featureType: "poi", elementType: "labels.text.fill", stylers: [{ color: "#6f9ba5" }] },
                            { featureType: "poi", elementType: "labels.text.stroke", stylers: [{ color: "#1d2c4d" }] },
                            { featureType: "poi.park", elementType: "geometry.fill", stylers: [{ color: "#023e58" }] },
                            { featureType: "poi.park", elementType: "labels.text.fill", stylers: [{ color: "#3C7680" }] },
                            { featureType: "road", elementType: "geometry", stylers: [{ color: "#304a7d" }] },
                            { featureType: "road", elementType: "labels.text.fill", stylers: [{ color: "#98a5be" }] },
                            { featureType: "road", elementType: "labels.text.stroke", stylers: [{ color: "#1d2c4d" }] },
                            { featureType: "road.highway", elementType: "geometry", stylers: [{ color: "#2c6675" }] },
                            { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ color: "#255763" }] },
                            { featureType: "road.highway", elementType: "labels.text.fill", stylers: [{ color: "#b0d5ce" }] },
                            { featureType: "road.highway", elementType: "labels.text.stroke", stylers: [{ color: "#023e58" }] },
                            { featureType: "transit", elementType: "labels.text.fill", stylers: [{ color: "#98a5be" }] },
                            { featureType: "transit", elementType: "labels.text.stroke", stylers: [{ color: "#1d2c4d" }] },
                            { featureType: "transit.line", elementType: "geometry.fill", stylers: [{ color: "#283d6a" }] },
                            { featureType: "transit.station", elementType: "geometry", stylers: [{ color: "#3a4762" }] },
                            { featureType: "water", elementType: "geometry", stylers: [{ color: "#0e1626" }] },
                            { featureType: "water", elementType: "labels.text.fill", stylers: [{ color: "#4e6d70" }] },
                        ],
                    },
                }),
                    (t.apiStatus = null),
                    (this.geolocate = function (t) {
                        var n = e.Deferred(),
                            i = new google.maps.Geocoder(),
                            o = t.data("address-setting");
                        return (
                            i.geocode({ address: o }, function (e, t) {
                                t !== google.maps.GeocoderStatus.OK && n.reject(t), n.resolve(e);
                            }),
                            n
                        );
                    }),
                    (this.createMap = function (n) {
                        var i = e(".map-section__map-container", n);
                        return t
                            .geolocate(i)
                            .then(
                                function (o) {
                                    var s = { zoom: t.config.zoom, styles: t.config.styles[e(n).data("map-style")], center: o[0].geometry.location, scrollwheel: !1, disableDoubleClickZoom: !0, disableDefaultUI: !0, zoomControl: !0 };
                                    (t.map = new google.maps.Map(i[0], s)),
                                        (t.center = t.map.getCenter()),
                                        new google.maps.Marker({ map: t.map, position: t.center, clickable: !1 }),
                                        google.maps.event.addDomListener(window, "resize", function () {
                                            google.maps.event.trigger(t.map, "resize"), t.map.setCenter(t.center);
                                        });
                                }.bind(this)
                            )
                            .fail(function () {
                                var e;
                                switch (status) {
                                    case "ZERO_RESULTS":
                                        e = theme.strings.addressNoResults;
                                        break;
                                    case "OVER_QUERY_LIMIT":
                                        e = theme.strings.addressQueryLimit;
                                        break;
                                    default:
                                        e = theme.strings.addressError;
                                }
                                if (Shopify.designMode) {
                                    var t = i.parents(".map-section");
                                    t.addClass("page-width map-section--load-error"), t.find(".map-section__wrapper").html('<div class="errors text-center">' + e + "</div>");
                                }
                            });
                    }),
                    (this.onSectionLoad = function (n) {
                        var i = e(n);
                        window.gm_authFailure = function () {
                            Shopify.designMode && (i.addClass("page-width map-section--load-error"), i.find(".map-section__wrapper").html('<div class="errors text-center">' + theme.strings.authError + "</div>"));
                        };
                        var o = i.data("api-key");
                        "string" == typeof o &&
                            "" !== o &&
                            theme.loadScriptOnce("https://maps.googleapis.com/maps/api/js?key=" + o, function () {
                                t.createMap(i);
                            });
                    }),
                    (this.onSectionUnload = function (e) {
                        void 0 !== window.google && void 0 !== google.maps && google.maps.event.clearListeners(this.map, "resize");
                    });
            })()),
            s.sections.push({ name: "map", section: theme.MapSection }),
            (theme.VideoManager = new (function () {
                var t = this;
                (t._permitPlayback = function (t) {
                    return !(e(t).hasClass("video-container--background") && e(window).outerWidth() < 768);
                }),
                    (t.youtubeVars = { incrementor: 0, apiReady: !1, videoData: {}, toProcessSelector: '.video-container[data-video-type="youtube"]:not(.video--init)' }),
                    (t.youtubeApiReady = function () {
                        (t.youtubeVars.apiReady = !0), t._loadYoutubeVideos();
                    }),
                    (t._loadYoutubeVideos = function (n) {
                        e(t.youtubeVars.toProcessSelector, n).length &&
                            (t.youtubeVars.apiReady
                                ? e(t.youtubeVars.toProcessSelector, n).each(function () {
                                      if (t._permitPlayback(e(this))) {
                                          e(this).addClass("video--init"), t.youtubeVars.incrementor++;
                                          var n = "theme-yt-video-" + t.youtubeVars.incrementor;
                                          e(this).data("video-container-id", n);
                                          var i = e('<div class="video-container__video-element">').attr("id", n).appendTo(e(".video-container__video", this)),
                                              o = e(this).data("video-autoplay"),
                                              s = e(this).data("video-loop"),
                                              r = new YT.Player(n, {
                                                  height: "360",
                                                  width: "640",
                                                  videoId: e(this).data("video-id"),
                                                  playerVars: { iv_load_policy: 3, modestbranding: 1, autoplay: 0, loop: s ? 1 : 0, playlist: e(this).data("video-id"), rel: 0, showinfo: 0 },
                                                  events: {
                                                      onReady: t._onYoutubePlayerReady.bind({ autoplay: o, loop: s, $container: e(this) }),
                                                      onStateChange: t._onYoutubePlayerStateChange.bind({ autoplay: o, loop: s, $container: e(this) }),
                                                  },
                                              });
                                          t.youtubeVars.videoData[n] = { id: n, container: this, videoElement: i, player: r };
                                      }
                                  })
                                : theme.loadScriptOnce("https://www.youtube.com/iframe_api"));
                    }),
                    (t._onYoutubePlayerReady = function (e) {
                        e.target.setPlaybackQuality("hd1080"), this.autoplay && (e.target.mute(), e.target.playVideo()), t._initBackgroundVideo(this.$container);
                    }),
                    (t._onYoutubePlayerStateChange = function (e) {
                        if (e.data == YT.PlayerState.PLAYING && (this.$container.addClass("video--play-started"), this.autoplay && e.target.mute(), this.loop)) {
                            var t = e.target.getDuration() - 1;
                            t > 2 &&
                                (function n() {
                                    e.target.getCurrentTime() > t && e.target.seekTo(0), setTimeout(n, 250);
                                })();
                        }
                    }),
                    (t._unloadYoutubeVideos = function (n) {
                        for (var i in t.youtubeVars.videoData) {
                            var o = t.youtubeVars.videoData[i];
                            if (e(n).find(o.container).length) return o.player.destroy(), void delete t.youtubeVars.videoData[i];
                        }
                    }),
                    (t.vimeoVars = { incrementor: 0, apiReady: !1, videoData: {}, toProcessSelector: '.video-container[data-video-type="vimeo"]:not(.video--init)' }),
                    (t.vimeoApiReady = function () {
                        (t.vimeoVars.apiReady = !0), t._loadVimeoVideos();
                    }),
                    (t._loadVimeoVideos = function (n) {
                        e(t.vimeoVars.toProcessSelector, n).length &&
                            (t.vimeoVars.apiReady
                                ? e(t.vimeoVars.toProcessSelector, n).each(function () {
                                      if (t._permitPlayback(e(this))) {
                                          e(this).addClass("video--init"), t.vimeoVars.incrementor++;
                                          var n = e(this),
                                              i = "theme-vi-video-" + t.vimeoVars.incrementor;
                                          e(this).data("video-container-id", i);
                                          var o = e('<div class="video-container__video-element">').attr("id", i).appendTo(e(".video-container__video", this)),
                                              s = !!e(this).data("video-autoplay"),
                                              r = new Vimeo.Player(i, { url: e(this).data("video-url"), width: 640, loop: e(this).data("video-autoplay"), autoplay: s, muted: n.hasClass("video-container--background") });
                                          r.on(
                                              "playing",
                                              function () {
                                                  e(this).addClass("video--play-started");
                                              }.bind(this)
                                          ),
                                              r.ready().then(function () {
                                                  if ((s && (r.setVolume(0), r.play()), r.element && r.element.width && r.element.height)) {
                                                      var e = parseInt(r.element.height) / parseInt(r.element.width);
                                                      n.find(".video-container__video").css("padding-bottom", 100 * e + "%");
                                                  }
                                                  t._initBackgroundVideo(n);
                                              }),
                                              (t.vimeoVars.videoData[i] = { id: i, container: this, videoElement: o, player: r, autoPlay: s });
                                      }
                                  })
                                : window.define
                                ? theme.loadScriptOnce(
                                      "https://player.vimeo.com/api/player.js",
                                      function () {
                                          (t.vimeoVars.apiReady = !0), t._loadVimeoVideos(), (window.define = window.tempDefine);
                                      },
                                      function () {
                                          (window.tempDefine = window.define), (window.define = null);
                                      }
                                  )
                                : theme.loadScriptOnce("https://player.vimeo.com/api/player.js", function () {
                                      (t.vimeoVars.apiReady = !0), t._loadVimeoVideos();
                                  }));
                    }),
                    (t._unloadVimeoVideos = function (n) {
                        for (var i in t.vimeoVars.videoData) {
                            var o = t.vimeoVars.videoData[i];
                            if (e(n).find(o.container).length) return o.player.unload(), void delete t.vimeoVars.videoData[i];
                        }
                    }),
                    (t._loadThirdPartyApis = function (n) {
                        t._permitPlayback(e(".video-container", n)) && (t._loadYoutubeVideos(n), t._loadVimeoVideos(n));
                    }),
                    (t.mp4Vars = { incrementor: 0, videoData: {}, toProcessSelector: '.video-container[data-video-type="mp4"]:not(.video--init)' }),
                    (t._loadMp4Videos = function (n) {
                        e(t.mp4Vars.toProcessSelector, n).length &&
                            e(t.mp4Vars.toProcessSelector, n)
                                .addClass("video--init")
                                .each(function () {
                                    t.mp4Vars.incrementor++, e(this);
                                    var n = "theme-mp-video-" + t.mp4Vars.incrementor;
                                    e(this).data("video-container-id", n);
                                    var i = e('<div class="video-container__video-element">').attr("id", n).appendTo(e(".video-container__video", this)),
                                        o = e("<video playsinline>");
                                    e(this).data("video-loop") && o.attr("loop", "loop"),
                                        e(this).data("video-autoplay") &&
                                            (o.attr({ autoplay: "autoplay", muted: "muted" }),
                                            (o[0].muted = !0),
                                            o.one("loadeddata", function () {
                                                this.play();
                                            })),
                                        o.on(
                                            "playing",
                                            function () {
                                                e(this).addClass("video--play-started");
                                            }.bind(this)
                                        ),
                                        o.attr("src", e(this).data("video-url")).appendTo(i);
                                });
                    }),
                    (t._unloadMp4Videos = function (e) {}),
                    (t._initBackgroundVideo = function (t) {
                        if (t.hasClass("video-container--background") && t.find(".video-container__video iframe").length) {
                            var n = function () {
                                var t = this.width(),
                                    n = this.height(),
                                    i = t / n,
                                    o = e(".video-container__video iframe", this),
                                    s = o.attr("width") / o.attr("height"),
                                    r = e(".video-container__video", this);
                                if (i > s) {
                                    var a = t / s + 150;
                                    r.css({ marginTop: (n - a) / 2 - 75, marginLeft: "", height: a + 150, width: "" });
                                } else {
                                    var l = t * s + 150 * s;
                                    r.css({ marginTop: -75, marginLeft: (t - l) / 2, height: n + 150, width: l });
                                }
                            };
                            n.bind(t)(), e(window).on("debouncedresize." + t.data("video-container-id"), n.bind(t));
                        }
                    }),
                    (this.onSectionLoad = function (n) {
                        e(".video-container[data-video-url]:not([data-video-type])").each(function () {
                            var t = e(this).data("video-url");
                            t.indexOf(".mp4") > -1 && e(this).attr("data-video-type", "mp4"),
                                t.indexOf("vimeo.com") > -1 && (e(this).attr("data-video-type", "vimeo"), e(this).attr("data-video-id", t.split("?")[0].split("/").pop())),
                                (t.indexOf("youtu.be") > -1 || t.indexOf("youtube.com") > -1) &&
                                    (e(this).attr("data-video-type", "youtube"), t.indexOf("v=") > -1 ? e(this).attr("data-video-id", t.split("v=").pop().split("&")[0]) : e(this).attr("data-video-id", t.split("?")[0].split("/").pop()));
                        }),
                            t._loadThirdPartyApis(n),
                            t._loadMp4Videos(n),
                            e(window).on("debouncedresize.video-manager-resize", function () {
                                t._loadThirdPartyApis(n);
                            }),
                            e(".video-container__play", n).on("click", function (i) {
                                i.preventDefault();
                                var o = e(this).closest(".video-container");
                                o.addClass("video-container--playing"), e(n).trigger("cc:video:play");
                                var s = o.data("video-container-id");
                                0 === s.indexOf("theme-yt-video") ? t.youtubeVars.videoData[s].player.playVideo() : t.vimeoVars.videoData[s].player.play();
                            }),
                            e(".video-container__stop", n).on("click", function (i) {
                                i.preventDefault();
                                var o = e(this).closest(".video-container");
                                o.removeClass("video-container--playing"), e(n).trigger("cc:video:stop");
                                var s = o.data("video-container-id");
                                0 === s.indexOf("theme-yt-video") ? t.youtubeVars.videoData[s].player.stopVideo() : (t.vimeoVars.videoData[s].player.pause(), t.vimeoVars.videoData[s].player.setCurrentTime(0));
                            });
                    }),
                    (this.onSectionUnload = function (n) {
                        e(".video-container__play, .video-container__stop", n).off("click"),
                            e(window).off("." + e(".video-container").data("video-container-id")),
                            e(window).off("debouncedresize.video-manager-resize"),
                            t._unloadYoutubeVideos(n),
                            t._unloadVimeoVideos(n),
                            t._unloadMp4Videos(n),
                            e(n).trigger("cc:video:stop");
                    });
            })()),
            (window.onYouTubeIframeAPIReady = function () {
                theme.VideoManager.youtubeApiReady();
            }),
            s.sections.push({ name: "video", section: theme.VideoManager }),
            (theme.Popup = new (function () {
                var t = "cc-theme-popup-dismissed";
                (this.onSectionLoad = function (n) {
                    var i = this;
                    (this.namespace = theme.namespaceFromSection(n)), (this.$container = e(n)), (this.popup = new a(this.$container, this.namespace));
                    var o = this.$container.data("dismiss-for-days"),
                        s = this.$container.data("delay-seconds"),
                        r = !0,
                        l = this.$container.data("test-mode"),
                        c = window.localStorage.getItem(t);
                    c && (new Date().getTime() - c) / 864e5 < o && (r = !1),
                        this.$container.find(".cc-popup-form__response").length && ((r = !0), (s = 1), this.$container.find(".cc-popup-form__response--success").length && this.functions.popupSetAsDismissed.call(this)),
                        document.querySelector(".shopify-challenge__container") && (r = !1),
                        (r || l) &&
                            setTimeout(function () {
                                i.popup.open();
                            }, 1e3 * s),
                        this.$container.on("click" + this.namespace, ".cc-popup-close, .cc-popup-background", function () {
                            i.popup.close(function () {
                                i.functions.popupSetAsDismissed.call(i);
                            });
                        });
                }),
                    (this.onSectionSelect = function () {
                        this.popup.open();
                    }),
                    (this.functions = {
                        popupSetAsDismissed: function () {
                            window.localStorage.setItem(t, new Date().getTime());
                        },
                    }),
                    (this.onSectionUnload = function () {
                        this.$container.off(this.namespace);
                    });
            })()),
            s.sections.push({ name: "newsletter-popup", section: theme.Popup }),
            (theme.StoreAvailability = function (t) {
                var n = "store-availability-loading",
                    i = "store-availability-initialized",
                    o = "cc-location";
                (this.onSectionLoad = function (t) {
                    var n = this;
                    (this.namespace = theme.namespaceFromSection(t)), (this.$container = e(t)), (this.productId = this.$container.data("store-availability-container")), (this.sectionUrl = this.$container.data("section-url")), this.$modal;
                    var i = !0;
                    e(window).on("cc-variant-updated".concat(this.namespace).concat(this.productId), function (e, t) {
                        t.product.id === n.productId && (n.functions.updateContent.bind(n)(t.variant.id, t.product.title, i, n.$container.data("has-only-default-variant"), void 0 !== t.variant.available), (i = !1));
                    }),
                        this.$container.data("single-variant-id") &&
                            (this.functions.updateContent.bind(this)(
                                this.$container.data("single-variant-id"),
                                this.$container.data("single-variant-product-title"),
                                i,
                                this.$container.data("has-only-default-variant"),
                                this.$container.data("single-variant-product-available")
                            ),
                            (i = !1));
                }),
                    (this.onSectionUnload = function () {
                        e(window).off("cc-variant-updated".concat(this.namespace).concat(this.productId)), this.$container.off("click"), this.$modal && this.$modal.off("click");
                    }),
                    (this.functions = {
                        getUserLocation: function () {
                            return new Promise(function (e, t) {
                                var n;
                                sessionStorage[o] && (n = JSON.parse(sessionStorage[o])),
                                    n
                                        ? e(n)
                                        : navigator.geolocation
                                        ? navigator.geolocation.getCurrentPosition(
                                              function (t) {
                                                  var n = { latitude: t.coords.latitude, longitude: t.coords.longitude };
                                                  fetch("/localization.json", { method: "PUT", headers: { "Content-Type": "application/json" }, body: JSON.stringify(n) }), (sessionStorage[o] = JSON.stringify(n)), e(n);
                                              },
                                              function () {
                                                  e(!1);
                                              },
                                              { maximumAge: 36e5, timeout: 5e3 }
                                          )
                                        : e(!1);
                            });
                        },
                        getAvailableStores: function (t, n) {
                            return e.get(this.sectionUrl.replace("VARIANT_ID", t), n);
                        },
                        calculateDistance: function (e, t, n) {
                            var i = Math.PI / 180,
                                o = "metric" === n ? 6378.14 : 3959,
                                s = e.latitude * i,
                                r = e.longitude * i,
                                a = t.latitude * i,
                                l = r - t.longitude * i,
                                c = s - a,
                                d = Math.pow(Math.sin(c / 2), 2) + Math.cos(s) * Math.cos(a) * Math.pow(Math.sin(l / 2), 2);
                            return o * (2 * Math.atan2(Math.sqrt(d), Math.sqrt(1 - d)));
                        },
                        updateLocationDistances: function (t) {
                            var n = this.$modal.find("[data-unit-system]").data("unit-system"),
                                i = this;
                            this.$modal.find('[data-distance="false"]').each(function () {
                                var o = this,
                                    s = { latitude: parseFloat(e(this).data("latitude")), longitude: parseFloat(e(this).data("longitude")) };
                                if (s.latitude && s.longitude) {
                                    var r = i.functions.calculateDistance(t, s, n).toFixed(1);
                                    e(this).html(r),
                                        setTimeout(function () {
                                            e(o).closest(".store-availability-list__location__distance").addClass("-in");
                                        }, 0);
                                }
                                e(this).attr("data-distance", "true");
                            });
                        },
                        updateContent: function (t, o, s, r, l) {
                            var c = this;
                            this.$container.off("click", "[data-store-availability-modal-open]"),
                                this.$container.off("click" + this.namespace, ".cc-popup-close, .cc-popup-background"),
                                e(".store-availabilities-modal").remove(),
                                s
                                    ? this.$container.hide()
                                    : l
                                    ? (this.$container.addClass(n).addClass(i), this.$container.css("height", this.$container.outerHeight() > 0 ? this.$container.outerHeight() + "px" : "auto"))
                                    : (this.$container.addClass(n).addClass(i), this.$container.css("height", "0px")),
                                l &&
                                    this.functions.getAvailableStores.call(this, t, function (i) {
                                        if (i.trim().length > 0 && !i.includes("NO_PICKUP")) {
                                            c.$container.html(i),
                                                c.$container.html(c.$container.children().first().html()),
                                                c.$container.find("[data-store-availability-modal-product-title]").html(o),
                                                r && c.$container.find(".store-availabilities-modal__variant-title").remove(),
                                                c.$container.find(".cc-popup").appendTo("body"),
                                                (c.$modal = e("body").find(".store-availabilities-modal"));
                                            var l = new a(c.$modal, c.namespace);
                                            if (
                                                (c.$container.on("click", "[data-store-availability-modal-open]", function () {
                                                    return (
                                                        l.open(),
                                                        c.functions.getUserLocation().then(function (n) {
                                                            n &&
                                                                c.$modal.find('[data-distance="false"]').length &&
                                                                c.functions.getAvailableStores.call(c, t, function (t) {
                                                                    c.$modal.find(".store-availabilities-list").html(e(t).find(".store-availabilities-list").html()), c.functions.updateLocationDistances.bind(c)(n);
                                                                });
                                                        }),
                                                        !1
                                                    );
                                                }),
                                                c.$modal.on("click" + c.namespace, ".cc-popup-close, .cc-popup-background", function () {
                                                    l.close();
                                                }),
                                                s)
                                            )
                                                c.$container.slideDown(300);
                                            else {
                                                c.$container.removeClass(n);
                                                var d = c.$container.find(".store-availability-container").outerHeight();
                                                c.$container.css("height", d > 0 ? d + "px" : "auto");
                                            }
                                        }
                                    });
                        },
                    }),
                    this.onSectionLoad(t);
            }),
            s.sections.push({ name: "store-availability", section: theme.StoreAvailability });
        try {
            theme.shopifyFeatures = JSON.parse(document.documentElement.querySelector("#shopify-features").textContent);
        } catch (e) {
            theme.shopifyFeatures = {};
        }
        (slate.a11y = {
            pageLinkFocus: function (e) {
                var t = "js-focus-hidden";
                e.first()
                    .attr("tabIndex", "-1")
                    .focus()
                    .addClass(t)
                    .one("blur", function () {
                        e.first().removeClass(t).removeAttr("tabindex");
                    });
            },
            focusHash: function () {
                var t = window.location.hash;
                t && document.getElementById(t.slice(1)) && this.pageLinkFocus(e(t));
            },
            bindInPageLinks: function () {
                e("a[href*=#]").on(
                    "click",
                    function (t) {
                        this.pageLinkFocus(e(t.currentTarget.hash));
                    }.bind(this)
                );
            },
            trapFocus: function (t) {
                var n = t.namespace ? "focusin." + t.namespace : "focusin";
                t.$elementToFocus || (t.$elementToFocus = t.$container),
                    t.$container.attr("tabindex", "-1"),
                    t.$elementToFocus.focus(),
                    e(document).on(n, function (e) {
                        t.$container[0] === e.target || t.$container.has(e.target).length || t.$container.focus();
                    });
            },
            removeTrapFocus: function (t) {
                var n = t.namespace ? "focusin." + t.namespace : "focusin";
                t.$container && t.$container.length && t.$container.removeAttr("tabindex"), e(document).off(n);
            },
        }),
            (slate.cart = {
                cookiesEnabled: function () {
                    var e = navigator.cookieEnabled;
                    return e || ((document.cookie = "testcookie"), (e = -1 !== document.cookie.indexOf("testcookie"))), e;
                },
            }),
            (slate.utils = {
                findInstance: function (e, t, n) {
                    for (var i = 0; i < e.length; i++) if (e[i][t] === n) return e[i];
                },
                removeInstance: function (e, t, n) {
                    for (var i = e.length; i--; )
                        if (e[i][t] === n) {
                            e.splice(i, 1);
                            break;
                        }
                    return e;
                },
                compact: function (e) {
                    for (var t = -1, n = null == e ? 0 : e.length, i = 0, o = []; ++t < n; ) {
                        var s = e[t];
                        s && (o[i++] = s);
                    }
                    return o;
                },
                defaultTo: function (e, t) {
                    return null == e || e != e ? t : e;
                },
            }),
            (slate.rte = {
                wrapTable: function (e) {
                    var t = void 0 === e.tableWrapperClass ? "" : e.tableWrapperClass;
                    e.$tables.wrap('<div class="' + t + '"></div>');
                },
                wrapIframe: function (t) {
                    var n = void 0 === t.iframeWrapperClass ? "" : t.iframeWrapperClass;
                    t.$iframes.each(function () {
                        e(this).wrap('<div class="' + n + '"></div>'), (this.src = this.src);
                    });
                },
            }),
            (slate.Image = {
                preload: function (e, t) {
                    "string" == typeof e && (e = [e]);
                    for (var n = 0; n < e.length; n++) {
                        var i = e[n];
                        this.loadImage(this.getSizedImageUrl(i, t));
                    }
                },
                loadImage: function (e) {
                    new Image().src = e;
                },
                imageSize: function (e) {
                    var t = e.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
                    return t ? t[1] : null;
                },
                getSizedImageUrl: function (e, t) {
                    if (null === t) return e;
                    if ("master" === t) return this.removeProtocol(e);
                    var n = e.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
                    if (n) {
                        var i = e.split(n[0]),
                            o = n[0];
                        return this.removeProtocol(i[0] + "_" + t + o);
                    }
                    return null;
                },
                removeProtocol: function (e) {
                    return e.replace(/http(s)?:/, "");
                },
            }),
            (slate.Variants = (function () {
                function t(t) {
                    (this.$container = t.$container),
                        (this.product = t.product),
                        (this.singleOptionSelector = t.singleOptionSelector),
                        (this.originalSelectorId = t.originalSelectorId),
                        (this.secondaryIdSelectors = t.secondaryIdSelectors),
                        (this.enableHistoryState = t.enableHistoryState),
                        (this.currentVariant = this._getVariantFromOptions()),
                        e(this.singleOptionSelector, this.$container).on("change", this._onSelectChange.bind(this));
                }
                return (
                    (t.prototype = e.extend({}, t.prototype, {
                        _getCurrentOptions: function () {
                            var t = e.map(e(this.singleOptionSelector, this.$container), function (t) {
                                var n = e(t),
                                    i = n.attr("type"),
                                    o = {};
                                return "radio" === i || "checkbox" === i ? !!n[0].checked && ((o.value = n.val()), (o.index = n.data("index")), o) : ((o.value = n.val()), (o.index = n.data("index")), o);
                            });
                            return slate.utils.compact(t);
                        },
                        _getVariantFromOptions: function () {
                            var e = this._getCurrentOptions(),
                                t = this.product.variants,
                                n = !1;
                            return (
                                t.forEach(function (t) {
                                    var i = !0;
                                    e.forEach(function (e) {
                                        i && (i = e.value === t[e.index]);
                                    }),
                                        i && (n = t);
                                }),
                                n || null
                            );
                        },
                        _onSelectChange: function () {
                            var t = this._getVariantFromOptions();
                            t.available ? (e(".shipping-eta.goodchoic").show(), e(".shipping-eta.soldout").hide()) : (e(".shipping-eta.soldout").show(), e(".shipping-eta.goodchoic").hide()),
                                this.$container.trigger({ type: "variantChange", variant: t }),
                                t
                                    ? (e(window).trigger("cc-variant-updated", { variant: t, product: this.product }),
                                      this._updateMasterSelect(t),
                                      this._updateSecondarySelects(t),
                                      this._updateImages(t),
                                      this._updatePrice(t),
                                      (this.currentVariant = t),
                                      this.enableHistoryState && this._updateHistoryState(t))
                                    : this._updateSecondarySelects(t);
                        },
                        _updateImages: function (e) {
                            var t = e.featured_media || {},
                                n = this.currentVariant.featured_media || {};
                            e.featured_media && t.id !== n.id && this.$container.trigger({ type: "variantImageChange", variant: e });
                        },
                        _updatePrice: function (e) {
                            var t = !1;
                            (e.price !== this.currentVariant.price ||
                                e.compare_at_price !== this.currentVariant.compare_at_price ||
                                e.unit_price_measurement !== this.currentVariant.unit_price_measurement ||
                                (e.unit_price_measurement &&
                                    (e.unit_price !== this.currentVariant.unit_price ||
                                        e.unit_price_measurement.reference_value !== this.currentVariant.unit_price_measurement.reference_value ||
                                        e.unit_price_measurement.reference_unit !== this.currentVariant.unit_price_measurement.reference_unit))) &&
                                (t = !0),
                                t && this.$container.trigger({ type: "variantPriceChange", variant: e });
                        },
                        _updateHistoryState: function (e) {
                            if (history.replaceState && e) {
                                var t = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + e.id;
                                window.history.replaceState({ path: t }, "", t);
                            }
                        },
                        _updateMasterSelect: function (t) {
                            var n = e(this.originalSelectorId, this.$container)[0];
                            n && ((n.value = t.id), n.dispatchEvent(new Event("change", { bubbles: !0, cancelable: !1 })));
                        },
                        _updateSecondarySelects: function (t) {
                            e(this.secondaryIdSelectors, this.$container).each(function () {
                                (this.value = t ? t.id : null), this.dispatchEvent(new Event("change", { bubbles: !0, cancelable: !1 }));
                            });
                        },
                    })),
                    t
                );
            })()),
            (theme.storageAvailable = function (e) {
                try {
                    var t = window[e],
                        n = "__storage_test__";
                    return t.setItem(n, n), t.removeItem(n), !0;
                } catch (e) {
                    return e instanceof DOMException && (22 === e.code || 1014 === e.code || "QuotaExceededError" === e.name || "NS_ERROR_DOM_QUOTA_REACHED" === e.name) && 0 !== t.length;
                }
            }),
            (theme.variants = {
                selectors: {
                    originalSelectorId: "[data-product-select]",
                    secondaryIdSelectors: "[data-product-secondary-select]",
                    priceWrapper: "[data-price-wrapper]",
                    productPrice: "[data-product-price]",
                    addToCart: "[data-add-to-cart]",
                    addToCartText: "[data-add-to-cart-text]",
                    comparePrice: "[data-compare-price]",
                    comparePriceText: "[data-compare-text]",
                    unitPrice: ".unit-price",
                },
                getBaseUnit: function (e) {
                    return 1 === e.unit_price_measurement.reference_value ? e.unit_price_measurement.reference_unit : e.unit_price_measurement.reference_value + e.unit_price_measurement.reference_unit;
                },
                updateAddToCartState: function (t) {
                    var n = t.variant;
                    if (!n)
                        return (
                            e(theme.variants.selectors.addToCart, this.$container).prop("disabled", !0),
                            e(theme.variants.selectors.addToCartText, this.$container).html(theme.strings.unavailable),
                            void e(theme.variants.selectors.priceWrapper, this.$container).addClass("hide")
                        );
                    e(theme.variants.selectors.priceWrapper, this.$container).removeClass("hide"),
                        n.available
                            ? (e(theme.variants.selectors.addToCart, this.$container).prop("disabled", !1),
                              e(theme.variants.selectors.addToCartText, this.$container).html(theme.strings.addToCart),
                              e("form", this.$container).removeClass("variant--unavailable"))
                            : (e(theme.variants.selectors.addToCart, this.$container).prop("disabled", !0),
                              e(theme.variants.selectors.addToCartText, this.$container).html(theme.strings.soldOut),
                              e("form", this.$container).addClass("variant--unavailable"));
                    var i = e(".backorder", this.$container);
                    if (i.length)
                        if (n && n.available) {
                            var o = e(theme.variants.selectors.originalSelectorId + ' option[value="' + n.id + '"]', this.$container);
                            n.inventory_management && "out" == o.data("stock") ? (i.find(".backorder__variant").html(this.productSingleObject.title + (n.title.indexOf("Default") >= 0 ? "" : " - " + n.title)), i.show()) : i.hide();
                        } else i.hide();
                },
                updateProductPrices: function (t) {
                    var n = t.variant,
                        i = e(theme.variants.selectors.comparePrice, this.$container),
                        o = i.add(theme.variants.selectors.comparePriceText, this.$container),
                        s = e(theme.variants.selectors.productPrice, this.$container),
                        r = e(theme.variants.selectors.unitPrice, this.$container);
                    if (
                        (s.html('<span class="theme-money large-title">' + theme.Shopify.formatMoney(n.price, theme.moneyFormat) + "</span>"),
                        n.compare_at_price > n.price
                            ? (s.addClass("product-price__reduced"), i.html('<span class="product-price__compare theme-money">' + theme.Shopify.formatMoney(n.compare_at_price, theme.moneyFormat) + "</span>"), o.removeClass("hide"))
                            : (s.removeClass("product-price__reduced"), i.html(""), o.addClass("hide")),
                        n.unit_price_measurement)
                    ) {
                        var a = e('<div class="unit-price small-text">');
                        e('<span class="unit-price__price theme-money">').html(theme.Shopify.formatMoney(n.unit_price, theme.moneyFormat)).appendTo(a),
                            e('<span class="unit-price__separator">').html(theme.strings.unitPriceSeparator).appendTo(a),
                            e('<span class="unit-price__unit">').html(theme.variants.getBaseUnit(n)).appendTo(a),
                            r.length ? r.replaceWith(a) : e(theme.variants.selectors.priceWrapper, this.$container).append(a);
                    } else r.remove();
                },
            }),
            (theme.initAjaxAddToCartForm = function (t) {
                t.on("submit", function (t) {
                    t.preventDefault();
                    var n = e(this);
                    n
                        .addClass("add-in-progress")
                        .find(":submit")
                        .attr("disabled", "disabled")
                        .each(function () {
                            var t = e(this).is("button") ? "html" : "val";
                            e(this).data("previous-value", e(this)[t]())[t](theme.strings.addingToCart);
                        }),
                        e
                            .post(
                                theme.routes.cart_add_url + ".js",
                                n.serialize(),
                                function (t) {
                                    fetch(theme.routes.cart_url, { credentials: "same-origin", method: "GET" }).then(function (t) {
                                        t.text().then(function (t) {
                                            var n = document.createElement("div");
                                            n.innerHTML = t;
                                            var i = parseInt(n.querySelector("#gift-product--script").dataset.subtotal);
                                            if ("undefined" != typeof gift_product && gift_product.available && 0 == gift_product.incart)
                                                if (i >= gift_product.amount) {
                                                    var o = { items: [{ id: gift_product.id, quantity: 1 }] };
                                                    (gift_product.incart = !0),
                                                        fetch(`${theme.routes.cart_add_url}.js`, { body: JSON.stringify(o), method: "POST", headers: { "Content-Type": "application/json" } }).then(function (t) {
                                                            fetch(theme.routes.cart_url, { credentials: "same-origin", method: "GET" }).then(function (t) {
                                                                t.text().then(function (t) {
                                                                    var n = document.createElement("div");
                                                                    (n.innerHTML = t),
                                                                        (document.querySelector(".Drawer__Content").innerHTML = n.querySelector(".Drawer__Content").innerHTML),
                                                                        e(".customcartcount").html(n.querySelector(".customcartcount").innerHTML);
                                                                });
                                                            });
                                                        });
                                                } else (document.querySelector(".Drawer__Content").innerHTML = n.querySelector(".Drawer__Content").innerHTML), e(".customcartcount").html(n.querySelector(".customcartcount").innerHTML);
                                            else (document.querySelector(".Drawer__Content").innerHTML = n.querySelector(".Drawer__Content").innerHTML), e(".customcartcount").html(n.querySelector(".customcartcount").innerHTML);
                                        });
                                    }),
                                        n
                                            .find(":submit")
                                            .each(function () {
                                                var t = e(this),
                                                    i = e(this).is("button") ? "html" : "val";
                                                t[i](theme.strings.addedToCart),
                                                    setTimeout(function () {
                                                        t.removeAttr("disabled")[i](t.data("previous-value")), n.removeClass("add-in-progress");
                                                    }, 200);
                                            })
                                            .first(),
                                        e.get(theme.routes.search_url, function (t) {
                                            for (var n = [".page-header .header-cart", ".docked-navigation-container .header-cart"], i = e(e.parseHTML("<div>" + t + "</div>")), o = 0; o < n.length; o++) {
                                                var s = n[o],
                                                    r = i.find(s).clone();
                                                e(s).replaceWith(r);
                                            }
                                        }),
                                        e.colorbox.close(),
                                        (theme.productData = theme.productData || {}),
                                        theme.productData[t.product_id] || (theme.productData[t.product_id] = JSON.parse(document.querySelector(".ProductJson-" + t.product_id).innerHTML));
                                    for (var i = null, o = 0; o < theme.productData[t.product_id].variants.length; o++) {
                                        var s = theme.productData[t.product_id].variants[o];
                                        s.id == t.variant_id && (i = s);
                                    }
                                    var r = "";
                                    t.original_line_price > t.final_line_price
                                        ? ((r += '<span class="cart-summary__price-reduced product-price__reduced theme-money">' + theme.Shopify.formatMoney(t.final_line_price, theme.moneyFormat) + "</span>"),
                                          (r += '<span class="cart-summary__price-compare product-price__compare theme-money">' + theme.Shopify.formatMoney(t.original_line_price, theme.moneyFormat) + "</span>"))
                                        : (r += '<span class="theme-money">' + theme.Shopify.formatMoney(t.final_line_price, theme.moneyFormat) + "</span>"),
                                        t.unit_price &&
                                            (r +=
                                                '<span class="cart-summary__unit-price unit-price theme-money">' +
                                                theme.Shopify.formatMoney(t.unit_price, theme.moneyFormat) +
                                                theme.strings.unitPriceSeparator +
                                                t.unit_price_measurement.reference_unit +
                                                "</span>");
                                    var a = "";
                                    if ((t.quantity > 1 && (a = ' <span class="cart-summary__quantity">' + t.quantity + "</span>"), t.line_level_discount_allocations && t.line_level_discount_allocations.length > 0)) {
                                        for (r += '<ul class="cart-discount-list small-text">', o = 0; o < t.line_level_discount_allocations.length; o++) {
                                            var l = t.line_level_discount_allocations[o];
                                            r += [
                                                '<li class="cart-discount">',
                                                '<div class="cart-discount__label">',
                                                l.discount_application.title,
                                                "</div>",
                                                '<div class="cart-discount__amount theme-money">',
                                                theme.Shopify.formatMoney(l.amount, theme.moneyFormat),
                                                "</div>",
                                                "</li>",
                                            ].join("");
                                        }
                                        r += "</ul>";
                                    }
                                    var c = "";
                                    t.selling_plan_allocation && t.selling_plan_allocation.selling_plan.name && (c = ['<div class="cart-summary__selling-plan ">', t.selling_plan_allocation.selling_plan.name, "</div>"].join(""));
                                    var d,
                                        u = "";
                                    if (i) {
                                        var p = theme.productData[t.product_id].options;
                                        for (u = '<div class="cart-summary__product__variants">', o = 0; o < i.options.length; o++)
                                            i.options[o].indexOf("Default Title") < 0 &&
                                                ((u += '<div class="cart-summary__variant">'),
                                                (u += '<span class="cart-summary__variant-label">' + p[o] + ":</span> "),
                                                (u += '<span class="cart-summary__variant-value">' + i.options[o] + "</span>"),
                                                (u += "</div>"));
                                        u += "</div>";
                                    }
                                    i.featured_media
                                        ? (d = slate.Image.getSizedImageUrl(i.featured_media.preview_image.src, "200x"))
                                        : theme.productData[t.product_id].media && theme.productData[t.product_id].media.length > 0 && (d = slate.Image.getSizedImageUrl(theme.productData[t.product_id].media[0].preview_image.src, "200x")),
                                        e.getJSON(theme.routes.cart_url + ".js", function (n) {
                                            if (e(".ajax-cart-layer-form").length > 0 && e(".draweritem").length > 0) e(".Drawer").attr("aria-hidden", !1), e("body").toggleClass("notscroll"), e(".PageOverlay").toggleClass("is-visible");
                                            else {
                                                var i = e(
                                                    [
                                                        '<div class="added-notice global-border-radius added-notice--pre-reveal">',
                                                        '<div class="added-notice__header">',
                                                        '<span class="added-notice__title">',
                                                        theme.strings.addedToCartPopupTitle,
                                                        "</span>",
                                                        '<a class="added-notice__close feather-icon" href="#" aria-label="',
                                                        theme.strings.close,
                                                        '">',
                                                        theme.icons.close,
                                                        "</a>",
                                                        "</div>",
                                                        '<div class="cart-summary global-border-radius">',
                                                        '<div class="cart-summary__product">',
                                                        '<div class="cart-summary__product-image"><img class="global-border-radius" src="',
                                                        d,
                                                        '" role="presentation" alt=""></div>',
                                                        '<div class="cart-summary__product__description">',
                                                        '<div class="cart-summary__product-title">',
                                                        theme.productData[t.product_id].title,
                                                        a,
                                                        "</div>",
                                                        u,
                                                        c,
                                                        '<div class="cart-summary__price">',
                                                        r,
                                                        "</div>",
                                                        "</div>",
                                                        "</div>",
                                                        "</div>",
                                                        '<div class="cart-summary__footer">',
                                                        '<div class="cart-summary__total-quantity-row">',
                                                        "<span>",
                                                        theme.strings.addedToCartPopupItems,
                                                        "</span>",
                                                        "<span>",
                                                        n.item_count,
                                                        "</span>",
                                                        "</div>",
                                                        '<div class="cart-summary__total-price-row large-text">',
                                                        "<span>",
                                                        theme.strings.addedToCartPopupSubtotal,
                                                        "</span>",
                                                        '<span class="theme-money">',
                                                        theme.Shopify.formatMoney(n.total_price, theme.moneyFormat),
                                                        "</span>",
                                                        "</div>",
                                                        '<a href="',
                                                        theme.routes.cart_url,
                                                        '" class="btn btn--primary btn--small btn--fullwidth cart-summary__button">',
                                                        theme.strings.addedToCartPopupGoToCart,
                                                        "</a>",
                                                        "</div>",
                                                        "</div>",
                                                    ].join("")
                                                );
                                                i.appendTo("body"),
                                                    setTimeout(function () {
                                                        i.removeClass("added-notice--pre-reveal");
                                                    }, 10);
                                            }
                                        });
                                },
                                "json"
                            )
                            .fail(function (t) {
                                n.removeClass("add-in-progress");
                                var i = n
                                    .find(":submit")
                                    .removeAttr("disabled")
                                    .each(function () {
                                        var t = e(this),
                                            n = t.is("button") ? "html" : "val";
                                        t[n](t.data("previous-value"));
                                    })
                                    .first();
                                void 0 !== t && t.responseJSON && t.responseJSON.description ? theme.showQuickPopup(t.responseJSON.description, i) : n.off("submit").submit();
                            });
                }),
                    e(document).off(".ajaxAddToCart"),
                    e(document).on("click.ajaxAddToCart", ".added-notice__close", function () {
                        var t = e(this).closest(".added-notice").addClass("added-notice--pre-destroy");
                        return (
                            setTimeout(function () {
                                t.remove();
                            }, 500),
                            !1
                        );
                    }),
                    e(document).on("mouseenter.ajaxAddToCart", ".header-cart", function () {
                        clearTimeout(theme.addedToCartNoticeHideTimeoutId), e(".added-notice__close").trigger("click");
                    });
            }),
            (theme.unloadAjaxAddToCartForm = function (e) {
                e.off("submit");
            }),
            e(function () {
                var t = 10,
                    n = 11;
                function i(e) {
                    var t = { left: e.offset().left - parseFloat(e.css("margin-left")), top: e.offset().top - parseFloat(e.css("margin-top")), width: e.outerWidth(), height: e.outerHeight() };
                    return (
                        (t.right = t.left + t.width),
                        (t.bottom = t.top + t.height),
                        e.hasClass("avoid-overlaps__item--gravity-left") ? (t.gravity = 0) : e.hasClass("avoid-overlaps__item--gravity-right") ? (t.gravity = 2) : (t.gravity = 1),
                        t
                    );
                }
                function o(e) {
                    0 == e.newRect.gravity ||
                        (2 == e.newRect.gravity
                            ? ((e.newRect.right = e.newRect.left), (e.newRect.left = e.newRect.right - e.newRect.width))
                            : ((e.newRect.left = e.newRect.left - e.newRect.width / 2), (e.newRect.right = e.newRect.left + e.newRect.width))),
                        (e.newRect.top = e.newRect.top - e.newRect.height / 2),
                        (e.newRect.bottom = e.newRect.top + e.newRect.height);
                }
                function s(e, i) {
                    e.newRect.left < i.left + t && ((e.newRect.left = i.left + n), (e.newRect.right = e.newRect.left + e.newRect.width)),
                        e.newRect.top < i.top + t && ((e.newRect.top = i.top + n), (e.newRect.bottom = e.newRect.top + e.newRect.height)),
                        e.newRect.right > i.right - t && ((e.newRect.right = i.right - n), (e.newRect.left = e.newRect.right - e.newRect.width)),
                        e.newRect.bottom > i.bottom - t && ((e.newRect.bottom = i.bottom - n), (e.newRect.top = e.newRect.bottom - e.newRect.height));
                }
                function r(e, t) {
                    var n = t.left + (t.right - t.left) / 2 - (e.left + (e.right - e.left) / 2),
                        i = t.top + (t.bottom - t.top) / 2 - (e.top + (e.bottom - e.top) / 2);
                    return Math.abs(n) > Math.abs(i) ? (n > 0 ? [1, 0, 2, 3] : [3, 0, 2, 1]) : i > 0 ? [2, 1, 3, 0] : [0, 1, 3, 2];
                }
                function a(i, o, s, r, a) {
                    var l = e.extend({}, i.newRect);
                    switch (o) {
                        case 0:
                            (l.bottom = s.newRect.top - n), (l.top = l.bottom - l.height);
                            break;
                        case 1:
                            (l.left = s.newRect.right + n), (l.right = l.left + l.width);
                            break;
                        case 2:
                            (l.top = s.newRect.bottom + n), (l.bottom = l.top + l.height);
                            break;
                        case 3:
                            (l.right = s.newRect.left - n), (l.left = l.right - l.width);
                    }
                    for (var c, d, u, p, h = ((d = r), (c = l).left >= d.left + t && c.top >= d.top + t && c.right <= d.right - t && c.bottom <= d.bottom - t), f = !1, m = 0; m < a.length; m++) {
                        var g = a[m];
                        g.el[0] != i.el[0] && ((u = l), (p = g.newRect), u.right < p.left || u.left > p.right || u.bottom < p.top || u.top > p.bottom || (f = !0));
                    }
                    return !(!h || f || ((i.newRect = l), 0));
                }
                (theme.checkOverlaps = function () {
                    e(".avoid-overlaps")
                        .each(function () {
                            var n,
                                l = e(this),
                                c = e(".avoid-overlaps__mobile-container", this);
                            n = c.length && "relative" == c.css("position") ? i(c) : i(l);
                            var d,
                                u,
                                p = e(this).find(".avoid-overlaps__item"),
                                h = [],
                                f = [],
                                m = [];
                            p.each(function () {
                                var t = { el: e(this), newRect: i(e(this)), oldRect: i(e(this)), overlaps: !1 };
                                h.push(t), e(this).hasClass("overlay") || m.push(t), "absolute" != e(this).css("position") || e(this).hasClass("overlay--bottom-wide") || e(this).hasClass("overlay--low-wide") || f.push(t);
                            });
                            for (var g = 0; g < f.length; g++) o((v = f[g])), s(v, n);
                            for (g = 0; g < h.length; g++)
                                for (var v = h[g], y = 0; y < m.length; y++) {
                                    var b = m[y];
                                    if (b.el[0] != v.el[0])
                                        for (var w = r(v.newRect, b.newRect); w.length > 0 && ((d = v.newRect), (u = b.newRect), !(d.right + t < u.left || d.left - t > u.right || d.bottom + t < u.top || d.top - t > u.bottom)); ) {
                                            var x = a(b, w.shift(), v, n, h);
                                            b.overlaps = !x;
                                        }
                                }
                            for (y = 0; y < h.length; y++) {
                                var T = h[y],
                                    C = T.newRect.left - T.oldRect.left,
                                    S = T.newRect.top - T.oldRect.top;
                                T.el.css({ marginLeft: 0 != C ? C : "", marginTop: 0 != S ? S : "" }), T.el.toggleClass("is-overlapping", T.overlaps);
                            }
                        })
                        .addClass("avoid-overlaps--processed");
                }),
                    theme.checkOverlaps(),
                    e(document).on("shopify:section:load", theme.checkOverlaps),
                    e(window).on("debouncedresize", theme.checkOverlaps);
            }),
            (theme.assessLoadedRTEImage = function (t) {
                var n = e(t).closest(".rte").width();
                if (e(t)[0].naturalWidth > n) {
                    var i = e(t).parentsUntil(".rte").filter("p");
                    i.length > 0 ? i.addClass("expanded-width") : e(t).wrap('<p class="expanded-width"></p>');
                } else e(t).closest(".expanded-width").removeClass("expanded-width");
            }),
            (theme.assessRTEImagesOnLoad = function (t) {
                e(".rte--expanded-images img:not(.exp-loaded)", t).each(function () {
                    var t = this,
                        n = new Image();
                    e(n).on("load.rteExpandedImage", function () {
                        e(t).addClass("exp-loaded"), theme.assessLoadedRTEImage(t);
                    }),
                        (n.src = this.src),
                        (n.complete || 4 === n.readyState) && (e(n).off("load.rteExpandedImage"), e(t).addClass("exp-loaded"), theme.assessLoadedRTEImage(t));
                });
            }),
            theme.assessRTEImagesOnLoad(),
            e(window).on("debouncedresize", function () {
                e(".rte--expanded-images img.exp-loaded").each(function () {
                    theme.assessLoadedRTEImage(this);
                });
            }),
            (theme.recentProductCacheExpiry = 6e5),
            (theme.recentProductHistoryCap = 12),
            (theme.recentProductsStorageKey = "theme.recent_products_v3"),
            (theme.addRecentProduct = function (t, n, i, o, s) {
                var r = t[n],
                    a = t,
                    l = o,
                    c = s,
                    d = i,
                    u = e('<div class="product-block product-block--recent-unloaded grid__item one-sixth medium--one-quarter small-down--one-whole">'),
                    p = new Date().getTime();
                r.timestamp && r.timestamp > p - theme.recentProductCacheExpiry
                    ? u.append(theme.buildRecentProduct(r, l, c)).removeClass("product-block--recent-unloaded")
                    : e.getJSON(r.url + ".js", function (e) {
                          (r.title = e.title),
                              (r.image = e.media && e.media.length ? e.media[0].preview_image.src : ""),
                              (r.timestamp = p),
                              window.localStorage.setItem(theme.recentProductsStorageKey, JSON.stringify(a)),
                              d.filter(".slick-initialized").slick("slickUnfilter"),
                              u.append(theme.buildRecentProduct(r, l, c)).removeClass("product-block--recent-unloaded"),
                              d.filter(".slick-initialized").slick("slickFilter", ":not(.product-block--recent-unloaded)"),
                              theme.initUniformHeightMonitor(d, ".product-block__image-container", ".product-block__image-container .image-one");
                      }),
                    i.append(u),
                    theme.assessRecentProductGrid(i);
            }),
            (theme.assessRecentProductGrid = function (t) {
                var n = t.children(),
                    i = Math.max(n.length - 4, 0);
                if (i > 0) {
                    n.slice(0, 3).removeClass("medium--hide");
                    for (var o = 0; o < i; o++) e(n[o]).addClass("medium--hide");
                }
            }),
            (theme.onRecentProductImageLoad = function () {
                if (theme.settings.uniformProductGridImagesEnabled) {
                    var t = e(this).closest(".uhm-active");
                    t.length && t.data("uhm-callback")();
                }
            }),
            (theme.buildRecentProduct = function (t, n, i) {
                var o = e('<a class="recently-viewed-product plain-link">').attr({ href: t.url, title: t.title }),
                    s = e('<div class="product-price small-text">');
                if (
                    (t.priceVaries && (e('<span class="product-price__from tiny-text">').html(theme.strings.priceFrom).appendTo(s), s.append(" ")),
                    t.compareAtPrice > t.price
                        ? (e('<span class="product-price__reduced theme-money">').html(theme.Shopify.formatMoney(t.price, theme.moneyFormat)).appendTo(s),
                          s.append(" "),
                          e('<span class="product-price__compare theme-money">').html(theme.Shopify.formatMoney(t.compareAtPrice, theme.moneyFormat)).appendTo(s))
                        : e('<span class="theme-money">').html(theme.Shopify.formatMoney(t.price, theme.moneyFormat)).appendTo(s),
                    t.unitPrice)
                ) {
                    var r = e('<div class="unit-price tiny-text">');
                    e('<span class="unit-price__price theme-money">').html(theme.Shopify.formatMoney(t.unitPrice, theme.moneyFormat)).appendTo(r),
                        e('<span class="unit-price__separator">').html(theme.strings.unitPriceSeparator).appendTo(r),
                        e('<span class="unit-price__unit">').html(t.unitPriceUnit).appendTo(r),
                        r.appendTo(s);
                }
                var a = e('<div class="product-block__image-container">').appendTo(o),
                    l = e('<div class="hover-images global-border-radius relative">').appendTo(a);
                return (
                    t.image &&
                        e('<div class="image-one">')
                            .append(e('<img role="presentation">').on("load", theme.onRecentProductImageLoad).attr({ src: t.image, alt: t.title }))
                            .appendTo(l),
                    n &&
                        t.image2 &&
                        (l.addClass("hover-images--two"),
                        e('<div class="image-two">')
                            .css("background-image", "url(" + t.image2 + ")")
                            .appendTo(l)),
                    !1 === t.available
                        ? theme.settings.soldLabelEnabled && e('<span class="product-label product-label--sold-out global-border-radius"></span>').html(theme.strings.soldOut).appendTo(l)
                        : theme.settings.saleLabelEnabled && t.compareAtPrice > t.price && e('<span class="product-label product-label--on-sale global-border-radius"></span>').html(theme.strings.onSale).appendTo(l),
                    e('<div class="product-block__title small-text">').html(t.title).appendTo(o),
                    i && e('<div class="product-block__vendor tiny-text">').html(t.vendor).appendTo(o),
                    o.append(s),
                    o
                );
            }),
            (theme.getRecentProducts = function () {
                var e = window.localStorage.getItem(theme.recentProductsStorageKey);
                if (e)
                    try {
                        return JSON.parse(e);
                    } catch (e) {}
                return [];
            }),
            (theme.addToAndReturnRecentProducts = function (e) {
                for (var t = theme.getRecentProducts(), n = !0; n; ) {
                    n = !1;
                    for (var i = 0; i < t.length; i++)
                        if (t[i].handle == e.handle) {
                            t.splice(i, 1), (n = !0);
                            break;
                        }
                }
                for (e.timestamp = new Date().getTime(), t.push(e); t.length > theme.recentProductHistoryCap; ) t.shift();
                return window.localStorage.setItem(theme.recentProductsStorageKey, JSON.stringify(t)), t;
            }),
            (theme.loadRecentlyViewed = function (t) {
                theme.peekCarousel.init(t, e(".grid", t), ".recentlyViewed", function () {
                    return e(window).width() < 768;
                }),
                    e(".grid", t).filter(".slick-initialized").slick("slickFilter", ":not(.product-block--recent-unloaded)"),
                    theme.initUniformHeightMonitor(t, ".product-block__image-container", ".product-block__image-container .image-one");
            }),
            (theme.unloadRecentlyViewed = function (t) {
                theme.destroyUniformHeightMonitor(t), theme.peekCarousel.destroy(t, e(".slick-initialized", t), ".recentlyViewed");
            }),
            (theme.ProductMedia = new (function () {
                var t = this;
                (t._setupShopifyXr = function () {
                    window.ShopifyXR ? (window.ShopifyXR.addModels(JSON.parse(e(this).html())), window.ShopifyXR.setupXRElements()) : document.addEventListener("shopify_xr_initialized", t._setupShopifyXr.bind(this));
                }),
                    (this.init = function (n, i) {
                        i = i || {};
                        var o = n;
                        e(n).on("mediaVisible", ".product-media--video-loaded, .product-media--model-loaded", function () {
                            e(window).width() >= 768 && e(this).data("player").play(), e(this).hasClass("product-media--model") && e(".view-in-space", o).attr("data-shopify-model3d-id", e(this).data("model-id"));
                        }),
                            e(n).on("mediaHidden", ".product-media--video-loaded, .product-media--model-loaded", function () {
                                e(this).data("player").pause();
                            }),
                            i.onVideoVisible && e(n).on("mediaVisible", ".product-media--video-loaded", i.onVideoVisible),
                            i.onVideoHidden && e(n).on("mediaHidden", ".product-media--video-loaded", i.onVideoHidden),
                            e("model-viewer", n).each(function () {
                                i.onModelViewerPlay && e(this).on("shopify_model_viewer_ui_toggle_play", i.onModelViewerPlay), i.onModelViewerPause && e(this).on("shopify_model_viewer_ui_toggle_pause", i.onModelViewerPause);
                            }),
                            e(n)
                                .find(".product-media--video")
                                .each(function (t) {
                                    var n = e(this).data("enable-video-looping"),
                                        o = e(this).find("iframe, video")[0],
                                        s = e(this);
                                    if ("VIDEO" === o.tagName)
                                        window.Shopify.loadFeatures([
                                            {
                                                name: "video-ui",
                                                version: "1.0",
                                                onLoad: function () {
                                                    var t = { playerType: "html5", element: o };
                                                    (t.play = function () {
                                                        this.plyr.play();
                                                    }.bind(t)),
                                                        (t.pause = function () {
                                                            this.plyr.pause();
                                                        }.bind(t)),
                                                        (t.destroy = function () {
                                                            this.plyr.destroy();
                                                        }.bind(t)),
                                                        (t.plyr = new Shopify.Plyr(o, {
                                                            controls: ["play", "progress", "mute", "volume", "play-large", "fullscreen"],
                                                            loop: { active: n },
                                                            hideControlsOnPause: !0,
                                                            iconUrl: "//cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.svg",
                                                            tooltips: { controls: !1, seek: !0 },
                                                        })),
                                                        e(this).data("player", t).addClass("product-media--video-loaded"),
                                                        e(o).on("playing", function () {
                                                            e(".product-media").not(s).trigger("mediaHidden"),
                                                                s
                                                                    .find(".plyr__controls")
                                                                    .off(".themeMediaEventFix")
                                                                    .on("keydown.themeMediaEventFix touchstart.themeMediaEventFix mousedown.themeMediaEventFix keydown.themeMediaEventFix", function (e) {
                                                                        e.stopPropagation();
                                                                    }),
                                                                i.onPlyrPlay && i.onPlyrPlay(t);
                                                        }),
                                                        e(o).on("pause ended", function () {
                                                            s.find(".plyr__controls").off(".themeMediaEventFix"), i.onPlyrPause && i.onPlyrPause(t);
                                                        }),
                                                        i.onPlyrInit && i.onPlyrInit(t);
                                                }.bind(this),
                                            },
                                        ]),
                                            theme.loadStyleOnce("https://cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.css");
                                    else if ("IFRAME" === o.tagName && /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(o.src)) {
                                        var r = window.onYouTubeIframeAPIReady,
                                            a = function () {
                                                var t = { playerType: "youtube", element: o },
                                                    r = e(this).data("video-id");
                                                (t.player = new YT.Player(o, {
                                                    videoId: r,
                                                    events: {
                                                        onStateChange: function (o) {
                                                            o.data === YT.PlayerState.ENDED && n && o.target.seekTo(0),
                                                                o.data === YT.PlayerState.PLAYING && (e(".product-media").not(s).trigger("mediaHidden"), i.onYouTubePlay && i.onYouTubePlay(t)),
                                                                o.data === YT.PlayerState.PAUSED && o.data === YT.PlayerState.ENDED && i.onYouTubePause && i.onYouTubePause(t);
                                                        },
                                                    },
                                                })),
                                                    (t.play = function () {
                                                        this.player.playVideo();
                                                    }.bind(t)),
                                                    (t.pause = function () {
                                                        this.player.pauseVideo();
                                                    }.bind(t)),
                                                    (t.destroy = function () {
                                                        this.player.destroy();
                                                    }.bind(t)),
                                                    e(this).data("player", t).addClass("product-media--video-loaded"),
                                                    i.onYouTubeInit && i.onYouTubeInit(t);
                                            }.bind(this);
                                        window.YT && window.YT.Player
                                            ? a()
                                            : ((window.onYouTubeIframeAPIReady = function () {
                                                  r && r(), a();
                                              }),
                                              theme.loadScriptOnce("https://www.youtube.com/iframe_api"));
                                    }
                                }),
                            e(n).on("mediaVisible mediaVisibleInitial", ".product-media--model:not(.product-media--model-loaded):not(.product-media--model-loading)", function (t) {
                                var n = e(this).find("model-viewer")[0],
                                    o = e(this),
                                    s = "mediaVisibleInitial" != t.type;
                                e(this).addClass("product-media--model-loading"),
                                    theme.loadStyleOnce("https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css"),
                                    window.Shopify.loadFeatures([
                                        {
                                            name: "model-viewer-ui",
                                            version: "1.0",
                                            onLoad: function () {
                                                e(this).data("player", new Shopify.ModelViewerUI(n)),
                                                    e('<div class="theme-event-proxy">')
                                                        .on("mouseup", function (t) {
                                                            t.stopPropagation(),
                                                                t.preventDefault(),
                                                                e(t.currentTarget)
                                                                    .closest(".product-media")[0]
                                                                    .dispatchEvent(new MouseEvent("mouseup", { bubbles: !0 }));
                                                        })
                                                        .appendTo(e(this).find(".shopify-model-viewer-ui__controls-overlay")),
                                                    e(this)
                                                        .find("model-viewer")
                                                        .on("shopify_model_viewer_ui_toggle_play", function () {
                                                            e(this)
                                                                .closest(".product-media")
                                                                .on("touchstart.themeModelViewerFix mousedown.themeModelViewerFix keydown.themeModelViewerFix", function (e) {
                                                                    e.stopPropagation();
                                                                });
                                                        })
                                                        .on("shopify_model_viewer_ui_toggle_pause", function () {
                                                            e(this).closest(".shopify-model-viewer-ui").off(".themeMediaEventFix");
                                                        }),
                                                    e(this)
                                                        .find("model-viewer")
                                                        .on("shopify_model_viewer_ui_toggle_play", function () {
                                                            e(".product-media").not(o).trigger("mediaHidden");
                                                        }),
                                                    e(this).addClass("product-media--model-loaded").removeClass("product-media--model-loading"),
                                                    i.onModelViewerInit && i.onModelViewerInit(n),
                                                    s && e(this).trigger("mediaVisible");
                                            }.bind(this),
                                        },
                                    ]);
                            }),
                            e(".model-json", n).length &&
                                (window.Shopify.loadFeatures([{ name: "shopify-xr", version: "1.0", onLoad: t._setupShopifyXr.bind(e(".model-json", n)) }]),
                                e(document).on("shopify_xr_launch", function () {
                                    e(".product-media--video-loaded").each(function () {
                                        e(this).data("player").pause();
                                    });
                                })),
                            setTimeout(
                                function () {
                                    e(".product-media:first", this).filter(".product-media--model").trigger("mediaVisibleInitial");
                                }.bind(n),
                                50
                            );
                    }),
                    (this.destroy = function (t) {
                        e(document).off("shopify_xr_launch"),
                            e(t).off("mediaVisible mediaVisibleInitial mediaHidden"),
                            e(".product-media--video-loaded, .product-media--model-loaded", t).each(function () {
                                e(this).data("player").destroy();
                            }),
                            e(".product-media--video video", t).off("playing pause ended"),
                            e("model-viewer", t).off("shopify_model_viewer_ui_toggle_play shopify_model_viewer_ui_toggle_pause");
                    });
            })());
        var d,
            u = (function () {
                "use strict";
                function e(t) {
                    var n = this;
                    _classCallCheck(this, e),
                        (this.container = t),
                        (this.selectors = {
                            inputMin: ".cc-price-range__input--min",
                            inputMax: ".cc-price-range__input--max",
                            control: ".cc-price-range__control",
                            controlMin: ".cc-price-range__control--min",
                            controlMax: ".cc-price-range__control--max",
                            bar: ".cc-price-range__bar",
                            activeBar: ".cc-price-range__bar-active",
                        }),
                        (this.controls = {
                            min: { barControl: t.querySelector(this.selectors.controlMin), input: t.querySelector(this.selectors.inputMin) },
                            max: { barControl: t.querySelector(this.selectors.controlMax), input: t.querySelector(this.selectors.inputMax) },
                        }),
                        (this.controls.min.value = parseInt("" === this.controls.min.input.value ? this.controls.min.input.placeholder : this.controls.min.input.value)),
                        (this.controls.max.value = parseInt("" === this.controls.max.input.value ? this.controls.max.input.placeholder : this.controls.max.input.value)),
                        (this.valueMin = this.controls.min.input.min),
                        (this.valueMax = this.controls.min.input.max),
                        (this.valueRange = this.valueMax - this.valueMin),
                        [this.controls.min, this.controls.max].forEach(function (e) {
                            e.barControl.setAttribute("aria-valuemin", n.valueMin), e.barControl.setAttribute("aria-valuemax", n.valueMax);
                        }),
                        this.controls.min.barControl.setAttribute("aria-valuenow", this.controls.min.value),
                        this.controls.max.barControl.setAttribute("aria-valuenow", this.controls.max.value),
                        (this.bar = t.querySelector(this.selectors.bar)),
                        (this.activeBar = t.querySelector(this.selectors.activeBar)),
                        (this.inDrag = !1),
                        this.bindEvents(),
                        this.render();
                }
                return (
                    _createClass(e, [
                        {
                            key: "getPxToValueRatio",
                            value: function () {
                                return this.bar.clientWidth / (this.valueMax - this.valueMin);
                            },
                        },
                        {
                            key: "getPcToValueRatio",
                            value: function () {
                                return 100 / (this.valueMax - this.valueMin);
                            },
                        },
                        {
                            key: "setActiveControlValue",
                            value: function (e, t) {
                                this.activeControl === this.controls.min
                                    ? ("" === e && (e = this.valueMin), (e = Math.max(this.valueMin, e)), (e = Math.min(e, this.controls.max.value)))
                                    : ("" === e && (e = this.valueMax), (e = Math.min(this.valueMax, e)), (e = Math.max(e, this.controls.min.value))),
                                    (this.activeControl.value = Math.round(e)),
                                    this.activeControl.input.value != this.activeControl.value &&
                                        (this.activeControl.value == this.activeControl.input.placeholder ? (this.activeControl.input.value = "") : (this.activeControl.input.value = this.activeControl.value),
                                        t || this.activeControl.input.dispatchEvent(new CustomEvent("change", { bubbles: !0, detail: { sender: "theme:component:price_range" } }))),
                                    this.activeControl.barControl.setAttribute("aria-valuenow", this.activeControl.value);
                            },
                        },
                        {
                            key: "render",
                            value: function () {
                                this.drawControl(this.controls.min), this.drawControl(this.controls.max), this.drawActiveBar();
                            },
                        },
                        {
                            key: "drawControl",
                            value: function (e) {
                                e.barControl.style.left = "".concat((e.value - this.valueMin) * this.getPcToValueRatio(), "%");
                            },
                        },
                        {
                            key: "drawActiveBar",
                            value: function () {
                                (this.activeBar.style.left = "".concat((this.controls.min.value - this.valueMin) * this.getPcToValueRatio(), "%")),
                                    (this.activeBar.style.right = "".concat((this.valueMax - this.controls.max.value) * this.getPcToValueRatio(), "%"));
                            },
                        },
                        {
                            key: "handleControlTouchStart",
                            value: function (e) {
                                e.preventDefault(),
                                    this.startDrag(e.target, e.touches[0].clientX),
                                    (this.boundControlTouchMoveEvent = this.handleControlTouchMove.bind(this)),
                                    (this.boundControlTouchEndEvent = this.handleControlTouchEnd.bind(this)),
                                    window.addEventListener("touchmove", this.boundControlTouchMoveEvent),
                                    window.addEventListener("touchend", this.boundControlTouchEndEvent);
                            },
                        },
                        {
                            key: "handleControlTouchMove",
                            value: function (e) {
                                this.moveDrag(e.touches[0].clientX);
                            },
                        },
                        {
                            key: "handleControlTouchEnd",
                            value: function (e) {
                                e.preventDefault(), window.removeEventListener("touchmove", this.boundControlTouchMoveEvent), window.removeEventListener("touchend", this.boundControlTouchEndEvent), this.stopDrag();
                            },
                        },
                        {
                            key: "handleControlMouseDown",
                            value: function (e) {
                                e.preventDefault(),
                                    this.startDrag(e.target, e.clientX),
                                    (this.boundControlMouseMoveEvent = this.handleControlMouseMove.bind(this)),
                                    (this.boundControlMouseUpEvent = this.handleControlMouseUp.bind(this)),
                                    window.addEventListener("mousemove", this.boundControlMouseMoveEvent),
                                    window.addEventListener("mouseup", this.boundControlMouseUpEvent);
                            },
                        },
                        {
                            key: "handleControlMouseMove",
                            value: function (e) {
                                this.moveDrag(e.clientX);
                            },
                        },
                        {
                            key: "handleControlMouseUp",
                            value: function (e) {
                                e.preventDefault(), window.removeEventListener("mousemove", this.boundControlMouseMoveEvent), window.removeEventListener("mouseup", this.boundControlMouseUpEvent), this.stopDrag();
                            },
                        },
                        {
                            key: "startDrag",
                            value: function (e, t) {
                                (this.activeControl = this.controls.min.barControl === e ? this.controls.min : this.controls.max), (this.dragStartX = t), (this.dragStartValue = this.activeControl.value), (this.inDrag = !0);
                            },
                        },
                        {
                            key: "moveDrag",
                            value: function (e) {
                                if (this.inDrag) {
                                    var t = this.dragStartValue + (e - this.dragStartX) / this.getPxToValueRatio();
                                    this.setActiveControlValue(t), this.render();
                                }
                            },
                        },
                        {
                            key: "stopDrag",
                            value: function () {
                                this.inDrag = !1;
                            },
                        },
                        {
                            key: "handleInputChange",
                            value: function (e) {
                                if ("INPUT" === e.target.tagName && (!e.detail || "theme:component:price_range" !== e.detail.sender)) {
                                    var t = e.detail && "reset" === e.detail.sender;
                                    (this.activeControl = this.controls.min.input === e.target ? this.controls.min : this.controls.max), this.setActiveControlValue(e.target.value, t), this.render();
                                }
                            },
                        },
                        {
                            key: "bindEvents",
                            value: function () {
                                var e = this;
                                [this.controls.min, this.controls.max].forEach(function (t) {
                                    t.barControl.addEventListener("touchstart", e.handleControlTouchStart.bind(e)), t.barControl.addEventListener("mousedown", e.handleControlMouseDown.bind(e));
                                }),
                                    this.container.addEventListener("change", this.handleInputChange.bind(this));
                            },
                        },
                        { key: "destroy", value: function () {} },
                    ]),
                    e
                );
            })(),
            p = (function (e) {
                "use strict";
                _inherits(n, e);
                var t = _createSuper(n);
                function n() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "price-range",
                        i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ".cc-".concat(e);
                    return _classCallCheck(this, n), t.call(this, e, i);
                }
                return (
                    _createClass(n, [
                        {
                            key: "init",
                            value: function (e) {
                                _get(_getPrototypeOf(n.prototype), "init", this).call(this, e), this.registerInstance(e, new u(e));
                            },
                        },
                        {
                            key: "destroy",
                            value: function (e) {
                                this.destroyInstance(e), _get(_getPrototypeOf(n.prototype), "destroy", this).call(this, e);
                            },
                        },
                    ]),
                    n
                );
            })(r);
        new p(),
            (theme.Header = new (function () {
                (this.onSectionLoad = function (t) {
                    (this.$container = e(t)),
                        (this.namespace = theme.namespaceFromSection(t)),
                        (this.$nav = e(".site-nav", t)),
                        (this.$navLinks = this.$nav.children(".site-nav__item:not(.site-nav__more-links)")),
                        (this.$navMoreLinksLink = e(".site-nav__more-links", this.$nav)),
                        (this.$navMoreLinksContainer = e(".small-dropdown__container", this.$navMoreLinksLink)),
                        (this.$navMoreLinksSubmenuContainer = e(".site-nav__more-links .more-links__dropdown-container", this.$nav)),
                        (this.search = {
                            ongoingRequest: null,
                            ongoingTimeoutId: -1,
                            throttleMs: 500,
                            searchUrlKey: "searchUrl",
                            resultsSelector: ".search-bar__results",
                            resultsLoadingClass: "search-bar--loading-results",
                            resultsLoadedClass: "search-bar--has-results",
                            loadingMessage: theme.strings.searchLoading,
                            moreResultsMessage: theme.strings.searchMoreResults,
                            emptyMessage: theme.strings.searchNoResults,
                        }),
                        e(this.$container).on("click" + this.namespace, ".js-search-form-open", this.functions.searchFormOpen.bind(this)),
                        e(this.$container).on("click" + this.namespace, ".js-search-form-focus", this.functions.searchFormFocus.bind(this)),
                        e(this.$container).on("click" + this.namespace, ".js-search-form-close", this.functions.searchFormClose.bind(this)),
                        e(this.$container).on("click" + this.namespace, ".js-mobile-menu-icon", this.functions.mobileMenuOpen.bind(this)),
                        e(this.$container).on("click" + this.namespace, ".js-close-mobile-menu", this.functions.mobileMenuClose.bind(this)),
                        e(this.$container).on("focusin" + this.namespace, ".search-bar", this.functions.searchFocusIn.bind(this)),
                        e(this.$container).on("focusout" + this.namespace, ".search-bar", this.functions.searchFocusOut.bind(this)),
                        e(".search-bar.live-search", this.$container).length &&
                            e(this.$container).on("keyup" + this.namespace + " change" + this.namespace, '.search-bar.live-search input[name="q"]', this.functions.updateSearchResults.bind(this)),
                        this.functions.setSearchTabbing.bind(this)(),
                        e(".focus-tint").on("click" + this.namespace, this.functions.onFocusTintClick.bind(this)),
                        e("body").toggleClass("header-has-messages", this.$container.find(".store-messages-bar").length > 0),
                        e(".js-messages-slider", this.$container).slick({ infinite: !0, autoplay: !0, slidesToShow: 1, slidesToScroll: 1, prevArrow: !1, nextArrow: !1 }),
                        e(".js-mobile-messages-slider", this.$container).slick({
                            infinite: !0,
                            autoplay: !0,
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            mobileFirst: !0,
                            prevArrow: !1,
                            nextArrow: !1,
                            responsive: [{ breakpoint: 767, settings: "unslick" }],
                        }),
                        e(window).on("debouncedresize" + this.namespace, function (t) {
                            e(".js-mobile-messages-slider", this.$container).slick("resize");
                        }),
                        e(this.$container).on("click" + this.namespace, '.mobile-site-nav__icon, .mobile-site-nav__link[href="#"]', function (t) {
                            t.preventDefault(), e(this).siblings(".mobile-site-nav__menu").slideToggle(250), e(this).toggleClass("submenu-open");
                        }),
                        e(this.$container).on("click" + this.namespace, ".customer-account .customer-login", this.functions.loginOpen.bind(this)),
                        e(this.$container).on("click" + this.namespace, ".customer-account .customer-register", this.functions.registerOpen.bind(this)),
                        this.$container.hasClass("docking-header") &&
                            ((this.desktopHeaderWasDocked = !1),
                            (this.$dockedDesktopContentsContainer = e(".docked-navigation-container__inner", t)),
                            (this.$dockedDesktopBaseContainer = e(".docked-navigation-container", t)),
                            (this.mobileHeaderWasDocked = !1),
                            (this.$dockedMobileContentsContainer = e(".docked-mobile-navigation-container__inner", t)),
                            (this.$dockedMobileBaseContainer = e(".docked-mobile-navigation-container", t)),
                            e(this.functions.dockedNavCheck.call(this)),
                            e(window).on("scroll" + this.namespace, this.functions.dockedNavCheck.bind(this)),
                            e(window).on("debouncedresize" + this.namespace, this.functions.dockedNavCheck.bind(this)),
                            e('<style id="themeDockedNavStyle">').appendTo("head"),
                            e(this.functions.updateDockedNavHeightStyle.call(this)),
                            e(window).on("debouncedresize" + this.namespace, this.functions.updateDockedNavHeightStyle.bind(this))),
                        e(this.functions.menuLinkVisibilityCheck.call(this)),
                        e(window).on("debouncedresize" + this.namespace, this.functions.menuLinkVisibilityCheck.bind(this)),
                        e(this.$container).on("mouseenter" + this.namespace, ".more-links--with-dropdown .site-nav__item", this.functions.onMoreLinksSubMenuActive.bind(this)),
                        (this.navHoverDelay = 250),
                        (this.$navLastOpenDropdown = e()),
                        e(this.$container).on(
                            "mouseenter" + this.namespace + " mouseleave" + this.namespace,
                            ".site-nav__item--has-dropdown",
                            function (t) {
                                var n = e(t.currentTarget);
                                if ("mouseenter" == t.type) {
                                    clearTimeout(this.navOpenTimeoutId), clearTimeout(n.data("navCloseTimeoutId"));
                                    var i = n.siblings(".open");
                                    i.not(this.$navLastOpenDropdown).removeClass("open"), (this.$navLastOpenDropdown = n);
                                    var o = 0 == i.length ? 0 : this.navHoverDelay,
                                        s = setTimeout(
                                            function () {
                                                n.addClass("open").siblings(".open").removeClass("open");
                                                var e = n.children(".small-dropdown:not(.more-links-dropdown)");
                                                if (e.length && n.parent().hasClass("site-nav")) {
                                                    var t = n.offset().left + e.outerWidth(),
                                                        i = "",
                                                        o = this.$container.outerWidth() - 10;
                                                    t > o && (i = "translateX(" + (o - t) + "px)"), e.css("transform", i);
                                                }
                                            }.bind(this),
                                            o
                                        );
                                    (this.navOpenTimeoutId = s), n.data("navOpenTimeoutId", s);
                                } else
                                    clearTimeout(n.data("navOpenTimeoutId")),
                                        n.data(
                                            "navCloseTimeoutId",
                                            setTimeout(function () {
                                                n.removeClass("open").children(".small-dropdown:not(.more-links-dropdown)").css("transform", "");
                                            }, this.navHoverDelay)
                                        );
                                n.children("[aria-expanded]").attr("aria-expanded", "mouseenter" == t.type);
                            }.bind(this)
                        ),
                        e(this.$container).on("keydown" + this.namespace, ".site-nav__item--has-dropdown > .site-nav__link", this.functions.dropdownLinkKeyPress.bind(this)),
                        e(this.$container).on("touchstart" + this.namespace + " touchend" + this.namespace + " click" + this.namespace, ".site-nav__item--has-dropdown > .site-nav__link", function (t) {
                            if ("touchstart" == t.type) e(this).data("touchstartedAt", t.timeStamp);
                            else if ("touchend" == t.type) {
                                if (t.timeStamp - e(this).data("touchstartedAt") < 1e3)
                                    return (
                                        e(this).data("touchOpenTriggeredAt", t.timeStamp),
                                        e(this).parent().hasClass("open") ? e(this).parent().trigger("mouseleave") : (e(".site-nav__item.open").trigger("mouseleave"), e(this).parent().trigger("mouseenter")),
                                        !1
                                    );
                            } else if ("click" == t.type && e(this).data("touchOpenTriggeredAt") && t.timeStamp - e(this).data("touchOpenTriggeredAt") < 1e3) return !1;
                        }),
                        e(this.$container).on("touchstart" + this.namespace, ".customer-account__parent-link", function () {
                            e(this).closest(".customer-account").addClass("customer-account--using-touch");
                        }),
                        e(this.$container).on("click" + this.namespace, ".customer-account__parent-link", this.functions.onAccountIconClick.bind(this)),
                        e(".disclosure", this.$container).each(function () {
                            e(this).data("disclosure", new theme.Disclosure(e(this)));
                        });
                }),
                    (this.functions = {
                        onAccountIconClick: function (t) {
                            if (e(window).width() >= 768) {
                                t.preventDefault();
                                var n = e(t.target).closest(".customer-account").toggleClass("customer-account--reveal-menu").hasClass("customer-account--reveal-menu");
                                e(t.target).closest(".customer-account__parent-link").attr("aria-expanded", n);
                            }
                        },
                        dropdownLinkKeyPress: function (t) {
                            if (13 == t.which) {
                                if (e(t.target).closest(".site-nav__dropdown").length && e(t.target).closest(".more-links").length) e(t.target).trigger("mouseenter");
                                else {
                                    var n = e(t.target).closest(".site-nav__item--has-dropdown").toggleClass("open").hasClass("open");
                                    e(t.target).attr("aria-expanded", n);
                                }
                                return !1;
                            }
                        },
                        setSearchTabbing: function (t) {
                            e(".search-bar", this.$container).each(function () {
                                "none" == e(this).css("pointer-events") ? e(this).find("a, input, button").attr("tabindex", "-1") : e(this).find("a, input, button").removeAttr("tabindex");
                            });
                        },
                        onMoreLinksSubMenuActive: function (t) {
                            this.$navMoreLinksSubmenuContainer.empty();
                            var n = e(t.currentTarget).children(".site-nav__dropdown");
                            if (n.length) {
                                var i = n.clone();
                                i.find(".mega-dropdown__container .one-third").removeClass("one-third").addClass("one-half"),
                                    i.find(".mega-dropdown__container .one-quarter").removeClass("one-quarter").addClass("one-third"),
                                    i.find(".site-nav__promo-container > .three-quarters").removeClass("three-quarters").addClass("two-thirds"),
                                    i.find(".site-nav__promo-container > .one-quarter").removeClass("one-quarter").addClass("one-third"),
                                    i.appendTo(this.$navMoreLinksSubmenuContainer);
                            }
                            var o = this.$navMoreLinksSubmenuContainer.outerHeight() + 30;
                            this.$navMoreLinksSubmenuContainer.parent().css("min-height", o),
                                e(t.currentTarget).removeClass("more-links__parent--inactive").addClass("more-links__parent--active").siblings().removeClass("more-links__parent--active").addClass("more-links__parent--inactive"),
                                e(t.target).attr("aria-expanded", !0),
                                e(t.target).parent().siblings().find("a").attr("aria-expanded", !1);
                        },
                        menuLinkVisibilityCheck: function (t) {
                            var n = this.$nav.width(),
                                i = this.$navMoreLinksLink.width(),
                                o = 0;
                            if (
                                (this.$navLinks.each(function () {
                                    o += e(this).width() + 4;
                                }),
                                o > n)
                            ) {
                                o = i;
                                var s = this.$navMoreLinksContainer.empty();
                                this.$navLinks.each(function () {
                                    (o += e(this).width() + 4) > n
                                        ? (s.append(e(this).clone().removeClass("site-nav__invisible")), e(this).addClass("site-nav__invisible").find("a").attr("tabindex", "-1"))
                                        : e(this).removeClass("site-nav__invisible").find("a").removeAttr("tabindex");
                                }),
                                    this.$navMoreLinksLink.attr("role", "menu"),
                                    this.$navMoreLinksContainer.find("a").removeAttr("tabindex"),
                                    this.$navMoreLinksLink.removeClass("site-nav__invisible"),
                                    this.$navMoreLinksLink.toggleClass("more-links--with-dropdown", this.$navMoreLinksLink.find(".small-dropdown:first, .mega-dropdown:first").length > 0),
                                    this.$navMoreLinksLink.toggleClass("more-links--with-mega-dropdown", this.$navMoreLinksLink.find(".mega-dropdown:first").length > 0),
                                    this.$navMoreLinksContainer.find(".small-dropdown").css("transform", "");
                            } else this.$navLinks.removeClass("site-nav__invisible"), this.$navMoreLinksLink.addClass("site-nav__invisible"), this.$navMoreLinksLink.removeAttr("role"), this.$navMoreLinksContainer.empty();
                        },
                        loginOpen: function (e) {
                            e.preventDefault(), theme.openPageContentInLightbox(theme.routes.account_login_url);
                        },
                        registerOpen: function (e) {
                            e.preventDefault(), theme.openPageContentInLightbox(theme.routes.account_register_url);
                        },
                        searchFormOpen: function (t) {
                            t.preventDefault(),
                                t.stopPropagation(),
                                e("body").addClass("search-bar-open"),
                                e('.search-bar:not(.mobile-menu-search):visible input[name="q"]', this.$container).focus(),
                                this.functions.setSearchTabbing.bind(this)();
                        },
                        searchFormFocus: function (t) {
                            e('.search-bar:visible input[name="q"]', this.$container).focus();
                        },
                        searchFormClose: function (t) {
                            e("body").removeClass("search-bar-open search-bar-in-focus"), this.functions.setSearchTabbing.bind(this)(), t && t.target && e(t.target).closest(".search-bar").prev("a").focus().blur();
                        },
                        searchFocusIn: function (t) {
                            clearTimeout(this.searchFocusOutTimeout), e("body").addClass("search-bar-in-focus");
                        },
                        searchFocusOut: function (t) {
                            this.searchFocusOutTimeout = setTimeout(function () {
                                e("body").removeClass("search-bar-in-focus"), e(".search-bar").removeClass("search-bar--has-results");
                            }, 100);
                        },
                        onFocusTintClick: function (e) {
                            return this.functions.searchFormClose.bind(this)(), !1;
                        },
                        mobileMenuOpen: function (t) {
                            e(".header-navigation", this.$container).addClass("header-navigation--open"), e(document.body, this.$container).addClass("mobile-menu-open");
                        },
                        mobileMenuClose: function (t) {
                            e(".header-navigation", this.$container).removeClass("header-navigation--open"), e(document.body, this.$container).removeClass("mobile-menu-open");
                        },
                        updateSearchResults: function (t) {
                            var n = e(t.target).closest("form"),
                                i = n.closest(".search-bar"),
                                o = n.attr("action") + (n.attr("action").indexOf("?") >= 0 ? "&" : "?") + n.serialize();
                            o != n.data(this.search.searchUrlKey) &&
                                (n.data(this.search.searchUrlKey, o),
                                this.functions._abortSearch.bind(this)(),
                                n.find('input[name="q"]').val().length < 3
                                    ? this.functions._searchResultsHide.bind(this)(i)
                                    : (i.addClass(this.search.resultsLoadingClass),
                                      i.find(this.search.resultsSelector).html('<div class="search-result search-result--loading">' + this.search.loadingMessage + "</div>"),
                                      (this.search.ongoingTimeoutId = setTimeout(this.functions._fetchResults.bind(this, n, o, i), this.search.throttleMs))));
                        },
                        _abortSearch: function () {
                            this.search.ongoingRequest && this.search.ongoingRequest.abort(), clearTimeout(this.search.ongoingTimeoutId);
                        },
                        _fetchResults: function (t, n, i) {
                            var o, s;
                            theme.shopifyFeatures.predictiveSearch
                                ? ((o = theme.routes.search_url + "/suggest.json"), (s = { q: t.find('input[name="q"]').val(), resources: { type: t.find('input[name="type"]').val(), limit: 6, options: { unavailable_products: "last" } } }))
                                : ((o = t.attr("action") + "?" + t.serialize() + "&view=json"), (s = null)),
                                (this.search.ongoingRequest = e
                                    .ajax({ url: o, data: s, dataType: "json", success: this.functions._searchResultsSuccess.bind(this, i, n) })
                                    .fail(
                                        function (e, t) {
                                            console.log("Error fetching results"), console.log(t), this.functions._searchResultsHide.bind(this, e);
                                        }.bind(this, i)
                                    )
                                    .always(
                                        function () {
                                            this.search.ongoingRequest = null;
                                        }.bind(this)
                                    ));
                        },
                        _searchResultsSuccess: function (t, n, i) {
                            t.addClass(this.search.resultsLoadedClass).removeClass(this.search.resultsLoadingClass);
                            var o = e("<div>"),
                                s = t.hasClass("live-search--show-price"),
                                r = t.hasClass("live-search--show-vendor");
                            if (
                                (i.resources.results.products && i.resources.results.products.length > 0) ||
                                (i.resources.results.pages && i.resources.results.pages.length > 0) ||
                                (i.resources.results.articles && i.resources.results.articles.length > 0)
                            ) {
                                if (i.resources.results.products)
                                    for (var a = 0; a < i.resources.results.products.length; a++) {
                                        var l = i.resources.results.products[a],
                                            c = e('<a class="search-result">').attr("href", l.url),
                                            d = e('<div class="search-result__title">').appendTo(c);
                                        if ((e('<div class="search-result__title search-result__title--product">').text(l.title).appendTo(d), r && e('<div class="search-result__vendor">').text(l.vendor).appendTo(d), s)) {
                                            var u = e('<div class="search-result__price product-price">').appendTo(d);
                                            parseFloat(l.price_min) != parseFloat(l.price_max) && u.append(e('<span class="product-price__from">').html(theme.strings.priceFrom)).append(" "),
                                                e('<span class="theme-money">')
                                                    .toggleClass("product-price__reduced", parseFloat(l.compare_at_price_min) > parseFloat(l.price_min))
                                                    .html(theme.Shopify.formatMoney(l.price_min, theme.moneyFormat))
                                                    .appendTo(u),
                                                parseFloat(l.compare_at_price_min) > parseFloat(l.price_min) &&
                                                    u.append(" ").append(e('<span class="product-price__compare theme-money">').html(theme.Shopify.formatMoney(l.compare_at_price_min, theme.moneyFormat)));
                                        }
                                        (p = l.image
                                            ? e('<span class="search-result__image">').append(e('<img role="presentation" alt="">').attr("src", slate.Image.getSizedImageUrl(l.image, "100x100_crop_center")))
                                            : e('<span class="search-result__image">').append(e('<span class="search-result__char">').html(l.title[0]))),
                                            c.prepend(p).appendTo(o);
                                    }
                                if (i.resources.results.articles)
                                    for (a = 0; a < i.resources.results.articles.length; a++)
                                        (l = i.resources.results.articles[a]),
                                            (c = e('<a class="search-result">').attr("href", l.url).append(e('<span class="search-result__title">').text(l.title))),
                                            (p = l.image
                                                ? e('<span class="search-result__image">').append(e('<img role="presentation" alt="">').attr("src", slate.Image.getSizedImageUrl(l.image, "100x100_crop_center")))
                                                : e('<span class="search-result__image">').append(e('<span class="search-result__char">').html(l.title[0]))),
                                            c.prepend(p).appendTo(o);
                                if (i.resources.results.pages)
                                    for (a = 0; a < i.resources.results.pages.length; a++) {
                                        (l = i.resources.results.pages[a]), (c = e('<a class="search-result">').attr("href", l.url).append(e('<span class="search-result__title">').text(l.title)));
                                        var p = e('<span class="search-result__image">').append(e('<span class="search-result__char">').html(l.title[0]));
                                        c.prepend(p).appendTo(o);
                                    }
                                e('<a class="search-result search-result--more">').attr("href", n).html(this.search.moreResultsMessage).appendTo(o);
                            } else o.append('<div class="search-result search-result--empty">' + this.search.emptyMessage + "</div>");
                            t.find(this.search.resultsSelector).html(o);
                        },
                        _searchResultsHide: function (e) {
                            e.removeClass(this.search.resultsLoadedClass).removeClass(this.search.resultsLoadingClass).find(this.search.resultsSelector).empty();
                        },
                        dockedNavCheck: function (t) {
                            var n = e(window).scrollTop(),
                                i = e(window).width() >= theme.dockedNavDesktopMinWidth && n > 0,
                                o = e(window).width() < theme.dockedNavDesktopMinWidth && this.$dockedMobileBaseContainer.offset().top < n;
                            i ? this.$dockedDesktopBaseContainer.css("height", this.$dockedDesktopContentsContainer.outerHeight()) : this.desktopHeaderWasDocked && this.$dockedDesktopBaseContainer.css("height", ""),
                                o ? this.$dockedMobileBaseContainer.css("height", this.$dockedMobileContentsContainer.outerHeight()) : this.mobileHeaderWasDocked && this.$dockedMobileBaseContainer.css("height", ""),
                                this.$container.toggleClass("docked-header--dock", i || o),
                                i != this.desktopHeaderWasDocked && this.functions.menuLinkVisibilityCheck.bind(this)(),
                                (this.desktopHeaderWasDocked = i),
                                (this.mobileHeaderWasDocked = o);
                        },
                        updateDockedNavHeightStyle: function () {
                            var t = theme.dockedNavHeight() + 30;
                            e("#themeDockedNavStyle").html("@media (min-width:768px){.sticky-element{top:" + theme.dockedNavHeight() + "px;} .product-detail__detail.sticky-element{top:" + t + "px;}}");
                        },
                    }),
                    (this.onSectionUnload = function () {
                        this.$container.off(this.namespace),
                            e(".focus-tint").off(this.namespace),
                            e(window).off(this.namespace),
                            e(".js-messages-slider", this.$container).slick("unslick"),
                            e(".js-mobile-messages-slider", this.$container).slick("unslick"),
                            e("#themeDockedNavStyle").remove(),
                            e(".disclosure", this.$container).each(function () {
                                e(this).data("disclosure").unload();
                            });
                    });
            })()),
            (theme.Footer = new (function () {
                (this.onSectionLoad = function (t) {
                    (this.$container = e(t)),
                        (this.namespace = theme.namespaceFromSection(t)),
                        (this.$stickyFooter = e(".sticky-footer", t)),
                        e("body").removeClass("sticky-footer-not-visible sticky-footer-partly-visible sticky-footer-fully-visible sticky-footer-taller-than-page sticky-footer-scrolled-into"),
                        this.$stickyFooter.length
                            ? (this.functions.stickyResize.bind(this)(),
                              this.functions.stickyScroll.bind(this)(),
                              e(window).on("debouncedresize" + this.namespace, this.functions.stickyResize.bind(this)),
                              e(window).on("scroll" + this.namespace, this.functions.stickyScroll.bind(this)))
                            : ((this.$footerInner = this.$container.find(".page-footer__inner ")), this.functions.pushDown.call(this), e(window).on("debouncedresize" + this.namespace, this.functions.pushDown.bind(this))),
                        e(".disclosure", this.$container).each(function () {
                            e(this).data("disclosure", new theme.Disclosure(e(this)));
                        });
                }),
                    (this.functions = {
                        pushDown: function () {
                            var t = e(window).height() - (this.$container.offset().top + this.$footerInner.outerHeight());
                            t > 0 ? this.$container.css("padding-top", t) : this.$container.css("padding-top", "");
                        },
                        stickyScroll: function () {
                            e("body").toggleClass("sticky-footer-scrolled-into", e(window).scrollTop() > this.$container.offset().top);
                        },
                        stickyResize: function () {
                            var t = this.$stickyFooter.outerHeight(),
                                n = this.$container.offset().top,
                                i = n < e(window).height(),
                                o = n + t < e(window).height(),
                                s = t > e(window).height();
                            e("body").toggleClass("sticky-footer-not-visible", !i),
                                e("body").toggleClass("sticky-footer-partly-visible", i && !o),
                                e("body").toggleClass("sticky-footer-fully-visible", o),
                                e("body").toggleClass("sticky-footer-taller-than-page", s),
                                this.$container.css("min-height", t);
                        },
                    }),
                    (this.onSectionUnload = function () {
                        e(window).off(this.namespace),
                            e(".disclosure", this.$container).each(function () {
                                e(this).data("disclosure").unload();
                            });
                    });
            })()),
            (theme.Product = new (function () {
                var t = e.extend({}, theme.variants.selectors, {
                    productJson: "[data-product-json]",
                    productMediaContainer: ".product-detail__images",
                    productMedia: "[data-product-media]",
                    productImages: "[data-product-image]",
                    productMediaThumbnails: "[data-product-media-thumbnail]",
                    singleOptionSelector: "[data-single-option-selector]",
                    skuWrapper: ".sku-wrapper",
                    sku: ".sku-wrapper__sku",
                    styledSelect: ".selector-wrapper select",
                    quantitySelect: ".quantity-proxy",
                    storeAvailability: "[data-store-availability-container]",
                });
                (this.onSectionLoad = function (n) {
                    if (
                        ((this.$container = e(n)),
                        (this.namespace = theme.namespaceFromSection(n)),
                        e(t.storeAvailability, n).length && (this.storeAvailability = new theme.StoreAvailability(e(t.storeAvailability, n)[0])),
                        e(t.productJson, this.$container).html())
                    ) {
                        this.$container.attr("data-section-id"), (this.productSingleObject = JSON.parse(e(t.productJson, this.$container).html()));
                        var i = {
                            $container: this.$container,
                            enableHistoryState: this.$container.data("enable-history-state") || !1,
                            singleOptionSelector: t.singleOptionSelector,
                            originalSelectorId: t.originalSelectorId,
                            secondaryIdSelectors: t.secondaryIdSelectors,
                            product: this.productSingleObject,
                        };
                        (this.settings = {}),
                            (this.settings.imageSize = "master"),
                            (this.variants = new slate.Variants(i)),
                            (this.$productMediaContainer = e(t.productMediaContainer, this.$container)),
                            (this.$productMedia = e(t.productMedia, this.$container)),
                            (this.$productImages = e(t.productImages, this.$container)),
                            (this.$productMediaThumbnails = e(t.productMediaThumbnails, this.$container)),
                            this.$container.on("variantChange" + this.namespace, theme.variants.updateAddToCartState.bind(this)),
                            this.$container.on("variantPriceChange" + this.namespace, theme.variants.updateProductPrices.bind(this)),
                            this.$container.find(t.skuWrapper) && this.$container.on("variantChange" + this.namespace, this.functions.updateSKU.bind(this)),
                            this.$productMediaThumbnails.length
                                ? (this.$productMedia.length > 1 &&
                                      (this.$container.on("click" + this.namespace, t.productMediaThumbnails, this.functions.updatePrimaryProductMediaFromThumbnailClick.bind(this)),
                                      this.$container.on("variantImageChange" + this.namespace, this.functions.updateProductMediaSlideshowFromVariantChange.bind(this))),
                                  this.$container.on("click" + this.namespace, t.productImages, this.functions.openGallery.bind(this)))
                                : (this.$productMedia.length > 1 &&
                                      (this.$container.on("variantImageChange" + this.namespace, this.functions.updateProductMediaColumn.bind(this)),
                                      e(document).on(
                                          "click" + this.namespace + " keydown" + this.namespace,
                                          function () {
                                              this.$productMedia.not(".variant-dim--fixed").removeClass("variant-dim");
                                          }.bind(this)
                                      ),
                                      e(window).on(
                                          "scroll" + this.namespace + " ontouchstart" + this.namespace,
                                          function () {
                                              this.$productMedia.not(".variant-dim--fixed").removeClass("variant-dim");
                                          }.bind(this)
                                      ),
                                      e(window).on("scroll" + this.namespace, this.functions.notifyMediaOfVisibilityInColumn.bind(this)),
                                      this.functions.notifyMediaOfVisibilityInColumn.bind(this)()),
                                  this.$container.on("click" + this.namespace, t.productImages, this.functions.openGallery.bind(this))),
                            (this.mediaSlideshowActive = !1),
                            e(window).on("debouncedresize" + this.namespace, this.functions.assessMediaSlideshow.bind(this)),
                            this.functions.assessMediaSlideshow.bind(this)(),
                            theme.ProductMedia.init(this.$container, {
                                onPlyrInit: function (t) {
                                    var n = e(t.element).closest(".slick-initialized");
                                    n.length && theme.productGallerySlideshowTabFix(n.slick("getSlick").$slides, n.slick("getSlick").currentSlide);
                                },
                                onYoutubeInit: function (t) {
                                    var n = e(t.element).closest(".slick-initialized");
                                    n.length && theme.productGallerySlideshowTabFix(n.slick("getSlick").$slides, n.slick("getSlick").currentSlide);
                                },
                                onModelViewerInit: function (t) {
                                    var n = e(t.element).closest(".slick-initialized");
                                    n.length && theme.productGallerySlideshowTabFix(n.slick("getSlick").$slides, n.slick("getSlick").currentSlide);
                                },
                            }),
                            this.$container.find(".product-media").trigger("mediaVisibleInitial"),
                            theme.styleVariantSelectors(e(t.styledSelect, n), i.product),
                            this.variants.product.variants.length > 1 && e(window).trigger("cc-variant-updated", { variant: this.variants.currentVariant, product: this.productSingleObject }),
                            theme.select2.init(e(t.quantitySelect, n)),
                            this.$container.on("click", ".js-size-chart-open", function (t) {
                                t.preventDefault(), e("body").addClass("size-chart-is-open");
                            }),
                            this.$container.on("click", ".js-size-chart-close", function () {
                                e("body").removeClass("size-chart-is-open");
                            }),
                            theme.initAjaxAddToCartForm(e("form.ajax-product-form", this.$container)),
                            theme.assessRTEImagesOnLoad(this.$container);
                    }
                }),
                    (this.functions = {
                        updateSKU: function (n) {
                            var i = n.variant;
                            i && i.sku
                                ? (e(t.skuWrapper, this.$container).removeClass("sku-wrapper--empty"), e(t.sku, this.$container).html(i.sku))
                                : (e(t.skuWrapper, this.$container).addClass("sku-wrapper--empty"), e(t.sku, this.$container).empty());
                        },
                        notifyMediaOfVisibilityInColumn: function () {
                            var t = e(window).scrollTop(),
                                n = t + e(window).height();
                            e(".product-media", this.$container).each(function () {
                                var i = e(this).offset().top,
                                    o = i + e(this).outerHeight();
                                (i > t && i < n) || (o > t && o < n)
                                    ? e(this).hasClass("product-media--on-screen") ||
                                      (e(this).addClass("product-media--on-screen"), e(this).is(".product-media--model:not(.product-media--model-loaded)") && e(this).trigger("mediaVisibleInitial"))
                                    : e(this).hasClass("product-media--on-screen") && e(this).removeClass("product-media--on-screen").trigger("mediaHidden");
                            });
                        },
                        _updatePrimaryProductMediaFromThumbnail: function (e) {
                            var t = this.$productMedia
                                .filter('[data-media-id="' + e.data("media-id") + '"]')
                                .closest(".slick-slide")
                                .data("slick-index");
                            this.$productMediaContainer.slick("slickGoTo", t);
                        },
                        updatePrimaryProductMediaFromThumbnailClick: function (t) {
                            t.preventDefault(), this.functions._updatePrimaryProductMediaFromThumbnail.bind(this)(e(t.currentTarget));
                        },
                        updateProductMediaSlideshowFromVariantChange: function (t) {
                            var n = t.variant,
                                i = this.$productMedia.filter(function () {
                                    return e(this).data("media-id") == n.featured_media.id;
                                });
                            1 == i.length && this.functions._updatePrimaryProductMediaFromThumbnail.bind(this)(i);
                        },
                        updateProductMediaColumn: function (t) {
                            var n = t.variant,
                                i = this.$productMedia.filter(function () {
                                    return e(this).data("media-id") == n.featured_media.id;
                                });
                            1 == i.length &&
                                (this.$productMediaContainer.hasClass("slick-slider")
                                    ? this.functions._updatePrimaryProductMediaFromThumbnail.bind(this)(i)
                                    : (clearTimeout(this.variantScrollTimeoutId),
                                      (this.variantScrollTimeoutId = setTimeout(
                                          function () {
                                              var t = i.offset().top - theme.dockedNavHeight(),
                                                  n = i.closest(".product-detail"),
                                                  o = n.offset().top + n.height() - n.find(".product-detail__detail").outerHeight() - 20;
                                              e("html,body").animate(
                                                  { scrollTop: Math.min(t, o) },
                                                  500,
                                                  function () {
                                                      i.removeClass("variant-dim"),
                                                          this.$productImages.not(i).addClass("variant-dim variant-dim--fixed"),
                                                          setTimeout(function () {
                                                              e(".variant-dim--fixed").removeClass("variant-dim--fixed");
                                                          }, 500);
                                                  }.bind(this)
                                              );
                                          }.bind(this),
                                          25
                                      ))));
                        },
                        assessMediaSlideshow: function (t) {
                            var n = e(window).width(),
                                i = !1;
                            if ((this.$productMediaContainer.children().length > 1 && (i = !0), n < 768 || e(".product-detail__thumbnails").length)) {
                                if (!this.mediaSlideshowActive) {
                                    var o,
                                        s = this.$productMediaContainer.data("featured-media-id");
                                    this.$productMediaContainer.data("featured-media-id", null),
                                        (o = this.$productMediaContainer
                                            .find('[data-media-id="' + s + '"]')
                                            .parent()
                                            .index());
                                    var r = this.$productMediaContainer.slick({
                                        infinite: !1,
                                        fade: !0,
                                        arrows: !1,
                                        dots: !1,
                                        adaptiveHeight: !0,
                                        prevArrow: theme.icons.slideshowPrevArrow,
                                        nextArrow: theme.icons.slideshowNextArrow,
                                        appendArrows: e(".slick-external-controls .slick-arrows", this.$container),
                                        appendDots: e(".slick-external-controls .slick-dots", this.$container),
                                        initialSlide: o,
                                        responsive: [{ breakpoint: 767, settings: { fade: !1, arrows: !0, dots: i } }],
                                    });
                                    r.find(".product-media").trigger("mediaVisibleInitial"),
                                        r.on("afterChange", function (t, n, i) {
                                            var o = e(".product-media", n.$slides[i]);
                                            e(".product-media").not(o).trigger("mediaHidden"), o.trigger("mediaVisible");
                                            var s = e("[data-product-image]", n.$slides[i]);
                                            e('.product-detail__thumbnail[data-media-id="' + s.data("media-id") + '"]')
                                                .addClass("thumb-active")
                                                .siblings()
                                                .removeClass("thumb-active"),
                                                theme.productGallerySlideshowTabFix(n.$slides, i),
                                                e(this).closest(".quickbuy-container").trigger("changedsize");
                                        }),
                                        theme.productGallerySlideshowTabFix(r.slick("getSlick").$slides, r.slick("getSlick").currentSlide),
                                        (this.mediaSlideshowActive = !0);
                                }
                            } else this.mediaSlideshowActive && (this.$productMediaContainer.slick("unslick"), (this.mediaSlideshowActive = !1));
                        },
                        openGallery: function (t) {
                            t.preventDefault();
                            var n = document.querySelectorAll(".pswp")[0],
                                i = [];
                            this.$productImages.each(function (t) {
                                e(this).data("image-index", t);
                                var n = { src: e(this).attr("href"), w: e(this).data("image-w"), h: e(this).data("image-h") },
                                    o = e(this).find("img")[0];
                                void 0 !== o.currentSrc && (n.msrc = o.currentSrc), i.push(n);
                            });
                            var o = { history: !1, captionEl: !1, shareEl: !1, fullscreenEl: !1 };
                            (o.index = e(t.target).closest("a").data("image-index")),
                                (o.getThumbBoundsFn = function (e) {
                                    var t = this.$productImages[e].getElementsByTagName("img")[0],
                                        n = window.pageYOffset || document.documentElement.scrollTop,
                                        i = t.getBoundingClientRect();
                                    return { x: i.left, y: i.top + n, w: i.width };
                                }.bind(this)),
                                (this.imageGallery = new PhotoSwipe(n, PhotoSwipeUI_Default, i, o)),
                                this.imageGallery.init(),
                                this.imageGallery.listen(
                                    "destroy",
                                    function () {
                                        this.imageGallery = null;
                                    }.bind(this)
                                );
                            var s = this;
                            this.imageGallery.listen("afterChange", function () {
                                var t = this.currItem.src,
                                    n = s.$productImages.filter(function () {
                                        return e(this).attr("href") == t;
                                    });
                                s.functions._updatePrimaryProductMediaFromThumbnail.bind(s)(n);
                            });
                        },
                    }),
                    (this.onSectionUnload = function () {
                        this.$container.off(this.namespace),
                            e(document).off(this.namespace),
                            e(window).off(this.namespace),
                            this.imageGallery && this.imageGallery.close(),
                            this.storeAvailability && this.storeAvailability.onSectionUnload(),
                            theme.ProductMedia.destroy(this.$container),
                            this.$container.find(".slick-initialized").slick("unslick").off("afterChange"),
                            this.$container.find(".clickybox-replaced").clickyBoxes("destroy"),
                            theme.unloadAjaxAddToCartForm(e("form.ajax-product-form", this.$container));
                    });
            })()),
            (theme.Blog = new (function () {
                (this.onSectionLoad = function (t) {
                    (this.$container = e(t)),
                        (this.namespace = theme.namespaceFromSection(t)),
                        (this.$header = e(".featured-blog__header, .blog-featured-image", this.$container)),
                        (this.$headerImage = e(".featured-blog__header-image, .blog-image", this.$container)),
                        e(".js-content-products-slider .grid", this.$container).each(
                            function (t, n) {
                                theme.peekCarousel.init(
                                    this.$container,
                                    e(n),
                                    this.namespace,
                                    function () {
                                        return !0;
                                    },
                                    !1,
                                    {
                                        infinite: !1,
                                        slidesToShow: 3,
                                        slidesToScroll: 1,
                                        swipeToSlide: !0,
                                        dots: !1,
                                        prevArrow: e(n).closest(".content-products").find(".content-products-controls .prev"),
                                        nextArrow: e(n).closest(".content-products").find(".content-products-controls .next"),
                                        responsive: [{ breakpoint: e(".single-column-layout", this.$container).length ? 768 : 960, settings: { slidesToShow: 1 } }],
                                    }
                                ),
                                    theme.initUniformHeightMonitor(e(n), ".product-block__image-container", ".product-block__image-container .image-one");
                            }.bind(this)
                        ),
                        this.functions.assessSection.bind(this)(),
                        e(window).on("debouncedresize" + this.namespace, this.functions.assessSection.bind(this));
                }),
                    (this.functions = {
                        assessSection: function (t) {
                            if (e(window).width() < 768) this.$headerImage.css("height", "");
                            else {
                                var n = parseInt(this.$header.css("padding-top"));
                                this.$headerImage.css("height", e(window).height() - 2 * n - theme.dockedNavHeight());
                            }
                        },
                    }),
                    (this.onSectionUnload = function (t) {
                        this.$container.off(this.namespace),
                            e(window).off(this.namespace),
                            theme.destroyUniformHeightMonitor(e(".js-content-products-slider .grid", this.$container)),
                            theme.peekCarousel.destroy(this.$container, e(".js-content-products-slider .grid", this.$container), this.namespace);
                    });
            })()),
            (theme.Article = new (function () {
                var t = ".js-content-products-slider .grid";
                (this.onSectionLoad = function (n) {
                    (this.$container = e(n)),
                        (this.namespace = theme.namespaceFromSection(n)),
                        e(".template-article .rte").width(),
                        e(t, this.$container).each(
                            function (t, n) {
                                theme.peekCarousel.init(
                                    this.$container,
                                    e(n),
                                    this.namespace,
                                    function () {
                                        return !0;
                                    },
                                    !1,
                                    {
                                        infinite: !1,
                                        slidesToShow: 3,
                                        slidesToScroll: 1,
                                        swipeToSlide: !0,
                                        dots: !1,
                                        prevArrow: e(n).closest(".content-products").find(".content-products-controls .prev"),
                                        nextArrow: e(n).closest(".content-products").find(".content-products-controls .next"),
                                        responsive: [{ breakpoint: e(".single-column-layout", this.$container).length ? 768 : 960, settings: { slidesToShow: 1 } }],
                                    }
                                ),
                                    theme.initUniformHeightMonitor(e(n), ".product-block__image-container", ".product-block__image-container .image-one");
                            }.bind(this)
                        ),
                        theme.assessRTEImagesOnLoad(this.$container);
                }),
                    (this.onSectionUnload = function () {
                        this.$container.off(this.namespace), e(window).off(this.namespace), theme.destroyUniformHeightMonitor(e(t, this.$container)), theme.peekCarousel.destroy(this.$container, e(t, this.$container), this.namespace);
                    });
            })()),
            (theme.Slideshow = new (function () {
                (this.onSectionLoad = function (t) {
                    (this.$container = e(t)), (this.namespace = theme.namespaceFromSection(t)), (this.$slideshow = e(".js-slideshow-section", this.$container));
                    var n = !1;
                    this.$slideshow.children().length > 1 && (n = !0),
                        this.$slideshow.slick({
                            infinite: !0,
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            dots: n,
                            adaptiveHeight: !1,
                            autoplay: this.$slideshow.data("autoplay"),
                            autoplaySpeed: this.$slideshow.data("autoplayspeed"),
                            prevArrow: e(".full-width-slideshow-controls .prev", this.$container),
                            nextArrow: e(".full-width-slideshow-controls .next", this.$container),
                            pauseOnHover: !1,
                            responsive: [{ breakpoint: 768, settings: { appendDots: e(".full-width-slideshow .slide .overlay") } }],
                        });
                    var i = "slick-active",
                        o = "aria-hidden";
                    e(".js-slideshow-section")
                        .on("init", function () {
                            e(".slick-dots li:first-of-type").addClass(i).attr(o, !1);
                        })
                        .on("afterChange", function (t, n, s) {
                            var r = e(".slick-dots");
                            e("li", r).removeClass(i).attr(o, !0),
                                r.each(function () {
                                    e("li", e(this)).eq(s).addClass(i).attr(o, !1);
                                });
                        }),
                        e(window).on("debouncedresize" + this.namespace, this.functions.onResize.bind(this)),
                        theme.checkOverlaps && theme.checkOverlaps();
                }),
                    (this.functions = {
                        onResize: function (e) {
                            this.$slideshow.slick("setPosition");
                        },
                    }),
                    (this.onBlockSelect = function (t) {
                        this.$slideshow.slick("slickGoTo", e(t).data("slick-index"), !0).slick("slickPause");
                    }),
                    (this.onBlockDeselect = function (e) {
                        this.$slideshow.slick("slickPlay");
                    }),
                    (this.onSectionUnload = function () {
                        this.$container.off(this.namespace), e(window).off(this.namespace), this.$slideshow.slick("unslick");
                    });
            })()),
            (theme.Banner = new (function () {
                (this.onSectionLoad = theme.Slideshow.onSectionLoad),
                    (this.onSectionUnload = theme.Slideshow.onSectionUnload),
                    (this.onBlockSelect = theme.Slideshow.onBlockSelect),
                    (this.onBlockDeselect = theme.Slideshow.onBlockDeselect),
                    (this.functions = theme.Slideshow.functions);
            })()),
            (theme.StandoutCollection = new (function () {
                (this.onSectionLoad = function (t) {
                    (this.$container = e(t)),
                        (this.namespace = theme.namespaceFromSection(t)),
                        theme.peekCarousel.init(
                            this.$container,
                            e(".js-standout-collection-slider", this.$container),
                            this.namespace,
                            function () {
                                return !0;
                            },
                            !1,
                            {
                                infinite: !1,
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                dots: !1,
                                prevArrow: e(".standout-collection-slider__controls .prev", this.$container),
                                nextArrow: e(".standout-collection-slider__controls .next", this.$container),
                            }
                        );
                }),
                    (this.onSectionUnload = function () {
                        this.$container.off(this.namespace), theme.peekCarousel.destroy(this.$container, e(".js-standout-collection-slider", this.$container), this.namespace);
                    });
            })()),
            (theme.GetTheLook = new (function () {
                (this.onSectionLoad = function (t) {
                    (this.$container = e(t)),
                        (this.namespace = theme.namespaceFromSection(t)),
                        (this.$header = e(".get-the-look__image-container", this.$container)),
                        (this.$headerImage = e(".get-the-look__image-container .placeholder-svg, .get-the-look__image-container .rimage-background", this.$container)),
                        (this.$slideshow = e(".js-get-the-look-slider", this.$container)),
                        (this.$firstProduct = e(".get-the-look__product:first", this.$container)),
                        theme.peekCarousel.init(
                            this.$container,
                            this.$slideshow,
                            this.namespace,
                            function () {
                                return this.$firstProduct.length && 0 == parseInt(this.$firstProduct.css("margin-right"));
                            }.bind(this)
                        ),
                        this.functions.assessSection.bind(this)(),
                        e(window).on("debouncedresize" + this.namespace, this.functions.assessSection.bind(this));
                }),
                    (this.functions = {
                        assessSection: function (t) {
                            if (this.$firstProduct.length && 0 == parseInt(this.$firstProduct.css("margin-right"))) this.$headerImage.css("height", "");
                            else {
                                var n = parseInt(this.$header.css("margin-top"));
                                this.$headerImage.css("height", e(window).height() - 2 * n - theme.dockedNavHeight());
                            }
                        },
                    }),
                    (this.onSectionUnload = function () {
                        this.$container.off(this.namespace), e(window).off(this.namespace), theme.peekCarousel.destroy(this.$container, this.$slideshow, this.namespace);
                    });
            })()),
            (theme.PromotionalImages = new (function () {
                (this.onSectionLoad = function (t) {
                    (this.$container = e(t)), (this.namespace = theme.namespaceFromSection(t)), e(this.functions.assessSection.call(this)), e(window).on("debouncedresize" + this.namespace, this.functions.assessSection.bind(this));
                }),
                    (this.functions = {
                        assessSection: function (t) {
                            e(window).width() >= 768
                                ? e(".promotional-row").each(function () {
                                      var t = 0;
                                      e(this)
                                          .find(".text_over_image .promotional-row__content")
                                          .each(function () {
                                              var n = e(this).outerHeight() + 60;
                                              n > t && (t = n);
                                          }),
                                          e(this).find(".text_over_image").css("min-height", t);
                                  })
                                : e(".promotional-row .text_over_image").css("min-height", "");
                        },
                    }),
                    (this.onSectionUnload = function () {
                        this.$container.off(this.namespace), e(window).off(this.namespace);
                    });
            })()),
            (theme.FeaturedCollection = new (function () {
                (this.onSectionLoad = function (t) {
                    (this.$container = e(t)),
                        (this.namespace = theme.namespaceFromSection(t)),
                        (this.$slideshow = e("[data-carousel-enabled]", this.$container)),
                        this.$slideshow.each(
                            function (t, n) {
                                theme.peekCarousel.init(
                                    this.$container,
                                    e(n),
                                    this.namespace,
                                    function () {
                                        return !0;
                                    },
                                    !1,
                                    {
                                        infinite: !1,
                                        slidesToShow: this.$slideshow.data("slides-per-row"),
                                        slidesToScroll: 1,
                                        swipeToSlide: !0,
                                        dots: !1,
                                        prevArrow: e(".featured-collection-controls .prev", this.$container),
                                        nextArrow: e(".featured-collection-controls .next", this.$container),
                                        responsive: [{ breakpoint: 768, settings: { slidesToShow: 1, nextArrow: !1, prevArrow: !1 } }],
                                    }
                                );
                            }.bind(this)
                        ),
                        theme.initUniformHeightMonitor(this.$container, ".product-block__image-container", ".product-block__image-container .image-one");
                }),
                    (this.onSectionUnload = function () {
                        this.$container.off(this.namespace), theme.destroyUniformHeightMonitor(this.$container), theme.peekCarousel.destroy(this.$container, this.$slideshow, this.namespace);
                    });
            })()),
            (theme.TabsProducts = new (function () {
                (this.onSectionLoad = function (t) {
                    (this.$container = e(t)),
                        (this.namespace = theme.namespaceFromSection(t)),
                        (this.$slideshow = e("[data-carousel-enabled]", this.$container)),
                        console.log(this.$slideshow, e(".featured-collection-controls .prev", this.$tab), e(".featured-collection-controls .next", this.$tab)),
                        this.$slideshow.each(
                            function (t, n) {
                                const i = n.dataset.blockId,
                                    o = document.querySelector('[data-block-id="' + i + '"].featured-collection-controls .prev'),
                                    s = document.querySelector('[data-block-id="' + i + '"].featured-collection-controls .next');
                                console.log(n, i, o, s),
                                    theme.peekCarousel.init(
                                        this.$container,
                                        e(n),
                                        this.namespace,
                                        function () {
                                            return !0;
                                        },
                                        !1,
                                        {
                                            infinite: !1,
                                            slidesToShow: this.$slideshow.data("slides-per-row"),
                                            rows: this.$slideshow.data("row-count"),
                                            slidesToScroll: 1,
                                            swipeToSlide: !0,
                                            dots: !1,
                                            prevArrow: o,
                                            nextArrow: s,
                                            responsive: [{ breakpoint: 768, settings: { slidesToShow: 1, nextArrow: !1, prevArrow: !1 } }],
                                        }
                                    );
                            }.bind(this)
                        ),
                        theme.initUniformHeightMonitor(this.$container, ".product-block__image-container", ".product-block__image-container .image-one");
                        theme.initUniformHeightMonitor(this.$container, ".product-block__title", ".product-block__title");
                        theme.initUniformHeightMonitor(this.$container, ".product-price", ".product-price");
                }),
                    (this.onSectionUnload = function () {
                        this.$container.off(this.namespace), theme.destroyUniformHeightMonitor(this.$container), theme.peekCarousel.destroy(this.$container, this.$slideshow, this.namespace);
                    });
            })()),
            (theme.ListCollections = new (function () {
                (this.onSectionLoad = function (t) {
                    (this.$container = e(t)),
                        (this.namespace = theme.namespaceFromSection(t)),
                        theme.assessRTEImagesOnLoad(this.$container),
                        e(".js-list-collection-slider", this.$container).each(
                            function (t, n) {
                                theme.peekCarousel.init(
                                    this.$container,
                                    e(n),
                                    this.namespace,
                                    function () {
                                        return !0;
                                    },
                                    !1,
                                    {
                                        infinite: !0,
                                        slidesToShow: 1,
                                        slidesToScroll: 1,
                                        dots: !1,
                                        prevArrow: e(n).siblings(".standout-collection-slider__controls").children(".prev"),
                                        nextArrow: e(n).siblings(".standout-collection-slider__controls").children(".next"),
                                        responsive: [{ breakpoint: 768, settings: { slidesToShow: 1 } }],
                                    }
                                );
                            }.bind(this)
                        );
                }),
                    (this.onSectionUnload = function () {
                        this.$container.off(this.namespace), theme.peekCarousel.destroy(this.$container, e(".js-list-collection-slider", this.$container), this.namespace);
                    });
            })()),
            (theme.CollectionTemplate = new (function () {
                (this.onSectionLoad = function () {
                    (this.productList = document.querySelector(".cc-product-list")), theme.initUniformHeightMonitor(this.productList, ".product-block__image-container", ".product-block__image-container .image-one");
                }),
                    (this.onSectionUnload = function () {
                        theme.destroyUniformHeightMonitor(this.productList);
                    });
            })()),
            (theme.Cart = new (function () {
                (this.onSectionLoad = function (t) {
                    if (
                        ((this.$container = e(t)),
                        (this.namespace = theme.namespaceFromSection(t)),
                        this.$container.on("click" + this.namespace, ".js-shipping-calculator-trigger", function () {
                            var t = e(this),
                                n = t.parents(".shipping-calculator-container");
                            n.toggleClass("calculator-open"),
                                n.hasClass("calculator-open")
                                    ? (t.html(theme.strings.cart_shipping_calculator_hide_calculator), n.children(".shipping-calculator").slideDown(250))
                                    : (t.html(theme.strings.cart_shipping_calculator_title), n.children(".shipping-calculator").slideUp(250));
                        }),
                        this.$container.on("click" + this.namespace, ".js-cart-notes-trigger", function () {
                            var t = e(this),
                                n = t.parent(".cart-notes-container");
                            n.toggleClass("notes-open"),
                                n.hasClass("notes-open") ? (t.html(theme.strings.cart_general_hide_note), n.children(".cart-notes").slideDown(250)) : (t.html(theme.strings.cart_general_show_note), n.children(".cart-notes").slideUp(250));
                        }),
                        theme.cartNoteMonitor.load(e('.cart-notes [name="note"]', this.$container)),
                        this.$container.data("ajax-update"))
                    ) {
                        var n = this.functions.updateCart.bind(this);
                        this.$container.on("keyup" + this.namespace + " change" + this.namespace, ".quantity__change input", function () {
                            if ((!e(this).data("initial-value") || e(this).data("initial-value") != e(this).val()) && 0 != e(this).val().length && "0" != e(this).val()) {
                                var t = e(this).attr("id");
                                n({ line: e(this).data("line"), quantity: e(this).val() }, function () {
                                    e("#" + t).focus();
                                }),
                                    e(this).data("previousValue", e(this).val());
                            }
                        }),
                            this.$container.on("click" + this.namespace, ".quantity__minus, .quantity__plus", function (t) {
                                var n = e(this).closest(".quantity__change").find(".quantity__number");
                                return e(this).hasClass("quantity__minus") ? n.val(parseInt(n.val()) - 1).trigger("change") : n.val(parseInt(n.val()) + 1).trigger("change"), !1;
                            });
                    }
                    this.$container
                        .on("focusin" + this.namespace + " click" + this.namespace, "input.quantity__number", function () {
                            e(this).select();
                        })
                        .on("mouseup" + this.namespace, "input.quantity__number", function (e) {
                            e.preventDefault();
                        }),
                        e("#terms", t).length > 0 &&
                            e(document).on("click" + this.namespace, '[name="checkout"], a[href*="/checkout"]', function () {
                                if (0 == e("#terms:checked").length) return alert(theme.strings.cartTermsNotChecked), !1;
                            }),
                        (this.$recentlyViewed = e(".recently-viewed", this.$container)),
                        this.$recentlyViewed.length && (this.functions.loadRecentlyViewed.bind(this)(), theme.loadRecentlyViewed(this.$recentlyViewed));
                }),
                    (this.functions = {
                        loadRecentlyViewed: function (e) {
                            if (theme.storageAvailable("localStorage")) {
                                var t = theme.getRecentProducts();
                                if (t.length) {
                                    var n = this.$recentlyViewed.data("exclude"),
                                        i = [];
                                    n.length && (i = n.split(","));
                                    for (var o = this.$recentlyViewed.find(".grid"), s = 0, r = 0, a = this.$recentlyViewed.data("show-vendor"), l = this.$recentlyViewed.data("show-hover-image"); s < 6 && r < t.length; ) {
                                        for (var c = !0, d = 0; d < i.length; d++)
                                            if (t[r].handle == i[d]) {
                                                c = !1;
                                                break;
                                            }
                                        c && (s++, theme.addRecentProduct(t, r, o, l, a)), r++;
                                    }
                                    s > 0 && this.$recentlyViewed.removeClass("hidden");
                                }
                            }
                        },
                        updateCart: function (t, n) {
                            var i = this;
                            i.cartXhr && i.cartXhr.abort(),
                                i.cartRefreshXhr && i.cartRefreshXhr.abort(),
                                (i.cartXhr = e.ajax({
                                    type: "POST",
                                    url: theme.routes.cart_change_url + ".js",
                                    data: t,
                                    dataType: "json",
                                    success: function (t) {
                                        i.cartRefreshXhr && i.cartRefreshXhr.abort(),
                                            (i.cartRefreshXhr = e.ajax({
                                                type: "GET",
                                                url: theme.routes.cart_url + "?sections=main-cart",
                                                success: function (e) {
                                                    var t = [".cart-items", ".subtotal-row"],
                                                        n = $(e["main-cart"]);
                                                    if ((n.find(".fade-in").removeClass("fade-in"), "undefined" != typeof gift_product && gift_product.available)) {
                                                        var i = parseInt(n.find(".cart").data("cart-total"));
                                                        cartPageGiftUpdate(n, t, i);
                                                    } else for (var o = 0; o < t.length; o++) $('[data-section-type="cart"] ' + t[o]).html(n.find(t[o]).html());
                                                },
                                                error: function (e) {
                                                    "abort" != e.statusText && (console.log("Error refreshing page"), console.log(e));
                                                },
                                                complete: function () {
                                                    i.cartRefreshXhr = null;
                                                },
                                            }));
                                    },
                                    error: function (e) {
                                        console.log("Error processing update"), console.log(e);
                                    },
                                }));
                        },
                    }),
                    (this.onSectionUnload = function () {
                        this.$container.off(this.namespace),
                            e(document).off(this.namespace),
                            this.$recentlyViewed.length && theme.unloadRecentlyViewed(this.$recentlyViewed),
                            theme.cartNoteMonitor.unload(e('.cart-notes [name="note"]', this.$container));
                    });
            })()),
            (theme.ImageWithText = new (function () {
                (this.onSectionLoad = function (t) {
                    function n(e) {
                        var t = this.$image.height() / this.$image.width(),
                            n = this.$imageContainer.outerWidth() * t;
                        this.$imageContainer.toggleClass("image-with-text__image--inset", n < this.$text.outerHeight());
                    }
                    (this.namespace = theme.namespaceFromSection(t)),
                        (this.$container = e(t)),
                        (this.$imageContainer = e(".image-with-text__image", t)),
                        (this.$image = e(".image-with-text__image .rimage__image", t)),
                        (this.$text = e(".image-with-text__content", t)),
                        e(window).on("debouncedresize" + this.namespace, n.bind(this)),
                        e(n.call(this));
                }),
                    (this.onSectionUnload = function () {
                        e(window).off(this.namespace);
                    });
            })()),
            (theme.FeaturedProduct = new (function () {
                (this.onSectionLoad = function (t) {
                    (this.namespace = theme.namespaceFromSection(t)),
                        (this.$container = e(t)),
                        (this.$row = e(".featured-product-section", t)),
                        (this.$imageOuterContainer = e(".featured-product-image", t)),
                        (this.$mediaContainer = e(".featured-product-image-link, .product-media-wrapper", t)),
                        (this.$media = e(".product-media", t)),
                        this.$media.length && theme.ProductMedia.init(this.$container),
                        e(window).on("debouncedresize" + this.namespace, this.functions.assessInset.bind(this)),
                        e(this.functions.assessInset.call(this));
                }),
                    (this.functions = {
                        assessInset: function (e) {
                            var t = this.$mediaContainer.height() / this.$mediaContainer.width(),
                                n = Math.round(this.$imageOuterContainer.outerWidth() * t);
                            this.$imageOuterContainer.toggleClass("featured-product-image--inset", n < this.$row.height());
                        },
                    }),
                    (this.onSectionUnload = function () {
                        this.$media.length && theme.ProductMedia.destroy(this.$container), e(window).off(this.namespace);
                    });
            })()),
            (theme.RecentlyViewed = new (function () {
                (this.onSectionLoad = function (t) {
                    (this.$container = e(t)),
                        (this.namespace = theme.namespaceFromSection(t)),
                        (this.$recentlyViewed = e(".recently-viewed", this.$container)),
                        this.$recentlyViewed.length && (this.functions.loadRecentlyViewed.bind(this)(), theme.loadRecentlyViewed(this.$recentlyViewed));
                }),
                    (this.functions = {
                        loadRecentlyViewed: function (e) {
                            if (theme.storageAvailable("localStorage")) {
                                var t = {
                                    handle: this.$recentlyViewed.data("handle"),
                                    url: this.$recentlyViewed.data("url").split("?")[0],
                                    title: this.$recentlyViewed.data("title"),
                                    vendor: this.$recentlyViewed.data("vendor"),
                                    available: this.$recentlyViewed.data("available"),
                                    image: this.$recentlyViewed.data("image"),
                                    image2: this.$recentlyViewed.data("image2"),
                                    price: this.$recentlyViewed.data("price"),
                                    priceVaries: this.$recentlyViewed.data("price-varies"),
                                    compareAtPrice: this.$recentlyViewed.data("price-compare"),
                                };
                                this.$recentlyViewed.data("unit-price-price") && ((t.unitPrice = this.$recentlyViewed.data("unit-price-price")), (t.unitPriceUnit = this.$recentlyViewed.data("unit-price-unit")));
                                var n = theme.addToAndReturnRecentProducts(t);
                                if (n.length > 1)
                                    for (
                                        var i = this.$recentlyViewed.removeClass("hidden").find(".grid"),
                                            o = this.$recentlyViewed.data("show-vendor"),
                                            s = this.$recentlyViewed.data("show-hover-image"),
                                            r = Math.max(0, n.length - 6 - 1),
                                            a = n.length - 1,
                                            l = r;
                                        l < a;
                                        l++
                                    )
                                        theme.addRecentProduct(n, l, i, s, o);
                            }
                        },
                    }),
                    (this.onSectionUnload = function () {
                        this.$recentlyViewed.length && theme.unloadRecentlyViewed(this.$recentlyViewed);
                    });
            })()),
            (theme.SearchTemplate = new (function () {
                (this.onSectionLoad = function (t) {
                    (this.$container = e(t)),
                        (this.namespace = theme.namespaceFromSection(t)),
                        (this.$productsContainer = e(".search-results-list", t)),
                        theme.initUniformHeightMonitor(this.$productsContainer, ".product-block__image-container", ".product-block__image-container .image-one");
                }),
                    (this.onSectionUnload = function () {
                        this.$container.off(this.namespace), e(window).off(this.namespace), theme.destroyUniformHeightMonitor(this.$productsContainer);
                    });
            })()),
            (theme.Testimonials = new (function () {
                (this.onSectionLoad = function (t) {
                    (this.$container = e(t)), (this.namespace = theme.namespaceFromSection(t)), (this.$slideshow = e(".js-testimonials-section", this.$container));
                    var n = !1;
                    if ((this.$slideshow.children().length > 2 && (n = !0), this.$slideshow.children().length > 1)) var i = !0;
                    this.$slideshow.slick({
                        infinite: !0,
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        dots: n,
                        adaptiveHeight: !1,
                        autoplay: this.$slideshow.data("autoplay"),
                        autoplaySpeed: this.$slideshow.data("autoplayspeed"),
                        arrows: !1,
                        responsive: [{ breakpoint: 768, settings: { slidesToShow: 1, dots: i } }],
                    }),
                        e(window).on("debouncedresize" + this.namespace, this.functions.onResize.bind(this));
                }),
                    (this.functions = {
                        onResize: function (e) {
                            this.$slideshow.slick("setPosition");
                        },
                    }),
                    (this.onBlockSelect = function (t) {
                        this.$slideshow.slick("slickGoTo", e(t).data("slick-index"), !0).slick("slickPause");
                    }),
                    (this.onBlockDeselect = function (e) {
                        this.$slideshow.slick("slickPlay");
                    }),
                    (this.onSectionUnload = function () {
                        this.$container.off(this.namespace), e(window).off(this.namespace), this.$slideshow.slick("unslick");
                    });
            })()),
            (theme.Gallery = new (function () {
                (this.onSectionLoad = function (t) {
                    if (((this.$container = e(t)), (this.namespace = theme.namespaceFromSection(t)), ($slideshow = e(".gallery--mobile-carousel", this.$container)), $slideshow.length)) {
                        var n = function () {
                            var t = $slideshow.hasClass("slick-slider"),
                                n = e(window).width() < 768;
                            if ((n || e(".lazyload--manual", $slideshow).removeClass("lazyload--manual").addClass("lazyload"), t && !n)) {
                                $slideshow.slick("unslick").off("init"), $slideshow.find("a, .gallery__item").removeAttr("tabindex").removeAttr("role");
                                var i = $slideshow.data("grid"),
                                    o = null;
                                $slideshow.find(".gallery__item").each(function (t) {
                                    t % i == 0 && (o = e('<div class="gallery__row">').appendTo($slideshow)), e(this).appendTo(o);
                                });
                            } else
                                !t &&
                                    n &&
                                    ($slideshow.find(".gallery__item").appendTo($slideshow),
                                    $slideshow.find(".gallery__row").remove(),
                                    $slideshow
                                        .on("init", function () {
                                            e(".lazyload--manual", this).removeClass("lazyload--manual").addClass("lazyload");
                                        })
                                        .slick({
                                            autoplay: !1,
                                            fade: !1,
                                            infinite: !0,
                                            useTransform: !0,
                                            dots: !0,
                                            prevArrow: e(".gallery-slideshow-controls .prev", this.$container),
                                            nextArrow: e(".gallery-slideshow-controls .next", this.$container),
                                        }));
                        };
                        n(), e(window).on("debouncedresize.themeSection" + this.$container, n);
                    }
                }),
                    (this.onSectionUnload = function () {
                        this.$container.off(this.namespace),
                            e(window).off(this.namespace),
                            e(".slick-slider", this.$container).each(function () {
                                e(this).slick("unslick").off("init");
                            });
                    }),
                    (this.onBlockSelect = function (t) {
                        e(t)
                            .closest(".slick-slider")
                            .each(function () {
                                e(this).slick("slickGoTo", e(this).data("slick-index")).slick("slickPause");
                            });
                    }),
                    (this.onBlockDeselect = function (t) {
                        e(t)
                            .closest(".slick-slider")
                            .each(function () {
                                e(this).slick("slickPlay");
                            });
                    });
            })()),
            (theme._initCustomerAddressCountryDropdown = function () {
                new Shopify.CountryProvinceSelector("AddressCountryNew", "AddressProvinceNew", { hideElement: "AddressProvinceContainerNew" }),
                    e("#AddressCountryNew-modal").length && new Shopify.CountryProvinceSelector("AddressCountryNew-modal", "AddressProvinceNew-modal", { hideElement: "AddressProvinceContainerNew-modal" }),
                    e(".address-country-option").each(function () {
                        var t = e(this).data("form-id"),
                            n = "AddressCountry_" + t,
                            i = "AddressProvince_" + t,
                            o = "AddressProvinceContainer_" + t;
                        new Shopify.CountryProvinceSelector(n, i, { hideElement: o });
                    });
            }),
            (theme._setupCustomAddressModal = function () {
                var t = "-modal";
                e(".lightbox-content form, .lightbox-content input[id], .lightbox-content select[id], .lightbox-content div[id]").each(function () {
                    e(this).attr("id", e(this).attr("id") + t);
                }),
                    e(".lightbox-content label[for]").each(function () {
                        e(this).attr("for", e(this).attr("for") + t);
                    }),
                    e(".lightbox-content .address-country-option").each(function () {
                        var n = e(this).data("form-id") + t;
                        e(this).attr("data-form-id", n).data("form-id", n);
                    }),
                    theme._initCustomerAddressCountryDropdown();
            }),
            (theme.customerAddresses = void (
                (d = e("#AddressNewForm")).length &&
                (Shopify && theme._initCustomerAddressCountryDropdown(),
                e(".address-new-toggle").on("click", function () {
                    return e.colorbox({ transition: "fade", html: '<div class="lightbox-content">' + d.html() + "</div>", onComplete: theme._setupCustomAddressModal }), !1;
                }),
                e(".address-edit-toggle").on("click", function () {
                    var t = e(this).data("form-id");
                    return e.colorbox({ transition: "fade", html: '<div class="lightbox-content">' + e("#EditAddress_" + t).html() + "</div>", onComplete: theme._setupCustomAddressModal }), !1;
                }),
                e(".address-delete").on("click", function () {
                    var t = e(this),
                        n = t.data("form-id"),
                        i = t.data("confirm-message");
                    confirm(i || "Are you sure you wish to delete this address?") && Shopify.postLink(theme.routes.account_addresses_url + "/" + n, { parameters: { _method: "delete" } });
                }),
                e("#AddressNewForm .errors").length && e(".address-new-toggle").click(),
                e(".grid .address-card .errors").length && e(".grid .address-card .errors").first().closest(".address-card").find(".address-edit-toggle").click())
            )),
            (theme.customerLogin = (function () {
                var t = "#RecoverPassword";
                function n(t) {
                    t.preventDefault(), i(e(this).closest(".container"));
                }
                function i(t) {
                    e("[id=RecoverPasswordForm]", t).toggleClass("hide"), e("[id=CustomerLoginForm]", t).toggleClass("hide");
                }
                e(document).on("click", t, n),
                    e(document).on("click", "#HideRecoverPasswordLink", n),
                    e(t).length && ("#recover" === window.location.hash && i(null), e(".reset-password-success").length && e("#ResetSuccess").removeClass("hide"));
            })()),
            (theme.initUniformHeightMonitor = function (t, n, i) {
                theme.settings.uniformProductGridImagesEnabled &&
                    (e(t)
                        .addClass("uhm-active")
                        .data(
                            "uhm-callback",
                            function (t, n) {
                                var i = 0,
                                    o = e(t, this);
                                e(n, this).each(function () {
                                    var t = e(this).height();
                                    t > i && (i = t);
                                }),
                                    o.css("height", Math.ceil(i) + "px");
                            }.bind(t, n, i)
                        ),
                    e(t).data("uhm-callback")(),
                    e(window).on("debouncedresize", e(t).data("uhm-callback")));
            }),
            (theme.destroyUniformHeightMonitor = function (t) {
                theme.settings.uniformProductGridImagesEnabled &&
                    e(t)
                        .each(function () {
                            e(window).off("debouncedresize", e(this).data("uhm-callback"));
                        })
                        .removeClass("uhm-active");
            }),
            (theme.icons = {
                close:
                    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>',
                slideshowPrevArrow:
                    '<button class="slick-prev" aria-label="' +
                    theme.strings.previous +
                    '"><svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"/><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/></svg></button>',
                slideshowNextArrow:
                    '<button class="slick-next" aria-label="' +
                    theme.strings.next +
                    '"><svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"/><path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"/></svg></button>',
            }),
            (theme.openPageContentInLightbox = function (t) {
                e.get(t, function (t) {
                    var n = e("#MainContent", e.parseHTML("<div>" + t + "</div>"));
                    e.colorbox({
                        transition: "fade",
                        html: '<div class="lightbox-content">' + n.html() + "</div>",
                        onComplete: function () {
                            e("#cboxContent .input-wrapper input").trigger("inputstateEmpty"), e("#cboxContent input[data-desktop-autofocus]").focus();
                        },
                    });
                });
            }),
            (theme.styleVariantSelectors = function (t, n, i) {
                var o = t.filter(function () {
                    return void 0 !== e(this).data("listed");
                });
                if (
                    (o.each(function () {
                        e(this).clickyBoxes();
                        var t = e(this).closest(".selector-wrapper").find(".variant-option-title");
                        t.length &&
                            (t.data("default-content", t.html()),
                            e(this)
                                .siblings(".clickyboxes")
                                .on("change", function () {
                                    t.data("default-content", e(this).find("a.active").data("value"));
                                })
                                .on("mouseenter", "a", function () {
                                    t.html(e(this).data("value"));
                                })
                                .on("mouseleave", "a", function () {
                                    t.html(t.data("default-content"));
                                }));
                    }),
                    o.length > 0)
                )
                    for (var s = 0; s < n.options.length; s++) {
                        for (var r = {}, a = 0; a < n.variants.length; a++) {
                            var l = n.variants[a];
                            void 0 === r[l.options[s]] && (r[l.options[s]] = !1), l.available && (r[l.options[s]] = !0);
                        }
                        for (var c in r)
                            r[c] ||
                                e(t[s])
                                    .siblings(".clickyboxes")
                                    .find("li a")
                                    .filter(function () {
                                        return e(this).attr("data-value") == c;
                                    })
                                    .addClass("unavailable");
                    }
                t.not(o).each(function () {
                    var t = {};
                    i && (t.dropdownParent = e("#cboxWrapper")), theme.select2.init(e(this), t);
                }),
                    i && e.colorbox.resize();
            }),
            (theme.select2 = {
                init: function (t, n) {
                    var i = { minimumResultsForSearch: 1 / 0 },
                        o = { minimumResultsForSearch: 1 / 0, templateResult: theme.select2.swatchSelect2OptionTemplate, templateSelection: theme.select2.swatchSelect2OptionTemplate };
                    void 0 !== n && ((i = e.extend(i, n)), (o = e.extend(o, n))),
                        t.each(function () {
                            e(this).select2(e(this).data("colour-swatch") ? o : i);
                        });
                },
                swatchSelect2OptionTemplate: function (t) {
                    if (t.id) {
                        var n = removeDiacritics(t.id)
                            .toLowerCase()
                            .replace(/'/g, "")
                            .replace(/[^a-z0-9]+/g, "-")
                            .replace(/-+/g, "-")
                            .replace(/-*$/, "");
                        return e(['<div class="swatch-option">', '<span class="swatch-option__nugget bg-', n, '"></span>', '<span class="swatch-option__label">', t.text, "</span>", "</div>"].join(""));
                    }
                    return e(['<div class="swatch-option swatch-option--all">', '<span class="swatch-option__label">', t.text, "</span>", "</div>"].join(""));
                },
            }),
            (theme.namespaceFromSection = function (t) {
                return [".", e(t).data("section-type"), e(t).data("section-id")].join("");
            }),
            (theme.dockedNavDesktopMinWidth = 768),
            (theme.dockedNavHeight = function () {
                if (e(window).width() >= theme.dockedNavDesktopMinWidth) {
                    if (e(".docked-navigation-container").length) return e(".docked-navigation-container__inner").height();
                } else if (e(".docked-mobile-navigation-container").length) return e(".docked-mobile-navigation-container__inner").height();
                return 0;
            }),
            (theme.resizeAccent = function () {
                var t = 0,
                    n = e(".accent-background").next();
                if (n.length) {
                    var i = parseInt(n.css("margin-top"));
                    "shopify-section-banner" === n[0].id && (n.children().length || n.text().trim().length || (n = n.next())),
                        (t = n.find(".sticky-element").length ? Math.round(n.find(".sticky-element").outerHeight() / 2 + i) : Math.round(n.outerHeight() / 2 + i)),
                        e(".accent-background").css("height", t);
                } else t = "";
                e(".accent-background").css("height", t);
            }),
            (theme.peekCarousel = {
                init: function (t, n, i, o, s, r) {
                    theme.peekCarousel._checkAdvice(t);
                    var a = { $slideshows: n, useCarouselCheckFn: o, removeClasses: s, slickConfig: "object" == _typeof(r) ? r : { infinite: !1, slidesToShow: 1, slidesToScroll: 1, swipeToSlide: !0, dots: !1, arrows: !1 } };
                    theme.peekCarousel._assess.bind(a)(),
                        e(window).on("debouncedresize" + i, theme.peekCarousel._assess.bind(a)),
                        e(".product-carousel-peek__advice", t).on("click", function () {
                            e(this).closest(".product-carousel-peek").find(".slick-initialized").slick("slickNext").trigger("dismissAdvice");
                        });
                },
                destroy: function (t, n, i) {
                    n.hasClass("slick-initialized") && n.slick("unslick").off("swipe dismissAdvice afterChange init"), e(window).off("debouncedresize" + i, theme.peekCarousel._assess), e(".product-carousel-peek__advice", t).off("click");
                },
                _assess: function () {
                    for (var t = 0; t < this.$slideshows.length; t++) {
                        var n = e(this.$slideshows[t]);
                        this.useCarouselCheckFn()
                            ? n.hasClass("slick-initialized") ||
                              (this.removeClasses &&
                                  n.children().each(function () {
                                      e(this).data("peekOriginalClassName", this.className), (this.className = "");
                                  }),
                              0 == n.children().length && n.closest(".product-carousel-peek").addClass("product-carousel-peek--empty"),
                              1 == n.children().length && n.closest(".product-carousel-peek").addClass("product-carousel-peek--single"),
                              n.on("afterChange init", theme.peekCarousel._lazyLoadProduct),
                              n.slick(this.slickConfig).on("swipe dismissAdvice", theme.peekCarousel._dismissAdviceOnSlickSwipe))
                            : n.hasClass("slick-initialized") &&
                              (n.slick("unslick").off("swipe dismissAdvice afterChange"),
                              this.removeClasses &&
                                  n.children().each(function () {
                                      this.className = e(this).data("peekOriginalClassName");
                                  }));
                    }
                },
                _checkAdvice: function (t) {
                    "1" != e.cookie("theme.boost.dismissPeekAdvice") && e(".product-carousel-peek", t).addClass("product-carousel-peek--show-advice");
                },
                _dismissAdvice: function () {
                    e.cookie("theme.boost.dismissPeekAdvice", "1", { expires: 7, path: "/", domain: window.location.hostname }), e(".product-carousel-peek").addClass("product-carousel-peek--dismiss-advice");
                },
                _dismissAdviceOnSlickSwipe: function (t, n) {
                    theme.peekCarousel._dismissAdvice(), e(this).off("swipe");
                },
                _lazyLoadProduct: function (t, n) {
                    n.$slides
                        .filter("[data-lazy-product-url]")
                        .filter(function () {
                            return e(this).hasClass("slick-active") || e(this).prev().hasClass("slick-active");
                        })
                        .each(function () {
                            var t = e(this);
                            e.get(e(this).data("lazy-product-url") + "?sections=product-block", function (n) {
                                if ((t.html(e(n["product-block"]).children().html()), theme.settings.uniformProductGridImagesEnabled)) {
                                    var i = t.closest(".uhm-active");
                                    i.length && i.data("uhm-callback")();
                                }
                            }),
                                t.removeAttr("data-lazy-product-url");
                        });
                },
            }),
            (theme.productGallerySlideshowTabFix = function (t, n) {
                e(t[n])
                    .attr("tabindex", "-1")
                    .find("[tabindex]")
                    .each(function () {
                        e(this).attr("tabindex", "0"), e(this).filter("model-viewer").attr("tabindex", "-1");
                    }),
                    e(t)
                        .not(t[n])
                        .attr("tabindex", "-1")
                        .find("a, input, select, textarea, button, iframe, video, model-viewer, [tabindex]")
                        .each(function () {
                            e(this).attr("tabindex", "-1");
                        });
            }),
            e(function () {
                function t() {
                    e(".tabs:not(:has(.tab--active)) a:first").trigger("assess");
                }
                slate.a11y.pageLinkFocus(e(window.location.hash)),
                    e(".in-page-link").on("click", function (t) {
                        slate.a11y.pageLinkFocus(e(t.currentTarget.hash));
                    }),
                    e(document).on("keyup.themeTabCheck", function (t) {
                        9 === t.keyCode && (e("body").addClass("tab-used"), e(document).off("keyup.themeTabCheck"));
                    }),
                    slate.rte.wrapTable({ $tables: e(".rte table"), tableWrapperClass: "rte__table-wrapper" }),
                    slate.rte.wrapIframe({ $iframes: e('.rte iframe[src*="youtube.com/embed"],.rte iframe[src*="player.vimeo"]'), iframeWrapperClass: "rte__video-wrapper" }),
                    slate.cart.cookiesEnabled() && (document.documentElement.className = document.documentElement.className.replace("supports-no-cookies", "supports-cookies")),
                    e(document).on("change focusout inputstateEmpty", ".input-wrapper input, .input-wrapper textarea", function () {
                        e(this)
                            .closest(".input-wrapper")
                            .toggleClass("is-empty", 0 == e(this).val().length);
                    }),
                    e(document).on("focusin focusout", ".input-wrapper input, .input-wrapper textarea", function (t) {
                        e(this)
                            .closest(".input-wrapper")
                            .toggleClass("in-focus", "focusin" == t.type);
                    }),
                    e(document).on("shopify:section:load", function () {
                        e(".input-wrapper input, .input-wrapper textarea").trigger("inputstateEmpty");
                    }),
                    e(".input-wrapper input:focus, .input-wrapper textarea:focus").closest(".input-wrapper").addClass("in-focus"),
                    e(".input-wrapper input, .input-wrapper textarea").trigger("inputstateEmpty"),
                    e(".input-wrapper input, .input-wrapper textarea").on("animationstart", function (t) {
                        "onAutoFillStart" == t.originalEvent.animationName ? e(this).closest(".input-wrapper").removeClass("is-empty") : "onAutoFillCancel" == t.originalEvent.animationName && e(this).trigger("inputstateEmpty");
                    }),
                    e(window).width() > 1024 && e("input[data-desktop-autofocus]").focus(),
                    e(document).on("click assess", ".tabs a", function (t) {
                        e(this).addClass("tab--active").closest("ul").find(".tab--active").not(this).removeClass("tab--active"),
                            e(this)
                                .closest("li")
                                .siblings()
                                .find("a")
                                .each(function () {
                                    e(e(this).attr("href")).removeClass("tab-content--active");
                                }),
                            e(e(this).attr("href")).addClass("tab-content--active"),
                            t.preventDefault();
                    }),
                    t(),
                    e(document).on("shopify:section:load", t),
                    e(document).on("click", ".js-contains-quickbuy .js-quickbuy-button", function (t) {
                        if (e(window).width() > 768) {
                            var n = e(this),
                                i = e(this).closest(".js-contains-quickbuy"),
                                o = i.find(".quickbuy-placeholder-template").html(),
                                s = e('<div class="quickbuy">' + o + "</div>"),
                                r = !1,
                                a = new MutationObserver(function (t) {
                                    e.colorbox.resize();
                                });
                            return (
                                e.colorbox({
                                    closeButton: !1,
                                    preloading: !1,
                                    open: !0,
                                    speed: 200,
                                    slideshow: !0,
                                    html: [s.wrap("<div>").parent().html()].join(""),
                                    onComplete: function () {
                                        var t = e(".quickbuy__product-media").slick({
                                            infinite: !1,
                                            slidesToScroll: 1,
                                            speed: 300,
                                            slidesToShow: 1,
                                            swipeToSlide: !0,
                                            variableWidth: !0,
                                            prevArrow: e(".quickbuy__slider-controls .prev"),
                                            nextArrow: e(".quickbuy__slider-controls .next"),
                                        });
                                        theme.ProductMedia.init(e(".quickbuy__media-container"), {
                                            onPlyrInit: function (e) {
                                                theme.productGallerySlideshowTabFix(t.slick("getSlick").$slides, t.slick("getSlick").currentSlide);
                                            },
                                            onYoutubeInit: function (e) {
                                                theme.productGallerySlideshowTabFix(t.slick("getSlick").$slides, t.slick("getSlick").currentSlide);
                                            },
                                            onModelViewerInit: function (e) {
                                                theme.productGallerySlideshowTabFix(t.slick("getSlick").$slides, t.slick("getSlick").currentSlide);
                                            },
                                            onVideoVisible: function (t) {
                                                e(t.target).closest(".slick-slider").slick("slickSetOption", "swipe", !1);
                                            },
                                            onVideoHidden: function (t) {
                                                e(t.target).closest(".slick-slider").slick("slickSetOption", "swipe", !0);
                                            },
                                            onPlyrPlay: function (t) {
                                                e(t.target).closest(".slick-slider").slick("slickSetOption", "swipe", !1);
                                            },
                                            onPlyrPause: function (t) {
                                                e(t.target).closest(".slick-slider").slick("slickSetOption", "swipe", !0);
                                            },
                                            onModelViewerPlay: function (t) {
                                                e(t.target).closest(".slick-slider").slick("slickSetOption", "swipe", !1).slick("slickSetOption", "accessibility", !1).closest(".quickbuy__media-container").addClass("media-playing");
                                            },
                                            onModelViewerPause: function (t) {
                                                e(t.target).closest(".slick-slider").slick("slickSetOption", "swipe", !0).slick("slickSetOption", "accessibility", !0).closest(".quickbuy__media-container").removeClass("media-playing");
                                            },
                                        }),
                                            t.find(".product-media").trigger("mediaVisibleInitial"),
                                            t.on("afterChange", function (n, i, o) {
                                                e(".product-media--activated").removeClass("product-media--activated").trigger("mediaHidden");
                                                var s = e(".product-media", i.$slides[o]).addClass("product-media--activated").trigger("mediaVisible");
                                                theme.productGallerySlideshowTabFix(i.$slides, o),
                                                    t.closest(".quickbuy__media-container").toggleClass("quickbuy__media-container--current-image", s.hasClass("product-media--image")),
                                                    e(this).closest(".quickbuy-container").trigger("changedsize");
                                            }),
                                            theme.productGallerySlideshowTabFix(t.slick("getSlick").$slides, t.slick("getSlick").currentSlide),
                                            e.colorbox.resize();
                                        var o = e(".quickbuy-form"),
                                            s = JSON.parse(e("[data-product-json]", i).html()),
                                            l = {
                                                $container: o,
                                                enableHistoryState: !1,
                                                singleOptionSelector: "[data-single-option-selector]",
                                                originalSelectorId: "[data-product-select]",
                                                secondaryIdSelectors: "[data-product-secondary-select]",
                                                product: s,
                                                productSingleObject: s,
                                            };
                                        new slate.Variants(l),
                                            o.on("variantChange", theme.variants.updateAddToCartState.bind(l)),
                                            o.on("variantPriceChange", theme.variants.updateProductPrices.bind(l)),
                                            e(".quickbuy__product-media .slick-slide", o).length > 1 &&
                                                o.on("variantImageChange", function (t) {
                                                    var n = t.variant,
                                                        i = e('.quickbuy__product-media .slick-slide:not(.slick-cloned)[data-media-id="' + n.featured_media.id + '"]', o);
                                                    i.length && i.closest(".slick-slider").slick("slickGoTo", i.data("slick-index"));
                                                }),
                                            o.on("variantChange", e.colorbox.resize),
                                            theme.styleVariantSelectors(e(".quickbuy .selector-wrapper select"), l.product, !0),
                                            theme.select2.init(e(".quickbuy .quantity-proxy"), { dropdownParent: e("#cboxWrapper") }),
                                            Shopify.PaymentButton &&
                                                (e(document).on("shopify:payment_button:loaded.themeQuickBuy", function () {
                                                    e(document).off("shopify:payment_button:loaded.themeQuickBuy"),
                                                        e.colorbox.resize(),
                                                        (r = e(".quickbuy-form .shopify-payment-button")[0]) && a.observe(r, { attributes: !0, childList: !0, subtree: !0 });
                                                }),
                                                Shopify.PaymentButton.init()),
                                            theme.initAjaxAddToCartForm(e("form.ajax-product-form", o));
                                        for (
                                            var c = {
                                                    handle: s.handle,
                                                    url: n.attr("href").split("?")[0],
                                                    title: s.title,
                                                    vendor: s.vendor,
                                                    available: s.available,
                                                    image: s.media && s.media.length > 0 ? s.media[0].preview_image.src : null,
                                                    image2: s.media && s.media.length > 1 ? s.media[1].preview_image.src : null,
                                                    price: s.price,
                                                    priceVaries: s.price_varies,
                                                    compareAtPrice: s.compare_at_price,
                                                },
                                                d = s.variants[0],
                                                u = 1;
                                            u < s.variants.length;
                                            u++
                                        )
                                            s.variants[u].price < d.price && (d = s.variants[u]);
                                        d.unit_price_measurement && ((c.unitPrice = d.unit_price), (c.unitPriceUnit = theme.variants.getBaseUnit(d))), theme.addToAndReturnRecentProducts(c);
                                    },
                                    onCleanup: function () {
                                        a.disconnect(),
                                            theme.ProductMedia.destroy(e(".quickbuy__media-container")),
                                            e(".quickbuy .slick-initialized").slick("unslick").off("afterChange"),
                                            e(".quickbuy-form").off("variantChange variantPriceChange variantImageChange"),
                                            e(".quickbuy-form .clickybox-replaced").clickyBoxes("destroy"),
                                            theme.initAjaxAddToCartForm(e(".quickbuy form.ajax-product-form"));
                                    },
                                }),
                                !1
                            );
                        }
                    }),
                    e(document).on("click", "#colorbox .quickbuy__close .js-close-quickbuy", function () {
                        return e.colorbox.close(), !1;
                    }),
                    e(document).on("click", ".js-close-lightbox", function () {
                        return e.colorbox.close(), !1;
                    }),
                    e(document).on("change", ".quantity-proxy", function () {
                        var t = e(this).val(),
                            n = e(this).siblings('[name="quantity"]');
                        "10+" == t
                            ? (n.val("10").closest(".quantity-wrapper").addClass("hide-proxy"),
                              setTimeout(function () {
                                  n.select().focus();
                              }, 10))
                            : n.val(t);
                    });
                var n = e(".subscribe-form__response--success");
                n.length &&
                    e.colorbox({
                        transition: "fade",
                        html: '<div class="subscribe-form-lightbox-response">' + n.html() + "</div>",
                        onOpen: function () {
                            e("#colorbox").css("opacity", 0);
                        },
                        onComplete: function () {
                            e("#colorbox").animate({ opacity: 1 }, 350);
                        },
                    }),
                    e(".accent-background").length &&
                        (e(function () {
                            theme.resizeAccent();
                        }),
                        e(window).on("debouncedresize", theme.resizeAccent),
                        e(document).on("shopify:section:load", function (t) {
                            e(t.target).prev().hasClass("accent-background") && theme.resizeAccent();
                        }),
                        e(document).on("shopify:section:reorder", theme.resizeAccent));
            }),
            theme.Sections.init(),
            theme.Sections.register("header", theme.Header, { deferredLoad: !1 }),
            theme.Sections.register("footer", theme.Footer),
            theme.Sections.register("product", theme.Product, { deferredLoad: !1 }),
            theme.Sections.register("blog", theme.Blog),
            theme.Sections.register("article", theme.Article),
            theme.Sections.register("slideshow", theme.Slideshow),
            theme.Sections.register("banner", theme.Banner),
            theme.Sections.register("standout-collection", theme.StandoutCollection),
            theme.Sections.register("get-the-look", theme.GetTheLook),
            theme.Sections.register("promotional-images", theme.PromotionalImages),
            theme.Sections.register("tabs-products", theme.TabsProducts),
            theme.Sections.register("featured-collection", theme.FeaturedCollection),
            theme.Sections.register("list-collections", theme.ListCollections, { deferredLoad: !1 }),
            theme.Sections.register("collection-template", theme.CollectionTemplate, { deferredLoad: !1 }),
            theme.Sections.register("cart", theme.Cart, { deferredLoad: !1 }),
            theme.Sections.register("image-with-text", theme.ImageWithText),
            theme.Sections.register("featured-product", theme.FeaturedProduct),
            theme.Sections.register("recently-viewed", theme.RecentlyViewed),
            theme.Sections.register("testimonials", theme.Testimonials),
            theme.Sections.register("gallery", theme.Gallery),
            theme.Sections.register("video", theme.VideoManager),
            theme.Sections.register("background-video", theme.VideoManager),
            theme.Sections.register("search-template", theme.SearchTemplate, { deferredLoad: !1 }),
            e(function (e) {
                s.sections.length
                    ? s.sections.forEach(function (e) {
                          try {
                              theme.Sections.register(e.name, e.section);
                          } catch (t) {
                              console.error("Unable to register section ".concat(e.name, "."), t);
                          }
                      })
                    : console.warn("Barry: No common sections have been registered.");
            });
    })(theme.jQuery),
    (() => {
        var e,
            t = {
                "./src/js/main.js":
                    /*!************************!*\
        !*** ./src/js/main.js ***!
        \************************/
                    () => {
                        let e = window.location.href;
                        function t() {
                            if ($(".product-detail__detail .variantoption").length) {
                                let e = 0;
                                setTimeout(function () {
                                    $(".product-detail__detail .bannerprice").each(function () {
                                        $(this).outerHeight() > e && (e = $(this).outerHeight());
                                    }),
                                        $(".product-detail__detail .bannerprice").css("min-height", e + "px");
                                }, 1e3);
                            }
                        }
                        ("https://wldoho.de/products/100-klingen" != e && "https://wldoho.de/products/100-klingen?variant=43674810384648" != e) || (window.location.href = "https://wldoho.de/products/nachfullpack-rasierklingen-wldoho"),
                            $(document).ready(function () {
                                var e = new Swiper(".mySwiper", {
                                    direction: "horizontal",
                                    pagination: { el: ".swiper-pagination", clickable: !0 },
                                    on: {
                                        reachEnd: function () {
                                            var e = this;
                                            this.slides.length > 1 &&
                                                (this.el.classList.add("swiper-no-swiping"),
                                                setTimeout(function () {
                                                    e.el.classList.remove("swiper-no-swiping");
                                                }, 1e3));
                                        },
                                    },
                                });
                                let n = 0,
                                    i = 0,
                                    o = setInterval(function () {
                                        i++,
                                            (n = $(".product-detail__images-container .swiper-pagination .swiper-pagination-bullet").length),
                                            (n > 1 || i > 300) && (clearInterval(o), $(".product-detail__images-container .swiper-pagination.swiper-pagination-bullets").css("min-width", 19 * n + "px"));
                                    }, 100);
                                if (
                                    ($(".pagination-left-arrow").on("click", function () {
                                        e.slidePrev();
                                    }),
                                    $(".pagination-right-arrow").on("click", function () {
                                        e.slideNext();
                                    }),
                                    (window.screen.width < 767 || window.innerWidth < 767) &&
                                        ((window.onscroll = function () {
                                            $(".hulk_cookie_bar.mobile_bottom").length > 0 &&
                                                (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50
                                                    ? ($(".hulk_cookie_bar.mobile_bottom").addClass("nodisplay"), $(".hulk_cookie_bar.mobile_bottom").removeClass("flexdisplay"), $("#shopify-section-header").css("margin-top", "0px"))
                                                    : ($(".hulk_cookie_bar.mobile_bottom").removeClass("nodisplay"), $(".hulk_cookie_bar.mobile_bottom").addClass("flexdisplay"), $("#shopify-section-header").css("margin-top", "70px")));
                                        }),
                                        setTimeout(function () {
                                            $(".hulk_cookie_bar.mobile_bottom").length > 0 ? $("#shopify-section-header").css("margin-top", "70px") : $("#shopify-section-header").css("margin-top", "0px");
                                        }, 2800),
                                        $(document).on("click", ".hulk_cookie_bar button", function () {
                                            $("#shopify-section-header").css("margin-top", "0px");
                                        })),
                                    $(".product-slideshow__action").click(function () {
                                        $(".pswp").addClass("nodisplay"),
                                            $(".product-slideshow__details").toggleClass("tooltip-active"),
                                            $(".swiper-pagination").toggle(),
                                            setTimeout(function () {
                                                $(".pswp").removeClass("pswp--open"), $(".pswp").removeClass("nodisplay");
                                            }, 100);
                                    }),
                                    $(document).on("click", ".draweritem", function () {
                                        "/cart" != location.pathname &&
                                            ($(".Drawer").attr("aria-hidden", !1), $("body").toggleClass("notscroll"), $(".PageOverlay").toggleClass("is-visible"), $("#trustbadge-container-98e3dadd90eb493088abdc5597a70810").hide());
                                    }),
                                    $(document).on("click", ".Drawer__Close", function () {
                                        $(".Drawer").attr("aria-hidden", !0), $("body").toggleClass("notscroll"), $(".PageOverlay").toggleClass("is-visible"), $("#trustbadge-container-98e3dadd90eb493088abdc5597a70810").show();
                                    }),
                                    $(document).on("click", ".Link", function () {
                                        var e = $(this).attr("data-href");
                                        fetch(e, { credentials: "same-origin", method: "GET" }).then(function (e) {
                                            e.text().then(function (e) {
                                                var t = document.createElement("div");
                                                (t.innerHTML = e),
                                                    (document.querySelector(".Drawer__Content").innerHTML = t.querySelector(".Drawer__Content").innerHTML),
                                                    $(".customcartcount").html(t.querySelector(".customcartcount").innerHTML);
                                            });
                                        });
                                    }),
                                    $(document).on("blur", ".QuantitySelector__CurrentQuantity", function () {
                                        var e = $(this).attr("data-href");
                                        (e = e + "?quantity=" + $(this).val() + "&id=" + $(this).attr("data-line-id")),
                                            fetch(e, { credentials: "same-origin", method: "GET" }).then(function (e) {
                                                e.text().then(function (e) {
                                                    var t = document.createElement("div");
                                                    (t.innerHTML = e),
                                                        (document.querySelector(".Drawer__Content").innerHTML = t.querySelector(".Drawer__Content").innerHTML),
                                                        $(".customcartcount").html(t.querySelector(".customcartcount").innerHTML);
                                                });
                                            });
                                    }),
                                    $(document).on("click", ".changewrapperd", function () {
                                        $(".changewrapperd .variantoption").removeClass("selectedopt"), $(this).children(".variantoption").addClass("selectedopt");
                                        for (var t = 0; t < $(".forwrapperdd ul li").length; t++)
                                            $(".forwrapperdd ul li").eq(t).children("a").html() == $(this).children(".variantoption").eq(0).children(".titlevar").html() &&
                                                ((getl = document.querySelector(".variantwrap").innerHTML), $(".forwrapperdd ul li").eq(t).children("a").trigger("click"), (document.querySelector(".variantwrap").innerHTML = getl));
                                        for (t = 0; t < $(".slick-dots li").length; t++) $(".slick-dots li").eq(t).hasClass("slick-active") && e.slideTo(t, 1e3, !1);
                                    }),
                                    $(".template-product").length > 0)
                                ) {
                                    var s = (function (e) {
                                        var t,
                                            n,
                                            i = window.location.search.substring(1).split("&");
                                        for (n = 0; n < i.length; n++) if ("variant" === (t = i[n].split("="))[0]) return void 0 === t[1] || decodeURIComponent(t[1]);
                                    })();
                                    setTimeout(function () {
                                        if (void 0 === s) e.slideTo(0, 1e3, !1);
                                        else for (var t = 0; t < $(".product-detail__thumbnail").length; t++) $(".product-detail__thumbnail").eq(t).hasClass("thumb-active") && e.slideTo(t, 1e3, !1);
                                    }, 100);
                                }
                                $(".RoundButton").click(function () {
                                    "open-product-zoom" == $(this).attr("data-action") && e.zoom.in();
                                }),
                                    t();
                            }),
                            $(window).on("resize", function () {
                                t();
                            }),
                            $(document).on("click", ".Drawer__Tab", function () {
                                $(".Drawer__Tab").removeClass("active_tab"),
                                    $(this).addClass("active_tab"),
                                    $(".nav-item").removeClass("active_nav"),
                                    $(".nav-item[data-navitem='" + $(this).attr("data-navfor") + "']")
                                        .eq(0)
                                        .addClass("active_nav");
                            }),
                            $(".hd-AnnouncementBar_CopyButton").click(function () {
                                navigator.clipboard.writeText($(this).attr("data-code")), $(this).html($(this).attr("data-text-after")), $(this).removeClass("underlined");
                            }),
                            setTimeout(function () {
                                $(".easytabs-text")
                                    .eq($(".easytabs-text").length - 1)
                                    .append("<div class='powerfemaleshow'><img src='https://cdn.shopify.com/s/files/1/0019/0699/9348/files/WLDOHO_70_icone.png?v=1646222095'/></div>");
                            }, 2e3);
                    },
                "./src/scss/main.scss":
                    /*!****************************!*\
        !*** ./src/scss/main.scss ***!
        \****************************/
                    (e, t, n) => {
                        "use strict";
                        n.r(t);
                    },
            },
            n = {};
        function i(e) {
            var o = n[e];
            if (void 0 !== o) return o.exports;
            var s = (n[e] = { exports: {} });
            return t[e](s, s.exports, i), s.exports;
        }
        (i.m = t),
            (e = []),
            (i.O = (t, n, o, s) => {
                if (!n) {
                    var r = 1 / 0;
                    for (d = 0; d < e.length; d++) {
                        for (var [n, o, s] = e[d], a = !0, l = 0; l < n.length; l++) (!1 & s || r >= s) && Object.keys(i.O).every((e) => i.O[e](n[l])) ? n.splice(l--, 1) : ((a = !1), s < r && (r = s));
                        if (a) {
                            e.splice(d--, 1);
                            var c = o();
                            void 0 !== c && (t = c);
                        }
                    }
                    return t;
                }
                s = s || 0;
                for (var d = e.length; d > 0 && e[d - 1][2] > s; d--) e[d] = e[d - 1];
                e[d] = [n, o, s];
            }),
            (i.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t)),
            (i.r = (e) => {
                "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(e, "__esModule", { value: !0 });
            }),
            (() => {
                var e = { "/assets/main": 0, "assets/main": 0 };
                i.O.j = (t) => 0 === e[t];
                var t = (t, n) => {
                        var o,
                            s,
                            [r, a, l] = n,
                            c = 0;
                        if (r.some((t) => 0 !== e[t])) {
                            for (o in a) i.o(a, o) && (i.m[o] = a[o]);
                            if (l) var d = l(i);
                        }
                        for (t && t(n); c < r.length; c++) (s = r[c]), i.o(e, s) && e[s] && e[s][0](), (e[r[c]] = 0);
                        return i.O(d);
                    },
                    n = (self.webpackChunkwldoho = self.webpackChunkwldoho || []);
                n.forEach(t.bind(null, 0)), (n.push = t.bind(null, n.push.bind(n)));
            })(),
            i.O(void 0, ["assets/main"], () => i("./src/js/main.js"));
        var o = i.O(void 0, ["assets/main"], () => i("./src/scss/main.scss"));
        o = i.O(o);
    })(),
    $(".pd-tb-header").click(function () {
        $(this).parent(".pd-tb").toggleClass("active");
    });
var scrollToTopBtn = document.querySelector(".scrollToTopBtn"),
    rootElement = document.documentElement;
function scrollToTop() {
    rootElement.scrollTo({ top: 0, behavior: "smooth" });
}
scrollToTopBtn.addEventListener("click", scrollToTop);
let freeProductHandle = "/intimate-shaving-oil-xm22",
    redirectPage = "/products/intimate-shaving-oil",
    url = window.location.href.toLowerCase();
function hideProductFromCollectionPage() {
    document.querySelectorAll(".product-block").forEach((e) => {
        let t = e.querySelector(".product-block__title-link");
        t && t.href.toLowerCase().includes(freeProductHandle) && e.remove();
    });
}
function watchForChanges(e, t, n = { attributes: !0 }) {
    (target = document.querySelector(e)),
        new MutationObserver((e, n) => {
            for (const i of e) t(i, n);
        }).observe(target, n);
}
url.includes(freeProductHandle) && (window.location.pathname = redirectPage),
    hideProductFromCollectionPage(),
    watchForChanges(
        "body",
        (e, t) => {
            hideProductFromCollectionPage();
        },
        { childList: !0, subtree: !0 }
    );
